(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7509"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7509"] = parcelRequire;
}
parcelRequire.register("e8l21", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $a4a2207a12bd8f5a$export$ffb0004e005737fa; }, function (v) { return $a4a2207a12bd8f5a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $a4a2207a12bd8f5a$export$34b9dba7ce09269b; }, function (v) { return $a4a2207a12bd8f5a$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $a4a2207a12bd8f5a$export$25062201e9e25d76; }, function (v) { return $a4a2207a12bd8f5a$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a4a2207a12bd8f5a$export$ffb0004e005737fa;
var $a4a2207a12bd8f5a$export$34b9dba7ce09269b;
var $a4a2207a12bd8f5a$export$25062201e9e25d76;
"use strict";

var $4lkrv = parcelRequire("4lkrv");
var $a4a2207a12bd8f5a$var$k = Symbol.for("react.element"), $a4a2207a12bd8f5a$var$l = Symbol.for("react.fragment"), $a4a2207a12bd8f5a$var$m = Object.prototype.hasOwnProperty, $a4a2207a12bd8f5a$var$n = $4lkrv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $a4a2207a12bd8f5a$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a4a2207a12bd8f5a$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$a4a2207a12bd8f5a$var$m.call(a, b) && !$a4a2207a12bd8f5a$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $a4a2207a12bd8f5a$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $a4a2207a12bd8f5a$var$n.current
    };
}
$a4a2207a12bd8f5a$export$ffb0004e005737fa = $a4a2207a12bd8f5a$var$l;
$a4a2207a12bd8f5a$export$34b9dba7ce09269b = $a4a2207a12bd8f5a$var$q;
$a4a2207a12bd8f5a$export$25062201e9e25d76 = $a4a2207a12bd8f5a$var$q;

});
parcelRequire.register("4lkrv", function(module, exports) {
"use strict";

module.exports = (parcelRequire("65Q8y"));

});
parcelRequire.register("65Q8y", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $46fba702bbee3038$export$dca3b0875bd9a954; }, function (v) { return $46fba702bbee3038$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $46fba702bbee3038$export$16fa2f45be04daa8; }, function (v) { return $46fba702bbee3038$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $46fba702bbee3038$export$ffb0004e005737fa; }, function (v) { return $46fba702bbee3038$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $46fba702bbee3038$export$e2c29f18771995cb; }, function (v) { return $46fba702bbee3038$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $46fba702bbee3038$export$221d75b3f55bb0bd; }, function (v) { return $46fba702bbee3038$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $46fba702bbee3038$export$5f8d39834fd61797; }, function (v) { return $46fba702bbee3038$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $46fba702bbee3038$export$74bf444e3cd11ea5; }, function (v) { return $46fba702bbee3038$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $46fba702bbee3038$export$ae55be85d98224ed; }, function (v) { return $46fba702bbee3038$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $46fba702bbee3038$export$3ba232387fd5d6dd; }, function (v) { return $46fba702bbee3038$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $46fba702bbee3038$export$e530037191fcd5d7; }, function (v) { return $46fba702bbee3038$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $46fba702bbee3038$export$fd42f52fd3ae1109; }, function (v) { return $46fba702bbee3038$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $46fba702bbee3038$export$c8a8987d4410bf2d; }, function (v) { return $46fba702bbee3038$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $46fba702bbee3038$export$d38cd72104c1f0e9; }, function (v) { return $46fba702bbee3038$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $46fba702bbee3038$export$7d1e3a5e95ceca43; }, function (v) { return $46fba702bbee3038$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $46fba702bbee3038$export$257a8862b851cb5b; }, function (v) { return $46fba702bbee3038$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $46fba702bbee3038$export$a8257692ac88316c; }, function (v) { return $46fba702bbee3038$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $46fba702bbee3038$export$488013bae63b21da; }, function (v) { return $46fba702bbee3038$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $46fba702bbee3038$export$7c73462e0d25e514; }, function (v) { return $46fba702bbee3038$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $46fba702bbee3038$export$7568632d0d33d16d; }, function (v) { return $46fba702bbee3038$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $46fba702bbee3038$export$88948ce120ea2619; }, function (v) { return $46fba702bbee3038$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $46fba702bbee3038$export$35808ee640e87ca7; }, function (v) { return $46fba702bbee3038$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $46fba702bbee3038$export$fae74005e78b1a27; }, function (v) { return $46fba702bbee3038$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $46fba702bbee3038$export$dc8fbce3eb94dc1e; }, function (v) { return $46fba702bbee3038$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $46fba702bbee3038$export$6a7bc4e911dc01cf; }, function (v) { return $46fba702bbee3038$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $46fba702bbee3038$export$6d9c69b0de29b591; }, function (v) { return $46fba702bbee3038$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $46fba702bbee3038$export$f680877a34711e37; }, function (v) { return $46fba702bbee3038$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $46fba702bbee3038$export$d5a552a76deda3c2; }, function (v) { return $46fba702bbee3038$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $46fba702bbee3038$export$aaabe4eda9ed9969; }, function (v) { return $46fba702bbee3038$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $46fba702bbee3038$export$e5c5a5f917a5871c; }, function (v) { return $46fba702bbee3038$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $46fba702bbee3038$export$1538c33de8887b59; }, function (v) { return $46fba702bbee3038$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $46fba702bbee3038$export$13e3392192263954; }, function (v) { return $46fba702bbee3038$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $46fba702bbee3038$export$b8f5890fc79d6aca; }, function (v) { return $46fba702bbee3038$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $46fba702bbee3038$export$60241385465d0a34; }, function (v) { return $46fba702bbee3038$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $46fba702bbee3038$export$306c0aa65ff9ec16; }, function (v) { return $46fba702bbee3038$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $46fba702bbee3038$export$7b286972b8d8ccbf; }, function (v) { return $46fba702bbee3038$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $46fba702bbee3038$export$83d89fbfd8236492; }, function (v) { return $46fba702bbee3038$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $46fba702bbee3038$export$dca3b0875bd9a954;
var $46fba702bbee3038$export$16fa2f45be04daa8;
var $46fba702bbee3038$export$ffb0004e005737fa;
var $46fba702bbee3038$export$e2c29f18771995cb;
var $46fba702bbee3038$export$221d75b3f55bb0bd;
var $46fba702bbee3038$export$5f8d39834fd61797;
var $46fba702bbee3038$export$74bf444e3cd11ea5;
var $46fba702bbee3038$export$ae55be85d98224ed;
var $46fba702bbee3038$export$3ba232387fd5d6dd;
var $46fba702bbee3038$export$e530037191fcd5d7;
var $46fba702bbee3038$export$fd42f52fd3ae1109;
var $46fba702bbee3038$export$c8a8987d4410bf2d;
var $46fba702bbee3038$export$d38cd72104c1f0e9;
var $46fba702bbee3038$export$7d1e3a5e95ceca43;
var $46fba702bbee3038$export$257a8862b851cb5b;
var $46fba702bbee3038$export$a8257692ac88316c;
var $46fba702bbee3038$export$488013bae63b21da;
var $46fba702bbee3038$export$7c73462e0d25e514;
var $46fba702bbee3038$export$7568632d0d33d16d;
var $46fba702bbee3038$export$88948ce120ea2619;
var $46fba702bbee3038$export$35808ee640e87ca7;
var $46fba702bbee3038$export$fae74005e78b1a27;
var $46fba702bbee3038$export$dc8fbce3eb94dc1e;
var $46fba702bbee3038$export$6a7bc4e911dc01cf;
var $46fba702bbee3038$export$6d9c69b0de29b591;
var $46fba702bbee3038$export$f680877a34711e37;
var $46fba702bbee3038$export$d5a552a76deda3c2;
var $46fba702bbee3038$export$aaabe4eda9ed9969;
var $46fba702bbee3038$export$e5c5a5f917a5871c;
var $46fba702bbee3038$export$1538c33de8887b59;
var $46fba702bbee3038$export$13e3392192263954;
var $46fba702bbee3038$export$b8f5890fc79d6aca;
var $46fba702bbee3038$export$60241385465d0a34;
var $46fba702bbee3038$export$306c0aa65ff9ec16;
var $46fba702bbee3038$export$7b286972b8d8ccbf;
var $46fba702bbee3038$export$83d89fbfd8236492;
"use strict";
var $46fba702bbee3038$var$l = Symbol.for("react.element"), $46fba702bbee3038$var$n = Symbol.for("react.portal"), $46fba702bbee3038$var$p = Symbol.for("react.fragment"), $46fba702bbee3038$var$q = Symbol.for("react.strict_mode"), $46fba702bbee3038$var$r = Symbol.for("react.profiler"), $46fba702bbee3038$var$t = Symbol.for("react.provider"), $46fba702bbee3038$var$u = Symbol.for("react.context"), $46fba702bbee3038$var$v = Symbol.for("react.forward_ref"), $46fba702bbee3038$var$w = Symbol.for("react.suspense"), $46fba702bbee3038$var$x = Symbol.for("react.memo"), $46fba702bbee3038$var$y = Symbol.for("react.lazy"), $46fba702bbee3038$var$z = Symbol.iterator;
function $46fba702bbee3038$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $46fba702bbee3038$var$z && a[$46fba702bbee3038$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $46fba702bbee3038$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $46fba702bbee3038$var$C = Object.assign, $46fba702bbee3038$var$D = {};
function $46fba702bbee3038$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $46fba702bbee3038$var$D;
    this.updater = e || $46fba702bbee3038$var$B;
}
$46fba702bbee3038$var$E.prototype.isReactComponent = {};
$46fba702bbee3038$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$46fba702bbee3038$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $46fba702bbee3038$var$F() {}
$46fba702bbee3038$var$F.prototype = $46fba702bbee3038$var$E.prototype;
function $46fba702bbee3038$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $46fba702bbee3038$var$D;
    this.updater = e || $46fba702bbee3038$var$B;
}
var $46fba702bbee3038$var$H = $46fba702bbee3038$var$G.prototype = new $46fba702bbee3038$var$F;
$46fba702bbee3038$var$H.constructor = $46fba702bbee3038$var$G;
$46fba702bbee3038$var$C($46fba702bbee3038$var$H, $46fba702bbee3038$var$E.prototype);
$46fba702bbee3038$var$H.isPureReactComponent = !0;
var $46fba702bbee3038$var$I = Array.isArray, $46fba702bbee3038$var$J = Object.prototype.hasOwnProperty, $46fba702bbee3038$var$K = {
    current: null
}, $46fba702bbee3038$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $46fba702bbee3038$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$46fba702bbee3038$var$J.call(b, d) && !$46fba702bbee3038$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $46fba702bbee3038$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $46fba702bbee3038$var$K.current
    };
}
function $46fba702bbee3038$var$N(a, b) {
    return {
        $$typeof: $46fba702bbee3038$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $46fba702bbee3038$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $46fba702bbee3038$var$l;
}
function $46fba702bbee3038$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $46fba702bbee3038$var$P = /\/+/g;
function $46fba702bbee3038$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $46fba702bbee3038$var$escape("" + a.key) : b.toString(36);
}
function $46fba702bbee3038$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $46fba702bbee3038$var$l:
                case $46fba702bbee3038$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $46fba702bbee3038$var$Q(h, 0) : d, $46fba702bbee3038$var$I(c) ? (e = "", null != a && (e = a.replace($46fba702bbee3038$var$P, "$&/") + "/"), $46fba702bbee3038$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($46fba702bbee3038$var$O(c) && (c = $46fba702bbee3038$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($46fba702bbee3038$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($46fba702bbee3038$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $46fba702bbee3038$var$Q(k, g);
        h += $46fba702bbee3038$var$R(k, b, e, f, c);
    }
    else if (f = $46fba702bbee3038$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $46fba702bbee3038$var$Q(k, g++), h += $46fba702bbee3038$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $46fba702bbee3038$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $46fba702bbee3038$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $46fba702bbee3038$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $46fba702bbee3038$var$U = {
    current: null
}, $46fba702bbee3038$var$V = {
    transition: null
}, $46fba702bbee3038$var$W = {
    ReactCurrentDispatcher: $46fba702bbee3038$var$U,
    ReactCurrentBatchConfig: $46fba702bbee3038$var$V,
    ReactCurrentOwner: $46fba702bbee3038$var$K
};
function $46fba702bbee3038$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$46fba702bbee3038$export$dca3b0875bd9a954 = {
    map: $46fba702bbee3038$var$S,
    forEach: function(a, b, e) {
        $46fba702bbee3038$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $46fba702bbee3038$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $46fba702bbee3038$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$46fba702bbee3038$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$46fba702bbee3038$export$16fa2f45be04daa8 = $46fba702bbee3038$var$E;
$46fba702bbee3038$export$ffb0004e005737fa = $46fba702bbee3038$var$p;
$46fba702bbee3038$export$e2c29f18771995cb = $46fba702bbee3038$var$r;
$46fba702bbee3038$export$221d75b3f55bb0bd = $46fba702bbee3038$var$G;
$46fba702bbee3038$export$5f8d39834fd61797 = $46fba702bbee3038$var$q;
$46fba702bbee3038$export$74bf444e3cd11ea5 = $46fba702bbee3038$var$w;
$46fba702bbee3038$export$ae55be85d98224ed = $46fba702bbee3038$var$W;
$46fba702bbee3038$export$3ba232387fd5d6dd = $46fba702bbee3038$var$X;
$46fba702bbee3038$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $46fba702bbee3038$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $46fba702bbee3038$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$46fba702bbee3038$var$J.call(b, f) && !$46fba702bbee3038$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $46fba702bbee3038$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$46fba702bbee3038$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $46fba702bbee3038$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $46fba702bbee3038$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$46fba702bbee3038$export$c8a8987d4410bf2d = $46fba702bbee3038$var$M;
$46fba702bbee3038$export$d38cd72104c1f0e9 = function(a) {
    var b = $46fba702bbee3038$var$M.bind(null, a);
    b.type = a;
    return b;
};
$46fba702bbee3038$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$46fba702bbee3038$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $46fba702bbee3038$var$v,
        render: a
    };
};
$46fba702bbee3038$export$a8257692ac88316c = $46fba702bbee3038$var$O;
$46fba702bbee3038$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $46fba702bbee3038$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $46fba702bbee3038$var$T
    };
};
$46fba702bbee3038$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $46fba702bbee3038$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$46fba702bbee3038$export$7568632d0d33d16d = function(a) {
    var b = $46fba702bbee3038$var$V.transition;
    $46fba702bbee3038$var$V.transition = {};
    try {
        a();
    } finally{
        $46fba702bbee3038$var$V.transition = b;
    }
};
$46fba702bbee3038$export$88948ce120ea2619 = $46fba702bbee3038$var$X;
$46fba702bbee3038$export$35808ee640e87ca7 = function(a, b) {
    return $46fba702bbee3038$var$U.current.useCallback(a, b);
};
$46fba702bbee3038$export$fae74005e78b1a27 = function(a) {
    return $46fba702bbee3038$var$U.current.useContext(a);
};
$46fba702bbee3038$export$dc8fbce3eb94dc1e = function() {};
$46fba702bbee3038$export$6a7bc4e911dc01cf = function(a) {
    return $46fba702bbee3038$var$U.current.useDeferredValue(a);
};
$46fba702bbee3038$export$6d9c69b0de29b591 = function(a, b) {
    return $46fba702bbee3038$var$U.current.useEffect(a, b);
};
$46fba702bbee3038$export$f680877a34711e37 = function() {
    return $46fba702bbee3038$var$U.current.useId();
};
$46fba702bbee3038$export$d5a552a76deda3c2 = function(a, b, e) {
    return $46fba702bbee3038$var$U.current.useImperativeHandle(a, b, e);
};
$46fba702bbee3038$export$aaabe4eda9ed9969 = function(a, b) {
    return $46fba702bbee3038$var$U.current.useInsertionEffect(a, b);
};
$46fba702bbee3038$export$e5c5a5f917a5871c = function(a, b) {
    return $46fba702bbee3038$var$U.current.useLayoutEffect(a, b);
};
$46fba702bbee3038$export$1538c33de8887b59 = function(a, b) {
    return $46fba702bbee3038$var$U.current.useMemo(a, b);
};
$46fba702bbee3038$export$13e3392192263954 = function(a, b, e) {
    return $46fba702bbee3038$var$U.current.useReducer(a, b, e);
};
$46fba702bbee3038$export$b8f5890fc79d6aca = function(a) {
    return $46fba702bbee3038$var$U.current.useRef(a);
};
$46fba702bbee3038$export$60241385465d0a34 = function(a) {
    return $46fba702bbee3038$var$U.current.useState(a);
};
$46fba702bbee3038$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $46fba702bbee3038$var$U.current.useSyncExternalStore(a, b, e);
};
$46fba702bbee3038$export$7b286972b8d8ccbf = function() {
    return $46fba702bbee3038$var$U.current.useTransition();
};
$46fba702bbee3038$export$83d89fbfd8236492 = "18.3.1";

});



parcelRequire.register("1CoNo", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $12dc92f49356566c$export$ae55be85d98224ed; }, function (v) { return $12dc92f49356566c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $12dc92f49356566c$export$d39a5bbd09211389; }, function (v) { return $12dc92f49356566c$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $12dc92f49356566c$export$882461b6382ed46c; }, function (v) { return $12dc92f49356566c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $12dc92f49356566c$export$466bfc07425424d5; }, function (v) { return $12dc92f49356566c$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $12dc92f49356566c$export$cd75ccfd720a3cd4; }, function (v) { return $12dc92f49356566c$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $12dc92f49356566c$export$fa8d919ba61d84db; }, function (v) { return $12dc92f49356566c$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $12dc92f49356566c$export$757ceba2d55c277e; }, function (v) { return $12dc92f49356566c$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $12dc92f49356566c$export$b3890eb0ae9dca99; }, function (v) { return $12dc92f49356566c$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $12dc92f49356566c$export$502457920280e6be; }, function (v) { return $12dc92f49356566c$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $12dc92f49356566c$export$c78a37762a8d58e1; }, function (v) { return $12dc92f49356566c$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $12dc92f49356566c$export$dc54d992c10e8a18; }, function (v) { return $12dc92f49356566c$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $12dc92f49356566c$export$83d89fbfd8236492; }, function (v) { return $12dc92f49356566c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $12dc92f49356566c$export$ae55be85d98224ed;
var $12dc92f49356566c$export$d39a5bbd09211389;
var $12dc92f49356566c$export$882461b6382ed46c;
var $12dc92f49356566c$export$466bfc07425424d5;
var $12dc92f49356566c$export$cd75ccfd720a3cd4;
var $12dc92f49356566c$export$fa8d919ba61d84db;
var $12dc92f49356566c$export$757ceba2d55c277e;
var $12dc92f49356566c$export$b3890eb0ae9dca99;
var $12dc92f49356566c$export$502457920280e6be;
var $12dc92f49356566c$export$c78a37762a8d58e1;
var $12dc92f49356566c$export$dc54d992c10e8a18;
var $12dc92f49356566c$export$83d89fbfd8236492;
"use strict";

var $4lkrv = parcelRequire("4lkrv");

var $aeNmU = parcelRequire("aeNmU");
function $12dc92f49356566c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $12dc92f49356566c$var$da = new Set, $12dc92f49356566c$var$ea = {};
function $12dc92f49356566c$var$fa(a, b) {
    $12dc92f49356566c$var$ha(a, b);
    $12dc92f49356566c$var$ha(a + "Capture", b);
}
function $12dc92f49356566c$var$ha(a, b) {
    $12dc92f49356566c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$12dc92f49356566c$var$da.add(b[a]);
}
var $12dc92f49356566c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $12dc92f49356566c$var$ja = Object.prototype.hasOwnProperty, $12dc92f49356566c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $12dc92f49356566c$var$la = {}, $12dc92f49356566c$var$ma = {};
function $12dc92f49356566c$var$oa(a) {
    if ($12dc92f49356566c$var$ja.call($12dc92f49356566c$var$ma, a)) return !0;
    if ($12dc92f49356566c$var$ja.call($12dc92f49356566c$var$la, a)) return !1;
    if ($12dc92f49356566c$var$ka.test(a)) return $12dc92f49356566c$var$ma[a] = !0;
    $12dc92f49356566c$var$la[a] = !0;
    return !1;
}
function $12dc92f49356566c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $12dc92f49356566c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $12dc92f49356566c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $12dc92f49356566c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $12dc92f49356566c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $12dc92f49356566c$var$z[a] = new $12dc92f49356566c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $12dc92f49356566c$var$z[b] = new $12dc92f49356566c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $12dc92f49356566c$var$z[a] = new $12dc92f49356566c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $12dc92f49356566c$var$z[a] = new $12dc92f49356566c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $12dc92f49356566c$var$z[a] = new $12dc92f49356566c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $12dc92f49356566c$var$z[a] = new $12dc92f49356566c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $12dc92f49356566c$var$z[a] = new $12dc92f49356566c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $12dc92f49356566c$var$z[a] = new $12dc92f49356566c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $12dc92f49356566c$var$z[a] = new $12dc92f49356566c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $12dc92f49356566c$var$ra = /[\-:]([a-z])/g;
function $12dc92f49356566c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($12dc92f49356566c$var$ra, $12dc92f49356566c$var$sa);
    $12dc92f49356566c$var$z[b] = new $12dc92f49356566c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($12dc92f49356566c$var$ra, $12dc92f49356566c$var$sa);
    $12dc92f49356566c$var$z[b] = new $12dc92f49356566c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($12dc92f49356566c$var$ra, $12dc92f49356566c$var$sa);
    $12dc92f49356566c$var$z[b] = new $12dc92f49356566c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $12dc92f49356566c$var$z[a] = new $12dc92f49356566c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$12dc92f49356566c$var$z.xlinkHref = new $12dc92f49356566c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $12dc92f49356566c$var$z[a] = new $12dc92f49356566c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $12dc92f49356566c$var$ta(a, b, c, d) {
    var e = $12dc92f49356566c$var$z.hasOwnProperty(b) ? $12dc92f49356566c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $12dc92f49356566c$var$qa(b, c, e, d) && (c = null), d || null === e ? $12dc92f49356566c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $12dc92f49356566c$var$ua = $4lkrv.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $12dc92f49356566c$var$va = Symbol.for("react.element"), $12dc92f49356566c$var$wa = Symbol.for("react.portal"), $12dc92f49356566c$var$ya = Symbol.for("react.fragment"), $12dc92f49356566c$var$za = Symbol.for("react.strict_mode"), $12dc92f49356566c$var$Aa = Symbol.for("react.profiler"), $12dc92f49356566c$var$Ba = Symbol.for("react.provider"), $12dc92f49356566c$var$Ca = Symbol.for("react.context"), $12dc92f49356566c$var$Da = Symbol.for("react.forward_ref"), $12dc92f49356566c$var$Ea = Symbol.for("react.suspense"), $12dc92f49356566c$var$Fa = Symbol.for("react.suspense_list"), $12dc92f49356566c$var$Ga = Symbol.for("react.memo"), $12dc92f49356566c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $12dc92f49356566c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $12dc92f49356566c$var$Ja = Symbol.iterator;
function $12dc92f49356566c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $12dc92f49356566c$var$Ja && a[$12dc92f49356566c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $12dc92f49356566c$var$A = Object.assign, $12dc92f49356566c$var$La;
function $12dc92f49356566c$var$Ma(a) {
    if (void 0 === $12dc92f49356566c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $12dc92f49356566c$var$La = b && b[1] || "";
    }
    return "\n" + $12dc92f49356566c$var$La + a;
}
var $12dc92f49356566c$var$Na = !1;
function $12dc92f49356566c$var$Oa(a, b) {
    if (!a || $12dc92f49356566c$var$Na) return "";
    $12dc92f49356566c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $12dc92f49356566c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $12dc92f49356566c$var$Ma(a) : "";
}
function $12dc92f49356566c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $12dc92f49356566c$var$Ma(a.type);
        case 16:
            return $12dc92f49356566c$var$Ma("Lazy");
        case 13:
            return $12dc92f49356566c$var$Ma("Suspense");
        case 19:
            return $12dc92f49356566c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $12dc92f49356566c$var$Oa(a.type, !1), a;
        case 11:
            return a = $12dc92f49356566c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $12dc92f49356566c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $12dc92f49356566c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $12dc92f49356566c$var$ya:
            return "Fragment";
        case $12dc92f49356566c$var$wa:
            return "Portal";
        case $12dc92f49356566c$var$Aa:
            return "Profiler";
        case $12dc92f49356566c$var$za:
            return "StrictMode";
        case $12dc92f49356566c$var$Ea:
            return "Suspense";
        case $12dc92f49356566c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $12dc92f49356566c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $12dc92f49356566c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $12dc92f49356566c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $12dc92f49356566c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $12dc92f49356566c$var$Qa(a.type) || "Memo";
        case $12dc92f49356566c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $12dc92f49356566c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $12dc92f49356566c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $12dc92f49356566c$var$Qa(b);
        case 8:
            return b === $12dc92f49356566c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $12dc92f49356566c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $12dc92f49356566c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $12dc92f49356566c$var$Ua(a) {
    var b = $12dc92f49356566c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $12dc92f49356566c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $12dc92f49356566c$var$Ua(a));
}
function $12dc92f49356566c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $12dc92f49356566c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $12dc92f49356566c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $12dc92f49356566c$var$Ya(a, b) {
    var c = b.checked;
    return $12dc92f49356566c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $12dc92f49356566c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $12dc92f49356566c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $12dc92f49356566c$var$ab(a, b) {
    b = b.checked;
    null != b && $12dc92f49356566c$var$ta(a, "checked", b, !1);
}
function $12dc92f49356566c$var$bb(a, b) {
    $12dc92f49356566c$var$ab(a, b);
    var c = $12dc92f49356566c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $12dc92f49356566c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $12dc92f49356566c$var$cb(a, b.type, $12dc92f49356566c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $12dc92f49356566c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $12dc92f49356566c$var$cb(a, b, c) {
    if ("number" !== b || $12dc92f49356566c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $12dc92f49356566c$var$eb = Array.isArray;
function $12dc92f49356566c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $12dc92f49356566c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $12dc92f49356566c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($12dc92f49356566c$var$p(91));
    return $12dc92f49356566c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $12dc92f49356566c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($12dc92f49356566c$var$p(92));
            if ($12dc92f49356566c$var$eb(c)) {
                if (1 < c.length) throw Error($12dc92f49356566c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $12dc92f49356566c$var$Sa(c)
    };
}
function $12dc92f49356566c$var$ib(a, b) {
    var c = $12dc92f49356566c$var$Sa(b.value), d = $12dc92f49356566c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $12dc92f49356566c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $12dc92f49356566c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $12dc92f49356566c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $12dc92f49356566c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $12dc92f49356566c$var$mb, $12dc92f49356566c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $12dc92f49356566c$var$mb = $12dc92f49356566c$var$mb || document.createElement("div");
        $12dc92f49356566c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $12dc92f49356566c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $12dc92f49356566c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $12dc92f49356566c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $12dc92f49356566c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($12dc92f49356566c$var$pb).forEach(function(a) {
    $12dc92f49356566c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $12dc92f49356566c$var$pb[b] = $12dc92f49356566c$var$pb[a];
    });
});
function $12dc92f49356566c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $12dc92f49356566c$var$pb.hasOwnProperty(a) && $12dc92f49356566c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $12dc92f49356566c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $12dc92f49356566c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $12dc92f49356566c$var$tb = $12dc92f49356566c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $12dc92f49356566c$var$ub(a, b) {
    if (b) {
        if ($12dc92f49356566c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($12dc92f49356566c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($12dc92f49356566c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($12dc92f49356566c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($12dc92f49356566c$var$p(62));
    }
}
function $12dc92f49356566c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $12dc92f49356566c$var$wb = null;
function $12dc92f49356566c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $12dc92f49356566c$var$yb = null, $12dc92f49356566c$var$zb = null, $12dc92f49356566c$var$Ab = null;
function $12dc92f49356566c$var$Bb(a) {
    if (a = $12dc92f49356566c$var$Cb(a)) {
        if ("function" !== typeof $12dc92f49356566c$var$yb) throw Error($12dc92f49356566c$var$p(280));
        var b = a.stateNode;
        b && (b = $12dc92f49356566c$var$Db(b), $12dc92f49356566c$var$yb(a.stateNode, a.type, b));
    }
}
function $12dc92f49356566c$var$Eb(a) {
    $12dc92f49356566c$var$zb ? $12dc92f49356566c$var$Ab ? $12dc92f49356566c$var$Ab.push(a) : $12dc92f49356566c$var$Ab = [
        a
    ] : $12dc92f49356566c$var$zb = a;
}
function $12dc92f49356566c$var$Fb() {
    if ($12dc92f49356566c$var$zb) {
        var a = $12dc92f49356566c$var$zb, b = $12dc92f49356566c$var$Ab;
        $12dc92f49356566c$var$Ab = $12dc92f49356566c$var$zb = null;
        $12dc92f49356566c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$12dc92f49356566c$var$Bb(b[a]);
    }
}
function $12dc92f49356566c$var$Gb(a, b) {
    return a(b);
}
function $12dc92f49356566c$var$Hb() {}
var $12dc92f49356566c$var$Ib = !1;
function $12dc92f49356566c$var$Jb(a, b, c) {
    if ($12dc92f49356566c$var$Ib) return a(b, c);
    $12dc92f49356566c$var$Ib = !0;
    try {
        return $12dc92f49356566c$var$Gb(a, b, c);
    } finally{
        if ($12dc92f49356566c$var$Ib = !1, null !== $12dc92f49356566c$var$zb || null !== $12dc92f49356566c$var$Ab) $12dc92f49356566c$var$Hb(), $12dc92f49356566c$var$Fb();
    }
}
function $12dc92f49356566c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $12dc92f49356566c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($12dc92f49356566c$var$p(231, b, typeof c));
    return c;
}
var $12dc92f49356566c$var$Lb = !1;
if ($12dc92f49356566c$var$ia) try {
    var $12dc92f49356566c$var$Mb = {};
    Object.defineProperty($12dc92f49356566c$var$Mb, "passive", {
        get: function() {
            $12dc92f49356566c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $12dc92f49356566c$var$Mb, $12dc92f49356566c$var$Mb);
    window.removeEventListener("test", $12dc92f49356566c$var$Mb, $12dc92f49356566c$var$Mb);
} catch (a) {
    $12dc92f49356566c$var$Lb = !1;
}
function $12dc92f49356566c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $12dc92f49356566c$var$Ob = !1, $12dc92f49356566c$var$Pb = null, $12dc92f49356566c$var$Qb = !1, $12dc92f49356566c$var$Rb = null, $12dc92f49356566c$var$Sb = {
    onError: function(a) {
        $12dc92f49356566c$var$Ob = !0;
        $12dc92f49356566c$var$Pb = a;
    }
};
function $12dc92f49356566c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $12dc92f49356566c$var$Ob = !1;
    $12dc92f49356566c$var$Pb = null;
    $12dc92f49356566c$var$Nb.apply($12dc92f49356566c$var$Sb, arguments);
}
function $12dc92f49356566c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $12dc92f49356566c$var$Tb.apply(this, arguments);
    if ($12dc92f49356566c$var$Ob) {
        if ($12dc92f49356566c$var$Ob) {
            var l = $12dc92f49356566c$var$Pb;
            $12dc92f49356566c$var$Ob = !1;
            $12dc92f49356566c$var$Pb = null;
        } else throw Error($12dc92f49356566c$var$p(198));
        $12dc92f49356566c$var$Qb || ($12dc92f49356566c$var$Qb = !0, $12dc92f49356566c$var$Rb = l);
    }
}
function $12dc92f49356566c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $12dc92f49356566c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $12dc92f49356566c$var$Xb(a) {
    if ($12dc92f49356566c$var$Vb(a) !== a) throw Error($12dc92f49356566c$var$p(188));
}
function $12dc92f49356566c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $12dc92f49356566c$var$Vb(a);
        if (null === b) throw Error($12dc92f49356566c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $12dc92f49356566c$var$Xb(e), a;
                if (f === d) return $12dc92f49356566c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($12dc92f49356566c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($12dc92f49356566c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($12dc92f49356566c$var$p(190));
    }
    if (3 !== c.tag) throw Error($12dc92f49356566c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $12dc92f49356566c$var$Zb(a) {
    a = $12dc92f49356566c$var$Yb(a);
    return null !== a ? $12dc92f49356566c$var$$b(a) : null;
}
function $12dc92f49356566c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $12dc92f49356566c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $12dc92f49356566c$var$ac = $aeNmU.unstable_scheduleCallback, $12dc92f49356566c$var$bc = $aeNmU.unstable_cancelCallback, $12dc92f49356566c$var$cc = $aeNmU.unstable_shouldYield, $12dc92f49356566c$var$dc = $aeNmU.unstable_requestPaint, $12dc92f49356566c$var$B = $aeNmU.unstable_now, $12dc92f49356566c$var$ec = $aeNmU.unstable_getCurrentPriorityLevel, $12dc92f49356566c$var$fc = $aeNmU.unstable_ImmediatePriority, $12dc92f49356566c$var$gc = $aeNmU.unstable_UserBlockingPriority, $12dc92f49356566c$var$hc = $aeNmU.unstable_NormalPriority, $12dc92f49356566c$var$ic = $aeNmU.unstable_LowPriority, $12dc92f49356566c$var$jc = $aeNmU.unstable_IdlePriority, $12dc92f49356566c$var$kc = null, $12dc92f49356566c$var$lc = null;
function $12dc92f49356566c$var$mc(a) {
    if ($12dc92f49356566c$var$lc && "function" === typeof $12dc92f49356566c$var$lc.onCommitFiberRoot) try {
        $12dc92f49356566c$var$lc.onCommitFiberRoot($12dc92f49356566c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $12dc92f49356566c$var$oc = Math.clz32 ? Math.clz32 : $12dc92f49356566c$var$nc, $12dc92f49356566c$var$pc = Math.log, $12dc92f49356566c$var$qc = Math.LN2;
function $12dc92f49356566c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($12dc92f49356566c$var$pc(a) / $12dc92f49356566c$var$qc | 0) | 0;
}
var $12dc92f49356566c$var$rc = 64, $12dc92f49356566c$var$sc = 4194304;
function $12dc92f49356566c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $12dc92f49356566c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $12dc92f49356566c$var$tc(h) : (f &= g, 0 !== f && (d = $12dc92f49356566c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $12dc92f49356566c$var$tc(g) : 0 !== f && (d = $12dc92f49356566c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $12dc92f49356566c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $12dc92f49356566c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $12dc92f49356566c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $12dc92f49356566c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $12dc92f49356566c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $12dc92f49356566c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $12dc92f49356566c$var$yc() {
    var a = $12dc92f49356566c$var$rc;
    $12dc92f49356566c$var$rc <<= 1;
    0 === ($12dc92f49356566c$var$rc & 4194240) && ($12dc92f49356566c$var$rc = 64);
    return a;
}
function $12dc92f49356566c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $12dc92f49356566c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $12dc92f49356566c$var$oc(b);
    a[b] = c;
}
function $12dc92f49356566c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $12dc92f49356566c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $12dc92f49356566c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $12dc92f49356566c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $12dc92f49356566c$var$C = 0;
function $12dc92f49356566c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $12dc92f49356566c$var$Ec, $12dc92f49356566c$var$Fc, $12dc92f49356566c$var$Gc, $12dc92f49356566c$var$Hc, $12dc92f49356566c$var$Ic, $12dc92f49356566c$var$Jc = !1, $12dc92f49356566c$var$Kc = [], $12dc92f49356566c$var$Lc = null, $12dc92f49356566c$var$Mc = null, $12dc92f49356566c$var$Nc = null, $12dc92f49356566c$var$Oc = new Map, $12dc92f49356566c$var$Pc = new Map, $12dc92f49356566c$var$Qc = [], $12dc92f49356566c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $12dc92f49356566c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $12dc92f49356566c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $12dc92f49356566c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $12dc92f49356566c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $12dc92f49356566c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $12dc92f49356566c$var$Pc.delete(b.pointerId);
    }
}
function $12dc92f49356566c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $12dc92f49356566c$var$Cb(b), null !== b && $12dc92f49356566c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $12dc92f49356566c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $12dc92f49356566c$var$Lc = $12dc92f49356566c$var$Tc($12dc92f49356566c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $12dc92f49356566c$var$Mc = $12dc92f49356566c$var$Tc($12dc92f49356566c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $12dc92f49356566c$var$Nc = $12dc92f49356566c$var$Tc($12dc92f49356566c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $12dc92f49356566c$var$Oc.set(f, $12dc92f49356566c$var$Tc($12dc92f49356566c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $12dc92f49356566c$var$Pc.set(f, $12dc92f49356566c$var$Tc($12dc92f49356566c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $12dc92f49356566c$var$Vc(a) {
    var b = $12dc92f49356566c$var$Wc(a.target);
    if (null !== b) {
        var c = $12dc92f49356566c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $12dc92f49356566c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $12dc92f49356566c$var$Ic(a.priority, function() {
                        $12dc92f49356566c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $12dc92f49356566c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $12dc92f49356566c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $12dc92f49356566c$var$wb = d;
            c.target.dispatchEvent(d);
            $12dc92f49356566c$var$wb = null;
        } else return b = $12dc92f49356566c$var$Cb(c), null !== b && $12dc92f49356566c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $12dc92f49356566c$var$Zc(a, b, c) {
    $12dc92f49356566c$var$Xc(a) && c.delete(b);
}
function $12dc92f49356566c$var$$c() {
    $12dc92f49356566c$var$Jc = !1;
    null !== $12dc92f49356566c$var$Lc && $12dc92f49356566c$var$Xc($12dc92f49356566c$var$Lc) && ($12dc92f49356566c$var$Lc = null);
    null !== $12dc92f49356566c$var$Mc && $12dc92f49356566c$var$Xc($12dc92f49356566c$var$Mc) && ($12dc92f49356566c$var$Mc = null);
    null !== $12dc92f49356566c$var$Nc && $12dc92f49356566c$var$Xc($12dc92f49356566c$var$Nc) && ($12dc92f49356566c$var$Nc = null);
    $12dc92f49356566c$var$Oc.forEach($12dc92f49356566c$var$Zc);
    $12dc92f49356566c$var$Pc.forEach($12dc92f49356566c$var$Zc);
}
function $12dc92f49356566c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $12dc92f49356566c$var$Jc || ($12dc92f49356566c$var$Jc = !0, $aeNmU.unstable_scheduleCallback($aeNmU.unstable_NormalPriority, $12dc92f49356566c$var$$c)));
}
function $12dc92f49356566c$var$bd(a) {
    function b(b) {
        return $12dc92f49356566c$var$ad(b, a);
    }
    if (0 < $12dc92f49356566c$var$Kc.length) {
        $12dc92f49356566c$var$ad($12dc92f49356566c$var$Kc[0], a);
        for(var c = 1; c < $12dc92f49356566c$var$Kc.length; c++){
            var d = $12dc92f49356566c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $12dc92f49356566c$var$Lc && $12dc92f49356566c$var$ad($12dc92f49356566c$var$Lc, a);
    null !== $12dc92f49356566c$var$Mc && $12dc92f49356566c$var$ad($12dc92f49356566c$var$Mc, a);
    null !== $12dc92f49356566c$var$Nc && $12dc92f49356566c$var$ad($12dc92f49356566c$var$Nc, a);
    $12dc92f49356566c$var$Oc.forEach(b);
    $12dc92f49356566c$var$Pc.forEach(b);
    for(c = 0; c < $12dc92f49356566c$var$Qc.length; c++)d = $12dc92f49356566c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $12dc92f49356566c$var$Qc.length && (c = $12dc92f49356566c$var$Qc[0], null === c.blockedOn);)$12dc92f49356566c$var$Vc(c), null === c.blockedOn && $12dc92f49356566c$var$Qc.shift();
}
var $12dc92f49356566c$var$cd = $12dc92f49356566c$var$ua.ReactCurrentBatchConfig, $12dc92f49356566c$var$dd = !0;
function $12dc92f49356566c$var$ed(a, b, c, d) {
    var e = $12dc92f49356566c$var$C, f = $12dc92f49356566c$var$cd.transition;
    $12dc92f49356566c$var$cd.transition = null;
    try {
        $12dc92f49356566c$var$C = 1, $12dc92f49356566c$var$fd(a, b, c, d);
    } finally{
        $12dc92f49356566c$var$C = e, $12dc92f49356566c$var$cd.transition = f;
    }
}
function $12dc92f49356566c$var$gd(a, b, c, d) {
    var e = $12dc92f49356566c$var$C, f = $12dc92f49356566c$var$cd.transition;
    $12dc92f49356566c$var$cd.transition = null;
    try {
        $12dc92f49356566c$var$C = 4, $12dc92f49356566c$var$fd(a, b, c, d);
    } finally{
        $12dc92f49356566c$var$C = e, $12dc92f49356566c$var$cd.transition = f;
    }
}
function $12dc92f49356566c$var$fd(a, b, c, d) {
    if ($12dc92f49356566c$var$dd) {
        var e = $12dc92f49356566c$var$Yc(a, b, c, d);
        if (null === e) $12dc92f49356566c$var$hd(a, b, d, $12dc92f49356566c$var$id, c), $12dc92f49356566c$var$Sc(a, d);
        else if ($12dc92f49356566c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($12dc92f49356566c$var$Sc(a, d), b & 4 && -1 < $12dc92f49356566c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $12dc92f49356566c$var$Cb(e);
                null !== f && $12dc92f49356566c$var$Ec(f);
                f = $12dc92f49356566c$var$Yc(a, b, c, d);
                null === f && $12dc92f49356566c$var$hd(a, b, d, $12dc92f49356566c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $12dc92f49356566c$var$hd(a, b, d, null, c);
    }
}
var $12dc92f49356566c$var$id = null;
function $12dc92f49356566c$var$Yc(a, b, c, d) {
    $12dc92f49356566c$var$id = null;
    a = $12dc92f49356566c$var$xb(d);
    a = $12dc92f49356566c$var$Wc(a);
    if (null !== a) {
        if (b = $12dc92f49356566c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $12dc92f49356566c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $12dc92f49356566c$var$id = a;
    return null;
}
function $12dc92f49356566c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($12dc92f49356566c$var$ec()){
                case $12dc92f49356566c$var$fc:
                    return 1;
                case $12dc92f49356566c$var$gc:
                    return 4;
                case $12dc92f49356566c$var$hc:
                case $12dc92f49356566c$var$ic:
                    return 16;
                case $12dc92f49356566c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $12dc92f49356566c$var$kd = null, $12dc92f49356566c$var$ld = null, $12dc92f49356566c$var$md = null;
function $12dc92f49356566c$var$nd() {
    if ($12dc92f49356566c$var$md) return $12dc92f49356566c$var$md;
    var a, b = $12dc92f49356566c$var$ld, c = b.length, d, e = "value" in $12dc92f49356566c$var$kd ? $12dc92f49356566c$var$kd.value : $12dc92f49356566c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $12dc92f49356566c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $12dc92f49356566c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $12dc92f49356566c$var$pd() {
    return !0;
}
function $12dc92f49356566c$var$qd() {
    return !1;
}
function $12dc92f49356566c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $12dc92f49356566c$var$pd : $12dc92f49356566c$var$qd;
        this.isPropagationStopped = $12dc92f49356566c$var$qd;
        return this;
    }
    $12dc92f49356566c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $12dc92f49356566c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $12dc92f49356566c$var$pd);
        },
        persist: function() {},
        isPersistent: $12dc92f49356566c$var$pd
    });
    return b;
}
var $12dc92f49356566c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $12dc92f49356566c$var$td = $12dc92f49356566c$var$rd($12dc92f49356566c$var$sd), $12dc92f49356566c$var$ud = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$sd, {
    view: 0,
    detail: 0
}), $12dc92f49356566c$var$vd = $12dc92f49356566c$var$rd($12dc92f49356566c$var$ud), $12dc92f49356566c$var$wd, $12dc92f49356566c$var$xd, $12dc92f49356566c$var$yd, $12dc92f49356566c$var$Ad = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $12dc92f49356566c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $12dc92f49356566c$var$yd && ($12dc92f49356566c$var$yd && "mousemove" === a.type ? ($12dc92f49356566c$var$wd = a.screenX - $12dc92f49356566c$var$yd.screenX, $12dc92f49356566c$var$xd = a.screenY - $12dc92f49356566c$var$yd.screenY) : $12dc92f49356566c$var$xd = $12dc92f49356566c$var$wd = 0, $12dc92f49356566c$var$yd = a);
        return $12dc92f49356566c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $12dc92f49356566c$var$xd;
    }
}), $12dc92f49356566c$var$Bd = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Ad), $12dc92f49356566c$var$Cd = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$Ad, {
    dataTransfer: 0
}), $12dc92f49356566c$var$Dd = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Cd), $12dc92f49356566c$var$Ed = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$ud, {
    relatedTarget: 0
}), $12dc92f49356566c$var$Fd = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Ed), $12dc92f49356566c$var$Gd = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $12dc92f49356566c$var$Hd = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Gd), $12dc92f49356566c$var$Id = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $12dc92f49356566c$var$Jd = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Id), $12dc92f49356566c$var$Kd = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$sd, {
    data: 0
}), $12dc92f49356566c$var$Ld = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Kd), $12dc92f49356566c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $12dc92f49356566c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $12dc92f49356566c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $12dc92f49356566c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $12dc92f49356566c$var$Od[a]) ? !!b[a] : !1;
}
function $12dc92f49356566c$var$zd() {
    return $12dc92f49356566c$var$Pd;
}
var $12dc92f49356566c$var$Qd = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $12dc92f49356566c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $12dc92f49356566c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $12dc92f49356566c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $12dc92f49356566c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $12dc92f49356566c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $12dc92f49356566c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $12dc92f49356566c$var$Rd = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Qd), $12dc92f49356566c$var$Sd = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $12dc92f49356566c$var$Td = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Sd), $12dc92f49356566c$var$Ud = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $12dc92f49356566c$var$zd
}), $12dc92f49356566c$var$Vd = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Ud), $12dc92f49356566c$var$Wd = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $12dc92f49356566c$var$Xd = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Wd), $12dc92f49356566c$var$Yd = $12dc92f49356566c$var$A({}, $12dc92f49356566c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $12dc92f49356566c$var$Zd = $12dc92f49356566c$var$rd($12dc92f49356566c$var$Yd), $12dc92f49356566c$var$$d = [
    9,
    13,
    27,
    32
], $12dc92f49356566c$var$ae = $12dc92f49356566c$var$ia && "CompositionEvent" in window, $12dc92f49356566c$var$be = null;
$12dc92f49356566c$var$ia && "documentMode" in document && ($12dc92f49356566c$var$be = document.documentMode);
var $12dc92f49356566c$var$ce = $12dc92f49356566c$var$ia && "TextEvent" in window && !$12dc92f49356566c$var$be, $12dc92f49356566c$var$de = $12dc92f49356566c$var$ia && (!$12dc92f49356566c$var$ae || $12dc92f49356566c$var$be && 8 < $12dc92f49356566c$var$be && 11 >= $12dc92f49356566c$var$be), $12dc92f49356566c$var$ee = String.fromCharCode(32), $12dc92f49356566c$var$fe = !1;
function $12dc92f49356566c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $12dc92f49356566c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $12dc92f49356566c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $12dc92f49356566c$var$ie = !1;
function $12dc92f49356566c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $12dc92f49356566c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $12dc92f49356566c$var$fe = !0;
            return $12dc92f49356566c$var$ee;
        case "textInput":
            return a = b.data, a === $12dc92f49356566c$var$ee && $12dc92f49356566c$var$fe ? null : a;
        default:
            return null;
    }
}
function $12dc92f49356566c$var$ke(a, b) {
    if ($12dc92f49356566c$var$ie) return "compositionend" === a || !$12dc92f49356566c$var$ae && $12dc92f49356566c$var$ge(a, b) ? (a = $12dc92f49356566c$var$nd(), $12dc92f49356566c$var$md = $12dc92f49356566c$var$ld = $12dc92f49356566c$var$kd = null, $12dc92f49356566c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $12dc92f49356566c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $12dc92f49356566c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $12dc92f49356566c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$12dc92f49356566c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $12dc92f49356566c$var$ne(a, b, c, d) {
    $12dc92f49356566c$var$Eb(d);
    b = $12dc92f49356566c$var$oe(b, "onChange");
    0 < b.length && (c = new $12dc92f49356566c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $12dc92f49356566c$var$pe = null, $12dc92f49356566c$var$qe = null;
function $12dc92f49356566c$var$re(a) {
    $12dc92f49356566c$var$se(a, 0);
}
function $12dc92f49356566c$var$te(a) {
    var b = $12dc92f49356566c$var$ue(a);
    if ($12dc92f49356566c$var$Wa(b)) return a;
}
function $12dc92f49356566c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $12dc92f49356566c$var$we = !1;
if ($12dc92f49356566c$var$ia) {
    var $12dc92f49356566c$var$xe;
    if ($12dc92f49356566c$var$ia) {
        var $12dc92f49356566c$var$ye = "oninput" in document;
        if (!$12dc92f49356566c$var$ye) {
            var $12dc92f49356566c$var$ze = document.createElement("div");
            $12dc92f49356566c$var$ze.setAttribute("oninput", "return;");
            $12dc92f49356566c$var$ye = "function" === typeof $12dc92f49356566c$var$ze.oninput;
        }
        $12dc92f49356566c$var$xe = $12dc92f49356566c$var$ye;
    } else $12dc92f49356566c$var$xe = !1;
    $12dc92f49356566c$var$we = $12dc92f49356566c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $12dc92f49356566c$var$Ae() {
    $12dc92f49356566c$var$pe && ($12dc92f49356566c$var$pe.detachEvent("onpropertychange", $12dc92f49356566c$var$Be), $12dc92f49356566c$var$qe = $12dc92f49356566c$var$pe = null);
}
function $12dc92f49356566c$var$Be(a) {
    if ("value" === a.propertyName && $12dc92f49356566c$var$te($12dc92f49356566c$var$qe)) {
        var b = [];
        $12dc92f49356566c$var$ne(b, $12dc92f49356566c$var$qe, a, $12dc92f49356566c$var$xb(a));
        $12dc92f49356566c$var$Jb($12dc92f49356566c$var$re, b);
    }
}
function $12dc92f49356566c$var$Ce(a, b, c) {
    "focusin" === a ? ($12dc92f49356566c$var$Ae(), $12dc92f49356566c$var$pe = b, $12dc92f49356566c$var$qe = c, $12dc92f49356566c$var$pe.attachEvent("onpropertychange", $12dc92f49356566c$var$Be)) : "focusout" === a && $12dc92f49356566c$var$Ae();
}
function $12dc92f49356566c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $12dc92f49356566c$var$te($12dc92f49356566c$var$qe);
}
function $12dc92f49356566c$var$Ee(a, b) {
    if ("click" === a) return $12dc92f49356566c$var$te(b);
}
function $12dc92f49356566c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $12dc92f49356566c$var$te(b);
}
function $12dc92f49356566c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $12dc92f49356566c$var$He = "function" === typeof Object.is ? Object.is : $12dc92f49356566c$var$Ge;
function $12dc92f49356566c$var$Ie(a, b) {
    if ($12dc92f49356566c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$12dc92f49356566c$var$ja.call(b, e) || !$12dc92f49356566c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $12dc92f49356566c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $12dc92f49356566c$var$Ke(a, b) {
    var c = $12dc92f49356566c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $12dc92f49356566c$var$Je(c);
    }
}
function $12dc92f49356566c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $12dc92f49356566c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $12dc92f49356566c$var$Me() {
    for(var a = window, b = $12dc92f49356566c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $12dc92f49356566c$var$Xa(a.document);
    }
    return b;
}
function $12dc92f49356566c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $12dc92f49356566c$var$Oe(a) {
    var b = $12dc92f49356566c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $12dc92f49356566c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $12dc92f49356566c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $12dc92f49356566c$var$Ke(c, f);
                var g = $12dc92f49356566c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $12dc92f49356566c$var$Pe = $12dc92f49356566c$var$ia && "documentMode" in document && 11 >= document.documentMode, $12dc92f49356566c$var$Qe = null, $12dc92f49356566c$var$Re = null, $12dc92f49356566c$var$Se = null, $12dc92f49356566c$var$Te = !1;
function $12dc92f49356566c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $12dc92f49356566c$var$Te || null == $12dc92f49356566c$var$Qe || $12dc92f49356566c$var$Qe !== $12dc92f49356566c$var$Xa(d) || (d = $12dc92f49356566c$var$Qe, "selectionStart" in d && $12dc92f49356566c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $12dc92f49356566c$var$Se && $12dc92f49356566c$var$Ie($12dc92f49356566c$var$Se, d) || ($12dc92f49356566c$var$Se = d, d = $12dc92f49356566c$var$oe($12dc92f49356566c$var$Re, "onSelect"), 0 < d.length && (b = new $12dc92f49356566c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $12dc92f49356566c$var$Qe)));
}
function $12dc92f49356566c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $12dc92f49356566c$var$We = {
    animationend: $12dc92f49356566c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $12dc92f49356566c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $12dc92f49356566c$var$Ve("Animation", "AnimationStart"),
    transitionend: $12dc92f49356566c$var$Ve("Transition", "TransitionEnd")
}, $12dc92f49356566c$var$Xe = {}, $12dc92f49356566c$var$Ye = {};
$12dc92f49356566c$var$ia && ($12dc92f49356566c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $12dc92f49356566c$var$We.animationend.animation, delete $12dc92f49356566c$var$We.animationiteration.animation, delete $12dc92f49356566c$var$We.animationstart.animation), "TransitionEvent" in window || delete $12dc92f49356566c$var$We.transitionend.transition);
function $12dc92f49356566c$var$Ze(a) {
    if ($12dc92f49356566c$var$Xe[a]) return $12dc92f49356566c$var$Xe[a];
    if (!$12dc92f49356566c$var$We[a]) return a;
    var b = $12dc92f49356566c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $12dc92f49356566c$var$Ye) return $12dc92f49356566c$var$Xe[a] = b[c];
    return a;
}
var $12dc92f49356566c$var$$e = $12dc92f49356566c$var$Ze("animationend"), $12dc92f49356566c$var$af = $12dc92f49356566c$var$Ze("animationiteration"), $12dc92f49356566c$var$bf = $12dc92f49356566c$var$Ze("animationstart"), $12dc92f49356566c$var$cf = $12dc92f49356566c$var$Ze("transitionend"), $12dc92f49356566c$var$df = new Map, $12dc92f49356566c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $12dc92f49356566c$var$ff(a, b) {
    $12dc92f49356566c$var$df.set(a, b);
    $12dc92f49356566c$var$fa(b, [
        a
    ]);
}
for(var $12dc92f49356566c$var$gf = 0; $12dc92f49356566c$var$gf < $12dc92f49356566c$var$ef.length; $12dc92f49356566c$var$gf++){
    var $12dc92f49356566c$var$hf = $12dc92f49356566c$var$ef[$12dc92f49356566c$var$gf], $12dc92f49356566c$var$jf = $12dc92f49356566c$var$hf.toLowerCase(), $12dc92f49356566c$var$kf = $12dc92f49356566c$var$hf[0].toUpperCase() + $12dc92f49356566c$var$hf.slice(1);
    $12dc92f49356566c$var$ff($12dc92f49356566c$var$jf, "on" + $12dc92f49356566c$var$kf);
}
$12dc92f49356566c$var$ff($12dc92f49356566c$var$$e, "onAnimationEnd");
$12dc92f49356566c$var$ff($12dc92f49356566c$var$af, "onAnimationIteration");
$12dc92f49356566c$var$ff($12dc92f49356566c$var$bf, "onAnimationStart");
$12dc92f49356566c$var$ff("dblclick", "onDoubleClick");
$12dc92f49356566c$var$ff("focusin", "onFocus");
$12dc92f49356566c$var$ff("focusout", "onBlur");
$12dc92f49356566c$var$ff($12dc92f49356566c$var$cf, "onTransitionEnd");
$12dc92f49356566c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$12dc92f49356566c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$12dc92f49356566c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$12dc92f49356566c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$12dc92f49356566c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$12dc92f49356566c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$12dc92f49356566c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$12dc92f49356566c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$12dc92f49356566c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$12dc92f49356566c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $12dc92f49356566c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $12dc92f49356566c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($12dc92f49356566c$var$lf));
function $12dc92f49356566c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $12dc92f49356566c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $12dc92f49356566c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $12dc92f49356566c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $12dc92f49356566c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($12dc92f49356566c$var$Qb) throw a = $12dc92f49356566c$var$Rb, $12dc92f49356566c$var$Qb = !1, $12dc92f49356566c$var$Rb = null, a;
}
function $12dc92f49356566c$var$D(a, b) {
    var c = b[$12dc92f49356566c$var$of];
    void 0 === c && (c = b[$12dc92f49356566c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($12dc92f49356566c$var$pf(b, a, 2, !1), c.add(d));
}
function $12dc92f49356566c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $12dc92f49356566c$var$pf(c, a, d, b);
}
var $12dc92f49356566c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $12dc92f49356566c$var$sf(a) {
    if (!a[$12dc92f49356566c$var$rf]) {
        a[$12dc92f49356566c$var$rf] = !0;
        $12dc92f49356566c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($12dc92f49356566c$var$mf.has(b) || $12dc92f49356566c$var$qf(b, !1, a), $12dc92f49356566c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$12dc92f49356566c$var$rf] || (b[$12dc92f49356566c$var$rf] = !0, $12dc92f49356566c$var$qf("selectionchange", !1, b));
    }
}
function $12dc92f49356566c$var$pf(a, b, c, d) {
    switch($12dc92f49356566c$var$jd(b)){
        case 1:
            var e = $12dc92f49356566c$var$ed;
            break;
        case 4:
            e = $12dc92f49356566c$var$gd;
            break;
        default:
            e = $12dc92f49356566c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$12dc92f49356566c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $12dc92f49356566c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $12dc92f49356566c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $12dc92f49356566c$var$Jb(function() {
        var d = f, e = $12dc92f49356566c$var$xb(c), g = [];
        a: {
            var h = $12dc92f49356566c$var$df.get(a);
            if (void 0 !== h) {
                var k = $12dc92f49356566c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $12dc92f49356566c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $12dc92f49356566c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $12dc92f49356566c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $12dc92f49356566c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $12dc92f49356566c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $12dc92f49356566c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $12dc92f49356566c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $12dc92f49356566c$var$Vd;
                        break;
                    case $12dc92f49356566c$var$$e:
                    case $12dc92f49356566c$var$af:
                    case $12dc92f49356566c$var$bf:
                        k = $12dc92f49356566c$var$Hd;
                        break;
                    case $12dc92f49356566c$var$cf:
                        k = $12dc92f49356566c$var$Xd;
                        break;
                    case "scroll":
                        k = $12dc92f49356566c$var$vd;
                        break;
                    case "wheel":
                        k = $12dc92f49356566c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $12dc92f49356566c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $12dc92f49356566c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $12dc92f49356566c$var$Kb(w, x), null != F && t.push($12dc92f49356566c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $12dc92f49356566c$var$wb && (n = c.relatedTarget || c.fromElement) && ($12dc92f49356566c$var$Wc(n) || n[$12dc92f49356566c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $12dc92f49356566c$var$Wc(n) : null, null !== n && (J = $12dc92f49356566c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $12dc92f49356566c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $12dc92f49356566c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $12dc92f49356566c$var$ue(k);
                        u = null == n ? h : $12dc92f49356566c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $12dc92f49356566c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $12dc92f49356566c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $12dc92f49356566c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $12dc92f49356566c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $12dc92f49356566c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $12dc92f49356566c$var$vf(t);
                                x = $12dc92f49356566c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $12dc92f49356566c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $12dc92f49356566c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $12dc92f49356566c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $12dc92f49356566c$var$ve;
                else if ($12dc92f49356566c$var$me(h)) {
                    if ($12dc92f49356566c$var$we) na = $12dc92f49356566c$var$Fe;
                    else {
                        na = $12dc92f49356566c$var$De;
                        var xa = $12dc92f49356566c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $12dc92f49356566c$var$Ee);
                if (na && (na = na(a, d))) {
                    $12dc92f49356566c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $12dc92f49356566c$var$cb(h, "number", h.value);
            }
            xa = d ? $12dc92f49356566c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($12dc92f49356566c$var$me(xa) || "true" === xa.contentEditable) $12dc92f49356566c$var$Qe = xa, $12dc92f49356566c$var$Re = d, $12dc92f49356566c$var$Se = null;
                    break;
                case "focusout":
                    $12dc92f49356566c$var$Se = $12dc92f49356566c$var$Re = $12dc92f49356566c$var$Qe = null;
                    break;
                case "mousedown":
                    $12dc92f49356566c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $12dc92f49356566c$var$Te = !1;
                    $12dc92f49356566c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($12dc92f49356566c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $12dc92f49356566c$var$Ue(g, c, e);
            }
            var $a;
            if ($12dc92f49356566c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $12dc92f49356566c$var$ie ? $12dc92f49356566c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($12dc92f49356566c$var$de && "ko" !== c.locale && ($12dc92f49356566c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $12dc92f49356566c$var$ie && ($a = $12dc92f49356566c$var$nd()) : ($12dc92f49356566c$var$kd = e, $12dc92f49356566c$var$ld = "value" in $12dc92f49356566c$var$kd ? $12dc92f49356566c$var$kd.value : $12dc92f49356566c$var$kd.textContent, $12dc92f49356566c$var$ie = !0)), xa = $12dc92f49356566c$var$oe(d, ba), 0 < xa.length && (ba = new $12dc92f49356566c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $12dc92f49356566c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $12dc92f49356566c$var$ce ? $12dc92f49356566c$var$je(a, c) : $12dc92f49356566c$var$ke(a, c)) d = $12dc92f49356566c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $12dc92f49356566c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $12dc92f49356566c$var$se(g, b);
    });
}
function $12dc92f49356566c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $12dc92f49356566c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $12dc92f49356566c$var$Kb(a, c), null != f && d.unshift($12dc92f49356566c$var$tf(a, f, e)), f = $12dc92f49356566c$var$Kb(a, b), null != f && d.push($12dc92f49356566c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $12dc92f49356566c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $12dc92f49356566c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $12dc92f49356566c$var$Kb(c, f), null != k && g.unshift($12dc92f49356566c$var$tf(c, k, h))) : e || (k = $12dc92f49356566c$var$Kb(c, f), null != k && g.push($12dc92f49356566c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $12dc92f49356566c$var$xf = /\r\n?/g, $12dc92f49356566c$var$yf = /\u0000|\uFFFD/g;
function $12dc92f49356566c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($12dc92f49356566c$var$xf, "\n").replace($12dc92f49356566c$var$yf, "");
}
function $12dc92f49356566c$var$Af(a, b, c) {
    b = $12dc92f49356566c$var$zf(b);
    if ($12dc92f49356566c$var$zf(a) !== b && c) throw Error($12dc92f49356566c$var$p(425));
}
function $12dc92f49356566c$var$Bf() {}
var $12dc92f49356566c$var$Cf = null, $12dc92f49356566c$var$Df = null;
function $12dc92f49356566c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $12dc92f49356566c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $12dc92f49356566c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $12dc92f49356566c$var$Hf = "function" === typeof Promise ? Promise : void 0, $12dc92f49356566c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $12dc92f49356566c$var$Hf ? function(a) {
    return $12dc92f49356566c$var$Hf.resolve(null).then(a).catch($12dc92f49356566c$var$If);
} : $12dc92f49356566c$var$Ff;
function $12dc92f49356566c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $12dc92f49356566c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $12dc92f49356566c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $12dc92f49356566c$var$bd(b);
}
function $12dc92f49356566c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $12dc92f49356566c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $12dc92f49356566c$var$Nf = Math.random().toString(36).slice(2), $12dc92f49356566c$var$Of = "__reactFiber$" + $12dc92f49356566c$var$Nf, $12dc92f49356566c$var$Pf = "__reactProps$" + $12dc92f49356566c$var$Nf, $12dc92f49356566c$var$uf = "__reactContainer$" + $12dc92f49356566c$var$Nf, $12dc92f49356566c$var$of = "__reactEvents$" + $12dc92f49356566c$var$Nf, $12dc92f49356566c$var$Qf = "__reactListeners$" + $12dc92f49356566c$var$Nf, $12dc92f49356566c$var$Rf = "__reactHandles$" + $12dc92f49356566c$var$Nf;
function $12dc92f49356566c$var$Wc(a) {
    var b = a[$12dc92f49356566c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$12dc92f49356566c$var$uf] || c[$12dc92f49356566c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $12dc92f49356566c$var$Mf(a); null !== a;){
                if (c = a[$12dc92f49356566c$var$Of]) return c;
                a = $12dc92f49356566c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $12dc92f49356566c$var$Cb(a) {
    a = a[$12dc92f49356566c$var$Of] || a[$12dc92f49356566c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $12dc92f49356566c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($12dc92f49356566c$var$p(33));
}
function $12dc92f49356566c$var$Db(a) {
    return a[$12dc92f49356566c$var$Pf] || null;
}
var $12dc92f49356566c$var$Sf = [], $12dc92f49356566c$var$Tf = -1;
function $12dc92f49356566c$var$Uf(a) {
    return {
        current: a
    };
}
function $12dc92f49356566c$var$E(a) {
    0 > $12dc92f49356566c$var$Tf || (a.current = $12dc92f49356566c$var$Sf[$12dc92f49356566c$var$Tf], $12dc92f49356566c$var$Sf[$12dc92f49356566c$var$Tf] = null, $12dc92f49356566c$var$Tf--);
}
function $12dc92f49356566c$var$G(a, b) {
    $12dc92f49356566c$var$Tf++;
    $12dc92f49356566c$var$Sf[$12dc92f49356566c$var$Tf] = a.current;
    a.current = b;
}
var $12dc92f49356566c$var$Vf = {}, $12dc92f49356566c$var$H = $12dc92f49356566c$var$Uf($12dc92f49356566c$var$Vf), $12dc92f49356566c$var$Wf = $12dc92f49356566c$var$Uf(!1), $12dc92f49356566c$var$Xf = $12dc92f49356566c$var$Vf;
function $12dc92f49356566c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $12dc92f49356566c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $12dc92f49356566c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $12dc92f49356566c$var$$f() {
    $12dc92f49356566c$var$E($12dc92f49356566c$var$Wf);
    $12dc92f49356566c$var$E($12dc92f49356566c$var$H);
}
function $12dc92f49356566c$var$ag(a, b, c) {
    if ($12dc92f49356566c$var$H.current !== $12dc92f49356566c$var$Vf) throw Error($12dc92f49356566c$var$p(168));
    $12dc92f49356566c$var$G($12dc92f49356566c$var$H, b);
    $12dc92f49356566c$var$G($12dc92f49356566c$var$Wf, c);
}
function $12dc92f49356566c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($12dc92f49356566c$var$p(108, $12dc92f49356566c$var$Ra(a) || "Unknown", e));
    return $12dc92f49356566c$var$A({}, c, d);
}
function $12dc92f49356566c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $12dc92f49356566c$var$Vf;
    $12dc92f49356566c$var$Xf = $12dc92f49356566c$var$H.current;
    $12dc92f49356566c$var$G($12dc92f49356566c$var$H, a);
    $12dc92f49356566c$var$G($12dc92f49356566c$var$Wf, $12dc92f49356566c$var$Wf.current);
    return !0;
}
function $12dc92f49356566c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($12dc92f49356566c$var$p(169));
    c ? (a = $12dc92f49356566c$var$bg(a, b, $12dc92f49356566c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $12dc92f49356566c$var$E($12dc92f49356566c$var$Wf), $12dc92f49356566c$var$E($12dc92f49356566c$var$H), $12dc92f49356566c$var$G($12dc92f49356566c$var$H, a)) : $12dc92f49356566c$var$E($12dc92f49356566c$var$Wf);
    $12dc92f49356566c$var$G($12dc92f49356566c$var$Wf, c);
}
var $12dc92f49356566c$var$eg = null, $12dc92f49356566c$var$fg = !1, $12dc92f49356566c$var$gg = !1;
function $12dc92f49356566c$var$hg(a) {
    null === $12dc92f49356566c$var$eg ? $12dc92f49356566c$var$eg = [
        a
    ] : $12dc92f49356566c$var$eg.push(a);
}
function $12dc92f49356566c$var$ig(a) {
    $12dc92f49356566c$var$fg = !0;
    $12dc92f49356566c$var$hg(a);
}
function $12dc92f49356566c$var$jg() {
    if (!$12dc92f49356566c$var$gg && null !== $12dc92f49356566c$var$eg) {
        $12dc92f49356566c$var$gg = !0;
        var a = 0, b = $12dc92f49356566c$var$C;
        try {
            var c = $12dc92f49356566c$var$eg;
            for($12dc92f49356566c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $12dc92f49356566c$var$eg = null;
            $12dc92f49356566c$var$fg = !1;
        } catch (e) {
            throw null !== $12dc92f49356566c$var$eg && ($12dc92f49356566c$var$eg = $12dc92f49356566c$var$eg.slice(a + 1)), $12dc92f49356566c$var$ac($12dc92f49356566c$var$fc, $12dc92f49356566c$var$jg), e;
        } finally{
            $12dc92f49356566c$var$C = b, $12dc92f49356566c$var$gg = !1;
        }
    }
    return null;
}
var $12dc92f49356566c$var$kg = [], $12dc92f49356566c$var$lg = 0, $12dc92f49356566c$var$mg = null, $12dc92f49356566c$var$ng = 0, $12dc92f49356566c$var$og = [], $12dc92f49356566c$var$pg = 0, $12dc92f49356566c$var$qg = null, $12dc92f49356566c$var$rg = 1, $12dc92f49356566c$var$sg = "";
function $12dc92f49356566c$var$tg(a, b) {
    $12dc92f49356566c$var$kg[$12dc92f49356566c$var$lg++] = $12dc92f49356566c$var$ng;
    $12dc92f49356566c$var$kg[$12dc92f49356566c$var$lg++] = $12dc92f49356566c$var$mg;
    $12dc92f49356566c$var$mg = a;
    $12dc92f49356566c$var$ng = b;
}
function $12dc92f49356566c$var$ug(a, b, c) {
    $12dc92f49356566c$var$og[$12dc92f49356566c$var$pg++] = $12dc92f49356566c$var$rg;
    $12dc92f49356566c$var$og[$12dc92f49356566c$var$pg++] = $12dc92f49356566c$var$sg;
    $12dc92f49356566c$var$og[$12dc92f49356566c$var$pg++] = $12dc92f49356566c$var$qg;
    $12dc92f49356566c$var$qg = a;
    var d = $12dc92f49356566c$var$rg;
    a = $12dc92f49356566c$var$sg;
    var e = 32 - $12dc92f49356566c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $12dc92f49356566c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $12dc92f49356566c$var$rg = 1 << 32 - $12dc92f49356566c$var$oc(b) + e | c << e | d;
        $12dc92f49356566c$var$sg = f + a;
    } else $12dc92f49356566c$var$rg = 1 << f | c << e | d, $12dc92f49356566c$var$sg = a;
}
function $12dc92f49356566c$var$vg(a) {
    null !== a.return && ($12dc92f49356566c$var$tg(a, 1), $12dc92f49356566c$var$ug(a, 1, 0));
}
function $12dc92f49356566c$var$wg(a) {
    for(; a === $12dc92f49356566c$var$mg;)$12dc92f49356566c$var$mg = $12dc92f49356566c$var$kg[--$12dc92f49356566c$var$lg], $12dc92f49356566c$var$kg[$12dc92f49356566c$var$lg] = null, $12dc92f49356566c$var$ng = $12dc92f49356566c$var$kg[--$12dc92f49356566c$var$lg], $12dc92f49356566c$var$kg[$12dc92f49356566c$var$lg] = null;
    for(; a === $12dc92f49356566c$var$qg;)$12dc92f49356566c$var$qg = $12dc92f49356566c$var$og[--$12dc92f49356566c$var$pg], $12dc92f49356566c$var$og[$12dc92f49356566c$var$pg] = null, $12dc92f49356566c$var$sg = $12dc92f49356566c$var$og[--$12dc92f49356566c$var$pg], $12dc92f49356566c$var$og[$12dc92f49356566c$var$pg] = null, $12dc92f49356566c$var$rg = $12dc92f49356566c$var$og[--$12dc92f49356566c$var$pg], $12dc92f49356566c$var$og[$12dc92f49356566c$var$pg] = null;
}
var $12dc92f49356566c$var$xg = null, $12dc92f49356566c$var$yg = null, $12dc92f49356566c$var$I = !1, $12dc92f49356566c$var$zg = null;
function $12dc92f49356566c$var$Ag(a, b) {
    var c = $12dc92f49356566c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $12dc92f49356566c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $12dc92f49356566c$var$xg = a, $12dc92f49356566c$var$yg = $12dc92f49356566c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $12dc92f49356566c$var$xg = a, $12dc92f49356566c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $12dc92f49356566c$var$qg ? {
                id: $12dc92f49356566c$var$rg,
                overflow: $12dc92f49356566c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $12dc92f49356566c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $12dc92f49356566c$var$xg = a, $12dc92f49356566c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $12dc92f49356566c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $12dc92f49356566c$var$Eg(a) {
    if ($12dc92f49356566c$var$I) {
        var b = $12dc92f49356566c$var$yg;
        if (b) {
            var c = b;
            if (!$12dc92f49356566c$var$Cg(a, b)) {
                if ($12dc92f49356566c$var$Dg(a)) throw Error($12dc92f49356566c$var$p(418));
                b = $12dc92f49356566c$var$Lf(c.nextSibling);
                var d = $12dc92f49356566c$var$xg;
                b && $12dc92f49356566c$var$Cg(a, b) ? $12dc92f49356566c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $12dc92f49356566c$var$I = !1, $12dc92f49356566c$var$xg = a);
            }
        } else {
            if ($12dc92f49356566c$var$Dg(a)) throw Error($12dc92f49356566c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $12dc92f49356566c$var$I = !1;
            $12dc92f49356566c$var$xg = a;
        }
    }
}
function $12dc92f49356566c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $12dc92f49356566c$var$xg = a;
}
function $12dc92f49356566c$var$Gg(a) {
    if (a !== $12dc92f49356566c$var$xg) return !1;
    if (!$12dc92f49356566c$var$I) return $12dc92f49356566c$var$Fg(a), $12dc92f49356566c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$12dc92f49356566c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $12dc92f49356566c$var$yg)) {
        if ($12dc92f49356566c$var$Dg(a)) throw $12dc92f49356566c$var$Hg(), Error($12dc92f49356566c$var$p(418));
        for(; b;)$12dc92f49356566c$var$Ag(a, b), b = $12dc92f49356566c$var$Lf(b.nextSibling);
    }
    $12dc92f49356566c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($12dc92f49356566c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $12dc92f49356566c$var$yg = $12dc92f49356566c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $12dc92f49356566c$var$yg = null;
        }
    } else $12dc92f49356566c$var$yg = $12dc92f49356566c$var$xg ? $12dc92f49356566c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $12dc92f49356566c$var$Hg() {
    for(var a = $12dc92f49356566c$var$yg; a;)a = $12dc92f49356566c$var$Lf(a.nextSibling);
}
function $12dc92f49356566c$var$Ig() {
    $12dc92f49356566c$var$yg = $12dc92f49356566c$var$xg = null;
    $12dc92f49356566c$var$I = !1;
}
function $12dc92f49356566c$var$Jg(a) {
    null === $12dc92f49356566c$var$zg ? $12dc92f49356566c$var$zg = [
        a
    ] : $12dc92f49356566c$var$zg.push(a);
}
var $12dc92f49356566c$var$Kg = $12dc92f49356566c$var$ua.ReactCurrentBatchConfig;
function $12dc92f49356566c$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($12dc92f49356566c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($12dc92f49356566c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($12dc92f49356566c$var$p(284));
        if (!c._owner) throw Error($12dc92f49356566c$var$p(290, a));
    }
    return a;
}
function $12dc92f49356566c$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($12dc92f49356566c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $12dc92f49356566c$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $12dc92f49356566c$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $12dc92f49356566c$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $12dc92f49356566c$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $12dc92f49356566c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $12dc92f49356566c$var$Ha && $12dc92f49356566c$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $12dc92f49356566c$var$Lg(a, b, c), d.return = a, d;
        d = $12dc92f49356566c$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $12dc92f49356566c$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $12dc92f49356566c$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $12dc92f49356566c$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $12dc92f49356566c$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $12dc92f49356566c$var$va:
                    return c = $12dc92f49356566c$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $12dc92f49356566c$var$Lg(a, null, b), c.return = a, c;
                case $12dc92f49356566c$var$wa:
                    return b = $12dc92f49356566c$var$Sg(b, a.mode, c), b.return = a, b;
                case $12dc92f49356566c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($12dc92f49356566c$var$eb(b) || $12dc92f49356566c$var$Ka(b)) return b = $12dc92f49356566c$var$Tg(b, a.mode, c, null), b.return = a, b;
            $12dc92f49356566c$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $12dc92f49356566c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $12dc92f49356566c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $12dc92f49356566c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($12dc92f49356566c$var$eb(c) || $12dc92f49356566c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $12dc92f49356566c$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $12dc92f49356566c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $12dc92f49356566c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $12dc92f49356566c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($12dc92f49356566c$var$eb(d) || $12dc92f49356566c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $12dc92f49356566c$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $12dc92f49356566c$var$I && $12dc92f49356566c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $12dc92f49356566c$var$I && $12dc92f49356566c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $12dc92f49356566c$var$I && $12dc92f49356566c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $12dc92f49356566c$var$Ka(h);
        if ("function" !== typeof l) throw Error($12dc92f49356566c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($12dc92f49356566c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $12dc92f49356566c$var$I && $12dc92f49356566c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $12dc92f49356566c$var$I && $12dc92f49356566c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $12dc92f49356566c$var$I && $12dc92f49356566c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $12dc92f49356566c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $12dc92f49356566c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $12dc92f49356566c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $12dc92f49356566c$var$Ha && $12dc92f49356566c$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $12dc92f49356566c$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $12dc92f49356566c$var$ya ? (d = $12dc92f49356566c$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $12dc92f49356566c$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $12dc92f49356566c$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $12dc92f49356566c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $12dc92f49356566c$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $12dc92f49356566c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($12dc92f49356566c$var$eb(f)) return n(a, d, f, h);
            if ($12dc92f49356566c$var$Ka(f)) return t(a, d, f, h);
            $12dc92f49356566c$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $12dc92f49356566c$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $12dc92f49356566c$var$Ug = $12dc92f49356566c$var$Og(!0), $12dc92f49356566c$var$Vg = $12dc92f49356566c$var$Og(!1), $12dc92f49356566c$var$Wg = $12dc92f49356566c$var$Uf(null), $12dc92f49356566c$var$Xg = null, $12dc92f49356566c$var$Yg = null, $12dc92f49356566c$var$Zg = null;
function $12dc92f49356566c$var$$g() {
    $12dc92f49356566c$var$Zg = $12dc92f49356566c$var$Yg = $12dc92f49356566c$var$Xg = null;
}
function $12dc92f49356566c$var$ah(a) {
    var b = $12dc92f49356566c$var$Wg.current;
    $12dc92f49356566c$var$E($12dc92f49356566c$var$Wg);
    a._currentValue = b;
}
function $12dc92f49356566c$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $12dc92f49356566c$var$ch(a, b) {
    $12dc92f49356566c$var$Xg = a;
    $12dc92f49356566c$var$Zg = $12dc92f49356566c$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($12dc92f49356566c$var$dh = !0), a.firstContext = null);
}
function $12dc92f49356566c$var$eh(a) {
    var b = a._currentValue;
    if ($12dc92f49356566c$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $12dc92f49356566c$var$Yg) {
            if (null === $12dc92f49356566c$var$Xg) throw Error($12dc92f49356566c$var$p(308));
            $12dc92f49356566c$var$Yg = a;
            $12dc92f49356566c$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $12dc92f49356566c$var$Yg = $12dc92f49356566c$var$Yg.next = a;
    }
    return b;
}
var $12dc92f49356566c$var$fh = null;
function $12dc92f49356566c$var$gh(a) {
    null === $12dc92f49356566c$var$fh ? $12dc92f49356566c$var$fh = [
        a
    ] : $12dc92f49356566c$var$fh.push(a);
}
function $12dc92f49356566c$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $12dc92f49356566c$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $12dc92f49356566c$var$ih(a, d);
}
function $12dc92f49356566c$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $12dc92f49356566c$var$jh = !1;
function $12dc92f49356566c$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $12dc92f49356566c$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $12dc92f49356566c$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $12dc92f49356566c$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($12dc92f49356566c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $12dc92f49356566c$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $12dc92f49356566c$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $12dc92f49356566c$var$ih(a, c);
}
function $12dc92f49356566c$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $12dc92f49356566c$var$Cc(a, c);
    }
}
function $12dc92f49356566c$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $12dc92f49356566c$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $12dc92f49356566c$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $12dc92f49356566c$var$A({}, q, r);
                            break a;
                        case 2:
                            $12dc92f49356566c$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $12dc92f49356566c$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $12dc92f49356566c$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($12dc92f49356566c$var$p(191, e));
            e.call(d);
        }
    }
}
var $12dc92f49356566c$var$th = {}, $12dc92f49356566c$var$uh = $12dc92f49356566c$var$Uf($12dc92f49356566c$var$th), $12dc92f49356566c$var$vh = $12dc92f49356566c$var$Uf($12dc92f49356566c$var$th), $12dc92f49356566c$var$wh = $12dc92f49356566c$var$Uf($12dc92f49356566c$var$th);
function $12dc92f49356566c$var$xh(a) {
    if (a === $12dc92f49356566c$var$th) throw Error($12dc92f49356566c$var$p(174));
    return a;
}
function $12dc92f49356566c$var$yh(a, b) {
    $12dc92f49356566c$var$G($12dc92f49356566c$var$wh, b);
    $12dc92f49356566c$var$G($12dc92f49356566c$var$vh, a);
    $12dc92f49356566c$var$G($12dc92f49356566c$var$uh, $12dc92f49356566c$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $12dc92f49356566c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $12dc92f49356566c$var$lb(b, a);
    }
    $12dc92f49356566c$var$E($12dc92f49356566c$var$uh);
    $12dc92f49356566c$var$G($12dc92f49356566c$var$uh, b);
}
function $12dc92f49356566c$var$zh() {
    $12dc92f49356566c$var$E($12dc92f49356566c$var$uh);
    $12dc92f49356566c$var$E($12dc92f49356566c$var$vh);
    $12dc92f49356566c$var$E($12dc92f49356566c$var$wh);
}
function $12dc92f49356566c$var$Ah(a) {
    $12dc92f49356566c$var$xh($12dc92f49356566c$var$wh.current);
    var b = $12dc92f49356566c$var$xh($12dc92f49356566c$var$uh.current);
    var c = $12dc92f49356566c$var$lb(b, a.type);
    b !== c && ($12dc92f49356566c$var$G($12dc92f49356566c$var$vh, a), $12dc92f49356566c$var$G($12dc92f49356566c$var$uh, c));
}
function $12dc92f49356566c$var$Bh(a) {
    $12dc92f49356566c$var$vh.current === a && ($12dc92f49356566c$var$E($12dc92f49356566c$var$uh), $12dc92f49356566c$var$E($12dc92f49356566c$var$vh));
}
var $12dc92f49356566c$var$L = $12dc92f49356566c$var$Uf(0);
function $12dc92f49356566c$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $12dc92f49356566c$var$Dh = [];
function $12dc92f49356566c$var$Eh() {
    for(var a = 0; a < $12dc92f49356566c$var$Dh.length; a++)$12dc92f49356566c$var$Dh[a]._workInProgressVersionPrimary = null;
    $12dc92f49356566c$var$Dh.length = 0;
}
var $12dc92f49356566c$var$Fh = $12dc92f49356566c$var$ua.ReactCurrentDispatcher, $12dc92f49356566c$var$Gh = $12dc92f49356566c$var$ua.ReactCurrentBatchConfig, $12dc92f49356566c$var$Hh = 0, $12dc92f49356566c$var$M = null, $12dc92f49356566c$var$N = null, $12dc92f49356566c$var$O = null, $12dc92f49356566c$var$Ih = !1, $12dc92f49356566c$var$Jh = !1, $12dc92f49356566c$var$Kh = 0, $12dc92f49356566c$var$Lh = 0;
function $12dc92f49356566c$var$P() {
    throw Error($12dc92f49356566c$var$p(321));
}
function $12dc92f49356566c$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$12dc92f49356566c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $12dc92f49356566c$var$Nh(a, b, c, d, e, f) {
    $12dc92f49356566c$var$Hh = f;
    $12dc92f49356566c$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $12dc92f49356566c$var$Fh.current = null === a || null === a.memoizedState ? $12dc92f49356566c$var$Oh : $12dc92f49356566c$var$Ph;
    a = c(d, e);
    if ($12dc92f49356566c$var$Jh) {
        f = 0;
        do {
            $12dc92f49356566c$var$Jh = !1;
            $12dc92f49356566c$var$Kh = 0;
            if (25 <= f) throw Error($12dc92f49356566c$var$p(301));
            f += 1;
            $12dc92f49356566c$var$O = $12dc92f49356566c$var$N = null;
            b.updateQueue = null;
            $12dc92f49356566c$var$Fh.current = $12dc92f49356566c$var$Qh;
            a = c(d, e);
        }while ($12dc92f49356566c$var$Jh);
    }
    $12dc92f49356566c$var$Fh.current = $12dc92f49356566c$var$Rh;
    b = null !== $12dc92f49356566c$var$N && null !== $12dc92f49356566c$var$N.next;
    $12dc92f49356566c$var$Hh = 0;
    $12dc92f49356566c$var$O = $12dc92f49356566c$var$N = $12dc92f49356566c$var$M = null;
    $12dc92f49356566c$var$Ih = !1;
    if (b) throw Error($12dc92f49356566c$var$p(300));
    return a;
}
function $12dc92f49356566c$var$Sh() {
    var a = 0 !== $12dc92f49356566c$var$Kh;
    $12dc92f49356566c$var$Kh = 0;
    return a;
}
function $12dc92f49356566c$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $12dc92f49356566c$var$O ? $12dc92f49356566c$var$M.memoizedState = $12dc92f49356566c$var$O = a : $12dc92f49356566c$var$O = $12dc92f49356566c$var$O.next = a;
    return $12dc92f49356566c$var$O;
}
function $12dc92f49356566c$var$Uh() {
    if (null === $12dc92f49356566c$var$N) {
        var a = $12dc92f49356566c$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $12dc92f49356566c$var$N.next;
    var b = null === $12dc92f49356566c$var$O ? $12dc92f49356566c$var$M.memoizedState : $12dc92f49356566c$var$O.next;
    if (null !== b) $12dc92f49356566c$var$O = b, $12dc92f49356566c$var$N = a;
    else {
        if (null === a) throw Error($12dc92f49356566c$var$p(310));
        $12dc92f49356566c$var$N = a;
        a = {
            memoizedState: $12dc92f49356566c$var$N.memoizedState,
            baseState: $12dc92f49356566c$var$N.baseState,
            baseQueue: $12dc92f49356566c$var$N.baseQueue,
            queue: $12dc92f49356566c$var$N.queue,
            next: null
        };
        null === $12dc92f49356566c$var$O ? $12dc92f49356566c$var$M.memoizedState = $12dc92f49356566c$var$O = a : $12dc92f49356566c$var$O = $12dc92f49356566c$var$O.next = a;
    }
    return $12dc92f49356566c$var$O;
}
function $12dc92f49356566c$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $12dc92f49356566c$var$Wh(a) {
    var b = $12dc92f49356566c$var$Uh(), c = b.queue;
    if (null === c) throw Error($12dc92f49356566c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $12dc92f49356566c$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($12dc92f49356566c$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $12dc92f49356566c$var$M.lanes |= m;
                $12dc92f49356566c$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $12dc92f49356566c$var$He(d, b.memoizedState) || ($12dc92f49356566c$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $12dc92f49356566c$var$M.lanes |= f, $12dc92f49356566c$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $12dc92f49356566c$var$Xh(a) {
    var b = $12dc92f49356566c$var$Uh(), c = b.queue;
    if (null === c) throw Error($12dc92f49356566c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $12dc92f49356566c$var$He(f, b.memoizedState) || ($12dc92f49356566c$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $12dc92f49356566c$var$Yh() {}
function $12dc92f49356566c$var$Zh(a, b) {
    var c = $12dc92f49356566c$var$M, d = $12dc92f49356566c$var$Uh(), e = b(), f = !$12dc92f49356566c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $12dc92f49356566c$var$dh = !0);
    d = d.queue;
    $12dc92f49356566c$var$$h($12dc92f49356566c$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $12dc92f49356566c$var$O && $12dc92f49356566c$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $12dc92f49356566c$var$bi(9, $12dc92f49356566c$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $12dc92f49356566c$var$Q) throw Error($12dc92f49356566c$var$p(349));
        0 !== ($12dc92f49356566c$var$Hh & 30) || $12dc92f49356566c$var$di(c, b, e);
    }
    return e;
}
function $12dc92f49356566c$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $12dc92f49356566c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $12dc92f49356566c$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $12dc92f49356566c$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $12dc92f49356566c$var$ei(b) && $12dc92f49356566c$var$fi(a);
}
function $12dc92f49356566c$var$ai(a, b, c) {
    return c(function() {
        $12dc92f49356566c$var$ei(b) && $12dc92f49356566c$var$fi(a);
    });
}
function $12dc92f49356566c$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$12dc92f49356566c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $12dc92f49356566c$var$fi(a) {
    var b = $12dc92f49356566c$var$ih(a, 1);
    null !== b && $12dc92f49356566c$var$gi(b, a, 1, -1);
}
function $12dc92f49356566c$var$hi(a) {
    var b = $12dc92f49356566c$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $12dc92f49356566c$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $12dc92f49356566c$var$ii.bind(null, $12dc92f49356566c$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $12dc92f49356566c$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $12dc92f49356566c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $12dc92f49356566c$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $12dc92f49356566c$var$ji() {
    return $12dc92f49356566c$var$Uh().memoizedState;
}
function $12dc92f49356566c$var$ki(a, b, c, d) {
    var e = $12dc92f49356566c$var$Th();
    $12dc92f49356566c$var$M.flags |= a;
    e.memoizedState = $12dc92f49356566c$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $12dc92f49356566c$var$li(a, b, c, d) {
    var e = $12dc92f49356566c$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $12dc92f49356566c$var$N) {
        var g = $12dc92f49356566c$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $12dc92f49356566c$var$Mh(d, g.deps)) {
            e.memoizedState = $12dc92f49356566c$var$bi(b, c, f, d);
            return;
        }
    }
    $12dc92f49356566c$var$M.flags |= a;
    e.memoizedState = $12dc92f49356566c$var$bi(1 | b, c, f, d);
}
function $12dc92f49356566c$var$mi(a, b) {
    return $12dc92f49356566c$var$ki(8390656, 8, a, b);
}
function $12dc92f49356566c$var$$h(a, b) {
    return $12dc92f49356566c$var$li(2048, 8, a, b);
}
function $12dc92f49356566c$var$ni(a, b) {
    return $12dc92f49356566c$var$li(4, 2, a, b);
}
function $12dc92f49356566c$var$oi(a, b) {
    return $12dc92f49356566c$var$li(4, 4, a, b);
}
function $12dc92f49356566c$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $12dc92f49356566c$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $12dc92f49356566c$var$li(4, 4, $12dc92f49356566c$var$pi.bind(null, b, a), c);
}
function $12dc92f49356566c$var$ri() {}
function $12dc92f49356566c$var$si(a, b) {
    var c = $12dc92f49356566c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $12dc92f49356566c$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $12dc92f49356566c$var$ti(a, b) {
    var c = $12dc92f49356566c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $12dc92f49356566c$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $12dc92f49356566c$var$ui(a, b, c) {
    if (0 === ($12dc92f49356566c$var$Hh & 21)) return a.baseState && (a.baseState = !1, $12dc92f49356566c$var$dh = !0), a.memoizedState = c;
    $12dc92f49356566c$var$He(c, b) || (c = $12dc92f49356566c$var$yc(), $12dc92f49356566c$var$M.lanes |= c, $12dc92f49356566c$var$rh |= c, a.baseState = !0);
    return b;
}
function $12dc92f49356566c$var$vi(a, b) {
    var c = $12dc92f49356566c$var$C;
    $12dc92f49356566c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $12dc92f49356566c$var$Gh.transition;
    $12dc92f49356566c$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $12dc92f49356566c$var$C = c, $12dc92f49356566c$var$Gh.transition = d;
    }
}
function $12dc92f49356566c$var$wi() {
    return $12dc92f49356566c$var$Uh().memoizedState;
}
function $12dc92f49356566c$var$xi(a, b, c) {
    var d = $12dc92f49356566c$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($12dc92f49356566c$var$zi(a)) $12dc92f49356566c$var$Ai(b, c);
    else if (c = $12dc92f49356566c$var$hh(a, b, c, d), null !== c) {
        var e = $12dc92f49356566c$var$R();
        $12dc92f49356566c$var$gi(c, a, d, e);
        $12dc92f49356566c$var$Bi(c, b, d);
    }
}
function $12dc92f49356566c$var$ii(a, b, c) {
    var d = $12dc92f49356566c$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($12dc92f49356566c$var$zi(a)) $12dc92f49356566c$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($12dc92f49356566c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $12dc92f49356566c$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $12dc92f49356566c$var$hh(a, b, e, d);
        null !== c && (e = $12dc92f49356566c$var$R(), $12dc92f49356566c$var$gi(c, a, d, e), $12dc92f49356566c$var$Bi(c, b, d));
    }
}
function $12dc92f49356566c$var$zi(a) {
    var b = a.alternate;
    return a === $12dc92f49356566c$var$M || null !== b && b === $12dc92f49356566c$var$M;
}
function $12dc92f49356566c$var$Ai(a, b) {
    $12dc92f49356566c$var$Jh = $12dc92f49356566c$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $12dc92f49356566c$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $12dc92f49356566c$var$Cc(a, c);
    }
}
var $12dc92f49356566c$var$Rh = {
    readContext: $12dc92f49356566c$var$eh,
    useCallback: $12dc92f49356566c$var$P,
    useContext: $12dc92f49356566c$var$P,
    useEffect: $12dc92f49356566c$var$P,
    useImperativeHandle: $12dc92f49356566c$var$P,
    useInsertionEffect: $12dc92f49356566c$var$P,
    useLayoutEffect: $12dc92f49356566c$var$P,
    useMemo: $12dc92f49356566c$var$P,
    useReducer: $12dc92f49356566c$var$P,
    useRef: $12dc92f49356566c$var$P,
    useState: $12dc92f49356566c$var$P,
    useDebugValue: $12dc92f49356566c$var$P,
    useDeferredValue: $12dc92f49356566c$var$P,
    useTransition: $12dc92f49356566c$var$P,
    useMutableSource: $12dc92f49356566c$var$P,
    useSyncExternalStore: $12dc92f49356566c$var$P,
    useId: $12dc92f49356566c$var$P,
    unstable_isNewReconciler: !1
}, $12dc92f49356566c$var$Oh = {
    readContext: $12dc92f49356566c$var$eh,
    useCallback: function(a, b) {
        $12dc92f49356566c$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $12dc92f49356566c$var$eh,
    useEffect: $12dc92f49356566c$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $12dc92f49356566c$var$ki(4194308, 4, $12dc92f49356566c$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $12dc92f49356566c$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $12dc92f49356566c$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $12dc92f49356566c$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $12dc92f49356566c$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $12dc92f49356566c$var$xi.bind(null, $12dc92f49356566c$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $12dc92f49356566c$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $12dc92f49356566c$var$hi,
    useDebugValue: $12dc92f49356566c$var$ri,
    useDeferredValue: function(a) {
        return $12dc92f49356566c$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $12dc92f49356566c$var$hi(!1), b = a[0];
        a = $12dc92f49356566c$var$vi.bind(null, a[1]);
        $12dc92f49356566c$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $12dc92f49356566c$var$M, e = $12dc92f49356566c$var$Th();
        if ($12dc92f49356566c$var$I) {
            if (void 0 === c) throw Error($12dc92f49356566c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $12dc92f49356566c$var$Q) throw Error($12dc92f49356566c$var$p(349));
            0 !== ($12dc92f49356566c$var$Hh & 30) || $12dc92f49356566c$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $12dc92f49356566c$var$mi($12dc92f49356566c$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $12dc92f49356566c$var$bi(9, $12dc92f49356566c$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $12dc92f49356566c$var$Th(), b = $12dc92f49356566c$var$Q.identifierPrefix;
        if ($12dc92f49356566c$var$I) {
            var c = $12dc92f49356566c$var$sg;
            var d = $12dc92f49356566c$var$rg;
            c = (d & ~(1 << 32 - $12dc92f49356566c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $12dc92f49356566c$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $12dc92f49356566c$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $12dc92f49356566c$var$Ph = {
    readContext: $12dc92f49356566c$var$eh,
    useCallback: $12dc92f49356566c$var$si,
    useContext: $12dc92f49356566c$var$eh,
    useEffect: $12dc92f49356566c$var$$h,
    useImperativeHandle: $12dc92f49356566c$var$qi,
    useInsertionEffect: $12dc92f49356566c$var$ni,
    useLayoutEffect: $12dc92f49356566c$var$oi,
    useMemo: $12dc92f49356566c$var$ti,
    useReducer: $12dc92f49356566c$var$Wh,
    useRef: $12dc92f49356566c$var$ji,
    useState: function() {
        return $12dc92f49356566c$var$Wh($12dc92f49356566c$var$Vh);
    },
    useDebugValue: $12dc92f49356566c$var$ri,
    useDeferredValue: function(a) {
        var b = $12dc92f49356566c$var$Uh();
        return $12dc92f49356566c$var$ui(b, $12dc92f49356566c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $12dc92f49356566c$var$Wh($12dc92f49356566c$var$Vh)[0], b = $12dc92f49356566c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $12dc92f49356566c$var$Yh,
    useSyncExternalStore: $12dc92f49356566c$var$Zh,
    useId: $12dc92f49356566c$var$wi,
    unstable_isNewReconciler: !1
}, $12dc92f49356566c$var$Qh = {
    readContext: $12dc92f49356566c$var$eh,
    useCallback: $12dc92f49356566c$var$si,
    useContext: $12dc92f49356566c$var$eh,
    useEffect: $12dc92f49356566c$var$$h,
    useImperativeHandle: $12dc92f49356566c$var$qi,
    useInsertionEffect: $12dc92f49356566c$var$ni,
    useLayoutEffect: $12dc92f49356566c$var$oi,
    useMemo: $12dc92f49356566c$var$ti,
    useReducer: $12dc92f49356566c$var$Xh,
    useRef: $12dc92f49356566c$var$ji,
    useState: function() {
        return $12dc92f49356566c$var$Xh($12dc92f49356566c$var$Vh);
    },
    useDebugValue: $12dc92f49356566c$var$ri,
    useDeferredValue: function(a) {
        var b = $12dc92f49356566c$var$Uh();
        return null === $12dc92f49356566c$var$N ? b.memoizedState = a : $12dc92f49356566c$var$ui(b, $12dc92f49356566c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $12dc92f49356566c$var$Xh($12dc92f49356566c$var$Vh)[0], b = $12dc92f49356566c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $12dc92f49356566c$var$Yh,
    useSyncExternalStore: $12dc92f49356566c$var$Zh,
    useId: $12dc92f49356566c$var$wi,
    unstable_isNewReconciler: !1
};
function $12dc92f49356566c$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $12dc92f49356566c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $12dc92f49356566c$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $12dc92f49356566c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $12dc92f49356566c$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $12dc92f49356566c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $12dc92f49356566c$var$R(), e = $12dc92f49356566c$var$yi(a), f = $12dc92f49356566c$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $12dc92f49356566c$var$nh(a, f, e);
        null !== b && ($12dc92f49356566c$var$gi(b, a, e, d), $12dc92f49356566c$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $12dc92f49356566c$var$R(), e = $12dc92f49356566c$var$yi(a), f = $12dc92f49356566c$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $12dc92f49356566c$var$nh(a, f, e);
        null !== b && ($12dc92f49356566c$var$gi(b, a, e, d), $12dc92f49356566c$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $12dc92f49356566c$var$R(), d = $12dc92f49356566c$var$yi(a), e = $12dc92f49356566c$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $12dc92f49356566c$var$nh(a, e, d);
        null !== b && ($12dc92f49356566c$var$gi(b, a, d, c), $12dc92f49356566c$var$oh(b, a, d));
    }
};
function $12dc92f49356566c$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$12dc92f49356566c$var$Ie(c, d) || !$12dc92f49356566c$var$Ie(e, f) : !0;
}
function $12dc92f49356566c$var$Gi(a, b, c) {
    var d = !1, e = $12dc92f49356566c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $12dc92f49356566c$var$eh(f) : (e = $12dc92f49356566c$var$Zf(b) ? $12dc92f49356566c$var$Xf : $12dc92f49356566c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $12dc92f49356566c$var$Yf(a, e) : $12dc92f49356566c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $12dc92f49356566c$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $12dc92f49356566c$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $12dc92f49356566c$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $12dc92f49356566c$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $12dc92f49356566c$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $12dc92f49356566c$var$eh(f) : (f = $12dc92f49356566c$var$Zf(b) ? $12dc92f49356566c$var$Xf : $12dc92f49356566c$var$H.current, e.context = $12dc92f49356566c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($12dc92f49356566c$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $12dc92f49356566c$var$Ei.enqueueReplaceState(e, e.state, null), $12dc92f49356566c$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $12dc92f49356566c$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $12dc92f49356566c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $12dc92f49356566c$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $12dc92f49356566c$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $12dc92f49356566c$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $12dc92f49356566c$var$Ni(a, b, c) {
    c = $12dc92f49356566c$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $12dc92f49356566c$var$Oi || ($12dc92f49356566c$var$Oi = !0, $12dc92f49356566c$var$Pi = d);
        $12dc92f49356566c$var$Li(a, b);
    };
    return c;
}
function $12dc92f49356566c$var$Qi(a, b, c) {
    c = $12dc92f49356566c$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $12dc92f49356566c$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $12dc92f49356566c$var$Li(a, b);
        "function" !== typeof d && (null === $12dc92f49356566c$var$Ri ? $12dc92f49356566c$var$Ri = new Set([
            this
        ]) : $12dc92f49356566c$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $12dc92f49356566c$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $12dc92f49356566c$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $12dc92f49356566c$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $12dc92f49356566c$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $12dc92f49356566c$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $12dc92f49356566c$var$mh(-1, 1), b.tag = 2, $12dc92f49356566c$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $12dc92f49356566c$var$Wi = $12dc92f49356566c$var$ua.ReactCurrentOwner, $12dc92f49356566c$var$dh = !1;
function $12dc92f49356566c$var$Xi(a, b, c, d) {
    b.child = null === a ? $12dc92f49356566c$var$Vg(b, null, c, d) : $12dc92f49356566c$var$Ug(b, a.child, c, d);
}
function $12dc92f49356566c$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $12dc92f49356566c$var$ch(b, e);
    d = $12dc92f49356566c$var$Nh(a, b, c, d, f, e);
    c = $12dc92f49356566c$var$Sh();
    if (null !== a && !$12dc92f49356566c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $12dc92f49356566c$var$Zi(a, b, e);
    $12dc92f49356566c$var$I && c && $12dc92f49356566c$var$vg(b);
    b.flags |= 1;
    $12dc92f49356566c$var$Xi(a, b, d, e);
    return b.child;
}
function $12dc92f49356566c$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$12dc92f49356566c$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $12dc92f49356566c$var$bj(a, b, f, d, e);
        a = $12dc92f49356566c$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $12dc92f49356566c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $12dc92f49356566c$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $12dc92f49356566c$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $12dc92f49356566c$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($12dc92f49356566c$var$Ie(f, d) && a.ref === b.ref) {
            if ($12dc92f49356566c$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($12dc92f49356566c$var$dh = !0);
            else return b.lanes = a.lanes, $12dc92f49356566c$var$Zi(a, b, e);
        }
    }
    return $12dc92f49356566c$var$cj(a, b, c, d, e);
}
function $12dc92f49356566c$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $12dc92f49356566c$var$G($12dc92f49356566c$var$ej, $12dc92f49356566c$var$fj), $12dc92f49356566c$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $12dc92f49356566c$var$G($12dc92f49356566c$var$ej, $12dc92f49356566c$var$fj), $12dc92f49356566c$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $12dc92f49356566c$var$G($12dc92f49356566c$var$ej, $12dc92f49356566c$var$fj);
            $12dc92f49356566c$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $12dc92f49356566c$var$G($12dc92f49356566c$var$ej, $12dc92f49356566c$var$fj), $12dc92f49356566c$var$fj |= d;
    $12dc92f49356566c$var$Xi(a, b, e, c);
    return b.child;
}
function $12dc92f49356566c$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $12dc92f49356566c$var$cj(a, b, c, d, e) {
    var f = $12dc92f49356566c$var$Zf(c) ? $12dc92f49356566c$var$Xf : $12dc92f49356566c$var$H.current;
    f = $12dc92f49356566c$var$Yf(b, f);
    $12dc92f49356566c$var$ch(b, e);
    c = $12dc92f49356566c$var$Nh(a, b, c, d, f, e);
    d = $12dc92f49356566c$var$Sh();
    if (null !== a && !$12dc92f49356566c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $12dc92f49356566c$var$Zi(a, b, e);
    $12dc92f49356566c$var$I && d && $12dc92f49356566c$var$vg(b);
    b.flags |= 1;
    $12dc92f49356566c$var$Xi(a, b, c, e);
    return b.child;
}
function $12dc92f49356566c$var$hj(a, b, c, d, e) {
    if ($12dc92f49356566c$var$Zf(c)) {
        var f = !0;
        $12dc92f49356566c$var$cg(b);
    } else f = !1;
    $12dc92f49356566c$var$ch(b, e);
    if (null === b.stateNode) $12dc92f49356566c$var$ij(a, b), $12dc92f49356566c$var$Gi(b, c, d), $12dc92f49356566c$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $12dc92f49356566c$var$eh(l) : (l = $12dc92f49356566c$var$Zf(c) ? $12dc92f49356566c$var$Xf : $12dc92f49356566c$var$H.current, l = $12dc92f49356566c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $12dc92f49356566c$var$Hi(b, g, d, l);
        $12dc92f49356566c$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $12dc92f49356566c$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $12dc92f49356566c$var$Wf.current || $12dc92f49356566c$var$jh ? ("function" === typeof m && ($12dc92f49356566c$var$Di(b, c, m, d), k = b.memoizedState), (h = $12dc92f49356566c$var$jh || $12dc92f49356566c$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $12dc92f49356566c$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $12dc92f49356566c$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $12dc92f49356566c$var$eh(k) : (k = $12dc92f49356566c$var$Zf(c) ? $12dc92f49356566c$var$Xf : $12dc92f49356566c$var$H.current, k = $12dc92f49356566c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $12dc92f49356566c$var$Hi(b, g, d, k);
        $12dc92f49356566c$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $12dc92f49356566c$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $12dc92f49356566c$var$Wf.current || $12dc92f49356566c$var$jh ? ("function" === typeof y && ($12dc92f49356566c$var$Di(b, c, y, d), n = b.memoizedState), (l = $12dc92f49356566c$var$jh || $12dc92f49356566c$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $12dc92f49356566c$var$jj(a, b, c, d, f, e);
}
function $12dc92f49356566c$var$jj(a, b, c, d, e, f) {
    $12dc92f49356566c$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $12dc92f49356566c$var$dg(b, c, !1), $12dc92f49356566c$var$Zi(a, b, f);
    d = b.stateNode;
    $12dc92f49356566c$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $12dc92f49356566c$var$Ug(b, a.child, null, f), b.child = $12dc92f49356566c$var$Ug(b, null, h, f)) : $12dc92f49356566c$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $12dc92f49356566c$var$dg(b, c, !0);
    return b.child;
}
function $12dc92f49356566c$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $12dc92f49356566c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $12dc92f49356566c$var$ag(a, b.context, !1);
    $12dc92f49356566c$var$yh(a, b.containerInfo);
}
function $12dc92f49356566c$var$lj(a, b, c, d, e) {
    $12dc92f49356566c$var$Ig();
    $12dc92f49356566c$var$Jg(e);
    b.flags |= 256;
    $12dc92f49356566c$var$Xi(a, b, c, d);
    return b.child;
}
var $12dc92f49356566c$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $12dc92f49356566c$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $12dc92f49356566c$var$oj(a, b, c) {
    var d = b.pendingProps, e = $12dc92f49356566c$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $12dc92f49356566c$var$G($12dc92f49356566c$var$L, e & 1);
    if (null === a) {
        $12dc92f49356566c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $12dc92f49356566c$var$pj(g, d, 0, null), a = $12dc92f49356566c$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $12dc92f49356566c$var$nj(c), b.memoizedState = $12dc92f49356566c$var$mj, a) : $12dc92f49356566c$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $12dc92f49356566c$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $12dc92f49356566c$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $12dc92f49356566c$var$Pg(h, f) : (f = $12dc92f49356566c$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $12dc92f49356566c$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $12dc92f49356566c$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $12dc92f49356566c$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $12dc92f49356566c$var$qj(a, b) {
    b = $12dc92f49356566c$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $12dc92f49356566c$var$sj(a, b, c, d) {
    null !== d && $12dc92f49356566c$var$Jg(d);
    $12dc92f49356566c$var$Ug(b, a.child, null, c);
    a = $12dc92f49356566c$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $12dc92f49356566c$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $12dc92f49356566c$var$Ki(Error($12dc92f49356566c$var$p(422))), $12dc92f49356566c$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $12dc92f49356566c$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $12dc92f49356566c$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $12dc92f49356566c$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $12dc92f49356566c$var$nj(g);
        b.memoizedState = $12dc92f49356566c$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $12dc92f49356566c$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($12dc92f49356566c$var$p(419));
        d = $12dc92f49356566c$var$Ki(f, d, void 0);
        return $12dc92f49356566c$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($12dc92f49356566c$var$dh || h) {
        d = $12dc92f49356566c$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $12dc92f49356566c$var$ih(a, e), $12dc92f49356566c$var$gi(d, a, e, -1));
        }
        $12dc92f49356566c$var$tj();
        d = $12dc92f49356566c$var$Ki(Error($12dc92f49356566c$var$p(421)));
        return $12dc92f49356566c$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $12dc92f49356566c$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $12dc92f49356566c$var$yg = $12dc92f49356566c$var$Lf(e.nextSibling);
    $12dc92f49356566c$var$xg = b;
    $12dc92f49356566c$var$I = !0;
    $12dc92f49356566c$var$zg = null;
    null !== a && ($12dc92f49356566c$var$og[$12dc92f49356566c$var$pg++] = $12dc92f49356566c$var$rg, $12dc92f49356566c$var$og[$12dc92f49356566c$var$pg++] = $12dc92f49356566c$var$sg, $12dc92f49356566c$var$og[$12dc92f49356566c$var$pg++] = $12dc92f49356566c$var$qg, $12dc92f49356566c$var$rg = a.id, $12dc92f49356566c$var$sg = a.overflow, $12dc92f49356566c$var$qg = b);
    b = $12dc92f49356566c$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $12dc92f49356566c$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $12dc92f49356566c$var$bh(a.return, b, c);
}
function $12dc92f49356566c$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $12dc92f49356566c$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $12dc92f49356566c$var$Xi(a, b, d.children, c);
    d = $12dc92f49356566c$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $12dc92f49356566c$var$vj(a, c, b);
            else if (19 === a.tag) $12dc92f49356566c$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $12dc92f49356566c$var$G($12dc92f49356566c$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $12dc92f49356566c$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $12dc92f49356566c$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $12dc92f49356566c$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $12dc92f49356566c$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $12dc92f49356566c$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $12dc92f49356566c$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $12dc92f49356566c$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $12dc92f49356566c$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($12dc92f49356566c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $12dc92f49356566c$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $12dc92f49356566c$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $12dc92f49356566c$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $12dc92f49356566c$var$kj(b);
            $12dc92f49356566c$var$Ig();
            break;
        case 5:
            $12dc92f49356566c$var$Ah(b);
            break;
        case 1:
            $12dc92f49356566c$var$Zf(b.type) && $12dc92f49356566c$var$cg(b);
            break;
        case 4:
            $12dc92f49356566c$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $12dc92f49356566c$var$G($12dc92f49356566c$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $12dc92f49356566c$var$G($12dc92f49356566c$var$L, $12dc92f49356566c$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $12dc92f49356566c$var$oj(a, b, c);
                $12dc92f49356566c$var$G($12dc92f49356566c$var$L, $12dc92f49356566c$var$L.current & 1);
                a = $12dc92f49356566c$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $12dc92f49356566c$var$G($12dc92f49356566c$var$L, $12dc92f49356566c$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $12dc92f49356566c$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $12dc92f49356566c$var$G($12dc92f49356566c$var$L, $12dc92f49356566c$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $12dc92f49356566c$var$dj(a, b, c);
    }
    return $12dc92f49356566c$var$Zi(a, b, c);
}
var $12dc92f49356566c$var$zj, $12dc92f49356566c$var$Aj, $12dc92f49356566c$var$Bj, $12dc92f49356566c$var$Cj;
$12dc92f49356566c$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$12dc92f49356566c$var$Aj = function() {};
$12dc92f49356566c$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $12dc92f49356566c$var$xh($12dc92f49356566c$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $12dc92f49356566c$var$Ya(a, e);
                d = $12dc92f49356566c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $12dc92f49356566c$var$A({}, e, {
                    value: void 0
                });
                d = $12dc92f49356566c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $12dc92f49356566c$var$gb(a, e);
                d = $12dc92f49356566c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $12dc92f49356566c$var$Bf);
        }
        $12dc92f49356566c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($12dc92f49356566c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($12dc92f49356566c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $12dc92f49356566c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$12dc92f49356566c$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $12dc92f49356566c$var$Dj(a, b) {
    if (!$12dc92f49356566c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $12dc92f49356566c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $12dc92f49356566c$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $12dc92f49356566c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $12dc92f49356566c$var$S(b), null;
        case 1:
            return $12dc92f49356566c$var$Zf(b.type) && $12dc92f49356566c$var$$f(), $12dc92f49356566c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $12dc92f49356566c$var$zh();
            $12dc92f49356566c$var$E($12dc92f49356566c$var$Wf);
            $12dc92f49356566c$var$E($12dc92f49356566c$var$H);
            $12dc92f49356566c$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $12dc92f49356566c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $12dc92f49356566c$var$zg && ($12dc92f49356566c$var$Fj($12dc92f49356566c$var$zg), $12dc92f49356566c$var$zg = null));
            $12dc92f49356566c$var$Aj(a, b);
            $12dc92f49356566c$var$S(b);
            return null;
        case 5:
            $12dc92f49356566c$var$Bh(b);
            var e = $12dc92f49356566c$var$xh($12dc92f49356566c$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $12dc92f49356566c$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($12dc92f49356566c$var$p(166));
                    $12dc92f49356566c$var$S(b);
                    return null;
                }
                a = $12dc92f49356566c$var$xh($12dc92f49356566c$var$uh.current);
                if ($12dc92f49356566c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$12dc92f49356566c$var$Of] = b;
                    d[$12dc92f49356566c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $12dc92f49356566c$var$D("cancel", d);
                            $12dc92f49356566c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $12dc92f49356566c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $12dc92f49356566c$var$lf.length; e++)$12dc92f49356566c$var$D($12dc92f49356566c$var$lf[e], d);
                            break;
                        case "source":
                            $12dc92f49356566c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $12dc92f49356566c$var$D("error", d);
                            $12dc92f49356566c$var$D("load", d);
                            break;
                        case "details":
                            $12dc92f49356566c$var$D("toggle", d);
                            break;
                        case "input":
                            $12dc92f49356566c$var$Za(d, f);
                            $12dc92f49356566c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $12dc92f49356566c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $12dc92f49356566c$var$hb(d, f), $12dc92f49356566c$var$D("invalid", d);
                    }
                    $12dc92f49356566c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $12dc92f49356566c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $12dc92f49356566c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $12dc92f49356566c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $12dc92f49356566c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $12dc92f49356566c$var$Va(d);
                            $12dc92f49356566c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $12dc92f49356566c$var$Va(d);
                            $12dc92f49356566c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $12dc92f49356566c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $12dc92f49356566c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$12dc92f49356566c$var$Of] = b;
                    a[$12dc92f49356566c$var$Pf] = d;
                    $12dc92f49356566c$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $12dc92f49356566c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $12dc92f49356566c$var$D("cancel", a);
                                $12dc92f49356566c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $12dc92f49356566c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $12dc92f49356566c$var$lf.length; e++)$12dc92f49356566c$var$D($12dc92f49356566c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $12dc92f49356566c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $12dc92f49356566c$var$D("error", a);
                                $12dc92f49356566c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $12dc92f49356566c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $12dc92f49356566c$var$Za(a, d);
                                e = $12dc92f49356566c$var$Ya(a, d);
                                $12dc92f49356566c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $12dc92f49356566c$var$A({}, d, {
                                    value: void 0
                                });
                                $12dc92f49356566c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $12dc92f49356566c$var$hb(a, d);
                                e = $12dc92f49356566c$var$gb(a, d);
                                $12dc92f49356566c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $12dc92f49356566c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $12dc92f49356566c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $12dc92f49356566c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $12dc92f49356566c$var$ob(a, k) : "number" === typeof k && $12dc92f49356566c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($12dc92f49356566c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $12dc92f49356566c$var$D("scroll", a) : null != k && $12dc92f49356566c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $12dc92f49356566c$var$Va(a);
                                $12dc92f49356566c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $12dc92f49356566c$var$Va(a);
                                $12dc92f49356566c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $12dc92f49356566c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $12dc92f49356566c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $12dc92f49356566c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $12dc92f49356566c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $12dc92f49356566c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $12dc92f49356566c$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($12dc92f49356566c$var$p(166));
                c = $12dc92f49356566c$var$xh($12dc92f49356566c$var$wh.current);
                $12dc92f49356566c$var$xh($12dc92f49356566c$var$uh.current);
                if ($12dc92f49356566c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$12dc92f49356566c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $12dc92f49356566c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $12dc92f49356566c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $12dc92f49356566c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$12dc92f49356566c$var$Of] = b, b.stateNode = d;
            }
            $12dc92f49356566c$var$S(b);
            return null;
        case 13:
            $12dc92f49356566c$var$E($12dc92f49356566c$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($12dc92f49356566c$var$I && null !== $12dc92f49356566c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $12dc92f49356566c$var$Hg(), $12dc92f49356566c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $12dc92f49356566c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($12dc92f49356566c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($12dc92f49356566c$var$p(317));
                        f[$12dc92f49356566c$var$Of] = b;
                    } else $12dc92f49356566c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $12dc92f49356566c$var$S(b);
                    f = !1;
                } else null !== $12dc92f49356566c$var$zg && ($12dc92f49356566c$var$Fj($12dc92f49356566c$var$zg), $12dc92f49356566c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($12dc92f49356566c$var$L.current & 1) ? 0 === $12dc92f49356566c$var$T && ($12dc92f49356566c$var$T = 3) : $12dc92f49356566c$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $12dc92f49356566c$var$S(b);
            return null;
        case 4:
            return $12dc92f49356566c$var$zh(), $12dc92f49356566c$var$Aj(a, b), null === a && $12dc92f49356566c$var$sf(b.stateNode.containerInfo), $12dc92f49356566c$var$S(b), null;
        case 10:
            return $12dc92f49356566c$var$ah(b.type._context), $12dc92f49356566c$var$S(b), null;
        case 17:
            return $12dc92f49356566c$var$Zf(b.type) && $12dc92f49356566c$var$$f(), $12dc92f49356566c$var$S(b), null;
        case 19:
            $12dc92f49356566c$var$E($12dc92f49356566c$var$L);
            f = b.memoizedState;
            if (null === f) return $12dc92f49356566c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $12dc92f49356566c$var$Dj(f, !1);
                else {
                    if (0 !== $12dc92f49356566c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $12dc92f49356566c$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $12dc92f49356566c$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $12dc92f49356566c$var$G($12dc92f49356566c$var$L, $12dc92f49356566c$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $12dc92f49356566c$var$B() > $12dc92f49356566c$var$Gj && (b.flags |= 128, d = !0, $12dc92f49356566c$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $12dc92f49356566c$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $12dc92f49356566c$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$12dc92f49356566c$var$I) return $12dc92f49356566c$var$S(b), null;
                    } else 2 * $12dc92f49356566c$var$B() - f.renderingStartTime > $12dc92f49356566c$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $12dc92f49356566c$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $12dc92f49356566c$var$B(), b.sibling = null, c = $12dc92f49356566c$var$L.current, $12dc92f49356566c$var$G($12dc92f49356566c$var$L, d ? c & 1 | 2 : c & 1), b;
            $12dc92f49356566c$var$S(b);
            return null;
        case 22:
        case 23:
            return $12dc92f49356566c$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($12dc92f49356566c$var$fj & 1073741824) && ($12dc92f49356566c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $12dc92f49356566c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($12dc92f49356566c$var$p(156, b.tag));
}
function $12dc92f49356566c$var$Ij(a, b) {
    $12dc92f49356566c$var$wg(b);
    switch(b.tag){
        case 1:
            return $12dc92f49356566c$var$Zf(b.type) && $12dc92f49356566c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $12dc92f49356566c$var$zh(), $12dc92f49356566c$var$E($12dc92f49356566c$var$Wf), $12dc92f49356566c$var$E($12dc92f49356566c$var$H), $12dc92f49356566c$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $12dc92f49356566c$var$Bh(b), null;
        case 13:
            $12dc92f49356566c$var$E($12dc92f49356566c$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($12dc92f49356566c$var$p(340));
                $12dc92f49356566c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $12dc92f49356566c$var$E($12dc92f49356566c$var$L), null;
        case 4:
            return $12dc92f49356566c$var$zh(), null;
        case 10:
            return $12dc92f49356566c$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $12dc92f49356566c$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $12dc92f49356566c$var$Jj = !1, $12dc92f49356566c$var$U = !1, $12dc92f49356566c$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $12dc92f49356566c$var$V = null;
function $12dc92f49356566c$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $12dc92f49356566c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $12dc92f49356566c$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $12dc92f49356566c$var$W(a, b, d);
    }
}
var $12dc92f49356566c$var$Nj = !1;
function $12dc92f49356566c$var$Oj(a, b) {
    $12dc92f49356566c$var$Cf = $12dc92f49356566c$var$dd;
    a = $12dc92f49356566c$var$Me();
    if ($12dc92f49356566c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $12dc92f49356566c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $12dc92f49356566c$var$dd = !1;
    for($12dc92f49356566c$var$V = b; null !== $12dc92f49356566c$var$V;)if (b = $12dc92f49356566c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $12dc92f49356566c$var$V = a;
    else for(; null !== $12dc92f49356566c$var$V;){
        b = $12dc92f49356566c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $12dc92f49356566c$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($12dc92f49356566c$var$p(163));
            }
        } catch (F) {
            $12dc92f49356566c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $12dc92f49356566c$var$V = a;
            break;
        }
        $12dc92f49356566c$var$V = b.return;
    }
    n = $12dc92f49356566c$var$Nj;
    $12dc92f49356566c$var$Nj = !1;
    return n;
}
function $12dc92f49356566c$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $12dc92f49356566c$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $12dc92f49356566c$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $12dc92f49356566c$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $12dc92f49356566c$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $12dc92f49356566c$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$12dc92f49356566c$var$Of], delete b[$12dc92f49356566c$var$Pf], delete b[$12dc92f49356566c$var$of], delete b[$12dc92f49356566c$var$Qf], delete b[$12dc92f49356566c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $12dc92f49356566c$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $12dc92f49356566c$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $12dc92f49356566c$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $12dc92f49356566c$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $12dc92f49356566c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($12dc92f49356566c$var$Vj(a, b, c), a = a.sibling; null !== a;)$12dc92f49356566c$var$Vj(a, b, c), a = a.sibling;
}
function $12dc92f49356566c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($12dc92f49356566c$var$Wj(a, b, c), a = a.sibling; null !== a;)$12dc92f49356566c$var$Wj(a, b, c), a = a.sibling;
}
var $12dc92f49356566c$var$X = null, $12dc92f49356566c$var$Xj = !1;
function $12dc92f49356566c$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$12dc92f49356566c$var$Zj(a, b, c), c = c.sibling;
}
function $12dc92f49356566c$var$Zj(a, b, c) {
    if ($12dc92f49356566c$var$lc && "function" === typeof $12dc92f49356566c$var$lc.onCommitFiberUnmount) try {
        $12dc92f49356566c$var$lc.onCommitFiberUnmount($12dc92f49356566c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $12dc92f49356566c$var$U || $12dc92f49356566c$var$Lj(c, b);
        case 6:
            var d = $12dc92f49356566c$var$X, e = $12dc92f49356566c$var$Xj;
            $12dc92f49356566c$var$X = null;
            $12dc92f49356566c$var$Yj(a, b, c);
            $12dc92f49356566c$var$X = d;
            $12dc92f49356566c$var$Xj = e;
            null !== $12dc92f49356566c$var$X && ($12dc92f49356566c$var$Xj ? (a = $12dc92f49356566c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $12dc92f49356566c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $12dc92f49356566c$var$X && ($12dc92f49356566c$var$Xj ? (a = $12dc92f49356566c$var$X, c = c.stateNode, 8 === a.nodeType ? $12dc92f49356566c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $12dc92f49356566c$var$Kf(a, c), $12dc92f49356566c$var$bd(a)) : $12dc92f49356566c$var$Kf($12dc92f49356566c$var$X, c.stateNode));
            break;
        case 4:
            d = $12dc92f49356566c$var$X;
            e = $12dc92f49356566c$var$Xj;
            $12dc92f49356566c$var$X = c.stateNode.containerInfo;
            $12dc92f49356566c$var$Xj = !0;
            $12dc92f49356566c$var$Yj(a, b, c);
            $12dc92f49356566c$var$X = d;
            $12dc92f49356566c$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$12dc92f49356566c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $12dc92f49356566c$var$Mj(c, b, g) : 0 !== (f & 4) && $12dc92f49356566c$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $12dc92f49356566c$var$Yj(a, b, c);
            break;
        case 1:
            if (!$12dc92f49356566c$var$U && ($12dc92f49356566c$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $12dc92f49356566c$var$W(c, b, h);
            }
            $12dc92f49356566c$var$Yj(a, b, c);
            break;
        case 21:
            $12dc92f49356566c$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($12dc92f49356566c$var$U = (d = $12dc92f49356566c$var$U) || null !== c.memoizedState, $12dc92f49356566c$var$Yj(a, b, c), $12dc92f49356566c$var$U = d) : $12dc92f49356566c$var$Yj(a, b, c);
            break;
        default:
            $12dc92f49356566c$var$Yj(a, b, c);
    }
}
function $12dc92f49356566c$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $12dc92f49356566c$var$Kj);
        b.forEach(function(b) {
            var d = $12dc92f49356566c$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $12dc92f49356566c$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $12dc92f49356566c$var$X = h.stateNode;
                        $12dc92f49356566c$var$Xj = !1;
                        break a;
                    case 3:
                        $12dc92f49356566c$var$X = h.stateNode.containerInfo;
                        $12dc92f49356566c$var$Xj = !0;
                        break a;
                    case 4:
                        $12dc92f49356566c$var$X = h.stateNode.containerInfo;
                        $12dc92f49356566c$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $12dc92f49356566c$var$X) throw Error($12dc92f49356566c$var$p(160));
            $12dc92f49356566c$var$Zj(f, g, e);
            $12dc92f49356566c$var$X = null;
            $12dc92f49356566c$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $12dc92f49356566c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$12dc92f49356566c$var$dk(b, a), b = b.sibling;
}
function $12dc92f49356566c$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $12dc92f49356566c$var$ck(b, a);
            $12dc92f49356566c$var$ek(a);
            if (d & 4) {
                try {
                    $12dc92f49356566c$var$Pj(3, a, a.return), $12dc92f49356566c$var$Qj(3, a);
                } catch (t) {
                    $12dc92f49356566c$var$W(a, a.return, t);
                }
                try {
                    $12dc92f49356566c$var$Pj(5, a, a.return);
                } catch (t) {
                    $12dc92f49356566c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $12dc92f49356566c$var$ck(b, a);
            $12dc92f49356566c$var$ek(a);
            d & 512 && null !== c && $12dc92f49356566c$var$Lj(c, c.return);
            break;
        case 5:
            $12dc92f49356566c$var$ck(b, a);
            $12dc92f49356566c$var$ek(a);
            d & 512 && null !== c && $12dc92f49356566c$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $12dc92f49356566c$var$ob(e, "");
                } catch (t) {
                    $12dc92f49356566c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $12dc92f49356566c$var$ab(e, f);
                    $12dc92f49356566c$var$vb(h, g);
                    var l = $12dc92f49356566c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $12dc92f49356566c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $12dc92f49356566c$var$nb(e, q) : "children" === m ? $12dc92f49356566c$var$ob(e, q) : $12dc92f49356566c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $12dc92f49356566c$var$bb(e, f);
                            break;
                        case "textarea":
                            $12dc92f49356566c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $12dc92f49356566c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $12dc92f49356566c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $12dc92f49356566c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$12dc92f49356566c$var$Pf] = f;
                } catch (t) {
                    $12dc92f49356566c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $12dc92f49356566c$var$ck(b, a);
            $12dc92f49356566c$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($12dc92f49356566c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $12dc92f49356566c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $12dc92f49356566c$var$ck(b, a);
            $12dc92f49356566c$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $12dc92f49356566c$var$bd(b.containerInfo);
            } catch (t) {
                $12dc92f49356566c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $12dc92f49356566c$var$ck(b, a);
            $12dc92f49356566c$var$ek(a);
            break;
        case 13:
            $12dc92f49356566c$var$ck(b, a);
            $12dc92f49356566c$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($12dc92f49356566c$var$fk = $12dc92f49356566c$var$B()));
            d & 4 && $12dc92f49356566c$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($12dc92f49356566c$var$U = (l = $12dc92f49356566c$var$U) || m, $12dc92f49356566c$var$ck(b, a), $12dc92f49356566c$var$U = l) : $12dc92f49356566c$var$ck(b, a);
            $12dc92f49356566c$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($12dc92f49356566c$var$V = a, m = a.child; null !== m;){
                    for(q = $12dc92f49356566c$var$V = m; null !== $12dc92f49356566c$var$V;){
                        r = $12dc92f49356566c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $12dc92f49356566c$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $12dc92f49356566c$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $12dc92f49356566c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $12dc92f49356566c$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $12dc92f49356566c$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $12dc92f49356566c$var$V = y) : $12dc92f49356566c$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $12dc92f49356566c$var$rb("display", g));
                            } catch (t) {
                                $12dc92f49356566c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $12dc92f49356566c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $12dc92f49356566c$var$ck(b, a);
            $12dc92f49356566c$var$ek(a);
            d & 4 && $12dc92f49356566c$var$ak(a);
            break;
        case 21:
            break;
        default:
            $12dc92f49356566c$var$ck(b, a), $12dc92f49356566c$var$ek(a);
    }
}
function $12dc92f49356566c$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($12dc92f49356566c$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($12dc92f49356566c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($12dc92f49356566c$var$ob(e, ""), d.flags &= -33);
                    var f = $12dc92f49356566c$var$Uj(a);
                    $12dc92f49356566c$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $12dc92f49356566c$var$Uj(a);
                    $12dc92f49356566c$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($12dc92f49356566c$var$p(161));
            }
        } catch (k) {
            $12dc92f49356566c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $12dc92f49356566c$var$hk(a, b, c) {
    $12dc92f49356566c$var$V = a;
    $12dc92f49356566c$var$ik(a, b, c);
}
function $12dc92f49356566c$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $12dc92f49356566c$var$V;){
        var e = $12dc92f49356566c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $12dc92f49356566c$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $12dc92f49356566c$var$U;
                h = $12dc92f49356566c$var$Jj;
                var l = $12dc92f49356566c$var$U;
                $12dc92f49356566c$var$Jj = g;
                if (($12dc92f49356566c$var$U = k) && !l) for($12dc92f49356566c$var$V = e; null !== $12dc92f49356566c$var$V;)g = $12dc92f49356566c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $12dc92f49356566c$var$jk(e) : null !== k ? (k.return = g, $12dc92f49356566c$var$V = k) : $12dc92f49356566c$var$jk(e);
                for(; null !== f;)$12dc92f49356566c$var$V = f, $12dc92f49356566c$var$ik(f, b, c), f = f.sibling;
                $12dc92f49356566c$var$V = e;
                $12dc92f49356566c$var$Jj = h;
                $12dc92f49356566c$var$U = l;
            }
            $12dc92f49356566c$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $12dc92f49356566c$var$V = f) : $12dc92f49356566c$var$kk(a, b, c);
    }
}
function $12dc92f49356566c$var$kk(a) {
    for(; null !== $12dc92f49356566c$var$V;){
        var b = $12dc92f49356566c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $12dc92f49356566c$var$U || $12dc92f49356566c$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$12dc92f49356566c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $12dc92f49356566c$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $12dc92f49356566c$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $12dc92f49356566c$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $12dc92f49356566c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($12dc92f49356566c$var$p(163));
                }
                $12dc92f49356566c$var$U || b.flags & 512 && $12dc92f49356566c$var$Rj(b);
            } catch (r) {
                $12dc92f49356566c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $12dc92f49356566c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $12dc92f49356566c$var$V = c;
            break;
        }
        $12dc92f49356566c$var$V = b.return;
    }
}
function $12dc92f49356566c$var$gk(a) {
    for(; null !== $12dc92f49356566c$var$V;){
        var b = $12dc92f49356566c$var$V;
        if (b === a) {
            $12dc92f49356566c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $12dc92f49356566c$var$V = c;
            break;
        }
        $12dc92f49356566c$var$V = b.return;
    }
}
function $12dc92f49356566c$var$jk(a) {
    for(; null !== $12dc92f49356566c$var$V;){
        var b = $12dc92f49356566c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $12dc92f49356566c$var$Qj(4, b);
                    } catch (k) {
                        $12dc92f49356566c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $12dc92f49356566c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $12dc92f49356566c$var$Rj(b);
                    } catch (k) {
                        $12dc92f49356566c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $12dc92f49356566c$var$Rj(b);
                    } catch (k) {
                        $12dc92f49356566c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $12dc92f49356566c$var$W(b, b.return, k);
        }
        if (b === a) {
            $12dc92f49356566c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $12dc92f49356566c$var$V = h;
            break;
        }
        $12dc92f49356566c$var$V = b.return;
    }
}
var $12dc92f49356566c$var$lk = Math.ceil, $12dc92f49356566c$var$mk = $12dc92f49356566c$var$ua.ReactCurrentDispatcher, $12dc92f49356566c$var$nk = $12dc92f49356566c$var$ua.ReactCurrentOwner, $12dc92f49356566c$var$ok = $12dc92f49356566c$var$ua.ReactCurrentBatchConfig, $12dc92f49356566c$var$K = 0, $12dc92f49356566c$var$Q = null, $12dc92f49356566c$var$Y = null, $12dc92f49356566c$var$Z = 0, $12dc92f49356566c$var$fj = 0, $12dc92f49356566c$var$ej = $12dc92f49356566c$var$Uf(0), $12dc92f49356566c$var$T = 0, $12dc92f49356566c$var$pk = null, $12dc92f49356566c$var$rh = 0, $12dc92f49356566c$var$qk = 0, $12dc92f49356566c$var$rk = 0, $12dc92f49356566c$var$sk = null, $12dc92f49356566c$var$tk = null, $12dc92f49356566c$var$fk = 0, $12dc92f49356566c$var$Gj = Infinity, $12dc92f49356566c$var$uk = null, $12dc92f49356566c$var$Oi = !1, $12dc92f49356566c$var$Pi = null, $12dc92f49356566c$var$Ri = null, $12dc92f49356566c$var$vk = !1, $12dc92f49356566c$var$wk = null, $12dc92f49356566c$var$xk = 0, $12dc92f49356566c$var$yk = 0, $12dc92f49356566c$var$zk = null, $12dc92f49356566c$var$Ak = -1, $12dc92f49356566c$var$Bk = 0;
function $12dc92f49356566c$var$R() {
    return 0 !== ($12dc92f49356566c$var$K & 6) ? $12dc92f49356566c$var$B() : -1 !== $12dc92f49356566c$var$Ak ? $12dc92f49356566c$var$Ak : $12dc92f49356566c$var$Ak = $12dc92f49356566c$var$B();
}
function $12dc92f49356566c$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($12dc92f49356566c$var$K & 2) && 0 !== $12dc92f49356566c$var$Z) return $12dc92f49356566c$var$Z & -$12dc92f49356566c$var$Z;
    if (null !== $12dc92f49356566c$var$Kg.transition) return 0 === $12dc92f49356566c$var$Bk && ($12dc92f49356566c$var$Bk = $12dc92f49356566c$var$yc()), $12dc92f49356566c$var$Bk;
    a = $12dc92f49356566c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $12dc92f49356566c$var$jd(a.type);
    return a;
}
function $12dc92f49356566c$var$gi(a, b, c, d) {
    if (50 < $12dc92f49356566c$var$yk) throw $12dc92f49356566c$var$yk = 0, $12dc92f49356566c$var$zk = null, Error($12dc92f49356566c$var$p(185));
    $12dc92f49356566c$var$Ac(a, c, d);
    if (0 === ($12dc92f49356566c$var$K & 2) || a !== $12dc92f49356566c$var$Q) a === $12dc92f49356566c$var$Q && (0 === ($12dc92f49356566c$var$K & 2) && ($12dc92f49356566c$var$qk |= c), 4 === $12dc92f49356566c$var$T && $12dc92f49356566c$var$Ck(a, $12dc92f49356566c$var$Z)), $12dc92f49356566c$var$Dk(a, d), 1 === c && 0 === $12dc92f49356566c$var$K && 0 === (b.mode & 1) && ($12dc92f49356566c$var$Gj = $12dc92f49356566c$var$B() + 500, $12dc92f49356566c$var$fg && $12dc92f49356566c$var$jg());
}
function $12dc92f49356566c$var$Dk(a, b) {
    var c = a.callbackNode;
    $12dc92f49356566c$var$wc(a, b);
    var d = $12dc92f49356566c$var$uc(a, a === $12dc92f49356566c$var$Q ? $12dc92f49356566c$var$Z : 0);
    if (0 === d) null !== c && $12dc92f49356566c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $12dc92f49356566c$var$bc(c);
        if (1 === b) 0 === a.tag ? $12dc92f49356566c$var$ig($12dc92f49356566c$var$Ek.bind(null, a)) : $12dc92f49356566c$var$hg($12dc92f49356566c$var$Ek.bind(null, a)), $12dc92f49356566c$var$Jf(function() {
            0 === ($12dc92f49356566c$var$K & 6) && $12dc92f49356566c$var$jg();
        }), c = null;
        else {
            switch($12dc92f49356566c$var$Dc(d)){
                case 1:
                    c = $12dc92f49356566c$var$fc;
                    break;
                case 4:
                    c = $12dc92f49356566c$var$gc;
                    break;
                case 16:
                    c = $12dc92f49356566c$var$hc;
                    break;
                case 536870912:
                    c = $12dc92f49356566c$var$jc;
                    break;
                default:
                    c = $12dc92f49356566c$var$hc;
            }
            c = $12dc92f49356566c$var$Fk(c, $12dc92f49356566c$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $12dc92f49356566c$var$Gk(a, b) {
    $12dc92f49356566c$var$Ak = -1;
    $12dc92f49356566c$var$Bk = 0;
    if (0 !== ($12dc92f49356566c$var$K & 6)) throw Error($12dc92f49356566c$var$p(327));
    var c = a.callbackNode;
    if ($12dc92f49356566c$var$Hk() && a.callbackNode !== c) return null;
    var d = $12dc92f49356566c$var$uc(a, a === $12dc92f49356566c$var$Q ? $12dc92f49356566c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $12dc92f49356566c$var$Ik(a, d);
    else {
        b = d;
        var e = $12dc92f49356566c$var$K;
        $12dc92f49356566c$var$K |= 2;
        var f = $12dc92f49356566c$var$Jk();
        if ($12dc92f49356566c$var$Q !== a || $12dc92f49356566c$var$Z !== b) $12dc92f49356566c$var$uk = null, $12dc92f49356566c$var$Gj = $12dc92f49356566c$var$B() + 500, $12dc92f49356566c$var$Kk(a, b);
        for(;;)try {
            $12dc92f49356566c$var$Lk();
            break;
        } catch (h) {
            $12dc92f49356566c$var$Mk(a, h);
        }
        $12dc92f49356566c$var$$g();
        $12dc92f49356566c$var$mk.current = f;
        $12dc92f49356566c$var$K = e;
        null !== $12dc92f49356566c$var$Y ? b = 0 : ($12dc92f49356566c$var$Q = null, $12dc92f49356566c$var$Z = 0, b = $12dc92f49356566c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $12dc92f49356566c$var$xc(a), 0 !== e && (d = e, b = $12dc92f49356566c$var$Nk(a, e)));
        if (1 === b) throw c = $12dc92f49356566c$var$pk, $12dc92f49356566c$var$Kk(a, 0), $12dc92f49356566c$var$Ck(a, d), $12dc92f49356566c$var$Dk(a, $12dc92f49356566c$var$B()), c;
        if (6 === b) $12dc92f49356566c$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$12dc92f49356566c$var$Ok(e) && (b = $12dc92f49356566c$var$Ik(a, d), 2 === b && (f = $12dc92f49356566c$var$xc(a), 0 !== f && (d = f, b = $12dc92f49356566c$var$Nk(a, f))), 1 === b)) throw c = $12dc92f49356566c$var$pk, $12dc92f49356566c$var$Kk(a, 0), $12dc92f49356566c$var$Ck(a, d), $12dc92f49356566c$var$Dk(a, $12dc92f49356566c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($12dc92f49356566c$var$p(345));
                case 2:
                    $12dc92f49356566c$var$Pk(a, $12dc92f49356566c$var$tk, $12dc92f49356566c$var$uk);
                    break;
                case 3:
                    $12dc92f49356566c$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $12dc92f49356566c$var$fk + 500 - $12dc92f49356566c$var$B(), 10 < b)) {
                        if (0 !== $12dc92f49356566c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $12dc92f49356566c$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $12dc92f49356566c$var$Ff($12dc92f49356566c$var$Pk.bind(null, a, $12dc92f49356566c$var$tk, $12dc92f49356566c$var$uk), b);
                        break;
                    }
                    $12dc92f49356566c$var$Pk(a, $12dc92f49356566c$var$tk, $12dc92f49356566c$var$uk);
                    break;
                case 4:
                    $12dc92f49356566c$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $12dc92f49356566c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $12dc92f49356566c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $12dc92f49356566c$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $12dc92f49356566c$var$Ff($12dc92f49356566c$var$Pk.bind(null, a, $12dc92f49356566c$var$tk, $12dc92f49356566c$var$uk), d);
                        break;
                    }
                    $12dc92f49356566c$var$Pk(a, $12dc92f49356566c$var$tk, $12dc92f49356566c$var$uk);
                    break;
                case 5:
                    $12dc92f49356566c$var$Pk(a, $12dc92f49356566c$var$tk, $12dc92f49356566c$var$uk);
                    break;
                default:
                    throw Error($12dc92f49356566c$var$p(329));
            }
        }
    }
    $12dc92f49356566c$var$Dk(a, $12dc92f49356566c$var$B());
    return a.callbackNode === c ? $12dc92f49356566c$var$Gk.bind(null, a) : null;
}
function $12dc92f49356566c$var$Nk(a, b) {
    var c = $12dc92f49356566c$var$sk;
    a.current.memoizedState.isDehydrated && ($12dc92f49356566c$var$Kk(a, b).flags |= 256);
    a = $12dc92f49356566c$var$Ik(a, b);
    2 !== a && (b = $12dc92f49356566c$var$tk, $12dc92f49356566c$var$tk = c, null !== b && $12dc92f49356566c$var$Fj(b));
    return a;
}
function $12dc92f49356566c$var$Fj(a) {
    null === $12dc92f49356566c$var$tk ? $12dc92f49356566c$var$tk = a : $12dc92f49356566c$var$tk.push.apply($12dc92f49356566c$var$tk, a);
}
function $12dc92f49356566c$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$12dc92f49356566c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $12dc92f49356566c$var$Ck(a, b) {
    b &= ~$12dc92f49356566c$var$rk;
    b &= ~$12dc92f49356566c$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $12dc92f49356566c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $12dc92f49356566c$var$Ek(a) {
    if (0 !== ($12dc92f49356566c$var$K & 6)) throw Error($12dc92f49356566c$var$p(327));
    $12dc92f49356566c$var$Hk();
    var b = $12dc92f49356566c$var$uc(a, 0);
    if (0 === (b & 1)) return $12dc92f49356566c$var$Dk(a, $12dc92f49356566c$var$B()), null;
    var c = $12dc92f49356566c$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $12dc92f49356566c$var$xc(a);
        0 !== d && (b = d, c = $12dc92f49356566c$var$Nk(a, d));
    }
    if (1 === c) throw c = $12dc92f49356566c$var$pk, $12dc92f49356566c$var$Kk(a, 0), $12dc92f49356566c$var$Ck(a, b), $12dc92f49356566c$var$Dk(a, $12dc92f49356566c$var$B()), c;
    if (6 === c) throw Error($12dc92f49356566c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $12dc92f49356566c$var$Pk(a, $12dc92f49356566c$var$tk, $12dc92f49356566c$var$uk);
    $12dc92f49356566c$var$Dk(a, $12dc92f49356566c$var$B());
    return null;
}
function $12dc92f49356566c$var$Qk(a, b) {
    var c = $12dc92f49356566c$var$K;
    $12dc92f49356566c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $12dc92f49356566c$var$K = c, 0 === $12dc92f49356566c$var$K && ($12dc92f49356566c$var$Gj = $12dc92f49356566c$var$B() + 500, $12dc92f49356566c$var$fg && $12dc92f49356566c$var$jg());
    }
}
function $12dc92f49356566c$var$Rk(a) {
    null !== $12dc92f49356566c$var$wk && 0 === $12dc92f49356566c$var$wk.tag && 0 === ($12dc92f49356566c$var$K & 6) && $12dc92f49356566c$var$Hk();
    var b = $12dc92f49356566c$var$K;
    $12dc92f49356566c$var$K |= 1;
    var c = $12dc92f49356566c$var$ok.transition, d = $12dc92f49356566c$var$C;
    try {
        if ($12dc92f49356566c$var$ok.transition = null, $12dc92f49356566c$var$C = 1, a) return a();
    } finally{
        $12dc92f49356566c$var$C = d, $12dc92f49356566c$var$ok.transition = c, $12dc92f49356566c$var$K = b, 0 === ($12dc92f49356566c$var$K & 6) && $12dc92f49356566c$var$jg();
    }
}
function $12dc92f49356566c$var$Hj() {
    $12dc92f49356566c$var$fj = $12dc92f49356566c$var$ej.current;
    $12dc92f49356566c$var$E($12dc92f49356566c$var$ej);
}
function $12dc92f49356566c$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $12dc92f49356566c$var$Gf(c));
    if (null !== $12dc92f49356566c$var$Y) for(c = $12dc92f49356566c$var$Y.return; null !== c;){
        var d = c;
        $12dc92f49356566c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $12dc92f49356566c$var$$f();
                break;
            case 3:
                $12dc92f49356566c$var$zh();
                $12dc92f49356566c$var$E($12dc92f49356566c$var$Wf);
                $12dc92f49356566c$var$E($12dc92f49356566c$var$H);
                $12dc92f49356566c$var$Eh();
                break;
            case 5:
                $12dc92f49356566c$var$Bh(d);
                break;
            case 4:
                $12dc92f49356566c$var$zh();
                break;
            case 13:
                $12dc92f49356566c$var$E($12dc92f49356566c$var$L);
                break;
            case 19:
                $12dc92f49356566c$var$E($12dc92f49356566c$var$L);
                break;
            case 10:
                $12dc92f49356566c$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $12dc92f49356566c$var$Hj();
        }
        c = c.return;
    }
    $12dc92f49356566c$var$Q = a;
    $12dc92f49356566c$var$Y = a = $12dc92f49356566c$var$Pg(a.current, null);
    $12dc92f49356566c$var$Z = $12dc92f49356566c$var$fj = b;
    $12dc92f49356566c$var$T = 0;
    $12dc92f49356566c$var$pk = null;
    $12dc92f49356566c$var$rk = $12dc92f49356566c$var$qk = $12dc92f49356566c$var$rh = 0;
    $12dc92f49356566c$var$tk = $12dc92f49356566c$var$sk = null;
    if (null !== $12dc92f49356566c$var$fh) {
        for(b = 0; b < $12dc92f49356566c$var$fh.length; b++)if (c = $12dc92f49356566c$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $12dc92f49356566c$var$fh = null;
    }
    return a;
}
function $12dc92f49356566c$var$Mk(a, b) {
    do {
        var c = $12dc92f49356566c$var$Y;
        try {
            $12dc92f49356566c$var$$g();
            $12dc92f49356566c$var$Fh.current = $12dc92f49356566c$var$Rh;
            if ($12dc92f49356566c$var$Ih) {
                for(var d = $12dc92f49356566c$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $12dc92f49356566c$var$Ih = !1;
            }
            $12dc92f49356566c$var$Hh = 0;
            $12dc92f49356566c$var$O = $12dc92f49356566c$var$N = $12dc92f49356566c$var$M = null;
            $12dc92f49356566c$var$Jh = !1;
            $12dc92f49356566c$var$Kh = 0;
            $12dc92f49356566c$var$nk.current = null;
            if (null === c || null === c.return) {
                $12dc92f49356566c$var$T = 1;
                $12dc92f49356566c$var$pk = b;
                $12dc92f49356566c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $12dc92f49356566c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $12dc92f49356566c$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $12dc92f49356566c$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $12dc92f49356566c$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $12dc92f49356566c$var$Si(f, l, b);
                            $12dc92f49356566c$var$tj();
                            break a;
                        }
                        k = Error($12dc92f49356566c$var$p(426));
                    }
                } else if ($12dc92f49356566c$var$I && h.mode & 1) {
                    var J = $12dc92f49356566c$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $12dc92f49356566c$var$Vi(J, g, h, f, b);
                        $12dc92f49356566c$var$Jg($12dc92f49356566c$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $12dc92f49356566c$var$Ji(k, h);
                4 !== $12dc92f49356566c$var$T && ($12dc92f49356566c$var$T = 2);
                null === $12dc92f49356566c$var$sk ? $12dc92f49356566c$var$sk = [
                    f
                ] : $12dc92f49356566c$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $12dc92f49356566c$var$Ni(f, k, b);
                            $12dc92f49356566c$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $12dc92f49356566c$var$Ri || !$12dc92f49356566c$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $12dc92f49356566c$var$Qi(f, h, b);
                                $12dc92f49356566c$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $12dc92f49356566c$var$Sk(c);
        } catch (na) {
            b = na;
            $12dc92f49356566c$var$Y === c && null !== c && ($12dc92f49356566c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $12dc92f49356566c$var$Jk() {
    var a = $12dc92f49356566c$var$mk.current;
    $12dc92f49356566c$var$mk.current = $12dc92f49356566c$var$Rh;
    return null === a ? $12dc92f49356566c$var$Rh : a;
}
function $12dc92f49356566c$var$tj() {
    if (0 === $12dc92f49356566c$var$T || 3 === $12dc92f49356566c$var$T || 2 === $12dc92f49356566c$var$T) $12dc92f49356566c$var$T = 4;
    null === $12dc92f49356566c$var$Q || 0 === ($12dc92f49356566c$var$rh & 268435455) && 0 === ($12dc92f49356566c$var$qk & 268435455) || $12dc92f49356566c$var$Ck($12dc92f49356566c$var$Q, $12dc92f49356566c$var$Z);
}
function $12dc92f49356566c$var$Ik(a, b) {
    var c = $12dc92f49356566c$var$K;
    $12dc92f49356566c$var$K |= 2;
    var d = $12dc92f49356566c$var$Jk();
    if ($12dc92f49356566c$var$Q !== a || $12dc92f49356566c$var$Z !== b) $12dc92f49356566c$var$uk = null, $12dc92f49356566c$var$Kk(a, b);
    for(;;)try {
        $12dc92f49356566c$var$Tk();
        break;
    } catch (e) {
        $12dc92f49356566c$var$Mk(a, e);
    }
    $12dc92f49356566c$var$$g();
    $12dc92f49356566c$var$K = c;
    $12dc92f49356566c$var$mk.current = d;
    if (null !== $12dc92f49356566c$var$Y) throw Error($12dc92f49356566c$var$p(261));
    $12dc92f49356566c$var$Q = null;
    $12dc92f49356566c$var$Z = 0;
    return $12dc92f49356566c$var$T;
}
function $12dc92f49356566c$var$Tk() {
    for(; null !== $12dc92f49356566c$var$Y;)$12dc92f49356566c$var$Uk($12dc92f49356566c$var$Y);
}
function $12dc92f49356566c$var$Lk() {
    for(; null !== $12dc92f49356566c$var$Y && !$12dc92f49356566c$var$cc();)$12dc92f49356566c$var$Uk($12dc92f49356566c$var$Y);
}
function $12dc92f49356566c$var$Uk(a) {
    var b = $12dc92f49356566c$var$Vk(a.alternate, a, $12dc92f49356566c$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $12dc92f49356566c$var$Sk(a) : $12dc92f49356566c$var$Y = b;
    $12dc92f49356566c$var$nk.current = null;
}
function $12dc92f49356566c$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $12dc92f49356566c$var$Ej(c, b, $12dc92f49356566c$var$fj), null !== c) {
                $12dc92f49356566c$var$Y = c;
                return;
            }
        } else {
            c = $12dc92f49356566c$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $12dc92f49356566c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $12dc92f49356566c$var$T = 6;
                $12dc92f49356566c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $12dc92f49356566c$var$Y = b;
            return;
        }
        $12dc92f49356566c$var$Y = b = a;
    }while (null !== b);
    0 === $12dc92f49356566c$var$T && ($12dc92f49356566c$var$T = 5);
}
function $12dc92f49356566c$var$Pk(a, b, c) {
    var d = $12dc92f49356566c$var$C, e = $12dc92f49356566c$var$ok.transition;
    try {
        $12dc92f49356566c$var$ok.transition = null, $12dc92f49356566c$var$C = 1, $12dc92f49356566c$var$Wk(a, b, c, d);
    } finally{
        $12dc92f49356566c$var$ok.transition = e, $12dc92f49356566c$var$C = d;
    }
    return null;
}
function $12dc92f49356566c$var$Wk(a, b, c, d) {
    do $12dc92f49356566c$var$Hk();
    while (null !== $12dc92f49356566c$var$wk);
    if (0 !== ($12dc92f49356566c$var$K & 6)) throw Error($12dc92f49356566c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($12dc92f49356566c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $12dc92f49356566c$var$Bc(a, f);
    a === $12dc92f49356566c$var$Q && ($12dc92f49356566c$var$Y = $12dc92f49356566c$var$Q = null, $12dc92f49356566c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $12dc92f49356566c$var$vk || ($12dc92f49356566c$var$vk = !0, $12dc92f49356566c$var$Fk($12dc92f49356566c$var$hc, function() {
        $12dc92f49356566c$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $12dc92f49356566c$var$ok.transition;
        $12dc92f49356566c$var$ok.transition = null;
        var g = $12dc92f49356566c$var$C;
        $12dc92f49356566c$var$C = 1;
        var h = $12dc92f49356566c$var$K;
        $12dc92f49356566c$var$K |= 4;
        $12dc92f49356566c$var$nk.current = null;
        $12dc92f49356566c$var$Oj(a, c);
        $12dc92f49356566c$var$dk(c, a);
        $12dc92f49356566c$var$Oe($12dc92f49356566c$var$Df);
        $12dc92f49356566c$var$dd = !!$12dc92f49356566c$var$Cf;
        $12dc92f49356566c$var$Df = $12dc92f49356566c$var$Cf = null;
        a.current = c;
        $12dc92f49356566c$var$hk(c, a, e);
        $12dc92f49356566c$var$dc();
        $12dc92f49356566c$var$K = h;
        $12dc92f49356566c$var$C = g;
        $12dc92f49356566c$var$ok.transition = f;
    } else a.current = c;
    $12dc92f49356566c$var$vk && ($12dc92f49356566c$var$vk = !1, $12dc92f49356566c$var$wk = a, $12dc92f49356566c$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($12dc92f49356566c$var$Ri = null);
    $12dc92f49356566c$var$mc(c.stateNode, d);
    $12dc92f49356566c$var$Dk(a, $12dc92f49356566c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($12dc92f49356566c$var$Oi) throw $12dc92f49356566c$var$Oi = !1, a = $12dc92f49356566c$var$Pi, $12dc92f49356566c$var$Pi = null, a;
    0 !== ($12dc92f49356566c$var$xk & 1) && 0 !== a.tag && $12dc92f49356566c$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $12dc92f49356566c$var$zk ? $12dc92f49356566c$var$yk++ : ($12dc92f49356566c$var$yk = 0, $12dc92f49356566c$var$zk = a) : $12dc92f49356566c$var$yk = 0;
    $12dc92f49356566c$var$jg();
    return null;
}
function $12dc92f49356566c$var$Hk() {
    if (null !== $12dc92f49356566c$var$wk) {
        var a = $12dc92f49356566c$var$Dc($12dc92f49356566c$var$xk), b = $12dc92f49356566c$var$ok.transition, c = $12dc92f49356566c$var$C;
        try {
            $12dc92f49356566c$var$ok.transition = null;
            $12dc92f49356566c$var$C = 16 > a ? 16 : a;
            if (null === $12dc92f49356566c$var$wk) var d = !1;
            else {
                a = $12dc92f49356566c$var$wk;
                $12dc92f49356566c$var$wk = null;
                $12dc92f49356566c$var$xk = 0;
                if (0 !== ($12dc92f49356566c$var$K & 6)) throw Error($12dc92f49356566c$var$p(331));
                var e = $12dc92f49356566c$var$K;
                $12dc92f49356566c$var$K |= 4;
                for($12dc92f49356566c$var$V = a.current; null !== $12dc92f49356566c$var$V;){
                    var f = $12dc92f49356566c$var$V, g = f.child;
                    if (0 !== ($12dc92f49356566c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($12dc92f49356566c$var$V = l; null !== $12dc92f49356566c$var$V;){
                                    var m = $12dc92f49356566c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $12dc92f49356566c$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $12dc92f49356566c$var$V = q;
                                    else for(; null !== $12dc92f49356566c$var$V;){
                                        m = $12dc92f49356566c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $12dc92f49356566c$var$Sj(m);
                                        if (m === l) {
                                            $12dc92f49356566c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $12dc92f49356566c$var$V = r;
                                            break;
                                        }
                                        $12dc92f49356566c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $12dc92f49356566c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $12dc92f49356566c$var$V = g;
                    else b: for(; null !== $12dc92f49356566c$var$V;){
                        f = $12dc92f49356566c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $12dc92f49356566c$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $12dc92f49356566c$var$V = x;
                            break b;
                        }
                        $12dc92f49356566c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($12dc92f49356566c$var$V = w; null !== $12dc92f49356566c$var$V;){
                    g = $12dc92f49356566c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $12dc92f49356566c$var$V = u;
                    else b: for(g = w; null !== $12dc92f49356566c$var$V;){
                        h = $12dc92f49356566c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $12dc92f49356566c$var$Qj(9, h);
                            }
                        } catch (na) {
                            $12dc92f49356566c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $12dc92f49356566c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $12dc92f49356566c$var$V = F;
                            break b;
                        }
                        $12dc92f49356566c$var$V = h.return;
                    }
                }
                $12dc92f49356566c$var$K = e;
                $12dc92f49356566c$var$jg();
                if ($12dc92f49356566c$var$lc && "function" === typeof $12dc92f49356566c$var$lc.onPostCommitFiberRoot) try {
                    $12dc92f49356566c$var$lc.onPostCommitFiberRoot($12dc92f49356566c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $12dc92f49356566c$var$C = c, $12dc92f49356566c$var$ok.transition = b;
        }
    }
    return !1;
}
function $12dc92f49356566c$var$Xk(a, b, c) {
    b = $12dc92f49356566c$var$Ji(c, b);
    b = $12dc92f49356566c$var$Ni(a, b, 1);
    a = $12dc92f49356566c$var$nh(a, b, 1);
    b = $12dc92f49356566c$var$R();
    null !== a && ($12dc92f49356566c$var$Ac(a, 1, b), $12dc92f49356566c$var$Dk(a, b));
}
function $12dc92f49356566c$var$W(a, b, c) {
    if (3 === a.tag) $12dc92f49356566c$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $12dc92f49356566c$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $12dc92f49356566c$var$Ri || !$12dc92f49356566c$var$Ri.has(d))) {
                a = $12dc92f49356566c$var$Ji(c, a);
                a = $12dc92f49356566c$var$Qi(b, a, 1);
                b = $12dc92f49356566c$var$nh(b, a, 1);
                a = $12dc92f49356566c$var$R();
                null !== b && ($12dc92f49356566c$var$Ac(b, 1, a), $12dc92f49356566c$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $12dc92f49356566c$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $12dc92f49356566c$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $12dc92f49356566c$var$Q === a && ($12dc92f49356566c$var$Z & c) === c && (4 === $12dc92f49356566c$var$T || 3 === $12dc92f49356566c$var$T && ($12dc92f49356566c$var$Z & 130023424) === $12dc92f49356566c$var$Z && 500 > $12dc92f49356566c$var$B() - $12dc92f49356566c$var$fk ? $12dc92f49356566c$var$Kk(a, 0) : $12dc92f49356566c$var$rk |= c);
    $12dc92f49356566c$var$Dk(a, b);
}
function $12dc92f49356566c$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $12dc92f49356566c$var$sc, $12dc92f49356566c$var$sc <<= 1, 0 === ($12dc92f49356566c$var$sc & 130023424) && ($12dc92f49356566c$var$sc = 4194304)));
    var c = $12dc92f49356566c$var$R();
    a = $12dc92f49356566c$var$ih(a, b);
    null !== a && ($12dc92f49356566c$var$Ac(a, b, c), $12dc92f49356566c$var$Dk(a, c));
}
function $12dc92f49356566c$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $12dc92f49356566c$var$Yk(a, c);
}
function $12dc92f49356566c$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($12dc92f49356566c$var$p(314));
    }
    null !== d && d.delete(b);
    $12dc92f49356566c$var$Yk(a, c);
}
var $12dc92f49356566c$var$Vk;
$12dc92f49356566c$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $12dc92f49356566c$var$Wf.current) $12dc92f49356566c$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $12dc92f49356566c$var$dh = !1, $12dc92f49356566c$var$yj(a, b, c);
            $12dc92f49356566c$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $12dc92f49356566c$var$dh = !1, $12dc92f49356566c$var$I && 0 !== (b.flags & 1048576) && $12dc92f49356566c$var$ug(b, $12dc92f49356566c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $12dc92f49356566c$var$ij(a, b);
            a = b.pendingProps;
            var e = $12dc92f49356566c$var$Yf(b, $12dc92f49356566c$var$H.current);
            $12dc92f49356566c$var$ch(b, c);
            e = $12dc92f49356566c$var$Nh(null, b, d, a, e, c);
            var f = $12dc92f49356566c$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $12dc92f49356566c$var$Zf(d) ? (f = !0, $12dc92f49356566c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $12dc92f49356566c$var$kh(b), e.updater = $12dc92f49356566c$var$Ei, b.stateNode = e, e._reactInternals = b, $12dc92f49356566c$var$Ii(b, d, a, c), b = $12dc92f49356566c$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $12dc92f49356566c$var$I && f && $12dc92f49356566c$var$vg(b), $12dc92f49356566c$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $12dc92f49356566c$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $12dc92f49356566c$var$Zk(d);
                a = $12dc92f49356566c$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $12dc92f49356566c$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $12dc92f49356566c$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $12dc92f49356566c$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $12dc92f49356566c$var$$i(null, b, d, $12dc92f49356566c$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($12dc92f49356566c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $12dc92f49356566c$var$Ci(d, e), $12dc92f49356566c$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $12dc92f49356566c$var$Ci(d, e), $12dc92f49356566c$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $12dc92f49356566c$var$kj(b);
                if (null === a) throw Error($12dc92f49356566c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $12dc92f49356566c$var$lh(a, b);
                $12dc92f49356566c$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $12dc92f49356566c$var$Ji(Error($12dc92f49356566c$var$p(423)), b);
                        b = $12dc92f49356566c$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $12dc92f49356566c$var$Ji(Error($12dc92f49356566c$var$p(424)), b);
                        b = $12dc92f49356566c$var$lj(a, b, d, c, e);
                        break a;
                    } else for($12dc92f49356566c$var$yg = $12dc92f49356566c$var$Lf(b.stateNode.containerInfo.firstChild), $12dc92f49356566c$var$xg = b, $12dc92f49356566c$var$I = !0, $12dc92f49356566c$var$zg = null, c = $12dc92f49356566c$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $12dc92f49356566c$var$Ig();
                    if (d === e) {
                        b = $12dc92f49356566c$var$Zi(a, b, c);
                        break a;
                    }
                    $12dc92f49356566c$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $12dc92f49356566c$var$Ah(b), null === a && $12dc92f49356566c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $12dc92f49356566c$var$Ef(d, e) ? g = null : null !== f && $12dc92f49356566c$var$Ef(d, f) && (b.flags |= 32), $12dc92f49356566c$var$gj(a, b), $12dc92f49356566c$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $12dc92f49356566c$var$Eg(b), null;
        case 13:
            return $12dc92f49356566c$var$oj(a, b, c);
        case 4:
            return $12dc92f49356566c$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $12dc92f49356566c$var$Ug(b, null, d, c) : $12dc92f49356566c$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $12dc92f49356566c$var$Ci(d, e), $12dc92f49356566c$var$Yi(a, b, d, e, c);
        case 7:
            return $12dc92f49356566c$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $12dc92f49356566c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $12dc92f49356566c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $12dc92f49356566c$var$G($12dc92f49356566c$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($12dc92f49356566c$var$He(f.value, g)) {
                        if (f.children === e.children && !$12dc92f49356566c$var$Wf.current) {
                            b = $12dc92f49356566c$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $12dc92f49356566c$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $12dc92f49356566c$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($12dc92f49356566c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $12dc92f49356566c$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $12dc92f49356566c$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $12dc92f49356566c$var$ch(b, c), e = $12dc92f49356566c$var$eh(e), d = d(e), b.flags |= 1, $12dc92f49356566c$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $12dc92f49356566c$var$Ci(d, b.pendingProps), e = $12dc92f49356566c$var$Ci(d.type, e), $12dc92f49356566c$var$$i(a, b, d, e, c);
        case 15:
            return $12dc92f49356566c$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $12dc92f49356566c$var$Ci(d, e), $12dc92f49356566c$var$ij(a, b), b.tag = 1, $12dc92f49356566c$var$Zf(d) ? (a = !0, $12dc92f49356566c$var$cg(b)) : a = !1, $12dc92f49356566c$var$ch(b, c), $12dc92f49356566c$var$Gi(b, d, e), $12dc92f49356566c$var$Ii(b, d, e, c), $12dc92f49356566c$var$jj(null, b, d, !0, a, c);
        case 19:
            return $12dc92f49356566c$var$xj(a, b, c);
        case 22:
            return $12dc92f49356566c$var$dj(a, b, c);
    }
    throw Error($12dc92f49356566c$var$p(156, b.tag));
};
function $12dc92f49356566c$var$Fk(a, b) {
    return $12dc92f49356566c$var$ac(a, b);
}
function $12dc92f49356566c$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $12dc92f49356566c$var$Bg(a, b, c, d) {
    return new $12dc92f49356566c$var$$k(a, b, c, d);
}
function $12dc92f49356566c$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $12dc92f49356566c$var$Zk(a) {
    if ("function" === typeof a) return $12dc92f49356566c$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $12dc92f49356566c$var$Da) return 11;
        if (a === $12dc92f49356566c$var$Ga) return 14;
    }
    return 2;
}
function $12dc92f49356566c$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $12dc92f49356566c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $12dc92f49356566c$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $12dc92f49356566c$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $12dc92f49356566c$var$ya:
            return $12dc92f49356566c$var$Tg(c.children, e, f, b);
        case $12dc92f49356566c$var$za:
            g = 8;
            e |= 8;
            break;
        case $12dc92f49356566c$var$Aa:
            return a = $12dc92f49356566c$var$Bg(12, c, b, e | 2), a.elementType = $12dc92f49356566c$var$Aa, a.lanes = f, a;
        case $12dc92f49356566c$var$Ea:
            return a = $12dc92f49356566c$var$Bg(13, c, b, e), a.elementType = $12dc92f49356566c$var$Ea, a.lanes = f, a;
        case $12dc92f49356566c$var$Fa:
            return a = $12dc92f49356566c$var$Bg(19, c, b, e), a.elementType = $12dc92f49356566c$var$Fa, a.lanes = f, a;
        case $12dc92f49356566c$var$Ia:
            return $12dc92f49356566c$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $12dc92f49356566c$var$Ba:
                    g = 10;
                    break a;
                case $12dc92f49356566c$var$Ca:
                    g = 9;
                    break a;
                case $12dc92f49356566c$var$Da:
                    g = 11;
                    break a;
                case $12dc92f49356566c$var$Ga:
                    g = 14;
                    break a;
                case $12dc92f49356566c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($12dc92f49356566c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $12dc92f49356566c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $12dc92f49356566c$var$Tg(a, b, c, d) {
    a = $12dc92f49356566c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $12dc92f49356566c$var$pj(a, b, c, d) {
    a = $12dc92f49356566c$var$Bg(22, a, d, b);
    a.elementType = $12dc92f49356566c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $12dc92f49356566c$var$Qg(a, b, c) {
    a = $12dc92f49356566c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $12dc92f49356566c$var$Sg(a, b, c) {
    b = $12dc92f49356566c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $12dc92f49356566c$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $12dc92f49356566c$var$zc(0);
    this.expirationTimes = $12dc92f49356566c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $12dc92f49356566c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $12dc92f49356566c$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $12dc92f49356566c$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $12dc92f49356566c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $12dc92f49356566c$var$kh(f);
    return a;
}
function $12dc92f49356566c$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $12dc92f49356566c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $12dc92f49356566c$var$dl(a) {
    if (!a) return $12dc92f49356566c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($12dc92f49356566c$var$Vb(a) !== a || 1 !== a.tag) throw Error($12dc92f49356566c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($12dc92f49356566c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($12dc92f49356566c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($12dc92f49356566c$var$Zf(c)) return $12dc92f49356566c$var$bg(a, c, b);
    }
    return b;
}
function $12dc92f49356566c$var$el(a, b, c, d, e, f, g, h, k) {
    a = $12dc92f49356566c$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $12dc92f49356566c$var$dl(null);
    c = a.current;
    d = $12dc92f49356566c$var$R();
    e = $12dc92f49356566c$var$yi(c);
    f = $12dc92f49356566c$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $12dc92f49356566c$var$nh(c, f, e);
    a.current.lanes = e;
    $12dc92f49356566c$var$Ac(a, e, d);
    $12dc92f49356566c$var$Dk(a, d);
    return a;
}
function $12dc92f49356566c$var$fl(a, b, c, d) {
    var e = b.current, f = $12dc92f49356566c$var$R(), g = $12dc92f49356566c$var$yi(e);
    c = $12dc92f49356566c$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $12dc92f49356566c$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $12dc92f49356566c$var$nh(e, b, g);
    null !== a && ($12dc92f49356566c$var$gi(a, e, g, f), $12dc92f49356566c$var$oh(a, e, g));
    return g;
}
function $12dc92f49356566c$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $12dc92f49356566c$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $12dc92f49356566c$var$il(a, b) {
    $12dc92f49356566c$var$hl(a, b);
    (a = a.alternate) && $12dc92f49356566c$var$hl(a, b);
}
function $12dc92f49356566c$var$jl() {
    return null;
}
var $12dc92f49356566c$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $12dc92f49356566c$var$ll(a) {
    this._internalRoot = a;
}
$12dc92f49356566c$var$ml.prototype.render = $12dc92f49356566c$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($12dc92f49356566c$var$p(409));
    $12dc92f49356566c$var$fl(a, b, null, null);
};
$12dc92f49356566c$var$ml.prototype.unmount = $12dc92f49356566c$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $12dc92f49356566c$var$Rk(function() {
            $12dc92f49356566c$var$fl(null, a, null, null);
        });
        b[$12dc92f49356566c$var$uf] = null;
    }
};
function $12dc92f49356566c$var$ml(a) {
    this._internalRoot = a;
}
$12dc92f49356566c$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $12dc92f49356566c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $12dc92f49356566c$var$Qc.length && 0 !== b && b < $12dc92f49356566c$var$Qc[c].priority; c++);
        $12dc92f49356566c$var$Qc.splice(c, 0, a);
        0 === c && $12dc92f49356566c$var$Vc(a);
    }
};
function $12dc92f49356566c$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $12dc92f49356566c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $12dc92f49356566c$var$pl() {}
function $12dc92f49356566c$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $12dc92f49356566c$var$gl(g);
                f.call(a);
            };
        }
        var g = $12dc92f49356566c$var$el(b, d, a, 0, null, !1, !1, "", $12dc92f49356566c$var$pl);
        a._reactRootContainer = g;
        a[$12dc92f49356566c$var$uf] = g.current;
        $12dc92f49356566c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $12dc92f49356566c$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $12dc92f49356566c$var$gl(k);
            h.call(a);
        };
    }
    var k = $12dc92f49356566c$var$bl(a, 0, !1, null, null, !1, !1, "", $12dc92f49356566c$var$pl);
    a._reactRootContainer = k;
    a[$12dc92f49356566c$var$uf] = k.current;
    $12dc92f49356566c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $12dc92f49356566c$var$Rk(function() {
        $12dc92f49356566c$var$fl(b, k, c, d);
    });
    return k;
}
function $12dc92f49356566c$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $12dc92f49356566c$var$gl(g);
                h.call(a);
            };
        }
        $12dc92f49356566c$var$fl(b, g, a, e);
    } else g = $12dc92f49356566c$var$ql(c, b, a, e, d);
    return $12dc92f49356566c$var$gl(g);
}
$12dc92f49356566c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $12dc92f49356566c$var$tc(b.pendingLanes);
                0 !== c && ($12dc92f49356566c$var$Cc(b, c | 1), $12dc92f49356566c$var$Dk(b, $12dc92f49356566c$var$B()), 0 === ($12dc92f49356566c$var$K & 6) && ($12dc92f49356566c$var$Gj = $12dc92f49356566c$var$B() + 500, $12dc92f49356566c$var$jg()));
            }
            break;
        case 13:
            $12dc92f49356566c$var$Rk(function() {
                var b = $12dc92f49356566c$var$ih(a, 1);
                if (null !== b) {
                    var c = $12dc92f49356566c$var$R();
                    $12dc92f49356566c$var$gi(b, a, 1, c);
                }
            }), $12dc92f49356566c$var$il(a, 1);
    }
};
$12dc92f49356566c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $12dc92f49356566c$var$ih(a, 134217728);
        if (null !== b) {
            var c = $12dc92f49356566c$var$R();
            $12dc92f49356566c$var$gi(b, a, 134217728, c);
        }
        $12dc92f49356566c$var$il(a, 134217728);
    }
};
$12dc92f49356566c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $12dc92f49356566c$var$yi(a), c = $12dc92f49356566c$var$ih(a, b);
        if (null !== c) {
            var d = $12dc92f49356566c$var$R();
            $12dc92f49356566c$var$gi(c, a, b, d);
        }
        $12dc92f49356566c$var$il(a, b);
    }
};
$12dc92f49356566c$var$Hc = function() {
    return $12dc92f49356566c$var$C;
};
$12dc92f49356566c$var$Ic = function(a, b) {
    var c = $12dc92f49356566c$var$C;
    try {
        return $12dc92f49356566c$var$C = a, b();
    } finally{
        $12dc92f49356566c$var$C = c;
    }
};
$12dc92f49356566c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $12dc92f49356566c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $12dc92f49356566c$var$Db(d);
                        if (!e) throw Error($12dc92f49356566c$var$p(90));
                        $12dc92f49356566c$var$Wa(d);
                        $12dc92f49356566c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $12dc92f49356566c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $12dc92f49356566c$var$fb(a, !!c.multiple, b, !1);
    }
};
$12dc92f49356566c$var$Gb = $12dc92f49356566c$var$Qk;
$12dc92f49356566c$var$Hb = $12dc92f49356566c$var$Rk;
var $12dc92f49356566c$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $12dc92f49356566c$var$Cb,
        $12dc92f49356566c$var$ue,
        $12dc92f49356566c$var$Db,
        $12dc92f49356566c$var$Eb,
        $12dc92f49356566c$var$Fb,
        $12dc92f49356566c$var$Qk
    ]
}, $12dc92f49356566c$var$tl = {
    findFiberByHostInstance: $12dc92f49356566c$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $12dc92f49356566c$var$ul = {
    bundleType: $12dc92f49356566c$var$tl.bundleType,
    version: $12dc92f49356566c$var$tl.version,
    rendererPackageName: $12dc92f49356566c$var$tl.rendererPackageName,
    rendererConfig: $12dc92f49356566c$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $12dc92f49356566c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $12dc92f49356566c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $12dc92f49356566c$var$tl.findFiberByHostInstance || $12dc92f49356566c$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $12dc92f49356566c$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$12dc92f49356566c$var$vl.isDisabled && $12dc92f49356566c$var$vl.supportsFiber) try {
        $12dc92f49356566c$var$kc = $12dc92f49356566c$var$vl.inject($12dc92f49356566c$var$ul), $12dc92f49356566c$var$lc = $12dc92f49356566c$var$vl;
    } catch (a) {}
}
$12dc92f49356566c$export$ae55be85d98224ed = $12dc92f49356566c$var$sl;
$12dc92f49356566c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$12dc92f49356566c$var$nl(b)) throw Error($12dc92f49356566c$var$p(200));
    return $12dc92f49356566c$var$cl(a, b, null, c);
};
$12dc92f49356566c$export$882461b6382ed46c = function(a, b) {
    if (!$12dc92f49356566c$var$nl(a)) throw Error($12dc92f49356566c$var$p(299));
    var c = !1, d = "", e = $12dc92f49356566c$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $12dc92f49356566c$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$12dc92f49356566c$var$uf] = b.current;
    $12dc92f49356566c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $12dc92f49356566c$var$ll(b);
};
$12dc92f49356566c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($12dc92f49356566c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($12dc92f49356566c$var$p(268, a));
    }
    a = $12dc92f49356566c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$12dc92f49356566c$export$cd75ccfd720a3cd4 = function(a) {
    return $12dc92f49356566c$var$Rk(a);
};
$12dc92f49356566c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$12dc92f49356566c$var$ol(b)) throw Error($12dc92f49356566c$var$p(200));
    return $12dc92f49356566c$var$rl(null, a, b, !0, c);
};
$12dc92f49356566c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$12dc92f49356566c$var$nl(a)) throw Error($12dc92f49356566c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $12dc92f49356566c$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $12dc92f49356566c$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$12dc92f49356566c$var$uf] = b.current;
    $12dc92f49356566c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $12dc92f49356566c$var$ml(b);
};
$12dc92f49356566c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$12dc92f49356566c$var$ol(b)) throw Error($12dc92f49356566c$var$p(200));
    return $12dc92f49356566c$var$rl(null, a, b, !1, c);
};
$12dc92f49356566c$export$502457920280e6be = function(a) {
    if (!$12dc92f49356566c$var$ol(a)) throw Error($12dc92f49356566c$var$p(40));
    return a._reactRootContainer ? ($12dc92f49356566c$var$Rk(function() {
        $12dc92f49356566c$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$12dc92f49356566c$var$uf] = null;
        });
    }), !0) : !1;
};
$12dc92f49356566c$export$c78a37762a8d58e1 = $12dc92f49356566c$var$Qk;
$12dc92f49356566c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$12dc92f49356566c$var$ol(c)) throw Error($12dc92f49356566c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($12dc92f49356566c$var$p(38));
    return $12dc92f49356566c$var$rl(a, b, c, !1, d);
};
$12dc92f49356566c$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRequire.register("aeNmU", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ffFS5"));

});
parcelRequire.register("ffFS5", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $b1a8bc8759033890$export$c4744153514ff05d; }, function (v) { return $b1a8bc8759033890$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $b1a8bc8759033890$export$3e506c1ccc9cc1a7; }, function (v) { return $b1a8bc8759033890$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $b1a8bc8759033890$export$e26fe2ed2fa76875; }, function (v) { return $b1a8bc8759033890$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $b1a8bc8759033890$export$502329bbf4b505b1; }, function (v) { return $b1a8bc8759033890$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $b1a8bc8759033890$export$6e3807111c4874c4; }, function (v) { return $b1a8bc8759033890$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $b1a8bc8759033890$export$c27134553091fb3a; }, function (v) { return $b1a8bc8759033890$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $b1a8bc8759033890$export$33ee1acdc04fd2a2; }, function (v) { return $b1a8bc8759033890$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $b1a8bc8759033890$export$b00a404bbd5edef2; }, function (v) { return $b1a8bc8759033890$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $b1a8bc8759033890$export$8352ce38b91d0c62; }, function (v) { return $b1a8bc8759033890$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $b1a8bc8759033890$export$d66a1c1c77bd778b; }, function (v) { return $b1a8bc8759033890$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $b1a8bc8759033890$export$d3dfb8e4810cb555; }, function (v) { return $b1a8bc8759033890$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $b1a8bc8759033890$export$839f9183b0465a69; }, function (v) { return $b1a8bc8759033890$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $b1a8bc8759033890$export$72fdf0e06517287b; }, function (v) { return $b1a8bc8759033890$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $b1a8bc8759033890$export$4b844e58a3e414b4; }, function (v) { return $b1a8bc8759033890$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $b1a8bc8759033890$export$816d2913ae6b83b1; }, function (v) { return $b1a8bc8759033890$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $b1a8bc8759033890$export$61bcfe829111a1d0; }, function (v) { return $b1a8bc8759033890$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $b1a8bc8759033890$export$7ee8c9beb337bc3f; }, function (v) { return $b1a8bc8759033890$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $b1a8bc8759033890$export$b5836b71941fa3ed; }, function (v) { return $b1a8bc8759033890$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $b1a8bc8759033890$export$cf845f2c119da08a; }, function (v) { return $b1a8bc8759033890$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b1a8bc8759033890$export$c4744153514ff05d;
var $b1a8bc8759033890$export$3e506c1ccc9cc1a7;
var $b1a8bc8759033890$export$e26fe2ed2fa76875;
var $b1a8bc8759033890$export$502329bbf4b505b1;
var $b1a8bc8759033890$export$6e3807111c4874c4;
var $b1a8bc8759033890$export$c27134553091fb3a;
var $b1a8bc8759033890$export$33ee1acdc04fd2a2;
var $b1a8bc8759033890$export$b00a404bbd5edef2;
var $b1a8bc8759033890$export$8352ce38b91d0c62;
var $b1a8bc8759033890$export$d66a1c1c77bd778b;
var $b1a8bc8759033890$export$d3dfb8e4810cb555;
var $b1a8bc8759033890$export$839f9183b0465a69;
var $b1a8bc8759033890$export$72fdf0e06517287b;
var $b1a8bc8759033890$export$4b844e58a3e414b4;
var $b1a8bc8759033890$export$816d2913ae6b83b1;
var $b1a8bc8759033890$export$61bcfe829111a1d0;
var $b1a8bc8759033890$export$7ee8c9beb337bc3f;
var $b1a8bc8759033890$export$b5836b71941fa3ed;
var $b1a8bc8759033890$export$cf845f2c119da08a;
"use strict";
function $b1a8bc8759033890$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $b1a8bc8759033890$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $b1a8bc8759033890$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $b1a8bc8759033890$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $b1a8bc8759033890$var$g(C, c)) n < e && 0 > $b1a8bc8759033890$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $b1a8bc8759033890$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $b1a8bc8759033890$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b1a8bc8759033890$var$l = performance;
    $b1a8bc8759033890$export$c4744153514ff05d = function() {
        return $b1a8bc8759033890$var$l.now();
    };
} else {
    var $b1a8bc8759033890$var$p = Date, $b1a8bc8759033890$var$q = $b1a8bc8759033890$var$p.now();
    $b1a8bc8759033890$export$c4744153514ff05d = function() {
        return $b1a8bc8759033890$var$p.now() - $b1a8bc8759033890$var$q;
    };
}
var $b1a8bc8759033890$var$r = [], $b1a8bc8759033890$var$t = [], $b1a8bc8759033890$var$u = 1, $b1a8bc8759033890$var$v = null, $b1a8bc8759033890$var$y = 3, $b1a8bc8759033890$var$z = !1, $b1a8bc8759033890$var$A = !1, $b1a8bc8759033890$var$B = !1, $b1a8bc8759033890$var$D = "function" === typeof setTimeout ? setTimeout : null, $b1a8bc8759033890$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $b1a8bc8759033890$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $b1a8bc8759033890$var$G(a) {
    for(var b = $b1a8bc8759033890$var$h($b1a8bc8759033890$var$t); null !== b;){
        if (null === b.callback) $b1a8bc8759033890$var$k($b1a8bc8759033890$var$t);
        else if (b.startTime <= a) $b1a8bc8759033890$var$k($b1a8bc8759033890$var$t), b.sortIndex = b.expirationTime, $b1a8bc8759033890$var$f($b1a8bc8759033890$var$r, b);
        else break;
        b = $b1a8bc8759033890$var$h($b1a8bc8759033890$var$t);
    }
}
function $b1a8bc8759033890$var$H(a) {
    $b1a8bc8759033890$var$B = !1;
    $b1a8bc8759033890$var$G(a);
    if (!$b1a8bc8759033890$var$A) {
        if (null !== $b1a8bc8759033890$var$h($b1a8bc8759033890$var$r)) $b1a8bc8759033890$var$A = !0, $b1a8bc8759033890$var$I($b1a8bc8759033890$var$J);
        else {
            var b = $b1a8bc8759033890$var$h($b1a8bc8759033890$var$t);
            null !== b && $b1a8bc8759033890$var$K($b1a8bc8759033890$var$H, b.startTime - a);
        }
    }
}
function $b1a8bc8759033890$var$J(a, b) {
    $b1a8bc8759033890$var$A = !1;
    $b1a8bc8759033890$var$B && ($b1a8bc8759033890$var$B = !1, $b1a8bc8759033890$var$E($b1a8bc8759033890$var$L), $b1a8bc8759033890$var$L = -1);
    $b1a8bc8759033890$var$z = !0;
    var c = $b1a8bc8759033890$var$y;
    try {
        $b1a8bc8759033890$var$G(b);
        for($b1a8bc8759033890$var$v = $b1a8bc8759033890$var$h($b1a8bc8759033890$var$r); null !== $b1a8bc8759033890$var$v && (!($b1a8bc8759033890$var$v.expirationTime > b) || a && !$b1a8bc8759033890$var$M());){
            var d = $b1a8bc8759033890$var$v.callback;
            if ("function" === typeof d) {
                $b1a8bc8759033890$var$v.callback = null;
                $b1a8bc8759033890$var$y = $b1a8bc8759033890$var$v.priorityLevel;
                var e = d($b1a8bc8759033890$var$v.expirationTime <= b);
                b = $b1a8bc8759033890$export$c4744153514ff05d();
                "function" === typeof e ? $b1a8bc8759033890$var$v.callback = e : $b1a8bc8759033890$var$v === $b1a8bc8759033890$var$h($b1a8bc8759033890$var$r) && $b1a8bc8759033890$var$k($b1a8bc8759033890$var$r);
                $b1a8bc8759033890$var$G(b);
            } else $b1a8bc8759033890$var$k($b1a8bc8759033890$var$r);
            $b1a8bc8759033890$var$v = $b1a8bc8759033890$var$h($b1a8bc8759033890$var$r);
        }
        if (null !== $b1a8bc8759033890$var$v) var w = !0;
        else {
            var m = $b1a8bc8759033890$var$h($b1a8bc8759033890$var$t);
            null !== m && $b1a8bc8759033890$var$K($b1a8bc8759033890$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $b1a8bc8759033890$var$v = null, $b1a8bc8759033890$var$y = c, $b1a8bc8759033890$var$z = !1;
    }
}
var $b1a8bc8759033890$var$N = !1, $b1a8bc8759033890$var$O = null, $b1a8bc8759033890$var$L = -1, $b1a8bc8759033890$var$P = 5, $b1a8bc8759033890$var$Q = -1;
function $b1a8bc8759033890$var$M() {
    return $b1a8bc8759033890$export$c4744153514ff05d() - $b1a8bc8759033890$var$Q < $b1a8bc8759033890$var$P ? !1 : !0;
}
function $b1a8bc8759033890$var$R() {
    if (null !== $b1a8bc8759033890$var$O) {
        var a = $b1a8bc8759033890$export$c4744153514ff05d();
        $b1a8bc8759033890$var$Q = a;
        var b = !0;
        try {
            b = $b1a8bc8759033890$var$O(!0, a);
        } finally{
            b ? $b1a8bc8759033890$var$S() : ($b1a8bc8759033890$var$N = !1, $b1a8bc8759033890$var$O = null);
        }
    } else $b1a8bc8759033890$var$N = !1;
}
var $b1a8bc8759033890$var$S;
if ("function" === typeof $b1a8bc8759033890$var$F) $b1a8bc8759033890$var$S = function() {
    $b1a8bc8759033890$var$F($b1a8bc8759033890$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b1a8bc8759033890$var$T = new MessageChannel, $b1a8bc8759033890$var$U = $b1a8bc8759033890$var$T.port2;
    $b1a8bc8759033890$var$T.port1.onmessage = $b1a8bc8759033890$var$R;
    $b1a8bc8759033890$var$S = function() {
        $b1a8bc8759033890$var$U.postMessage(null);
    };
} else $b1a8bc8759033890$var$S = function() {
    $b1a8bc8759033890$var$D($b1a8bc8759033890$var$R, 0);
};
function $b1a8bc8759033890$var$I(a) {
    $b1a8bc8759033890$var$O = a;
    $b1a8bc8759033890$var$N || ($b1a8bc8759033890$var$N = !0, $b1a8bc8759033890$var$S());
}
function $b1a8bc8759033890$var$K(a, b) {
    $b1a8bc8759033890$var$L = $b1a8bc8759033890$var$D(function() {
        a($b1a8bc8759033890$export$c4744153514ff05d());
    }, b);
}
$b1a8bc8759033890$export$3e506c1ccc9cc1a7 = 5;
$b1a8bc8759033890$export$e26fe2ed2fa76875 = 1;
$b1a8bc8759033890$export$502329bbf4b505b1 = 4;
$b1a8bc8759033890$export$6e3807111c4874c4 = 3;
$b1a8bc8759033890$export$c27134553091fb3a = null;
$b1a8bc8759033890$export$33ee1acdc04fd2a2 = 2;
$b1a8bc8759033890$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$b1a8bc8759033890$export$8352ce38b91d0c62 = function() {
    $b1a8bc8759033890$var$A || $b1a8bc8759033890$var$z || ($b1a8bc8759033890$var$A = !0, $b1a8bc8759033890$var$I($b1a8bc8759033890$var$J));
};
$b1a8bc8759033890$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b1a8bc8759033890$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$b1a8bc8759033890$export$d3dfb8e4810cb555 = function() {
    return $b1a8bc8759033890$var$y;
};
$b1a8bc8759033890$export$839f9183b0465a69 = function() {
    return $b1a8bc8759033890$var$h($b1a8bc8759033890$var$r);
};
$b1a8bc8759033890$export$72fdf0e06517287b = function(a) {
    switch($b1a8bc8759033890$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $b1a8bc8759033890$var$y;
    }
    var c = $b1a8bc8759033890$var$y;
    $b1a8bc8759033890$var$y = b;
    try {
        return a();
    } finally{
        $b1a8bc8759033890$var$y = c;
    }
};
$b1a8bc8759033890$export$4b844e58a3e414b4 = function() {};
$b1a8bc8759033890$export$816d2913ae6b83b1 = function() {};
$b1a8bc8759033890$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $b1a8bc8759033890$var$y;
    $b1a8bc8759033890$var$y = a;
    try {
        return b();
    } finally{
        $b1a8bc8759033890$var$y = c;
    }
};
$b1a8bc8759033890$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $b1a8bc8759033890$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $b1a8bc8759033890$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $b1a8bc8759033890$var$f($b1a8bc8759033890$var$t, a), null === $b1a8bc8759033890$var$h($b1a8bc8759033890$var$r) && a === $b1a8bc8759033890$var$h($b1a8bc8759033890$var$t) && ($b1a8bc8759033890$var$B ? ($b1a8bc8759033890$var$E($b1a8bc8759033890$var$L), $b1a8bc8759033890$var$L = -1) : $b1a8bc8759033890$var$B = !0, $b1a8bc8759033890$var$K($b1a8bc8759033890$var$H, c - d))) : (a.sortIndex = e, $b1a8bc8759033890$var$f($b1a8bc8759033890$var$r, a), $b1a8bc8759033890$var$A || $b1a8bc8759033890$var$z || ($b1a8bc8759033890$var$A = !0, $b1a8bc8759033890$var$I($b1a8bc8759033890$var$J)));
    return a;
};
$b1a8bc8759033890$export$b5836b71941fa3ed = $b1a8bc8759033890$var$M;
$b1a8bc8759033890$export$cf845f2c119da08a = function(a) {
    var b = $b1a8bc8759033890$var$y;
    return function() {
        var c = $b1a8bc8759033890$var$y;
        $b1a8bc8759033890$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $b1a8bc8759033890$var$y = c;
        }
    };
};

});



parcelRequire.register("lfOSa", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $f79275f3dd0c4438$export$2b8d127b894957b9; }, function (v) { return $f79275f3dd0c4438$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $f79275f3dd0c4438$export$cea3a54a6425200c; }, function (v) { return $f79275f3dd0c4438$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $f79275f3dd0c4438$export$a7c73072b1a182ae; }, function (v) { return $f79275f3dd0c4438$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $f79275f3dd0c4438$export$9f27bc3417b4524d; }, function (v) { return $f79275f3dd0c4438$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $f79275f3dd0c4438$export$db77ccec0bb4ccac; }, function (v) { return $f79275f3dd0c4438$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $f79275f3dd0c4438$export$8392c0c9d3dcbd35; }, function (v) { return $f79275f3dd0c4438$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f79275f3dd0c4438$export$ffb0004e005737fa; }, function (v) { return $f79275f3dd0c4438$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $f79275f3dd0c4438$export$b624eff549462981; }, function (v) { return $f79275f3dd0c4438$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $f79275f3dd0c4438$export$7897aa7841a5380c; }, function (v) { return $f79275f3dd0c4438$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $f79275f3dd0c4438$export$602eac185826482c; }, function (v) { return $f79275f3dd0c4438$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $f79275f3dd0c4438$export$e2c29f18771995cb; }, function (v) { return $f79275f3dd0c4438$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f79275f3dd0c4438$export$5f8d39834fd61797; }, function (v) { return $f79275f3dd0c4438$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f79275f3dd0c4438$export$74bf444e3cd11ea5; }, function (v) { return $f79275f3dd0c4438$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $f79275f3dd0c4438$export$92387174baf9b227; }, function (v) { return $f79275f3dd0c4438$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $f79275f3dd0c4438$export$ec112efeb987d9c6; }, function (v) { return $f79275f3dd0c4438$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $f79275f3dd0c4438$export$b706b080d889d2c9; }, function (v) { return $f79275f3dd0c4438$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $f79275f3dd0c4438$export$5be5a87408f70ddc; }, function (v) { return $f79275f3dd0c4438$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $f79275f3dd0c4438$export$45a5e7f76e0caa8d; }, function (v) { return $f79275f3dd0c4438$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $f79275f3dd0c4438$export$455c2e768291efa6; }, function (v) { return $f79275f3dd0c4438$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $f79275f3dd0c4438$export$9522e17588c12572; }, function (v) { return $f79275f3dd0c4438$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $f79275f3dd0c4438$export$2110ac352bb060b9; }, function (v) { return $f79275f3dd0c4438$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $f79275f3dd0c4438$export$56885ab8b9c456ab; }, function (v) { return $f79275f3dd0c4438$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $f79275f3dd0c4438$export$d927fcb6adf8f9de; }, function (v) { return $f79275f3dd0c4438$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $f79275f3dd0c4438$export$b82d16f27459e05a; }, function (v) { return $f79275f3dd0c4438$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $f79275f3dd0c4438$export$522c17b4f5e123e8; }, function (v) { return $f79275f3dd0c4438$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $f79275f3dd0c4438$export$1aabd8a0274ecfd6; }, function (v) { return $f79275f3dd0c4438$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $f79275f3dd0c4438$export$9b621391a187a31a; }, function (v) { return $f79275f3dd0c4438$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $f79275f3dd0c4438$export$f5bbd400c2f4426f; }, function (v) { return $f79275f3dd0c4438$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f79275f3dd0c4438$export$2b8d127b894957b9;
var $f79275f3dd0c4438$export$cea3a54a6425200c;
var $f79275f3dd0c4438$export$a7c73072b1a182ae;
var $f79275f3dd0c4438$export$9f27bc3417b4524d;
var $f79275f3dd0c4438$export$db77ccec0bb4ccac;
var $f79275f3dd0c4438$export$8392c0c9d3dcbd35;
var $f79275f3dd0c4438$export$ffb0004e005737fa;
var $f79275f3dd0c4438$export$b624eff549462981;
var $f79275f3dd0c4438$export$7897aa7841a5380c;
var $f79275f3dd0c4438$export$602eac185826482c;
var $f79275f3dd0c4438$export$e2c29f18771995cb;
var $f79275f3dd0c4438$export$5f8d39834fd61797;
var $f79275f3dd0c4438$export$74bf444e3cd11ea5;
var $f79275f3dd0c4438$export$92387174baf9b227;
var $f79275f3dd0c4438$export$ec112efeb987d9c6;
var $f79275f3dd0c4438$export$b706b080d889d2c9;
var $f79275f3dd0c4438$export$5be5a87408f70ddc;
var $f79275f3dd0c4438$export$45a5e7f76e0caa8d;
var $f79275f3dd0c4438$export$455c2e768291efa6;
var $f79275f3dd0c4438$export$9522e17588c12572;
var $f79275f3dd0c4438$export$2110ac352bb060b9;
var $f79275f3dd0c4438$export$56885ab8b9c456ab;
var $f79275f3dd0c4438$export$d927fcb6adf8f9de;
var $f79275f3dd0c4438$export$b82d16f27459e05a;
var $f79275f3dd0c4438$export$522c17b4f5e123e8;
var $f79275f3dd0c4438$export$1aabd8a0274ecfd6;
var $f79275f3dd0c4438$export$9b621391a187a31a;
var $f79275f3dd0c4438$export$f5bbd400c2f4426f;
"use strict";
var $f79275f3dd0c4438$var$b = "function" === typeof Symbol && Symbol.for, $f79275f3dd0c4438$var$c = $f79275f3dd0c4438$var$b ? Symbol.for("react.element") : 60103, $f79275f3dd0c4438$var$d = $f79275f3dd0c4438$var$b ? Symbol.for("react.portal") : 60106, $f79275f3dd0c4438$var$e = $f79275f3dd0c4438$var$b ? Symbol.for("react.fragment") : 60107, $f79275f3dd0c4438$var$f = $f79275f3dd0c4438$var$b ? Symbol.for("react.strict_mode") : 60108, $f79275f3dd0c4438$var$g = $f79275f3dd0c4438$var$b ? Symbol.for("react.profiler") : 60114, $f79275f3dd0c4438$var$h = $f79275f3dd0c4438$var$b ? Symbol.for("react.provider") : 60109, $f79275f3dd0c4438$var$k = $f79275f3dd0c4438$var$b ? Symbol.for("react.context") : 60110, $f79275f3dd0c4438$var$l = $f79275f3dd0c4438$var$b ? Symbol.for("react.async_mode") : 60111, $f79275f3dd0c4438$var$m = $f79275f3dd0c4438$var$b ? Symbol.for("react.concurrent_mode") : 60111, $f79275f3dd0c4438$var$n = $f79275f3dd0c4438$var$b ? Symbol.for("react.forward_ref") : 60112, $f79275f3dd0c4438$var$p = $f79275f3dd0c4438$var$b ? Symbol.for("react.suspense") : 60113, $f79275f3dd0c4438$var$q = $f79275f3dd0c4438$var$b ? Symbol.for("react.suspense_list") : 60120, $f79275f3dd0c4438$var$r = $f79275f3dd0c4438$var$b ? Symbol.for("react.memo") : 60115, $f79275f3dd0c4438$var$t = $f79275f3dd0c4438$var$b ? Symbol.for("react.lazy") : 60116, $f79275f3dd0c4438$var$v = $f79275f3dd0c4438$var$b ? Symbol.for("react.block") : 60121, $f79275f3dd0c4438$var$w = $f79275f3dd0c4438$var$b ? Symbol.for("react.fundamental") : 60117, $f79275f3dd0c4438$var$x = $f79275f3dd0c4438$var$b ? Symbol.for("react.responder") : 60118, $f79275f3dd0c4438$var$y = $f79275f3dd0c4438$var$b ? Symbol.for("react.scope") : 60119;
function $f79275f3dd0c4438$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $f79275f3dd0c4438$var$c:
                switch(a = a.type, a){
                    case $f79275f3dd0c4438$var$l:
                    case $f79275f3dd0c4438$var$m:
                    case $f79275f3dd0c4438$var$e:
                    case $f79275f3dd0c4438$var$g:
                    case $f79275f3dd0c4438$var$f:
                    case $f79275f3dd0c4438$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $f79275f3dd0c4438$var$k:
                            case $f79275f3dd0c4438$var$n:
                            case $f79275f3dd0c4438$var$t:
                            case $f79275f3dd0c4438$var$r:
                            case $f79275f3dd0c4438$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $f79275f3dd0c4438$var$d:
                return u;
        }
    }
}
function $f79275f3dd0c4438$var$A(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$m;
}
$f79275f3dd0c4438$export$2b8d127b894957b9 = $f79275f3dd0c4438$var$l;
$f79275f3dd0c4438$export$cea3a54a6425200c = $f79275f3dd0c4438$var$m;
$f79275f3dd0c4438$export$a7c73072b1a182ae = $f79275f3dd0c4438$var$k;
$f79275f3dd0c4438$export$9f27bc3417b4524d = $f79275f3dd0c4438$var$h;
$f79275f3dd0c4438$export$db77ccec0bb4ccac = $f79275f3dd0c4438$var$c;
$f79275f3dd0c4438$export$8392c0c9d3dcbd35 = $f79275f3dd0c4438$var$n;
$f79275f3dd0c4438$export$ffb0004e005737fa = $f79275f3dd0c4438$var$e;
$f79275f3dd0c4438$export$b624eff549462981 = $f79275f3dd0c4438$var$t;
$f79275f3dd0c4438$export$7897aa7841a5380c = $f79275f3dd0c4438$var$r;
$f79275f3dd0c4438$export$602eac185826482c = $f79275f3dd0c4438$var$d;
$f79275f3dd0c4438$export$e2c29f18771995cb = $f79275f3dd0c4438$var$g;
$f79275f3dd0c4438$export$5f8d39834fd61797 = $f79275f3dd0c4438$var$f;
$f79275f3dd0c4438$export$74bf444e3cd11ea5 = $f79275f3dd0c4438$var$p;
$f79275f3dd0c4438$export$92387174baf9b227 = function(a) {
    return $f79275f3dd0c4438$var$A(a) || $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$l;
};
$f79275f3dd0c4438$export$ec112efeb987d9c6 = $f79275f3dd0c4438$var$A;
$f79275f3dd0c4438$export$b706b080d889d2c9 = function(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$k;
};
$f79275f3dd0c4438$export$5be5a87408f70ddc = function(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$h;
};
$f79275f3dd0c4438$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f79275f3dd0c4438$var$c;
};
$f79275f3dd0c4438$export$455c2e768291efa6 = function(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$n;
};
$f79275f3dd0c4438$export$9522e17588c12572 = function(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$e;
};
$f79275f3dd0c4438$export$2110ac352bb060b9 = function(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$t;
};
$f79275f3dd0c4438$export$56885ab8b9c456ab = function(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$r;
};
$f79275f3dd0c4438$export$d927fcb6adf8f9de = function(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$d;
};
$f79275f3dd0c4438$export$b82d16f27459e05a = function(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$g;
};
$f79275f3dd0c4438$export$522c17b4f5e123e8 = function(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$f;
};
$f79275f3dd0c4438$export$1aabd8a0274ecfd6 = function(a) {
    return $f79275f3dd0c4438$var$z(a) === $f79275f3dd0c4438$var$p;
};
$f79275f3dd0c4438$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $f79275f3dd0c4438$var$e || a === $f79275f3dd0c4438$var$m || a === $f79275f3dd0c4438$var$g || a === $f79275f3dd0c4438$var$f || a === $f79275f3dd0c4438$var$p || a === $f79275f3dd0c4438$var$q || "object" === typeof a && null !== a && (a.$$typeof === $f79275f3dd0c4438$var$t || a.$$typeof === $f79275f3dd0c4438$var$r || a.$$typeof === $f79275f3dd0c4438$var$h || a.$$typeof === $f79275f3dd0c4438$var$k || a.$$typeof === $f79275f3dd0c4438$var$n || a.$$typeof === $f79275f3dd0c4438$var$w || a.$$typeof === $f79275f3dd0c4438$var$x || a.$$typeof === $f79275f3dd0c4438$var$y || a.$$typeof === $f79275f3dd0c4438$var$v);
};
$f79275f3dd0c4438$export$f5bbd400c2f4426f = $f79275f3dd0c4438$var$z;

});

parcelRequire.register("16Ekm", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $0ce5a227a530be63$export$a7c73072b1a182ae; }, function (v) { return $0ce5a227a530be63$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $0ce5a227a530be63$export$9f27bc3417b4524d; }, function (v) { return $0ce5a227a530be63$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $0ce5a227a530be63$export$db77ccec0bb4ccac; }, function (v) { return $0ce5a227a530be63$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $0ce5a227a530be63$export$8392c0c9d3dcbd35; }, function (v) { return $0ce5a227a530be63$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0ce5a227a530be63$export$ffb0004e005737fa; }, function (v) { return $0ce5a227a530be63$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $0ce5a227a530be63$export$b624eff549462981; }, function (v) { return $0ce5a227a530be63$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $0ce5a227a530be63$export$7897aa7841a5380c; }, function (v) { return $0ce5a227a530be63$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $0ce5a227a530be63$export$602eac185826482c; }, function (v) { return $0ce5a227a530be63$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $0ce5a227a530be63$export$e2c29f18771995cb; }, function (v) { return $0ce5a227a530be63$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0ce5a227a530be63$export$5f8d39834fd61797; }, function (v) { return $0ce5a227a530be63$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0ce5a227a530be63$export$74bf444e3cd11ea5; }, function (v) { return $0ce5a227a530be63$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $0ce5a227a530be63$export$998bcd577473dd93; }, function (v) { return $0ce5a227a530be63$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $0ce5a227a530be63$export$92387174baf9b227; }, function (v) { return $0ce5a227a530be63$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $0ce5a227a530be63$export$ec112efeb987d9c6; }, function (v) { return $0ce5a227a530be63$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $0ce5a227a530be63$export$b706b080d889d2c9; }, function (v) { return $0ce5a227a530be63$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $0ce5a227a530be63$export$5be5a87408f70ddc; }, function (v) { return $0ce5a227a530be63$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $0ce5a227a530be63$export$45a5e7f76e0caa8d; }, function (v) { return $0ce5a227a530be63$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $0ce5a227a530be63$export$455c2e768291efa6; }, function (v) { return $0ce5a227a530be63$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $0ce5a227a530be63$export$9522e17588c12572; }, function (v) { return $0ce5a227a530be63$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $0ce5a227a530be63$export$2110ac352bb060b9; }, function (v) { return $0ce5a227a530be63$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $0ce5a227a530be63$export$56885ab8b9c456ab; }, function (v) { return $0ce5a227a530be63$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $0ce5a227a530be63$export$d927fcb6adf8f9de; }, function (v) { return $0ce5a227a530be63$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $0ce5a227a530be63$export$b82d16f27459e05a; }, function (v) { return $0ce5a227a530be63$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $0ce5a227a530be63$export$522c17b4f5e123e8; }, function (v) { return $0ce5a227a530be63$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $0ce5a227a530be63$export$1aabd8a0274ecfd6; }, function (v) { return $0ce5a227a530be63$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $0ce5a227a530be63$export$3d6c20d97e46b957; }, function (v) { return $0ce5a227a530be63$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $0ce5a227a530be63$export$9b621391a187a31a; }, function (v) { return $0ce5a227a530be63$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $0ce5a227a530be63$export$f5bbd400c2f4426f; }, function (v) { return $0ce5a227a530be63$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0ce5a227a530be63$export$a7c73072b1a182ae;
var $0ce5a227a530be63$export$9f27bc3417b4524d;
var $0ce5a227a530be63$export$db77ccec0bb4ccac;
var $0ce5a227a530be63$export$8392c0c9d3dcbd35;
var $0ce5a227a530be63$export$ffb0004e005737fa;
var $0ce5a227a530be63$export$b624eff549462981;
var $0ce5a227a530be63$export$7897aa7841a5380c;
var $0ce5a227a530be63$export$602eac185826482c;
var $0ce5a227a530be63$export$e2c29f18771995cb;
var $0ce5a227a530be63$export$5f8d39834fd61797;
var $0ce5a227a530be63$export$74bf444e3cd11ea5;
var $0ce5a227a530be63$export$998bcd577473dd93;
var $0ce5a227a530be63$export$92387174baf9b227;
var $0ce5a227a530be63$export$ec112efeb987d9c6;
var $0ce5a227a530be63$export$b706b080d889d2c9;
var $0ce5a227a530be63$export$5be5a87408f70ddc;
var $0ce5a227a530be63$export$45a5e7f76e0caa8d;
var $0ce5a227a530be63$export$455c2e768291efa6;
var $0ce5a227a530be63$export$9522e17588c12572;
var $0ce5a227a530be63$export$2110ac352bb060b9;
var $0ce5a227a530be63$export$56885ab8b9c456ab;
var $0ce5a227a530be63$export$d927fcb6adf8f9de;
var $0ce5a227a530be63$export$b82d16f27459e05a;
var $0ce5a227a530be63$export$522c17b4f5e123e8;
var $0ce5a227a530be63$export$1aabd8a0274ecfd6;
var $0ce5a227a530be63$export$3d6c20d97e46b957;
var $0ce5a227a530be63$export$9b621391a187a31a;
var $0ce5a227a530be63$export$f5bbd400c2f4426f;
"use strict";
var $0ce5a227a530be63$var$b = Symbol.for("react.element"), $0ce5a227a530be63$var$c = Symbol.for("react.portal"), $0ce5a227a530be63$var$d = Symbol.for("react.fragment"), $0ce5a227a530be63$var$e = Symbol.for("react.strict_mode"), $0ce5a227a530be63$var$f = Symbol.for("react.profiler"), $0ce5a227a530be63$var$g = Symbol.for("react.provider"), $0ce5a227a530be63$var$h = Symbol.for("react.context"), $0ce5a227a530be63$var$k = Symbol.for("react.server_context"), $0ce5a227a530be63$var$l = Symbol.for("react.forward_ref"), $0ce5a227a530be63$var$m = Symbol.for("react.suspense"), $0ce5a227a530be63$var$n = Symbol.for("react.suspense_list"), $0ce5a227a530be63$var$p = Symbol.for("react.memo"), $0ce5a227a530be63$var$q = Symbol.for("react.lazy"), $0ce5a227a530be63$var$t = Symbol.for("react.offscreen"), $0ce5a227a530be63$var$u;
$0ce5a227a530be63$var$u = Symbol.for("react.module.reference");
function $0ce5a227a530be63$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $0ce5a227a530be63$var$b:
                switch(a = a.type, a){
                    case $0ce5a227a530be63$var$d:
                    case $0ce5a227a530be63$var$f:
                    case $0ce5a227a530be63$var$e:
                    case $0ce5a227a530be63$var$m:
                    case $0ce5a227a530be63$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $0ce5a227a530be63$var$k:
                            case $0ce5a227a530be63$var$h:
                            case $0ce5a227a530be63$var$l:
                            case $0ce5a227a530be63$var$q:
                            case $0ce5a227a530be63$var$p:
                            case $0ce5a227a530be63$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $0ce5a227a530be63$var$c:
                return r;
        }
    }
}
$0ce5a227a530be63$export$a7c73072b1a182ae = $0ce5a227a530be63$var$h;
$0ce5a227a530be63$export$9f27bc3417b4524d = $0ce5a227a530be63$var$g;
$0ce5a227a530be63$export$db77ccec0bb4ccac = $0ce5a227a530be63$var$b;
$0ce5a227a530be63$export$8392c0c9d3dcbd35 = $0ce5a227a530be63$var$l;
$0ce5a227a530be63$export$ffb0004e005737fa = $0ce5a227a530be63$var$d;
$0ce5a227a530be63$export$b624eff549462981 = $0ce5a227a530be63$var$q;
$0ce5a227a530be63$export$7897aa7841a5380c = $0ce5a227a530be63$var$p;
$0ce5a227a530be63$export$602eac185826482c = $0ce5a227a530be63$var$c;
$0ce5a227a530be63$export$e2c29f18771995cb = $0ce5a227a530be63$var$f;
$0ce5a227a530be63$export$5f8d39834fd61797 = $0ce5a227a530be63$var$e;
$0ce5a227a530be63$export$74bf444e3cd11ea5 = $0ce5a227a530be63$var$m;
$0ce5a227a530be63$export$998bcd577473dd93 = $0ce5a227a530be63$var$n;
$0ce5a227a530be63$export$92387174baf9b227 = function() {
    return !1;
};
$0ce5a227a530be63$export$ec112efeb987d9c6 = function() {
    return !1;
};
$0ce5a227a530be63$export$b706b080d889d2c9 = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$h;
};
$0ce5a227a530be63$export$5be5a87408f70ddc = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$g;
};
$0ce5a227a530be63$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0ce5a227a530be63$var$b;
};
$0ce5a227a530be63$export$455c2e768291efa6 = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$l;
};
$0ce5a227a530be63$export$9522e17588c12572 = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$d;
};
$0ce5a227a530be63$export$2110ac352bb060b9 = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$q;
};
$0ce5a227a530be63$export$56885ab8b9c456ab = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$p;
};
$0ce5a227a530be63$export$d927fcb6adf8f9de = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$c;
};
$0ce5a227a530be63$export$b82d16f27459e05a = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$f;
};
$0ce5a227a530be63$export$522c17b4f5e123e8 = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$e;
};
$0ce5a227a530be63$export$1aabd8a0274ecfd6 = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$m;
};
$0ce5a227a530be63$export$3d6c20d97e46b957 = function(a) {
    return $0ce5a227a530be63$var$v(a) === $0ce5a227a530be63$var$n;
};
$0ce5a227a530be63$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $0ce5a227a530be63$var$d || a === $0ce5a227a530be63$var$f || a === $0ce5a227a530be63$var$e || a === $0ce5a227a530be63$var$m || a === $0ce5a227a530be63$var$n || a === $0ce5a227a530be63$var$t || "object" === typeof a && null !== a && (a.$$typeof === $0ce5a227a530be63$var$q || a.$$typeof === $0ce5a227a530be63$var$p || a.$$typeof === $0ce5a227a530be63$var$g || a.$$typeof === $0ce5a227a530be63$var$h || a.$$typeof === $0ce5a227a530be63$var$l || a.$$typeof === $0ce5a227a530be63$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$0ce5a227a530be63$export$f5bbd400c2f4426f = $0ce5a227a530be63$var$v;

});

parcelRequire.register("irtyR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5YV4M.default;
    }
});

var $5YV4M = parcelRequire("5YV4M");

});
parcelRequire.register("5YV4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45aed47c3c48d484$export$2e2bcd8739ae039; });

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");

var $jxoUN = parcelRequire("jxoUN");

var $gWMia = parcelRequire("gWMia");
function $45aed47c3c48d484$export$2e2bcd8739ae039(path, displayName) {
    const Component = (props, ref)=>/*#__PURE__*/ (0, $gWMia.jsx)((0, $jxoUN.default), (0, $9YD4s.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    Component.muiName = (0, $jxoUN.default).muiName;
    return /*#__PURE__*/ $4lkrv.memo(/*#__PURE__*/ $4lkrv.forwardRef(Component));
}

});
parcelRequire.register("9YD4s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74380652bae9a580$export$2e2bcd8739ae039; });
function $74380652bae9a580$export$2e2bcd8739ae039() {
    $74380652bae9a580$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $74380652bae9a580$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("jxoUN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3946cfc6824b204$export$2e2bcd8739ae039; });

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $lJkvk = parcelRequire("lJkvk");

var $at7OG = parcelRequire("at7OG");

var $bgnZl = parcelRequire("bgnZl");

var $3o6xx = parcelRequire("3o6xx");

var $gWMia = parcelRequire("gWMia");
const $e3946cfc6824b204$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $e3946cfc6824b204$var$useUtilityClasses = (ownerState)=>{
    const { color: color , fontSize: fontSize , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $lJkvk.default)(color)}`,
            `fontSize${(0, $lJkvk.default)(fontSize)}`
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $3o6xx.getSvgIconUtilityClass), classes);
};
const $e3946cfc6824b204$var$SvgIconRoot = (0, $bgnZl.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $lJkvk.default)(ownerState.color)}`],
            styles[`fontSize${(0, $lJkvk.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fill: "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $e3946cfc6824b204$var$SvgIcon = /*#__PURE__*/ $4lkrv.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children , className: className , color: color = "inherit" , component: component = "svg" , fontSize: fontSize = "medium" , htmlColor: htmlColor , inheritViewBox: inheritViewBox = false , titleAccess: titleAccess , viewBox: viewBox = "0 0 24 24"  } = props, other = (0, $eLWn9.default)(props, $e3946cfc6824b204$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $e3946cfc6824b204$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsxs)($e3946cfc6824b204$var$SvgIconRoot, (0, $9YD4s.default)({
        as: component,
        className: (0, $iB56s.default)(classes.root, className),
        ownerState: ownerState,
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, {
        children: [
            children,
            titleAccess ? /*#__PURE__*/ (0, $gWMia.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$e3946cfc6824b204$var$SvgIcon.muiName = "SvgIcon";
var $e3946cfc6824b204$export$2e2bcd8739ae039 = $e3946cfc6824b204$var$SvgIcon;

});
parcelRequire.register("eLWn9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac12bc03bfd5574f$export$2e2bcd8739ae039; });
function $ac12bc03bfd5574f$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("iB56s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d89fa4125c956d02$export$2e2bcd8739ae039; });
function $d89fa4125c956d02$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $d89fa4125c956d02$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $d89fa4125c956d02$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $d89fa4125c956d02$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $d89fa4125c956d02$export$2e2bcd8739ae039 = $d89fa4125c956d02$export$4f5d2d50c9deca37;

});

parcelRequire.register("kdLbD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb899fd5497e98c3$export$2e2bcd8739ae039; });
function $eb899fd5497e98c3$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRequire.register("lJkvk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd1db4adb66e9839$export$2e2bcd8739ae039; });

var $1Z8IT = parcelRequire("1Z8IT");
var $fd1db4adb66e9839$export$2e2bcd8739ae039 = (0, $1Z8IT.default);

});
parcelRequire.register("1Z8IT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1722412aea7b1913$export$2e2bcd8739ae039; });

var $gp8jy = parcelRequire("gp8jy");
function $1722412aea7b1913$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $gp8jy.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRequire.register("gp8jy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf156e36f10b0cb4$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $bf156e36f10b0cb4$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRequire.register("at7OG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79f2ad0281214ae5$export$2e2bcd8739ae039; });

var $bS3WL = parcelRequire("bS3WL");

var $ksq4v = parcelRequire("ksq4v");
function $79f2ad0281214ae5$export$2e2bcd8739ae039({ props: props , name: name  }) {
    return (0, $bS3WL.default)({
        props: props,
        name: name,
        defaultTheme: $ksq4v.default
    });
}

});
parcelRequire.register("bS3WL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a47cc9d8604b8c8$export$2e2bcd8739ae039; });

var $goj8c = parcelRequire("goj8c");

var $4pME4 = parcelRequire("4pME4");
function $8a47cc9d8604b8c8$export$2e2bcd8739ae039({ props: props , name: name , defaultTheme: defaultTheme , themeId: themeId  }) {
    let theme = (0, $4pME4.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $goj8c.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRequire.register("goj8c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beedba4e0752ccd8$export$2e2bcd8739ae039; });

var $8Ksxr = parcelRequire("8Ksxr");
function $beedba4e0752ccd8$export$2e2bcd8739ae039(params) {
    const { theme: theme , name: name , props: props  } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $8Ksxr.default)(theme.components[name].defaultProps, props);
}

});
parcelRequire.register("8Ksxr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65e8c1babb544d2f$export$2e2bcd8739ae039; });

var $9YD4s = parcelRequire("9YD4s");
function $65e8c1babb544d2f$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $9YD4s.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $9YD4s.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $9YD4s.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $65e8c1babb544d2f$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRequire.register("4pME4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $336f3b30f6381c5a$export$2e2bcd8739ae039; });

var $l77nE = parcelRequire("l77nE");

var $idqiR = parcelRequire("idqiR");
const $336f3b30f6381c5a$export$35e57303dbd8a66 = (0, $l77nE.default)();
function $336f3b30f6381c5a$var$useTheme(defaultTheme = $336f3b30f6381c5a$export$35e57303dbd8a66) {
    return (0, $idqiR.default)(defaultTheme);
}
var $336f3b30f6381c5a$export$2e2bcd8739ae039 = $336f3b30f6381c5a$var$useTheme;

});
parcelRequire.register("l77nE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5effa04508ae66b$export$2e2bcd8739ae039; });

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $3ocmy = parcelRequire("3ocmy");

var $6rC0i = parcelRequire("6rC0i");

var $jhndL = parcelRequire("jhndL");

var $712Sh = parcelRequire("712Sh");

var $gNSaz = parcelRequire("gNSaz");

var $cLAFm = parcelRequire("cLAFm");
const $f5effa04508ae66b$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $f5effa04508ae66b$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {} , palette: paletteInput = {} , spacing: spacingInput , shape: shapeInput = {}  } = options, other = (0, $eLWn9.default)(options, $f5effa04508ae66b$var$_excluded);
    const breakpoints = (0, $6rC0i.default)(breakpointsInput);
    const spacing = (0, $712Sh.default)(spacingInput);
    let muiTheme = (0, $3ocmy.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $9YD4s.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $9YD4s.default)({}, (0, $jhndL.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3ocmy.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $9YD4s.default)({}, (0, $cLAFm.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $gNSaz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $f5effa04508ae66b$export$2e2bcd8739ae039 = $f5effa04508ae66b$var$createTheme;

});
parcelRequire.register("3ocmy", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $277d33f4bb2a8657$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $277d33f4bb2a8657$export$2e2bcd8739ae039; });

var $9YD4s = parcelRequire("9YD4s");
function $277d33f4bb2a8657$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $277d33f4bb2a8657$var$deepClone(source) {
    if (!$277d33f4bb2a8657$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $277d33f4bb2a8657$var$deepClone(source[key]);
    });
    return output;
}
function $277d33f4bb2a8657$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $9YD4s.default)({}, target) : target;
    if ($277d33f4bb2a8657$export$53b83ca8eaab0383(target) && $277d33f4bb2a8657$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($277d33f4bb2a8657$export$53b83ca8eaab0383(source[key]) && key in target && $277d33f4bb2a8657$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $277d33f4bb2a8657$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $277d33f4bb2a8657$export$53b83ca8eaab0383(source[key]) ? $277d33f4bb2a8657$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRequire.register("6rC0i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b12be79806cd679$export$2e2bcd8739ae039; });

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");
const $4b12be79806cd679$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $4b12be79806cd679$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $4b12be79806cd679$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $9YD4s.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $4b12be79806cd679$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    } , unit: unit = "px" , step: step = 5  } = breakpoints, other = (0, $eLWn9.default)(breakpoints, $4b12be79806cd679$var$_excluded);
    const sortedValues = $4b12be79806cd679$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $9YD4s.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRequire.register("jhndL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0919e0ee798519f$export$2e2bcd8739ae039; });
const $e0919e0ee798519f$var$shape = {
    borderRadius: 4
};
var $e0919e0ee798519f$export$2e2bcd8739ae039 = $e0919e0ee798519f$var$shape;

});

parcelRequire.register("712Sh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51badb3257a5180b$export$2e2bcd8739ae039; });

var $iHy64 = parcelRequire("iHy64");
function $51badb3257a5180b$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $iHy64.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("iHy64", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $d9d6b117adda47cf$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $d9d6b117adda47cf$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $d9d6b117adda47cf$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $d9d6b117adda47cf$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $d9d6b117adda47cf$export$6f98e8eaf0be1996; });


var $2GXkB = parcelRequire("2GXkB");

var $7NEVK = parcelRequire("7NEVK");

var $dAZ15 = parcelRequire("dAZ15");

var $k8UJh = parcelRequire("k8UJh");
const $d9d6b117adda47cf$var$properties = {
    m: "margin",
    p: "padding"
};
const $d9d6b117adda47cf$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $d9d6b117adda47cf$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $d9d6b117adda47cf$var$getCssProperties = (0, $k8UJh.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($d9d6b117adda47cf$var$aliases[prop]) prop = $d9d6b117adda47cf$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $d9d6b117adda47cf$var$properties[a];
    const direction = $d9d6b117adda47cf$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $d9d6b117adda47cf$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $d9d6b117adda47cf$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $d9d6b117adda47cf$var$spacingKeys = [
    ...$d9d6b117adda47cf$export$aab52a0dde05ad8a,
    ...$d9d6b117adda47cf$export$f8397d44f03ab6ad
];
function $d9d6b117adda47cf$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $7NEVK.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $d9d6b117adda47cf$export$1def6f833384e3d1(theme) {
    return $d9d6b117adda47cf$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $d9d6b117adda47cf$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $d9d6b117adda47cf$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $d9d6b117adda47cf$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $d9d6b117adda47cf$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $d9d6b117adda47cf$var$getCssProperties(prop);
    const styleFromPropValue = $d9d6b117adda47cf$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $2GXkB.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $d9d6b117adda47cf$var$style(props, keys) {
    const transformer = $d9d6b117adda47cf$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$d9d6b117adda47cf$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $dAZ15.default), {});
}
function $d9d6b117adda47cf$export$7ede87f9b603dd3c(props) {
    return $d9d6b117adda47cf$var$style(props, $d9d6b117adda47cf$export$aab52a0dde05ad8a);
}
$d9d6b117adda47cf$export$7ede87f9b603dd3c.propTypes = {};
$d9d6b117adda47cf$export$7ede87f9b603dd3c.filterProps = $d9d6b117adda47cf$export$aab52a0dde05ad8a;
function $d9d6b117adda47cf$export$6f98e8eaf0be1996(props) {
    return $d9d6b117adda47cf$var$style(props, $d9d6b117adda47cf$export$f8397d44f03ab6ad);
}
$d9d6b117adda47cf$export$6f98e8eaf0be1996.propTypes = {};
$d9d6b117adda47cf$export$6f98e8eaf0be1996.filterProps = $d9d6b117adda47cf$export$f8397d44f03ab6ad;
function $d9d6b117adda47cf$var$spacing(props) {
    return $d9d6b117adda47cf$var$style(props, $d9d6b117adda47cf$var$spacingKeys);
}
$d9d6b117adda47cf$var$spacing.propTypes = {};
$d9d6b117adda47cf$var$spacing.filterProps = $d9d6b117adda47cf$var$spacingKeys;
var $d9d6b117adda47cf$export$2e2bcd8739ae039 = $d9d6b117adda47cf$var$spacing;

});
parcelRequire.register("2GXkB", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $1f5d86f51ef9f795$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $1f5d86f51ef9f795$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $1f5d86f51ef9f795$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $1f5d86f51ef9f795$export$8922c90b6e020726; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $1f5d86f51ef9f795$export$980e6a259d807490; });

var $9YD4s = parcelRequire("9YD4s");


var $3ocmy = parcelRequire("3ocmy");

var $dAZ15 = parcelRequire("dAZ15");
const $1f5d86f51ef9f795$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $1f5d86f51ef9f795$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$1f5d86f51ef9f795$export$68c286be0e7e55b7[key]}px)`
};
function $1f5d86f51ef9f795$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $1f5d86f51ef9f795$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $1f5d86f51ef9f795$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $1f5d86f51ef9f795$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $1f5d86f51ef9f795$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $1f5d86f51ef9f795$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $9YD4s.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $dAZ15.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $1f5d86f51ef9f795$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $1f5d86f51ef9f795$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $1f5d86f51ef9f795$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $1f5d86f51ef9f795$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3ocmy.default)(prev, next), {});
    return $1f5d86f51ef9f795$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $1f5d86f51ef9f795$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $1f5d86f51ef9f795$export$980e6a259d807490({ values: breakpointValues , breakpoints: themeBreakpoints , base: customBase  }) {
    const base = customBase || $1f5d86f51ef9f795$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $1f5d86f51ef9f795$export$2e2bcd8739ae039 = $1f5d86f51ef9f795$var$breakpoints;

});
parcelRequire.register("dAZ15", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e5df7c1e77fb32b$export$2e2bcd8739ae039; });

var $3ocmy = parcelRequire("3ocmy");
function $9e5df7c1e77fb32b$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3ocmy.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $9e5df7c1e77fb32b$export$2e2bcd8739ae039 = $9e5df7c1e77fb32b$var$merge;

});


parcelRequire.register("7NEVK", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $5adcdbf12320050d$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $5adcdbf12320050d$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $5adcdbf12320050d$export$2e2bcd8739ae039; });

var $1Z8IT = parcelRequire("1Z8IT");


var $2GXkB = parcelRequire("2GXkB");
function $5adcdbf12320050d$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $5adcdbf12320050d$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $5adcdbf12320050d$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $5adcdbf12320050d$var$style(options) {
    const { prop: prop , cssProperty: cssProperty = options.prop , themeKey: themeKey , transform: transform  } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $5adcdbf12320050d$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $5adcdbf12320050d$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $5adcdbf12320050d$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $1Z8IT.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $2GXkB.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $5adcdbf12320050d$export$2e2bcd8739ae039 = $5adcdbf12320050d$var$style;

});

parcelRequire.register("k8UJh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaa08f3e73731a67$export$2e2bcd8739ae039; });
function $eaa08f3e73731a67$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("gNSaz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3bb3ddd644bf79a$export$2e2bcd8739ae039; });

var $1Z8IT = parcelRequire("1Z8IT");

var $dAZ15 = parcelRequire("dAZ15");

var $7NEVK = parcelRequire("7NEVK");

var $2GXkB = parcelRequire("2GXkB");

var $cLAFm = parcelRequire("cLAFm");
function $c3bb3ddd644bf79a$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $c3bb3ddd644bf79a$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $c3bb3ddd644bf79a$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop , themeKey: themeKey , transform: transform , style: style  } = options;
        if (val == null) return null;
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $7NEVK.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $7NEVK.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $7NEVK.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $1Z8IT.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $2GXkB.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx , theme: theme = {}  } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $cLAFm.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $2GXkB.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $c3bb3ddd644bf79a$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $dAZ15.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $2GXkB.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($c3bb3ddd644bf79a$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $dAZ15.default)(css, breakpointsValues);
                        }
                    } else css = (0, $dAZ15.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $2GXkB.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $c3bb3ddd644bf79a$var$styleFunctionSx = $c3bb3ddd644bf79a$export$7d53d8bf2911e013();
$c3bb3ddd644bf79a$var$styleFunctionSx.filterProps = [
    "sx"
];
var $c3bb3ddd644bf79a$export$2e2bcd8739ae039 = $c3bb3ddd644bf79a$var$styleFunctionSx;

});
parcelRequire.register("cLAFm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94b650f467f8a855$export$2e2bcd8739ae039; });

var $iHy64 = parcelRequire("iHy64");

var $8jbFQ = parcelRequire("8jbFQ");

var $iAq4I = parcelRequire("iAq4I");

var $1w8lQ = parcelRequire("1w8lQ");

var $6FRez = parcelRequire("6FRez");
const $94b650f467f8a855$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $8jbFQ.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $8jbFQ.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $8jbFQ.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $8jbFQ.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $8jbFQ.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $8jbFQ.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $1w8lQ.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $1w8lQ.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $1w8lQ.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $iHy64.padding)
    },
    pt: {
        style: (0, $iHy64.padding)
    },
    pr: {
        style: (0, $iHy64.padding)
    },
    pb: {
        style: (0, $iHy64.padding)
    },
    pl: {
        style: (0, $iHy64.padding)
    },
    px: {
        style: (0, $iHy64.padding)
    },
    py: {
        style: (0, $iHy64.padding)
    },
    padding: {
        style: (0, $iHy64.padding)
    },
    paddingTop: {
        style: (0, $iHy64.padding)
    },
    paddingRight: {
        style: (0, $iHy64.padding)
    },
    paddingBottom: {
        style: (0, $iHy64.padding)
    },
    paddingLeft: {
        style: (0, $iHy64.padding)
    },
    paddingX: {
        style: (0, $iHy64.padding)
    },
    paddingY: {
        style: (0, $iHy64.padding)
    },
    paddingInline: {
        style: (0, $iHy64.padding)
    },
    paddingInlineStart: {
        style: (0, $iHy64.padding)
    },
    paddingInlineEnd: {
        style: (0, $iHy64.padding)
    },
    paddingBlock: {
        style: (0, $iHy64.padding)
    },
    paddingBlockStart: {
        style: (0, $iHy64.padding)
    },
    paddingBlockEnd: {
        style: (0, $iHy64.padding)
    },
    m: {
        style: (0, $iHy64.margin)
    },
    mt: {
        style: (0, $iHy64.margin)
    },
    mr: {
        style: (0, $iHy64.margin)
    },
    mb: {
        style: (0, $iHy64.margin)
    },
    ml: {
        style: (0, $iHy64.margin)
    },
    mx: {
        style: (0, $iHy64.margin)
    },
    my: {
        style: (0, $iHy64.margin)
    },
    margin: {
        style: (0, $iHy64.margin)
    },
    marginTop: {
        style: (0, $iHy64.margin)
    },
    marginRight: {
        style: (0, $iHy64.margin)
    },
    marginBottom: {
        style: (0, $iHy64.margin)
    },
    marginLeft: {
        style: (0, $iHy64.margin)
    },
    marginX: {
        style: (0, $iHy64.margin)
    },
    marginY: {
        style: (0, $iHy64.margin)
    },
    marginInline: {
        style: (0, $iHy64.margin)
    },
    marginInlineStart: {
        style: (0, $iHy64.margin)
    },
    marginInlineEnd: {
        style: (0, $iHy64.margin)
    },
    marginBlock: {
        style: (0, $iHy64.margin)
    },
    marginBlockStart: {
        style: (0, $iHy64.margin)
    },
    marginBlockEnd: {
        style: (0, $iHy64.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $iAq4I.gap)
    },
    rowGap: {
        style: (0, $iAq4I.rowGap)
    },
    columnGap: {
        style: (0, $iAq4I.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $6FRez.sizingTransform)
    },
    maxWidth: {
        style: (0, $6FRez.maxWidth)
    },
    minWidth: {
        transform: (0, $6FRez.sizingTransform)
    },
    height: {
        transform: (0, $6FRez.sizingTransform)
    },
    maxHeight: {
        transform: (0, $6FRez.sizingTransform)
    },
    minHeight: {
        transform: (0, $6FRez.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $94b650f467f8a855$export$2e2bcd8739ae039 = $94b650f467f8a855$var$defaultSxConfig;

});
parcelRequire.register("8jbFQ", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $60c9274b72fc5845$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $60c9274b72fc5845$export$7a57f79000377ca2; });


var $7NEVK = parcelRequire("7NEVK");

var $lvAl2 = parcelRequire("lvAl2");

var $iHy64 = parcelRequire("iHy64");

var $2GXkB = parcelRequire("2GXkB");
function $60c9274b72fc5845$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $60c9274b72fc5845$export$1edee58a52776cd9 = (0, $7NEVK.default)({
    prop: "border",
    themeKey: "borders",
    transform: $60c9274b72fc5845$export$34e2febe53ae29cc
});
const $60c9274b72fc5845$export$f9a7b6bd24892946 = (0, $7NEVK.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $60c9274b72fc5845$export$34e2febe53ae29cc
});
const $60c9274b72fc5845$export$5abca33e6be905d2 = (0, $7NEVK.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $60c9274b72fc5845$export$34e2febe53ae29cc
});
const $60c9274b72fc5845$export$e2ce9f12a980a822 = (0, $7NEVK.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $60c9274b72fc5845$export$34e2febe53ae29cc
});
const $60c9274b72fc5845$export$47658cca1a909427 = (0, $7NEVK.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $60c9274b72fc5845$export$34e2febe53ae29cc
});
const $60c9274b72fc5845$export$e7fb0694ba2404fc = (0, $7NEVK.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $60c9274b72fc5845$export$126a92c968acdb85 = (0, $7NEVK.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $60c9274b72fc5845$export$85cc51cb8fbb8c0e = (0, $7NEVK.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $60c9274b72fc5845$export$340b0327727f6d1a = (0, $7NEVK.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $60c9274b72fc5845$export$60beef91a985b4bf = (0, $7NEVK.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $60c9274b72fc5845$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $iHy64.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $iHy64.getValue)(transformer, propValue)
            });
        return (0, $2GXkB.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$60c9274b72fc5845$export$7a57f79000377ca2.propTypes = {};
$60c9274b72fc5845$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $60c9274b72fc5845$var$borders = (0, $lvAl2.default)($60c9274b72fc5845$export$1edee58a52776cd9, $60c9274b72fc5845$export$f9a7b6bd24892946, $60c9274b72fc5845$export$5abca33e6be905d2, $60c9274b72fc5845$export$e2ce9f12a980a822, $60c9274b72fc5845$export$47658cca1a909427, $60c9274b72fc5845$export$e7fb0694ba2404fc, $60c9274b72fc5845$export$126a92c968acdb85, $60c9274b72fc5845$export$85cc51cb8fbb8c0e, $60c9274b72fc5845$export$340b0327727f6d1a, $60c9274b72fc5845$export$60beef91a985b4bf, $60c9274b72fc5845$export$7a57f79000377ca2);
var $60c9274b72fc5845$export$2e2bcd8739ae039 = $60c9274b72fc5845$var$borders;

});
parcelRequire.register("lvAl2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa88ae461ef8bc1f$export$2e2bcd8739ae039; });

var $dAZ15 = parcelRequire("dAZ15");
function $fa88ae461ef8bc1f$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $dAZ15.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $fa88ae461ef8bc1f$export$2e2bcd8739ae039 = $fa88ae461ef8bc1f$var$compose;

});


parcelRequire.register("iAq4I", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $d87fd0bf48ef3572$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $d87fd0bf48ef3572$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $d87fd0bf48ef3572$export$8a833ffa5f5dbeda; });

var $7NEVK = parcelRequire("7NEVK");

var $lvAl2 = parcelRequire("lvAl2");

var $iHy64 = parcelRequire("iHy64");

var $2GXkB = parcelRequire("2GXkB");

const $d87fd0bf48ef3572$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $iHy64.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $iHy64.getValue)(transformer, propValue)
            });
        return (0, $2GXkB.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$d87fd0bf48ef3572$export$5df9adcb0db95e1e.propTypes = {};
$d87fd0bf48ef3572$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $d87fd0bf48ef3572$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $iHy64.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $iHy64.getValue)(transformer, propValue)
            });
        return (0, $2GXkB.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$d87fd0bf48ef3572$export$ec60d70ff941a580.propTypes = {};
$d87fd0bf48ef3572$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $d87fd0bf48ef3572$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $iHy64.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $iHy64.getValue)(transformer, propValue)
            });
        return (0, $2GXkB.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$d87fd0bf48ef3572$export$8a833ffa5f5dbeda.propTypes = {};
$d87fd0bf48ef3572$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $d87fd0bf48ef3572$export$baf44164ca3a34e8 = (0, $7NEVK.default)({
    prop: "gridColumn"
});
const $d87fd0bf48ef3572$export$8f7213a1cd01e832 = (0, $7NEVK.default)({
    prop: "gridRow"
});
const $d87fd0bf48ef3572$export$b0e0abbc49ba668 = (0, $7NEVK.default)({
    prop: "gridAutoFlow"
});
const $d87fd0bf48ef3572$export$bcd8b929d4b4142 = (0, $7NEVK.default)({
    prop: "gridAutoColumns"
});
const $d87fd0bf48ef3572$export$e5039a674e14c828 = (0, $7NEVK.default)({
    prop: "gridAutoRows"
});
const $d87fd0bf48ef3572$export$42bd9088661ffb03 = (0, $7NEVK.default)({
    prop: "gridTemplateColumns"
});
const $d87fd0bf48ef3572$export$920682ae05b999bc = (0, $7NEVK.default)({
    prop: "gridTemplateRows"
});
const $d87fd0bf48ef3572$export$1b88fbdd482fd33a = (0, $7NEVK.default)({
    prop: "gridTemplateAreas"
});
const $d87fd0bf48ef3572$export$bdb486e40d52d26f = (0, $7NEVK.default)({
    prop: "gridArea"
});
const $d87fd0bf48ef3572$var$grid = (0, $lvAl2.default)($d87fd0bf48ef3572$export$5df9adcb0db95e1e, $d87fd0bf48ef3572$export$ec60d70ff941a580, $d87fd0bf48ef3572$export$8a833ffa5f5dbeda, $d87fd0bf48ef3572$export$baf44164ca3a34e8, $d87fd0bf48ef3572$export$8f7213a1cd01e832, $d87fd0bf48ef3572$export$b0e0abbc49ba668, $d87fd0bf48ef3572$export$bcd8b929d4b4142, $d87fd0bf48ef3572$export$e5039a674e14c828, $d87fd0bf48ef3572$export$42bd9088661ffb03, $d87fd0bf48ef3572$export$920682ae05b999bc, $d87fd0bf48ef3572$export$1b88fbdd482fd33a, $d87fd0bf48ef3572$export$bdb486e40d52d26f);
var $d87fd0bf48ef3572$export$2e2bcd8739ae039 = $d87fd0bf48ef3572$var$grid;

});

parcelRequire.register("1w8lQ", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $11af420457e3c63d$export$dbaffd4420ea0ac6; });

var $7NEVK = parcelRequire("7NEVK");

var $lvAl2 = parcelRequire("lvAl2");
function $11af420457e3c63d$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $11af420457e3c63d$export$35e9368ef982300f = (0, $7NEVK.default)({
    prop: "color",
    themeKey: "palette",
    transform: $11af420457e3c63d$export$dbaffd4420ea0ac6
});
const $11af420457e3c63d$export$2506f56c10355b33 = (0, $7NEVK.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $11af420457e3c63d$export$dbaffd4420ea0ac6
});
const $11af420457e3c63d$export$8c5a050822fd698c = (0, $7NEVK.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $11af420457e3c63d$export$dbaffd4420ea0ac6
});
const $11af420457e3c63d$var$palette = (0, $lvAl2.default)($11af420457e3c63d$export$35e9368ef982300f, $11af420457e3c63d$export$2506f56c10355b33, $11af420457e3c63d$export$8c5a050822fd698c);
var $11af420457e3c63d$export$2e2bcd8739ae039 = $11af420457e3c63d$var$palette;

});

parcelRequire.register("6FRez", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $4dbfdd8ef2a58836$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $4dbfdd8ef2a58836$export$488fda99655ff65a; });

var $7NEVK = parcelRequire("7NEVK");

var $lvAl2 = parcelRequire("lvAl2");

var $2GXkB = parcelRequire("2GXkB");
function $4dbfdd8ef2a58836$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $4dbfdd8ef2a58836$export$7e3df82ee760448c = (0, $7NEVK.default)({
    prop: "width",
    transform: $4dbfdd8ef2a58836$export$8afece71750ec241
});
const $4dbfdd8ef2a58836$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $2GXkB.values)[propValue];
            return {
                maxWidth: breakpoint || $4dbfdd8ef2a58836$export$8afece71750ec241(propValue)
            };
        };
        return (0, $2GXkB.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$4dbfdd8ef2a58836$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $4dbfdd8ef2a58836$export$ee148fbbe8357dd2 = (0, $7NEVK.default)({
    prop: "minWidth",
    transform: $4dbfdd8ef2a58836$export$8afece71750ec241
});
const $4dbfdd8ef2a58836$export$ac607276a8fe9f0a = (0, $7NEVK.default)({
    prop: "height",
    transform: $4dbfdd8ef2a58836$export$8afece71750ec241
});
const $4dbfdd8ef2a58836$export$dc0d8bd0b94f8570 = (0, $7NEVK.default)({
    prop: "maxHeight",
    transform: $4dbfdd8ef2a58836$export$8afece71750ec241
});
const $4dbfdd8ef2a58836$export$a43cf604e12f3b17 = (0, $7NEVK.default)({
    prop: "minHeight",
    transform: $4dbfdd8ef2a58836$export$8afece71750ec241
});
const $4dbfdd8ef2a58836$export$ffed9f14fb65e276 = (0, $7NEVK.default)({
    prop: "size",
    cssProperty: "width",
    transform: $4dbfdd8ef2a58836$export$8afece71750ec241
});
const $4dbfdd8ef2a58836$export$905076ed6620e671 = (0, $7NEVK.default)({
    prop: "size",
    cssProperty: "height",
    transform: $4dbfdd8ef2a58836$export$8afece71750ec241
});
const $4dbfdd8ef2a58836$export$6ccc93f785106a58 = (0, $7NEVK.default)({
    prop: "boxSizing"
});
const $4dbfdd8ef2a58836$var$sizing = (0, $lvAl2.default)($4dbfdd8ef2a58836$export$7e3df82ee760448c, $4dbfdd8ef2a58836$export$488fda99655ff65a, $4dbfdd8ef2a58836$export$ee148fbbe8357dd2, $4dbfdd8ef2a58836$export$ac607276a8fe9f0a, $4dbfdd8ef2a58836$export$dc0d8bd0b94f8570, $4dbfdd8ef2a58836$export$a43cf604e12f3b17, $4dbfdd8ef2a58836$export$6ccc93f785106a58);
var $4dbfdd8ef2a58836$export$2e2bcd8739ae039 = $4dbfdd8ef2a58836$var$sizing;

});




parcelRequire.register("idqiR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d42dd82465e91898$export$2e2bcd8739ae039; });

var $4lkrv = parcelRequire("4lkrv");
parcelRequire("35uzv");
var $3SpgA = parcelRequire("3SpgA");
function $d42dd82465e91898$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $d42dd82465e91898$var$useTheme(defaultTheme = null) {
    const contextTheme = $4lkrv.useContext((0, $3SpgA.T));
    return !contextTheme || $d42dd82465e91898$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $d42dd82465e91898$export$2e2bcd8739ae039 = $d42dd82465e91898$var$useTheme;

});
parcelRequire.register("35uzv", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $23f98da4381a3867$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $23f98da4381a3867$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $23f98da4381a3867$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("3SpgA")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("3SpgA")).w; });

var $4lkrv = parcelRequire("4lkrv");
parcelRequire("b9MOd");

var $3SpgA = parcelRequire("3SpgA");
parcelRequire("9cWX8");
parcelRequire("5AVll");
parcelRequire("43t7c");


var $iWlFq = parcelRequire("iWlFq");

var $eAHF1 = parcelRequire("eAHF1");

var $fn8Lu = parcelRequire("fn8Lu");
var $23f98da4381a3867$var$pkg = {
    name: "@emotion/react",
    version: "11.10.6",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.10.6",
        "@emotion/cache": "^11.10.5",
        "@emotion/serialize": "^1.1.1",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
        "@emotion/utils": "^1.2.0",
        "@emotion/weak-memoize": "^0.3.0",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.10.6",
        "@emotion/css-prettifier": "1.1.1",
        "@emotion/server": "11.10.0",
        "@emotion/styled": "11.10.6",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": "./macro.js"
            }
        }
    }
};
var $23f98da4381a3867$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $3SpgA.h).call(props, "css")) // $FlowFixMe
    return (0, $4lkrv.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $3SpgA.E);
    createElementArgArray[1] = (0, $3SpgA.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $4lkrv.createElement).apply(null, createElementArgArray);
};
var $23f98da4381a3867$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $23f98da4381a3867$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $3SpgA.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $eAHF1.serializeStyles)([
        styles
    ], undefined, (0, $4lkrv.useContext)((0, $3SpgA.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $4lkrv.useRef)();
    (0, $fn8Lu.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fn8Lu.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $iWlFq.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $23f98da4381a3867$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $eAHF1.serializeStyles)(args);
}
var $23f98da4381a3867$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $23f98da4381a3867$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $23f98da4381a3867$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $23f98da4381a3867$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $iWlFq.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $23f98da4381a3867$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $fn8Lu.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)var res = (0, $iWlFq.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $23f98da4381a3867$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $3SpgA.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $eAHF1.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $iWlFq.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $23f98da4381a3867$var$merge(cache.registered, css, $23f98da4381a3867$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $4lkrv.useContext)((0, $3SpgA.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ (0, $4lkrv.createElement)((0, $4lkrv.Fragment), null, /*#__PURE__*/ (0, $4lkrv.createElement)($23f98da4381a3867$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $23f98da4381a3867$var$isBrowser, $23f98da4381a3867$var$isTestEnv, $23f98da4381a3867$var$globalContext, $23f98da4381a3867$var$globalKey;

});
parcelRequire.register("b9MOd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81f66566ab6d1845$export$2e2bcd8739ae039; });

var $jel8k = parcelRequire("jel8k");

var $7JRAC = parcelRequire("7JRAC");
parcelRequire("5AVll");
parcelRequire("7R3W4");
var $81f66566ab6d1845$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $7JRAC.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $7JRAC.token)(character)) break;
        (0, $7JRAC.next)();
    }
    return (0, $7JRAC.slice)(begin, (0, $7JRAC.position));
};
var $81f66566ab6d1845$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $7JRAC.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $7JRAC.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $81f66566ab6d1845$var$identifierWithPointTracking((0, $7JRAC.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $7JRAC.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $7JRAC.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $7JRAC.from)(character);
    }
    while (character = (0, $7JRAC.next)());
    return parsed;
};
var $81f66566ab6d1845$var$getRules = function getRules(value, points) {
    return (0, $7JRAC.dealloc)($81f66566ab6d1845$var$toRules((0, $7JRAC.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $81f66566ab6d1845$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $81f66566ab6d1845$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$81f66566ab6d1845$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $81f66566ab6d1845$var$fixedElements.set(element, true);
    var points = [];
    var rules = $81f66566ab6d1845$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $81f66566ab6d1845$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $81f66566ab6d1845$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $81f66566ab6d1845$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($81f66566ab6d1845$var$ignoreFlag) > -1;
};
var $81f66566ab6d1845$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($81f66566ab6d1845$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $81f66566ab6d1845$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $81f66566ab6d1845$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$81f66566ab6d1845$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $81f66566ab6d1845$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $81f66566ab6d1845$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$81f66566ab6d1845$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $81f66566ab6d1845$var$nullifyElement(element);
    } else if ($81f66566ab6d1845$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $81f66566ab6d1845$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $81f66566ab6d1845$var$prefix(value, length) {
    switch((0, $7JRAC.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $7JRAC.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $7JRAC.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MOZ) + value + (0, $7JRAC.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + value + value;
        // order
        case 6165:
            return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.replace)(value, /(\w+).+(:[^]+)/, (0, $7JRAC.WEBKIT) + "box-$1$2" + (0, $7JRAC.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + "flex-item-" + (0, $7JRAC.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + "flex-line-pack" + (0, $7JRAC.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + (0, $7JRAC.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + (0, $7JRAC.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $7JRAC.WEBKIT) + "box-" + (0, $7JRAC.replace)(value, "-grow", "") + (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + (0, $7JRAC.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $7JRAC.WEBKIT) + (0, $7JRAC.replace)(value, /([^-])(transform)/g, "$1" + (0, $7JRAC.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $7JRAC.replace)((0, $7JRAC.replace)((0, $7JRAC.replace)(value, /(zoom-|grab)/, (0, $7JRAC.WEBKIT) + "$1"), /(image-set)/, (0, $7JRAC.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $7JRAC.replace)(value, /(image-set\([^]*)/, (0, $7JRAC.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $7JRAC.replace)((0, $7JRAC.replace)(value, /(.+:)(flex-)?(.*)/, (0, $7JRAC.WEBKIT) + "box-pack:$3" + (0, $7JRAC.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $7JRAC.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $7JRAC.replace)(value, /(.+)-inline(.+)/, (0, $7JRAC.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $7JRAC.strlen)(value) - 1 - length > 6) switch((0, $7JRAC.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $7JRAC.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $7JRAC.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $7JRAC.WEBKIT) + "$2-$3" + "$1" + (0, $7JRAC.MOZ) + ((0, $7JRAC.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $7JRAC.indexof)(value, "stretch") ? $81f66566ab6d1845$var$prefix((0, $7JRAC.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $7JRAC.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $7JRAC.charat)(value, (0, $7JRAC.strlen)(value) - 3 - (~(0, $7JRAC.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $7JRAC.replace)(value, ":", ":" + (0, $7JRAC.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $7JRAC.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $7JRAC.WEBKIT) + ((0, $7JRAC.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $7JRAC.WEBKIT) + "$2$3" + "$1" + (0, $7JRAC.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $7JRAC.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + (0, $7JRAC.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + (0, $7JRAC.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + (0, $7JRAC.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $7JRAC.WEBKIT) + value + (0, $7JRAC.MS) + value + value;
    }
    return value;
}
var $81f66566ab6d1845$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $7JRAC.DECLARATION:
                element["return"] = $81f66566ab6d1845$var$prefix(element.value, element.length);
                break;
            case 0, $7JRAC.KEYFRAMES:
                return (0, $7JRAC.serialize)([
                    (0, $7JRAC.copy)(element, {
                        value: (0, $7JRAC.replace)(element.value, "@", "@" + (0, $7JRAC.WEBKIT))
                    })
                ], callback);
            case 0, $7JRAC.RULESET:
                if (element.length) return (0, $7JRAC.combine)(element.props, function(value) {
                    switch((0, $7JRAC.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $7JRAC.serialize)([
                                (0, $7JRAC.copy)(element, {
                                    props: [
                                        (0, $7JRAC.replace)(value, /:(read-\w+)/, ":" + (0, $7JRAC.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $7JRAC.serialize)([
                                (0, $7JRAC.copy)(element, {
                                    props: [
                                        (0, $7JRAC.replace)(value, /:(plac\w+)/, ":" + (0, $7JRAC.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $7JRAC.copy)(element, {
                                    props: [
                                        (0, $7JRAC.replace)(value, /:(plac\w+)/, ":" + (0, $7JRAC.MOZ) + "$1")
                                    ]
                                }),
                                (0, $7JRAC.copy)(element, {
                                    props: [
                                        (0, $7JRAC.replace)(value, /:(plac\w+)/, (0, $7JRAC.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $81f66566ab6d1845$var$defaultStylisPlugins = [
    $81f66566ab6d1845$var$prefixer
];
var $81f66566ab6d1845$var$createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $81f66566ab6d1845$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $81f66566ab6d1845$var$compat,
        $81f66566ab6d1845$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $7JRAC.stringify),
        (0, $7JRAC.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $7JRAC.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $7JRAC.serialize)((0, $7JRAC.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $jel8k.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
var $81f66566ab6d1845$export$2e2bcd8739ae039 = $81f66566ab6d1845$var$createCache;

});
parcelRequire.register("jel8k", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $dfffb7c477dd7b06$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $dfffb7c477dd7b06$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $dfffb7c477dd7b06$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $dfffb7c477dd7b06$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($dfffb7c477dd7b06$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $dfffb7c477dd7b06$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("7JRAC", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $39fb70ddd1e2f193$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $39fb70ddd1e2f193$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $39fb70ddd1e2f193$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $39fb70ddd1e2f193$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $39fb70ddd1e2f193$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $39fb70ddd1e2f193$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $39fb70ddd1e2f193$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $39fb70ddd1e2f193$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $39fb70ddd1e2f193$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $39fb70ddd1e2f193$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $39fb70ddd1e2f193$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $39fb70ddd1e2f193$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $39fb70ddd1e2f193$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $39fb70ddd1e2f193$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $39fb70ddd1e2f193$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $39fb70ddd1e2f193$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $39fb70ddd1e2f193$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $39fb70ddd1e2f193$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $39fb70ddd1e2f193$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $39fb70ddd1e2f193$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $39fb70ddd1e2f193$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $39fb70ddd1e2f193$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $39fb70ddd1e2f193$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $39fb70ddd1e2f193$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $39fb70ddd1e2f193$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $39fb70ddd1e2f193$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $39fb70ddd1e2f193$export$38bcb760f1d4871c; });
var $39fb70ddd1e2f193$export$71ad59f2e432cfe8 = "-ms-";
var $39fb70ddd1e2f193$export$2c0f367103c8d01c = "-moz-";
var $39fb70ddd1e2f193$export$39dfd62a25e0fe93 = "-webkit-";
var $39fb70ddd1e2f193$export$a29989082612d0d9 = "comm";
var $39fb70ddd1e2f193$export$aa3a2e812ca8570d = "rule";
var $39fb70ddd1e2f193$export$527d108ccf083c2b = "decl";
var $39fb70ddd1e2f193$export$d3d35020fa5b54f0 = "@page";
var $39fb70ddd1e2f193$export$500415a86c544f73 = "@media";
var $39fb70ddd1e2f193$export$a763edbf796b780a = "@import";
var $39fb70ddd1e2f193$export$2790aeb8b4e5c826 = "@charset";
var $39fb70ddd1e2f193$export$1cc683e23b84b133 = "@viewport";
var $39fb70ddd1e2f193$export$9447a5efea57e862 = "@supports";
var $39fb70ddd1e2f193$export$ef011b4e114b1fba = "@document";
var $39fb70ddd1e2f193$export$6aad947bda0f3f46 = "@namespace";
var $39fb70ddd1e2f193$export$b44a8529a35fcb60 = "@keyframes";
var $39fb70ddd1e2f193$export$2c16de31893252e6 = "@font-face";
var $39fb70ddd1e2f193$export$3d846dd52e150c6f = "@counter-style";
var $39fb70ddd1e2f193$export$22314bfbb57653fe = "@font-feature-values";
var $39fb70ddd1e2f193$export$2335f513bbd82c6d = Math.abs;
var $39fb70ddd1e2f193$export$6788812c4e6611e6 = String.fromCharCode;
var $39fb70ddd1e2f193$export$e6e34fd1f2686227 = Object.assign;
function $39fb70ddd1e2f193$export$d6af199866bfb566(e, r) {
    return $39fb70ddd1e2f193$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $39fb70ddd1e2f193$export$a9db5e087081082d(e, 0)) << 2 ^ $39fb70ddd1e2f193$export$a9db5e087081082d(e, 1)) << 2 ^ $39fb70ddd1e2f193$export$a9db5e087081082d(e, 2)) << 2 ^ $39fb70ddd1e2f193$export$a9db5e087081082d(e, 3) : 0;
}
function $39fb70ddd1e2f193$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $39fb70ddd1e2f193$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $39fb70ddd1e2f193$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $39fb70ddd1e2f193$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $39fb70ddd1e2f193$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $39fb70ddd1e2f193$export$36776f635604f274(e) {
    return e.length;
}
function $39fb70ddd1e2f193$export$f9084667e487ed46(e) {
    return e.length;
}
function $39fb70ddd1e2f193$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $39fb70ddd1e2f193$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $39fb70ddd1e2f193$export$53f1d5ea8de3d7c = 1;
var $39fb70ddd1e2f193$export$4e0c71f277ca26b3 = 1;
var $39fb70ddd1e2f193$export$f24224f1c91d8156 = 0;
var $39fb70ddd1e2f193$export$5880b8b5730aff45 = 0;
var $39fb70ddd1e2f193$export$c0306caf338ac095 = 0;
var $39fb70ddd1e2f193$export$30a86d91af8ff6e6 = "";
function $39fb70ddd1e2f193$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $39fb70ddd1e2f193$export$53f1d5ea8de3d7c,
        column: $39fb70ddd1e2f193$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $39fb70ddd1e2f193$export$784d13d8ee351f07(e, r) {
    return $39fb70ddd1e2f193$export$e6e34fd1f2686227($39fb70ddd1e2f193$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $39fb70ddd1e2f193$export$eba6f6f03b0a92e7() {
    return $39fb70ddd1e2f193$export$c0306caf338ac095;
}
function $39fb70ddd1e2f193$export$232faf9add678146() {
    $39fb70ddd1e2f193$export$c0306caf338ac095 = $39fb70ddd1e2f193$export$5880b8b5730aff45 > 0 ? $39fb70ddd1e2f193$export$a9db5e087081082d($39fb70ddd1e2f193$export$30a86d91af8ff6e6, --$39fb70ddd1e2f193$export$5880b8b5730aff45) : 0;
    if ($39fb70ddd1e2f193$export$4e0c71f277ca26b3--, $39fb70ddd1e2f193$export$c0306caf338ac095 === 10) $39fb70ddd1e2f193$export$4e0c71f277ca26b3 = 1, $39fb70ddd1e2f193$export$53f1d5ea8de3d7c--;
    return $39fb70ddd1e2f193$export$c0306caf338ac095;
}
function $39fb70ddd1e2f193$export$48cfd1e771a65c4f() {
    $39fb70ddd1e2f193$export$c0306caf338ac095 = $39fb70ddd1e2f193$export$5880b8b5730aff45 < $39fb70ddd1e2f193$export$f24224f1c91d8156 ? $39fb70ddd1e2f193$export$a9db5e087081082d($39fb70ddd1e2f193$export$30a86d91af8ff6e6, $39fb70ddd1e2f193$export$5880b8b5730aff45++) : 0;
    if ($39fb70ddd1e2f193$export$4e0c71f277ca26b3++, $39fb70ddd1e2f193$export$c0306caf338ac095 === 10) $39fb70ddd1e2f193$export$4e0c71f277ca26b3 = 1, $39fb70ddd1e2f193$export$53f1d5ea8de3d7c++;
    return $39fb70ddd1e2f193$export$c0306caf338ac095;
}
function $39fb70ddd1e2f193$export$4d3fb11e950abb9e() {
    return $39fb70ddd1e2f193$export$a9db5e087081082d($39fb70ddd1e2f193$export$30a86d91af8ff6e6, $39fb70ddd1e2f193$export$5880b8b5730aff45);
}
function $39fb70ddd1e2f193$export$e88cb2efb12ae807() {
    return $39fb70ddd1e2f193$export$5880b8b5730aff45;
}
function $39fb70ddd1e2f193$export$58adb3bec8346d0f(e, r) {
    return $39fb70ddd1e2f193$export$2f35ab04d2335697($39fb70ddd1e2f193$export$30a86d91af8ff6e6, e, r);
}
function $39fb70ddd1e2f193$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $39fb70ddd1e2f193$export$2de70f21292aac9e(e) {
    return $39fb70ddd1e2f193$export$53f1d5ea8de3d7c = $39fb70ddd1e2f193$export$4e0c71f277ca26b3 = 1, $39fb70ddd1e2f193$export$f24224f1c91d8156 = $39fb70ddd1e2f193$export$36776f635604f274($39fb70ddd1e2f193$export$30a86d91af8ff6e6 = e), $39fb70ddd1e2f193$export$5880b8b5730aff45 = 0, [];
}
function $39fb70ddd1e2f193$export$45918ac1574455b1(e) {
    return $39fb70ddd1e2f193$export$30a86d91af8ff6e6 = "", e;
}
function $39fb70ddd1e2f193$export$410ac95b9ec204b8(e) {
    return $39fb70ddd1e2f193$export$87c2784dc9fc4ab($39fb70ddd1e2f193$export$58adb3bec8346d0f($39fb70ddd1e2f193$export$5880b8b5730aff45 - 1, $39fb70ddd1e2f193$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $39fb70ddd1e2f193$export$660b2ee2d4fb4eff(e) {
    return $39fb70ddd1e2f193$export$45918ac1574455b1($39fb70ddd1e2f193$export$5f8c09e3ae6f64e1($39fb70ddd1e2f193$export$2de70f21292aac9e(e)));
}
function $39fb70ddd1e2f193$export$7af1228ff777d175(e) {
    while($39fb70ddd1e2f193$export$c0306caf338ac095 = $39fb70ddd1e2f193$export$4d3fb11e950abb9e())if ($39fb70ddd1e2f193$export$c0306caf338ac095 < 33) $39fb70ddd1e2f193$export$48cfd1e771a65c4f();
    else break;
    return $39fb70ddd1e2f193$export$9e1725a4cfeada27(e) > 2 || $39fb70ddd1e2f193$export$9e1725a4cfeada27($39fb70ddd1e2f193$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $39fb70ddd1e2f193$export$5f8c09e3ae6f64e1(e) {
    while($39fb70ddd1e2f193$export$48cfd1e771a65c4f())switch($39fb70ddd1e2f193$export$9e1725a4cfeada27($39fb70ddd1e2f193$export$c0306caf338ac095)){
        case 0:
            $39fb70ddd1e2f193$export$10d8903dec122b9d($39fb70ddd1e2f193$export$c2ab62c7bf24634($39fb70ddd1e2f193$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $39fb70ddd1e2f193$export$10d8903dec122b9d($39fb70ddd1e2f193$export$410ac95b9ec204b8($39fb70ddd1e2f193$export$c0306caf338ac095), e);
            break;
        default:
            $39fb70ddd1e2f193$export$10d8903dec122b9d($39fb70ddd1e2f193$export$6788812c4e6611e6($39fb70ddd1e2f193$export$c0306caf338ac095), e);
    }
    return e;
}
function $39fb70ddd1e2f193$export$955ba06d119e085e(e, r) {
    while(--r && $39fb70ddd1e2f193$export$48cfd1e771a65c4f())if ($39fb70ddd1e2f193$export$c0306caf338ac095 < 48 || $39fb70ddd1e2f193$export$c0306caf338ac095 > 102 || $39fb70ddd1e2f193$export$c0306caf338ac095 > 57 && $39fb70ddd1e2f193$export$c0306caf338ac095 < 65 || $39fb70ddd1e2f193$export$c0306caf338ac095 > 70 && $39fb70ddd1e2f193$export$c0306caf338ac095 < 97) break;
    return $39fb70ddd1e2f193$export$58adb3bec8346d0f(e, $39fb70ddd1e2f193$export$e88cb2efb12ae807() + (r < 6 && $39fb70ddd1e2f193$export$4d3fb11e950abb9e() == 32 && $39fb70ddd1e2f193$export$48cfd1e771a65c4f() == 32));
}
function $39fb70ddd1e2f193$export$c889f2fcc19dbf12(e) {
    while($39fb70ddd1e2f193$export$48cfd1e771a65c4f())switch($39fb70ddd1e2f193$export$c0306caf338ac095){
        case e:
            return $39fb70ddd1e2f193$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $39fb70ddd1e2f193$export$c889f2fcc19dbf12($39fb70ddd1e2f193$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $39fb70ddd1e2f193$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $39fb70ddd1e2f193$export$48cfd1e771a65c4f();
            break;
    }
    return $39fb70ddd1e2f193$export$5880b8b5730aff45;
}
function $39fb70ddd1e2f193$export$4254d4e2b3745c4c(e, r) {
    while($39fb70ddd1e2f193$export$48cfd1e771a65c4f())if (e + $39fb70ddd1e2f193$export$c0306caf338ac095 === 57) break;
    else if (e + $39fb70ddd1e2f193$export$c0306caf338ac095 === 84 && $39fb70ddd1e2f193$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $39fb70ddd1e2f193$export$58adb3bec8346d0f(r, $39fb70ddd1e2f193$export$5880b8b5730aff45 - 1) + "*" + $39fb70ddd1e2f193$export$6788812c4e6611e6(e === 47 ? e : $39fb70ddd1e2f193$export$48cfd1e771a65c4f());
}
function $39fb70ddd1e2f193$export$c2ab62c7bf24634(e) {
    while(!$39fb70ddd1e2f193$export$9e1725a4cfeada27($39fb70ddd1e2f193$export$4d3fb11e950abb9e()))$39fb70ddd1e2f193$export$48cfd1e771a65c4f();
    return $39fb70ddd1e2f193$export$58adb3bec8346d0f(e, $39fb70ddd1e2f193$export$5880b8b5730aff45);
}
function $39fb70ddd1e2f193$export$ef7acd7185315e22(e) {
    return $39fb70ddd1e2f193$export$45918ac1574455b1($39fb70ddd1e2f193$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $39fb70ddd1e2f193$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $39fb70ddd1e2f193$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var O = g;
    while(w)switch(h = $, $ = $39fb70ddd1e2f193$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $39fb70ddd1e2f193$export$a9db5e087081082d(O, l - 1) == 58) {
                if ($39fb70ddd1e2f193$export$f8e21b1e77979a08(O += $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed($39fb70ddd1e2f193$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            O += $39fb70ddd1e2f193$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            O += $39fb70ddd1e2f193$export$7af1228ff777d175(h);
            break;
        case 92:
            O += $39fb70ddd1e2f193$export$955ba06d119e085e($39fb70ddd1e2f193$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($39fb70ddd1e2f193$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $39fb70ddd1e2f193$export$10d8903dec122b9d($39fb70ddd1e2f193$export$4a34f930e789283c($39fb70ddd1e2f193$export$4254d4e2b3745c4c($39fb70ddd1e2f193$export$48cfd1e771a65c4f(), $39fb70ddd1e2f193$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    O += "/";
            }
            break;
        case 123 * b:
            u[f++] = $39fb70ddd1e2f193$export$36776f635604f274(O) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (p > 0 && $39fb70ddd1e2f193$export$36776f635604f274(O) - l) $39fb70ddd1e2f193$export$10d8903dec122b9d(p > 32 ? $39fb70ddd1e2f193$export$f8483753829ec8f3(O + ";", n, a, l - 1) : $39fb70ddd1e2f193$export$f8483753829ec8f3($39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(O, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    O += ";";
                default:
                    $39fb70ddd1e2f193$export$10d8903dec122b9d(y = $39fb70ddd1e2f193$export$3307ffa7023ede1e(O, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $39fb70ddd1e2f193$export$98e6a39c04603d36(O, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $39fb70ddd1e2f193$export$a9db5e087081082d(O, 3) === 110 ? 100 : v){
                            case 100:
                            case 109:
                            case 115:
                                $39fb70ddd1e2f193$export$98e6a39c04603d36(e, y, y, n && $39fb70ddd1e2f193$export$10d8903dec122b9d($39fb70ddd1e2f193$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $39fb70ddd1e2f193$export$98e6a39c04603d36(O, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = O = "", l = t;
            break;
        case 58:
            l = 1 + $39fb70ddd1e2f193$export$36776f635604f274(O), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $39fb70ddd1e2f193$export$232faf9add678146() == 125) continue;
            }
            switch(O += $39fb70ddd1e2f193$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (O += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($39fb70ddd1e2f193$export$36776f635604f274(O) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($39fb70ddd1e2f193$export$4d3fb11e950abb9e() === 45) O += $39fb70ddd1e2f193$export$410ac95b9ec204b8($39fb70ddd1e2f193$export$48cfd1e771a65c4f());
                    v = $39fb70ddd1e2f193$export$4d3fb11e950abb9e(), o = l = $39fb70ddd1e2f193$export$36776f635604f274(g = O += $39fb70ddd1e2f193$export$c2ab62c7bf24634($39fb70ddd1e2f193$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $39fb70ddd1e2f193$export$36776f635604f274(O) == 2) b = 0;
            }
    }
    return s;
}
function $39fb70ddd1e2f193$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $39fb70ddd1e2f193$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var k = 0, g = $39fb70ddd1e2f193$export$2f35ab04d2335697(e, v + 1, v = $39fb70ddd1e2f193$export$2335f513bbd82c6d(w = u[b])), m = e; k < h; ++k)if (m = $39fb70ddd1e2f193$export$87c2784dc9fc4ab(w > 0 ? p[k] + " " + g : $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(g, /&\f/g, p[k]))) f[d++] = m;
    return $39fb70ddd1e2f193$export$35059013cd4a06db(e, r, a, s === 0 ? $39fb70ddd1e2f193$export$aa3a2e812ca8570d : i, f, o, l);
}
function $39fb70ddd1e2f193$export$4a34f930e789283c(e, r, a) {
    return $39fb70ddd1e2f193$export$35059013cd4a06db(e, r, a, $39fb70ddd1e2f193$export$a29989082612d0d9, $39fb70ddd1e2f193$export$6788812c4e6611e6($39fb70ddd1e2f193$export$eba6f6f03b0a92e7()), $39fb70ddd1e2f193$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $39fb70ddd1e2f193$export$f8483753829ec8f3(e, r, a, n) {
    return $39fb70ddd1e2f193$export$35059013cd4a06db(e, r, a, $39fb70ddd1e2f193$export$527d108ccf083c2b, $39fb70ddd1e2f193$export$2f35ab04d2335697(e, 0, n), $39fb70ddd1e2f193$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $39fb70ddd1e2f193$export$82e9f45cca5ba907(n, c, s) {
    switch($39fb70ddd1e2f193$export$d6af199866bfb566(n, c)){
        case 5103:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $39fb70ddd1e2f193$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$2c0f367103c8d01c + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($39fb70ddd1e2f193$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "box-$1$2" + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + "flex-item-" + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$39fb70ddd1e2f193$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + "grid-row-" + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + "flex-line-pack" + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "box-" + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, "-grow", "") + $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed($39fb70ddd1e2f193$export$77ad94ebf1c2b9ed($39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed($39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "box-pack:$3" + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$39fb70ddd1e2f193$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + "grid-column-align" + $39fb70ddd1e2f193$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $39fb70ddd1e2f193$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$39fb70ddd1e2f193$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$39fb70ddd1e2f193$export$f8e21b1e77979a08(s, "span") ? $39fb70ddd1e2f193$export$4659b591c19bdf3d(s, /\d+/) : +$39fb70ddd1e2f193$export$4659b591c19bdf3d(s, /\d+/) - +$39fb70ddd1e2f193$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $39fb70ddd1e2f193$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed($39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($39fb70ddd1e2f193$export$36776f635604f274(n) - 1 - c > 6) switch($39fb70ddd1e2f193$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($39fb70ddd1e2f193$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $39fb70ddd1e2f193$export$2c0f367103c8d01c + ($39fb70ddd1e2f193$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$39fb70ddd1e2f193$export$f8e21b1e77979a08(n, "stretch") ? $39fb70ddd1e2f193$export$82e9f45cca5ba907($39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($39fb70ddd1e2f193$export$a9db5e087081082d(n, c + 6) === 121) return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, ":", ":" + $39fb70ddd1e2f193$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($39fb70ddd1e2f193$export$a9db5e087081082d(n, $39fb70ddd1e2f193$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + ($39fb70ddd1e2f193$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, ":", ":" + $39fb70ddd1e2f193$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $39fb70ddd1e2f193$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $39fb70ddd1e2f193$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $39fb70ddd1e2f193$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $39fb70ddd1e2f193$export$a763edbf796b780a:
        case $39fb70ddd1e2f193$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $39fb70ddd1e2f193$export$a29989082612d0d9:
            return "";
        case $39fb70ddd1e2f193$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $39fb70ddd1e2f193$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $39fb70ddd1e2f193$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $39fb70ddd1e2f193$export$36776f635604f274(a = $39fb70ddd1e2f193$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $39fb70ddd1e2f193$export$5a7767152ae0305f(e) {
    var r = $39fb70ddd1e2f193$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $39fb70ddd1e2f193$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $39fb70ddd1e2f193$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $39fb70ddd1e2f193$export$527d108ccf083c2b:
                n.return = $39fb70ddd1e2f193$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $39fb70ddd1e2f193$export$b44a8529a35fcb60:
                return $39fb70ddd1e2f193$export$dfdc1655ccc5b9cb([
                    $39fb70ddd1e2f193$export$784d13d8ee351f07(n, {
                        value: $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $39fb70ddd1e2f193$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $39fb70ddd1e2f193$export$aa3a2e812ca8570d:
                if (n.length) return $39fb70ddd1e2f193$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($39fb70ddd1e2f193$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $39fb70ddd1e2f193$export$dfdc1655ccc5b9cb([
                                $39fb70ddd1e2f193$export$784d13d8ee351f07(n, {
                                    props: [
                                        $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $39fb70ddd1e2f193$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $39fb70ddd1e2f193$export$dfdc1655ccc5b9cb([
                                $39fb70ddd1e2f193$export$784d13d8ee351f07(n, {
                                    props: [
                                        $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $39fb70ddd1e2f193$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $39fb70ddd1e2f193$export$784d13d8ee351f07(n, {
                                    props: [
                                        $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $39fb70ddd1e2f193$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $39fb70ddd1e2f193$export$784d13d8ee351f07(n, {
                                    props: [
                                        $39fb70ddd1e2f193$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $39fb70ddd1e2f193$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $39fb70ddd1e2f193$export$76a88f7de6507443(e) {
    switch(e.type){
        case $39fb70ddd1e2f193$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $39fb70ddd1e2f193$export$1be1fc439b849fdf($39fb70ddd1e2f193$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($39fb70ddd1e2f193$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $39fb70ddd1e2f193$export$2f35ab04d2335697(r, 1, $39fb70ddd1e2f193$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $39fb70ddd1e2f193$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $39fb70ddd1e2f193$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $39fb70ddd1e2f193$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("5AVll", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $412ccbbca80b1ab5$export$2e2bcd8739ae039; });
var $412ccbbca80b1ab5$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $412ccbbca80b1ab5$export$2e2bcd8739ae039 = $412ccbbca80b1ab5$var$weakMemoize;

});

parcelRequire.register("7R3W4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b8089324dd74119$export$2e2bcd8739ae039; });
function $5b8089324dd74119$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $5b8089324dd74119$export$2e2bcd8739ae039 = $5b8089324dd74119$var$memoize;

});


parcelRequire.register("3SpgA", function(module, exports) {

$parcel$export(module.exports, "h", function () { return $2d2a03a5337c57d8$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $2d2a03a5337c57d8$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $2d2a03a5337c57d8$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $2d2a03a5337c57d8$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $2d2a03a5337c57d8$export$a9c23c6ac3fc3eca; });

var $4lkrv = parcelRequire("4lkrv");

var $b9MOd = parcelRequire("b9MOd");

var $9YD4s = parcelRequire("9YD4s");

var $5AVll = parcelRequire("5AVll");

var $jDgdM = parcelRequire("jDgdM");

var $iWlFq = parcelRequire("iWlFq");

var $eAHF1 = parcelRequire("eAHF1");

var $fn8Lu = parcelRequire("fn8Lu");
var $2d2a03a5337c57d8$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $2d2a03a5337c57d8$var$EmotionCacheContext = /* #__PURE__ */ (0, $4lkrv.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $b9MOd.default)({
    key: "css"
}) : null);
var $2d2a03a5337c57d8$export$e7094788287c5e9b = $2d2a03a5337c57d8$var$EmotionCacheContext.Provider;
var $2d2a03a5337c57d8$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $4lkrv.useContext)($2d2a03a5337c57d8$var$EmotionCacheContext);
};
var $2d2a03a5337c57d8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $4lkrv.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $4lkrv.useContext)($2d2a03a5337c57d8$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $2d2a03a5337c57d8$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $4lkrv.createContext)({});
var $2d2a03a5337c57d8$export$3b14a55fb2447963 = function useTheme() {
    return (0, $4lkrv.useContext)($2d2a03a5337c57d8$export$971d5caa766a69d7);
};
var $2d2a03a5337c57d8$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $9YD4s.default)({}, outerTheme, theme);
};
var $2d2a03a5337c57d8$var$createCacheWithTheme = /* #__PURE__ */ (0, $5AVll.default)(function(outerTheme) {
    return (0, $5AVll.default)(function(theme) {
        return $2d2a03a5337c57d8$var$getTheme(outerTheme, theme);
    });
});
var $2d2a03a5337c57d8$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = (0, $4lkrv.useContext)($2d2a03a5337c57d8$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $2d2a03a5337c57d8$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $4lkrv.createElement)($2d2a03a5337c57d8$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $2d2a03a5337c57d8$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = (0, $4lkrv.useContext)($2d2a03a5337c57d8$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $4lkrv.createElement)(Component, (0, $9YD4s.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $4lkrv.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $jDgdM.default)(WithTheme, Component);
}
var $2d2a03a5337c57d8$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $2d2a03a5337c57d8$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $2d2a03a5337c57d8$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $2d2a03a5337c57d8$var$getLastPart(match[1]);
    return undefined;
};
var $2d2a03a5337c57d8$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $2d2a03a5337c57d8$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $2d2a03a5337c57d8$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $2d2a03a5337c57d8$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($2d2a03a5337c57d8$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $2d2a03a5337c57d8$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $2d2a03a5337c57d8$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $2d2a03a5337c57d8$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $2d2a03a5337c57d8$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($2d2a03a5337c57d8$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$2d2a03a5337c57d8$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $2d2a03a5337c57d8$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $iWlFq.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $fn8Lu.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $iWlFq.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $2d2a03a5337c57d8$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $2d2a03a5337c57d8$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$2d2a03a5337c57d8$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $iWlFq.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $eAHF1.serializeStyles)(registeredStyles, undefined, (0, $4lkrv.useContext)($2d2a03a5337c57d8$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($2d2a03a5337c57d8$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $2d2a03a5337c57d8$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ (0, $4lkrv.createElement)((0, $4lkrv.Fragment), null, /*#__PURE__*/ (0, $4lkrv.createElement)($2d2a03a5337c57d8$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ (0, $4lkrv.createElement)(WrappedComponent, newProps));
});

});
parcelRequire.register("jDgdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4ae3e04a51b6db4$export$2e2bcd8739ae039; });

var $43t7c = parcelRequire("43t7c");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $e4ae3e04a51b6db4$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($43t7c)))(targetComponent, sourceComponent);
};
var $e4ae3e04a51b6db4$export$2e2bcd8739ae039 = $e4ae3e04a51b6db4$var$hoistNonReactStatics;

});
parcelRequire.register("43t7c", function(module, exports) {
"use strict";

var $8qTSC = parcelRequire("8qTSC");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $2f3e06e45d666bed$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $2f3e06e45d666bed$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $2f3e06e45d666bed$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $2f3e06e45d666bed$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $2f3e06e45d666bed$var$TYPE_STATICS = {};
$2f3e06e45d666bed$var$TYPE_STATICS[$8qTSC.ForwardRef] = $2f3e06e45d666bed$var$FORWARD_REF_STATICS;
$2f3e06e45d666bed$var$TYPE_STATICS[$8qTSC.Memo] = $2f3e06e45d666bed$var$MEMO_STATICS;
function $2f3e06e45d666bed$var$getStatics(component) {
    // React v16.11 and below
    if ($8qTSC.isMemo(component)) return $2f3e06e45d666bed$var$MEMO_STATICS;
     // React v16.12 and above
    return $2f3e06e45d666bed$var$TYPE_STATICS[component["$$typeof"]] || $2f3e06e45d666bed$var$REACT_STATICS;
}
var $2f3e06e45d666bed$var$defineProperty = Object.defineProperty;
var $2f3e06e45d666bed$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $2f3e06e45d666bed$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $2f3e06e45d666bed$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2f3e06e45d666bed$var$getPrototypeOf = Object.getPrototypeOf;
var $2f3e06e45d666bed$var$objectPrototype = Object.prototype;
function $2f3e06e45d666bed$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($2f3e06e45d666bed$var$objectPrototype) {
            var inheritedComponent = $2f3e06e45d666bed$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $2f3e06e45d666bed$var$objectPrototype) $2f3e06e45d666bed$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $2f3e06e45d666bed$var$getOwnPropertyNames(sourceComponent);
        if ($2f3e06e45d666bed$var$getOwnPropertySymbols) keys = keys.concat($2f3e06e45d666bed$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $2f3e06e45d666bed$var$getStatics(targetComponent);
        var sourceStatics = $2f3e06e45d666bed$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$2f3e06e45d666bed$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $2f3e06e45d666bed$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $2f3e06e45d666bed$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $2f3e06e45d666bed$var$hoistNonReactStatics;

});
parcelRequire.register("8qTSC", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lfOSa"));

});



parcelRequire.register("iWlFq", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $dc9e736d6c1ff491$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $dc9e736d6c1ff491$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $dc9e736d6c1ff491$export$6f077d94b33a01aa; });
var $dc9e736d6c1ff491$var$isBrowser = true;
function $dc9e736d6c1ff491$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $dc9e736d6c1ff491$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $dc9e736d6c1ff491$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $dc9e736d6c1ff491$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $dc9e736d6c1ff491$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRequire.register("eAHF1", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $a9f64b9255198d75$export$6321afa313b251b5; });

var $ap71u = parcelRequire("ap71u");

var $lCO8l = parcelRequire("lCO8l");

var $7R3W4 = parcelRequire("7R3W4");
var $a9f64b9255198d75$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $a9f64b9255198d75$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $a9f64b9255198d75$var$hyphenateRegex = /[A-Z]|^ms/g;
var $a9f64b9255198d75$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $a9f64b9255198d75$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $a9f64b9255198d75$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $a9f64b9255198d75$var$processStyleName = /* #__PURE__ */ (0, $7R3W4.default)(function(styleName) {
    return $a9f64b9255198d75$var$isCustomProperty(styleName) ? styleName : styleName.replace($a9f64b9255198d75$var$hyphenateRegex, "-$&").toLowerCase();
});
var $a9f64b9255198d75$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($a9f64b9255198d75$var$animationRegex, function(match, p1, p2) {
                $a9f64b9255198d75$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $a9f64b9255198d75$var$cursor
                };
                return p1;
            });
    }
    if ((0, $lCO8l.default)[key] !== 1 && !$a9f64b9255198d75$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $a9f64b9255198d75$var$contentValuePattern, $a9f64b9255198d75$var$contentValues, $a9f64b9255198d75$var$oldProcessStyleValue, $a9f64b9255198d75$var$msPattern, $a9f64b9255198d75$var$hyphenPattern, $a9f64b9255198d75$var$hyphenatedCache;
var $a9f64b9255198d75$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $a9f64b9255198d75$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $a9f64b9255198d75$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $a9f64b9255198d75$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $a9f64b9255198d75$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $a9f64b9255198d75$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $a9f64b9255198d75$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $a9f64b9255198d75$var$cursor;
                var result = interpolation(mergedProps);
                $a9f64b9255198d75$var$cursor = previousCursor;
                return $a9f64b9255198d75$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $a9f64b9255198d75$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $a9f64b9255198d75$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($a9f64b9255198d75$var$isProcessableValue(value)) string += $a9f64b9255198d75$var$processStyleName(_key) + ":" + $a9f64b9255198d75$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($a9f64b9255198d75$var$isProcessableValue(value[_i])) string += $a9f64b9255198d75$var$processStyleName(_key) + ":" + $a9f64b9255198d75$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $a9f64b9255198d75$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $a9f64b9255198d75$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $a9f64b9255198d75$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $a9f64b9255198d75$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $a9f64b9255198d75$var$cursor;
var $a9f64b9255198d75$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $a9f64b9255198d75$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $a9f64b9255198d75$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $a9f64b9255198d75$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $a9f64b9255198d75$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $a9f64b9255198d75$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $ap71u.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $a9f64b9255198d75$var$cursor
    };
};

});
parcelRequire.register("ap71u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7931afcc35e3a4f4$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7931afcc35e3a4f4$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $7931afcc35e3a4f4$export$2e2bcd8739ae039 = $7931afcc35e3a4f4$var$murmur2;

});

parcelRequire.register("lCO8l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbe4090e95bea3df$export$2e2bcd8739ae039; });
var $fbe4090e95bea3df$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $fbe4090e95bea3df$export$2e2bcd8739ae039 = $fbe4090e95bea3df$var$unitlessKeys;

});


parcelRequire.register("fn8Lu", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $b30fcd8f3876d723$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $b30fcd8f3876d723$export$811a713a7276cb9d; });

var $4lkrv = parcelRequire("4lkrv");
var $b30fcd8f3876d723$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b30fcd8f3876d723$var$useInsertionEffect = $4lkrv.useInsertionEffect ? $4lkrv.useInsertionEffect : false;
var $b30fcd8f3876d723$export$db21c7ffa21794e7 = $b30fcd8f3876d723$var$useInsertionEffect || $b30fcd8f3876d723$var$syncFallback;
var $b30fcd8f3876d723$export$811a713a7276cb9d = $b30fcd8f3876d723$var$useInsertionEffect || (0, $4lkrv.useLayoutEffect);

});


parcelRequire.register("9cWX8", function(module, exports) {
function $6b42f6d4f090bb25$var$_extends() {
    module.exports = $6b42f6d4f090bb25$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $6b42f6d4f090bb25$var$_extends.apply(this, arguments);
}
module.exports = $6b42f6d4f090bb25$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRequire.register("ksq4v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee4aa574f5d11108$export$2e2bcd8739ae039; });

var $hCTiq = parcelRequire("hCTiq");
const $ee4aa574f5d11108$var$defaultTheme = (0, $hCTiq.default)();
var $ee4aa574f5d11108$export$2e2bcd8739ae039 = $ee4aa574f5d11108$var$defaultTheme;

});
parcelRequire.register("hCTiq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd50e0f85a5706a1$export$2e2bcd8739ae039; });

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $3ocmy = parcelRequire("3ocmy");
var $gp8jy = parcelRequire("gp8jy");


var $l77nE = parcelRequire("l77nE");

var $gmFgX = parcelRequire("gmFgX");

var $7T4rm = parcelRequire("7T4rm");

var $4yBGH = parcelRequire("4yBGH");

var $1ZNBX = parcelRequire("1ZNBX");

var $hzi1X = parcelRequire("hzi1X");

var $9lLTq = parcelRequire("9lLTq");
const $cd50e0f85a5706a1$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $cd50e0f85a5706a1$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {} , palette: paletteInput = {} , transitions: transitionsInput = {} , typography: typographyInput = {}  } = options, other = (0, $eLWn9.default)(options, $cd50e0f85a5706a1$var$_excluded);
    if (options.vars) throw new Error((0, $gp8jy.default)(18));
    const palette = (0, $7T4rm.default)(paletteInput);
    const systemTheme = (0, $l77nE.default)(options);
    let muiTheme = (0, $3ocmy.default)(systemTheme, {
        mixins: (0, $gmFgX.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $1ZNBX.default).slice(),
        typography: (0, $4yBGH.default)(palette, typographyInput),
        transitions: (0, $hzi1X.default)(transitionsInput),
        zIndex: (0, $9YD4s.default)({}, (0, $9lLTq.default))
    });
    muiTheme = (0, $3ocmy.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3ocmy.default)(acc, argument), muiTheme);
    var component;
    return muiTheme;
}
let $cd50e0f85a5706a1$var$warnedOnce = false;
function $cd50e0f85a5706a1$export$c469355549431d9b(...args) {
    return $cd50e0f85a5706a1$var$createTheme(...args);
}
var $cd50e0f85a5706a1$export$2e2bcd8739ae039 = $cd50e0f85a5706a1$var$createTheme;

});
parcelRequire.register("gmFgX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be9eb74b04063ce5$export$2e2bcd8739ae039; });

var $9YD4s = parcelRequire("9YD4s");
function $be9eb74b04063ce5$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $9YD4s.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRequire.register("7T4rm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5be11d312ac4465d$export$2e2bcd8739ae039; });

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $3ocmy = parcelRequire("3ocmy");
var $gp8jy = parcelRequire("gp8jy");

var $kFXNp = parcelRequire("kFXNp");

var $5Vu5D = parcelRequire("5Vu5D");

var $ayZqg = parcelRequire("ayZqg");

var $lELwo = parcelRequire("lELwo");

var $ioBN3 = parcelRequire("ioBN3");

var $9oVqX = parcelRequire("9oVqX");

var $9qm5G = parcelRequire("9qm5G");

var $hqMfV = parcelRequire("hqMfV");

var $5GoPS = parcelRequire("5GoPS");
const $5be11d312ac4465d$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $5be11d312ac4465d$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $5Vu5D.default).white,
        default: (0, $5Vu5D.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $5be11d312ac4465d$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $5Vu5D.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $5Vu5D.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $5be11d312ac4465d$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $kFXNp.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $kFXNp.darken)(intent.main, tonalOffsetDark);
    }
}
function $5be11d312ac4465d$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $9qm5G.default)[200],
        light: (0, $9qm5G.default)[50],
        dark: (0, $9qm5G.default)[400]
    };
    return {
        main: (0, $9qm5G.default)[700],
        light: (0, $9qm5G.default)[400],
        dark: (0, $9qm5G.default)[800]
    };
}
function $5be11d312ac4465d$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $lELwo.default)[200],
        light: (0, $lELwo.default)[50],
        dark: (0, $lELwo.default)[400]
    };
    return {
        main: (0, $lELwo.default)[500],
        light: (0, $lELwo.default)[300],
        dark: (0, $lELwo.default)[700]
    };
}
function $5be11d312ac4465d$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $ioBN3.default)[500],
        light: (0, $ioBN3.default)[300],
        dark: (0, $ioBN3.default)[700]
    };
    return {
        main: (0, $ioBN3.default)[700],
        light: (0, $ioBN3.default)[400],
        dark: (0, $ioBN3.default)[800]
    };
}
function $5be11d312ac4465d$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $hqMfV.default)[400],
        light: (0, $hqMfV.default)[300],
        dark: (0, $hqMfV.default)[700]
    };
    return {
        main: (0, $hqMfV.default)[700],
        light: (0, $hqMfV.default)[500],
        dark: (0, $hqMfV.default)[900]
    };
}
function $5be11d312ac4465d$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5GoPS.default)[400],
        light: (0, $5GoPS.default)[300],
        dark: (0, $5GoPS.default)[700]
    };
    return {
        main: (0, $5GoPS.default)[800],
        light: (0, $5GoPS.default)[500],
        dark: (0, $5GoPS.default)[900]
    };
}
function $5be11d312ac4465d$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $9oVqX.default)[400],
        light: (0, $9oVqX.default)[300],
        dark: (0, $9oVqX.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $9oVqX.default)[500],
        dark: (0, $9oVqX.default)[900]
    };
}
function $5be11d312ac4465d$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light" , contrastThreshold: contrastThreshold = 3 , tonalOffset: tonalOffset = 0.2  } = palette, other = (0, $eLWn9.default)(palette, $5be11d312ac4465d$var$_excluded);
    const primary = palette.primary || $5be11d312ac4465d$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $5be11d312ac4465d$var$getDefaultSecondary(mode);
    const error = palette.error || $5be11d312ac4465d$var$getDefaultError(mode);
    const info = palette.info || $5be11d312ac4465d$var$getDefaultInfo(mode);
    const success = palette.success || $5be11d312ac4465d$var$getDefaultSuccess(mode);
    const warning = palette.warning || $5be11d312ac4465d$var$getDefaultWarning(mode); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kFXNp.getContrastRatio)(background, $5be11d312ac4465d$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $5be11d312ac4465d$export$55ce6f3a06c59543.text.primary : $5be11d312ac4465d$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color , name: name , mainShade: mainShade = 500 , lightShade: lightShade = 300 , darkShade: darkShade = 700  })=>{
        color = (0, $9YD4s.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $gp8jy.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $gp8jy.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $5be11d312ac4465d$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $5be11d312ac4465d$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $5be11d312ac4465d$export$55ce6f3a06c59543,
        light: $5be11d312ac4465d$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3ocmy.default)((0, $9YD4s.default)({
        // A collection of common colors.
        common: (0, $9YD4s.default)({}, (0, $5Vu5D.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $ayZqg.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRequire.register("kFXNp", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $f0d605325a044d11$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $f0d605325a044d11$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $f0d605325a044d11$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $f0d605325a044d11$export$c0816ed86df316af; });

var $gp8jy = parcelRequire("gp8jy");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f0d605325a044d11$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $f0d605325a044d11$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $f0d605325a044d11$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $f0d605325a044d11$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $f0d605325a044d11$export$677b39864803984e($f0d605325a044d11$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $gp8jy.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $gp8jy.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $f0d605325a044d11$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $f0d605325a044d11$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $f0d605325a044d11$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $f0d605325a044d11$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $f0d605325a044d11$export$211a73f2b8c10ce4(color) {
    const { type: type , colorSpace: colorSpace  } = color;
    let { values: values  } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $f0d605325a044d11$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values  } = $f0d605325a044d11$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$f0d605325a044d11$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $f0d605325a044d11$export$29fb7152bd3f781a(color) {
    color = $f0d605325a044d11$export$677b39864803984e(color);
    const { values: values  } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $f0d605325a044d11$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $f0d605325a044d11$export$c852d90bf7403b62(color) {
    color = $f0d605325a044d11$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $f0d605325a044d11$export$677b39864803984e($f0d605325a044d11$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $f0d605325a044d11$export$d061e26956a60b0a(foreground, background) {
    const lumA = $f0d605325a044d11$export$c852d90bf7403b62(foreground);
    const lumB = $f0d605325a044d11$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $f0d605325a044d11$export$58f0f39f63f3cf42(color, value) {
    color = $f0d605325a044d11$export$677b39864803984e(color);
    value = $f0d605325a044d11$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f0d605325a044d11$export$211a73f2b8c10ce4(color);
}
function $f0d605325a044d11$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $f0d605325a044d11$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $f0d605325a044d11$export$4b073707ff63303(color, coefficient) {
    color = $f0d605325a044d11$export$677b39864803984e(color);
    coefficient = $f0d605325a044d11$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f0d605325a044d11$export$211a73f2b8c10ce4(color);
}
function $f0d605325a044d11$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $f0d605325a044d11$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $f0d605325a044d11$export$c0816ed86df316af(color, coefficient) {
    color = $f0d605325a044d11$export$677b39864803984e(color);
    coefficient = $f0d605325a044d11$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f0d605325a044d11$export$211a73f2b8c10ce4(color);
}
function $f0d605325a044d11$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $f0d605325a044d11$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $f0d605325a044d11$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $f0d605325a044d11$export$c852d90bf7403b62(color) > 0.5 ? $f0d605325a044d11$export$4b073707ff63303(color, coefficient) : $f0d605325a044d11$export$c0816ed86df316af(color, coefficient);
}
function $f0d605325a044d11$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $f0d605325a044d11$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});

parcelRequire.register("5Vu5D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45099ddade27f896$export$2e2bcd8739ae039; });
const $45099ddade27f896$var$common = {
    black: "#000",
    white: "#fff"
};
var $45099ddade27f896$export$2e2bcd8739ae039 = $45099ddade27f896$var$common;

});

parcelRequire.register("ayZqg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b0cb99ef61c4fc2$export$2e2bcd8739ae039; });
const $7b0cb99ef61c4fc2$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $7b0cb99ef61c4fc2$export$2e2bcd8739ae039 = $7b0cb99ef61c4fc2$var$grey;

});

parcelRequire.register("lELwo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc42322af85335bb$export$2e2bcd8739ae039; });
const $fc42322af85335bb$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $fc42322af85335bb$export$2e2bcd8739ae039 = $fc42322af85335bb$var$purple;

});

parcelRequire.register("ioBN3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d647c83ccf09a6f7$export$2e2bcd8739ae039; });
const $d647c83ccf09a6f7$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $d647c83ccf09a6f7$export$2e2bcd8739ae039 = $d647c83ccf09a6f7$var$red;

});

parcelRequire.register("9oVqX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d82e81f2e98962c$export$2e2bcd8739ae039; });
const $6d82e81f2e98962c$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $6d82e81f2e98962c$export$2e2bcd8739ae039 = $6d82e81f2e98962c$var$orange;

});

parcelRequire.register("9qm5G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dc7ad88be5631b8$export$2e2bcd8739ae039; });
const $6dc7ad88be5631b8$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $6dc7ad88be5631b8$export$2e2bcd8739ae039 = $6dc7ad88be5631b8$var$blue;

});

parcelRequire.register("hqMfV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0a4bfad80b9d42$export$2e2bcd8739ae039; });
const $cb0a4bfad80b9d42$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $cb0a4bfad80b9d42$export$2e2bcd8739ae039 = $cb0a4bfad80b9d42$var$lightBlue;

});

parcelRequire.register("5GoPS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $423423d5cbab8b93$export$2e2bcd8739ae039; });
const $423423d5cbab8b93$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $423423d5cbab8b93$export$2e2bcd8739ae039 = $423423d5cbab8b93$var$green;

});


parcelRequire.register("4yBGH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35179265b41dba6a$export$2e2bcd8739ae039; });

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $3ocmy = parcelRequire("3ocmy");
const $35179265b41dba6a$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $35179265b41dba6a$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $35179265b41dba6a$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $35179265b41dba6a$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $35179265b41dba6a$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $35179265b41dba6a$var$defaultFontFamily , fontSize: // The default font size of the Material Specification.
    fontSize = 14 , fontWeightLight: // px
    fontWeightLight = 300 , fontWeightRegular: fontWeightRegular = 400 , fontWeightMedium: fontWeightMedium = 500 , fontWeightBold: fontWeightBold = 700 , htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16 , allVariants: // Apply the CSS properties to all the variants.
    allVariants , pxToRem: pxToRem2  } = _ref, other = (0, $eLWn9.default)(_ref, $35179265b41dba6a$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $9YD4s.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $35179265b41dba6a$var$defaultFontFamily ? {
            letterSpacing: `${$35179265b41dba6a$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $35179265b41dba6a$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $35179265b41dba6a$var$caseAllCaps)
    };
    return (0, $3ocmy.default)((0, $9YD4s.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("1ZNBX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1741f8af798b8371$export$2e2bcd8739ae039; });
const $1741f8af798b8371$var$shadowKeyUmbraOpacity = 0.2;
const $1741f8af798b8371$var$shadowKeyPenumbraOpacity = 0.14;
const $1741f8af798b8371$var$shadowAmbientShadowOpacity = 0.12;
function $1741f8af798b8371$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$1741f8af798b8371$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$1741f8af798b8371$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$1741f8af798b8371$var$shadowAmbientShadowOpacity})`
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $1741f8af798b8371$var$shadows = [
    "none",
    $1741f8af798b8371$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $1741f8af798b8371$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $1741f8af798b8371$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $1741f8af798b8371$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $1741f8af798b8371$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $1741f8af798b8371$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $1741f8af798b8371$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $1741f8af798b8371$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $1741f8af798b8371$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $1741f8af798b8371$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $1741f8af798b8371$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $1741f8af798b8371$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $1741f8af798b8371$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $1741f8af798b8371$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $1741f8af798b8371$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $1741f8af798b8371$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $1741f8af798b8371$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $1741f8af798b8371$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $1741f8af798b8371$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $1741f8af798b8371$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $1741f8af798b8371$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $1741f8af798b8371$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $1741f8af798b8371$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $1741f8af798b8371$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $1741f8af798b8371$export$2e2bcd8739ae039 = $1741f8af798b8371$var$shadows;

});

parcelRequire.register("hzi1X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cca3b111ebbf3623$export$2e2bcd8739ae039; });

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");
const $cca3b111ebbf3623$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $cca3b111ebbf3623$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
const $cca3b111ebbf3623$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $cca3b111ebbf3623$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $cca3b111ebbf3623$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $cca3b111ebbf3623$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $9YD4s.default)({}, $cca3b111ebbf3623$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $9YD4s.default)({}, $cca3b111ebbf3623$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard , easing: easingOption = mergedEasing.easeInOut , delay: delay = 0  } = options, other = (0, $eLWn9.default)(options, $cca3b111ebbf3623$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $cca3b111ebbf3623$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $cca3b111ebbf3623$var$formatMs(delay)}`).join(",");
    };
    return (0, $9YD4s.default)({
        getAutoHeightDuration: $cca3b111ebbf3623$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRequire.register("9lLTq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ceb39bf96151689$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $6ceb39bf96151689$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $6ceb39bf96151689$export$2e2bcd8739ae039 = $6ceb39bf96151689$var$zIndex;

});




parcelRequire.register("bgnZl", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $8333cbf507da4fcd$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $8333cbf507da4fcd$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $8333cbf507da4fcd$export$2e2bcd8739ae039; });

var $i0DZt = parcelRequire("i0DZt");

var $ksq4v = parcelRequire("ksq4v");
const $8333cbf507da4fcd$export$effb20ecdbf4d6aa = (prop)=>(0, $i0DZt.shouldForwardProp)(prop) && prop !== "classes";
const $8333cbf507da4fcd$export$f10c5a10d27438e5 = (0, $i0DZt.shouldForwardProp);
const $8333cbf507da4fcd$var$styled = (0, $i0DZt.default)({
    defaultTheme: $ksq4v.default,
    rootShouldForwardProp: $8333cbf507da4fcd$export$effb20ecdbf4d6aa
});
var $8333cbf507da4fcd$export$2e2bcd8739ae039 = $8333cbf507da4fcd$var$styled;

});
parcelRequire.register("i0DZt", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $d1c73f614b72a727$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $d1c73f614b72a727$export$2e2bcd8739ae039; });

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4pHkY = parcelRequire("4pHkY");


var $l77nE = parcelRequire("l77nE");

var $W6wXO = parcelRequire("W6wXO");

var $gNSaz = parcelRequire("gNSaz");
const $d1c73f614b72a727$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $d1c73f614b72a727$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $d1c73f614b72a727$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $d1c73f614b72a727$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $d1c73f614b72a727$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $W6wXO.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $d1c73f614b72a727$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {}  } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $W6wXO.default)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $d1c73f614b72a727$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $d1c73f614b72a727$export$35e57303dbd8a66 = (0, $l77nE.default)();
const $d1c73f614b72a727$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $d1c73f614b72a727$var$resolveTheme({ defaultTheme: defaultTheme , theme: theme , themeId: themeId  }) {
    return $d1c73f614b72a727$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $d1c73f614b72a727$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId , defaultTheme: defaultTheme = $d1c73f614b72a727$export$35e57303dbd8a66 , rootShouldForwardProp: rootShouldForwardProp = $d1c73f614b72a727$export$3ba67b570e26eea0 , slotShouldForwardProp: slotShouldForwardProp = $d1c73f614b72a727$export$3ba67b570e26eea0  } = input;
    const systemSx = (props)=>{
        return (0, $gNSaz.default)((0, $9YD4s.default)({}, props, {
            theme: $d1c73f614b72a727$var$resolveTheme((0, $9YD4s.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $4pHkY.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName , slot: componentSlot , skipVariantsResolver: inputSkipVariantsResolver , skipSx: inputSkipSx , overridesResolver: overridesResolver  } = inputOptions, options = (0, $eLWn9.default)(inputOptions, $d1c73f614b72a727$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $d1c73f614b72a727$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($d1c73f614b72a727$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $4pHkY.default)(tag, (0, $9YD4s.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (props)=>{
                    return stylesArg((0, $9YD4s.default)({}, props, {
                        theme: $d1c73f614b72a727$var$resolveTheme((0, $9YD4s.default)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $d1c73f614b72a727$var$resolveTheme((0, $9YD4s.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $d1c73f614b72a727$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $9YD4s.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $d1c73f614b72a727$var$resolveTheme((0, $9YD4s.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $d1c73f614b72a727$var$variantsResolver(props, $d1c73f614b72a727$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>styleArg((0, $9YD4s.default)({}, props, {
                    theme: $d1c73f614b72a727$var$resolveTheme((0, $9YD4s.default)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRequire.register("4pHkY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $336b1d19e56296e3$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $336b1d19e56296e3$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.12.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $jiV72 = parcelRequire("jiV72");
parcelRequire("35uzv");
var $3SpgA = parcelRequire("3SpgA");
var $35uzv = parcelRequire("35uzv");


var $1NUoC = parcelRequire("1NUoC");
function $336b1d19e56296e3$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $jiV72.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $336b1d19e56296e3$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRequire.register("jiV72", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0dc001c550c47dc$export$2e2bcd8739ae039; });
parcelRequire("9cWX8");
parcelRequire("4lkrv");
parcelRequire("92qxR");

var $8brV1 = parcelRequire("8brV1");

parcelRequire("iWlFq");
parcelRequire("eAHF1");
parcelRequire("fn8Lu");
var $e0dc001c550c47dc$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $e0dc001c550c47dc$var$newStyled = (0, $8brV1.default).bind();
$e0dc001c550c47dc$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $e0dc001c550c47dc$var$newStyled[tagName] = $e0dc001c550c47dc$var$newStyled(tagName);
});
var $e0dc001c550c47dc$export$2e2bcd8739ae039 = $e0dc001c550c47dc$var$newStyled;

});
parcelRequire.register("92qxR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6948e444f3ac5980$export$2e2bcd8739ae039; });

var $7R3W4 = parcelRequire("7R3W4");
var $6948e444f3ac5980$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $6948e444f3ac5980$var$isPropValid = /* #__PURE__ */ (0, $7R3W4.default)(function(prop) {
    return $6948e444f3ac5980$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $6948e444f3ac5980$export$2e2bcd8739ae039 = $6948e444f3ac5980$var$isPropValid;

});

parcelRequire.register("8brV1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f5501e2710e0083$export$2e2bcd8739ae039; });

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");

var $92qxR = parcelRequire("92qxR");
parcelRequire("35uzv");
var $3SpgA = parcelRequire("3SpgA");

var $iWlFq = parcelRequire("iWlFq");

var $eAHF1 = parcelRequire("eAHF1");

var $fn8Lu = parcelRequire("fn8Lu");
var $5f5501e2710e0083$var$testOmitPropsOnStringTag = (0, $92qxR.default);
var $5f5501e2710e0083$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $5f5501e2710e0083$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $5f5501e2710e0083$var$testOmitPropsOnStringTag : $5f5501e2710e0083$var$testOmitPropsOnComponent;
};
var $5f5501e2710e0083$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $5f5501e2710e0083$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $5f5501e2710e0083$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $iWlFq.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $fn8Lu.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $iWlFq.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $5f5501e2710e0083$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $5f5501e2710e0083$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $5f5501e2710e0083$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $3SpgA.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $4lkrv.useContext)((0, $3SpgA.T));
            }
            if (typeof props.className === "string") className = (0, $iWlFq.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $eAHF1.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $5f5501e2710e0083$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $4lkrv.createElement)((0, $4lkrv.Fragment), null, /*#__PURE__*/ (0, $4lkrv.createElement)($5f5501e2710e0083$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ (0, $4lkrv.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $9YD4s.default)({}, options, nextOptions, {
                shouldForwardProp: $5f5501e2710e0083$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $5f5501e2710e0083$export$2e2bcd8739ae039 = $5f5501e2710e0083$var$createStyled;

});


parcelRequire.register("1NUoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15061d279d23836c$export$2e2bcd8739ae039; });
parcelRequire("4lkrv");


var $35uzv = parcelRequire("35uzv");

var $gWMia = parcelRequire("gWMia");
function $15061d279d23836c$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $15061d279d23836c$export$2e2bcd8739ae039(props) {
    const { styles: styles , defaultTheme: defaultTheme = {}  } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($15061d279d23836c$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $35uzv.Global), {
        styles: globalStyles
    });
}

});
parcelRequire.register("gWMia", function(module, exports) {
"use strict";

module.exports = (parcelRequire("e8l21"));

});



parcelRequire.register("W6wXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aea7bbffdfbd8f9$export$2e2bcd8739ae039; });

var $eLWn9 = parcelRequire("eLWn9");

var $1Z8IT = parcelRequire("1Z8IT");
const $0aea7bbffdfbd8f9$var$_excluded = [
    "variant"
];
function $0aea7bbffdfbd8f9$var$isEmpty(string) {
    return string.length === 0;
}
function $0aea7bbffdfbd8f9$export$2e2bcd8739ae039(props) {
    const { variant: variant  } = props, other = (0, $eLWn9.default)(props, $0aea7bbffdfbd8f9$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $0aea7bbffdfbd8f9$var$isEmpty(classKey) ? props[key] : (0, $1Z8IT.default)(props[key]);
        else classKey += `${$0aea7bbffdfbd8f9$var$isEmpty(classKey) ? key : (0, $1Z8IT.default)(key)}${(0, $1Z8IT.default)(props[key].toString())}`;
    });
    return classKey;
}

});



parcelRequire.register("3o6xx", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $2778afb559d577e2$export$c7c50641356bdfa5; });

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $2778afb559d577e2$export$c7c50641356bdfa5(slot) {
    return (0, $1HGD7.default)("MuiSvgIcon", slot);
}
const $2778afb559d577e2$var$svgIconClasses = (0, $3TIMy.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $2778afb559d577e2$export$2e2bcd8739ae039 = $2778afb559d577e2$var$svgIconClasses;

});
parcelRequire.register("1HGD7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13dae0041c3080a6$export$2e2bcd8739ae039; });

var $6HhiO = parcelRequire("6HhiO");
const $13dae0041c3080a6$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    readOnly: "readOnly",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    required: "required",
    selected: "selected"
};
function $13dae0041c3080a6$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $13dae0041c3080a6$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $6HhiO.default).generate(componentName)}-${slot}`;
}

});
parcelRequire.register("6HhiO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e042e1ba7d01a8a$export$2e2bcd8739ae039; });
const $4e042e1ba7d01a8a$var$defaultGenerator = (componentName)=>componentName;
const $4e042e1ba7d01a8a$var$createClassNameGenerator = ()=>{
    let generate = $4e042e1ba7d01a8a$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $4e042e1ba7d01a8a$var$defaultGenerator;
        }
    };
};
const $4e042e1ba7d01a8a$var$ClassNameGenerator = $4e042e1ba7d01a8a$var$createClassNameGenerator();
var $4e042e1ba7d01a8a$export$2e2bcd8739ae039 = $4e042e1ba7d01a8a$var$ClassNameGenerator;

});


parcelRequire.register("3TIMy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d693ef36fa33e4c$export$2e2bcd8739ae039; });

var $1HGD7 = parcelRequire("1HGD7");
function $2d693ef36fa33e4c$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $1HGD7.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});





parcelRequire.register("hEj67", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    var _$breadcrumbTypes_8 = [
        "navigation",
        "request",
        "process",
        "log",
        "user",
        "state",
        "error",
        "manual"
    ];
    // Array#reduce
    var _$reduce_17 = function(arr, fn, accum) {
        var val = accum;
        for(var i = 0, len = arr.length; i < len; i++)val = fn(val, arr[i], i, arr);
        return val;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#filter
    var _$filter_12 = function(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return !fn(item, i, arr) ? accum : accum.concat(item);
        }, []);
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#includes
    var _$includes_13 = function(arr, x) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum === true || item === x;
        }, false);
    };
    // Array#isArray
    var _$isArray_14 = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    /* eslint-disable-next-line no-prototype-builtins */ var _hasDontEnumBug = !({
        toString: null
    }).propertyIsEnumerable("toString");
    var _dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    // Object#keys
    var _$keys_15 = function(obj) {
        // stripped down version of
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
        var result = [];
        var prop;
        for(prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
        if (!_hasDontEnumBug) return result;
        for(var i = 0, len = _dontEnums.length; i < len; i++)if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
        return result;
    };
    var _$intRange_24 = function(min, max) {
        if (min === void 0) min = 1;
        if (max === void 0) max = Infinity;
        return function(value) {
            return typeof value === "number" && parseInt("" + value, 10) === value && value >= min && value <= max;
        };
    }; /* removed: var _$filter_12 = require('../es-utils/filter'); */ 
    var _$listOfFunctions_25 = function(value) {
        return typeof value === "function" || _$isArray_14(value) && _$filter_12(value, function(f) {
            return typeof f === "function";
        }).length === value.length;
    };
    var _$stringWithLength_26 = function(value) {
        return typeof value === "string" && !!value.length;
    };
    var _$config_5 = {}; /* removed: var _$filter_12 = require('./lib/es-utils/filter'); */ 
    var defaultErrorTypes = function() {
        return {
            unhandledExceptions: true,
            unhandledRejections: true
        };
    };
    _$config_5.schema = {
        apiKey: {
            defaultValue: function() {
                return null;
            },
            message: "is required",
            validate: _$stringWithLength_26
        },
        appVersion: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        appType: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        autoDetectErrors: {
            defaultValue: function() {
                return true;
            },
            message: "should be true|false",
            validate: function(value) {
                return value === true || value === false;
            }
        },
        enabledErrorTypes: {
            defaultValue: function() {
                return defaultErrorTypes();
            },
            message: "should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }",
            allowPartialObject: true,
            validate: function(value) {
                // ensure we have an object
                if (typeof value !== "object" || !value) return false;
                var providedKeys = _$keys_15(value);
                var defaultKeys = _$keys_15(defaultErrorTypes());
                // ensure it only has a subset of the allowed keys
                if (_$filter_12(providedKeys, function(k) {
                    return _$includes_13(defaultKeys, k);
                }).length < providedKeys.length) return false;
                // ensure all of the values are boolean
                if (_$filter_12(_$keys_15(value), function(k) {
                    return typeof value[k] !== "boolean";
                }).length > 0) return false;
                return true;
            }
        },
        onError: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        onSession: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        onBreadcrumb: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        endpoints: {
            defaultValue: function() {
                return {
                    notify: "https://notify.bugsnag.com",
                    sessions: "https://sessions.bugsnag.com"
                };
            },
            message: "should be an object containing endpoint URLs { notify, sessions }",
            validate: function(val) {
                return(// first, ensure it's an object
                val && typeof val === "object" && // notify and sessions must always be set
                _$stringWithLength_26(val.notify) && _$stringWithLength_26(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
                _$filter_12(_$keys_15(val), function(k) {
                    return !_$includes_13([
                        "notify",
                        "sessions"
                    ], k);
                }).length === 0);
            }
        },
        autoTrackSessions: {
            defaultValue: function(val) {
                return true;
            },
            message: "should be true|false",
            validate: function(val) {
                return val === true || val === false;
            }
        },
        enabledReleaseStages: {
            defaultValue: function() {
                return null;
            },
            message: "should be an array of strings",
            validate: function(value) {
                return value === null || _$isArray_14(value) && _$filter_12(value, function(f) {
                    return typeof f === "string";
                }).length === value.length;
            }
        },
        releaseStage: {
            defaultValue: function() {
                return "production";
            },
            message: "should be a string",
            validate: function(value) {
                return typeof value === "string" && value.length;
            }
        },
        maxBreadcrumbs: {
            defaultValue: function() {
                return 25;
            },
            message: "should be a number ≤100",
            validate: function(value) {
                return _$intRange_24(0, 100)(value);
            }
        },
        enabledBreadcrumbTypes: {
            defaultValue: function() {
                return _$breadcrumbTypes_8;
            },
            message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_8.join(",") + ")",
            validate: function(value) {
                return value === null || _$isArray_14(value) && _$reduce_17(value, function(accum, maybeType) {
                    if (accum === false) return accum;
                    return _$includes_13(_$breadcrumbTypes_8, maybeType);
                }, true);
            }
        },
        context: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || typeof value === "string";
            }
        },
        user: {
            defaultValue: function() {
                return {};
            },
            message: "should be an object with { id, email, name } properties",
            validate: function(value) {
                return value === null || value && _$reduce_17(_$keys_15(value), function(accum, key) {
                    return accum && _$includes_13([
                        "id",
                        "email",
                        "name"
                    ], key);
                }, true);
            }
        },
        metadata: {
            defaultValue: function() {
                return {};
            },
            message: "should be an object",
            validate: function(value) {
                return typeof value === "object" && value !== null;
            }
        },
        logger: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be null or an object with methods { debug, info, warn, error }",
            validate: function(value) {
                return !value || value && _$reduce_17([
                    "debug",
                    "info",
                    "warn",
                    "error"
                ], function(accum, method) {
                    return accum && typeof value[method] === "function";
                }, true);
            }
        },
        redactedKeys: {
            defaultValue: function() {
                return [
                    "password"
                ];
            },
            message: "should be an array of strings|regexes",
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(s) {
                    return typeof s === "string" || s && typeof s.test === "function";
                }).length;
            }
        },
        plugins: {
            defaultValue: function() {
                return [];
            },
            message: "should be an array of plugin objects",
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(p) {
                    return p && typeof p === "object" && typeof p.load === "function";
                }).length;
            }
        },
        featureFlags: {
            defaultValue: function() {
                return [];
            },
            message: 'should be an array of objects that have a "name" property',
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(feature) {
                    return feature && typeof feature === "object" && typeof feature.name === "string";
                }).length;
            }
        }
    };
    // extends helper from babel
    // https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
    var _$assign_11 = function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#map
    var _$map_16 = function(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum.concat(fn(item, i, arr));
        }, []);
    };
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    var schema = _$config_5.schema; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _$config_1 = {
        releaseStage: _$assign_11({}, schema.releaseStage, {
            defaultValue: function() {
                if (/^localhost(:\d+)?$/.test(window.location.host)) return "development";
                return "production";
            }
        }),
        appType: _extends({}, schema.appType, {
            defaultValue: function() {
                return "browser";
            }
        }),
        logger: _$assign_11({}, schema.logger, {
            defaultValue: function() {
                return(// set logger based on browser capability
                typeof console !== "undefined" && typeof console.debug === "function" ? getPrefixedConsole() : undefined);
            }
        })
    };
    var getPrefixedConsole = function() {
        var logger = {};
        var consoleLog = console.log;
        _$map_16([
            "debug",
            "info",
            "warn",
            "error"
        ], function(method) {
            var consoleMethod = console[method];
            logger[method] = typeof consoleMethod === "function" ? consoleMethod.bind(console, "[bugsnag]") : consoleLog.bind(console, "[bugsnag]");
        });
        return logger;
    };
    var Breadcrumb = /*#__PURE__*/ function() {
        function Breadcrumb(message, metadata, type, timestamp) {
            if (timestamp === void 0) timestamp = new Date();
            this.type = type;
            this.message = message;
            this.metadata = metadata;
            this.timestamp = timestamp;
        }
        var _proto = Breadcrumb.prototype;
        _proto.toJSON = function toJSON() {
            return {
                type: this.type,
                name: this.message,
                timestamp: this.timestamp,
                metaData: this.metadata
            };
        };
        return Breadcrumb;
    }();
    var _$Breadcrumb_3 = Breadcrumb;
    var _$stackframe_34 = {};
    (function(root, factory) {
        "use strict";
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stackframe", [], factory);
        else if (typeof _$stackframe_34 === "object") _$stackframe_34 = factory();
        else root.StackFrame = factory();
    })(this, function() {
        "use strict";
        function _isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
        function _capitalize(str) {
            return str.charAt(0).toUpperCase() + str.substring(1);
        }
        function _getter(p) {
            return function() {
                return this[p];
            };
        }
        var booleanProps = [
            "isConstructor",
            "isEval",
            "isNative",
            "isToplevel"
        ];
        var numericProps = [
            "columnNumber",
            "lineNumber"
        ];
        var stringProps = [
            "fileName",
            "functionName",
            "source"
        ];
        var arrayProps = [
            "args"
        ];
        var props = booleanProps.concat(numericProps, stringProps, arrayProps);
        function StackFrame(obj) {
            if (obj instanceof Object) {
                for(var i = 0; i < props.length; i++)if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) this["set" + _capitalize(props[i])](obj[props[i]]);
            }
        }
        StackFrame.prototype = {
            getArgs: function() {
                return this.args;
            },
            setArgs: function(v) {
                if (Object.prototype.toString.call(v) !== "[object Array]") throw new TypeError("Args must be an Array");
                this.args = v;
            },
            getEvalOrigin: function() {
                return this.evalOrigin;
            },
            setEvalOrigin: function(v) {
                if (v instanceof StackFrame) this.evalOrigin = v;
                else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
                else throw new TypeError("Eval Origin must be an Object or StackFrame");
            },
            toString: function() {
                var functionName = this.getFunctionName() || "{anonymous}";
                var args = "(" + (this.getArgs() || []).join(",") + ")";
                var fileName = this.getFileName() ? "@" + this.getFileName() : "";
                var lineNumber = _isNumber(this.getLineNumber()) ? ":" + this.getLineNumber() : "";
                var columnNumber = _isNumber(this.getColumnNumber()) ? ":" + this.getColumnNumber() : "";
                return functionName + args + fileName + lineNumber + columnNumber;
            }
        };
        for(var i = 0; i < booleanProps.length; i++){
            StackFrame.prototype["get" + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
            StackFrame.prototype["set" + _capitalize(booleanProps[i])] = function(p) {
                return function(v) {
                    this[p] = Boolean(v);
                };
            }(booleanProps[i]);
        }
        for(var j = 0; j < numericProps.length; j++){
            StackFrame.prototype["get" + _capitalize(numericProps[j])] = _getter(numericProps[j]);
            StackFrame.prototype["set" + _capitalize(numericProps[j])] = function(p) {
                return function(v) {
                    if (!_isNumber(v)) throw new TypeError(p + " must be a Number");
                    this[p] = Number(v);
                };
            }(numericProps[j]);
        }
        for(var k = 0; k < stringProps.length; k++){
            StackFrame.prototype["get" + _capitalize(stringProps[k])] = _getter(stringProps[k]);
            StackFrame.prototype["set" + _capitalize(stringProps[k])] = function(p) {
                return function(v) {
                    this[p] = String(v);
                };
            }(stringProps[k]);
        }
        return StackFrame;
    });
    var _$errorStackParser_31 = {};
    (function(root, factory) {
        "use strict";
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("error-stack-parser", [
            "stackframe"
        ], factory);
        else if (typeof _$errorStackParser_31 === "object") _$errorStackParser_31 = factory(_$stackframe_34);
        else root.ErrorStackParser = factory(root.StackFrame);
    })(this, function ErrorStackParser(StackFrame) {
        "use strict";
        var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
        var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
        var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
        return {
            /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */ parse: function ErrorStackParser$$parse(error) {
                if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") return this.parseOpera(error);
                else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
                else if (error.stack) return this.parseFFOrSafari(error);
                else throw new Error("Cannot parse given Error object");
            },
            // Separate line and column numbers from a string of the form: (URI:Line:Column)
            extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
                // Fail-fast but return locations like "(native)"
                if (urlLike.indexOf(":") === -1) return [
                    urlLike
                ];
                var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
                var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ""));
                return [
                    parts[1],
                    parts[2] || undefined,
                    parts[3] || undefined
                ];
            },
            parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !!line.match(CHROME_IE_STACK_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    if (line.indexOf("(eval ") > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, "");
                    var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "(");
                    // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                    // case it has spaces in it, as the string is split on \s+ later on
                    var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);
                    // remove the parenthesized location from the line, if it was matched
                    sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
                    var tokens = sanitizedLine.split(/\s+/).slice(1);
                    // if a location was matched, pass it to extractLocation() otherwise pop the last token
                    var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                    var functionName = tokens.join(" ") || undefined;
                    var fileName = [
                        "eval",
                        "<anonymous>"
                    ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                    return new StackFrame({
                        functionName: functionName,
                        fileName: fileName,
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            },
            parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ":$1");
                    if (line.indexOf("@") === -1 && line.indexOf(":") === -1) // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                    else {
                        var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                        var matches = line.match(functionNameRegex);
                        var functionName = matches && matches[1] ? matches[1] : undefined;
                        var locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
                        return new StackFrame({
                            functionName: functionName,
                            fileName: locationParts[0],
                            lineNumber: locationParts[1],
                            columnNumber: locationParts[2],
                            source: line
                        });
                    }
                }, this);
            },
            parseOpera: function ErrorStackParser$$parseOpera(e) {
                if (!e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length) return this.parseOpera9(e);
                else if (!e.stack) return this.parseOpera10(e);
                else return this.parseOpera11(e);
            },
            parseOpera9: function ErrorStackParser$$parseOpera9(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
                var lines = e.message.split("\n");
                var result = [];
                for(var i = 2, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            parseOpera10: function ErrorStackParser$$parseOpera10(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
                var lines = e.stacktrace.split("\n");
                var result = [];
                for(var i = 0, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        functionName: match[3] || undefined,
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            // Opera 10.65+ Error.stack very similar to FF/Safari
            parseOpera11: function ErrorStackParser$$parseOpera11(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
                }, this);
                return filtered.map(function(line) {
                    var tokens = line.split("@");
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionCall = tokens.shift() || "";
                    var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^\)]*\)/g, "") || undefined;
                    var argsRaw;
                    if (functionCall.match(/\(([^\)]*)\)/)) argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, "$1");
                    var args = argsRaw === undefined || argsRaw === "[arguments not available]" ? undefined : argsRaw.split(",");
                    return new StackFrame({
                        functionName: functionName,
                        args: args,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            }
        };
    });
    var _$errorStackParser_10 = _$errorStackParser_31;
    var _$safeJsonStringify_30 = function(data, replacer, space, opts) {
        var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
        var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
        return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
    };
    var MAX_DEPTH = 20;
    var MAX_EDGES = 25000;
    var MIN_PRESERVED_DEPTH = 8;
    var REPLACEMENT_NODE = "...";
    function isError(o) {
        return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
    }
    function throwsMessage(err) {
        return "[Throws: " + (err ? err.message : "?") + "]";
    }
    function find(haystack, needle) {
        for(var i = 0, len = haystack.length; i < len; i++){
            if (haystack[i] === needle) return true;
        }
        return false;
    }
    // returns true if the string `path` starts with any of the provided `paths`
    function isDescendent(paths, path) {
        for(var i = 0, len = paths.length; i < len; i++){
            if (path.indexOf(paths[i]) === 0) return true;
        }
        return false;
    }
    function shouldRedact(patterns, key) {
        for(var i = 0, len = patterns.length; i < len; i++){
            if (typeof patterns[i] === "string" && patterns[i].toLowerCase() === key.toLowerCase()) return true;
            if (patterns[i] && typeof patterns[i].test === "function" && patterns[i].test(key)) return true;
        }
        return false;
    }
    function __isArray_30(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    }
    function safelyGetProp(obj, prop) {
        try {
            return obj[prop];
        } catch (err) {
            return throwsMessage(err);
        }
    }
    function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
        var seen = []; // store references to objects we have seen before
        var edges = 0;
        function visit(obj, path) {
            function edgesExceeded() {
                return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
            }
            edges++;
            if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
            if (edgesExceeded()) return REPLACEMENT_NODE;
            if (obj === null || typeof obj !== "object") return obj;
            if (find(seen, obj)) return "[Circular]";
            seen.push(obj);
            if (typeof obj.toJSON === "function") try {
                // we're not going to count this as an edge because it
                // replaces the value of the currently visited object
                edges--;
                var fResult = visit(obj.toJSON(), path);
                seen.pop();
                return fResult;
            } catch (err) {
                return throwsMessage(err);
            }
            var er = isError(obj);
            if (er) {
                edges--;
                var eResult = visit({
                    name: obj.name,
                    message: obj.message
                }, path);
                seen.pop();
                return eResult;
            }
            if (__isArray_30(obj)) {
                var aResult = [];
                for(var i = 0, len = obj.length; i < len; i++){
                    if (edgesExceeded()) {
                        aResult.push(REPLACEMENT_NODE);
                        break;
                    }
                    aResult.push(visit(obj[i], path.concat("[]")));
                }
                seen.pop();
                return aResult;
            }
            var result = {};
            try {
                for(var prop in obj){
                    if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
                    if (isDescendent(redactedPaths, path.join(".")) && shouldRedact(redactedKeys, prop)) {
                        result[prop] = "[REDACTED]";
                        continue;
                    }
                    if (edgesExceeded()) {
                        result[prop] = REPLACEMENT_NODE;
                        break;
                    }
                    result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
                }
            } catch (e) {}
            seen.pop();
            return result;
        }
        return visit(obj, []);
    } /* removed: var _$map_16 = require('./es-utils/map'); */ 
    function add(existingFeatures, existingFeatureKeys, name, variant) {
        if (typeof name !== "string") return;
        if (variant === undefined) variant = null;
        else if (variant !== null && typeof variant !== "string") variant = _$safeJsonStringify_30(variant);
        var existingIndex = existingFeatureKeys[name];
        if (typeof existingIndex === "number") {
            existingFeatures[existingIndex] = {
                name: name,
                variant: variant
            };
            return;
        }
        existingFeatures.push({
            name: name,
            variant: variant
        });
        existingFeatureKeys[name] = existingFeatures.length - 1;
    }
    function merge(existingFeatures, newFeatures, existingFeatureKeys) {
        if (!_$isArray_14(newFeatures)) return;
        for(var i = 0; i < newFeatures.length; ++i){
            var feature = newFeatures[i];
            if (feature === null || typeof feature !== "object") continue;
            // 'add' will handle if 'name' doesn't exist & 'variant' is optional
            add(existingFeatures, existingFeatureKeys, feature.name, feature.variant);
        }
        return existingFeatures;
    }
    // convert feature flags from a map of 'name -> variant' into the format required
    // by the Bugsnag Event API:
    //   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]
    function toEventApi(featureFlags) {
        return _$map_16(_$filter_12(featureFlags, Boolean), function(_ref) {
            var name = _ref.name, variant = _ref.variant;
            var flag = {
                featureFlag: name
            };
            // don't add a 'variant' property unless there's actually a value
            if (typeof variant === "string") flag.variant = variant;
            return flag;
        });
    }
    function clear(features, featuresIndex, name) {
        var existingIndex = featuresIndex[name];
        if (typeof existingIndex === "number") {
            features[existingIndex] = null;
            delete featuresIndex[name];
        }
    }
    var _$featureFlagDelegate_18 = {
        add: add,
        clear: clear,
        merge: merge,
        toEventApi: toEventApi
    };
    // Given `err` which may be an error, does it have a stack property which is a string?
    var _$hasStack_19 = function(err) {
        return !!err && (!!err.stack || !!err.stacktrace || !!err["opera#sourceloc"]) && typeof (err.stack || err.stacktrace || err["opera#sourceloc"]) === "string" && err.stack !== err.name + ": " + err.message;
    };
    /**
 * Expose `isError`.
 */ var _$isError_32 = __isError_32;
    /**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */ function __isError_32(value) {
        switch(Object.prototype.toString.call(value)){
            case "[object Error]":
                return true;
            case "[object Exception]":
                return true;
            case "[object DOMException]":
                return true;
            default:
                return value instanceof Error;
        }
    }
    var _$iserror_20 = _$isError_32; /* removed: var _$assign_11 = require('./es-utils/assign'); */ 
    var __add_22 = function(state, section, keyOrObj, maybeVal) {
        var _updates;
        if (!section) return;
        var updates;
        // addMetadata("section", null) -> clears section
        if (keyOrObj === null) return __clear_22(state, section);
        // normalise the two supported input types into object form
        if (typeof keyOrObj === "object") updates = keyOrObj;
        if (typeof keyOrObj === "string") updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates);
        // exit if we don't have an updates object at this point
        if (!updates) return;
        // preventing the __proto__ property from being used as a key
        if (section === "__proto__" || section === "constructor" || section === "prototype") return;
        // ensure a section with this name exists
        if (!state[section]) state[section] = {};
        // merge the updates with the existing section
        state[section] = _$assign_11({}, state[section], updates);
    };
    var get = function(state, section, key) {
        if (typeof section !== "string") return undefined;
        if (!key) return state[section];
        if (state[section]) return state[section][key];
        return undefined;
    };
    var __clear_22 = function(state, section, key) {
        if (typeof section !== "string") return;
        // clear an entire section
        if (!key) {
            delete state[section];
            return;
        }
        // preventing the __proto__ property from being used as a key
        if (section === "__proto__" || section === "constructor" || section === "prototype") return;
        // clear a single value from a section
        if (state[section]) delete state[section][key];
    };
    var _$metadataDelegate_22 = {
        add: __add_22,
        get: get,
        clear: __clear_22
    };
    var _$stackGenerator_33 = {};
    (function(root, factory) {
        "use strict";
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stack-generator", [
            "stackframe"
        ], factory);
        else if (typeof _$stackGenerator_33 === "object") _$stackGenerator_33 = factory(_$stackframe_34);
        else root.StackGenerator = factory(root.StackFrame);
    })(this, function(StackFrame) {
        return {
            backtrace: function StackGenerator$$backtrace(opts) {
                var stack = [];
                var maxStackSize = 10;
                if (typeof opts === "object" && typeof opts.maxStackSize === "number") maxStackSize = opts.maxStackSize;
                var curr = arguments.callee;
                while(curr && stack.length < maxStackSize && curr["arguments"]){
                    // Allow V8 optimizations
                    var args = new Array(curr["arguments"].length);
                    for(var i = 0; i < args.length; ++i)args[i] = curr["arguments"][i];
                    if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                        functionName: RegExp.$1 || undefined,
                        args: args
                    }));
                    else stack.push(new StackFrame({
                        args: args
                    }));
                    try {
                        curr = curr.caller;
                    } catch (e) {
                        break;
                    }
                }
                return stack;
            }
        };
    }); /* removed: var _$errorStackParser_10 = require('./lib/error-stack-parser'); */ 
    var Event = /*#__PURE__*/ function() {
        function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
            if (stacktrace === void 0) stacktrace = [];
            if (handledState === void 0) handledState = defaultHandledState();
            this.apiKey = undefined;
            this.context = undefined;
            this.groupingHash = undefined;
            this.originalError = originalError;
            this._handledState = handledState;
            this.severity = this._handledState.severity;
            this.unhandled = this._handledState.unhandled;
            this.app = {};
            this.device = {};
            this.request = {};
            this.breadcrumbs = [];
            this.threads = [];
            this._metadata = {};
            this._features = [];
            this._featuresIndex = {};
            this._user = {};
            this._session = undefined;
            this.errors = [
                createBugsnagError(errorClass, errorMessage, Event.__type, stacktrace)
            ];
        // Flags.
        // Note these are not initialised unless they are used
        // to save unnecessary bytes in the browser bundle
        /* this.attemptImmediateDelivery, default: true */ }
        var _proto = Event.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            _$featureFlagDelegate_18.add(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            _$featureFlagDelegate_18.merge(this._features, featureFlags, this._featuresIndex);
        };
        _proto.getFeatureFlags = function getFeatureFlags() {
            return _$featureFlagDelegate_18.toEventApi(this._features);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            _$featureFlagDelegate_18.clear(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                payloadVersion: "4",
                exceptions: _$map_16(this.errors, function(er) {
                    return _$assign_11({}, er, {
                        message: er.errorMessage
                    });
                }),
                severity: this.severity,
                unhandled: this._handledState.unhandled,
                severityReason: this._handledState.severityReason,
                app: this.app,
                device: this.device,
                request: this.request,
                breadcrumbs: this.breadcrumbs,
                context: this.context,
                groupingHash: this.groupingHash,
                metaData: this._metadata,
                user: this._user,
                session: this._session,
                featureFlags: this.getFeatureFlags()
            };
        };
        return Event;
    }(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
    // and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)
    var formatStackframe = function(frame) {
        var f = {
            file: frame.fileName,
            method: normaliseFunctionName(frame.functionName),
            lineNumber: frame.lineNumber,
            columnNumber: frame.columnNumber,
            code: undefined,
            inProject: undefined
        };
        // Some instances result in no file:
        // - calling notify() from chrome's terminal results in no file/method.
        // - non-error exception thrown from global code in FF
        // This adds one.
        if (f.lineNumber > -1 && !f.file && !f.method) f.file = "global code";
        return f;
    };
    var normaliseFunctionName = function(name) {
        return /^global code$/i.test(name) ? "global code" : name;
    };
    var defaultHandledState = function() {
        return {
            unhandled: false,
            severity: "warning",
            severityReason: {
                type: "handledException"
            }
        };
    };
    var ensureString = function(str) {
        return typeof str === "string" ? str : "";
    };
    function createBugsnagError(errorClass, errorMessage, type, stacktrace) {
        return {
            errorClass: ensureString(errorClass),
            errorMessage: ensureString(errorMessage),
            type: type,
            stacktrace: _$reduce_17(stacktrace, function(accum, frame) {
                var f = formatStackframe(frame);
                // don't include a stackframe if none of its properties are defined
                try {
                    if (JSON.stringify(f) === "{}") return accum;
                    return accum.concat(f);
                } catch (e) {
                    return accum;
                }
            }, [])
        };
    }
    function getCauseStack(error) {
        if (error.cause) return [
            error
        ].concat(getCauseStack(error.cause));
        else return [
            error
        ];
    }
    // Helpers
    Event.getStacktrace = function(error, errorFramesToSkip, backtraceFramesToSkip) {
        if (_$hasStack_19(error)) return _$errorStackParser_10.parse(error).slice(errorFramesToSkip);
        // error wasn't provided or didn't have a stacktrace so try to walk the callstack
        try {
            return _$filter_12(_$stackGenerator_33.backtrace(), function(frame) {
                return (frame.functionName || "").indexOf("StackGenerator$$") === -1;
            }).slice(1 + backtraceFramesToSkip);
        } catch (e) {
            return [];
        }
    };
    Event.create = function(maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
        if (errorFramesToSkip === void 0) errorFramesToSkip = 0;
        var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger), error = _normaliseError[0], internalFrames = _normaliseError[1];
        var event;
        try {
            var stacktrace = Event.getStacktrace(error, // if an error was created/throw in the normaliseError() function, we need to
            // tell the getStacktrace() function to skip the number of frames we know will
            // be from our own functions. This is added to the number of frames deep we
            // were told about
            internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // if there's no stacktrace, the callstack may be walked to generated one.
            // this is how many frames should be removed because they come from our library
            1 + errorFramesToSkip);
            event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
        } catch (e) {
            event = new Event(error.name, error.message, [], handledState, maybeError);
        }
        if (error.name === "InvalidError") event.addMetadata("" + component, "non-error parameter", makeSerialisable(maybeError));
        if (error.cause) {
            var _event$errors;
            var causes = getCauseStack(error).slice(1);
            var normalisedCauses = _$map_16(causes, function(cause) {
                // Only get stacktrace for error causes that are a valid JS Error and already have a stack
                var stacktrace = _$iserror_20(cause) && _$hasStack_19(cause) ? _$errorStackParser_10.parse(cause) : [];
                var _normaliseError2 = normaliseError(cause, true, "error cause"), error = _normaliseError2[0];
                if (error.name === "InvalidError") event.addMetadata("error cause", makeSerialisable(cause));
                return createBugsnagError(error.name, error.message, Event.__type, stacktrace);
            });
            (_event$errors = event.errors).push.apply(_event$errors, normalisedCauses);
        }
        return event;
    };
    var makeSerialisable = function(err) {
        if (err === null) return "null";
        if (err === undefined) return "undefined";
        return err;
    };
    var normaliseError = function(maybeError, tolerateNonErrors, component, logger) {
        var error;
        var internalFrames = 0;
        var createAndLogInputError = function(reason) {
            var verb = component === "error cause" ? "was" : "received";
            if (logger) logger.warn(component + " " + verb + ' a non-error: "' + reason + '"');
            var err = new Error(component + " " + verb + ' a non-error. See "' + component + '" tab for more detail.');
            err.name = "InvalidError";
            return err;
        };
        // In some cases:
        //
        //  - the promise rejection handler (both in the browser and node)
        //  - the node uncaughtException handler
        //
        // We are really limited in what we can do to get a stacktrace. So we use the
        // tolerateNonErrors option to ensure that the resulting error communicates as
        // such.
        if (!tolerateNonErrors) {
            if (_$iserror_20(maybeError)) error = maybeError;
            else {
                error = createAndLogInputError(typeof maybeError);
                internalFrames += 2;
            }
        } else switch(typeof maybeError){
            case "string":
            case "number":
            case "boolean":
                error = new Error(String(maybeError));
                internalFrames += 1;
                break;
            case "function":
                error = createAndLogInputError("function");
                internalFrames += 2;
                break;
            case "object":
                if (maybeError !== null && _$iserror_20(maybeError)) error = maybeError;
                else if (maybeError !== null && hasNecessaryFields(maybeError)) {
                    error = new Error(maybeError.message || maybeError.errorMessage);
                    error.name = maybeError.name || maybeError.errorClass;
                    internalFrames += 1;
                } else {
                    error = createAndLogInputError(maybeError === null ? "null" : "unsupported object");
                    internalFrames += 2;
                }
                break;
            default:
                error = createAndLogInputError("nothing");
                internalFrames += 2;
        }
        if (!_$hasStack_19(error)) // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
        try {
            throw error;
        } catch (e) {
            if (_$hasStack_19(e)) {
                error = e;
                // if the error only got a stacktrace after we threw it here, we know it
                // will only have one extra internal frame from this function, regardless
                // of whether it went through createAndLogInputError() or not
                internalFrames = 1;
            }
        }
        return [
            error,
            internalFrames
        ];
    };
    // default value for stacktrace.type
    Event.__type = "browserjs";
    var hasNecessaryFields = function(error) {
        return (typeof error.name === "string" || typeof error.errorClass === "string") && (typeof error.message === "string" || typeof error.errorMessage === "string");
    };
    var _$Event_6 = Event;
    // This is a heavily modified/simplified version of
    //   https://github.com/othiym23/async-some
    // with the logic flipped so that it is akin to the
    // synchronous "every" method instead of "some".
    // run the asynchronous test function (fn) over each item in the array (arr)
    // in series until:
    //   - fn(item, cb) => calls cb(null, false)
    //   - or the end of the array is reached
    // the callback (cb) will be passed (null, false) if any of the items in arr
    // caused fn to call back with false, otherwise it will be passed (null, true)
    var _$asyncEvery_7 = function(arr, fn, cb) {
        var index = 0;
        var next = function() {
            if (index >= arr.length) return cb(null, true);
            fn(arr[index], function(err, result) {
                if (err) return cb(err);
                if (result === false) return cb(null, false);
                index++;
                next();
            });
        };
        next();
    }; /* removed: var _$asyncEvery_7 = require('./async-every'); */ 
    var _$callbackRunner_9 = function(callbacks, event, onCallbackError, cb) {
        // This function is how we support different kinds of callback:
        //  - synchronous - return value
        //  - node-style async with callback - cb(err, value)
        //  - promise/thenable - resolve(value)
        // It normalises each of these into the lowest common denominator – a node-style callback
        var runMaybeAsyncCallback = function(fn, cb) {
            if (typeof fn !== "function") return cb(null);
            try {
                // if function appears sync…
                if (fn.length !== 2) {
                    var ret = fn(event);
                    // check if it returned a "thenable" (promise)
                    if (ret && typeof ret.then === "function") return ret.then(// resolve
                    function(val) {
                        return setTimeout(function() {
                            return cb(null, val);
                        });
                    }, // reject
                    function(err) {
                        setTimeout(function() {
                            onCallbackError(err);
                            return cb(null, true);
                        });
                    });
                    return cb(null, ret);
                }
                // if function is async…
                fn(event, function(err, result) {
                    if (err) {
                        onCallbackError(err);
                        return cb(null);
                    }
                    cb(null, result);
                });
            } catch (e) {
                onCallbackError(e);
                cb(null);
            }
        };
        _$asyncEvery_7(callbacks, runMaybeAsyncCallback, cb);
    };
    var _$syncCallbackRunner_23 = function(callbacks, callbackArg, callbackType, logger) {
        var ignore = false;
        var cbs = callbacks.slice();
        while(!ignore){
            if (!cbs.length) break;
            try {
                ignore = cbs.pop()(callbackArg) === false;
            } catch (e) {
                logger.error("Error occurred in " + callbackType + " callback, continuing anyway…");
                logger.error(e);
            }
        }
        return ignore;
    };
    var _$pad_29 = function pad(num, size) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_29 = require('./pad.js'); */ 
    var env = typeof window === "object" ? window : self;
    var globalCount = 0;
    for(var prop in env)if (Object.hasOwnProperty.call(env, prop)) globalCount++;
    var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var clientId = _$pad_29((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);
    var _$fingerprint_28 = function fingerprint() {
        return clientId;
    }; /* removed: var _$fingerprint_28 = require('./lib/fingerprint.js'); */ 
    var c = 0, blockSize = 4, base = 36, discreteValues = Math.pow(base, blockSize);
    function randomBlock() {
        return _$pad_29((Math.random() * discreteValues << 0).toString(base), blockSize);
    }
    function safeCounter() {
        c = c < discreteValues ? c : 0;
        c++; // this is not subliminal
        return c - 1;
    }
    function cuid() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = "c", // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(base), // Prevent same-machine collisions.
        counter = _$pad_29(safeCounter().toString(base), blockSize), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_28(), // Grab some more chars from Math.random()
        random = randomBlock() + randomBlock();
        return letter + timestamp + counter + print + random;
    }
    cuid.fingerprint = _$fingerprint_28;
    var _$cuid_27 = cuid; /* removed: var _$cuid_27 = require('@bugsnag/cuid'); */ 
    var Session = /*#__PURE__*/ function() {
        function Session() {
            this.id = _$cuid_27();
            this.startedAt = new Date();
            this._handled = 0;
            this._unhandled = 0;
            this._user = {};
            this.app = {};
            this.device = {};
        }
        var _proto = Session.prototype;
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                id: this.id,
                startedAt: this.startedAt,
                events: {
                    handled: this._handled,
                    unhandled: this._unhandled
                }
            };
        };
        _proto._track = function _track(event) {
            this[event._handledState.unhandled ? "_unhandled" : "_handled"] += 1;
        };
        return Session;
    }();
    var _$Session_35 = Session; /* removed: var _$config_5 = require('./config'); */ 
    var __add_4 = _$featureFlagDelegate_18.add, __clear_4 = _$featureFlagDelegate_18.clear, __merge_4 = _$featureFlagDelegate_18.merge;
    var noop = function() {};
    var Client = /*#__PURE__*/ function() {
        function Client(configuration, schema, internalPlugins, notifier) {
            var _this = this;
            if (schema === void 0) schema = _$config_5.schema;
            if (internalPlugins === void 0) internalPlugins = [];
            // notifier id
            this._notifier = notifier;
            // intialise opts and config
            this._config = {};
            this._schema = schema;
            // i/o
            this._delivery = {
                sendSession: noop,
                sendEvent: noop
            };
            this._logger = {
                debug: noop,
                info: noop,
                warn: noop,
                error: noop
            };
            // plugins
            this._plugins = {};
            // state
            this._breadcrumbs = [];
            this._session = null;
            this._metadata = {};
            this._featuresIndex = {};
            this._features = [];
            this._context = undefined;
            this._user = {};
            // callbacks:
            //  e: onError
            //  s: onSession
            //  sp: onSessionPayload
            //  b: onBreadcrumb
            // (note these names are minified by hand because object
            // properties are not safe to minify automatically)
            this._cbs = {
                e: [],
                s: [],
                sp: [],
                b: []
            };
            // expose internal constructors
            this.Client = Client;
            this.Event = _$Event_6;
            this.Breadcrumb = _$Breadcrumb_3;
            this.Session = _$Session_35;
            this._config = this._configure(configuration, internalPlugins);
            _$map_16(internalPlugins.concat(this._config.plugins), function(pl) {
                if (pl) _this._loadPlugin(pl);
            });
            // when notify() is called we need to know how many frames are from our own source
            // this inital value is 1 not 0 because we wrap notify() to ensure it is always
            // bound to have the client as its `this` value – see below.
            this._depth = 1;
            var self1 = this;
            var notify = this.notify;
            this.notify = function() {
                return notify.apply(self1, arguments);
            };
        }
        var _proto = Client.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            __add_4(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            __merge_4(this._features, featureFlags, this._featuresIndex);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            __clear_4(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getContext = function getContext() {
            return this._context;
        };
        _proto.setContext = function setContext(c) {
            this._context = c;
        };
        _proto._configure = function _configure(opts, internalPlugins) {
            var schema = _$reduce_17(internalPlugins, function(schema, plugin) {
                if (plugin && plugin.configSchema) return _$assign_11({}, schema, plugin.configSchema);
                return schema;
            }, this._schema);
            // accumulate configuration and error messages
            var _reduce = _$reduce_17(_$keys_15(schema), function(accum, key) {
                var defaultValue = schema[key].defaultValue(opts[key]);
                if (opts[key] !== undefined) {
                    var valid = schema[key].validate(opts[key]);
                    if (!valid) {
                        accum.errors[key] = schema[key].message;
                        accum.config[key] = defaultValue;
                    } else if (schema[key].allowPartialObject) accum.config[key] = _$assign_11(defaultValue, opts[key]);
                    else accum.config[key] = opts[key];
                } else accum.config[key] = defaultValue;
                return accum;
            }, {
                errors: {},
                config: {}
            }), errors = _reduce.errors, config = _reduce.config;
            if (schema.apiKey) {
                // missing api key is the only fatal error
                if (!config.apiKey) throw new Error("No Bugsnag API Key set");
                // warn about an apikey that is not of the expected format
                if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = "should be a string of 32 hexadecimal characters";
            }
            // update and elevate some options
            this._metadata = _$assign_11({}, config.metadata);
            __merge_4(this._features, config.featureFlags, this._featuresIndex);
            this._user = _$assign_11({}, config.user);
            this._context = config.context;
            if (config.logger) this._logger = config.logger;
            // add callbacks
            if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
            if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
            if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession);
            // finally warn about any invalid config where we fell back to the default
            if (_$keys_15(errors).length) this._logger.warn(generateConfigErrorMessage(errors, opts));
            return config;
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto._loadPlugin = function _loadPlugin(plugin) {
            var result = plugin.load(this);
            // JS objects are not the safest way to store arbitrarily keyed values,
            // so bookend the key with some characters that prevent tampering with
            // stuff like __proto__ etc. (only store the result if the plugin had a
            // name)
            if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
            return this;
        };
        _proto.getPlugin = function getPlugin(name) {
            return this._plugins["~" + name + "~"];
        };
        _proto._setDelivery = function _setDelivery(d) {
            this._delivery = d(this);
        };
        _proto.startSession = function startSession() {
            var session = new _$Session_35();
            session.app.releaseStage = this._config.releaseStage;
            session.app.version = this._config.appVersion;
            session.app.type = this._config.appType;
            session._user = _$assign_11({}, this._user);
            // run onSession callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.s, session, "onSession", this._logger);
            if (ignore) {
                this._logger.debug("Session not started due to onSession callback");
                return this;
            }
            return this._sessionDelegate.startSession(this, session);
        };
        _proto.addOnError = function addOnError(fn, front) {
            if (front === void 0) front = false;
            this._cbs.e[front ? "unshift" : "push"](fn);
        };
        _proto.removeOnError = function removeOnError(fn) {
            this._cbs.e = _$filter_12(this._cbs.e, function(f) {
                return f !== fn;
            });
        };
        _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
            this._cbs.sp.push(fn);
        };
        _proto.addOnSession = function addOnSession(fn) {
            this._cbs.s.push(fn);
        };
        _proto.removeOnSession = function removeOnSession(fn) {
            this._cbs.s = _$filter_12(this._cbs.s, function(f) {
                return f !== fn;
            });
        };
        _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
            if (front === void 0) front = false;
            this._cbs.b[front ? "unshift" : "push"](fn);
        };
        _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
            this._cbs.b = _$filter_12(this._cbs.b, function(f) {
                return f !== fn;
            });
        };
        _proto.pauseSession = function pauseSession() {
            return this._sessionDelegate.pauseSession(this);
        };
        _proto.resumeSession = function resumeSession() {
            return this._sessionDelegate.resumeSession(this);
        };
        _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
            // coerce bad values so that the defaults get set
            message = typeof message === "string" ? message : "";
            type = typeof type === "string" && _$includes_13(_$breadcrumbTypes_8, type) ? type : "manual";
            metadata = typeof metadata === "object" && metadata !== null ? metadata : {};
            // if no message, discard
            if (!message) return;
            var crumb = new _$Breadcrumb_3(message, metadata, type);
            // run onBreadcrumb callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.b, crumb, "onBreadcrumb", this._logger);
            if (ignore) {
                this._logger.debug("Breadcrumb not attached due to onBreadcrumb callback");
                return;
            }
            // push the valid crumb onto the queue and maintain the length
            this._breadcrumbs.push(crumb);
            if (this._breadcrumbs.length > this._config.maxBreadcrumbs) this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
        };
        _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
            var types = this._config.enabledBreadcrumbTypes;
            return types === null || _$includes_13(types, type);
        };
        _proto.notify = function notify(maybeError, onError, postReportCallback) {
            if (postReportCallback === void 0) postReportCallback = noop;
            var event = _$Event_6.create(maybeError, true, undefined, "notify()", this._depth + 1, this._logger);
            this._notify(event, onError, postReportCallback);
        };
        _proto._notify = function _notify(event, onError, postReportCallback) {
            var _this2 = this;
            if (postReportCallback === void 0) postReportCallback = noop;
            event.app = _$assign_11({}, event.app, {
                releaseStage: this._config.releaseStage,
                version: this._config.appVersion,
                type: this._config.appType
            });
            event.context = event.context || this._context;
            event._metadata = _$assign_11({}, event._metadata, this._metadata);
            event._user = _$assign_11({}, event._user, this._user);
            event.breadcrumbs = this._breadcrumbs.slice();
            __merge_4(event._features, this._features, event._featuresIndex);
            // exit early if events should not be sent on the current releaseStage
            if (this._config.enabledReleaseStages !== null && !_$includes_13(this._config.enabledReleaseStages, this._config.releaseStage)) {
                this._logger.warn("Event not sent due to releaseStage/enabledReleaseStages configuration");
                return postReportCallback(null, event);
            }
            var originalSeverity = event.severity;
            var onCallbackError = function(err) {
                // errors in callbacks are tolerated but we want to log them out
                _this2._logger.error("Error occurred in onError callback, continuing anyway…");
                _this2._logger.error(err);
            };
            var callbacks = [].concat(this._cbs.e).concat(onError);
            _$callbackRunner_9(callbacks, event, onCallbackError, function(err, shouldSend) {
                if (err) onCallbackError(err);
                if (!shouldSend) {
                    _this2._logger.debug("Event not sent due to onError callback");
                    return postReportCallback(null, event);
                }
                if (_this2._isBreadcrumbTypeEnabled("error")) // only leave a crumb for the error if actually got sent
                Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
                    errorClass: event.errors[0].errorClass,
                    errorMessage: event.errors[0].errorMessage,
                    severity: event.severity
                }, "error");
                if (originalSeverity !== event.severity) event._handledState.severityReason = {
                    type: "userCallbackSetSeverity"
                };
                if (event.unhandled !== event._handledState.unhandled) {
                    event._handledState.severityReason.unhandledOverridden = true;
                    event._handledState.unhandled = event.unhandled;
                }
                if (_this2._session) {
                    _this2._session._track(event);
                    event._session = _this2._session;
                }
                _this2._delivery.sendEvent({
                    apiKey: event.apiKey || _this2._config.apiKey,
                    notifier: _this2._notifier,
                    events: [
                        event
                    ]
                }, function(err) {
                    return postReportCallback(err, event);
                });
            });
        };
        return Client;
    }();
    var generateConfigErrorMessage = function(errors, rawInput) {
        var er = new Error("Invalid configuration\n" + _$map_16(_$keys_15(errors), function(key) {
            return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
        }).join("\n\n"));
        return er;
    };
    var stringify = function(val) {
        switch(typeof val){
            case "string":
            case "number":
            case "object":
                return JSON.stringify(val);
            default:
                return String(val);
        }
    };
    var _$Client_4 = Client;
    var _$jsonPayload_21 = {}; /* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */ 
    var EVENT_REDACTION_PATHS = [
        "events.[].metaData",
        "events.[].breadcrumbs.[].metaData",
        "events.[].request"
    ];
    _$jsonPayload_21.event = function(event, redactedKeys) {
        var payload = _$safeJsonStringify_30(event, null, null, {
            redactedPaths: EVENT_REDACTION_PATHS,
            redactedKeys: redactedKeys
        });
        if (payload.length > 10e5) {
            event.events[0]._metadata = {
                notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
            };
            payload = _$safeJsonStringify_30(event, null, null, {
                redactedPaths: EVENT_REDACTION_PATHS,
                redactedKeys: redactedKeys
            });
        }
        return payload;
    };
    _$jsonPayload_21.session = function(session, redactedKeys) {
        var payload = _$safeJsonStringify_30(session, null, null);
        return payload;
    };
    var _$delivery_36 = {}; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    _$delivery_36 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                var url = getApiUrl(client._config, "notify", "4", win);
                var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.onerror = function() {
                    var err = new Error("Event failed to send");
                    client._logger.error("Event failed to send…", err);
                    if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                    cb(err);
                };
                req.open("POST", url);
                setTimeout(function() {
                    try {
                        req.send(body);
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                var url = getApiUrl(client._config, "sessions", "1", win);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.open("POST", url);
                setTimeout(function() {
                    try {
                        req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            }
        };
    };
    var getApiUrl = function(config, endpoint, version, win) {
        // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
        // to an ISO string when you use JSON stringify. Simply parsing the result of
        // JSON.stringify is smaller than using a toISOstring() polyfill.
        var isoDate = JSON.parse(JSON.stringify(new Date()));
        var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
        return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
    };
    var matchPageProtocol = _$delivery_36._matchPageProtocol = function(endpoint, pageProtocol) {
        return pageProtocol === "http:" ? endpoint.replace(/^https:/, "http:") : endpoint;
    }; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    var _$delivery_37 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.notify;
                    var req = new win.XMLHttpRequest();
                    var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Event failed to send…", err);
                                if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open("POST", url);
                    req.setRequestHeader("Content-Type", "application/json");
                    req.setRequestHeader("Bugsnag-Api-Key", event.apiKey || client._config.apiKey);
                    req.setRequestHeader("Bugsnag-Payload-Version", "4");
                    req.setRequestHeader("Bugsnag-Sent-At", new Date().toISOString());
                    req.send(body);
                } catch (e) {
                    client._logger.error(e);
                }
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.sessions;
                    var req = new win.XMLHttpRequest();
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Session failed to send…", err);
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open("POST", url);
                    req.setRequestHeader("Content-Type", "application/json");
                    req.setRequestHeader("Bugsnag-Api-Key", client._config.apiKey);
                    req.setRequestHeader("Bugsnag-Payload-Version", "1");
                    req.setRequestHeader("Bugsnag-Sent-At", new Date().toISOString());
                    req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                } catch (e) {
                    client._logger.error(e);
                }
            }
        };
    };
    var appStart = new Date();
    var reset = function() {
        appStart = new Date();
    };
    var _$app_38 = {
        name: "appDuration",
        load: function(client) {
            client.addOnError(function(event) {
                var now = new Date();
                event.app.duration = now - appStart;
            }, true);
            return {
                reset: reset
            };
        }
    };
    /*
 * Sets the default context to be the current URL
 */ var _$context_39 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.context !== undefined) return;
                    event.context = win.location.pathname;
                }, true);
            }
        };
    };
    var _$pad_43 = function pad(num, size) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_43 = require('./pad.js'); */ 
    var __env_42 = typeof window === "object" ? window : self;
    var __globalCount_42 = 0;
    for(var __prop_42 in __env_42)if (Object.hasOwnProperty.call(__env_42, __prop_42)) __globalCount_42++;
    var __mimeTypesLength_42 = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var __clientId_42 = _$pad_43((__mimeTypesLength_42 + navigator.userAgent.length).toString(36) + __globalCount_42.toString(36), 4);
    var _$fingerprint_42 = function fingerprint() {
        return __clientId_42;
    }; /* removed: var _$fingerprint_42 = require('./lib/fingerprint.js'); */ 
    var __c_41 = 0, __blockSize_41 = 4, __base_41 = 36, __discreteValues_41 = Math.pow(__base_41, __blockSize_41);
    function __randomBlock_41() {
        return _$pad_43((Math.random() * __discreteValues_41 << 0).toString(__base_41), __blockSize_41);
    }
    function __safeCounter_41() {
        __c_41 = __c_41 < __discreteValues_41 ? __c_41 : 0;
        __c_41++; // this is not subliminal
        return __c_41 - 1;
    }
    function __cuid_41() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = "c", // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(__base_41), // Prevent same-machine collisions.
        counter = _$pad_43(__safeCounter_41().toString(__base_41), __blockSize_41), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_42(), // Grab some more chars from Math.random()
        random = __randomBlock_41() + __randomBlock_41();
        return letter + timestamp + counter + print + random;
    }
    __cuid_41.fingerprint = _$fingerprint_42;
    var _$cuid_41 = __cuid_41; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    var BUGSNAG_ANONYMOUS_ID_KEY = "bugsnag-anonymous-id";
    var getDeviceId = function(win) {
        try {
            var storage = win.localStorage;
            var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY);
            // If we get an ID, make sure it looks like a valid cuid. The length can
            // fluctuate slightly, so some leeway is built in
            if (id && /^c[a-z0-9]{20,32}$/.test(id)) return id;
             /* removed: var _$cuid_41 = require('@bugsnag/cuid'); */ 
            id = _$cuid_41();
            storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
            return id;
        } catch (err) {
        // If localStorage is not available (e.g. because it's disabled) then give up
        }
    };
    /*
 * Automatically detects browser device details
 */ var _$device_40 = function(nav, win) {
        if (nav === void 0) nav = navigator;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                var device = {
                    locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
                    userAgent: nav.userAgent
                };
                if (win && win.screen && win.screen.orientation && win.screen.orientation.type) device.orientation = win.screen.orientation.type;
                else if (win && win.document) device.orientation = win.document.documentElement.clientWidth > win.document.documentElement.clientHeight ? "landscape" : "portrait";
                if (client._config.generateAnonymousId) device.id = getDeviceId(win);
                client.addOnSession(function(session) {
                    session.device = _$assign_11({}, session.device, device);
                    // only set device id if collectUserIp is false
                    if (!client._config.collectUserIp) setDefaultUserId(session);
                });
                // add time just as the event is sent
                client.addOnError(function(event) {
                    event.device = _$assign_11({}, event.device, device, {
                        time: new Date()
                    });
                    if (!client._config.collectUserIp) setDefaultUserId(event);
                }, true);
            },
            configSchema: {
                generateAnonymousId: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: "should be true|false"
                }
            }
        };
    };
    var setDefaultUserId = function(eventOrSession) {
        // device id is also used to populate the user id field, if it's not already set
        var user = eventOrSession.getUser();
        if (!user || !user.id) eventOrSession.setUser(eventOrSession.device.id);
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Sets the event request: { url } to be the current href
 */ var _$request_44 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.request && event.request.url) return;
                    event.request = _$assign_11({}, event.request, {
                        url: win.location.href
                    });
                }, true);
            }
        };
    }; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    var _$session_45 = {
        load: function(client) {
            client._sessionDelegate = sessionDelegate;
        }
    };
    var sessionDelegate = {
        startSession: function(client, session) {
            var sessionClient = client;
            sessionClient._session = session;
            sessionClient._pausedSession = null;
            // exit early if the current releaseStage is not enabled
            if (sessionClient._config.enabledReleaseStages !== null && !_$includes_13(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
                sessionClient._logger.warn("Session not sent due to releaseStage/enabledReleaseStages configuration");
                return sessionClient;
            }
            sessionClient._delivery.sendSession({
                notifier: sessionClient._notifier,
                device: session.device,
                app: session.app,
                sessions: [
                    {
                        id: session.id,
                        startedAt: session.startedAt,
                        user: session._user
                    }
                ]
            });
            return sessionClient;
        },
        resumeSession: function(client) {
            // Do nothing if there's already an active session
            if (client._session) return client;
            // If we have a paused session then make it the active session
            if (client._pausedSession) {
                client._session = client._pausedSession;
                client._pausedSession = null;
                return client;
            }
            // Otherwise start a new session
            return client.startSession();
        },
        pauseSession: function(client) {
            client._pausedSession = client._session;
            client._session = null;
        }
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Prevent collection of user IPs
 */ var _$clientIp_46 = {
        load: function(client) {
            if (client._config.collectUserIp) return;
            client.addOnError(function(event) {
                // If user.id is explicitly undefined, it will be missing from the payload. It needs
                // removing so that the following line replaces it
                if (event._user && typeof event._user.id === "undefined") delete event._user.id;
                event._user = _$assign_11({
                    id: "[REDACTED]"
                }, event._user);
                event.request = _$assign_11({
                    clientIp: "[REDACTED]"
                }, event.request);
            });
        },
        configSchema: {
            collectUserIp: {
                defaultValue: function() {
                    return true;
                },
                message: "should be true|false",
                validate: function(value) {
                    return value === true || value === false;
                }
            }
        }
    };
    var _$consoleBreadcrumbs_47 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    /*
 * Leaves breadcrumbs when console log methods are called
 */ _$consoleBreadcrumbs_47.load = function(client) {
        var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
        if (isDev || !client._isBreadcrumbTypeEnabled("log")) return;
        _$map_16(CONSOLE_LOG_METHODS, function(method) {
            var original = console[method];
            console[method] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                client.leaveBreadcrumb("Console output", _$reduce_17(args, function(accum, arg, i) {
                    // do the best/simplest stringification of each argument
                    var stringified = "[Unknown value]";
                    // this may fail if the input is:
                    // - an object whose [[Prototype]] is null (no toString)
                    // - an object with a broken toString or @@toPrimitive implementation
                    try {
                        stringified = String(arg);
                    } catch (e) {}
                    // if it stringifies to [object Object] attempt to JSON stringify
                    if (stringified === "[object Object]") // catch stringify errors and fallback to [object Object]
                    try {
                        stringified = JSON.stringify(arg);
                    } catch (e) {}
                    accum["[" + i + "]"] = stringified;
                    return accum;
                }, {
                    severity: method.indexOf("group") === 0 ? "log" : method
                }), "log");
                original.apply(console, args);
            };
            console[method]._restore = function() {
                console[method] = original;
            };
        });
    };
    var CONSOLE_LOG_METHODS = _$filter_12([
        "log",
        "debug",
        "info",
        "warn",
        "error"
    ], function(method) {
        return typeof console !== "undefined" && typeof console[method] === "function";
    }); /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var MAX_LINE_LENGTH = 200;
    var MAX_SCRIPT_LENGTH = 500000;
    var _$inlineScriptContent_48 = function(doc, win) {
        if (doc === void 0) doc = document;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!client._config.trackInlineScripts) return;
                var originalLocation = win.location.href;
                var html = "";
                // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
                // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing
                var isOldIe = !!doc.attachEvent;
                var DOMContentLoaded = isOldIe ? doc.readyState === "complete" : doc.readyState !== "loading";
                var getHtml = function() {
                    return doc.documentElement.outerHTML;
                };
                // get whatever HTML exists at this point in time
                html = getHtml();
                var prev = doc.onreadystatechange;
                // then update it when the DOM content has loaded
                doc.onreadystatechange = function() {
                    // IE8 compatible alternative to document#DOMContentLoaded
                    if (doc.readyState === "interactive") {
                        html = getHtml();
                        DOMContentLoaded = true;
                    }
                    try {
                        prev.apply(this, arguments);
                    } catch (e) {}
                };
                var _lastScript = null;
                var updateLastScript = function(script) {
                    _lastScript = script;
                };
                var getCurrentScript = function() {
                    var script = doc.currentScript || _lastScript;
                    if (!script && !DOMContentLoaded) {
                        var scripts = doc.scripts || doc.getElementsByTagName("script");
                        script = scripts[scripts.length - 1];
                    }
                    return script;
                };
                var addSurroundingCode = function(lineNumber) {
                    // get whatever html has rendered at this point
                    if (!DOMContentLoaded || !html) html = getHtml();
                    // simulate the raw html
                    var htmlLines = [
                        "<!-- DOC START -->"
                    ].concat(html.split("\n"));
                    var zeroBasedLine = lineNumber - 1;
                    var start = Math.max(zeroBasedLine - 3, 0);
                    var end = Math.min(zeroBasedLine + 3, htmlLines.length);
                    return _$reduce_17(htmlLines.slice(start, end), function(accum, line, i) {
                        accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
                        return accum;
                    }, {});
                };
                client.addOnError(function(event) {
                    // remove any of our own frames that may be part the stack this
                    // happens before the inline script check as it happens for all errors
                    event.errors[0].stacktrace = _$filter_12(event.errors[0].stacktrace, function(f) {
                        return !/__trace__$/.test(f.method);
                    });
                    var frame = event.errors[0].stacktrace[0];
                    // remove hash and query string from url
                    var cleanUrl = function(url) {
                        return url.replace(/#.*$/, "").replace(/\?.*$/, "");
                    };
                    // if frame.file exists and is not the original location of the page, this can't be an inline script
                    if (frame && frame.file && cleanUrl(frame.file) !== cleanUrl(originalLocation)) return;
                    // grab the last script known to have run
                    var currentScript = getCurrentScript();
                    if (currentScript) {
                        var content = currentScript.innerHTML;
                        event.addMetadata("script", "content", content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH));
                        // only attempt to grab some surrounding code if we have a line number
                        if (frame && frame.lineNumber) frame.code = addSurroundingCode(frame.lineNumber);
                    }
                }, true);
                // Proxy all the timer functions whose callback is their 0th argument.
                // Keep a reference to the original setTimeout because we need it later
                var _map = _$map_16([
                    "setTimeout",
                    "setInterval",
                    "setImmediate",
                    "requestAnimationFrame"
                ], function(fn) {
                    return __proxy(win, fn, function(original) {
                        return __traceOriginalScript(original, function(args) {
                            return {
                                get: function() {
                                    return args[0];
                                },
                                replace: function(fn) {
                                    args[0] = fn;
                                }
                            };
                        });
                    });
                }), _setTimeout = _map[0];
                // Proxy all the host objects whose prototypes have an addEventListener function
                _$map_16([
                    "EventTarget",
                    "Window",
                    "Node",
                    "ApplicationCache",
                    "AudioTrackList",
                    "ChannelMergerNode",
                    "CryptoOperation",
                    "EventSource",
                    "FileReader",
                    "HTMLUnknownElement",
                    "IDBDatabase",
                    "IDBRequest",
                    "IDBTransaction",
                    "KeyOperation",
                    "MediaController",
                    "MessagePort",
                    "ModalWindow",
                    "Notification",
                    "SVGElementInstance",
                    "Screen",
                    "TextTrack",
                    "TextTrackCue",
                    "TextTrackList",
                    "WebSocket",
                    "WebSocketWorker",
                    "Worker",
                    "XMLHttpRequest",
                    "XMLHttpRequestEventTarget",
                    "XMLHttpRequestUpload"
                ], function(o) {
                    if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, "addEventListener")) return;
                    __proxy(win[o].prototype, "addEventListener", function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor);
                    });
                    __proxy(win[o].prototype, "removeEventListener", function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
                    });
                });
                function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
                    if (alsoCallOriginal === void 0) alsoCallOriginal = false;
                    return function() {
                        // this is required for removeEventListener to remove anything added with
                        // addEventListener before the functions started being wrapped by Bugsnag
                        var args = [].slice.call(arguments);
                        try {
                            var cba = callbackAccessor(args);
                            var cb = cba.get();
                            if (alsoCallOriginal) fn.apply(this, args);
                            if (typeof cb !== "function") return fn.apply(this, args);
                            if (cb.__trace__) cba.replace(cb.__trace__);
                            else {
                                var script = getCurrentScript();
                                // this function mustn't be annonymous due to a bug in the stack
                                // generation logic, meaning it gets tripped up
                                // see: https://github.com/stacktracejs/stack-generator/issues/6
                                cb.__trace__ = function __trace__() {
                                    // set the script that called this function
                                    updateLastScript(script);
                                    // immediately unset the currentScript synchronously below, however
                                    // if this cb throws an error the line after will not get run so schedule
                                    // an almost-immediate aysnc update too
                                    _setTimeout(function() {
                                        updateLastScript(null);
                                    }, 0);
                                    var ret = cb.apply(this, arguments);
                                    updateLastScript(null);
                                    return ret;
                                };
                                cb.__trace__.__trace__ = cb.__trace__;
                                cba.replace(cb.__trace__);
                            }
                        } catch (e) {
                        // swallow these errors on Selenium:
                        // Permission denied to access property '__trace__'
                        // WebDriverException: Message: Permission denied to access property "handleEvent"
                        }
                        // IE8 doesn't let you call .apply() on setTimeout/setInterval
                        if (fn.apply) return fn.apply(this, args);
                        switch(args.length){
                            case 1:
                                return fn(args[0]);
                            case 2:
                                return fn(args[0], args[1]);
                            default:
                                return fn();
                        }
                    };
                }
            },
            configSchema: {
                trackInlineScripts: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: "should be true|false"
                }
            }
        };
    };
    function __proxy(host, name, replacer) {
        var original = host[name];
        if (!original) return original;
        var replacement = replacer(original);
        host[name] = replacement;
        return original;
    }
    function eventTargetCallbackAccessor(args) {
        var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === "function";
        return {
            get: function() {
                return isEventHandlerObj ? args[1].handleEvent : args[1];
            },
            replace: function(fn) {
                if (isEventHandlerObj) args[1].handleEvent = fn;
                else args[1] = fn;
            }
        };
    }
    /*
 * Leaves breadcrumbs when the user interacts with the DOM
 */ var _$interactionBreadcrumbs_49 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!("addEventListener" in win)) return;
                if (!client._isBreadcrumbTypeEnabled("user")) return;
                win.addEventListener("click", function(event) {
                    var targetText, targetSelector;
                    try {
                        targetText = getNodeText(event.target);
                        targetSelector = getNodeSelector(event.target, win);
                    } catch (e) {
                        targetText = "[hidden]";
                        targetSelector = "[hidden]";
                        client._logger.error("Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z");
                    }
                    client.leaveBreadcrumb("UI click", {
                        targetText: targetText,
                        targetSelector: targetSelector
                    }, "user");
                }, true);
            }
        };
    };
    var trim = /^\s*([^\s][\s\S]{0,139}[^\s])?\s*/;
    function getNodeText(el) {
        var text = el.textContent || el.innerText || "";
        if (!text && (el.type === "submit" || el.type === "button")) text = el.value;
        text = text.replace(trim, "$1");
        if (text.length > 140) return text.slice(0, 135) + "(...)";
        return text;
    }
    // Create a label from tagname, id and css class of the element
    function getNodeSelector(el, win) {
        var parts = [
            el.tagName
        ];
        if (el.id) parts.push("#" + el.id);
        if (el.className && el.className.length) parts.push("." + el.className.split(" ").join("."));
        // Can't get much more advanced with the current browser
        if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join("");
        try {
            if (win.document.querySelectorAll(parts.join("")).length === 1) return parts.join("");
        } catch (e) {
            // Sometimes the query selector can be invalid just return it as-is
            return parts.join("");
        }
        // try to get a more specific selector if this one matches more than one element
        if (el.parentNode.childNodes.length > 1) {
            var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
            parts.push(":nth-child(" + index + ")");
        }
        if (win.document.querySelectorAll(parts.join("")).length === 1) return parts.join("");
        // try prepending the parent node selector
        if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join("");
        return parts.join("");
    }
    var _$navigationBreadcrumbs_50 = {};
    /*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/ _$navigationBreadcrumbs_50 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!("addEventListener" in win)) return;
                if (!client._isBreadcrumbTypeEnabled("navigation")) return;
                // returns a function that will drop a breadcrumb with a given name
                var drop = function(name) {
                    return function() {
                        return client.leaveBreadcrumb(name, {}, "navigation");
                    };
                };
                // simple drops – just names, no meta
                win.addEventListener("pagehide", drop("Page hidden"), true);
                win.addEventListener("pageshow", drop("Page shown"), true);
                win.addEventListener("load", drop("Page loaded"), true);
                win.document.addEventListener("DOMContentLoaded", drop("DOMContentLoaded"), true);
                // some browsers like to emit popstate when the page loads, so only add the popstate listener after that
                win.addEventListener("load", function() {
                    return win.addEventListener("popstate", drop("Navigated back"), true);
                });
                // hashchange has some metadata that we care about
                win.addEventListener("hashchange", function(event) {
                    var metadata = event.oldURL ? {
                        from: relativeLocation(event.oldURL, win),
                        to: relativeLocation(event.newURL, win),
                        state: getCurrentState(win)
                    } : {
                        to: relativeLocation(win.location.href, win)
                    };
                    client.leaveBreadcrumb("Hash changed", metadata, "navigation");
                }, true);
                // the only way to know about replaceState/pushState is to wrap them… >_<
                if (win.history.replaceState) wrapHistoryFn(client, win.history, "replaceState", win);
                if (win.history.pushState) wrapHistoryFn(client, win.history, "pushState", win);
            }
        };
        return plugin;
    };
    // takes a full url like http://foo.com:1234/pages/01.html?yes=no#section-2 and returns
    // just the path and hash parts, e.g. /pages/01.html?yes=no#section-2
    var relativeLocation = function(url, win) {
        var a = win.document.createElement("A");
        a.href = url;
        return "" + a.pathname + a.search + a.hash;
    };
    var stateChangeToMetadata = function(win, state, title, url) {
        var currentPath = relativeLocation(win.location.href, win);
        return {
            title: title,
            state: state,
            prevState: getCurrentState(win),
            to: url || currentPath,
            from: currentPath
        };
    };
    var wrapHistoryFn = function(client, target, fn, win) {
        var orig = target[fn];
        target[fn] = function(state, title, url) {
            client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), "navigation");
            // if throttle plugin is in use, reset the event sent count
            if (typeof client.resetEventCount === "function") client.resetEventCount();
            // if the client is operating in auto session-mode, a new route should trigger a new session
            if (client._config.autoTrackSessions) client.startSession();
            // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
            // to '/undefined'. therefore we only pass the url if it's not undefined.
            orig.apply(target, [
                state,
                title
            ].concat(url !== undefined ? url : []));
        };
    };
    var getCurrentState = function(win) {
        try {
            return win.history.state;
        } catch (e) {}
    };
    var BREADCRUMB_TYPE = "request"; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    /*
 * Leaves breadcrumbs when network requests occur
 */ var _$networkBreadcrumbs_51 = function(_ignoredUrls, win) {
        if (_ignoredUrls === void 0) _ignoredUrls = [];
        if (win === void 0) win = window;
        var restoreFunctions = [];
        var plugin = {
            load: function(client) {
                if (!client._isBreadcrumbTypeEnabled("request")) return;
                var ignoredUrls = [
                    client._config.endpoints.notify,
                    client._config.endpoints.sessions
                ].concat(_ignoredUrls);
                monkeyPatchXMLHttpRequest();
                monkeyPatchFetch();
                // XMLHttpRequest monkey patch
                function monkeyPatchXMLHttpRequest() {
                    if (!("addEventListener" in win.XMLHttpRequest.prototype)) return;
                    var nativeOpen = win.XMLHttpRequest.prototype.open;
                    // override native open()
                    win.XMLHttpRequest.prototype.open = function open(method, url) {
                        var _this = this;
                        var requestSetupKey = false;
                        var error = function() {
                            return handleXHRError(method, url);
                        };
                        var load = function() {
                            return handleXHRLoad(method, url, _this.status);
                        };
                        // if we have already setup listeners, it means open() was called twice, we need to remove
                        // the listeners and recreate them
                        if (requestSetupKey) {
                            this.removeEventListener("load", load);
                            this.removeEventListener("error", error);
                        }
                        // attach load event listener
                        this.addEventListener("load", load);
                        // attach error event listener
                        this.addEventListener("error", error);
                        requestSetupKey = true;
                        nativeOpen.apply(this, arguments);
                    };
                }
                function handleXHRLoad(method, url, status) {
                    if (url === undefined) {
                        client._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
                        return;
                    }
                    // an XMLHttpRequest's URL can be an object as long as its 'toString'
                    // returns a URL, e.g. a HTMLAnchorElement
                    if (typeof url === "string" && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ""))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    var metadata = {
                        status: status,
                        request: method + " " + url
                    };
                    if (status >= 400) // contacted server but got an error response
                    client.leaveBreadcrumb("XMLHttpRequest failed", metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb("XMLHttpRequest succeeded", metadata, BREADCRUMB_TYPE);
                }
                function handleXHRError(method, url) {
                    if (url === undefined) {
                        client._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
                        return;
                    }
                    if (typeof url === "string" && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ""))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    // failed to contact server
                    client.leaveBreadcrumb("XMLHttpRequest error", {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                }
                // window.fetch monkey patch
                function monkeyPatchFetch() {
                    // only patch it if it exists and if it is not a polyfill (patching a polyfilled
                    // fetch() results in duplicate breadcrumbs for the same request because the
                    // implementation uses XMLHttpRequest which is also patched)
                    if (!("fetch" in win) || win.fetch.polyfill) return;
                    var oldFetch = win.fetch;
                    win.fetch = function fetch() {
                        var _arguments = arguments;
                        var urlOrRequest = arguments[0];
                        var options = arguments[1];
                        var method;
                        var url = null;
                        if (urlOrRequest && typeof urlOrRequest === "object") {
                            url = urlOrRequest.url;
                            if (options && "method" in options) method = options.method;
                            else if (urlOrRequest && "method" in urlOrRequest) method = urlOrRequest.method;
                        } else {
                            url = urlOrRequest;
                            if (options && "method" in options) method = options.method;
                        }
                        if (method === undefined) method = "GET";
                        return new Promise(function(resolve, reject) {
                            // pass through to native fetch
                            oldFetch.apply(void 0, _arguments).then(function(response) {
                                handleFetchSuccess(response, method, url);
                                resolve(response);
                            })["catch"](function(error) {
                                handleFetchError(method, url);
                                reject(error);
                            });
                        });
                    };
                }
                var handleFetchSuccess = function(response, method, url) {
                    var metadata = {
                        status: response.status,
                        request: method + " " + url
                    };
                    if (response.status >= 400) // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
                    client.leaveBreadcrumb("fetch() failed", metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb("fetch() succeeded", metadata, BREADCRUMB_TYPE);
                };
                var handleFetchError = function(method, url) {
                    client.leaveBreadcrumb("fetch() error", {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                };
            }
        };
        return plugin;
    }; /* removed: var _$intRange_24 = require('@bugsnag/core/lib/validators/int-range'); */ 
    /*
 * Throttles and dedupes events
 */ var _$throttle_52 = {
        load: function(client) {
            // track sent events for each init of the plugin
            var n = 0;
            // add onError hook
            client.addOnError(function(event) {
                // have max events been sent already?
                if (n >= client._config.maxEvents) {
                    client._logger.warn("Cancelling event send due to maxEvents per session limit of " + client._config.maxEvents + " being reached");
                    return false;
                }
                n++;
            });
            client.resetEventCount = function() {
                n = 0;
            };
        },
        configSchema: {
            maxEvents: {
                defaultValue: function() {
                    return 10;
                },
                message: "should be a positive integer ≤100",
                validate: function(val) {
                    return _$intRange_24(1, 100)(val);
                }
            }
        }
    };
    var _$stripQueryString_53 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    _$stripQueryString_53 = {
        load: function(client) {
            client.addOnError(function(event) {
                var allFrames = _$reduce_17(event.errors, function(accum, er) {
                    return accum.concat(er.stacktrace);
                }, []);
                _$map_16(allFrames, function(frame) {
                    frame.file = strip(frame.file);
                });
            });
        }
    };
    var strip = _$stripQueryString_53._strip = function(str) {
        return typeof str === "string" ? str.replace(/\?.*$/, "").replace(/#.*$/, "") : str;
    };
    /*
 * Automatically notifies Bugsnag when window.onerror is called
 */ var _$onerror_54 = function(win, component) {
        if (win === void 0) win = window;
        if (component === void 0) component = "window onerror";
        return {
            load: function(client) {
                if (!client._config.autoDetectErrors) return;
                if (!client._config.enabledErrorTypes.unhandledExceptions) return;
                function onerror(messageOrEvent, url, lineNo, charNo, error) {
                    // Ignore errors with no info due to CORS settings
                    if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) client._logger.warn("Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z");
                    else {
                        // any error sent to window.onerror is unhandled and has severity=error
                        var handledState = {
                            severity: "error",
                            unhandled: true,
                            severityReason: {
                                type: "unhandledException"
                            }
                        };
                        var event;
                        // window.onerror can be called in a number of ways. This big if-else is how we
                        // figure out which arguments were supplied, and what kind of values it received.
                        if (error) {
                            // if the last parameter (error) was supplied, this is a modern browser's
                            // way of saying "this value was thrown and not caught"
                            event = client.Event.create(error, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        } else if (// This complex case detects "error" events that are typically synthesised
                        // by jquery's trigger method (although can be created in other ways). In
                        // order to detect this:
                        // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
                        // - the second argument (url) must either not exist or be something other than a string (if it
                        //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
                        //    function)
                        // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
                        typeof messageOrEvent === "object" && messageOrEvent !== null && (!url || typeof url !== "string") && !lineNo && !charNo && !error) {
                            // The jQuery event may have a "type" property, if so use it as part of the error message
                            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : "Error";
                            // attempt to find a message from one of the conventional properties, but
                            // default to empty string (the event will fill it with a placeholder)
                            var message = messageOrEvent.message || messageOrEvent.detail || "";
                            event = client.Event.create({
                                name: name,
                                message: message
                            }, true, handledState, component, 1);
                            // provide the original thing onerror received – not our error-like object we passed to _notify
                            event.originalError = messageOrEvent;
                            // include the raw input as metadata – it might contain more info than we extracted
                            event.addMetadata(component, {
                                event: messageOrEvent,
                                extraParameters: url
                            });
                        } else {
                            // Lastly, if there was no "error" parameter this event was probably from an old
                            // browser that doesn't support that. Instead we need to generate a stacktrace.
                            event = client.Event.create(messageOrEvent, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        }
                        client._notify(event);
                    }
                    if (typeof prevOnError === "function") prevOnError.apply(this, arguments);
                }
                var prevOnError = win.onerror;
                win.onerror = onerror;
            }
        };
    };
    // Sometimes the stacktrace has less information than was passed to window.onerror.
    // This function will augment the first stackframe with any useful info that was
    // received as arguments to the onerror callback.
    var decorateStack = function(stack, url, lineNo, charNo) {
        if (!stack[0]) stack.push({});
        var culprit = stack[0];
        if (!culprit.file && typeof url === "string") culprit.file = url;
        if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;
        if (!culprit.columnNumber) {
            if (isActualNumber(charNo)) culprit.columnNumber = charNo;
            else if (window.event && isActualNumber(window.event.errorCharacter)) culprit.columnNumber = window.event.errorCharacter;
        }
    };
    var isActualNumber = function(n) {
        return typeof n === "number" && String.call(n) !== "NaN";
    }; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _listener;
    /*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */ var _$unhandledRejection_55 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;
                var listener = function(evt) {
                    var error = evt.reason;
                    var isBluebird = false;
                    // accessing properties on evt.detail can throw errors (see #394)
                    try {
                        if (evt.detail && evt.detail.reason) {
                            error = evt.detail.reason;
                            isBluebird = true;
                        }
                    } catch (e) {}
                    var event = client.Event.create(error, false, {
                        severity: "error",
                        unhandled: true,
                        severityReason: {
                            type: "unhandledPromiseRejection"
                        }
                    }, "unhandledrejection handler", 1, client._logger);
                    if (isBluebird) _$map_16(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
                    client._notify(event, function(event) {
                        if (_$iserror_20(event.originalError) && !event.originalError.stack) {
                            var _event$addMetadata;
                            event.addMetadata("unhandledRejection handler", (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
                                name: event.originalError.name,
                                message: event.originalError.message,
                                code: event.originalError.code
                            }, _event$addMetadata));
                        }
                    });
                };
                if ("addEventListener" in win) win.addEventListener("unhandledrejection", listener);
                else win.onunhandledrejection = function(reason, promise) {
                    listener({
                        detail: {
                            reason: reason,
                            promise: promise
                        }
                    });
                };
                _listener = listener;
            }
        };
        return plugin;
    };
    // The stack parser on bluebird stacks in FF get a suprious first frame:
    //
    // Error: derp
    //   b@http://localhost:5000/bluebird.html:22:24
    //   a@http://localhost:5000/bluebird.html:18:9
    //   @http://localhost:5000/bluebird.html:14:9
    //
    // results in
    //   […]
    //     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
    //     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
    //     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
    //     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
    //
    // so the following reduce/accumulator function removes such frames
    //
    // Bluebird pads method names with spaces so trim that too…
    // https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571
    var fixBluebirdStacktrace = function(error) {
        return function(frame) {
            if (frame.file === error.toString()) return;
            if (frame.method) frame.method = frame.method.replace(/^\s+/, "");
        };
    };
    var _$notifier_2 = {};
    var name = "Bugsnag JavaScript";
    var version = "7.22.7";
    var url = "https://github.com/bugsnag/bugsnag-js"; /* removed: var _$Client_4 = require('@bugsnag/core/client'); */ 
    // extend the base config schema with some browser-specific options
    var __schema_2 = _$assign_11({}, _$config_5.schema, _$config_1); /* removed: var _$onerror_54 = require('@bugsnag/plugin-window-onerror'); */ 
    var Bugsnag = {
        _client: null,
        createClient: function(opts) {
            // handle very simple use case where user supplies just the api key as a string
            if (typeof opts === "string") opts = {
                apiKey: opts
            };
            if (!opts) opts = {};
            var internalPlugins = [
                // add browser-specific plugins
                _$app_38,
                _$device_40(),
                _$context_39(),
                _$request_44(),
                _$throttle_52,
                _$session_45,
                _$clientIp_46,
                _$stripQueryString_53,
                _$onerror_54(),
                _$unhandledRejection_55(),
                _$navigationBreadcrumbs_50(),
                _$interactionBreadcrumbs_49(),
                _$networkBreadcrumbs_51(),
                _$consoleBreadcrumbs_47,
                // this one added last to avoid wrapping functionality before bugsnag uses it
                _$inlineScriptContent_48()
            ];
            // configure a client with user supplied options
            var bugsnag = new _$Client_4(opts, __schema_2, internalPlugins, {
                name: name,
                version: version,
                url: url
            });
            // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)
            bugsnag._setDelivery(window.XDomainRequest ? _$delivery_36 : _$delivery_37);
            bugsnag._logger.debug("Loaded!");
            bugsnag.leaveBreadcrumb("Bugsnag loaded", {}, "state");
            return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
        },
        start: function(opts) {
            if (Bugsnag._client) {
                Bugsnag._client._logger.warn("Bugsnag.start() was called more than once. Ignoring.");
                return Bugsnag._client;
            }
            Bugsnag._client = Bugsnag.createClient(opts);
            return Bugsnag._client;
        },
        isStarted: function() {
            return Bugsnag._client != null;
        }
    };
    _$map_16([
        "resetEventCount"
    ].concat(_$keys_15(_$Client_4.prototype)), function(m) {
        if (/^_/.test(m)) return;
        Bugsnag[m] = function() {
            if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
            Bugsnag._client._depth += 1;
            var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);
            Bugsnag._client._depth -= 1;
            return ret;
        };
    });
    _$notifier_2 = Bugsnag;
    _$notifier_2.Client = _$Client_4;
    _$notifier_2.Event = _$Event_6;
    _$notifier_2.Session = _$Session_35;
    _$notifier_2.Breadcrumb = _$Breadcrumb_3;
    // Export a "default" property for compatibility with ESM imports
    _$notifier_2["default"] = Bugsnag;
    return _$notifier_2;
});

});

parcelRequire.register("b6MEP", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $8165ff9a065fd270$export$306c0aa65ff9ec16; }, function (v) { return $8165ff9a065fd270$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8165ff9a065fd270$export$306c0aa65ff9ec16;
"use strict";

var $4lkrv = parcelRequire("4lkrv");
function $8165ff9a065fd270$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8165ff9a065fd270$var$k = "function" === typeof Object.is ? Object.is : $8165ff9a065fd270$var$h, $8165ff9a065fd270$var$l = $4lkrv.useState, $8165ff9a065fd270$var$m = $4lkrv.useEffect, $8165ff9a065fd270$var$n = $4lkrv.useLayoutEffect, $8165ff9a065fd270$var$p = $4lkrv.useDebugValue;
function $8165ff9a065fd270$var$q(a, b) {
    var d = b(), f = $8165ff9a065fd270$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $8165ff9a065fd270$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $8165ff9a065fd270$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $8165ff9a065fd270$var$m(function() {
        $8165ff9a065fd270$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $8165ff9a065fd270$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $8165ff9a065fd270$var$p(d);
    return d;
}
function $8165ff9a065fd270$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$8165ff9a065fd270$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $8165ff9a065fd270$var$t(a, b) {
    return b();
}
var $8165ff9a065fd270$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $8165ff9a065fd270$var$t : $8165ff9a065fd270$var$q;
$8165ff9a065fd270$export$306c0aa65ff9ec16 = void 0 !== $4lkrv.useSyncExternalStore ? $4lkrv.useSyncExternalStore : $8165ff9a065fd270$var$u;

});

var $00126b774925bb38$exports = {};
$00126b774925bb38$exports = JSON.parse('{"PricingCalculator":{"enterSize":"Enter your size","chooseSize":"Choose your size","enterSizeDesc":"We can print any size from {{minWidth}}{{units}} to {{maxWidth}}{{units}}","quantityLabel":"Custom Quantity","quantityTooSmall":"Minimum order is {{moq}} pieces","quantityHelperText":"Minimum order is {{moq}} pieces","materialLabel":"Material","shapeLabel":"Shape","selectYourMaterial":"Select your material","selectYourShape":"Select your shape","quantityTitle":"Choose your quantity","quantitySubtitle":"Minimum order for {{dimensions}} is {{moq}} pieces","incTax":"prices inc VAT","exTax":"prices excl VAT","save":"Save","uploadText":"Next, upload your artwork & our designers will make it print ready. We\'ll send a proof before printing.","continue":"continue","quantity":"Quantity","customQuantityLabel":"Custom Quantity","dimensions":"Dimensions","bestseller":"Bestseller","customize":"Customize","addToCart":"Add to Cart"},"Dimensions":{"cm":"cm","in":"in","mm":"mm","m":"m","widthLabel":"Width","widthTooSmall":"Min. {{minWidth}}{{units}} width.","widthTooBig":"Max. {{maxWidth}}{{units}} width.","widthHelperText":"Min {{minWidth}}{{units}}, max {{maxWidth}}{{units}}","heightLabel":"Height","heightTooSmall":"Min. {{minHeight}}{{units}} height.","heightTooBig":"Max. {{maxHeight}}{{units}} height.","heightHelperText":"Min {{minHeight}}{{units}}, max {{maxHeight}}{{units}}","maxdp":"max dp"},"Materials":{"vinyl-white":{"name":"White Vinyl","description":"Most popular","sortOrder":1,"bestseller":"Best seller"},"vinyl-clear":{"name":"Clear vinyl","description":"Highly transparent","sortOrder":2},"holographic":{"name":"Holographic","description":"Rainbow iridescent effect gives metallic colours","sortOrder":3},"glitter":{"name":"Glitter","description":"Glitter effect creates sparkly colours","sortOrder":6},"paper-biodegradable":{"name":"Biodegradable Paper","description":"Premium compostable paper with a matte finish"},"mirror-gold":{"name":"Mirror gold","description":"Shiny gold chrome effect","sortOrder":5},"mirror-silver":{"name":"Mirror silver","description":"Silver chrome effect gives metallic colours","sortOrder":4},"transfer-white":{"name":"White vinyl transfer","description":"Cut from a single piece of white vinyl"},"transfer-black":{"name":"Black vinyl transfer","description":"Cut from a single piece of black vinyl"},"magnet-white":{"name":"White (Standard)","description":"Most popular, best for keeping your design true to the original colours"},"magnet-holo":{"name":"Holographic Magnet","description":"Rainbow iridescent effect gives metallic colours"},"magnet-glitter":{"name":"Glitter Magnet","description":"Glitter effect creates sparkly colours"},"magnet-silver":{"name":"Silver Magnet","description":"Silver chrome effect for metallic colours"},"magnet-gold":{"name":"Gold Magnet","description":"Shiny gold chrome effect"},"button-white":{"name":"White (Standard)","description":"Most popular, best for keeping your design true to the original colours"},"button-holo":{"name":"Holographic","description":"Rainbow iridescent effect gives metallic colours"},"button-glitter":{"name":"Glitter","description":"Glitter effect creates sparkly colours"},"button-silver":{"name":"Mirror Silver","description":"Silver chrome effect for metallic colours"},"button-gold":{"name":"Mirror Gold","description":"Shiny gold chrome effect"}},"MaterialChooser":{"chooseYourMaterial":"Choose your material","wePrintOn":"We print on these materials","cancel":"Cancel","continue":"Continue"},"StartDesign":{"uploadArtworkFeatures":["Get a digital proof within 12 working hours.","Upload up to {{maxDesigns}} designs at once, that are the same size.","Submit high-quality files to get the perfect print."],"uploadArtworkTitle":"Upload artwork","uploadArtworkButtonText":"Upload my artwork","uploadArtworkSkipText":"Skip and email later"},"ShapeChooser":{"title":"Choose your Shape","cancel":"Cancel","continue":"Continue"},"Shapes":{"custom":"Custom","circle":"Circle","oval":"Oval","rectangular":"Rectangular","rectangle":"Rectangular","roundedcorner":"Rounded Corner","square":"Square"},"Reorder":{"pageTitle":"Re-order","subtitle":"Enter your details here to retrieve your past order","orderNumberPlaceholder":"Order number","emailPlaceholder":"Email","submitButtonText":"Retrieve order","helpText":"Can\'t find your order number? Login to see all of your designs & reorder"}}');



var $gWMia = parcelRequire("gWMia");

var $4lkrv = parcelRequire("4lkrv");
var $e62bf22c69a691b7$export$882461b6382ed46c;
var $e62bf22c69a691b7$export$757ceba2d55c277e;
"use strict";
var $b4d8cf9ba0f25243$exports = {};
"use strict";
function $b4d8cf9ba0f25243$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4d8cf9ba0f25243$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4d8cf9ba0f25243$var$checkDCE();

$b4d8cf9ba0f25243$exports = (parcelRequire("1CoNo"));


var $e62bf22c69a691b7$var$i;
$e62bf22c69a691b7$export$882461b6382ed46c = $b4d8cf9ba0f25243$exports.createRoot;
$e62bf22c69a691b7$export$757ceba2d55c277e = $b4d8cf9ba0f25243$exports.hydrateRoot;



var $gWMia = parcelRequire("gWMia");

var $4lkrv = parcelRequire("4lkrv");

var $gWMia = parcelRequire("gWMia");

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");

var $iB56s = parcelRequire("iB56s");

var $4pHkY = parcelRequire("4pHkY");

var $gNSaz = parcelRequire("gNSaz");
var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $3ocmy = parcelRequire("3ocmy");

var $cLAFm = parcelRequire("cLAFm");
const $2f5db38d865a4b77$var$_excluded = [
    "sx"
];
const $2f5db38d865a4b77$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $cLAFm.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $2f5db38d865a4b77$export$2e2bcd8739ae039(props) {
    const { sx: inSx  } = props, other = (0, $eLWn9.default)(props, $2f5db38d865a4b77$var$_excluded);
    const { systemProps: systemProps , otherProps: otherProps  } = $2f5db38d865a4b77$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3ocmy.isPlainObject)(result)) return systemProps;
        return (0, $9YD4s.default)({}, systemProps, result);
    };
    else finalSx = (0, $9YD4s.default)({}, systemProps, inSx);
    return (0, $9YD4s.default)({}, otherProps, {
        sx: finalSx
    });
}



var $4pME4 = parcelRequire("4pME4");

var $gWMia = parcelRequire("gWMia");
const $d18b5eca1871472b$var$_excluded = [
    "className",
    "component"
];
function $d18b5eca1871472b$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId , defaultTheme: defaultTheme , defaultClassName: defaultClassName = "MuiBox-root" , generateClassName: generateClassName  } = options;
    const BoxRoot = (0, $4pHkY.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $gNSaz.default));
    const Box = /*#__PURE__*/ $4lkrv.forwardRef(function Box(inProps, ref) {
        const theme = (0, $4pME4.default)(defaultTheme);
        const _extendSxProp = (0, $2f5db38d865a4b77$export$2e2bcd8739ae039)(inProps), { className: className , component: component = "div"  } = _extendSxProp, other = (0, $eLWn9.default)(_extendSxProp, $d18b5eca1871472b$var$_excluded);
        return /*#__PURE__*/ (0, $gWMia.jsx)(BoxRoot, (0, $9YD4s.default)({
            as: component,
            ref: ref,
            className: (0, $iB56s.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $6HhiO = parcelRequire("6HhiO");

var $hCTiq = parcelRequire("hCTiq");
const $9bc6663fb5729a22$var$defaultTheme = (0, $hCTiq.default)();
const $9bc6663fb5729a22$var$Box = (0, $d18b5eca1871472b$export$2e2bcd8739ae039)({
    defaultTheme: $9bc6663fb5729a22$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $6HhiO.default).generate
});
var $9bc6663fb5729a22$export$2e2bcd8739ae039 = $9bc6663fb5729a22$var$Box;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");


var $kdLbD = parcelRequire("kdLbD");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $lJkvk = parcelRequire("lJkvk");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $afa30a468fb3a557$export$24c1f8f60cbac79e(slot) {
    return (0, $1HGD7.default)("MuiTypography", slot);
}
const $afa30a468fb3a557$var$typographyClasses = (0, $3TIMy.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $afa30a468fb3a557$export$2e2bcd8739ae039 = $afa30a468fb3a557$var$typographyClasses;



var $gWMia = parcelRequire("gWMia");
const $4d47fcbf28a0e37f$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $4d47fcbf28a0e37f$var$useUtilityClasses = (ownerState)=>{
    const { align: align , gutterBottom: gutterBottom , noWrap: noWrap , paragraph: paragraph , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $lJkvk.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $afa30a468fb3a557$export$24c1f8f60cbac79e), classes);
};
const $4d47fcbf28a0e37f$export$140e2f5526d3cad8 = (0, $bgnZl.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $lJkvk.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $4d47fcbf28a0e37f$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
}; // TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $4d47fcbf28a0e37f$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $4d47fcbf28a0e37f$var$transformDeprecatedColors = (color)=>{
    return $4d47fcbf28a0e37f$var$colorTransformations[color] || color;
};
const $4d47fcbf28a0e37f$var$Typography = /*#__PURE__*/ $4lkrv.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $at7OG.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $4d47fcbf28a0e37f$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $2f5db38d865a4b77$export$2e2bcd8739ae039)((0, $9YD4s.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit" , className: className , component: component , gutterBottom: gutterBottom = false , noWrap: noWrap = false , paragraph: paragraph = false , variant: variant = "body1" , variantMapping: variantMapping = $4d47fcbf28a0e37f$var$defaultVariantMapping  } = props, other = (0, $eLWn9.default)(props, $4d47fcbf28a0e37f$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $4d47fcbf28a0e37f$var$defaultVariantMapping[variant]) || "span";
    const classes = $4d47fcbf28a0e37f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)($4d47fcbf28a0e37f$export$140e2f5526d3cad8, (0, $9YD4s.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $iB56s.default)(classes.root, className)
    }, other));
});
var $4d47fcbf28a0e37f$export$2e2bcd8739ae039 = $4d47fcbf28a0e37f$var$Typography;


parcelRequire("4lkrv");

var $9oVqX = parcelRequire("9oVqX");

var $hCTiq = parcelRequire("hCTiq");
const $5b810149f92fce45$export$8f45430ccf837300 = {
    coolBlue: "#0076CF",
    coolBlueLight: "#CCE4f6",
    coolBlueDark: "#004B9D",
    blue: "#141B4D",
    blueLight: "#424279",
    blueDark: "#000026",
    green: "#99F2E4",
    greenLight: "#CCF9F2",
    greenLightest: "#E6FCF9",
    greenDark: "#00B19D",
    greenBar: "#ADF0E4",
    greenOriginal: "#33E4C9",
    greenSuperLight: "#C8FFF4",
    greenAlt: "#1BD114",
    validateFail: "#E40028",
    validateOk: "#1BD114",
    orange: "#FF5900",
    orangeDark: "#C44500",
    orangeLight: "#FFCDB2",
    red: "#F82323",
    redLight: "#FF9191",
    redDark: "#D61313",
    white: "#FFFFFF",
    grey: "#7F8481",
    greyLight: "#AEB4B0",
    greyDark: "#535755",
    greyBorder: "#808381",
    greyBackground: "#F3F3F3",
    greyDivider: "#808381",
    greyPlaceholder: "#0000001A",
    black: "#000000",
    blackLight: "#2C2C2C",
    blackDark: "#000000"
};
const $5b810149f92fce45$var$baseTheme = (0, $hCTiq.default)();
const $5b810149f92fce45$var$stickeritTheme = (0, $hCTiq.default)({
    components: {
        MuiTab: {
            styleOverrides: {
                root: {
                    letterSpacing: 0.8
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "9px",
                    letterSpacing: 0.8
                }
            }
        }
    },
    typography: {
        fontFamily: [
            "Poppins"
        ].join(","),
        h1: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "32px",
            [$5b810149f92fce45$var$baseTheme.breakpoints.up("md")]: {
                fontSize: "40px"
            },
            fontWeight: "400",
            letterSpacing: "-0.4px"
        },
        h2: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "32px",
            [$5b810149f92fce45$var$baseTheme.breakpoints.up("md")]: {
                fontSize: "32px"
            },
            fontWeight: "400",
            letterSpacing: "-0.02rem"
        },
        h3: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "24px",
            [$5b810149f92fce45$var$baseTheme.breakpoints.up("md")]: {
                fontSize: "28px"
            },
            fontWeight: "400",
            letterSpacing: "-0.28px"
        },
        h4: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "22px",
            [$5b810149f92fce45$var$baseTheme.breakpoints.up("md")]: {
                fontSize: "26px"
            },
            fontWeight: "400",
            letterSpacing: "-0.26px"
        },
        h5: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "20px",
            [$5b810149f92fce45$var$baseTheme.breakpoints.up("md")]: {
                fontSize: "21px"
            },
            fontWeight: "400"
        },
        h6: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "18px",
            fontWeight: "400",
            letterSpacing: "-0.18px"
        },
        subtitle1: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "16px",
            fontWeight: "400",
            letterSpacing: "-0.16px"
        },
        subtitle2: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "14px",
            fontWeight: "500",
            letterSpacing: "-0.14px"
        },
        body1: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "16px",
            fontWeight: "300",
            letterSpacing: "-0.16px"
        },
        body2: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "14px",
            fontWeight: "300",
            letterSpacing: "-0.14px"
        },
        button: {
            color: $5b810149f92fce45$export$8f45430ccf837300.white,
            fontSize: "14px",
            fontWeight: "400",
            letterSpacing: "-0.8px"
        },
        caption: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "12px",
            fontWeight: "300",
            letterSpacing: "-0.12px"
        },
        overline: {
            color: $5b810149f92fce45$export$8f45430ccf837300.blue,
            fontSize: "10px",
            fontWeight: "400",
            letterSpacing: "-0.1px",
            textTransform: "capitalize"
        }
    },
    palette: {
        primary: {
            main: $5b810149f92fce45$export$8f45430ccf837300.coolBlue,
            light: $5b810149f92fce45$export$8f45430ccf837300.coolBlueLight,
            dark: $5b810149f92fce45$export$8f45430ccf837300.coolBlueDark
        },
        secondary: {
            main: $5b810149f92fce45$export$8f45430ccf837300.green,
            light: $5b810149f92fce45$export$8f45430ccf837300.greenLight,
            dark: $5b810149f92fce45$export$8f45430ccf837300.greenDark
        }
    },
    status: {
        danger: (0, $9oVqX.default)[500]
    },
    colors: $5b810149f92fce45$export$8f45430ccf837300
});
const $5b810149f92fce45$var$theme = (0, $hCTiq.default)($5b810149f92fce45$var$stickeritTheme, {
    components: {
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    background: $5b810149f92fce45$var$stickeritTheme.colors.greenDark
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        color: $5b810149f92fce45$var$stickeritTheme.colors.greenDark
                    }
                }
            }
        }
    },
    status: {
        danger: (0, $9oVqX.default)[500]
    }
});
var $5b810149f92fce45$export$2e2bcd8739ae039 = $5b810149f92fce45$var$theme;


const $5f7e2c6633a64ab9$export$6e2c8f0811a474ce = (props)=>{
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
        sx: {
            paddingTop: 2,
            ...props.sx
        },
        children: [
            /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                sx: {
                    pl: props?.titlePadding ? {
                        md: "23px"
                    } : ""
                },
                children: [
                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                        variant: "h5",
                        component: "div",
                        children: props.title
                    }),
                    props.subtitle ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                        color: (0, $5b810149f92fce45$export$8f45430ccf837300).greyDark,
                        variant: "caption",
                        component: "div",
                        children: props.subtitle
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                sx: {
                    paddingTop: 2
                },
                children: props.children
            })
        ]
    });
};


// Hook

var $4lkrv = parcelRequire("4lkrv");
// T is a generic type for value parameter, our case this will be string
function $f07e996c3fe7b389$var$useDebounce(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = (0, $4lkrv.useState)(value);
    (0, $4lkrv.useEffect)(()=>{
        // Update debounced value after delay
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
}
var $f07e996c3fe7b389$export$2e2bcd8739ae039 = $f07e996c3fe7b389$var$useDebounce;



var $gWMia = parcelRequire("gWMia");

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $2GXkB = parcelRequire("2GXkB");

var $kdLbD = parcelRequire("kdLbD");


var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");
parcelRequire("4lkrv");

var $4pME4 = parcelRequire("4pME4");

var $ksq4v = parcelRequire("ksq4v");
function $0fbff9e4f89c0f97$export$2e2bcd8739ae039() {
    const theme = (0, $4pME4.default)((0, $ksq4v.default));
    return theme;
}



var $4lkrv = parcelRequire("4lkrv");
/**
 * @ignore - internal component.
 */ const $735ab471ab0e61de$var$GridContext = /*#__PURE__*/ $4lkrv.createContext();
var $735ab471ab0e61de$export$2e2bcd8739ae039 = $735ab471ab0e61de$var$GridContext;



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $bc287ebd683af639$export$9973ac5fd0181f33(slot) {
    return (0, $1HGD7.default)("MuiGrid", slot);
}
const $bc287ebd683af639$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $bc287ebd683af639$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $bc287ebd683af639$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $bc287ebd683af639$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $bc287ebd683af639$var$gridClasses = (0, $3TIMy.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    ...$bc287ebd683af639$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    ...$bc287ebd683af639$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    ...$bc287ebd683af639$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    ...$bc287ebd683af639$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$bc287ebd683af639$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$bc287ebd683af639$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$bc287ebd683af639$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$bc287ebd683af639$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $bc287ebd683af639$export$2e2bcd8739ae039 = $bc287ebd683af639$var$gridClasses;



var $gWMia = parcelRequire("gWMia");
const $62d2338da85f4e74$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $62d2338da85f4e74$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $62d2338da85f4e74$export$ca2a698f6020fda({ theme: theme , ownerState: ownerState  }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $2GXkB.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
             // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$62d2338da85f4e74$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            } // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $9YD4s.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        } // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $62d2338da85f4e74$export$71d4225eeb1bc13e({ theme: theme , ownerState: ownerState  }) {
    const directionValues = (0, $2GXkB.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $2GXkB.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $bc287ebd683af639$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $62d2338da85f4e74$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints , values: values  }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $62d2338da85f4e74$export$380604d7c79f9e8f({ theme: theme , ownerState: ownerState  }) {
    const { container: container , rowSpacing: rowSpacing  } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $2GXkB.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $62d2338da85f4e74$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $2GXkB.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$62d2338da85f4e74$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $bc287ebd683af639$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $62d2338da85f4e74$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $bc287ebd683af639$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $62d2338da85f4e74$export$4315fba5128fb4a1({ theme: theme , ownerState: ownerState  }) {
    const { container: container , columnSpacing: columnSpacing  } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $2GXkB.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $62d2338da85f4e74$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $2GXkB.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$62d2338da85f4e74$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$62d2338da85f4e74$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $bc287ebd683af639$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $62d2338da85f4e74$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $bc287ebd683af639$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $62d2338da85f4e74$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
     // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
     // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $62d2338da85f4e74$var$GridRoot = (0, $bgnZl.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        const { container: container , direction: direction , item: item , spacing: spacing , wrap: wrap , zeroMinWidth: zeroMinWidth , breakpoints: breakpoints  } = ownerState;
        let spacingStyles = []; // in case of grid item
        if (container) spacingStyles = $62d2338da85f4e74$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $62d2338da85f4e74$export$71d4225eeb1bc13e, $62d2338da85f4e74$export$380604d7c79f9e8f, $62d2338da85f4e74$export$4315fba5128fb4a1, $62d2338da85f4e74$export$ca2a698f6020fda);
function $62d2338da85f4e74$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
     // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
     // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $62d2338da85f4e74$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , container: container , direction: direction , item: item , spacing: spacing , wrap: wrap , zeroMinWidth: zeroMinWidth , breakpoints: breakpoints  } = ownerState;
    let spacingClasses = []; // in case of grid item
    if (container) spacingClasses = $62d2338da85f4e74$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $bc287ebd683af639$export$9973ac5fd0181f33), classes);
};
const $62d2338da85f4e74$var$Grid = /*#__PURE__*/ $4lkrv.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $at7OG.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints  } = (0, $0fbff9e4f89c0f97$export$2e2bcd8739ae039)();
    const props = (0, $2f5db38d865a4b77$export$2e2bcd8739ae039)(themeProps);
    const { className: className , columns: columnsProp , columnSpacing: columnSpacingProp , component: component = "div" , container: container = false , direction: direction = "row" , item: item = false , rowSpacing: rowSpacingProp , spacing: spacing = 0 , wrap: wrap = "wrap" , zeroMinWidth: zeroMinWidth = false  } = props, other = (0, $eLWn9.default)(props, $62d2338da85f4e74$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $4lkrv.useContext((0, $735ab471ab0e61de$export$2e2bcd8739ae039)); // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $9YD4s.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $9YD4s.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $62d2338da85f4e74$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $735ab471ab0e61de$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $gWMia.jsx)($62d2338da85f4e74$var$GridRoot, (0, $9YD4s.default)({
            ownerState: ownerState,
            className: (0, $iB56s.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $62d2338da85f4e74$export$2e2bcd8739ae039 = $62d2338da85f4e74$var$Grid;


var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");


var $kdLbD = parcelRequire("kdLbD");

var $kFXNp = parcelRequire("kFXNp");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");


var $kdLbD = parcelRequire("kdLbD");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $4lkrv = parcelRequire("4lkrv");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $a9049f392c885db3$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $28e34e368be50325$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $4lkrv.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $a9049f392c885db3$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


var $55694fd908cff41d$export$2e2bcd8739ae039 = (0, $28e34e368be50325$export$2e2bcd8739ae039);



var $4lkrv = parcelRequire("4lkrv");

var $4lkrv = parcelRequire("4lkrv");
const $436de094adc3733f$var$useEnhancedEffect = typeof window !== "undefined" ? $4lkrv.useLayoutEffect : $4lkrv.useEffect;
var $436de094adc3733f$export$2e2bcd8739ae039 = $436de094adc3733f$var$useEnhancedEffect;


function $9450e5fed5a2c751$export$2e2bcd8739ae039(fn) {
    const ref = $4lkrv.useRef(fn);
    (0, $436de094adc3733f$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $4lkrv.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}


var $b9f2c9ca7ac03833$export$2e2bcd8739ae039 = (0, $9450e5fed5a2c751$export$2e2bcd8739ae039);


// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $4lkrv = parcelRequire("4lkrv");
let $7d4c7419a9e94f55$var$hadKeyboardEvent = true;
let $7d4c7419a9e94f55$var$hadFocusVisibleRecently = false;
let $7d4c7419a9e94f55$var$hadFocusVisibleRecentlyTimeout;
const $7d4c7419a9e94f55$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $7d4c7419a9e94f55$var$focusTriggersKeyboardModality(node) {
    const { type: type , tagName: tagName  } = node;
    if (tagName === "INPUT" && $7d4c7419a9e94f55$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $7d4c7419a9e94f55$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $7d4c7419a9e94f55$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $7d4c7419a9e94f55$var$handlePointerDown() {
    $7d4c7419a9e94f55$var$hadKeyboardEvent = false;
}
function $7d4c7419a9e94f55$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($7d4c7419a9e94f55$var$hadFocusVisibleRecently) $7d4c7419a9e94f55$var$hadKeyboardEvent = true;
    }
}
function $7d4c7419a9e94f55$var$prepare(doc) {
    doc.addEventListener("keydown", $7d4c7419a9e94f55$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $7d4c7419a9e94f55$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $7d4c7419a9e94f55$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $7d4c7419a9e94f55$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $7d4c7419a9e94f55$var$handleVisibilityChange, true);
}
function $7d4c7419a9e94f55$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $7d4c7419a9e94f55$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $7d4c7419a9e94f55$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $7d4c7419a9e94f55$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $7d4c7419a9e94f55$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $7d4c7419a9e94f55$var$handleVisibilityChange, true);
}
function $7d4c7419a9e94f55$var$isFocusVisible(event) {
    const { target: target  } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $7d4c7419a9e94f55$var$hadKeyboardEvent || $7d4c7419a9e94f55$var$focusTriggersKeyboardModality(target);
}
function $7d4c7419a9e94f55$export$2e2bcd8739ae039() {
    const ref = $4lkrv.useCallback((node)=>{
        if (node != null) $7d4c7419a9e94f55$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $4lkrv.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $7d4c7419a9e94f55$var$hadFocusVisibleRecently = true;
            window.clearTimeout($7d4c7419a9e94f55$var$hadFocusVisibleRecentlyTimeout);
            $7d4c7419a9e94f55$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $7d4c7419a9e94f55$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($7d4c7419a9e94f55$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


var $774963030b527352$export$2e2bcd8739ae039 = (0, $7d4c7419a9e94f55$export$2e2bcd8739ae039);



var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");


var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");
function $8ecf9feca1f5acae$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $0342d4acdf04576f$export$2e2bcd8739ae039(o, p) {
    $0342d4acdf04576f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0342d4acdf04576f$export$2e2bcd8739ae039(o, p);
}


function $32997f18e5380783$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0342d4acdf04576f$export$2e2bcd8739ae039)(subClass, superClass);
}




var $4lkrv = parcelRequire("4lkrv");

var $4lkrv = parcelRequire("4lkrv");
var $e1a24da57486c215$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createContext(null);



var $4lkrv = parcelRequire("4lkrv");
function $50769ac181db1301$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $4lkrv.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $4lkrv.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $50769ac181db1301$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $50769ac181db1301$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $50769ac181db1301$export$fa71e2345c31d7a2(props, onExited) {
    return $50769ac181db1301$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $4lkrv.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $50769ac181db1301$var$getProp(child, "appear", props),
            enter: $50769ac181db1301$var$getProp(child, "enter", props),
            exit: $50769ac181db1301$var$getProp(child, "exit", props)
        });
    });
}
function $50769ac181db1301$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $50769ac181db1301$export$bbc8a025727ea824(nextProps.children);
    var children = $50769ac181db1301$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $4lkrv.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $4lkrv.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $4lkrv.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $50769ac181db1301$var$getProp(child, "exit", nextProps),
            enter: $50769ac181db1301$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $4lkrv.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $4lkrv.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $4lkrv.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $50769ac181db1301$var$getProp(child, "exit", nextProps),
            enter: $50769ac181db1301$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $8d52fdc9cab5f505$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $8d52fdc9cab5f505$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $8d52fdc9cab5f505$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $32997f18e5380783$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $8ecf9feca1f5acae$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $50769ac181db1301$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $50769ac181db1301$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $50769ac181db1301$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $9YD4s.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $eLWn9.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $8d52fdc9cab5f505$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement((0, $e1a24da57486c215$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement((0, $e1a24da57486c215$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).Component);
$8d52fdc9cab5f505$var$TransitionGroup.propTypes = {};
$8d52fdc9cab5f505$var$TransitionGroup.defaultProps = $8d52fdc9cab5f505$var$defaultProps;
var $8d52fdc9cab5f505$export$2e2bcd8739ae039 = $8d52fdc9cab5f505$var$TransitionGroup;



var $iB56s = parcelRequire("iB56s");

var $35uzv = parcelRequire("35uzv");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $gWMia = parcelRequire("gWMia");
function $a60705888ff6d29e$var$Ripple(props) {
    const { className: className , classes: classes , pulsate: pulsate = false , rippleX: rippleX , rippleY: rippleY , rippleSize: rippleSize , in: inProp , onExited: onExited , timeout: timeout  } = props;
    const [leaving, setLeaving] = $4lkrv.useState(false);
    const rippleClassName = (0, $iB56s.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $iB56s.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $4lkrv.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $gWMia.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $gWMia.jsx)("span", {
            className: childClassName
        })
    });
}
var $a60705888ff6d29e$export$2e2bcd8739ae039 = $a60705888ff6d29e$var$Ripple;



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $2e0c3f776f427855$export$b464606f735ab902(slot) {
    return (0, $1HGD7.default)("MuiTouchRipple", slot);
}
const $2e0c3f776f427855$var$touchRippleClasses = (0, $3TIMy.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $2e0c3f776f427855$export$2e2bcd8739ae039 = $2e0c3f776f427855$var$touchRippleClasses;



var $gWMia = parcelRequire("gWMia");
const $9d9863ec7e72511d$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $9d9863ec7e72511d$var$_ = (t)=>t, $9d9863ec7e72511d$var$_t, $9d9863ec7e72511d$var$_t2, $9d9863ec7e72511d$var$_t3, $9d9863ec7e72511d$var$_t4;
const $9d9863ec7e72511d$var$DURATION = 550;
const $9d9863ec7e72511d$export$95d0c9356b2231a3 = 80;
const $9d9863ec7e72511d$var$enterKeyframe = (0, $35uzv.keyframes)($9d9863ec7e72511d$var$_t || ($9d9863ec7e72511d$var$_t = $9d9863ec7e72511d$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $9d9863ec7e72511d$var$exitKeyframe = (0, $35uzv.keyframes)($9d9863ec7e72511d$var$_t2 || ($9d9863ec7e72511d$var$_t2 = $9d9863ec7e72511d$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $9d9863ec7e72511d$var$pulsateKeyframe = (0, $35uzv.keyframes)($9d9863ec7e72511d$var$_t3 || ($9d9863ec7e72511d$var$_t3 = $9d9863ec7e72511d$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $9d9863ec7e72511d$export$f6b7418508c72c25 = (0, $bgnZl.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
}); // This `styled()` function invokes keyframes. `styled-components` only supports keyframes
const $9d9863ec7e72511d$export$676cfe7b12693c4b = (0, $bgnZl.default)((0, $a60705888ff6d29e$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($9d9863ec7e72511d$var$_t4 || ($9d9863ec7e72511d$var$_t4 = $9d9863ec7e72511d$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $2e0c3f776f427855$export$2e2bcd8739ae039).rippleVisible, $9d9863ec7e72511d$var$enterKeyframe, $9d9863ec7e72511d$var$DURATION, ({ theme: theme  })=>theme.transitions.easing.easeInOut, (0, $2e0c3f776f427855$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme  })=>theme.transitions.duration.shorter, (0, $2e0c3f776f427855$export$2e2bcd8739ae039).child, (0, $2e0c3f776f427855$export$2e2bcd8739ae039).childLeaving, $9d9863ec7e72511d$var$exitKeyframe, $9d9863ec7e72511d$var$DURATION, ({ theme: theme  })=>theme.transitions.easing.easeInOut, (0, $2e0c3f776f427855$export$2e2bcd8739ae039).childPulsate, $9d9863ec7e72511d$var$pulsateKeyframe, ({ theme: theme  })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $9d9863ec7e72511d$var$TouchRipple = /*#__PURE__*/ $4lkrv.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false , classes: classes = {} , className: className  } = props, other = (0, $eLWn9.default)(props, $9d9863ec7e72511d$var$_excluded);
    const [ripples, setRipples] = $4lkrv.useState([]);
    const nextKey = $4lkrv.useRef(0);
    const rippleCallback = $4lkrv.useRef(null);
    $4lkrv.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $4lkrv.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $4lkrv.useRef(null); // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $4lkrv.useRef(null);
    const container = $4lkrv.useRef(null);
    $4lkrv.useEffect(()=>{
        return ()=>{
            clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $4lkrv.useCallback((params)=>{
        const { pulsate: pulsate , rippleX: rippleX , rippleY: rippleY , rippleSize: rippleSize , cb: cb  } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $gWMia.jsx)($9d9863ec7e72511d$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $iB56s.default)(classes.ripple, (0, $2e0c3f776f427855$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $iB56s.default)(classes.rippleVisible, (0, $2e0c3f776f427855$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $iB56s.default)(classes.ripplePulsate, (0, $2e0c3f776f427855$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $iB56s.default)(classes.child, (0, $2e0c3f776f427855$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $iB56s.default)(classes.childLeaving, (0, $2e0c3f776f427855$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $iB56s.default)(classes.childPulsate, (0, $2e0c3f776f427855$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $9d9863ec7e72511d$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $4lkrv.useCallback((event = {}, options = {}, cb)=>{
        const { pulsate: pulsate = false , center: center = centerProp || options.pulsate , fakeElement: fakeElement = false // For test purposes
          } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX , clientY: clientY  } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3); // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        } // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $9d9863ec7e72511d$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $4lkrv.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $4lkrv.useCallback((event, cb)=>{
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $4lkrv.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $gWMia.jsx)($9d9863ec7e72511d$export$f6b7418508c72c25, (0, $9YD4s.default)({
        className: (0, $iB56s.default)((0, $2e0c3f776f427855$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $8d52fdc9cab5f505$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $9d9863ec7e72511d$export$2e2bcd8739ae039 = $9d9863ec7e72511d$var$TouchRipple;



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $679a65f5856bfe05$export$fccb0498dcd99783(slot) {
    return (0, $1HGD7.default)("MuiButtonBase", slot);
}
const $679a65f5856bfe05$var$buttonBaseClasses = (0, $3TIMy.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $679a65f5856bfe05$export$2e2bcd8739ae039 = $679a65f5856bfe05$var$buttonBaseClasses;



var $gWMia = parcelRequire("gWMia");
const $946ef14610be8634$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $946ef14610be8634$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled , focusVisible: focusVisible , focusVisibleClassName: focusVisibleClassName , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $kdLbD.default)(slots, (0, $679a65f5856bfe05$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $946ef14610be8634$export$7ec0dcc5e3cdcd36 = (0, $bgnZl.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $679a65f5856bfe05$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $946ef14610be8634$var$ButtonBase = /*#__PURE__*/ $4lkrv.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action , centerRipple: centerRipple = false , children: children , className: className , component: component = "button" , disabled: disabled = false , disableRipple: disableRipple = false , disableTouchRipple: disableTouchRipple = false , focusRipple: focusRipple = false , LinkComponent: LinkComponent = "a" , onBlur: onBlur , onClick: onClick , onContextMenu: onContextMenu , onDragLeave: onDragLeave , onFocus: onFocus , onFocusVisible: onFocusVisible , onKeyDown: onKeyDown , onKeyUp: onKeyUp , onMouseDown: onMouseDown , onMouseLeave: onMouseLeave , onMouseUp: onMouseUp , onTouchEnd: onTouchEnd , onTouchMove: onTouchMove , onTouchStart: onTouchStart , tabIndex: tabIndex = 0 , TouchRippleProps: TouchRippleProps , touchRippleRef: touchRippleRef , type: type  } = props, other = (0, $eLWn9.default)(props, $946ef14610be8634$var$_excluded);
    const buttonRef = $4lkrv.useRef(null);
    const rippleRef = $4lkrv.useRef(null);
    const handleRippleRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef , onFocus: handleFocusVisible , onBlur: handleBlurVisible , ref: focusVisibleRef  } = (0, $774963030b527352$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $4lkrv.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $4lkrv.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $4lkrv.useState(false);
    $4lkrv.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $4lkrv.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $b9f2c9ca7ac03833$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $b9f2c9ca7ac03833$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $4lkrv.useRef(false);
    const handleKeyDown = (0, $b9f2c9ca7ac03833$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $b9f2c9ca7ac03833$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleOwnRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    const handleRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(ref, handleOwnRef);
    const ownerState = (0, $9YD4s.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $946ef14610be8634$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsxs)($946ef14610be8634$export$7ec0dcc5e3cdcd36, (0, $9YD4s.default)({
        as: ComponentProp,
        className: (0, $iB56s.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $gWMia.jsx)((0, $9d9863ec7e72511d$export$2e2bcd8739ae039), (0, $9YD4s.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $946ef14610be8634$export$2e2bcd8739ae039 = $946ef14610be8634$var$ButtonBase;



var $lJkvk = parcelRequire("lJkvk");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $7092b6bbe40120f1$export$5e8702d71474f093(slot) {
    return (0, $1HGD7.default)("MuiIconButton", slot);
}
const $7092b6bbe40120f1$var$iconButtonClasses = (0, $3TIMy.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $7092b6bbe40120f1$export$2e2bcd8739ae039 = $7092b6bbe40120f1$var$iconButtonClasses;



var $gWMia = parcelRequire("gWMia");
const $5dc18c1bf26fdbc8$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $5dc18c1bf26fdbc8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disabled: disabled , color: color , edge: edge , size: size  } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $lJkvk.default)(color)}`,
            edge && `edge${(0, $lJkvk.default)(edge)}`,
            `size${(0, $lJkvk.default)(size)}`
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $7092b6bbe40120f1$export$5e8702d71474f093), classes);
};
const $5dc18c1bf26fdbc8$var$IconButtonRoot = (0, $bgnZl.default)((0, $946ef14610be8634$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $lJkvk.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $lJkvk.default)(ownerState.edge)}`],
            styles[`size${(0, $lJkvk.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kFXNp.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $9YD4s.default)({
        color: (theme.vars || theme).palette[ownerState.color].main
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kFXNp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $7092b6bbe40120f1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $5dc18c1bf26fdbc8$var$IconButton = /*#__PURE__*/ $4lkrv.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false , children: children , className: className , color: color = "default" , disabled: disabled = false , disableFocusRipple: disableFocusRipple = false , size: size = "medium"  } = props, other = (0, $eLWn9.default)(props, $5dc18c1bf26fdbc8$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $5dc18c1bf26fdbc8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)($5dc18c1bf26fdbc8$var$IconButtonRoot, (0, $9YD4s.default)({
        className: (0, $iB56s.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $5dc18c1bf26fdbc8$export$2e2bcd8739ae039 = $5dc18c1bf26fdbc8$var$IconButton;


var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");


var $kdLbD = parcelRequire("kdLbD");

var $kFXNp = parcelRequire("kFXNp");

var $lJkvk = parcelRequire("lJkvk");

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");


var $kdLbD = parcelRequire("kdLbD");

var $lJkvk = parcelRequire("lJkvk");

var $bgnZl = parcelRequire("bgnZl");
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $4lkrv = parcelRequire("4lkrv");
function $d2607550e884c697$export$2e2bcd8739ae039({ controlled: controlled , default: defaultProp , name: name , state: state = "value"  }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled  } = $4lkrv.useRef(controlled !== undefined);
    const [valueState, setValue] = $4lkrv.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $4lkrv.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $fa80bb9ce38c215b$export$2e2bcd8739ae039 = (0, $d2607550e884c697$export$2e2bcd8739ae039);



var $4lkrv = parcelRequire("4lkrv");

var $4lkrv = parcelRequire("4lkrv");
/**
 * @ignore - internal component.
 */ const $bd78b4b4339c8870$var$FormControlContext = /*#__PURE__*/ $4lkrv.createContext();
var $bd78b4b4339c8870$export$2e2bcd8739ae039 = $bd78b4b4339c8870$var$FormControlContext;


function $0c428d32e0c6707f$export$2e2bcd8739ae039() {
    return $4lkrv.useContext((0, $bd78b4b4339c8870$export$2e2bcd8739ae039));
}




var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $859fa7aca3c009c8$export$baa0faa0c7ad8085(slot) {
    return (0, $1HGD7.default)("PrivateSwitchBase", slot);
}
const $859fa7aca3c009c8$var$switchBaseClasses = (0, $3TIMy.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $859fa7aca3c009c8$export$2e2bcd8739ae039 = $859fa7aca3c009c8$var$switchBaseClasses;



var $gWMia = parcelRequire("gWMia");
const $225db297418caa05$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $225db297418caa05$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , checked: checked , disabled: disabled , edge: edge  } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $lJkvk.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $859fa7aca3c009c8$export$baa0faa0c7ad8085), classes);
};
const $225db297418caa05$var$SwitchBaseRoot = (0, $bgnZl.default)((0, $946ef14610be8634$export$2e2bcd8739ae039))(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $225db297418caa05$var$SwitchBaseInput = (0, $bgnZl.default)("input")({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $225db297418caa05$var$SwitchBase = /*#__PURE__*/ $4lkrv.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus , checked: checkedProp , checkedIcon: checkedIcon , className: className , defaultChecked: defaultChecked , disabled: disabledProp , disableFocusRipple: disableFocusRipple = false , edge: edge = false , icon: icon , id: id , inputProps: inputProps , inputRef: inputRef , name: name , onBlur: onBlur , onChange: onChange , onFocus: onFocus , readOnly: readOnly , required: required , tabIndex: tabIndex , type: type , value: value  } = props, other = (0, $eLWn9.default)(props, $225db297418caa05$var$_excluded);
    const [checked, setCheckedState] = (0, $fa80bb9ce38c215b$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $0c428d32e0c6707f$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $9YD4s.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $225db297418caa05$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsxs)($225db297418caa05$var$SwitchBaseRoot, (0, $9YD4s.default)({
        component: "span",
        className: (0, $iB56s.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)($225db297418caa05$var$SwitchBaseInput, (0, $9YD4s.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor && id,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
}); // NB: If changed, please update Checkbox, Switch and Radio
var $225db297418caa05$export$2e2bcd8739ae039 = $225db297418caa05$var$SwitchBase;



var $at7OG = parcelRequire("at7OG");

var $bgnZl = parcelRequire("bgnZl");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $16a3d9d241f9053d$export$39f6debbec19b3ba(slot) {
    return (0, $1HGD7.default)("MuiSwitch", slot);
}
const $16a3d9d241f9053d$var$switchClasses = (0, $3TIMy.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $16a3d9d241f9053d$export$2e2bcd8739ae039 = $16a3d9d241f9053d$var$switchClasses;



var $gWMia = parcelRequire("gWMia");
const $7e72214818d9e0df$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $7e72214818d9e0df$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , edge: edge , size: size , color: color , checked: checked , disabled: disabled  } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $lJkvk.default)(edge)}`,
            `size${(0, $lJkvk.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $lJkvk.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $kdLbD.default)(slots, (0, $16a3d9d241f9053d$export$39f6debbec19b3ba), classes);
    return (0, $9YD4s.default)({}, classes, composedClasses);
};
const $7e72214818d9e0df$var$SwitchRoot = (0, $bgnZl.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $lJkvk.default)(ownerState.edge)}`],
            styles[`size${(0, $lJkvk.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        display: "inline-flex",
        width: 58,
        height: 38,
        overflow: "hidden",
        padding: 12,
        boxSizing: "border-box",
        position: "relative",
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: "middle",
        // For correct alignment with the text.
        "@media print": {
            colorAdjust: "exact"
        }
    }, ownerState.edge === "start" && {
        marginLeft: -8
    }, ownerState.edge === "end" && {
        marginRight: -8
    }, ownerState.size === "small" && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).switchBase}`]: {
            padding: 4,
            [`&.${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).checked}`]: {
                transform: "translateX(16px)"
            }
        }
    }));
const $7e72214818d9e0df$var$SwitchSwitchBase = (0, $bgnZl.default)((0, $225db297418caa05$export$2e2bcd8739ae039), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $lJkvk.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme  })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).checked} + .${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).disabled} + .${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kFXNp.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kFXNp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).disabled}`]: {
                color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, $kFXNp.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $kFXNp.darken)(theme.palette[ownerState.color].main, 0.55)}`
            }
        },
        [`&.${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).checked} + .${(0, $16a3d9d241f9053d$export$2e2bcd8739ae039).track}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main
        }
    }));
const $7e72214818d9e0df$var$SwitchTrack = (0, $bgnZl.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme  })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const $7e72214818d9e0df$var$SwitchThumb = (0, $bgnZl.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme  })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $7e72214818d9e0df$var$Switch = /*#__PURE__*/ $4lkrv.forwardRef(function Switch(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className , color: color = "primary" , edge: edge = false , size: size = "medium" , sx: sx  } = props, other = (0, $eLWn9.default)(props, $7e72214818d9e0df$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $7e72214818d9e0df$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $gWMia.jsx)($7e72214818d9e0df$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $gWMia.jsxs)($7e72214818d9e0df$var$SwitchRoot, {
        className: (0, $iB56s.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)($7e72214818d9e0df$var$SwitchSwitchBase, (0, $9YD4s.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $9YD4s.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $gWMia.jsx)($7e72214818d9e0df$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $7e72214818d9e0df$export$2e2bcd8739ae039 = $7e72214818d9e0df$var$Switch;


var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $4lkrv = parcelRequire("4lkrv");
let $5ab99b711f62def3$var$globalId = 0;
function $5ab99b711f62def3$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $4lkrv.useState(idOverride);
    const id = idOverride || defaultId;
    $4lkrv.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $5ab99b711f62def3$var$globalId += 1;
            setDefaultId(`mui-${$5ab99b711f62def3$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $5ab99b711f62def3$var$maybeReactUseId = $4lkrv.useId;
function $5ab99b711f62def3$export$2e2bcd8739ae039(idOverride) {
    if ($5ab99b711f62def3$var$maybeReactUseId !== undefined) {
        const reactId = $5ab99b711f62def3$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $5ab99b711f62def3$var$useGlobalId(idOverride);
}



var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $kdLbD = parcelRequire("kdLbD");

var $3ocmy = parcelRequire("3ocmy");

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $gp8jy = parcelRequire("gp8jy");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $bf7484b571a20c50$var$isHostComponent(element) {
    return typeof element === "string";
}
var $bf7484b571a20c50$export$2e2bcd8739ae039 = $bf7484b571a20c50$var$isHostComponent;


var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");


// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $bbb751b21b712194$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

function $52fb10e34f656fe7$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $2a8e298250dfc4b7$export$2e2bcd8739ae039(node) {
    const doc = (0, $52fb10e34f656fe7$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}



var $gWMia = parcelRequire("gWMia");
const $ec36f28889358489$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $ec36f28889358489$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
const $ec36f28889358489$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $ec36f28889358489$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
const $ec36f28889358489$var$TextareaAutosize = /*#__PURE__*/ $4lkrv.forwardRef(function TextareaAutosize(props, ref) {
    const { onChange: onChange , maxRows: maxRows , minRows: minRows = 1 , style: style , value: value  } = props, other = (0, $eLWn9.default)(props, $ec36f28889358489$var$_excluded);
    const { current: isControlled  } = $4lkrv.useRef(value != null);
    const inputRef = $4lkrv.useRef(null);
    const handleRef = (0, $28e34e368be50325$export$2e2bcd8739ae039)(ref, inputRef);
    const shadowRef = $4lkrv.useRef(null);
    const renders = $4lkrv.useRef(0);
    const [state, setState] = $4lkrv.useState({});
    const getUpdatedState = $4lkrv.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $2a8e298250dfc4b7$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input); // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {};
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle["box-sizing"];
        const padding = $ec36f28889358489$var$getStyleValue(computedStyle, "padding-bottom") + $ec36f28889358489$var$getStyleValue(computedStyle, "padding-top");
        const border = $ec36f28889358489$var$getStyleValue(computedStyle, "border-bottom-width") + $ec36f28889358489$var$getStyleValue(computedStyle, "border-top-width"); // The height of the inner content
        const innerHeight = inputShallow.scrollHeight; // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight; // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle , overflow: overflow  } = newState; // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $4lkrv.useCallback(()=>{
        const newState = getUpdatedState();
        if ($ec36f28889358489$var$isEmpty(newState)) return;
        setState((prevState)=>{
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    const syncHeightWithFlushSycn = ()=>{
        const newState = getUpdatedState();
        if ($ec36f28889358489$var$isEmpty(newState)) return;
         // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        (0, $b4d8cf9ba0f25243$exports.flushSync)(()=>{
            setState((prevState)=>{
                return updateState(prevState, newState);
            });
        });
    };
    $4lkrv.useEffect(()=>{
        const handleResize = (0, $bbb751b21b712194$export$2e2bcd8739ae039)(()=>{
            renders.current = 0; // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (inputRef.current) syncHeightWithFlushSycn();
        });
        const containerWindow = (0, $2a8e298250dfc4b7$export$2e2bcd8739ae039)(inputRef.current);
        containerWindow.addEventListener("resize", handleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(inputRef.current);
        }
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $436de094adc3733f$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $4lkrv.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $gWMia.jsxs)($4lkrv.Fragment, {
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)("textarea", (0, $9YD4s.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
                ,
                rows: minRows,
                style: (0, $9YD4s.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : null
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $gWMia.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $9YD4s.default)({}, $ec36f28889358489$var$styles.shadow, style, {
                    padding: 0
                })
            })
        ]
    });
});
var $ec36f28889358489$export$2e2bcd8739ae039 = $ec36f28889358489$var$TextareaAutosize;


var $kdLbD = parcelRequire("kdLbD");
function $a885e469819db777$export$2e2bcd8739ae039({ props: props , states: states , muiFormControl: muiFormControl  }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}





var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $lJkvk = parcelRequire("lJkvk");


var $c3a88e87df6459f2$export$2e2bcd8739ae039 = (0, $436de094adc3733f$export$2e2bcd8739ae039);



var $9YD4s = parcelRequire("9YD4s");
parcelRequire("4lkrv");

parcelRequire("4lkrv");


var $1NUoC = parcelRequire("1NUoC");

var $4pME4 = parcelRequire("4pME4");

var $gWMia = parcelRequire("gWMia");
function $c732b13bfe9176a0$var$GlobalStyles({ styles: styles , themeId: themeId , defaultTheme: defaultTheme = {}  }) {
    const upperTheme = (0, $4pME4.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $1NUoC.default), {
        styles: globalStyles
    });
}
var $c732b13bfe9176a0$export$2e2bcd8739ae039 = $c732b13bfe9176a0$var$GlobalStyles;



var $ksq4v = parcelRequire("ksq4v");

var $gWMia = parcelRequire("gWMia");
function $a7b2bbb01cfa3e26$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $c732b13bfe9176a0$export$2e2bcd8739ae039), (0, $9YD4s.default)({}, props, {
        defaultTheme: (0, $ksq4v.default)
    }));
}
var $a7b2bbb01cfa3e26$export$2e2bcd8739ae039 = $a7b2bbb01cfa3e26$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $557749fb1e6f585d$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $557749fb1e6f585d$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($557749fb1e6f585d$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $557749fb1e6f585d$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
} // Determine if an Input is adorned on start.
function $557749fb1e6f585d$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $9cad494705596716$export$ef57d5c8ca2278f6(slot) {
    return (0, $1HGD7.default)("MuiInputBase", slot);
}
const $9cad494705596716$var$inputBaseClasses = (0, $3TIMy.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $9cad494705596716$export$2e2bcd8739ae039 = $9cad494705596716$var$inputBaseClasses;



var $gWMia = parcelRequire("gWMia");
const $50538766c2d9fee0$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "startAdornment",
    "type",
    "value"
];
const $50538766c2d9fee0$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $lJkvk.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $50538766c2d9fee0$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $50538766c2d9fee0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , color: color , disabled: disabled , error: error , endAdornment: endAdornment , focused: focused , formControl: formControl , fullWidth: fullWidth , hiddenLabel: hiddenLabel , multiline: multiline , readOnly: readOnly , size: size , startAdornment: startAdornment , type: type  } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lJkvk.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size === "small" && "sizeSmall",
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $9cad494705596716$export$ef57d5c8ca2278f6), classes);
};
const $50538766c2d9fee0$export$298a043133d72a38 = (0, $bgnZl.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $50538766c2d9fee0$export$965edad20a84fa75
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $9cad494705596716$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $9YD4s.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $50538766c2d9fee0$export$a1ad29c901026019 = (0, $bgnZl.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $50538766c2d9fee0$export$cf507b112810e72d
})(({ theme: theme , ownerState: ownerState  })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $9YD4s.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $9YD4s.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $9cad494705596716$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $9cad494705596716$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $50538766c2d9fee0$var$inputGlobalStyles = /*#__PURE__*/ (0, $gWMia.jsx)((0, $a7b2bbb01cfa3e26$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $50538766c2d9fee0$var$InputBase = /*#__PURE__*/ $4lkrv.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby , autoComplete: autoComplete , autoFocus: autoFocus , className: className , components: components = {} , componentsProps: componentsProps = {} , defaultValue: defaultValue , disabled: disabled , disableInjectingGlobalStyles: disableInjectingGlobalStyles , endAdornment: endAdornment , fullWidth: fullWidth = false , id: id , inputComponent: inputComponent = "input" , inputProps: inputPropsProp = {} , inputRef: inputRefProp , maxRows: maxRows , minRows: minRows , multiline: multiline = false , name: name , onBlur: onBlur , onChange: onChange , onClick: onClick , onFocus: onFocus , onKeyDown: onKeyDown , onKeyUp: onKeyUp , placeholder: placeholder , readOnly: readOnly , renderSuffix: renderSuffix , rows: rows , startAdornment: startAdornment , type: type = "text" , value: valueProp  } = props, other = (0, $eLWn9.default)(props, $50538766c2d9fee0$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled  } = $4lkrv.useRef(value != null);
    const inputRef = $4lkrv.useRef();
    const handleInputRefWarning = $4lkrv.useCallback((instance)=>{}, []);
    const handleInputPropsRefProp = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(inputPropsProp.ref, handleInputRefWarning);
    const handleInputRefProp = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(inputRefProp, handleInputPropsRefProp);
    const handleInputRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(inputRef, handleInputRefProp);
    const [focused, setFocused] = $4lkrv.useState(false);
    const muiFormControl = (0, $0c428d32e0c6707f$export$2e2bcd8739ae039)();
    const fcs = (0, $a885e469819db777$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $4lkrv.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $4lkrv.useCallback((obj)=>{
        if ((0, $557749fb1e6f585d$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $c3a88e87df6459f2$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $gp8jy.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
         // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $4lkrv.useEffect(()=>{
        checkDirty(inputRef.current); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $9YD4s.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $9YD4s.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $ec36f28889358489$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $4lkrv.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $9YD4s.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $50538766c2d9fee0$var$useUtilityClasses(ownerState);
    const Root = components.Root || $50538766c2d9fee0$export$298a043133d72a38;
    const rootProps = componentsProps.root || {};
    const Input = components.Input || $50538766c2d9fee0$export$a1ad29c901026019;
    inputProps = (0, $9YD4s.default)({}, inputProps, componentsProps.input);
    return /*#__PURE__*/ (0, $gWMia.jsxs)($4lkrv.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $50538766c2d9fee0$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $gWMia.jsxs)(Root, (0, $9YD4s.default)({}, rootProps, !(0, $bf7484b571a20c50$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $9YD4s.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $iB56s.default)(classes.root, rootProps.className, className),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $bd78b4b4339c8870$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $gWMia.jsx)(Input, (0, $9YD4s.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $bf7484b571a20c50$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $9YD4s.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $iB56s.default)(classes.input, inputProps.className),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $9YD4s.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $50538766c2d9fee0$export$2e2bcd8739ae039 = $50538766c2d9fee0$var$InputBase;



var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $9YD4s = parcelRequire("9YD4s");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");

function $40db1c389b290769$export$cdb270390122322b(slot) {
    return (0, $1HGD7.default)("MuiInput", slot);
}
const $40db1c389b290769$var$inputClasses = (0, $9YD4s.default)({}, (0, $9cad494705596716$export$2e2bcd8739ae039), (0, $3TIMy.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $40db1c389b290769$export$2e2bcd8739ae039 = $40db1c389b290769$var$inputClasses;




var $gWMia = parcelRequire("gWMia");
const $9ff55d59ff528ce1$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "type"
];
const $9ff55d59ff528ce1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableUnderline: disableUnderline  } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $kdLbD.default)(slots, (0, $40db1c389b290769$export$cdb270390122322b), classes);
    return (0, $9YD4s.default)({}, classes, composedClasses);
};
const $9ff55d59ff528ce1$var$InputRoot = (0, $bgnZl.default)((0, $50538766c2d9fee0$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $bgnZl.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            ...(0, $50538766c2d9fee0$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $9YD4s.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $40db1c389b290769$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $40db1c389b290769$export$2e2bcd8739ae039).error}:after`]: {
            borderBottomColor: (theme.vars || theme).palette.error.main,
            transform: "scaleX(1)" // error is always underlined in red
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $40db1c389b290769$export$2e2bcd8739ae039).disabled}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $40db1c389b290769$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $9ff55d59ff528ce1$var$InputInput = (0, $bgnZl.default)((0, $50538766c2d9fee0$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $50538766c2d9fee0$export$cf507b112810e72d)
})({});
const $9ff55d59ff528ce1$var$Input = /*#__PURE__*/ $4lkrv.forwardRef(function Input(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline , components: components = {} , componentsProps: componentsPropsProp , fullWidth: fullWidth = false , inputComponent: inputComponent = "input" , multiline: multiline = false , type: type = "text"  } = props, other = (0, $eLWn9.default)(props, $9ff55d59ff528ce1$var$_excluded);
    const classes = $9ff55d59ff528ce1$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = componentsPropsProp ? (0, $3ocmy.default)(componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $50538766c2d9fee0$export$2e2bcd8739ae039), (0, $9YD4s.default)({
        components: (0, $9YD4s.default)({
            Root: $9ff55d59ff528ce1$var$InputRoot,
            Input: $9ff55d59ff528ce1$var$InputInput
        }, components),
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$9ff55d59ff528ce1$var$Input.muiName = "Input";
var $9ff55d59ff528ce1$export$2e2bcd8739ae039 = $9ff55d59ff528ce1$var$Input;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");

var $3ocmy = parcelRequire("3ocmy");


var $kdLbD = parcelRequire("kdLbD");


var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $9YD4s = parcelRequire("9YD4s");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");

function $96ab21f0384305b0$export$3331e419f1a48437(slot) {
    return (0, $1HGD7.default)("MuiFilledInput", slot);
}
const $96ab21f0384305b0$var$filledInputClasses = (0, $9YD4s.default)({}, (0, $9cad494705596716$export$2e2bcd8739ae039), (0, $3TIMy.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $96ab21f0384305b0$export$2e2bcd8739ae039 = $96ab21f0384305b0$var$filledInputClasses;




var $gWMia = parcelRequire("gWMia");
const $b156e13f7362c39a$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "type"
];
const $b156e13f7362c39a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableUnderline: disableUnderline  } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $kdLbD.default)(slots, (0, $96ab21f0384305b0$export$3331e419f1a48437), classes);
    return (0, $9YD4s.default)({}, classes, composedClasses);
};
const $b156e13f7362c39a$var$FilledInputRoot = (0, $bgnZl.default)((0, $50538766c2d9fee0$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $bgnZl.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            ...(0, $50538766c2d9fee0$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $9YD4s.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $96ab21f0384305b0$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $96ab21f0384305b0$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $96ab21f0384305b0$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $96ab21f0384305b0$export$2e2bcd8739ae039).error}:after`]: {
            borderBottomColor: (theme.vars || theme).palette.error.main,
            transform: "scaleX(1)" // error is always underlined in red
        },
        "&:before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $96ab21f0384305b0$export$2e2bcd8739ae039).disabled}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $96ab21f0384305b0$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $9YD4s.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $b156e13f7362c39a$var$FilledInputInput = (0, $bgnZl.default)((0, $50538766c2d9fee0$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $50538766c2d9fee0$export$cf507b112810e72d)
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $b156e13f7362c39a$var$FilledInput = /*#__PURE__*/ $4lkrv.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {} , componentsProps: componentsPropsProp , fullWidth: fullWidth = false , inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input" , multiline: multiline = false , type: type = "text"  } = props, other = (0, $eLWn9.default)(props, $b156e13f7362c39a$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $b156e13f7362c39a$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = componentsPropsProp ? (0, $3ocmy.default)(componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $50538766c2d9fee0$export$2e2bcd8739ae039), (0, $9YD4s.default)({
        components: (0, $9YD4s.default)({
            Root: $b156e13f7362c39a$var$FilledInputRoot,
            Input: $b156e13f7362c39a$var$FilledInputInput
        }, components),
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$b156e13f7362c39a$var$FilledInput.muiName = "Input";
var $b156e13f7362c39a$export$2e2bcd8739ae039 = $b156e13f7362c39a$var$FilledInput;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");



var $kdLbD = parcelRequire("kdLbD");

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");
parcelRequire("4lkrv");


var $bgnZl = parcelRequire("bgnZl");

var $gWMia = parcelRequire("gWMia");
var $d89711146f3f4c1e$var$_span;
const $d89711146f3f4c1e$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $d89711146f3f4c1e$var$NotchedOutlineRoot = (0, $bgnZl.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $d89711146f3f4c1e$var$NotchedOutlineLegend = (0, $bgnZl.default)("legend")(({ ownerState: ownerState , theme: theme  })=>(0, $9YD4s.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $9YD4s.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $d89711146f3f4c1e$export$2e2bcd8739ae039(props) {
    const { className: className , label: label , notched: notched  } = props, other = (0, $eLWn9.default)(props, $d89711146f3f4c1e$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $9YD4s.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $gWMia.jsx)($d89711146f3f4c1e$var$NotchedOutlineRoot, (0, $9YD4s.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $gWMia.jsx)($d89711146f3f4c1e$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $gWMia.jsx)("span", {
                children: label
            }) : $d89711146f3f4c1e$var$_span || ($d89711146f3f4c1e$var$_span = /*#__PURE__*/ (0, $gWMia.jsx)("span", {
                className: "notranslate",
                children: "​"
            }))
        })
    }));
}





var $bgnZl = parcelRequire("bgnZl");

var $9YD4s = parcelRequire("9YD4s");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");

function $f0f13a4c9c73e72d$export$89922944c7227687(slot) {
    return (0, $1HGD7.default)("MuiOutlinedInput", slot);
}
const $f0f13a4c9c73e72d$var$outlinedInputClasses = (0, $9YD4s.default)({}, (0, $9cad494705596716$export$2e2bcd8739ae039), (0, $3TIMy.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $f0f13a4c9c73e72d$export$2e2bcd8739ae039 = $f0f13a4c9c73e72d$var$outlinedInputClasses;




var $at7OG = parcelRequire("at7OG");

var $gWMia = parcelRequire("gWMia");
const $c4ee1ea31b1a6c1b$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "type"
];
const $c4ee1ea31b1a6c1b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $kdLbD.default)(slots, (0, $f0f13a4c9c73e72d$export$89922944c7227687), classes);
    return (0, $9YD4s.default)({}, classes, composedClasses);
};
const $c4ee1ea31b1a6c1b$var$OutlinedInputRoot = (0, $bgnZl.default)((0, $50538766c2d9fee0$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $bgnZl.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $50538766c2d9fee0$export$965edad20a84fa75)
})(({ theme: theme , ownerState: ownerState  })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $9YD4s.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $f0f13a4c9c73e72d$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $f0f13a4c9c73e72d$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $f0f13a4c9c73e72d$export$2e2bcd8739ae039).focused} .${(0, $f0f13a4c9c73e72d$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $f0f13a4c9c73e72d$export$2e2bcd8739ae039).error} .${(0, $f0f13a4c9c73e72d$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $f0f13a4c9c73e72d$export$2e2bcd8739ae039).disabled} .${(0, $f0f13a4c9c73e72d$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $9YD4s.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $c4ee1ea31b1a6c1b$var$NotchedOutlineRoot = (0, $bgnZl.default)((0, $d89711146f3f4c1e$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme  })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $c4ee1ea31b1a6c1b$var$OutlinedInputInput = (0, $bgnZl.default)((0, $50538766c2d9fee0$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $50538766c2d9fee0$export$cf507b112810e72d)
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $c4ee1ea31b1a6c1b$var$OutlinedInput = /*#__PURE__*/ $4lkrv.forwardRef(function OutlinedInput(inProps, ref) {
    var _React$Fragment;
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {} , fullWidth: fullWidth = false , inputComponent: inputComponent = "input" , label: label , multiline: multiline = false , notched: notched , type: type = "text"  } = props, other = (0, $eLWn9.default)(props, $c4ee1ea31b1a6c1b$var$_excluded);
    const classes = $c4ee1ea31b1a6c1b$var$useUtilityClasses(props);
    const muiFormControl = (0, $0c428d32e0c6707f$export$2e2bcd8739ae039)();
    const fcs = (0, $a885e469819db777$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "required"
        ]
    });
    const ownerState = (0, $9YD4s.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $50538766c2d9fee0$export$2e2bcd8739ae039), (0, $9YD4s.default)({
        components: (0, $9YD4s.default)({
            Root: $c4ee1ea31b1a6c1b$var$OutlinedInputRoot,
            Input: $c4ee1ea31b1a6c1b$var$OutlinedInputInput
        }, components),
        renderSuffix: (state)=>/*#__PURE__*/ (0, $gWMia.jsx)($c4ee1ea31b1a6c1b$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $gWMia.jsxs)($4lkrv.Fragment, {
                    children: [
                        label,
                        "\xa0",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $9YD4s.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$c4ee1ea31b1a6c1b$var$OutlinedInput.muiName = "Input";
var $c4ee1ea31b1a6c1b$export$2e2bcd8739ae039 = $c4ee1ea31b1a6c1b$var$OutlinedInput;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $kdLbD = parcelRequire("kdLbD");



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");



var $lJkvk = parcelRequire("lJkvk");

var $at7OG = parcelRequire("at7OG");

var $bgnZl = parcelRequire("bgnZl");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $ad33a5401610dc51$export$f7d501e40371cd17(slot) {
    return (0, $1HGD7.default)("MuiFormLabel", slot);
}
const $ad33a5401610dc51$var$formLabelClasses = (0, $3TIMy.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $ad33a5401610dc51$export$2e2bcd8739ae039 = $ad33a5401610dc51$var$formLabelClasses;



var $gWMia = parcelRequire("gWMia");
const $fff461ece6aa6fd5$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $fff461ece6aa6fd5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , color: color , focused: focused , disabled: disabled , error: error , filled: filled , required: required  } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lJkvk.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $ad33a5401610dc51$export$f7d501e40371cd17), classes);
};
const $fff461ece6aa6fd5$export$aa5bc7f8a4705b27 = (0, $bgnZl.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState  }, styles)=>{
        return (0, $9YD4s.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $ad33a5401610dc51$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $ad33a5401610dc51$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $ad33a5401610dc51$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $fff461ece6aa6fd5$var$AsteriskComponent = (0, $bgnZl.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme  })=>({
        [`&.${(0, $ad33a5401610dc51$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $fff461ece6aa6fd5$var$FormLabel = /*#__PURE__*/ $4lkrv.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children , className: className , component: component = "label"  } = props, other = (0, $eLWn9.default)(props, $fff461ece6aa6fd5$var$_excluded);
    const muiFormControl = (0, $0c428d32e0c6707f$export$2e2bcd8739ae039)();
    const fcs = (0, $a885e469819db777$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $9YD4s.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $fff461ece6aa6fd5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsxs)($fff461ece6aa6fd5$export$aa5bc7f8a4705b27, (0, $9YD4s.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $iB56s.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $gWMia.jsxs)($fff461ece6aa6fd5$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    " ",
                    "*"
                ]
            })
        ]
    }));
});
var $fff461ece6aa6fd5$export$2e2bcd8739ae039 = $fff461ece6aa6fd5$var$FormLabel;



var $at7OG = parcelRequire("at7OG");

var $bgnZl = parcelRequire("bgnZl");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $d7b9fa3b48d82fee$export$c1c4b4545ad2ea5f(slot) {
    return (0, $1HGD7.default)("MuiInputLabel", slot);
}
const $d7b9fa3b48d82fee$var$inputLabelClasses = (0, $3TIMy.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $d7b9fa3b48d82fee$export$2e2bcd8739ae039 = $d7b9fa3b48d82fee$var$inputLabelClasses;



var $gWMia = parcelRequire("gWMia");
const $c7c5c012b882f66d$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant"
];
const $c7c5c012b882f66d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , formControl: formControl , size: size , shrink: shrink , disableAnimation: disableAnimation , variant: variant , required: required  } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size === "small" && "sizeSmall",
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $kdLbD.default)(slots, (0, $d7b9fa3b48d82fee$export$c1c4b4545ad2ea5f), classes);
    return (0, $9YD4s.default)({}, classes, composedClasses);
};
const $c7c5c012b882f66d$var$InputLabelRoot = (0, $bgnZl.default)((0, $fff461ece6aa6fd5$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bgnZl.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            {
                [`& .${(0, $ad33a5401610dc51$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $9YD4s.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $9YD4s.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $9YD4s.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        maxWidth: "calc(133% - 24px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $c7c5c012b882f66d$var$InputLabel = /*#__PURE__*/ $4lkrv.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $at7OG.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false , shrink: shrinkProp  } = props, other = (0, $eLWn9.default)(props, $c7c5c012b882f66d$var$_excluded);
    const muiFormControl = (0, $0c428d32e0c6707f$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $a885e469819db777$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required"
        ]
    });
    const ownerState = (0, $9YD4s.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $c7c5c012b882f66d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)($c7c5c012b882f66d$var$InputLabelRoot, (0, $9YD4s.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes
    }));
});
var $c7c5c012b882f66d$export$2e2bcd8739ae039 = $c7c5c012b882f66d$var$InputLabel;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $at7OG = parcelRequire("at7OG");

var $bgnZl = parcelRequire("bgnZl");


var $lJkvk = parcelRequire("lJkvk");

var $4lkrv = parcelRequire("4lkrv");
function $21188b8f6692153b$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $4lkrv.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}


var $9da4006d06d30976$export$2e2bcd8739ae039 = (0, $21188b8f6692153b$export$2e2bcd8739ae039);




var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $4955532971ad8c35$export$149c8b8bab2289d1(slot) {
    return (0, $1HGD7.default)("MuiFormControl", slot);
}
const $4955532971ad8c35$var$formControlClasses = (0, $3TIMy.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $4955532971ad8c35$export$2e2bcd8739ae039 = $4955532971ad8c35$var$formControlClasses;



var $gWMia = parcelRequire("gWMia");
const $e8d14b4c1acbbd03$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $e8d14b4c1acbbd03$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , margin: margin , fullWidth: fullWidth  } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $lJkvk.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $4955532971ad8c35$export$149c8b8bab2289d1), classes);
};
const $e8d14b4c1acbbd03$var$FormControlRoot = (0, $bgnZl.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState  }, styles)=>{
        return (0, $9YD4s.default)({}, styles.root, styles[`margin${(0, $lJkvk.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it create visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $e8d14b4c1acbbd03$var$FormControl = /*#__PURE__*/ $4lkrv.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children , className: className , color: color = "primary" , component: component = "div" , disabled: disabled = false , error: error = false , focused: visuallyFocused , fullWidth: fullWidth = false , hiddenLabel: hiddenLabel = false , margin: margin = "none" , required: required = false , size: size = "medium" , variant: variant = "outlined"  } = props, other = (0, $eLWn9.default)(props, $e8d14b4c1acbbd03$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $e8d14b4c1acbbd03$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $4lkrv.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $4lkrv.Children.forEach(children, (child)=>{
            if (!(0, $9da4006d06d30976$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $9da4006d06d30976$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $557749fb1e6f585d$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $4lkrv.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $4lkrv.Children.forEach(children, (child)=>{
            if (!(0, $9da4006d06d30976$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $557749fb1e6f585d$export$d652b828d7fdeff8)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $4lkrv.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const onFilled = $4lkrv.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $4lkrv.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        size: size,
        onBlur: ()=>{
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: ()=>{
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $bd78b4b4339c8870$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $gWMia.jsx)($e8d14b4c1acbbd03$var$FormControlRoot, (0, $9YD4s.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $iB56s.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $e8d14b4c1acbbd03$export$2e2bcd8739ae039 = $e8d14b4c1acbbd03$var$FormControl;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");



var $bgnZl = parcelRequire("bgnZl");

var $lJkvk = parcelRequire("lJkvk");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $d1d1314bb5c04529$export$a394fa61b1d583a9(slot) {
    return (0, $1HGD7.default)("MuiFormHelperText", slot);
}
const $d1d1314bb5c04529$var$formHelperTextClasses = (0, $3TIMy.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $d1d1314bb5c04529$export$2e2bcd8739ae039 = $d1d1314bb5c04529$var$formHelperTextClasses;



var $at7OG = parcelRequire("at7OG");

var $gWMia = parcelRequire("gWMia");
var $f43d9c975a2b7e67$var$_span;
const $f43d9c975a2b7e67$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $f43d9c975a2b7e67$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , contained: contained , size: size , disabled: disabled , error: error , filled: filled , focused: focused , required: required  } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $lJkvk.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $d1d1314bb5c04529$export$a394fa61b1d583a9), classes);
};
const $f43d9c975a2b7e67$var$FormHelperTextRoot = (0, $bgnZl.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $lJkvk.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $d1d1314bb5c04529$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $d1d1314bb5c04529$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $f43d9c975a2b7e67$var$FormHelperText = /*#__PURE__*/ $4lkrv.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children , className: className , component: component = "p"  } = props, other = (0, $eLWn9.default)(props, $f43d9c975a2b7e67$var$_excluded);
    const muiFormControl = (0, $0c428d32e0c6707f$export$2e2bcd8739ae039)();
    const fcs = (0, $a885e469819db777$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $9YD4s.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $f43d9c975a2b7e67$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)($f43d9c975a2b7e67$var$FormHelperTextRoot, (0, $9YD4s.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $iB56s.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $f43d9c975a2b7e67$var$_span || ($f43d9c975a2b7e67$var$_span = /*#__PURE__*/ (0, $gWMia.jsx)("span", {
            className: "notranslate",
            children: "​"
        })) : children
    }));
});
var $f43d9c975a2b7e67$export$2e2bcd8739ae039 = $f43d9c975a2b7e67$var$FormHelperText;



var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $3ocmy = parcelRequire("3ocmy");

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $gp8jy = parcelRequire("gp8jy");

var $4lkrv = parcelRequire("4lkrv");
var $f4b8798a90dfd4ae$exports = {};
"use strict";

$f4b8798a90dfd4ae$exports = (parcelRequire("16Ekm"));




var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $f7b92ee647f8e6e0$export$2e2bcd8739ae039 = (0, $52fb10e34f656fe7$export$2e2bcd8739ae039);



var $lJkvk = parcelRequire("lJkvk");

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");



var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");


var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");




var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $4lkrv = parcelRequire("4lkrv");
/**
 * @ignore - internal component.
 */ const $6458657c0c336f3b$var$ListContext = /*#__PURE__*/ $4lkrv.createContext({});
var $6458657c0c336f3b$export$2e2bcd8739ae039 = $6458657c0c336f3b$var$ListContext;



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $eed0c10590382680$export$c6bd6795ed6e3203(slot) {
    return (0, $1HGD7.default)("MuiList", slot);
}
const $eed0c10590382680$var$listClasses = (0, $3TIMy.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $eed0c10590382680$export$2e2bcd8739ae039 = $eed0c10590382680$var$listClasses;



var $gWMia = parcelRequire("gWMia");
const $981795693fc84723$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $981795693fc84723$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disablePadding: disablePadding , dense: dense , subheader: subheader  } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $eed0c10590382680$export$c6bd6795ed6e3203), classes);
};
const $981795693fc84723$var$ListRoot = (0, $bgnZl.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $981795693fc84723$var$List = /*#__PURE__*/ $4lkrv.forwardRef(function List(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children , className: className , component: component = "ul" , dense: dense = false , disablePadding: disablePadding = false , subheader: subheader  } = props, other = (0, $eLWn9.default)(props, $981795693fc84723$var$_excluded);
    const context = $4lkrv.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $9YD4s.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $981795693fc84723$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $6458657c0c336f3b$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $gWMia.jsxs)($981795693fc84723$var$ListRoot, (0, $9YD4s.default)({
            as: component,
            className: (0, $iB56s.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $981795693fc84723$export$2e2bcd8739ae039 = $981795693fc84723$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $3228495a36c2621e$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $a4d6f54ac3a5a785$export$2e2bcd8739ae039 = (0, $3228495a36c2621e$export$2e2bcd8739ae039);





var $gWMia = parcelRequire("gWMia");
const $49221bc7487c3ae4$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $49221bc7487c3ae4$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $49221bc7487c3ae4$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $49221bc7487c3ae4$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $49221bc7487c3ae4$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$49221bc7487c3ae4$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menubutton/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $49221bc7487c3ae4$var$MenuList = /*#__PURE__*/ $4lkrv.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions , autoFocus: autoFocus = false , autoFocusItem: autoFocusItem = false , children: children , className: className , disabledItemsFocusable: disabledItemsFocusable = false , disableListWrap: disableListWrap = false , onKeyDown: onKeyDown , variant: variant = "selectedMenu"  } = props, other = (0, $eLWn9.default)(props, $49221bc7487c3ae4$var$_excluded);
    const listRef = $4lkrv.useRef(null);
    const textCriteriaRef = $4lkrv.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $c3a88e87df6459f2$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $4lkrv.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $a4d6f54ac3a5a785$export$2e2bcd8739ae039)((0, $f7b92ee647f8e6e0$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $f7b92ee647f8e6e0$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $49221bc7487c3ae4$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $49221bc7487c3ae4$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $49221bc7487c3ae4$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $49221bc7487c3ae4$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $49221bc7487c3ae4$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $49221bc7487c3ae4$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $49221bc7487c3ae4$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $49221bc7487c3ae4$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $49221bc7487c3ae4$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $49221bc7487c3ae4$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $49221bc7487c3ae4$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $4lkrv.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $4lkrv.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const items = $4lkrv.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $4lkrv.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $981795693fc84723$export$2e2bcd8739ae039), (0, $9YD4s.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $49221bc7487c3ae4$export$2e2bcd8739ae039 = $49221bc7487c3ae4$var$MenuList;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");


var $kdLbD = parcelRequire("kdLbD");

var $kFXNp = parcelRequire("kFXNp");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");


var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $81346337400b8ae6$export$29cdb466b9b6f20b(slot) {
    return (0, $1HGD7.default)("MuiPaper", slot);
}
const $81346337400b8ae6$var$paperClasses = (0, $3TIMy.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $81346337400b8ae6$export$2e2bcd8739ae039 = $81346337400b8ae6$var$paperClasses;



var $gWMia = parcelRequire("gWMia");
const $21e6fd1e4a152e6c$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $21e6fd1e4a152e6c$export$7852ee65d7f1c129 = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
const $21e6fd1e4a152e6c$var$useUtilityClasses = (ownerState)=>{
    const { square: square , elevation: elevation , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $81346337400b8ae6$export$29cdb466b9b6f20b), classes);
};
const $21e6fd1e4a152e6c$var$PaperRoot = (0, $bgnZl.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$vars$overlays;
    return (0, $9YD4s.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $9YD4s.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $kFXNp.alpha)("#fff", $21e6fd1e4a152e6c$export$7852ee65d7f1c129(ownerState.elevation))}, ${(0, $kFXNp.alpha)("#fff", $21e6fd1e4a152e6c$export$7852ee65d7f1c129(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $21e6fd1e4a152e6c$var$Paper = /*#__PURE__*/ $4lkrv.forwardRef(function Paper(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className , component: component = "div" , elevation: elevation = 1 , square: square = false , variant: variant = "elevation"  } = props, other = (0, $eLWn9.default)(props, $21e6fd1e4a152e6c$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $21e6fd1e4a152e6c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)($21e6fd1e4a152e6c$var$PaperRoot, (0, $9YD4s.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $iB56s.default)(classes.root, className),
        ref: ref
    }, other));
});
var $21e6fd1e4a152e6c$export$2e2bcd8739ae039 = $21e6fd1e4a152e6c$var$Paper;



var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");


var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $037c49fa2bc7bdf1$export$2e2bcd8739ae039 = (0, $bbb751b21b712194$export$2e2bcd8739ae039);




var $d77a77da69be36ff$export$2e2bcd8739ae039 = (0, $2a8e298250dfc4b7$export$2e2bcd8739ae039);




var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");



var $eLWn9 = parcelRequire("eLWn9");



var $4lkrv = parcelRequire("4lkrv");

var $0531f7b1580a4e77$export$2e2bcd8739ae039 = {
    disabled: false
};




var $24d2fb25495a0e7c$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $1f5178231486d241$export$bb38bb9a1161268 = "unmounted";
var $1f5178231486d241$export$84cbff306f539230 = "exited";
var $1f5178231486d241$export$df38205c966be359 = "entering";
var $1f5178231486d241$export$78e9e6e3e014d60a = "entered";
var $1f5178231486d241$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $1f5178231486d241$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $32997f18e5380783$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $1f5178231486d241$export$84cbff306f539230;
                _this.appearStatus = $1f5178231486d241$export$df38205c966be359;
            } else initialStatus = $1f5178231486d241$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $1f5178231486d241$export$bb38bb9a1161268;
        else initialStatus = $1f5178231486d241$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $1f5178231486d241$export$bb38bb9a1161268) return {
            status: $1f5178231486d241$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $1f5178231486d241$export$df38205c966be359 && status !== $1f5178231486d241$export$78e9e6e3e014d60a) nextStatus = $1f5178231486d241$export$df38205c966be359;
            } else if (status === $1f5178231486d241$export$df38205c966be359 || status === $1f5178231486d241$export$78e9e6e3e014d60a) nextStatus = $1f5178231486d241$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $1f5178231486d241$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4d8cf9ba0f25243$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $24d2fb25495a0e7c$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $1f5178231486d241$export$84cbff306f539230) this.setState({
            status: $1f5178231486d241$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($b4d8cf9ba0f25243$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $0531f7b1580a4e77$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $1f5178231486d241$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $1f5178231486d241$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $1f5178231486d241$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($b4d8cf9ba0f25243$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $0531f7b1580a4e77$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $1f5178231486d241$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $1f5178231486d241$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $1f5178231486d241$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4d8cf9ba0f25243$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $1f5178231486d241$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $eLWn9.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement((0, $e1a24da57486c215$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).Component);
$1f5178231486d241$var$Transition.contextType = (0, $e1a24da57486c215$export$2e2bcd8739ae039);
$1f5178231486d241$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $1f5178231486d241$var$noop() {}
$1f5178231486d241$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $1f5178231486d241$var$noop,
    onEntering: $1f5178231486d241$var$noop,
    onEntered: $1f5178231486d241$var$noop,
    onExit: $1f5178231486d241$var$noop,
    onExiting: $1f5178231486d241$var$noop,
    onExited: $1f5178231486d241$var$noop
};
$1f5178231486d241$var$Transition.UNMOUNTED = $1f5178231486d241$export$bb38bb9a1161268;
$1f5178231486d241$var$Transition.EXITED = $1f5178231486d241$export$84cbff306f539230;
$1f5178231486d241$var$Transition.ENTERING = $1f5178231486d241$export$df38205c966be359;
$1f5178231486d241$var$Transition.ENTERED = $1f5178231486d241$export$78e9e6e3e014d60a;
$1f5178231486d241$var$Transition.EXITING = $1f5178231486d241$export$4aacc83d4d59139f;
var $1f5178231486d241$export$2e2bcd8739ae039 = $1f5178231486d241$var$Transition;



const $a64b8dde1865c99e$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $a64b8dde1865c99e$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout , easing: easing , style: style = {}  } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $gWMia = parcelRequire("gWMia");
const $b23fa01d8d65d417$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $b23fa01d8d65d417$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $b23fa01d8d65d417$var$styles = {
    entering: {
        opacity: 1,
        transform: $b23fa01d8d65d417$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $b23fa01d8d65d417$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $b23fa01d8d65d417$var$Grow = /*#__PURE__*/ $4lkrv.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener , appear: appear = true , children: children , easing: easing , in: inProp , onEnter: onEnter , onEntered: onEntered , onEntering: onEntering , onExit: onExit , onExited: onExited , onExiting: onExiting , style: style , timeout: timeout = "auto" , TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1f5178231486d241$export$2e2bcd8739ae039)  } = props, other = (0, $eLWn9.default)(props, $b23fa01d8d65d417$var$_excluded);
    const timer = $4lkrv.useRef();
    const autoTimeout = $4lkrv.useRef();
    const theme = (0, $0fbff9e4f89c0f97$export$2e2bcd8739ae039)();
    const nodeRef = $4lkrv.useRef(null);
    const foreignRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(children.ref, ref);
    const handleRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(nodeRef, foreignRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $a64b8dde1865c99e$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration , delay: delay , easing: transitionTimingFunction  } = (0, $a64b8dde1865c99e$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $b23fa01d8d65d417$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration , delay: delay , easing: transitionTimingFunction  } = (0, $a64b8dde1865c99e$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $b23fa01d8d65d417$var$isWebKit154 ? duration : duration * 0.666,
                delay: $b23fa01d8d65d417$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $b23fa01d8d65d417$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $4lkrv.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $gWMia.jsx)(TransitionComponent, (0, $9YD4s.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $4lkrv.cloneElement(children, (0, $9YD4s.default)({
                style: (0, $9YD4s.default)({
                    opacity: 0,
                    transform: $b23fa01d8d65d417$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $b23fa01d8d65d417$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$b23fa01d8d65d417$var$Grow.muiSupportAuto = true;
var $b23fa01d8d65d417$export$2e2bcd8739ae039 = $b23fa01d8d65d417$var$Grow;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $978cb32acb89afe9$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



var $kdLbD = parcelRequire("kdLbD");

var $4lkrv = parcelRequire("4lkrv");




var $gWMia = parcelRequire("gWMia");
function $a860ed493a65e637$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ const $a860ed493a65e637$var$Portal = /*#__PURE__*/ $4lkrv.forwardRef(function Portal(props, ref) {
    const { children: children , container: container , disablePortal: disablePortal = false  } = props;
    const [mountNode, setMountNode] = $4lkrv.useState(null);
    const handleRef = (0, $28e34e368be50325$export$2e2bcd8739ae039)(/*#__PURE__*/ $4lkrv.isValidElement(children) ? children.ref : null, ref);
    (0, $436de094adc3733f$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($a860ed493a65e637$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $436de094adc3733f$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $a9049f392c885db3$export$2e2bcd8739ae039)(ref, mountNode);
            return ()=>{
                (0, $a9049f392c885db3$export$2e2bcd8739ae039)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $4lkrv.isValidElement(children)) return /*#__PURE__*/ $4lkrv.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return /*#__PURE__*/ (0, $gWMia.jsx)($4lkrv.Fragment, {
        children: mountNode ? /*#__PURE__*/ $b4d8cf9ba0f25243$exports.createPortal(children, mountNode) : mountNode
    });
});
var $a860ed493a65e637$export$2e2bcd8739ae039 = $a860ed493a65e637$var$Portal;



// Is a vertical scrollbar displayed?
function $a07866cb99aa5c5f$var$isOverflowing(container) {
    const doc = (0, $52fb10e34f656fe7$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $2a8e298250dfc4b7$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $a07866cb99aa5c5f$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $a07866cb99aa5c5f$var$getPaddingRight(element) {
    return parseInt((0, $2a8e298250dfc4b7$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $a07866cb99aa5c5f$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $a07866cb99aa5c5f$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude = [], show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$a07866cb99aa5c5f$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $a07866cb99aa5c5f$export$e1bd0c6150f13d96(element, show);
    });
}
function $a07866cb99aa5c5f$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $a07866cb99aa5c5f$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($a07866cb99aa5c5f$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $3228495a36c2621e$export$2e2bcd8739ae039)((0, $52fb10e34f656fe7$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$a07866cb99aa5c5f$var$getPaddingRight(container) + scrollbarSize}px`; // .mui-fixed is a global helper.
            const fixedElements = (0, $52fb10e34f656fe7$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$a07866cb99aa5c5f$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $52fb10e34f656fe7$export$2e2bcd8739ae039)(container).body;
        else {
            // Improve Gatsby support
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $2a8e298250dfc4b7$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        } // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value , el: el , property: property  })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $a07866cb99aa5c5f$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $a07866cb99aa5c5f$export$2e2bcd8739ae039 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal); // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $a07866cb99aa5c5f$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $a07866cb99aa5c5f$var$getHiddenSiblings(container);
        $a07866cb99aa5c5f$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $a07866cb99aa5c5f$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $a07866cb99aa5c5f$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $a07866cb99aa5c5f$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $a07866cb99aa5c5f$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $a07866cb99aa5c5f$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $a07866cb99aa5c5f$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $a07866cb99aa5c5f$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ 
var $4lkrv = parcelRequire("4lkrv");



var $gWMia = parcelRequire("gWMia");
const $18a9ad67a78a0811$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $18a9ad67a78a0811$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
     // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $18a9ad67a78a0811$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $18a9ad67a78a0811$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $18a9ad67a78a0811$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $18a9ad67a78a0811$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($18a9ad67a78a0811$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $18a9ad67a78a0811$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$18a9ad67a78a0811$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $18a9ad67a78a0811$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 */ function $18a9ad67a78a0811$var$TrapFocus(props) {
    const { children: children , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableRestoreFocus: disableRestoreFocus = false , getTabbable: getTabbable = $18a9ad67a78a0811$var$defaultGetTabbable , isEnabled: isEnabled = $18a9ad67a78a0811$var$defaultIsEnabled , open: open  } = props;
    const ignoreNextEnforceFocus = $4lkrv.useRef();
    const sentinelStart = $4lkrv.useRef(null);
    const sentinelEnd = $4lkrv.useRef(null);
    const nodeToRestore = $4lkrv.useRef(null);
    const reactFocusEventTarget = $4lkrv.useRef(null); // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $4lkrv.useRef(false);
    const rootRef = $4lkrv.useRef(null);
    const handleRef = (0, $28e34e368be50325$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $4lkrv.useRef(null);
    $4lkrv.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $4lkrv.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $52fb10e34f656fe7$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        }; // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open TrapFocus
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $4lkrv.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $52fb10e34f656fe7$export$2e2bcd8739ae039)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement  } = rootRef; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
             // Make sure the next tab starts from the right place.
            // doc.activeElement referes to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $gWMia.jsxs)($4lkrv.Fragment, {
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $4lkrv.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $18a9ad67a78a0811$export$2e2bcd8739ae039 = $18a9ad67a78a0811$var$TrapFocus;



var $3TIMy = parcelRequire("3TIMy");

var $1HGD7 = parcelRequire("1HGD7");
function $e73b6beda382fa5d$export$67960e22b12a638d(slot) {
    return (0, $1HGD7.default)("MuiModal", slot);
}
const $e73b6beda382fa5d$var$modalUnstyledClasses = (0, $3TIMy.default)("MuiModal", [
    "root",
    "hidden"
]);
var $e73b6beda382fa5d$export$2e2bcd8739ae039 = $e73b6beda382fa5d$var$modalUnstyledClasses;



var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");


var $9YD4s = parcelRequire("9YD4s");

function $11bbf8433f7ee15f$export$2e2bcd8739ae039(elementType, otherProps = {}, ownerState) {
    if ((0, $bf7484b571a20c50$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $9YD4s.default)({}, otherProps, {
        ownerState: (0, $9YD4s.default)({}, otherProps.ownerState, ownerState)
    });
}



var $9YD4s = parcelRequire("9YD4s");

var $iB56s = parcelRequire("iB56s");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $deb810e47a7375b4$export$2e2bcd8739ae039(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $54dac6701e6168de$export$2e2bcd8739ae039(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $bfe43c1e1008389b$export$2e2bcd8739ae039(parameters) {
    const { getSlotProps: getSlotProps , additionalProps: additionalProps , externalSlotProps: externalSlotProps , externalForwardedProps: externalForwardedProps , className: className  } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $iB56s.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $9YD4s.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $9YD4s.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    } // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $deb810e47a7375b4$export$2e2bcd8739ae039)((0, $9YD4s.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $54dac6701e6168de$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $54dac6701e6168de$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers); // The order of classes is important here.
    // Emotion (that we use in libraries consuming MUI Base) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $iB56s.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $9YD4s.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $9YD4s.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $4901e5e129074964$export$2e2bcd8739ae039(componentProps, ownerState) {
    if (typeof componentProps === "function") return componentProps(ownerState);
    return componentProps;
}


const $c8743838c402a3b4$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState"
];
function $c8743838c402a3b4$export$2e2bcd8739ae039(parameters) {
    var _parameters$additiona;
    const { elementType: elementType , externalSlotProps: externalSlotProps , ownerState: ownerState  } = parameters, rest = (0, $eLWn9.default)(parameters, $c8743838c402a3b4$var$_excluded);
    const resolvedComponentsProps = (0, $4901e5e129074964$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps , internalRef: internalRef  } = (0, $bfe43c1e1008389b$export$2e2bcd8739ae039)((0, $9YD4s.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $28e34e368be50325$export$2e2bcd8739ae039)(internalRef, (0, $28e34e368be50325$export$2e2bcd8739ae039)(resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref));
    const props = (0, $11bbf8433f7ee15f$export$2e2bcd8739ae039)(elementType, (0, $9YD4s.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $gWMia = parcelRequire("gWMia");
const $cc0decf445912d6b$var$_excluded = [
    "children",
    "classes",
    "closeAfterTransition",
    "component",
    "components",
    "componentsProps",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "onTransitionEnter",
    "onTransitionExited"
];
const $cc0decf445912d6b$var$useUtilityClasses = (ownerState)=>{
    const { open: open , exited: exited , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $e73b6beda382fa5d$export$67960e22b12a638d), classes);
};
function $cc0decf445912d6b$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $cc0decf445912d6b$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $cc0decf445912d6b$var$defaultManager = new (0, $a07866cb99aa5c5f$export$2e2bcd8739ae039)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $cc0decf445912d6b$var$ModalUnstyled = /*#__PURE__*/ $4lkrv.forwardRef(function ModalUnstyled(props, ref) {
    var _props$ariaHidden;
    const { children: children , classes: classesProp , closeAfterTransition: closeAfterTransition = false , component: component = "div" , components: components = {} , componentsProps: componentsProps = {} , container: container , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableEscapeKeyDown: disableEscapeKeyDown = false , disablePortal: disablePortal = false , disableRestoreFocus: disableRestoreFocus = false , disableScrollLock: disableScrollLock = false , hideBackdrop: hideBackdrop = false , keepMounted: keepMounted = false , manager: // private
    // eslint-disable-next-line react/prop-types
    manager = $cc0decf445912d6b$var$defaultManager , onBackdropClick: onBackdropClick , onClose: onClose , onKeyDown: onKeyDown , open: open , onTransitionEnter: /* eslint-disable react/prop-types */ onTransitionEnter , onTransitionExited: onTransitionExited  } = props, other = (0, $eLWn9.default)(props, $cc0decf445912d6b$var$_excluded);
    const [exited, setExited] = $4lkrv.useState(true);
    const modal = $4lkrv.useRef({});
    const mountNodeRef = $4lkrv.useRef(null);
    const modalRef = $4lkrv.useRef(null);
    const handleRef = (0, $28e34e368be50325$export$2e2bcd8739ae039)(modalRef, ref);
    const hasTransition = $cc0decf445912d6b$var$getHasTransition(props);
    const ariaHiddenProp = (_props$ariaHidden = props["aria-hidden"]) != null ? _props$ariaHidden : true;
    const getDoc = ()=>(0, $52fb10e34f656fe7$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $9450e5fed5a2c751$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $cc0decf445912d6b$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $4lkrv.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $9450e5fed5a2c751$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else (0, $a07866cb99aa5c5f$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $4lkrv.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        manager,
        ariaHiddenProp
    ]);
    $4lkrv.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $4lkrv.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $9YD4s.default)({}, props, {
        classes: classesProp,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $cc0decf445912d6b$var$useUtilityClasses(ownerState);
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
         // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $978cb32acb89afe9$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $978cb32acb89afe9$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    const Root = components.Root || component;
    const rootProps = (0, $c8743838c402a3b4$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: componentsProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRef,
            role: "presentation",
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: ownerState
    });
    const BackdropComponent = components.Backdrop;
    const backdropProps = (0, $c8743838c402a3b4$export$2e2bcd8739ae039)({
        elementType: BackdropComponent,
        externalSlotProps: componentsProps.backdrop,
        additionalProps: {
            "aria-hidden": true,
            onClick: handleBackdropClick,
            open: open
        },
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $a860ed493a65e637$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $gWMia.jsxs)(Root, (0, $9YD4s.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $gWMia.jsx)(BackdropComponent, (0, $9YD4s.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $18a9ad67a78a0811$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $4lkrv.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $cc0decf445912d6b$export$2e2bcd8739ae039 = $cc0decf445912d6b$var$ModalUnstyled;





var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");







var $gWMia = parcelRequire("gWMia");
const $caa37e747bd4f08b$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $caa37e747bd4f08b$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $caa37e747bd4f08b$var$Fade = /*#__PURE__*/ $4lkrv.forwardRef(function Fade(props, ref) {
    const theme = (0, $0fbff9e4f89c0f97$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener , appear: appear = true , children: children , easing: easing , in: inProp , onEnter: onEnter , onEntered: onEntered , onEntering: onEntering , onExit: onExit , onExited: onExited , onExiting: onExiting , style: style , timeout: timeout = defaultTimeout , TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1f5178231486d241$export$2e2bcd8739ae039)  } = props, other = (0, $eLWn9.default)(props, $caa37e747bd4f08b$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $4lkrv.useRef(null);
    const foreignRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(children.ref, ref);
    const handleRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(nodeRef, foreignRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $a64b8dde1865c99e$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $a64b8dde1865c99e$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $a64b8dde1865c99e$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $gWMia.jsx)(TransitionComponent, (0, $9YD4s.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $4lkrv.cloneElement(children, (0, $9YD4s.default)({
                style: (0, $9YD4s.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $caa37e747bd4f08b$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $caa37e747bd4f08b$export$2e2bcd8739ae039 = $caa37e747bd4f08b$var$Fade;



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $558a242e08facef4$export$9927a91fd93152bd(slot) {
    return (0, $1HGD7.default)("MuiBackdrop", slot);
}
const $558a242e08facef4$var$backdropClasses = (0, $3TIMy.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $558a242e08facef4$export$2e2bcd8739ae039 = $558a242e08facef4$var$backdropClasses;



var $gWMia = parcelRequire("gWMia");
const $9c4b5c2a5380ab28$var$_excluded = [
    "children",
    "component",
    "components",
    "componentsProps",
    "className",
    "invisible",
    "open",
    "transitionDuration",
    "TransitionComponent"
];
const $9c4b5c2a5380ab28$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , invisible: invisible  } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $558a242e08facef4$export$9927a91fd93152bd), classes);
};
const $9c4b5c2a5380ab28$var$BackdropRoot = (0, $bgnZl.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $9c4b5c2a5380ab28$var$Backdrop = /*#__PURE__*/ $4lkrv.forwardRef(function Backdrop(inProps, ref) {
    var _components$Root, _componentsProps$root;
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children , component: component = "div" , components: components = {} , componentsProps: componentsProps = {} , className: className , invisible: invisible = false , open: open , transitionDuration: transitionDuration , TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $caa37e747bd4f08b$export$2e2bcd8739ae039)  } = props, other = (0, $eLWn9.default)(props, $9c4b5c2a5380ab28$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $9c4b5c2a5380ab28$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)(TransitionComponent, (0, $9YD4s.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $gWMia.jsx)($9c4b5c2a5380ab28$var$BackdropRoot, {
            "aria-hidden": true,
            as: (_components$Root = components.Root) != null ? _components$Root : component,
            className: (0, $iB56s.default)(classes.root, className),
            ownerState: (0, $9YD4s.default)({}, ownerState, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState),
            classes: classes,
            ref: ref,
            children: children
        })
    }));
});
var $9c4b5c2a5380ab28$export$2e2bcd8739ae039 = $9c4b5c2a5380ab28$var$Backdrop;



var $gWMia = parcelRequire("gWMia");
const $381898583d2692cc$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "closeAfterTransition",
    "children",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "theme"
];
const $381898583d2692cc$export$eb211a494147b724 = (0, $e73b6beda382fa5d$export$2e2bcd8739ae039);
const $381898583d2692cc$var$extendUtilityClasses = (ownerState)=>{
    return ownerState.classes;
};
const $381898583d2692cc$var$ModalRoot = (0, $bgnZl.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $381898583d2692cc$var$ModalBackdrop = (0, $bgnZl.default)((0, $9c4b5c2a5380ab28$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $381898583d2692cc$var$Modal = /*#__PURE__*/ $4lkrv.forwardRef(function Modal(inProps, ref) {
    var _ref, _components$Root;
    const props = (0, $at7OG.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $381898583d2692cc$var$ModalBackdrop , BackdropProps: BackdropProps , closeAfterTransition: closeAfterTransition = false , children: children , component: component , components: components = {} , componentsProps: componentsProps = {} , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableEscapeKeyDown: disableEscapeKeyDown = false , disablePortal: disablePortal = false , disableRestoreFocus: disableRestoreFocus = false , disableScrollLock: disableScrollLock = false , hideBackdrop: hideBackdrop = false , keepMounted: keepMounted = false , theme: // eslint-disable-next-line react/prop-types
    theme  } = props, other = (0, $eLWn9.default)(props, $381898583d2692cc$var$_excluded);
    const [exited, setExited] = $4lkrv.useState(true);
    const commonProps = {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const ownerState = (0, $9YD4s.default)({}, props, commonProps, {
        exited: exited
    });
    const classes = $381898583d2692cc$var$extendUtilityClasses(ownerState);
    const Root = (_ref = (_components$Root = components.Root) != null ? _components$Root : component) != null ? _ref : $381898583d2692cc$var$ModalRoot;
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $cc0decf445912d6b$export$2e2bcd8739ae039), (0, $9YD4s.default)({
        components: (0, $9YD4s.default)({
            Root: Root,
            Backdrop: BackdropComponent
        }, components),
        componentsProps: {
            root: ()=>(0, $9YD4s.default)({}, (0, $4901e5e129074964$export$2e2bcd8739ae039)(componentsProps.root, ownerState), !(0, $bf7484b571a20c50$export$2e2bcd8739ae039)(Root) && {
                    as: component,
                    theme: theme
                }),
            backdrop: ()=>(0, $9YD4s.default)({}, BackdropProps, (0, $4901e5e129074964$export$2e2bcd8739ae039)(componentsProps.backdrop, ownerState))
        },
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, {
        classes: classes
    }, commonProps, {
        children: children
    }));
});
var $381898583d2692cc$export$2e2bcd8739ae039 = $381898583d2692cc$var$Modal;




var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $0b3cdbf8fb651dce$export$88f455dd56c95edb(slot) {
    return (0, $1HGD7.default)("MuiPopover", slot);
}
const $0b3cdbf8fb651dce$var$popoverClasses = (0, $3TIMy.default)("MuiPopover", [
    "root",
    "paper"
]);
var $0b3cdbf8fb651dce$export$2e2bcd8739ae039 = $0b3cdbf8fb651dce$var$popoverClasses;



var $gWMia = parcelRequire("gWMia");
const $431eb50034fcb21f$var$_excluded = [
    "onEntering"
], $431eb50034fcb21f$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
function $431eb50034fcb21f$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $431eb50034fcb21f$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $431eb50034fcb21f$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $431eb50034fcb21f$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $431eb50034fcb21f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $0b3cdbf8fb651dce$export$88f455dd56c95edb), classes);
};
const $431eb50034fcb21f$var$PopoverRoot = (0, $bgnZl.default)((0, $381898583d2692cc$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $431eb50034fcb21f$var$PopoverPaper = (0, $bgnZl.default)((0, $21e6fd1e4a152e6c$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $431eb50034fcb21f$var$Popover = /*#__PURE__*/ $4lkrv.forwardRef(function Popover(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action , anchorEl: anchorEl , anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    } , anchorPosition: anchorPosition , anchorReference: anchorReference = "anchorEl" , children: children , className: className , container: containerProp , elevation: elevation = 8 , marginThreshold: marginThreshold = 16 , open: open , PaperProps: PaperProps = {} , transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    } , TransitionComponent: TransitionComponent = (0, $b23fa01d8d65d417$export$2e2bcd8739ae039) , transitionDuration: transitionDurationProp = "auto" , TransitionProps: { onEntering: onEntering  } = {}  } = props, TransitionProps = (0, $eLWn9.default)(props.TransitionProps, $431eb50034fcb21f$var$_excluded), other = (0, $eLWn9.default)(props, $431eb50034fcb21f$var$_excluded2);
    const paperRef = $4lkrv.useRef();
    const handlePaperRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(paperRef, PaperProps.ref);
    const ownerState = (0, $9YD4s.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        PaperProps: PaperProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $431eb50034fcb21f$var$useUtilityClasses(ownerState); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $4lkrv.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $431eb50034fcb21f$var$resolveAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $f7b92ee647f8e6e0$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $431eb50034fcb21f$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $431eb50034fcb21f$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the base transform origin using the element
    const getTransformOrigin = $4lkrv.useCallback((elemRect)=>{
        return {
            vertical: $431eb50034fcb21f$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $431eb50034fcb21f$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $4lkrv.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $431eb50034fcb21f$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset(); // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $d77a77da69be36ff$export$2e2bcd8739ae039)($431eb50034fcb21f$var$resolveAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        if (left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $431eb50034fcb21f$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const setPositioningStyles = $4lkrv.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    $4lkrv.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $4lkrv.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $4lkrv.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $037c49fa2bc7bdf1$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $d77a77da69be36ff$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $f7b92ee647f8e6e0$export$2e2bcd8739ae039)($431eb50034fcb21f$var$resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ (0, $gWMia.jsx)($431eb50034fcb21f$var$PopoverRoot, (0, $9YD4s.default)({
        BackdropProps: {
            invisible: true
        },
        className: (0, $iB56s.default)(classes.root, className),
        container: container,
        open: open,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $gWMia.jsx)(TransitionComponent, (0, $9YD4s.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $gWMia.jsx)($431eb50034fcb21f$var$PopoverPaper, (0, $9YD4s.default)({
                elevation: elevation
            }, PaperProps, {
                ref: handlePaperRef,
                className: (0, $iB56s.default)(classes.paper, PaperProps.className),
                children: children
            }))
        }))
    }));
});
var $431eb50034fcb21f$export$2e2bcd8739ae039 = $431eb50034fcb21f$var$Popover;



var $bgnZl = parcelRequire("bgnZl");


var $at7OG = parcelRequire("at7OG");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $5ff009d950a59ec2$export$2cf86a63a84fe23d(slot) {
    return (0, $1HGD7.default)("MuiMenu", slot);
}
const $5ff009d950a59ec2$var$menuClasses = (0, $3TIMy.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $5ff009d950a59ec2$export$2e2bcd8739ae039 = $5ff009d950a59ec2$var$menuClasses;



var $gWMia = parcelRequire("gWMia");
const $1fdc8a8729d32b3a$var$_excluded = [
    "onEntering"
], $1fdc8a8729d32b3a$var$_excluded2 = [
    "autoFocus",
    "children",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant"
];
const $1fdc8a8729d32b3a$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $1fdc8a8729d32b3a$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $1fdc8a8729d32b3a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $5ff009d950a59ec2$export$2cf86a63a84fe23d), classes);
};
const $1fdc8a8729d32b3a$var$MenuRoot = (0, $bgnZl.default)((0, $431eb50034fcb21f$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bgnZl.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $1fdc8a8729d32b3a$var$MenuPaper = (0, $bgnZl.default)((0, $21e6fd1e4a152e6c$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $1fdc8a8729d32b3a$var$MenuMenuList = (0, $bgnZl.default)((0, $49221bc7487c3ae4$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $1fdc8a8729d32b3a$var$Menu = /*#__PURE__*/ $4lkrv.forwardRef(function Menu(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true , children: children , disableAutoFocusItem: disableAutoFocusItem = false , MenuListProps: MenuListProps = {} , onClose: onClose , open: open , PaperProps: PaperProps = {} , PopoverClasses: PopoverClasses , transitionDuration: transitionDuration = "auto" , TransitionProps: { onEntering: onEntering  } = {} , variant: variant = "selectedMenu"  } = props, TransitionProps = (0, $eLWn9.default)(props.TransitionProps, $1fdc8a8729d32b3a$var$_excluded), other = (0, $eLWn9.default)(props, $1fdc8a8729d32b3a$var$_excluded2);
    const theme = (0, $0fbff9e4f89c0f97$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $9YD4s.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $1fdc8a8729d32b3a$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $4lkrv.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $4lkrv.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $4lkrv.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    return /*#__PURE__*/ (0, $gWMia.jsx)($1fdc8a8729d32b3a$var$MenuRoot, (0, $9YD4s.default)({
        classes: PopoverClasses,
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $1fdc8a8729d32b3a$var$RTL_ORIGIN : $1fdc8a8729d32b3a$var$LTR_ORIGIN,
        PaperProps: (0, $9YD4s.default)({
            component: $1fdc8a8729d32b3a$var$MenuPaper
        }, PaperProps, {
            classes: (0, $9YD4s.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        className: classes.root,
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $9YD4s.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $gWMia.jsx)($1fdc8a8729d32b3a$var$MenuMenuList, (0, $9YD4s.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $iB56s.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $1fdc8a8729d32b3a$export$2e2bcd8739ae039 = $1fdc8a8729d32b3a$var$Menu;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");


var $kdLbD = parcelRequire("kdLbD");

var $lJkvk = parcelRequire("lJkvk");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $e93e8d7e9644e5c3$export$1ee13051fd9e2ab5(slot) {
    return (0, $1HGD7.default)("MuiNativeSelect", slot);
}
const $e93e8d7e9644e5c3$var$nativeSelectClasses = (0, $3TIMy.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput"
]);
var $e93e8d7e9644e5c3$export$2e2bcd8739ae039 = $e93e8d7e9644e5c3$var$nativeSelectClasses;



var $bgnZl = parcelRequire("bgnZl");

var $gWMia = parcelRequire("gWMia");
const $93883e1018550146$var$_excluded = [
    "className",
    "disabled",
    "IconComponent",
    "inputRef",
    "variant"
];
const $93883e1018550146$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , disabled: disabled , multiple: multiple , open: open  } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple"
        ],
        icon: [
            "icon",
            `icon${(0, $lJkvk.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $e93e8d7e9644e5c3$export$1ee13051fd9e2ab5), classes);
};
const $93883e1018550146$export$c1eccd1617458c87 = ({ ownerState: ownerState , theme: theme  })=>(0, $9YD4s.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": {
            // Show that it's not an text input
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
            borderRadius: 0 // Reset Chrome style
        },
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $e93e8d7e9644e5c3$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: theme.palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: theme.shape.borderRadius,
        "&:focus": {
            borderRadius: theme.shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $93883e1018550146$var$NativeSelectSelect = (0, $bgnZl.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $bgnZl.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            {
                [`&.${(0, $e93e8d7e9644e5c3$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($93883e1018550146$export$c1eccd1617458c87);
const $93883e1018550146$export$e7a817afd12a40d0 = ({ ownerState: ownerState , theme: theme  })=>(0, $9YD4s.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: theme.palette.action.active,
        [`&.${(0, $e93e8d7e9644e5c3$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $93883e1018550146$var$NativeSelectIcon = (0, $bgnZl.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $lJkvk.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($93883e1018550146$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $93883e1018550146$var$NativeSelectInput = /*#__PURE__*/ $4lkrv.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className , disabled: disabled , IconComponent: IconComponent , inputRef: inputRef , variant: variant = "standard"  } = props, other = (0, $eLWn9.default)(props, $93883e1018550146$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        disabled: disabled,
        variant: variant
    });
    const classes = $93883e1018550146$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsxs)($4lkrv.Fragment, {
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)($93883e1018550146$var$NativeSelectSelect, (0, $9YD4s.default)({
                ownerState: ownerState,
                className: (0, $iB56s.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $gWMia.jsx)($93883e1018550146$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $93883e1018550146$export$2e2bcd8739ae039 = $93883e1018550146$var$NativeSelectInput;




var $bgnZl = parcelRequire("bgnZl");



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $e9eea7839d5e35af$export$2c0c1ee5a3392e(slot) {
    return (0, $1HGD7.default)("MuiSelect", slot);
}
const $e9eea7839d5e35af$var$selectClasses = (0, $3TIMy.default)("MuiSelect", [
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput"
]);
var $e9eea7839d5e35af$export$2e2bcd8739ae039 = $e9eea7839d5e35af$var$selectClasses;



var $gWMia = parcelRequire("gWMia");
var $d382107469738ffb$var$_span;
const $d382107469738ffb$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $d382107469738ffb$var$SelectSelect = (0, $bgnZl.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            {
                [`&.${(0, $e9eea7839d5e35af$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $e9eea7839d5e35af$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $e9eea7839d5e35af$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $93883e1018550146$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $e9eea7839d5e35af$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $d382107469738ffb$var$SelectIcon = (0, $bgnZl.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $lJkvk.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $93883e1018550146$export$e7a817afd12a40d0));
const $d382107469738ffb$var$SelectNativeInput = (0, $bgnZl.default)("input", {
    shouldForwardProp: (prop)=>(0, $bgnZl.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $d382107469738ffb$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
     // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $d382107469738ffb$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $d382107469738ffb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , disabled: disabled , multiple: multiple , open: open  } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple"
        ],
        icon: [
            "icon",
            `icon${(0, $lJkvk.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $e9eea7839d5e35af$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $d382107469738ffb$var$SelectInput = /*#__PURE__*/ $4lkrv.forwardRef(function SelectInput(props, ref) {
    const { "aria-describedby": ariaDescribedby , "aria-label": ariaLabel , autoFocus: autoFocus , autoWidth: autoWidth , children: children , className: className , defaultOpen: defaultOpen , defaultValue: defaultValue , disabled: disabled , displayEmpty: displayEmpty , IconComponent: IconComponent , inputRef: inputRefProp , labelId: labelId , MenuProps: MenuProps = {} , multiple: multiple , name: name , onBlur: onBlur , onChange: onChange , onClose: onClose , onFocus: onFocus , onOpen: onOpen , open: openProp , readOnly: readOnly , renderValue: renderValue , SelectDisplayProps: SelectDisplayProps = {} , tabIndex: tabIndexProp , value: valueProp , variant: variant = "standard"  } = props, other = (0, $eLWn9.default)(props, $d382107469738ffb$var$_excluded);
    const [value, setValueState] = (0, $fa80bb9ce38c215b$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $fa80bb9ce38c215b$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $4lkrv.useRef(null);
    const displayRef = $4lkrv.useRef(null);
    const [displayNode, setDisplayNode] = $4lkrv.useState(null);
    const { current: isOpenControlled  } = $4lkrv.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $4lkrv.useState();
    const handleRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $4lkrv.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    $4lkrv.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]); // Resize menu on `defaultOpen` automatic toggle.
    $4lkrv.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            displayRef.current.focus();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]); // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $4lkrv.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $4lkrv.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $f7b92ee647f8e6e0$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $4lkrv.Children.toArray(children); // Support autofill.
    const handleChange = (event)=>{
        const index = childrenArray.map((child)=>child.props.value).indexOf(event.target.value);
        if (index === -1) return;
        const child = childrenArray[index];
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue; // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // https://www.w3.org/WAI/ARIA/apg/example-index/combobox/combobox-select-only.html
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $557749fb1e6f585d$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child, index, arr)=>{
        if (!/*#__PURE__*/ $4lkrv.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $gp8jy.default)(2));
            selected = value.some((v)=>$d382107469738ffb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $d382107469738ffb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        if (child.props.value === undefined) return /*#__PURE__*/ $4lkrv.cloneElement(child, {
            "aria-readonly": true,
            role: "option"
        });
        const isFirstSelectableElement = ()=>{
            if (value) return selected;
            const firstSelectableElement = arr.find((item)=>item.props.value !== undefined && item.props.disabled !== true);
            if (child === firstSelectableElement) return true;
            return selected;
        };
        return /*#__PURE__*/ $4lkrv.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: arr[0].props.value === undefined || arr[0].props.disabled === true ? isFirstSelectableElement() : selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    } // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $9YD4s.default)({}, props, {
        variant: variant,
        value: value,
        open: open
    });
    const classes = $d382107469738ffb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsxs)($4lkrv.Fragment, {
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)($d382107469738ffb$var$SelectSelect, (0, $9YD4s.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $iB56s.default)(SelectDisplayProps.className, classes.select, className) // The id is required for proper a11y
                ,
                id: buttonId,
                children: $d382107469738ffb$var$isEmpty(display) ? $d382107469738ffb$var$_span || ($d382107469738ffb$var$_span = /*#__PURE__*/ (0, $gWMia.jsx)("span", {
                    className: "notranslate",
                    children: "​"
                })) : display
            })),
            /*#__PURE__*/ (0, $gWMia.jsx)($d382107469738ffb$var$SelectNativeInput, (0, $9YD4s.default)({
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $gWMia.jsx)($d382107469738ffb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $1fdc8a8729d32b3a$export$2e2bcd8739ae039), (0, $9YD4s.default)({
                id: `menu-${name || ""}`,
                anchorEl: displayNode,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $9YD4s.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                PaperProps: (0, $9YD4s.default)({}, MenuProps.PaperProps, {
                    style: (0, $9YD4s.default)({
                        minWidth: menuMinWidth
                    }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
                }),
                children: items
            }))
        ]
    });
});
var $d382107469738ffb$export$2e2bcd8739ae039 = $d382107469738ffb$var$SelectInput;




parcelRequire("4lkrv");

var $5YV4M = parcelRequire("5YV4M");

var $gWMia = parcelRequire("gWMia");
var $f90889c1b2658741$export$2e2bcd8739ae039 = (0, $5YV4M.default)(/*#__PURE__*/ (0, $gWMia.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");







var $at7OG = parcelRequire("at7OG");


var $bgnZl = parcelRequire("bgnZl");

var $gWMia = parcelRequire("gWMia");
var $6cd68c276cf6dda7$var$_StyledInput, $6cd68c276cf6dda7$var$_StyledFilledInput;
const $6cd68c276cf6dda7$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
];
const $6cd68c276cf6dda7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    return classes;
};
const $6cd68c276cf6dda7$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $bgnZl.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $6cd68c276cf6dda7$var$StyledInput = (0, $bgnZl.default)((0, $9ff55d59ff528ce1$export$2e2bcd8739ae039), $6cd68c276cf6dda7$var$styledRootConfig)("");
const $6cd68c276cf6dda7$var$StyledOutlinedInput = (0, $bgnZl.default)((0, $c4ee1ea31b1a6c1b$export$2e2bcd8739ae039), $6cd68c276cf6dda7$var$styledRootConfig)("");
const $6cd68c276cf6dda7$var$StyledFilledInput = (0, $bgnZl.default)((0, $b156e13f7362c39a$export$2e2bcd8739ae039), $6cd68c276cf6dda7$var$styledRootConfig)("");
const $6cd68c276cf6dda7$var$Select = /*#__PURE__*/ $4lkrv.forwardRef(function Select(inProps, ref) {
    const props = (0, $at7OG.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false , children: children , classes: classesProp = {} , className: className , defaultOpen: defaultOpen = false , displayEmpty: displayEmpty = false , IconComponent: IconComponent = (0, $f90889c1b2658741$export$2e2bcd8739ae039) , id: id , input: input , inputProps: inputProps , label: label , labelId: labelId , MenuProps: MenuProps , multiple: multiple = false , native: native = false , onClose: onClose , onOpen: onOpen , open: open , renderValue: renderValue , SelectDisplayProps: SelectDisplayProps , variant: variantProp = "outlined"  } = props, other = (0, $eLWn9.default)(props, $6cd68c276cf6dda7$var$_excluded);
    const inputComponent = native ? (0, $93883e1018550146$export$2e2bcd8739ae039) : (0, $d382107469738ffb$export$2e2bcd8739ae039);
    const muiFormControl = (0, $0c428d32e0c6707f$export$2e2bcd8739ae039)();
    const fcs = (0, $a885e469819db777$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    const variant = fcs.variant || variantProp;
    const InputComponent = input || ({
        standard: $6cd68c276cf6dda7$var$_StyledInput || ($6cd68c276cf6dda7$var$_StyledInput = /*#__PURE__*/ (0, $gWMia.jsx)($6cd68c276cf6dda7$var$StyledInput, {})),
        outlined: /*#__PURE__*/ (0, $gWMia.jsx)($6cd68c276cf6dda7$var$StyledOutlinedInput, {
            label: label
        }),
        filled: $6cd68c276cf6dda7$var$_StyledFilledInput || ($6cd68c276cf6dda7$var$_StyledFilledInput = /*#__PURE__*/ (0, $gWMia.jsx)($6cd68c276cf6dda7$var$StyledFilledInput, {}))
    })[variant];
    const ownerState = (0, $9YD4s.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $6cd68c276cf6dda7$var$useUtilityClasses(ownerState);
    const inputComponentRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $gWMia.jsx)($4lkrv.Fragment, {
        children: /*#__PURE__*/ $4lkrv.cloneElement(InputComponent, (0, $9YD4s.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $9YD4s.default)({
                children: children,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $9YD4s.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $3ocmy.default)(classes, inputProps.classes) : classes
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $iB56s.default)(InputComponent.props.className, className)
        }, !input && {
            variant: variant
        }, other))
    });
});
$6cd68c276cf6dda7$var$Select.muiName = "Select";
var $6cd68c276cf6dda7$export$2e2bcd8739ae039 = $6cd68c276cf6dda7$var$Select;



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $4a2a8c20107760fa$export$c1bdcbaf0596aeda(slot) {
    return (0, $1HGD7.default)("MuiTextField", slot);
}
const $4a2a8c20107760fa$var$textFieldClasses = (0, $3TIMy.default)("MuiTextField", [
    "root"
]);
var $4a2a8c20107760fa$export$2e2bcd8739ae039 = $4a2a8c20107760fa$var$textFieldClasses;



var $gWMia = parcelRequire("gWMia");
const $3e443e1578d52cec$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $3e443e1578d52cec$var$variantComponent = {
    standard: (0, $9ff55d59ff528ce1$export$2e2bcd8739ae039),
    filled: (0, $b156e13f7362c39a$export$2e2bcd8739ae039),
    outlined: (0, $c4ee1ea31b1a6c1b$export$2e2bcd8739ae039)
};
const $3e443e1578d52cec$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $4a2a8c20107760fa$export$c1bdcbaf0596aeda), classes);
};
const $3e443e1578d52cec$var$TextFieldRoot = (0, $bgnZl.default)((0, $e8d14b4c1acbbd03$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $3e443e1578d52cec$var$TextField = /*#__PURE__*/ $4lkrv.forwardRef(function TextField(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete , autoFocus: autoFocus = false , children: children , className: className , color: color = "primary" , defaultValue: defaultValue , disabled: disabled = false , error: error = false , FormHelperTextProps: FormHelperTextProps , fullWidth: fullWidth = false , helperText: helperText , id: idOverride , InputLabelProps: InputLabelProps , inputProps: inputProps , InputProps: InputProps , inputRef: inputRef , label: label , maxRows: maxRows , minRows: minRows , multiline: multiline = false , name: name , onBlur: onBlur , onChange: onChange , onFocus: onFocus , placeholder: placeholder , required: required = false , rows: rows , select: select = false , SelectProps: SelectProps , type: type , value: value , variant: variant = "outlined"  } = props, other = (0, $eLWn9.default)(props, $3e443e1578d52cec$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $3e443e1578d52cec$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $5ab99b711f62def3$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $3e443e1578d52cec$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $gWMia.jsx)(InputComponent, (0, $9YD4s.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $gWMia.jsxs)($3e443e1578d52cec$var$TextFieldRoot, (0, $9YD4s.default)({
        className: (0, $iB56s.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $gWMia.jsx)((0, $c7c5c012b882f66d$export$2e2bcd8739ae039), (0, $9YD4s.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $6cd68c276cf6dda7$export$2e2bcd8739ae039), (0, $9YD4s.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $gWMia.jsx)((0, $f43d9c975a2b7e67$export$2e2bcd8739ae039), (0, $9YD4s.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $3e443e1578d52cec$export$2e2bcd8739ae039 = $3e443e1578d52cec$var$TextField;



var $4lkrv = parcelRequire("4lkrv");

var $bgnZl = parcelRequire("bgnZl");
const $7972a9f32c26a5b9$export$cb96e55acaabf0fe = (n)=>n / 25.4;
const $7972a9f32c26a5b9$export$fb6d1d2584ba8eab = (n)=>n / 2.54;
const $7972a9f32c26a5b9$export$b8c76d4beb67b58d = (n)=>n * 2.54;
const $7972a9f32c26a5b9$export$c0287025d001c3bb = (n)=>n * 25.4;
const $7972a9f32c26a5b9$export$40de1ad0c5a10e67 = (n)=>n * 10;
const $7972a9f32c26a5b9$export$1c276ef0dfdbe3a6 = (n)=>n / 10;
const $7972a9f32c26a5b9$export$4059381979a3a85c = (units, n)=>{
    if (units === "mm") return n.toString();
    return n.toFixed(units === "cm" ? 0 : 1);
};
const $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9 = (fromUnits, toUnits, n)=>{
    if (fromUnits === "mm") {
        if (toUnits === "cm") return $7972a9f32c26a5b9$export$1c276ef0dfdbe3a6(n);
        else if (toUnits === "in") return $7972a9f32c26a5b9$export$cb96e55acaabf0fe(n);
        return n;
    }
    if (fromUnits === "cm") {
        if (toUnits === "mm") return $7972a9f32c26a5b9$export$40de1ad0c5a10e67(n);
        else if (toUnits === "in") return $7972a9f32c26a5b9$export$fb6d1d2584ba8eab(n);
        return n;
    }
    if (fromUnits === "in") {
        if (toUnits === "mm") return $7972a9f32c26a5b9$export$c0287025d001c3bb(n);
        else if (toUnits === "cm") return $7972a9f32c26a5b9$export$b8c76d4beb67b58d(n);
        return n;
    }
    return n;
};




var $gWMia = parcelRequire("gWMia");

var $4lkrv = parcelRequire("4lkrv");
const $ed9398deb9665ea6$export$d05858291b5222ca = {
    cm: "cm",
    in: "in",
    mm: "mm",
    m: "m"
};
const $ed9398deb9665ea6$export$edb0f1065fa3b1ed = (props)=>{
    const t = (k)=>(props.translations || $ed9398deb9665ea6$export$d05858291b5222ca)[k];
    const formatter = new Intl.NumberFormat();
    if (props.displayAs) {
        const width = formatter.format(props.width / 10);
        const height = formatter.format(props.height / 10);
        if (props.displayAs === "cm" && props.units === "mm") return `${width} x ${height}${t(props.displayAs || "cm")}`;
    }
    const width = formatter.format(props.width);
    const height = formatter.format(props.height);
    return `${width} x ${height}${t(props.units)}`;
};
const $ed9398deb9665ea6$export$850c5a1ec5f5e27d = /*#__PURE__*/ (0, $4lkrv.memo)((props)=>{
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $gWMia.Fragment), {
        children: $ed9398deb9665ea6$export$edb0f1065fa3b1ed(props)
    });
});




const $18550a1b1cf51454$var$reMatcher = /{{.*?\}}/g;
function $18550a1b1cf51454$var$trFactory(translations) {
    return (k, vs)=>{
        const txt = translations[k] || `"${k}" not provided`;
        const matches = [
            ...txt.matchAll($18550a1b1cf51454$var$reMatcher)
        ];
        return matches.reduce((s, cur)=>{
            const trimmedKey = cur[0].replace("{{", "").replace("}}", "");
            return s.replace(cur[0], vs && vs[trimmedKey] || "?");
        }, txt);
    };
}
const $18550a1b1cf51454$export$2a099a09599f0bc7 = (tr, opts)=>(k)=>{
        const { width: width , height: height , units: units  } = opts;
        const displayAs = units;
        return tr(k, {
            units: units === "cm" ? tr("cm") : tr("in"),
            width: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(units, width),
            height: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(units, height),
            minWidth: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(displayAs, (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(opts.minDimensions.unit, displayAs, opts.minDimensions.width)),
            maxWidth: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(displayAs, (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(opts.maxDimensions.unit, displayAs, opts.maxDimensions.width)),
            minHeight: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(displayAs, (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(opts.minDimensions.unit, displayAs, opts.minDimensions.height)),
            maxHeight: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(displayAs, (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(opts.maxDimensions.unit, displayAs, opts.maxDimensions.height)),
            dimensions: (0, $ed9398deb9665ea6$export$edb0f1065fa3b1ed)({
                width: width,
                height: height,
                units: units,
                translations: (0, $ed9398deb9665ea6$export$d05858291b5222ca)
            }),
            moq: opts.moq.toString()
        });
    };
var $18550a1b1cf51454$export$2e2bcd8739ae039 = $18550a1b1cf51454$var$trFactory;


const $6e15a2f1d483daf7$var$StyledTextField = (0, $bgnZl.default)((props)=>/*#__PURE__*/ (0, $gWMia.jsx)((0, $3e443e1578d52cec$export$2e2bcd8739ae039), {
        ...props
    }))(({ theme: theme  })=>({
        width: "110px",
        "& .MuiFormHelperText-root": {
            margin: 4,
            marginRight: 0,
            fontSize: 10,
            [theme.breakpoints.down("md")]: {
                fontSize: 9
            }
        },
        [theme.breakpoints.down("md")]: {
            width: "100px"
        }
    }));
const $6e15a2f1d483daf7$var$graphicAsset = (path)=>{
    return `https://graphic-assets.fra1.cdn.digitaloceanspaces.com/${path}`;
};
const $6e15a2f1d483daf7$export$d5b8c1948b345816 = (props)=>{
    const { units: units  } = props;
    const [displayAs, setDisplayAs] = (0, $4lkrv.useState)(props.displayAs || "cm");
    const [width, setWidth] = (0, $4lkrv.useState)(props.width.toString());
    const [height, setHeight] = (0, $4lkrv.useState)(props.height.toString());
    const widthNum = parseFloat(width);
    const heightNum = parseFloat(height);
    const [fixedAspectRatio, setFixedAspectRatio] = (0, $4lkrv.useState)(props.fixedAspectRatio);
    const [originalAspectRatio, setOriginalAspectRatio] = (0, $4lkrv.useState)(widthNum / heightNum);
    const widthTooSmall = widthNum < (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.minDimensions.unit, displayAs, props.minDimensions.width);
    const widthTooBig = widthNum > (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.maxDimensions.unit, displayAs, props.maxDimensions.width);
    const heightTooSmall = heightNum < (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.minDimensions.unit, displayAs, props.minDimensions.height);
    const heightTooBig = heightNum > (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.maxDimensions.unit, displayAs, props.maxDimensions.height);
    const isWidthMoreThan2Decimal = !width.match(/^\d*(\.\d{0,1})?$/);
    const isHeightMoreThan2Decimal = !height.match(/^\d*(\.\d{0,1})?$/);
    const errors = widthTooSmall || widthTooBig || heightTooSmall || heightTooBig || isWidthMoreThan2Decimal || isHeightMoreThan2Decimal;
    (0, $4lkrv.useEffect)(()=>{
        if (errors) return;
        props.onChangeConfirmed(widthNum, heightNum, displayAs);
    }, [
        errors,
        widthNum,
        heightNum,
        displayAs
    ]);
    (0, $4lkrv.useEffect)(()=>{
        if (props.onError) props.onError(Object.values(errors).some((v)=>v));
    }, [
        errors
    ]);
    const tr = (0, $18550a1b1cf51454$export$2e2bcd8739ae039)(props.translations);
    const t = (k)=>{
        const v = tr(k, {
            units: displayAs === "cm" ? tr("cm") : displayAs === "mm" ? tr("mm") : tr("in"),
            width: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(units, props.width),
            height: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(units, props.height),
            minWidth: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(displayAs, (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.minDimensions.unit, displayAs, props.minDimensions.width)),
            maxWidth: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(displayAs, (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.maxDimensions.unit, displayAs, props.maxDimensions.width)),
            minHeight: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(displayAs, (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.minDimensions.unit, displayAs, props.minDimensions.height)),
            maxHeight: (0, $7972a9f32c26a5b9$export$4059381979a3a85c)(displayAs, (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.maxDimensions.unit, displayAs, props.maxDimensions.height))
        });
        return v;
    };
    const unitsText = t(displayAs);
    const handleCmInch = (ev)=>{
        const newUnits = ev.target.checked ? "in" : "cm";
        setWidth((0, $7972a9f32c26a5b9$export$4059381979a3a85c)(newUnits, (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(units, newUnits, widthNum)));
        setHeight((0, $7972a9f32c26a5b9$export$4059381979a3a85c)(newUnits, (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(units, newUnits, heightNum)));
        setDisplayAs(newUnits);
    };
    const handleSetWidth = (ev)=>{
        if (fixedAspectRatio) setHeight((parseFloat(ev.target.value) / originalAspectRatio).toFixed(1));
        setWidth(ev.target.value);
    };
    const handleSetHeight = (ev)=>{
        if (fixedAspectRatio) setWidth((parseFloat(ev.target.value) * originalAspectRatio).toFixed(1));
        setHeight(ev.target.value);
    };
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
        container: true,
        alignItems: "center",
        sx: {
            position: "relative"
        },
        children: [
            props.fixedAspectRatio ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                item: true,
                xs: 2,
                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $5dc18c1bf26fdbc8$export$2e2bcd8739ae039), {
                    sx: {
                        marginTop: -2
                    },
                    onClick: ()=>{
                        setFixedAspectRatio((prev)=>!prev);
                        setOriginalAspectRatio(widthNum / heightNum);
                    },
                    children: /*#__PURE__*/ (0, $gWMia.jsx)("img", {
                        height: 24,
                        width: 24,
                        src: $6e15a2f1d483daf7$var$graphicAsset(fixedAspectRatio ? "locked.svg" : "unlocked.svg")
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                item: true,
                xs: 4.3,
                md: 4.5,
                marginRight: 2,
                children: /*#__PURE__*/ (0, $gWMia.jsx)($6e15a2f1d483daf7$var$StyledTextField, {
                    error: widthTooBig || widthTooSmall || isWidthMoreThan2Decimal,
                    label: `${t("widthLabel")} (${unitsText})`,
                    value: width,
                    onChange: handleSetWidth,
                    type: "number",
                    inputProps: {
                        step: 0.1,
                        min: (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.minDimensions.unit, displayAs, props.minDimensions.width).toFixed(1),
                        max: (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.maxDimensions.unit, displayAs, props.maxDimensions.width).toFixed(1)
                    },
                    helperText: isWidthMoreThan2Decimal ? t("maxdp") : widthTooSmall ? t("widthTooSmall") : widthTooBig ? t("widthTooBig") : t("widthHelperText"),
                    role: "width"
                })
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                item: true,
                xs: 4.3,
                md: 4.5,
                children: /*#__PURE__*/ (0, $gWMia.jsx)($6e15a2f1d483daf7$var$StyledTextField, {
                    error: heightTooBig || heightTooSmall || isHeightMoreThan2Decimal,
                    label: `${t("heightLabel")} (${unitsText})`,
                    value: height,
                    onChange: handleSetHeight,
                    type: "number",
                    inputProps: {
                        step: 0.1,
                        min: (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.minDimensions.unit, displayAs, props.minDimensions.width).toFixed(1),
                        max: (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.maxDimensions.unit, displayAs, props.maxDimensions.width).toFixed(1)
                    },
                    helperText: isHeightMoreThan2Decimal ? t("maxdp") : heightTooSmall ? t("heightTooSmall") : heightTooBig ? t("heightTooBig") : t("heightHelperText"),
                    role: "height"
                })
            }),
            props.showInches ? /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                sx: {
                    fontFamily: "Poppins",
                    fontSize: "10px",
                    display: "flex",
                    alignItems: "center",
                    position: "absolute",
                    top: "20px",
                    right: {
                        xs: 0,
                        md: "-5px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $gWMia.jsx)("div", {
                        children: "cm"
                    }),
                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $7e72214818d9e0df$export$2e2bcd8739ae039), {
                        size: "small",
                        checked: units === "in",
                        onChange: handleCmInch,
                        role: "change-units"
                    }),
                    /*#__PURE__*/ (0, $gWMia.jsx)("div", {
                        children: "in"
                    })
                ]
            }) : null
        ]
    });
};



const $cc0655974355b7ea$export$412743ab81793131 = {
    cm: "cm",
    in: "in",
    mm: "mm",
    m: "m",
    widthLabel: "Width",
    widthTooSmall: "Min. {{minWidth}}{{units}} width.",
    widthTooBig: "Max. {{maxWidth}}{{units}} width.",
    widthHelperText: "Min {{minWidth}}{{units}}, max {{maxWidth}}{{units}}",
    heightLabel: "Height",
    heightTooSmall: "Min. {{minHeight}}{{units}} height.",
    heightTooBig: "Max. {{maxHeight}}{{units}} height.",
    heightHelperText: "Min {{minHeight}}{{units}}, max {{maxHeight}}{{units}}"
};




var $gWMia = parcelRequire("gWMia");
parcelRequire("4lkrv");

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $8Ksxr = parcelRequire("8Ksxr");

var $kdLbD = parcelRequire("kdLbD");

var $kFXNp = parcelRequire("kFXNp");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");


var $lJkvk = parcelRequire("lJkvk");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $f16086270f1917fa$export$5a6f9035944c8119(slot) {
    return (0, $1HGD7.default)("MuiButton", slot);
}
const $f16086270f1917fa$var$buttonClasses = (0, $3TIMy.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $f16086270f1917fa$export$2e2bcd8739ae039 = $f16086270f1917fa$var$buttonClasses;



var $4lkrv = parcelRequire("4lkrv");
/**
 * @ignore - internal component.
 */ const $401cbba8f1488c88$var$ButtonGroupContext = /*#__PURE__*/ $4lkrv.createContext({});
var $401cbba8f1488c88$export$2e2bcd8739ae039 = $401cbba8f1488c88$var$ButtonGroupContext;



var $gWMia = parcelRequire("gWMia");
const $c57a8262ea075bfb$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
], $c57a8262ea075bfb$var$_excluded2 = [
    "root"
];
const $c57a8262ea075bfb$var$useUtilityClasses = (ownerState)=>{
    const { color: color , disableElevation: disableElevation , fullWidth: fullWidth , size: size , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $lJkvk.default)(color)}`,
            `size${(0, $lJkvk.default)(size)}`,
            `${variant}Size${(0, $lJkvk.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $lJkvk.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $lJkvk.default)(size)}`
        ]
    };
    const composedClasses = (0, $kdLbD.default)(slots, (0, $f16086270f1917fa$export$5a6f9035944c8119), classes);
    return (0, $9YD4s.default)({}, classes, composedClasses);
};
const $c57a8262ea075bfb$var$commonIconStyles = (ownerState)=>(0, $9YD4s.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $c57a8262ea075bfb$var$ButtonRoot = (0, $bgnZl.default)((0, $946ef14610be8634$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bgnZl.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $lJkvk.default)(ownerState.color)}`],
            styles[`size${(0, $lJkvk.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $lJkvk.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, $9YD4s.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $9YD4s.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kFXNp.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kFXNp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kFXNp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $9YD4s.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $f16086270f1917fa$export$2e2bcd8739ae039).focusVisible}`]: (0, $9YD4s.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $f16086270f1917fa$export$2e2bcd8739ae039).disabled}`]: (0, $9YD4s.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "outlined" && ownerState.color === "secondary" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabled}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $kFXNp.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState  })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $f16086270f1917fa$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $f16086270f1917fa$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $c57a8262ea075bfb$var$ButtonStartIcon = (0, $bgnZl.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $lJkvk.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $c57a8262ea075bfb$var$commonIconStyles(ownerState)));
const $c57a8262ea075bfb$var$ButtonEndIcon = (0, $bgnZl.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $lJkvk.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $c57a8262ea075bfb$var$commonIconStyles(ownerState)));
const $c57a8262ea075bfb$var$Button = /*#__PURE__*/ $4lkrv.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $4lkrv.useContext((0, $401cbba8f1488c88$export$2e2bcd8739ae039));
    const resolvedProps = (0, $8Ksxr.default)(contextProps, inProps);
    const props = (0, $at7OG.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children , color: color = "primary" , component: component = "button" , className: className , disabled: disabled = false , disableElevation: disableElevation = false , disableFocusRipple: disableFocusRipple = false , endIcon: endIconProp , focusVisibleClassName: focusVisibleClassName , fullWidth: fullWidth = false , size: size = "medium" , startIcon: startIconProp , type: type , variant: variant = "text"  } = props, other = (0, $eLWn9.default)(props, $c57a8262ea075bfb$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const _useUtilityClasses = $c57a8262ea075bfb$var$useUtilityClasses(ownerState), { root: classesRoot  } = _useUtilityClasses, classes = (0, $eLWn9.default)(_useUtilityClasses, $c57a8262ea075bfb$var$_excluded2);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $gWMia.jsx)($c57a8262ea075bfb$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $gWMia.jsx)($c57a8262ea075bfb$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $gWMia.jsxs)($c57a8262ea075bfb$var$ButtonRoot, (0, $9YD4s.default)({
        ownerState: ownerState,
        className: (0, $iB56s.default)(contextProps.className, classesRoot, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $iB56s.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $c57a8262ea075bfb$export$2e2bcd8739ae039 = $c57a8262ea075bfb$var$Button;



var $gWMia = parcelRequire("gWMia");

parcelRequire("4lkrv");
const $6aa7d7a2594069b4$var$currencies = {
    EUR: "€",
    GBP: "\xa3",
    USD: "$"
};
const $6aa7d7a2594069b4$export$49333b01794f7d28 = (props)=>{
    const sxProps = {
        ...props.sx,
        fontFamily: "Poppins"
    };
    if (props.price === undefined || props.price === null || !props.currencyCode || !props.locale) return /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
        component: "span",
        sx: sxProps,
        children: "-"
    });
    const fallback = /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
        component: "span",
        sx: sxProps,
        children: [
            $6aa7d7a2594069b4$var$currencies[props.currencyCode] || "",
            props.price.toFixed(2)
        ]
    });
    if (!props.zeroValueText && props.price === 0) try {
        const formatted = new Intl.NumberFormat(props.locale, {
            style: "currency",
            currency: props.currencyCode,
            maximumFractionDigits: 0
        }).format(props.price);
        return /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
            component: "span",
            sx: sxProps,
            children: formatted
        });
    } catch (_err) {
        return fallback;
    }
    else if (props.zeroValueText && props.price === 0) return /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
        component: "span",
        sx: sxProps,
        children: props.zeroValueText
    });
    try {
        const formatted = new Intl.NumberFormat(props.locale, {
            style: "currency",
            currency: props.currencyCode,
            maximumFractionDigits: props.maximumFractionDigits || props.price.toFixed(2).endsWith(".00") ? 0 : 2
        }).format(props.price);
        return /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
            component: "span",
            sx: sxProps,
            children: formatted
        });
    } catch (_err) {
        return fallback;
    }
};
var $6aa7d7a2594069b4$export$2e2bcd8739ae039 = $6aa7d7a2594069b4$export$49333b01794f7d28;





var $gWMia = parcelRequire("gWMia");
parcelRequire("4lkrv");

const $04165d3803d5a8b7$export$f5a845d4be3630ee = (props)=>{
    const showBorder = props.noBorder ? false : true;
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
        sx: {
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                style: {
                    backgroundColor: "#99f2e4"
                },
                children: showBorder ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                    style: {
                        height: 4,
                        border: "5px solid #fff",
                        borderRadius: 8,
                        backgroundColor: "#fff",
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                    }
                }) : null
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                ...props,
                sx: {
                    ...props.sx,
                    backgroundColor: (theme)=>theme.colors.greenLightest
                },
                children: props.children
            })
        ]
    });
};


var $15f157c1531c2362$export$560e3d5bfb204b57;
(function(SubmitType) {
    SubmitType[SubmitType["Continue"] = 0] = "Continue";
    SubmitType[SubmitType["Customize"] = 1] = "Customize";
    SubmitType[SubmitType["AddToCart"] = 2] = "AddToCart";
})($15f157c1531c2362$export$560e3d5bfb204b57 || ($15f157c1531c2362$export$560e3d5bfb204b57 = {}));
const $15f157c1531c2362$var$Footer = (props)=>{
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $04165d3803d5a8b7$export$f5a845d4be3630ee), {
        sx: {
            mt: {
                xs: 2,
                md: 1
            },
            paddingLeft: "18px",
            paddingRight: "18px",
            paddingBottom: 1,
            paddingTop: "20.67px",
            color: "#7f8481",
            fontSize: 12
        },
        children: [
            props.graphicMode ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $c57a8262ea075bfb$export$2e2bcd8739ae039), {
                fullWidth: true,
                variant: "outlined",
                color: "primary",
                sx: {
                    backgroundColor: "#fff",
                    marginBottom: 1.25
                },
                disabled: !props.price || props.quantity < props.moq || props.loading,
                onClick: ()=>props.handleSubmit($15f157c1531c2362$export$560e3d5bfb204b57.Customize),
                children: props.translations.customize
            }) : null,
            /*#__PURE__*/ (0, $gWMia.jsxs)((0, $c57a8262ea075bfb$export$2e2bcd8739ae039), {
                fullWidth: true,
                variant: "contained",
                color: "primary",
                disabled: !props.price || props.quantity < props.moq || props.loading,
                onClick: ()=>props.handleSubmit(props.graphicMode ? $15f157c1531c2362$export$560e3d5bfb204b57.AddToCart : $15f157c1531c2362$export$560e3d5bfb204b57.Continue),
                children: [
                    props.graphicMode ? props.translations.addToCart : props.translations.continue,
                    " ",
                    props.graphicMode ? " - " : null,
                    props.graphicMode ? /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                        component: "span",
                        sx: {
                            ml: 1
                        },
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $6aa7d7a2594069b4$export$49333b01794f7d28), {
                                locale: props.locale,
                                price: props.price?.price || null,
                                currencyCode: props.currencyCode || ""
                            })
                        ]
                    }) : null
                ]
            }),
            !props.graphicMode && props.translations.uploadText ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                variant: "caption",
                component: "p",
                sx: {
                    textAlign: "right",
                    marginTop: "20px",
                    color: "#676767",
                    fontSize: "10px",
                    lineHeight: "16px"
                },
                children: props.translations.uploadText
            }) : null
        ]
    });
};
var $15f157c1531c2362$export$2e2bcd8739ae039 = $15f157c1531c2362$var$Footer;



var $gWMia = parcelRequire("gWMia");


var $4lkrv = parcelRequire("4lkrv");

var $gWMia = parcelRequire("gWMia");
parcelRequire("4lkrv");



var $gWMia = parcelRequire("gWMia");
parcelRequire("4lkrv");

var $bgnZl = parcelRequire("bgnZl");

const $70562694343dbda3$var$QuantityTextField = (0, $bgnZl.default)((props)=>/*#__PURE__*/ (0, $gWMia.jsx)((0, $3e443e1578d52cec$export$2e2bcd8739ae039), {
        ...props
    }))(({ theme: theme  })=>({
        "& .MuiInputBase-root": {
            width: "90%"
        },
        "& .MuiFormHelperText-root": {
            margin: 4,
            marginRight: 0,
            fontSize: 10
        }
    }));
var $70562694343dbda3$export$2e2bcd8739ae039 = $70562694343dbda3$var$QuantityTextField;


const $d847775e045d4bd8$var$CustomQuantityField = (props)=>{
    const { price: price , locale: locale , moq: moq , quantity: quantity , handleCustomQuantity: handleCustomQuantity  } = props;
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
        container: true,
        alignItems: "center",
        sx: {
            marginTop: 2,
            pl: {
                xs: 0,
                md: "23px"
            }
        },
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                item: true,
                xs: 8,
                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $70562694343dbda3$export$2e2bcd8739ae039), {
                    error: props.quantityError,
                    label: props.translations.quantityLabel,
                    defaultValue: quantity,
                    type: "number",
                    onChange: (ev)=>Number(ev.target.value) >= moq && handleCustomQuantity(ev),
                    inputProps: {
                        step: 1,
                        inputMode: "numeric",
                        min: moq
                    },
                    helperText: props.translations.quantityHelperText.replace("{{moq}}", props.moq.toString())
                })
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                item: true,
                xs: 4,
                sx: {
                    textAlign: "center",
                    mt: "-20px"
                },
                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $6aa7d7a2594069b4$export$49333b01794f7d28), {
                    locale: locale,
                    price: price?.price || null,
                    currencyCode: price?.currencyCode || ""
                })
            })
        ]
    });
};
var $d847775e045d4bd8$export$2e2bcd8739ae039 = $d847775e045d4bd8$var$CustomQuantityField;



var $gWMia = parcelRequire("gWMia");
parcelRequire("4lkrv");

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $kFXNp = parcelRequire("kFXNp");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");





var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $c8aaf065cd1dd1f3$export$46f01d01378ec5a2(slot) {
    return (0, $1HGD7.default)("MuiDivider", slot);
}
const $c8aaf065cd1dd1f3$var$dividerClasses = (0, $3TIMy.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $c8aaf065cd1dd1f3$export$2e2bcd8739ae039 = $c8aaf065cd1dd1f3$var$dividerClasses;



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $e0234da23279e90c$export$81478e24460c57f2(slot) {
    return (0, $1HGD7.default)("MuiListItemIcon", slot);
}
const $e0234da23279e90c$var$listItemIconClasses = (0, $3TIMy.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $e0234da23279e90c$export$2e2bcd8739ae039 = $e0234da23279e90c$var$listItemIconClasses;



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $75adc5174b3f215d$export$1061006a0db3aeb5(slot) {
    return (0, $1HGD7.default)("MuiListItemText", slot);
}
const $75adc5174b3f215d$var$listItemTextClasses = (0, $3TIMy.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $75adc5174b3f215d$export$2e2bcd8739ae039 = $75adc5174b3f215d$var$listItemTextClasses;



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $45f8813745b97d39$export$515f8c67b5305377(slot) {
    return (0, $1HGD7.default)("MuiMenuItem", slot);
}
const $45f8813745b97d39$var$menuItemClasses = (0, $3TIMy.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $45f8813745b97d39$export$2e2bcd8739ae039 = $45f8813745b97d39$var$menuItemClasses;



var $gWMia = parcelRequire("gWMia");
const $1faef22859109c7a$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex"
];
const $1faef22859109c7a$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1faef22859109c7a$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled , dense: dense , divider: divider , disableGutters: disableGutters , selected: selected , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $kdLbD.default)(slots, (0, $45f8813745b97d39$export$515f8c67b5305377), classes);
    return (0, $9YD4s.default)({}, classes, composedClasses);
};
const $1faef22859109c7a$var$MenuItemRoot = (0, $bgnZl.default)((0, $946ef14610be8634$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bgnZl.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $1faef22859109c7a$export$4334bb34c76fef24
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $45f8813745b97d39$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kFXNp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $45f8813745b97d39$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kFXNp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $45f8813745b97d39$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kFXNp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kFXNp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $45f8813745b97d39$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $45f8813745b97d39$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $c8aaf065cd1dd1f3$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $c8aaf065cd1dd1f3$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $75adc5174b3f215d$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $75adc5174b3f215d$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $e0234da23279e90c$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $9YD4s.default)({
        minHeight: 32,
        // https://material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $e0234da23279e90c$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $1faef22859109c7a$var$MenuItem = /*#__PURE__*/ $4lkrv.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false , component: component = "li" , dense: dense = false , divider: divider = false , disableGutters: disableGutters = false , focusVisibleClassName: focusVisibleClassName , role: role = "menuitem" , tabIndex: tabIndexProp  } = props, other = (0, $eLWn9.default)(props, $1faef22859109c7a$var$_excluded);
    const context = $4lkrv.useContext((0, $6458657c0c336f3b$export$2e2bcd8739ae039));
    const childContext = {
        dense: dense || context.dense || false,
        disableGutters: disableGutters
    };
    const menuItemRef = $4lkrv.useRef(null);
    (0, $c3a88e87df6459f2$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $9YD4s.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $1faef22859109c7a$var$useUtilityClasses(props);
    const handleRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $6458657c0c336f3b$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $gWMia.jsx)($1faef22859109c7a$var$MenuItemRoot, (0, $9YD4s.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $iB56s.default)(classes.focusVisible, focusVisibleClassName)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $1faef22859109c7a$export$2e2bcd8739ae039 = $1faef22859109c7a$var$MenuItem;


var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");



var $kdLbD = parcelRequire("kdLbD");

var $kFXNp = parcelRequire("kFXNp");


var $at7OG = parcelRequire("at7OG");

var $9YD4s = parcelRequire("9YD4s");
parcelRequire("4lkrv");

parcelRequire("4lkrv");

var $5YV4M = parcelRequire("5YV4M");

var $gWMia = parcelRequire("gWMia");
var $29dd219b725484f7$export$2e2bcd8739ae039 = (0, $5YV4M.default)(/*#__PURE__*/ (0, $gWMia.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");


parcelRequire("4lkrv");

var $5YV4M = parcelRequire("5YV4M");

var $gWMia = parcelRequire("gWMia");
var $99e9f73ec4c383b0$export$2e2bcd8739ae039 = (0, $5YV4M.default)(/*#__PURE__*/ (0, $gWMia.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");



var $bgnZl = parcelRequire("bgnZl");

var $gWMia = parcelRequire("gWMia");
const $c6b1c9972e2d77f0$var$RadioButtonIconRoot = (0, $bgnZl.default)("span")({
    position: "relative",
    display: "flex"
});
const $c6b1c9972e2d77f0$var$RadioButtonIconBackground = (0, $bgnZl.default)((0, $29dd219b725484f7$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $c6b1c9972e2d77f0$var$RadioButtonIconDot = (0, $bgnZl.default)((0, $99e9f73ec4c383b0$export$2e2bcd8739ae039))(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $c6b1c9972e2d77f0$var$RadioButtonIcon(props) {
    const { checked: checked = false , classes: classes = {} , fontSize: fontSize  } = props;
    const ownerState = (0, $9YD4s.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $gWMia.jsxs)($c6b1c9972e2d77f0$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)($c6b1c9972e2d77f0$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)($c6b1c9972e2d77f0$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $c6b1c9972e2d77f0$export$2e2bcd8739ae039 = $c6b1c9972e2d77f0$var$RadioButtonIcon;



var $lJkvk = parcelRequire("lJkvk");

var $a5ad6bfee37b8956$export$2e2bcd8739ae039 = (0, $978cb32acb89afe9$export$2e2bcd8739ae039);



var $4lkrv = parcelRequire("4lkrv");

var $4lkrv = parcelRequire("4lkrv");
/**
 * @ignore - internal component.
 */ const $765c40a6d555254a$var$RadioGroupContext = /*#__PURE__*/ $4lkrv.createContext(undefined);
var $765c40a6d555254a$export$2e2bcd8739ae039 = $765c40a6d555254a$var$RadioGroupContext;


function $82e7b58195dee618$export$2e2bcd8739ae039() {
    return $4lkrv.useContext((0, $765c40a6d555254a$export$2e2bcd8739ae039));
}



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $9f376172d08cd046$export$192f7b2363c77155(slot) {
    return (0, $1HGD7.default)("MuiRadio", slot);
}
const $9f376172d08cd046$var$radioClasses = (0, $3TIMy.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary"
]);
var $9f376172d08cd046$export$2e2bcd8739ae039 = $9f376172d08cd046$var$radioClasses;



var $bgnZl = parcelRequire("bgnZl");

var $gWMia = parcelRequire("gWMia");
const $d60e7eeade10e622$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size"
];
const $d60e7eeade10e622$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , color: color  } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lJkvk.default)(color)}`
        ]
    };
    return (0, $9YD4s.default)({}, classes, (0, $kdLbD.default)(slots, (0, $9f376172d08cd046$export$192f7b2363c77155), classes));
};
const $d60e7eeade10e622$var$RadioRoot = (0, $bgnZl.default)((0, $225db297418caa05$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bgnZl.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[`color${(0, $lJkvk.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        color: (theme.vars || theme).palette.text.secondary,
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kFXNp.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $9f376172d08cd046$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $9f376172d08cd046$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $d60e7eeade10e622$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
     // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $d60e7eeade10e622$var$defaultCheckedIcon = /*#__PURE__*/ (0, $gWMia.jsx)((0, $c6b1c9972e2d77f0$export$2e2bcd8739ae039), {
    checked: true
});
const $d60e7eeade10e622$var$defaultIcon = /*#__PURE__*/ (0, $gWMia.jsx)((0, $c6b1c9972e2d77f0$export$2e2bcd8739ae039), {});
const $d60e7eeade10e622$var$Radio = /*#__PURE__*/ $4lkrv.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp , checkedIcon: checkedIcon = $d60e7eeade10e622$var$defaultCheckedIcon , color: color = "primary" , icon: icon = $d60e7eeade10e622$var$defaultIcon , name: nameProp , onChange: onChangeProp , size: size = "medium"  } = props, other = (0, $eLWn9.default)(props, $d60e7eeade10e622$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $d60e7eeade10e622$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $82e7b58195dee618$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $a5ad6bfee37b8956$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $d60e7eeade10e622$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $gWMia.jsx)($d60e7eeade10e622$var$RadioRoot, (0, $9YD4s.default)({
        type: "radio",
        icon: /*#__PURE__*/ $4lkrv.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $d60e7eeade10e622$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $4lkrv.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $d60e7eeade10e622$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref
    }, other));
});
var $d60e7eeade10e622$export$2e2bcd8739ae039 = $d60e7eeade10e622$var$Radio;


var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");


var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $befe4f4b7e2158ac$export$d72d4cbdc30b331f(slot) {
    return (0, $1HGD7.default)("MuiFormGroup", slot);
}
const $befe4f4b7e2158ac$var$formGroupClasses = (0, $3TIMy.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $befe4f4b7e2158ac$export$2e2bcd8739ae039 = $befe4f4b7e2158ac$var$formGroupClasses;





var $gWMia = parcelRequire("gWMia");
const $8eb4b6ee183005e1$var$_excluded = [
    "className",
    "row"
];
const $8eb4b6ee183005e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , row: row , error: error  } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $befe4f4b7e2158ac$export$d72d4cbdc30b331f), classes);
};
const $8eb4b6ee183005e1$var$FormGroupRoot = (0, $bgnZl.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $8eb4b6ee183005e1$var$FormGroup = /*#__PURE__*/ $4lkrv.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className , row: row = false  } = props, other = (0, $eLWn9.default)(props, $8eb4b6ee183005e1$var$_excluded);
    const muiFormControl = (0, $0c428d32e0c6707f$export$2e2bcd8739ae039)();
    const fcs = (0, $a885e469819db777$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $9YD4s.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $8eb4b6ee183005e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)($8eb4b6ee183005e1$var$FormGroupRoot, (0, $9YD4s.default)({
        className: (0, $iB56s.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $8eb4b6ee183005e1$export$2e2bcd8739ae039 = $8eb4b6ee183005e1$var$FormGroup;






var $bf5620e76d9e1fde$export$2e2bcd8739ae039 = (0, $5ab99b711f62def3$export$2e2bcd8739ae039);



var $gWMia = parcelRequire("gWMia");
const $d549d890f6385274$var$_excluded = [
    "actions",
    "children",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $d549d890f6385274$var$RadioGroup = /*#__PURE__*/ $4lkrv.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions , children: children , defaultValue: defaultValue , name: nameProp , onChange: onChange , value: valueProp  } = props, other = (0, $eLWn9.default)(props, $d549d890f6385274$var$_excluded);
    const rootRef = $4lkrv.useRef(null);
    const [value, setValueState] = (0, $fa80bb9ce38c215b$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "RadioGroup"
    });
    $4lkrv.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(ref, rootRef);
    const handleChange = (event)=>{
        setValueState(event.target.value);
        if (onChange) onChange(event, event.target.value);
    };
    const name = (0, $bf5620e76d9e1fde$export$2e2bcd8739ae039)(nameProp);
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $765c40a6d555254a$export$2e2bcd8739ae039).Provider, {
        value: {
            name: name,
            onChange: handleChange,
            value: value
        },
        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $8eb4b6ee183005e1$export$2e2bcd8739ae039), (0, $9YD4s.default)({
            role: "radiogroup",
            ref: handleRef
        }, other, {
            children: children
        }))
    });
});
var $d549d890f6385274$export$2e2bcd8739ae039 = $d549d890f6385274$var$RadioGroup;





var $kFXNp = parcelRequire("kFXNp");
const $0d86dc30b05384c5$var$CustomQuantityMenuItem = (props)=>{
    const { prices: prices , customQuantity: customQuantity , locale: locale , quantity: quantity , handleCustomPricing: handleCustomPricing , pricesIncTax: pricesIncTax , setCustomQuantity: setCustomQuantity , variant: variant  } = props;
    if (variant === "desktop") return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $d549d890f6385274$export$2e2bcd8739ae039), {
        value: quantity,
        children: [
            prices.map((price)=>{
                const selected = !customQuantity && price.quantity === quantity;
                return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                    container: true,
                    alignItems: "center",
                    sx: {
                        backgroundColor: selected ? (0, $5b810149f92fce45$export$8f45430ccf837300).coolBlueLight : "inherit",
                        borderRadius: "9px",
                        height: "44px",
                        cursor: "pointer",
                        "&:hover": {
                            backgroundColor: (0, $kFXNp.lighten)((0, $5b810149f92fce45$export$8f45430ccf837300).coolBlueLight, 0.6)
                        }
                    },
                    onClick: ()=>handleCustomPricing(price),
                    children: [
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 2,
                            sx: {
                                px: "12px"
                            },
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $d60e7eeade10e622$export$2e2bcd8739ae039), {
                                color: "default",
                                checked: selected,
                                value: price.quantity,
                                sx: {
                                    transform: "scale(1.5)"
                                },
                                disabled: price.quantity < price.moq
                            })
                        }),
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 3,
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                variant: "body1",
                                sx: {
                                    fontSize: {
                                        xs: "14px",
                                        md: "16px"
                                    }
                                },
                                children: price.quantity
                            })
                        }),
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 3,
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                variant: "body1",
                                sx: {
                                    fontSize: {
                                        xs: "14px",
                                        md: "16px"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $6aa7d7a2594069b4$export$49333b01794f7d28), {
                                    locale: locale,
                                    price: price.quantity < price.moq ? null : pricesIncTax ? price.priceIncTax : price.priceExTax,
                                    currencyCode: price.currencyCode
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 4,
                            children: selected ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                variant: "body1",
                                sx: {
                                    color: (0, $5b810149f92fce45$export$8f45430ccf837300).grey,
                                    fontSize: 12
                                },
                                children: pricesIncTax ? props.translations.incTax : props.translations.exTax
                            }) : /*#__PURE__*/ (0, $gWMia.jsxs)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                variant: "body1",
                                sx: {
                                    color: (0, $5b810149f92fce45$export$8f45430ccf837300).green,
                                    fontSize: 14
                                },
                                children: [
                                    props.translations.save,
                                    " ",
                                    (price.totalDiscountPct * 100).toFixed(0),
                                    "%"
                                ]
                            })
                        })
                    ]
                }, price.quantity);
            }),
            /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                container: true,
                alignItems: "center",
                sx: {
                    backgroundColor: customQuantity ? (0, $5b810149f92fce45$export$8f45430ccf837300).coolBlueLight : "inherit",
                    cursor: "pointer",
                    borderRadius: "9px",
                    height: "44px",
                    "&:hover": {
                        backgroundColor: (0, $kFXNp.lighten)((0, $5b810149f92fce45$export$8f45430ccf837300).coolBlueLight, 0.25)
                    }
                },
                onClick: ()=>{
                    setCustomQuantity(true);
                },
                children: [
                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 2,
                        sx: {
                            px: "12px"
                        },
                        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $d60e7eeade10e622$export$2e2bcd8739ae039), {
                            color: "default",
                            checked: customQuantity,
                            sx: {
                                transform: "scale(1.5)"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 10,
                        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                            variant: "body1",
                            sx: {
                                fontSize: {
                                    xs: "14px",
                                    md: "16px"
                                }
                            },
                            children: props.translations.quantityTitle
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $e8d14b4c1acbbd03$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $c7c5c012b882f66d$export$2e2bcd8739ae039), {
                id: "quantity-custom-select-label",
                children: props.translations.customQuantityLabel
            }),
            /*#__PURE__*/ (0, $gWMia.jsxs)((0, $6cd68c276cf6dda7$export$2e2bcd8739ae039), {
                labelId: "quantity-custom-select-label",
                id: "quantity-custom-select",
                label: props.translations.customQuantityLabel,
                value: quantity,
                children: [
                    prices.map((price)=>{
                        const selected = !customQuantity && price.quantity === quantity;
                        return /*#__PURE__*/ (0, $gWMia.jsx)((0, $1faef22859109c7a$export$2e2bcd8739ae039), {
                            value: price.quantity,
                            onClick: ()=>handleCustomPricing(price),
                            disabled: price.quantity < price.moq,
                            children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                container: true,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            children: price.quantity
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $6aa7d7a2594069b4$export$49333b01794f7d28), {
                                                locale: locale,
                                                price: price.quantity < price.moq ? null : pricesIncTax ? price.priceIncTax : price.priceExTax,
                                                currencyCode: price.currencyCode
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: selected ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            sx: {
                                                color: (0, $5b810149f92fce45$export$8f45430ccf837300).grey,
                                                fontSize: "14px",
                                                textTransform: "capitalize"
                                            },
                                            children: pricesIncTax ? props.translations.incTax : props.translations.exTax
                                        }) : /*#__PURE__*/ (0, $gWMia.jsxs)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            sx: {
                                                color: (0, $5b810149f92fce45$export$8f45430ccf837300).green
                                            },
                                            children: [
                                                props.translations.save,
                                                " ",
                                                (price.totalDiscountPct * 100).toFixed(0),
                                                "%"
                                            ]
                                        })
                                    })
                                ]
                            }, price.quantity)
                        }, price.quantity);
                    }),
                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $1faef22859109c7a$export$2e2bcd8739ae039), {
                        value: customQuantity ? quantity : "",
                        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                            container: true,
                            alignItems: "center",
                            onClick: ()=>setCustomQuantity(true),
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 10,
                                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    children: props.translations.quantityTitle
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $0d86dc30b05384c5$export$2e2bcd8739ae039 = $0d86dc30b05384c5$var$CustomQuantityMenuItem;




const $759bd2a6351c3477$var$PricesSection = (props)=>{
    const [customQuantity, setCustomQuantity] = (0, $4lkrv.useState)(!props.prices?.some((p)=>p.quantity === props.quantity));
    if (!props.prices) return null;
    const tr = (0, $18550a1b1cf51454$export$2e2bcd8739ae039)(props.translations);
    const t = (k)=>{
        return tr(k, {
            moq: props.moq
        });
    };
    const prices = props.prices.filter((p)=>p.quantity >= p.moq);
    const quantityField = customQuantity ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $d847775e045d4bd8$export$2e2bcd8739ae039), {
        locale: props.locale,
        price: props.price,
        moq: props.moq,
        quantity: props.quantity,
        handleCustomQuantity: props.handleCustomQuantity,
        translations: {
            quantityLabel: props.translations.quantityLabel,
            quantityHelperText: props.translations.quantityHelperText
        },
        quantityError: props.quantityError
    }) : null;
    const list = !props.mode ? {
        display: {
            xs: "none",
            md: "block"
        }
    } : props.mode === "list" ? {
        display: "block"
    } : {
        display: "none"
    };
    const mobile = !props.mode ? {
        display: {
            xs: "block",
            md: "none"
        }
    } : props.mode === "dropdown" ? {
        display: "block"
    } : {
        display: "none"
    };
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $5f7e2c6633a64ab9$export$6e2c8f0811a474ce), {
        number: 3,
        title: t("quantityTitle"),
        subtitle: t("quantitySubtitle"),
        titlePadding: true,
        "data-section": "Quantity",
        children: [
            /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                sx: {
                    ...list
                },
                children: [
                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $0d86dc30b05384c5$export$2e2bcd8739ae039), {
                        variant: "desktop",
                        customQuantity: customQuantity,
                        pricesIncTax: props.pricesIncTax,
                        setCustomQuantity: setCustomQuantity,
                        prices: prices,
                        locale: props.locale,
                        quantity: props.quantity,
                        handleCustomPricing: (ev)=>{
                            setCustomQuantity(false);
                            props.handleCustomPricing(ev);
                        },
                        translations: {
                            incTax: props.translations.incTax,
                            exTax: props.translations.exTax,
                            save: props.translations.save,
                            quantityTitle: props.translations.quantityTitle,
                            customQuantityLabel: props.translations.customQuantityLabel
                        }
                    }),
                    quantityField
                ]
            }),
            /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                sx: {
                    ...mobile,
                    px: {
                        md: "23px"
                    },
                    maxWidth: {
                        xs: "100%",
                        md: "276px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $0d86dc30b05384c5$export$2e2bcd8739ae039), {
                        variant: "mobile",
                        customQuantity: customQuantity,
                        pricesIncTax: props.pricesIncTax,
                        setCustomQuantity: setCustomQuantity,
                        prices: prices,
                        locale: props.locale,
                        quantity: props.quantity,
                        handleCustomPricing: (ev)=>{
                            setCustomQuantity(false);
                            props.handleCustomPricing(ev);
                        },
                        translations: {
                            incTax: props.translations.incTax,
                            exTax: props.translations.exTax,
                            save: props.translations.save,
                            quantityTitle: props.translations.quantityTitle,
                            customQuantityLabel: props.translations.customQuantityLabel
                        }
                    }),
                    quantityField
                ]
            })
        ]
    });
//   } else {
//     !props.isSample
//       ? sections.push(
//           <Section
//             key={sections.length + 1}
//             number={sections.length + 1}
//             title={t("customQuantityLabel")}
//             subtitle={t("quantitySubtitle")}
//             titlePadding
//             data-section="Quantity"
//           >
//             <PricingSkeleton />
//           </Section>
//         )
//       : null;
//   }
};
var $759bd2a6351c3477$export$2e2bcd8739ae039 = $759bd2a6351c3477$var$PricesSection;



var $gWMia = parcelRequire("gWMia");

parcelRequire("4lkrv");

const $0d00bee21f2c0aec$var$MaterialsSection = (props)=>{
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $5f7e2c6633a64ab9$export$6e2c8f0811a474ce), {
        number: 2,
        title: props.translations.selectYourMaterial,
        "data-section": "Material",
        sx: {
            px: {
                md: "23px"
            }
        },
        children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $e8d14b4c1acbbd03$export$2e2bcd8739ae039), {
            fullWidth: true,
            children: [
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $c7c5c012b882f66d$export$2e2bcd8739ae039), {
                    id: "select-material-label",
                    children: props.translations.materialLabel
                }),
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $6cd68c276cf6dda7$export$2e2bcd8739ae039), {
                    labelId: "select-material-label",
                    id: "select-material",
                    value: props.materialSku,
                    label: props.translations.materialLabel,
                    sx: {
                        maxWidth: {
                            xs: "100%",
                            md: "276px"
                        }
                    },
                    open: props.open,
                    onOpen: props.onOpenMaterials,
                    onChange: (ev)=>{
                        props.onChangeComplete(ev.target.value);
                    },
                    children: props.materials.map((material)=>{
                        return /*#__PURE__*/ (0, $gWMia.jsx)((0, $1faef22859109c7a$export$2e2bcd8739ae039), {
                            value: material.sku,
                            children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                container: true,
                                children: [
                                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 6,
                                        children: material.name
                                    }),
                                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 6,
                                        sx: {
                                            textAlign: "right",
                                            paddingRight: 4
                                        },
                                        children: material.bestseller ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: material.bestseller
                                        }) : null
                                    })
                                ]
                            })
                        }, material.sku);
                    })
                })
            ]
        })
    }, "material");
};
var $0d00bee21f2c0aec$export$2e2bcd8739ae039 = $0d00bee21f2c0aec$var$MaterialsSection;



var $gWMia = parcelRequire("gWMia");
parcelRequire("4lkrv");

var $gWMia = parcelRequire("gWMia");

var $4lkrv = parcelRequire("4lkrv");

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");


var $kFXNp = parcelRequire("kFXNp");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");






var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $4826b43b4f38a64f$export$5682c366c0c669d9(slot) {
    return (0, $1HGD7.default)("MuiListItem", slot);
}
const $4826b43b4f38a64f$var$listItemClasses = (0, $3TIMy.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $4826b43b4f38a64f$export$2e2bcd8739ae039 = $4826b43b4f38a64f$var$listItemClasses;



var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $b506d1efb38ca587$export$c09531d8563c67a5(slot) {
    return (0, $1HGD7.default)("MuiListItemButton", slot);
}
const $b506d1efb38ca587$var$listItemButtonClasses = (0, $3TIMy.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $b506d1efb38ca587$export$2e2bcd8739ae039 = $b506d1efb38ca587$var$listItemButtonClasses;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");


var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $cf48890014920a92$export$ccdb26aeba48a86e(slot) {
    return (0, $1HGD7.default)("MuiListItemSecondaryAction", slot);
}
const $cf48890014920a92$var$listItemSecondaryActionClasses = (0, $3TIMy.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $cf48890014920a92$export$2e2bcd8739ae039 = $cf48890014920a92$var$listItemSecondaryActionClasses;



var $gWMia = parcelRequire("gWMia");
const $9fd52825d888dd22$var$_excluded = [
    "className"
];
const $9fd52825d888dd22$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $cf48890014920a92$export$ccdb26aeba48a86e), classes);
};
const $9fd52825d888dd22$var$ListItemSecondaryActionRoot = (0, $bgnZl.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $9fd52825d888dd22$var$ListItemSecondaryAction = /*#__PURE__*/ $4lkrv.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className  } = props, other = (0, $eLWn9.default)(props, $9fd52825d888dd22$var$_excluded);
    const context = $4lkrv.useContext((0, $6458657c0c336f3b$export$2e2bcd8739ae039));
    const ownerState = (0, $9YD4s.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $9fd52825d888dd22$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)($9fd52825d888dd22$var$ListItemSecondaryActionRoot, (0, $9YD4s.default)({
        className: (0, $iB56s.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$9fd52825d888dd22$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $9fd52825d888dd22$export$2e2bcd8739ae039 = $9fd52825d888dd22$var$ListItemSecondaryAction;



var $gWMia = parcelRequire("gWMia");
const $0a5a8a2907404c73$var$_excluded = [
    "className"
], $0a5a8a2907404c73$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected"
];
const $0a5a8a2907404c73$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $0a5a8a2907404c73$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems , button: button , classes: classes , dense: dense , disabled: disabled , disableGutters: disableGutters , disablePadding: disablePadding , divider: divider , hasSecondaryAction: hasSecondaryAction , selected: selected  } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $4826b43b4f38a64f$export$5682c366c0c669d9), classes);
};
const $0a5a8a2907404c73$export$aed538f7519abe89 = (0, $bgnZl.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $0a5a8a2907404c73$export$4334bb34c76fef24
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $9YD4s.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $b506d1efb38ca587$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $4826b43b4f38a64f$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $4826b43b4f38a64f$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kFXNp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $4826b43b4f38a64f$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kFXNp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $4826b43b4f38a64f$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $4826b43b4f38a64f$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kFXNp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kFXNp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $0a5a8a2907404c73$var$ListItemContainer = (0, $bgnZl.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $0a5a8a2907404c73$var$ListItem = /*#__PURE__*/ $4lkrv.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center" , autoFocus: autoFocus = false , button: button = false , children: childrenProp , className: className , component: componentProp , components: components = {} , componentsProps: componentsProps = {} , ContainerComponent: ContainerComponent = "li" , ContainerProps: { className: ContainerClassName  } = {} , dense: dense = false , disabled: disabled = false , disableGutters: disableGutters = false , disablePadding: disablePadding = false , divider: divider = false , focusVisibleClassName: focusVisibleClassName , secondaryAction: secondaryAction , selected: selected = false  } = props, ContainerProps = (0, $eLWn9.default)(props.ContainerProps, $0a5a8a2907404c73$var$_excluded), other = (0, $eLWn9.default)(props, $0a5a8a2907404c73$var$_excluded2);
    const context = $4lkrv.useContext((0, $6458657c0c336f3b$export$2e2bcd8739ae039));
    const childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems,
        disableGutters: disableGutters
    };
    const listItemRef = $4lkrv.useRef(null);
    (0, $c3a88e87df6459f2$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $4lkrv.Children.toArray(childrenProp); // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $9da4006d06d30976$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $9YD4s.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $0a5a8a2907404c73$var$useUtilityClasses(ownerState);
    const handleRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = components.Root || $0a5a8a2907404c73$export$aed538f7519abe89;
    const rootProps = componentsProps.root || {};
    const componentProps = (0, $9YD4s.default)({
        className: (0, $iB56s.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $iB56s.default)((0, $4826b43b4f38a64f$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $946ef14610be8634$export$2e2bcd8739ae039);
    } // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component; // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $gWMia.jsx)((0, $6458657c0c336f3b$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $gWMia.jsxs)($0a5a8a2907404c73$var$ListItemContainer, (0, $9YD4s.default)({
                as: ContainerComponent,
                className: (0, $iB56s.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $gWMia.jsx)(Root, (0, $9YD4s.default)({}, rootProps, !(0, $bf7484b571a20c50$export$2e2bcd8739ae039)(Root) && {
                        as: Component,
                        ownerState: (0, $9YD4s.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $6458657c0c336f3b$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $gWMia.jsxs)(Root, (0, $9YD4s.default)({}, rootProps, {
            as: Component,
            ref: handleRef,
            ownerState: ownerState
        }, !(0, $bf7484b571a20c50$export$2e2bcd8739ae039)(Root) && {
            ownerState: (0, $9YD4s.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $gWMia.jsx)((0, $9fd52825d888dd22$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $0a5a8a2907404c73$export$2e2bcd8739ae039 = $0a5a8a2907404c73$var$ListItem;



var $kFXNp = parcelRequire("kFXNp");


var $db4f288fda5f92a7$exports = {};
"use strict";
var $95a1a4123f33e1f5$exports = {};
function $95a1a4123f33e1f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$95a1a4123f33e1f5$exports = $95a1a4123f33e1f5$var$_interopRequireDefault, $95a1a4123f33e1f5$exports.__esModule = true, $95a1a4123f33e1f5$exports["default"] = $95a1a4123f33e1f5$exports;


Object.defineProperty($db4f288fda5f92a7$exports, "__esModule", {
    value: true
});
$db4f288fda5f92a7$exports.default = void 0;

var $db4f288fda5f92a7$var$_createSvgIcon = $95a1a4123f33e1f5$exports((parcelRequire("irtyR")));

var $gWMia = parcelRequire("gWMia");
var $db4f288fda5f92a7$var$_default = (0, $db4f288fda5f92a7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $gWMia.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
$db4f288fda5f92a7$exports.default = $db4f288fda5f92a7$var$_default;


var $04133f85715f197f$exports = {};
"use strict";

Object.defineProperty($04133f85715f197f$exports, "__esModule", {
    value: true
});
$04133f85715f197f$exports.default = void 0;

var $04133f85715f197f$var$_createSvgIcon = $95a1a4123f33e1f5$exports((parcelRequire("irtyR")));

var $gWMia = parcelRequire("gWMia");
var $04133f85715f197f$var$_default = (0, $04133f85715f197f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $gWMia.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), "InfoOutlined");
$04133f85715f197f$exports.default = $04133f85715f197f$var$_default;




var $4lkrv = parcelRequire("4lkrv");

var $4lkrv = parcelRequire("4lkrv");
const $e2f0b13a8b8b1035$export$e9e34775259af03f = (0, $4lkrv.createContext)({
    baseUrl: "",
    currencyCode: "GBP",
    shipToCountryCode: "GB",
    locale: "en-GB",
    storeHash: ""
});


"use strict";
function $d4edf5ffb938168b$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $62060544f16d0aa4$var$toString  } = Object.prototype;
const { getPrototypeOf: $62060544f16d0aa4$var$getPrototypeOf  } = Object;
const $62060544f16d0aa4$var$kindOf = ((cache)=>(thing)=>{
        const str = $62060544f16d0aa4$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $62060544f16d0aa4$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$62060544f16d0aa4$var$kindOf(thing) === type;
};
const $62060544f16d0aa4$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $62060544f16d0aa4$var$isArray  } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $62060544f16d0aa4$var$isUndefined = $62060544f16d0aa4$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $62060544f16d0aa4$var$isBuffer(val) {
    return val !== null && !$62060544f16d0aa4$var$isUndefined(val) && val.constructor !== null && !$62060544f16d0aa4$var$isUndefined(val.constructor) && $62060544f16d0aa4$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $62060544f16d0aa4$var$isArrayBuffer = $62060544f16d0aa4$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $62060544f16d0aa4$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $62060544f16d0aa4$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $62060544f16d0aa4$var$isString = $62060544f16d0aa4$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $62060544f16d0aa4$var$isFunction = $62060544f16d0aa4$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $62060544f16d0aa4$var$isNumber = $62060544f16d0aa4$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $62060544f16d0aa4$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $62060544f16d0aa4$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $62060544f16d0aa4$var$isPlainObject = (val)=>{
    if ($62060544f16d0aa4$var$kindOf(val) !== "object") return false;
    const prototype = $62060544f16d0aa4$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $62060544f16d0aa4$var$isDate = $62060544f16d0aa4$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $62060544f16d0aa4$var$isFile = $62060544f16d0aa4$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $62060544f16d0aa4$var$isBlob = $62060544f16d0aa4$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $62060544f16d0aa4$var$isFileList = $62060544f16d0aa4$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $62060544f16d0aa4$var$isStream = (val)=>$62060544f16d0aa4$var$isObject(val) && $62060544f16d0aa4$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $62060544f16d0aa4$var$isFormData = (thing)=>{
    const pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $62060544f16d0aa4$var$toString.call(thing) === pattern || $62060544f16d0aa4$var$isFunction(thing.toString) && thing.toString() === pattern);
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $62060544f16d0aa4$var$isURLSearchParams = $62060544f16d0aa4$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $62060544f16d0aa4$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $62060544f16d0aa4$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false  } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($62060544f16d0aa4$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $62060544f16d0aa4$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $62060544f16d0aa4$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $62060544f16d0aa4$var$isContextDefined = (context)=>!$62060544f16d0aa4$var$isUndefined(context) && context !== $62060544f16d0aa4$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $62060544f16d0aa4$var$merge() {
    const { caseless: caseless  } = $62060544f16d0aa4$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $62060544f16d0aa4$var$findKey(result, key) || key;
        if ($62060544f16d0aa4$var$isPlainObject(result[targetKey]) && $62060544f16d0aa4$var$isPlainObject(val)) result[targetKey] = $62060544f16d0aa4$var$merge(result[targetKey], val);
        else if ($62060544f16d0aa4$var$isPlainObject(val)) result[targetKey] = $62060544f16d0aa4$var$merge({}, val);
        else if ($62060544f16d0aa4$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $62060544f16d0aa4$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $62060544f16d0aa4$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys  } = {})=>{
    $62060544f16d0aa4$var$forEach(b, (val, key)=>{
        if (thisArg && $62060544f16d0aa4$var$isFunction(val)) a[key] = (0, $d4edf5ffb938168b$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $62060544f16d0aa4$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $62060544f16d0aa4$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $62060544f16d0aa4$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $62060544f16d0aa4$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $62060544f16d0aa4$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $62060544f16d0aa4$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($62060544f16d0aa4$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$62060544f16d0aa4$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $62060544f16d0aa4$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $62060544f16d0aa4$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $62060544f16d0aa4$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $62060544f16d0aa4$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $62060544f16d0aa4$var$isHTMLForm = $62060544f16d0aa4$var$kindOfTest("HTMLFormElement");
const $62060544f16d0aa4$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $62060544f16d0aa4$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty  })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $62060544f16d0aa4$var$isRegExp = $62060544f16d0aa4$var$kindOfTest("RegExp");
const $62060544f16d0aa4$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $62060544f16d0aa4$var$forEach(descriptors, (descriptor, name)=>{
        if (reducer(descriptor, name, obj) !== false) reducedDescriptors[name] = descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $62060544f16d0aa4$var$freezeMethods = (obj)=>{
    $62060544f16d0aa4$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($62060544f16d0aa4$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$62060544f16d0aa4$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $62060544f16d0aa4$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $62060544f16d0aa4$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $62060544f16d0aa4$var$noop = ()=>{};
const $62060544f16d0aa4$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $62060544f16d0aa4$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $62060544f16d0aa4$var$DIGIT = "0123456789";
const $62060544f16d0aa4$var$ALPHABET = {
    DIGIT: $62060544f16d0aa4$var$DIGIT,
    ALPHA: $62060544f16d0aa4$var$ALPHA,
    ALPHA_DIGIT: $62060544f16d0aa4$var$ALPHA + $62060544f16d0aa4$var$ALPHA.toUpperCase() + $62060544f16d0aa4$var$DIGIT
};
const $62060544f16d0aa4$var$generateString = (size = 16, alphabet = $62060544f16d0aa4$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length  } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $62060544f16d0aa4$var$isSpecCompliantForm(thing) {
    return !!(thing && $62060544f16d0aa4$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $62060544f16d0aa4$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($62060544f16d0aa4$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $62060544f16d0aa4$var$isArray(source) ? [] : {};
                $62060544f16d0aa4$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$62060544f16d0aa4$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
var $62060544f16d0aa4$export$2e2bcd8739ae039 = {
    isArray: $62060544f16d0aa4$var$isArray,
    isArrayBuffer: $62060544f16d0aa4$var$isArrayBuffer,
    isBuffer: $62060544f16d0aa4$var$isBuffer,
    isFormData: $62060544f16d0aa4$var$isFormData,
    isArrayBufferView: $62060544f16d0aa4$var$isArrayBufferView,
    isString: $62060544f16d0aa4$var$isString,
    isNumber: $62060544f16d0aa4$var$isNumber,
    isBoolean: $62060544f16d0aa4$var$isBoolean,
    isObject: $62060544f16d0aa4$var$isObject,
    isPlainObject: $62060544f16d0aa4$var$isPlainObject,
    isUndefined: $62060544f16d0aa4$var$isUndefined,
    isDate: $62060544f16d0aa4$var$isDate,
    isFile: $62060544f16d0aa4$var$isFile,
    isBlob: $62060544f16d0aa4$var$isBlob,
    isRegExp: $62060544f16d0aa4$var$isRegExp,
    isFunction: $62060544f16d0aa4$var$isFunction,
    isStream: $62060544f16d0aa4$var$isStream,
    isURLSearchParams: $62060544f16d0aa4$var$isURLSearchParams,
    isTypedArray: $62060544f16d0aa4$var$isTypedArray,
    isFileList: $62060544f16d0aa4$var$isFileList,
    forEach: $62060544f16d0aa4$var$forEach,
    merge: $62060544f16d0aa4$var$merge,
    extend: $62060544f16d0aa4$var$extend,
    trim: $62060544f16d0aa4$var$trim,
    stripBOM: $62060544f16d0aa4$var$stripBOM,
    inherits: $62060544f16d0aa4$var$inherits,
    toFlatObject: $62060544f16d0aa4$var$toFlatObject,
    kindOf: $62060544f16d0aa4$var$kindOf,
    kindOfTest: $62060544f16d0aa4$var$kindOfTest,
    endsWith: $62060544f16d0aa4$var$endsWith,
    toArray: $62060544f16d0aa4$var$toArray,
    forEachEntry: $62060544f16d0aa4$var$forEachEntry,
    matchAll: $62060544f16d0aa4$var$matchAll,
    isHTMLForm: $62060544f16d0aa4$var$isHTMLForm,
    hasOwnProperty: $62060544f16d0aa4$var$hasOwnProperty,
    hasOwnProp: $62060544f16d0aa4$var$hasOwnProperty,
    reduceDescriptors: $62060544f16d0aa4$var$reduceDescriptors,
    freezeMethods: $62060544f16d0aa4$var$freezeMethods,
    toObjectSet: $62060544f16d0aa4$var$toObjectSet,
    toCamelCase: $62060544f16d0aa4$var$toCamelCase,
    noop: $62060544f16d0aa4$var$noop,
    toFiniteNumber: $62060544f16d0aa4$var$toFiniteNumber,
    findKey: $62060544f16d0aa4$var$findKey,
    global: $62060544f16d0aa4$var$_global,
    isContextDefined: $62060544f16d0aa4$var$isContextDefined,
    ALPHABET: $62060544f16d0aa4$var$ALPHABET,
    generateString: $62060544f16d0aa4$var$generateString,
    isSpecCompliantForm: $62060544f16d0aa4$var$isSpecCompliantForm,
    toJSONObject: $62060544f16d0aa4$var$toJSONObject
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $16afd4c860037c35$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $62060544f16d0aa4$export$2e2bcd8739ae039).inherits($16afd4c860037c35$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $62060544f16d0aa4$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $16afd4c860037c35$var$prototype = $16afd4c860037c35$var$AxiosError.prototype;
const $16afd4c860037c35$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $16afd4c860037c35$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($16afd4c860037c35$var$AxiosError, $16afd4c860037c35$var$descriptors);
Object.defineProperty($16afd4c860037c35$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$16afd4c860037c35$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($16afd4c860037c35$var$prototype);
    (0, $62060544f16d0aa4$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $16afd4c860037c35$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $16afd4c860037c35$export$2e2bcd8739ae039 = $16afd4c860037c35$var$AxiosError;


// eslint-disable-next-line strict
var $e854f8a669d92959$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $ec820ff55f0f616d$export$a143d493d941bafc;
var $ec820ff55f0f616d$export$e4cf37d7f6fb9e0a;
var $ec820ff55f0f616d$export$f99ded8fe4b79145;
var $ec820ff55f0f616d$export$599f31c3813fae4d;
"use strict";
var $6c5cd92f22ffba9a$export$a48f0734ac7c2329;
var $6c5cd92f22ffba9a$export$d622b2ad8d90c771;
var $6c5cd92f22ffba9a$export$6100ba28696e12de;
"use strict";
$6c5cd92f22ffba9a$export$a48f0734ac7c2329 = $6c5cd92f22ffba9a$var$byteLength;
$6c5cd92f22ffba9a$export$d622b2ad8d90c771 = $6c5cd92f22ffba9a$var$toByteArray;
$6c5cd92f22ffba9a$export$6100ba28696e12de = $6c5cd92f22ffba9a$var$fromByteArray;
var $6c5cd92f22ffba9a$var$lookup = [];
var $6c5cd92f22ffba9a$var$revLookup = [];
var $6c5cd92f22ffba9a$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $6c5cd92f22ffba9a$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $6c5cd92f22ffba9a$var$i = 0, $6c5cd92f22ffba9a$var$len = $6c5cd92f22ffba9a$var$code.length; $6c5cd92f22ffba9a$var$i < $6c5cd92f22ffba9a$var$len; ++$6c5cd92f22ffba9a$var$i){
    $6c5cd92f22ffba9a$var$lookup[$6c5cd92f22ffba9a$var$i] = $6c5cd92f22ffba9a$var$code[$6c5cd92f22ffba9a$var$i];
    $6c5cd92f22ffba9a$var$revLookup[$6c5cd92f22ffba9a$var$code.charCodeAt($6c5cd92f22ffba9a$var$i)] = $6c5cd92f22ffba9a$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$6c5cd92f22ffba9a$var$revLookup["-".charCodeAt(0)] = 62;
$6c5cd92f22ffba9a$var$revLookup["_".charCodeAt(0)] = 63;
function $6c5cd92f22ffba9a$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $6c5cd92f22ffba9a$var$byteLength(b64) {
    var lens = $6c5cd92f22ffba9a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $6c5cd92f22ffba9a$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $6c5cd92f22ffba9a$var$toByteArray(b64) {
    var tmp;
    var lens = $6c5cd92f22ffba9a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $6c5cd92f22ffba9a$var$Arr($6c5cd92f22ffba9a$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $6c5cd92f22ffba9a$var$revLookup[b64.charCodeAt(i)] << 18 | $6c5cd92f22ffba9a$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $6c5cd92f22ffba9a$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $6c5cd92f22ffba9a$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $6c5cd92f22ffba9a$var$revLookup[b64.charCodeAt(i)] << 2 | $6c5cd92f22ffba9a$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $6c5cd92f22ffba9a$var$revLookup[b64.charCodeAt(i)] << 10 | $6c5cd92f22ffba9a$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $6c5cd92f22ffba9a$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $6c5cd92f22ffba9a$var$tripletToBase64(num) {
    return $6c5cd92f22ffba9a$var$lookup[num >> 18 & 0x3F] + $6c5cd92f22ffba9a$var$lookup[num >> 12 & 0x3F] + $6c5cd92f22ffba9a$var$lookup[num >> 6 & 0x3F] + $6c5cd92f22ffba9a$var$lookup[num & 0x3F];
}
function $6c5cd92f22ffba9a$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($6c5cd92f22ffba9a$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $6c5cd92f22ffba9a$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($6c5cd92f22ffba9a$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($6c5cd92f22ffba9a$var$lookup[tmp >> 2] + $6c5cd92f22ffba9a$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($6c5cd92f22ffba9a$var$lookup[tmp >> 10] + $6c5cd92f22ffba9a$var$lookup[tmp >> 4 & 0x3F] + $6c5cd92f22ffba9a$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7d269f417f635ca9$export$aafa59e2e03f2942;
var $7d269f417f635ca9$export$68d8715fc104d294;
$7d269f417f635ca9$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7d269f417f635ca9$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $ec820ff55f0f616d$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$ec820ff55f0f616d$export$a143d493d941bafc = $ec820ff55f0f616d$var$Buffer;
$ec820ff55f0f616d$export$e4cf37d7f6fb9e0a = $ec820ff55f0f616d$var$SlowBuffer;
$ec820ff55f0f616d$export$f99ded8fe4b79145 = 50;
var $ec820ff55f0f616d$var$K_MAX_LENGTH = 0x7fffffff;
$ec820ff55f0f616d$export$599f31c3813fae4d = $ec820ff55f0f616d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $ec820ff55f0f616d$var$Buffer.TYPED_ARRAY_SUPPORT = $ec820ff55f0f616d$var$typedArraySupport();
if (!$ec820ff55f0f616d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $ec820ff55f0f616d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($ec820ff55f0f616d$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$ec820ff55f0f616d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($ec820ff55f0f616d$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$ec820ff55f0f616d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $ec820ff55f0f616d$var$createBuffer(length) {
    if (length > $ec820ff55f0f616d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $ec820ff55f0f616d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ec820ff55f0f616d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $ec820ff55f0f616d$var$allocUnsafe(arg);
    }
    return $ec820ff55f0f616d$var$from(arg, encodingOrOffset, length);
}
$ec820ff55f0f616d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $ec820ff55f0f616d$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $ec820ff55f0f616d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $ec820ff55f0f616d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($ec820ff55f0f616d$var$isInstance(value, ArrayBuffer) || value && $ec820ff55f0f616d$var$isInstance(value.buffer, ArrayBuffer)) return $ec820ff55f0f616d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($ec820ff55f0f616d$var$isInstance(value, SharedArrayBuffer) || value && $ec820ff55f0f616d$var$isInstance(value.buffer, SharedArrayBuffer))) return $ec820ff55f0f616d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $ec820ff55f0f616d$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $ec820ff55f0f616d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $ec820ff55f0f616d$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ec820ff55f0f616d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ec820ff55f0f616d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($ec820ff55f0f616d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($ec820ff55f0f616d$var$Buffer, Uint8Array);
function $ec820ff55f0f616d$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $ec820ff55f0f616d$var$alloc(size, fill, encoding) {
    $ec820ff55f0f616d$var$assertSize(size);
    if (size <= 0) return $ec820ff55f0f616d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $ec820ff55f0f616d$var$createBuffer(size).fill(fill, encoding) : $ec820ff55f0f616d$var$createBuffer(size).fill(fill);
    return $ec820ff55f0f616d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ec820ff55f0f616d$var$Buffer.alloc = function(size, fill, encoding) {
    return $ec820ff55f0f616d$var$alloc(size, fill, encoding);
};
function $ec820ff55f0f616d$var$allocUnsafe(size) {
    $ec820ff55f0f616d$var$assertSize(size);
    return $ec820ff55f0f616d$var$createBuffer(size < 0 ? 0 : $ec820ff55f0f616d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ec820ff55f0f616d$var$Buffer.allocUnsafe = function(size) {
    return $ec820ff55f0f616d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ec820ff55f0f616d$var$Buffer.allocUnsafeSlow = function(size) {
    return $ec820ff55f0f616d$var$allocUnsafe(size);
};
function $ec820ff55f0f616d$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$ec820ff55f0f616d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $ec820ff55f0f616d$var$byteLength(string, encoding) | 0;
    var buf = $ec820ff55f0f616d$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $ec820ff55f0f616d$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $ec820ff55f0f616d$var$checked(array.length) | 0;
    var buf = $ec820ff55f0f616d$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $ec820ff55f0f616d$var$fromArrayView(arrayView) {
    if ($ec820ff55f0f616d$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $ec820ff55f0f616d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $ec820ff55f0f616d$var$fromArrayLike(arrayView);
}
function $ec820ff55f0f616d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $ec820ff55f0f616d$var$Buffer.prototype);
    return buf;
}
function $ec820ff55f0f616d$var$fromObject(obj) {
    if ($ec820ff55f0f616d$var$Buffer.isBuffer(obj)) {
        var len = $ec820ff55f0f616d$var$checked(obj.length) | 0;
        var buf = $ec820ff55f0f616d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $ec820ff55f0f616d$var$numberIsNaN(obj.length)) return $ec820ff55f0f616d$var$createBuffer(0);
        return $ec820ff55f0f616d$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $ec820ff55f0f616d$var$fromArrayLike(obj.data);
}
function $ec820ff55f0f616d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ec820ff55f0f616d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ec820ff55f0f616d$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $ec820ff55f0f616d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ec820ff55f0f616d$var$Buffer.alloc(+length);
}
$ec820ff55f0f616d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $ec820ff55f0f616d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$ec820ff55f0f616d$var$Buffer.compare = function compare(a, b) {
    if ($ec820ff55f0f616d$var$isInstance(a, Uint8Array)) a = $ec820ff55f0f616d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($ec820ff55f0f616d$var$isInstance(b, Uint8Array)) b = $ec820ff55f0f616d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$ec820ff55f0f616d$var$Buffer.isBuffer(a) || !$ec820ff55f0f616d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ec820ff55f0f616d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$ec820ff55f0f616d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ec820ff55f0f616d$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $ec820ff55f0f616d$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($ec820ff55f0f616d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $ec820ff55f0f616d$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$ec820ff55f0f616d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ec820ff55f0f616d$var$byteLength(string, encoding) {
    if ($ec820ff55f0f616d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $ec820ff55f0f616d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $ec820ff55f0f616d$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $ec820ff55f0f616d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $ec820ff55f0f616d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ec820ff55f0f616d$var$Buffer.byteLength = $ec820ff55f0f616d$var$byteLength;
function $ec820ff55f0f616d$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $ec820ff55f0f616d$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $ec820ff55f0f616d$var$utf8Slice(this, start, end);
        case "ascii":
            return $ec820ff55f0f616d$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $ec820ff55f0f616d$var$latin1Slice(this, start, end);
        case "base64":
            return $ec820ff55f0f616d$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $ec820ff55f0f616d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$ec820ff55f0f616d$var$Buffer.prototype._isBuffer = true;
function $ec820ff55f0f616d$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ec820ff55f0f616d$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$ec820ff55f0f616d$var$swap(this, i, i + 1);
    return this;
};
$ec820ff55f0f616d$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $ec820ff55f0f616d$var$swap(this, i, i + 3);
        $ec820ff55f0f616d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ec820ff55f0f616d$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $ec820ff55f0f616d$var$swap(this, i, i + 7);
        $ec820ff55f0f616d$var$swap(this, i + 1, i + 6);
        $ec820ff55f0f616d$var$swap(this, i + 2, i + 5);
        $ec820ff55f0f616d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ec820ff55f0f616d$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $ec820ff55f0f616d$var$utf8Slice(this, 0, length);
    return $ec820ff55f0f616d$var$slowToString.apply(this, arguments);
};
$ec820ff55f0f616d$var$Buffer.prototype.toLocaleString = $ec820ff55f0f616d$var$Buffer.prototype.toString;
$ec820ff55f0f616d$var$Buffer.prototype.equals = function equals(b) {
    if (!$ec820ff55f0f616d$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $ec820ff55f0f616d$var$Buffer.compare(this, b) === 0;
};
$ec820ff55f0f616d$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $ec820ff55f0f616d$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($ec820ff55f0f616d$var$customInspectSymbol) $ec820ff55f0f616d$var$Buffer.prototype[$ec820ff55f0f616d$var$customInspectSymbol] = $ec820ff55f0f616d$var$Buffer.prototype.inspect;
$ec820ff55f0f616d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($ec820ff55f0f616d$var$isInstance(target, Uint8Array)) target = $ec820ff55f0f616d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$ec820ff55f0f616d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ec820ff55f0f616d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($ec820ff55f0f616d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $ec820ff55f0f616d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ec820ff55f0f616d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ec820ff55f0f616d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ec820ff55f0f616d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $ec820ff55f0f616d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ec820ff55f0f616d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ec820ff55f0f616d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ec820ff55f0f616d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ec820ff55f0f616d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ec820ff55f0f616d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ec820ff55f0f616d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($ec820ff55f0f616d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ec820ff55f0f616d$var$utf8Write(buf, string, offset, length) {
    return $ec820ff55f0f616d$var$blitBuffer($ec820ff55f0f616d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ec820ff55f0f616d$var$asciiWrite(buf, string, offset, length) {
    return $ec820ff55f0f616d$var$blitBuffer($ec820ff55f0f616d$var$asciiToBytes(string), buf, offset, length);
}
function $ec820ff55f0f616d$var$base64Write(buf, string, offset, length) {
    return $ec820ff55f0f616d$var$blitBuffer($ec820ff55f0f616d$var$base64ToBytes(string), buf, offset, length);
}
function $ec820ff55f0f616d$var$ucs2Write(buf, string, offset, length) {
    return $ec820ff55f0f616d$var$blitBuffer($ec820ff55f0f616d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ec820ff55f0f616d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $ec820ff55f0f616d$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $ec820ff55f0f616d$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $ec820ff55f0f616d$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $ec820ff55f0f616d$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $ec820ff55f0f616d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ec820ff55f0f616d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ec820ff55f0f616d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6c5cd92f22ffba9a$export$6100ba28696e12de(buf);
    else return $6c5cd92f22ffba9a$export$6100ba28696e12de(buf.slice(start, end));
}
function $ec820ff55f0f616d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ec820ff55f0f616d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $ec820ff55f0f616d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ec820ff55f0f616d$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $ec820ff55f0f616d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ec820ff55f0f616d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ec820ff55f0f616d$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ec820ff55f0f616d$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ec820ff55f0f616d$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $ec820ff55f0f616d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $ec820ff55f0f616d$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ec820ff55f0f616d$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $ec820ff55f0f616d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ec820ff55f0f616d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$ec820ff55f0f616d$var$Buffer.prototype.readUintLE = $ec820ff55f0f616d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ec820ff55f0f616d$var$Buffer.prototype.readUintBE = $ec820ff55f0f616d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ec820ff55f0f616d$var$Buffer.prototype.readUint8 = $ec820ff55f0f616d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ec820ff55f0f616d$var$Buffer.prototype.readUint16LE = $ec820ff55f0f616d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ec820ff55f0f616d$var$Buffer.prototype.readUint16BE = $ec820ff55f0f616d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ec820ff55f0f616d$var$Buffer.prototype.readUint32LE = $ec820ff55f0f616d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ec820ff55f0f616d$var$Buffer.prototype.readUint32BE = $ec820ff55f0f616d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ec820ff55f0f616d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ec820ff55f0f616d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ec820ff55f0f616d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ec820ff55f0f616d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ec820ff55f0f616d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ec820ff55f0f616d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ec820ff55f0f616d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ec820ff55f0f616d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 4, this.length);
    return $7d269f417f635ca9$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$ec820ff55f0f616d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 4, this.length);
    return $7d269f417f635ca9$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$ec820ff55f0f616d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 8, this.length);
    return $7d269f417f635ca9$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$ec820ff55f0f616d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkOffset(offset, 8, this.length);
    return $7d269f417f635ca9$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $ec820ff55f0f616d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ec820ff55f0f616d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$ec820ff55f0f616d$var$Buffer.prototype.writeUintLE = $ec820ff55f0f616d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ec820ff55f0f616d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeUintBE = $ec820ff55f0f616d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ec820ff55f0f616d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeUint8 = $ec820ff55f0f616d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeUint16LE = $ec820ff55f0f616d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeUint16BE = $ec820ff55f0f616d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeUint32LE = $ec820ff55f0f616d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeUint32BE = $ec820ff55f0f616d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $ec820ff55f0f616d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $ec820ff55f0f616d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$ec820ff55f0f616d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $ec820ff55f0f616d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $ec820ff55f0f616d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7d269f417f635ca9$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ec820ff55f0f616d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ec820ff55f0f616d$var$writeFloat(this, value, offset, true, noAssert);
};
$ec820ff55f0f616d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ec820ff55f0f616d$var$writeFloat(this, value, offset, false, noAssert);
};
function $ec820ff55f0f616d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec820ff55f0f616d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7d269f417f635ca9$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ec820ff55f0f616d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ec820ff55f0f616d$var$writeDouble(this, value, offset, true, noAssert);
};
$ec820ff55f0f616d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ec820ff55f0f616d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ec820ff55f0f616d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$ec820ff55f0f616d$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ec820ff55f0f616d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$ec820ff55f0f616d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $ec820ff55f0f616d$var$Buffer.isBuffer(val) ? val : $ec820ff55f0f616d$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $ec820ff55f0f616d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $ec820ff55f0f616d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($ec820ff55f0f616d$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $ec820ff55f0f616d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $ec820ff55f0f616d$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ec820ff55f0f616d$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ec820ff55f0f616d$var$base64ToBytes(str) {
    return $6c5cd92f22ffba9a$export$d622b2ad8d90c771($ec820ff55f0f616d$var$base64clean(str));
}
function $ec820ff55f0f616d$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $ec820ff55f0f616d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $ec820ff55f0f616d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $ec820ff55f0f616d$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $ac87e3667a6b92ca$require$Buffer = $ec820ff55f0f616d$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $ac87e3667a6b92ca$var$isVisitable(thing) {
    return (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $ac87e3667a6b92ca$var$removeBrackets(key) {
    return (0, $62060544f16d0aa4$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $ac87e3667a6b92ca$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $ac87e3667a6b92ca$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $ac87e3667a6b92ca$var$isFlatArray(arr) {
    return (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(arr) && !arr.some($ac87e3667a6b92ca$var$isVisitable);
}
const $ac87e3667a6b92ca$var$predicates = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).toFlatObject((0, $62060544f16d0aa4$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $ac87e3667a6b92ca$var$toFormData(obj, formData, options) {
    if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $e854f8a669d92959$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $16afd4c860037c35$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $ac87e3667a6b92ca$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(value) && $ac87e3667a6b92ca$var$isFlatArray(value) || ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFileList(value) || (0, $62060544f16d0aa4$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $ac87e3667a6b92ca$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $ac87e3667a6b92ca$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($ac87e3667a6b92ca$var$isVisitable(value)) return true;
        formData.append($ac87e3667a6b92ca$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($ac87e3667a6b92ca$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $ac87e3667a6b92ca$var$isVisitable
    });
    function build(value, path) {
        if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $ac87e3667a6b92ca$export$2e2bcd8739ae039 = $ac87e3667a6b92ca$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $31c969d555cb19f9$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $31c969d555cb19f9$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $ac87e3667a6b92ca$export$2e2bcd8739ae039)(params, this, options);
}
const $31c969d555cb19f9$var$prototype = $31c969d555cb19f9$var$AxiosURLSearchParams.prototype;
$31c969d555cb19f9$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$31c969d555cb19f9$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $31c969d555cb19f9$var$encode);
    } : $31c969d555cb19f9$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $31c969d555cb19f9$export$2e2bcd8739ae039 = $31c969d555cb19f9$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $1cdd8b97a4bdad9e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $1cdd8b97a4bdad9e$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $1cdd8b97a4bdad9e$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $31c969d555cb19f9$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $3a62da52e7b1f205$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $3a62da52e7b1f205$export$2e2bcd8739ae039 = $3a62da52e7b1f205$var$InterceptorManager;





"use strict";
var $5fafa81305f3a991$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $cd97423044ab807d$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $31c969d555cb19f9$export$2e2bcd8739ae039);


"use strict";
var $07ee775d4d9265a7$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $e500017c8ce5bc75$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $d5f21f79e1b7a778$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $d5f21f79e1b7a778$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $d5f21f79e1b7a778$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $cd97423044ab807d$export$2e2bcd8739ae039,
        FormData: $07ee775d4d9265a7$export$2e2bcd8739ae039,
        Blob: $e500017c8ce5bc75$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $d5f21f79e1b7a778$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $d5f21f79e1b7a778$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $4b6481d2817042b0$export$2e2bcd8739ae039(data, options) {
    return (0, $ac87e3667a6b92ca$export$2e2bcd8739ae039)(data, new (0, $d5f21f79e1b7a778$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $d5f21f79e1b7a778$export$2e2bcd8739ae039).isNode && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $c60e9f460b5f4b3c$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $62060544f16d0aa4$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $c60e9f460b5f4b3c$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $c60e9f460b5f4b3c$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $c60e9f460b5f4b3c$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFormData(formData) && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($c60e9f460b5f4b3c$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $c60e9f460b5f4b3c$export$2e2bcd8739ae039 = $c60e9f460b5f4b3c$var$formDataToJSON;


"use strict";
const $92850945f03943d4$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": undefined
};
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $92850945f03943d4$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $62060544f16d0aa4$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $92850945f03943d4$var$defaults = {
    transitional: (0, $5fafa81305f3a991$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $c60e9f460b5f4b3c$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isBuffer(data) || (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isStream(data) || (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFile(data) || (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $4b6481d2817042b0$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $ac87e3667a6b92ca$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $92850945f03943d4$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $92850945f03943d4$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $16afd4c860037c35$export$2e2bcd8739ae039).from(e, (0, $16afd4c860037c35$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $d5f21f79e1b7a778$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $d5f21f79e1b7a778$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
(0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $92850945f03943d4$var$defaults.headers[method] = {};
});
(0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $92850945f03943d4$var$defaults.headers[method] = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).merge($92850945f03943d4$var$DEFAULT_CONTENT_TYPE);
});
var $92850945f03943d4$export$2e2bcd8739ae039 = $92850945f03943d4$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $b780d38a9d17a1f1$var$ignoreDuplicateOf = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $b780d38a9d17a1f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $b780d38a9d17a1f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $1cf3d961d96dea92$var$$internals = Symbol("internals");
function $1cf3d961d96dea92$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $1cf3d961d96dea92$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(value) ? value.map($1cf3d961d96dea92$var$normalizeValue) : String(value);
}
function $1cf3d961d96dea92$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $1cf3d961d96dea92$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $1cf3d961d96dea92$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $1cf3d961d96dea92$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $1cf3d961d96dea92$var$buildAccessors(obj, header) {
    const accessorName = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $1cf3d961d96dea92$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $1cf3d961d96dea92$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $1cf3d961d96dea92$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$1cf3d961d96dea92$var$isValidHeaderName(header)) setHeaders((0, $b780d38a9d17a1f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $1cf3d961d96dea92$var$normalizeHeader(header);
        if (header) {
            const key = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $1cf3d961d96dea92$var$parseTokens(value);
                if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $1cf3d961d96dea92$var$normalizeHeader(header);
        if (header) {
            const key = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $1cf3d961d96dea92$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $1cf3d961d96dea92$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $1cf3d961d96dea92$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $1cf3d961d96dea92$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $1cf3d961d96dea92$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $1cf3d961d96dea92$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $1cf3d961d96dea92$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$1cf3d961d96dea92$var$$internals] = this[$1cf3d961d96dea92$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $1cf3d961d96dea92$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $1cf3d961d96dea92$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$1cf3d961d96dea92$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
(0, $62060544f16d0aa4$export$2e2bcd8739ae039).freezeMethods($1cf3d961d96dea92$var$AxiosHeaders.prototype);
(0, $62060544f16d0aa4$export$2e2bcd8739ae039).freezeMethods($1cf3d961d96dea92$var$AxiosHeaders);
var $1cf3d961d96dea92$export$2e2bcd8739ae039 = $1cf3d961d96dea92$var$AxiosHeaders;


"use strict";
function $a41e733ab387fdc0$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $92850945f03943d4$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $1cf3d961d96dea92$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $361432ab6de1c230$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $c01a1f9a5a9bf0fc$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $16afd4c860037c35$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $16afd4c860037c35$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $62060544f16d0aa4$export$2e2bcd8739ae039).inherits($c01a1f9a5a9bf0fc$var$CanceledError, (0, $16afd4c860037c35$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $c01a1f9a5a9bf0fc$export$2e2bcd8739ae039 = $c01a1f9a5a9bf0fc$var$CanceledError;







"use strict";
function $95dc2c75a51f1668$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $16afd4c860037c35$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $16afd4c860037c35$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $16afd4c860037c35$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $c9df34e85cd32650$export$2e2bcd8739ae039 = (0, $d5f21f79e1b7a778$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $0d67f2b391fc4ee2$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $73d5ded77e763086$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $131b93a27bc19dbc$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $0d67f2b391fc4ee2$export$2e2bcd8739ae039)(requestedURL)) return (0, $73d5ded77e763086$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $bd62cce5b1bbf31a$export$2e2bcd8739ae039 = (0, $d5f21f79e1b7a778$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $fa201ff5ea5e194a$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $782458d31bf6b38d$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $782458d31bf6b38d$export$2e2bcd8739ae039 = $782458d31bf6b38d$var$speedometer;


"use strict";
function $fa8ac62bccab8125$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $782458d31bf6b38d$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $fa8ac62bccab8125$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $fa8ac62bccab8125$export$2e2bcd8739ae039 = $fa8ac62bccab8125$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $1cf3d961d96dea92$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFormData(requestData) && ((0, $d5f21f79e1b7a778$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $d5f21f79e1b7a778$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv)) requestHeaders.setContentType(false); // Let the browser set it
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $131b93a27bc19dbc$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $1cdd8b97a4bdad9e$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $1cf3d961d96dea92$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $95dc2c75a51f1668$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $16afd4c860037c35$export$2e2bcd8739ae039)("Request aborted", (0, $16afd4c860037c35$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $16afd4c860037c35$export$2e2bcd8739ae039)("Network Error", (0, $16afd4c860037c35$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $5fafa81305f3a991$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $16afd4c860037c35$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $16afd4c860037c35$export$2e2bcd8739ae039).ETIMEDOUT : (0, $16afd4c860037c35$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $d5f21f79e1b7a778$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $bd62cce5b1bbf31a$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $c9df34e85cd32650$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $fa8ac62bccab8125$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $fa8ac62bccab8125$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $c01a1f9a5a9bf0fc$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $fa201ff5ea5e194a$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $d5f21f79e1b7a778$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $16afd4c860037c35$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $16afd4c860037c35$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $9cc36753468ae69d$var$knownAdapters = {
    http: (0, $e854f8a669d92959$export$2e2bcd8739ae039),
    xhr: (0, $fa8ac62bccab8125$export$2e2bcd8739ae039)
};
(0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach($9cc36753468ae69d$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $9cc36753468ae69d$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length  } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isString(nameOrAdapter) ? $9cc36753468ae69d$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $16afd4c860037c35$export$2e2bcd8739ae039)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $62060544f16d0aa4$export$2e2bcd8739ae039).hasOwnProp($9cc36753468ae69d$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $9cc36753468ae69d$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $3b8201b710bbf267$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $c01a1f9a5a9bf0fc$export$2e2bcd8739ae039)(null, config);
}
function $3b8201b710bbf267$export$2e2bcd8739ae039(config) {
    $3b8201b710bbf267$var$throwIfCancellationRequested(config);
    config.headers = (0, $1cf3d961d96dea92$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $a41e733ab387fdc0$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $9cc36753468ae69d$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $92850945f03943d4$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $3b8201b710bbf267$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $a41e733ab387fdc0$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $1cf3d961d96dea92$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $361432ab6de1c230$export$2e2bcd8739ae039)(reason)) {
            $3b8201b710bbf267$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $a41e733ab387fdc0$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $1cf3d961d96dea92$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $680c9b270e1309ca$var$headersToObject = (thing)=>thing instanceof (0, $1cf3d961d96dea92$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $680c9b270e1309ca$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isPlainObject(target) && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $62060544f16d0aa4$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $62060544f16d0aa4$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($680c9b270e1309ca$var$headersToObject(a), $680c9b270e1309ca$var$headersToObject(b), true)
    };
    (0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $0b149db051caff15$export$a4ad2735b021c132 = "1.3.5";



"use strict";
const $f15121879607fc10$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $f15121879607fc10$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $f15121879607fc10$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $f15121879607fc10$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $0b149db051caff15$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $16afd4c860037c35$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $16afd4c860037c35$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$f15121879607fc10$var$deprecatedWarnings[opt]) {
            $f15121879607fc10$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $f15121879607fc10$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $16afd4c860037c35$export$2e2bcd8739ae039)("options must be an object", (0, $16afd4c860037c35$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $16afd4c860037c35$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $16afd4c860037c35$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $16afd4c860037c35$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $16afd4c860037c35$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $f15121879607fc10$export$2e2bcd8739ae039 = {
    assertOptions: $f15121879607fc10$var$assertOptions,
    validators: $f15121879607fc10$var$validators
};



"use strict";
const $1b26f3ec0611b662$var$validators = (0, $f15121879607fc10$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $1b26f3ec0611b662$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $3a62da52e7b1f205$export$2e2bcd8739ae039)(),
            response: new (0, $3a62da52e7b1f205$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $680c9b270e1309ca$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional , paramsSerializer: paramsSerializer , headers: headers  } = config;
        if (transitional !== undefined) (0, $f15121879607fc10$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $1b26f3ec0611b662$var$validators.transitional($1b26f3ec0611b662$var$validators.boolean),
            forcedJSONParsing: $1b26f3ec0611b662$var$validators.transitional($1b26f3ec0611b662$var$validators.boolean),
            clarifyTimeoutError: $1b26f3ec0611b662$var$validators.transitional($1b26f3ec0611b662$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $f15121879607fc10$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $1b26f3ec0611b662$var$validators.function,
                serialize: $1b26f3ec0611b662$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        let contextHeaders;
        // Flatten headers
        contextHeaders = headers && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        contextHeaders && (0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $1cf3d961d96dea92$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $3b8201b710bbf267$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $3b8201b710bbf267$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $680c9b270e1309ca$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $131b93a27bc19dbc$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $1cdd8b97a4bdad9e$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $1b26f3ec0611b662$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $680c9b270e1309ca$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $62060544f16d0aa4$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $680c9b270e1309ca$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $1b26f3ec0611b662$var$Axios.prototype[method] = generateHTTPMethod();
    $1b26f3ec0611b662$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $1b26f3ec0611b662$export$2e2bcd8739ae039 = $1b26f3ec0611b662$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $beadb62019c80283$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $c01a1f9a5a9bf0fc$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $beadb62019c80283$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $beadb62019c80283$export$2e2bcd8739ae039 = $beadb62019c80283$var$CancelToken;






"use strict";
function $cff3f330ca475695$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $26512057fa981694$export$2e2bcd8739ae039(payload) {
    return (0, $62060544f16d0aa4$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}



const $2aef145eaa80aa5c$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($2aef145eaa80aa5c$var$HttpStatusCode).forEach(([key, value])=>{
    $2aef145eaa80aa5c$var$HttpStatusCode[value] = key;
});
var $2aef145eaa80aa5c$export$2e2bcd8739ae039 = $2aef145eaa80aa5c$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $21ab6d98ff555ccc$var$createInstance(defaultConfig) {
    const context = new (0, $1b26f3ec0611b662$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $d4edf5ffb938168b$export$2e2bcd8739ae039)((0, $1b26f3ec0611b662$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $62060544f16d0aa4$export$2e2bcd8739ae039).extend(instance, (0, $1b26f3ec0611b662$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $62060544f16d0aa4$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $21ab6d98ff555ccc$var$createInstance((0, $680c9b270e1309ca$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $21ab6d98ff555ccc$var$axios = $21ab6d98ff555ccc$var$createInstance((0, $92850945f03943d4$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$21ab6d98ff555ccc$var$axios.Axios = (0, $1b26f3ec0611b662$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$21ab6d98ff555ccc$var$axios.CanceledError = (0, $c01a1f9a5a9bf0fc$export$2e2bcd8739ae039);
$21ab6d98ff555ccc$var$axios.CancelToken = (0, $beadb62019c80283$export$2e2bcd8739ae039);
$21ab6d98ff555ccc$var$axios.isCancel = (0, $361432ab6de1c230$export$2e2bcd8739ae039);
$21ab6d98ff555ccc$var$axios.VERSION = (0, $0b149db051caff15$export$a4ad2735b021c132);
$21ab6d98ff555ccc$var$axios.toFormData = (0, $ac87e3667a6b92ca$export$2e2bcd8739ae039);
// Expose AxiosError class
$21ab6d98ff555ccc$var$axios.AxiosError = (0, $16afd4c860037c35$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$21ab6d98ff555ccc$var$axios.Cancel = $21ab6d98ff555ccc$var$axios.CanceledError;
// Expose all/spread
$21ab6d98ff555ccc$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$21ab6d98ff555ccc$var$axios.spread = (0, $cff3f330ca475695$export$2e2bcd8739ae039);
// Expose isAxiosError
$21ab6d98ff555ccc$var$axios.isAxiosError = (0, $26512057fa981694$export$2e2bcd8739ae039);
// Expose mergeConfig
$21ab6d98ff555ccc$var$axios.mergeConfig = (0, $680c9b270e1309ca$export$2e2bcd8739ae039);
$21ab6d98ff555ccc$var$axios.AxiosHeaders = (0, $1cf3d961d96dea92$export$2e2bcd8739ae039);
$21ab6d98ff555ccc$var$axios.formToJSON = (thing)=>(0, $c60e9f460b5f4b3c$export$2e2bcd8739ae039)((0, $62060544f16d0aa4$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$21ab6d98ff555ccc$var$axios.HttpStatusCode = (0, $2aef145eaa80aa5c$export$2e2bcd8739ae039);
$21ab6d98ff555ccc$var$axios.default = $21ab6d98ff555ccc$var$axios;
var // this module should only have a default export
$21ab6d98ff555ccc$export$2e2bcd8739ae039 = $21ab6d98ff555ccc$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $cece9be405597c53$export$1c00760e9e5a4e95 , AxiosError: $cece9be405597c53$export$c1fbed17c2f6a328 , CanceledError: $cece9be405597c53$export$1ab0c6b20d94fa14 , isCancel: $cece9be405597c53$export$3b22524397b493c6 , CancelToken: $cece9be405597c53$export$fd08e3cb425f0d61 , VERSION: $cece9be405597c53$export$a4ad2735b021c132 , all: $cece9be405597c53$export$84bf76cd7afc7469 , Cancel: $cece9be405597c53$export$848c9b7ead0df967 , isAxiosError: $cece9be405597c53$export$fbafdbe06a5b5a9a , spread: $cece9be405597c53$export$3ae0fd4797ed47c8 , toFormData: $cece9be405597c53$export$10ae0d317ea97f8b , AxiosHeaders: $cece9be405597c53$export$4e7d6ff0f3e6520 , HttpStatusCode: $cece9be405597c53$export$a972f69c851492b3 , formToJSON: $cece9be405597c53$export$86d7c59254d6a2c9 , mergeConfig: $cece9be405597c53$export$7ec1ebcfa9d8bd6a  } = (0, $21ab6d98ff555ccc$export$2e2bcd8739ae039);



var $4lkrv = parcelRequire("4lkrv");

const $9f35c1aee77f93aa$var$useWebsiteApi = ()=>{
    const { baseUrl: baseUrl  } = (0, $4lkrv.useContext)((0, $e2f0b13a8b8b1035$export$e9e34775259af03f));
    const fetcher = (path)=>fetch(baseUrl + path).then((res)=>res.json());
    return {
        fetcher: fetcher,
        quote: async (params)=>{
            return await fetcher(`/v4/calc?${params.toString()}`);
        },
        getCart: async (cartId)=>{
            const resp = await fetch(`${baseUrl}/v4/cart/${cartId}/shopify`);
            return await resp.json();
        },
        removeFromCart: async (cartId, cartItemId)=>{
            const resp = await fetch(`${baseUrl}/v4/cart/${cartId}/items/${cartItemId}`, {
                method: "DELETE"
            });
            return await resp.json();
        },
        retrieveOrders: async (email, orderNumber, storeHash)=>{
            const params = new URLSearchParams();
            params.set("email", email);
            params.set("orderNumber", orderNumber);
            params.set("storeHash", storeHash);
            return await fetcher(`/v4/reorder?${params.toString()}`);
        },
        uploadArtwork: (f, onUploadProgress)=>{
            const form = new FormData();
            form.set("file", f);
            return (0, $21ab6d98ff555ccc$export$2e2bcd8739ae039).postForm(baseUrl + "/v1/media", form, {
                onUploadProgress: onUploadProgress
            }).then((resp)=>{
                return {
                    ...resp.data,
                    src: baseUrl + resp.data.src
                };
            });
        },
        createProject: async (templateCode)=>{
            const params = new URLSearchParams();
            params.set("code", templateCode);
            return await fetch(`https://graphic.stickerit.co/api/create?${params.toString()}`).then((res)=>res.json());
        }
    };
};
var $9f35c1aee77f93aa$export$2e2bcd8739ae039 = $9f35c1aee77f93aa$var$useWebsiteApi;


const $d717c651d716ec6b$export$38e79abb03ea76a8 = (allMaterials, design, showPricesIncTax, materialsOpen = false)=>{
    const { currencyCode: currencyCode , shipToCountryCode: shipToCountryCode , locale: locale  } = (0, $4lkrv.useContext)((0, $e2f0b13a8b8b1035$export$e9e34775259af03f));
    const [otherMaterialCosts, setOtherMaterialCosts] = (0, $4lkrv.useState)({});
    const websiteApi = (0, $9f35c1aee77f93aa$export$2e2bcd8739ae039)();
    (0, $4lkrv.useEffect)(()=>{
        if (!materialsOpen) return;
        allMaterials.map(({ sku: mSku  })=>{
            if (!mSku) return;
            if (mSku === design.materialSku) {
                setOtherMaterialCosts((prev)=>{
                    return {
                        ...prev,
                        [mSku]: undefined
                    };
                });
                return;
            }
            const params = new URLSearchParams();
            params.set("w", design.width.toString());
            params.set("h", design.height.toString());
            params.set("quantity", design.quantity.toString());
            params.set("u", design.unit);
            params.set("productSku", design.productSku);
            params.set("materialSku", mSku);
            params.set("currencyCode", currencyCode);
            params.set("shipToCountryCode", shipToCountryCode);
            params.set("languageCode", locale);
            websiteApi.quote(params).then((quote)=>{
                if (quote) setOtherMaterialCosts((prev)=>{
                    return {
                        ...prev,
                        [mSku]: {
                            price: showPricesIncTax ? quote.priceIncTax : quote.priceExTax,
                            currencyCode: quote.currencyCode
                        }
                    };
                });
                else setOtherMaterialCosts((prev)=>{
                    return {
                        ...prev,
                        [design.materialSku]: undefined
                    };
                });
            });
        });
    }, [
        materialsOpen,
        design,
        allMaterials,
        showPricesIncTax
    ]);
    return {
        otherMaterialCosts: otherMaterialCosts
    };
};


var $64b0978063c5d8f4$exports = {};
"use strict";

Object.defineProperty($64b0978063c5d8f4$exports, "__esModule", {
    value: true
});
$64b0978063c5d8f4$exports.default = void 0;

var $64b0978063c5d8f4$var$_createSvgIcon = $95a1a4123f33e1f5$exports((parcelRequire("irtyR")));

var $gWMia = parcelRequire("gWMia");
var $64b0978063c5d8f4$var$_default = (0, $64b0978063c5d8f4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $gWMia.jsx)("path", {
    d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), "Star");
$64b0978063c5d8f4$exports.default = $64b0978063c5d8f4$var$_default;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");


var $kdLbD = parcelRequire("kdLbD");

var $kFXNp = parcelRequire("kFXNp");

var $bgnZl = parcelRequire("bgnZl");


var $at7OG = parcelRequire("at7OG");

var $lJkvk = parcelRequire("lJkvk");


var $9YD4s = parcelRequire("9YD4s");

var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");

function $4d0e337a7078a55a$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $8b58baa35190fbc6$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $8b58baa35190fbc6$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $8b58baa35190fbc6$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $b8696baead778479$export$8960430cfd85939f = Math.max;
var $b8696baead778479$export$96ec731ed4dcb222 = Math.min;
var $b8696baead778479$export$2077e0241d6afd3c = Math.round;



function $9990575f26d59609$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $c9147bb9628e9936$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9990575f26d59609$export$2e2bcd8739ae039)());
}


function $edd64eb49dfdce55$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $b8696baead778479$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $b8696baead778479$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $8b58baa35190fbc6$export$45a5e7f76e0caa8d)(element) ? (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $c9147bb9628e9936$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $b5f19f6aa88c524c$export$2e2bcd8739ae039(node) {
    var win = (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $19767cf73f1c3484$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $94a606953cd85762$export$2e2bcd8739ae039(node) {
    if (node === (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(node) || !(0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(node)) return (0, $b5f19f6aa88c524c$export$2e2bcd8739ae039)(node);
    else return (0, $19767cf73f1c3484$export$2e2bcd8739ae039)(node);
}


function $9a459e1b7ae86d08$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $4fe7cd4cd0bd7696$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $8b58baa35190fbc6$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $212ff1ee14c69768$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $edd64eb49dfdce55$export$2e2bcd8739ae039)((0, $4fe7cd4cd0bd7696$export$2e2bcd8739ae039)(element)).left + (0, $b5f19f6aa88c524c$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $b6a6d53bc1c31772$export$2e2bcd8739ae039(element) {
    return (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $40c6dc6f77e53f7c$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $b6a6d53bc1c31772$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $4d4e1f5de0054402$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $b8696baead778479$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $b8696baead778479$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $4d4e1f5de0054402$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(offsetParent) && $4d4e1f5de0054402$var$isElementScaled(offsetParent);
    var documentElement = (0, $4fe7cd4cd0bd7696$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $edd64eb49dfdce55$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9a459e1b7ae86d08$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $40c6dc6f77e53f7c$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $94a606953cd85762$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $edd64eb49dfdce55$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $212ff1ee14c69768$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $52948678094e1805$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $edd64eb49dfdce55$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $1da7972da07fba50$export$2e2bcd8739ae039(element) {
    if ((0, $9a459e1b7ae86d08$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $8b58baa35190fbc6$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $4fe7cd4cd0bd7696$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $ae1ae6d8ad62cbdb$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $9a459e1b7ae86d08$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(node) && (0, $40c6dc6f77e53f7c$export$2e2bcd8739ae039)(node)) return node;
    return $ae1ae6d8ad62cbdb$export$2e2bcd8739ae039((0, $1da7972da07fba50$export$2e2bcd8739ae039)(node));
}





function $9133e135d4be554f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ae1ae6d8ad62cbdb$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $40c6dc6f77e53f7c$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($9133e135d4be554f$export$2e2bcd8739ae039((0, $1da7972da07fba50$export$2e2bcd8739ae039)(target)));
}







function $eba897732b7bedff$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $9a459e1b7ae86d08$export$2e2bcd8739ae039)(element)) >= 0;
}




function $14e8172e4746edd2$var$getTrueOffsetParent(element) {
    if (!(0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $b6a6d53bc1c31772$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $14e8172e4746edd2$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9990575f26d59609$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9990575f26d59609$export$2e2bcd8739ae039)());
    if (isIE && (0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $b6a6d53bc1c31772$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $1da7972da07fba50$export$2e2bcd8739ae039)(element);
    if ((0, $8b58baa35190fbc6$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $9a459e1b7ae86d08$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $b6a6d53bc1c31772$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $14e8172e4746edd2$export$2e2bcd8739ae039(element) {
    var window = (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(element);
    var offsetParent = $14e8172e4746edd2$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $eba897732b7bedff$export$2e2bcd8739ae039)(offsetParent) && (0, $b6a6d53bc1c31772$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $14e8172e4746edd2$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $9a459e1b7ae86d08$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $9a459e1b7ae86d08$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $b6a6d53bc1c31772$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $14e8172e4746edd2$var$getContainingBlock(element) || window;
}



var $8f4b51d0a8061e59$export$1e95b668f3b82d = "top";
var $8f4b51d0a8061e59$export$40e543e69a8b3fbb = "bottom";
var $8f4b51d0a8061e59$export$79ffe56a765070d2 = "right";
var $8f4b51d0a8061e59$export$eabcd2c8791e7bf4 = "left";
var $8f4b51d0a8061e59$export$dfb5619354ba860 = "auto";
var $8f4b51d0a8061e59$export$aec2ce47c367b8c3 = [
    $8f4b51d0a8061e59$export$1e95b668f3b82d,
    $8f4b51d0a8061e59$export$40e543e69a8b3fbb,
    $8f4b51d0a8061e59$export$79ffe56a765070d2,
    $8f4b51d0a8061e59$export$eabcd2c8791e7bf4
];
var $8f4b51d0a8061e59$export$b3571188c770cc5a = "start";
var $8f4b51d0a8061e59$export$bd5df0f255a350f8 = "end";
var $8f4b51d0a8061e59$export$390fd549c5303b4d = "clippingParents";
var $8f4b51d0a8061e59$export$d7b7311ec04a3e8f = "viewport";
var $8f4b51d0a8061e59$export$ae5ab1c730825774 = "popper";
var $8f4b51d0a8061e59$export$ca50aac9f3ba507f = "reference";
var $8f4b51d0a8061e59$export$368f9a87e87fa4e1 = /*#__PURE__*/ $8f4b51d0a8061e59$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $8f4b51d0a8061e59$export$b3571188c770cc5a,
        placement + "-" + $8f4b51d0a8061e59$export$bd5df0f255a350f8
    ]);
}, []);
var $8f4b51d0a8061e59$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($8f4b51d0a8061e59$export$aec2ce47c367b8c3, [
    $8f4b51d0a8061e59$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $8f4b51d0a8061e59$export$b3571188c770cc5a,
        placement + "-" + $8f4b51d0a8061e59$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $8f4b51d0a8061e59$export$421679a7c3d56e = "beforeRead";
var $8f4b51d0a8061e59$export$aafa59e2e03f2942 = "read";
var $8f4b51d0a8061e59$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $8f4b51d0a8061e59$export$c65e99957a05207c = "beforeMain";
var $8f4b51d0a8061e59$export$f22da7240b7add18 = "main";
var $8f4b51d0a8061e59$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $8f4b51d0a8061e59$export$8d4d2d70e7d46032 = "beforeWrite";
var $8f4b51d0a8061e59$export$68d8715fc104d294 = "write";
var $8f4b51d0a8061e59$export$70a6e5159acce2e6 = "afterWrite";
var $8f4b51d0a8061e59$export$d087d3878fdf71d5 = [
    $8f4b51d0a8061e59$export$421679a7c3d56e,
    $8f4b51d0a8061e59$export$aafa59e2e03f2942,
    $8f4b51d0a8061e59$export$6964f6c886723980,
    $8f4b51d0a8061e59$export$c65e99957a05207c,
    $8f4b51d0a8061e59$export$f22da7240b7add18,
    $8f4b51d0a8061e59$export$bab79516f2d662fe,
    $8f4b51d0a8061e59$export$8d4d2d70e7d46032,
    $8f4b51d0a8061e59$export$68d8715fc104d294,
    $8f4b51d0a8061e59$export$70a6e5159acce2e6
];


function $fe1c96b2f215f8fe$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $fe1c96b2f215f8fe$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $fe1c96b2f215f8fe$var$order(modifiers); // order based on phase
    return (0, $8f4b51d0a8061e59$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $addb998dd2d3c67f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $006e4dca1e84e5a9$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $11548eec001f316b$var$INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var $11548eec001f316b$var$INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var $11548eec001f316b$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $11548eec001f316b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $11548eec001f316b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $11548eec001f316b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $11548eec001f316b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $8b58baa35190fbc6$export$45a5e7f76e0caa8d)(reference) ? (0, $9133e135d4be554f$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $9133e135d4be554f$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $9133e135d4be554f$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $fe1c96b2f215f8fe$export$2e2bcd8739ae039)((0, $006e4dca1e84e5a9$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$11548eec001f316b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4d4e1f5de0054402$export$2e2bcd8739ae039)(reference, (0, $14e8172e4746edd2$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $52948678094e1805$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $addb998dd2d3c67f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$11548eec001f316b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $11548eec001f316b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $11548eec001f316b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $9d54290ef7562ac9$var$passive = {
    passive: true
};
function $9d54290ef7562ac9$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $9d54290ef7562ac9$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $9d54290ef7562ac9$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $9d54290ef7562ac9$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $9d54290ef7562ac9$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $9d54290ef7562ac9$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $9d54290ef7562ac9$var$effect,
    data: {}
};



function $78c0cf51d6ae20a5$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $9df536deeb0ba61e$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $ee6baf843ede9c87$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $4e393879c1799c73$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $78c0cf51d6ae20a5$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $9df536deeb0ba61e$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $8f4b51d0a8061e59$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $8f4b51d0a8061e59$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ee6baf843ede9c87$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $8f4b51d0a8061e59$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $8f4b51d0a8061e59$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $17813820adc25f90$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4e393879c1799c73$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $17813820adc25f90$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $17813820adc25f90$var$popperOffsets,
    data: {}
};










var $7ee748f020f72b86$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $7ee748f020f72b86$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $b8696baead778479$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $b8696baead778479$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $7ee748f020f72b86$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4);
    var sideY = (0, $8f4b51d0a8061e59$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $14e8172e4746edd2$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $4fe7cd4cd0bd7696$export$2e2bcd8739ae039)(popper);
            if ((0, $b6a6d53bc1c31772$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $8f4b51d0a8061e59$export$1e95b668f3b82d) || (placement === (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4) || placement === (0, $8f4b51d0a8061e59$export$79ffe56a765070d2)) && variation === (0, $8f4b51d0a8061e59$export$bd5df0f255a350f8)) {
            sideY = (0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4) || (placement === (0, $8f4b51d0a8061e59$export$1e95b668f3b82d) || placement === (0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb)) && variation === (0, $8f4b51d0a8061e59$export$bd5df0f255a350f8)) {
            sideX = (0, $8f4b51d0a8061e59$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $7ee748f020f72b86$var$unsetSides);
    var _ref4 = roundOffsets === true ? $7ee748f020f72b86$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $7ee748f020f72b86$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $78c0cf51d6ae20a5$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $9df536deeb0ba61e$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $7ee748f020f72b86$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $7ee748f020f72b86$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $7ee748f020f72b86$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $7ee748f020f72b86$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $3c8254cf92d71344$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(element) || !(0, $9a459e1b7ae86d08$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $3c8254cf92d71344$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(element) || !(0, $9a459e1b7ae86d08$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $3c8254cf92d71344$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $3c8254cf92d71344$var$applyStyles,
    effect: $3c8254cf92d71344$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $316a97a10f46a4e0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $78c0cf51d6ae20a5$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4),
        (0, $8f4b51d0a8061e59$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4),
        (0, $8f4b51d0a8061e59$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $316a97a10f46a4e0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $8f4b51d0a8061e59$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $316a97a10f46a4e0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $316a97a10f46a4e0$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $316a97a10f46a4e0$var$offset
};


var $09b4c236f0754fa1$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $09b4c236f0754fa1$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $09b4c236f0754fa1$var$hash[matched];
    });
}



var $eb8d3a590a2c5962$var$hash = {
    start: "end",
    end: "start"
};
function $eb8d3a590a2c5962$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $eb8d3a590a2c5962$var$hash[matched];
    });
}







function $d23c41a322770563$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $4d0e337a7078a55a$export$2e2bcd8739ae039)(element);
    var html = (0, $4fe7cd4cd0bd7696$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $c9147bb9628e9936$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $212ff1ee14c69768$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $5c2a4c33c4e76a13$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $4fe7cd4cd0bd7696$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $b5f19f6aa88c524c$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $b8696baead778479$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $b8696baead778479$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $212ff1ee14c69768$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $b6a6d53bc1c31772$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $b8696baead778479$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $0512e45ba67db4a6$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $8b58baa35190fbc6$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $aadc20f3a4f85e25$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $6134f8f64be41187$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $edd64eb49dfdce55$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $6134f8f64be41187$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $8f4b51d0a8061e59$export$d7b7311ec04a3e8f) ? (0, $aadc20f3a4f85e25$export$2e2bcd8739ae039)((0, $d23c41a322770563$export$2e2bcd8739ae039)(element, strategy)) : (0, $8b58baa35190fbc6$export$45a5e7f76e0caa8d)(clippingParent) ? $6134f8f64be41187$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $aadc20f3a4f85e25$export$2e2bcd8739ae039)((0, $5c2a4c33c4e76a13$export$2e2bcd8739ae039)((0, $4fe7cd4cd0bd7696$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $6134f8f64be41187$var$getClippingParents(element) {
    var clippingParents = (0, $9133e135d4be554f$export$2e2bcd8739ae039)((0, $1da7972da07fba50$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $b6a6d53bc1c31772$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $8b58baa35190fbc6$export$1b3bfaa9684536aa)(element) ? (0, $14e8172e4746edd2$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $8b58baa35190fbc6$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $8b58baa35190fbc6$export$45a5e7f76e0caa8d)(clippingParent) && (0, $0512e45ba67db4a6$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $9a459e1b7ae86d08$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $6134f8f64be41187$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $6134f8f64be41187$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $6134f8f64be41187$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $b8696baead778479$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $b8696baead778479$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $b8696baead778479$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $b8696baead778479$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $6134f8f64be41187$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $a138a34a2273169d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $9cdf1abde75e9a82$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $a138a34a2273169d$export$2e2bcd8739ae039)(), paddingObject);
}


function $7086013afd6b1f82$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $8eb1bedfacaf32cb$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $8f4b51d0a8061e59$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $8f4b51d0a8061e59$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $8f4b51d0a8061e59$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $9cdf1abde75e9a82$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $7086013afd6b1f82$export$2e2bcd8739ae039)(padding, (0, $8f4b51d0a8061e59$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $8f4b51d0a8061e59$export$ae5ab1c730825774) ? (0, $8f4b51d0a8061e59$export$ca50aac9f3ba507f) : (0, $8f4b51d0a8061e59$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $6134f8f64be41187$export$2e2bcd8739ae039)((0, $8b58baa35190fbc6$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $4fe7cd4cd0bd7696$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $edd64eb49dfdce55$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4e393879c1799c73$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $aadc20f3a4f85e25$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $8f4b51d0a8061e59$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $8f4b51d0a8061e59$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $8f4b51d0a8061e59$export$79ffe56a765070d2),
                (0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $8f4b51d0a8061e59$export$1e95b668f3b82d),
                (0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $b74ae9d36cb93137$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $8f4b51d0a8061e59$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $9df536deeb0ba61e$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $8f4b51d0a8061e59$export$368f9a87e87fa4e1) : (0, $8f4b51d0a8061e59$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $9df536deeb0ba61e$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $8f4b51d0a8061e59$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $8eb1bedfacaf32cb$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $78c0cf51d6ae20a5$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $85282375aec33b69$var$getExpandedFallbackPlacements(placement) {
    if ((0, $78c0cf51d6ae20a5$export$2e2bcd8739ae039)(placement) === (0, $8f4b51d0a8061e59$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $09b4c236f0754fa1$export$2e2bcd8739ae039)(placement);
    return [
        (0, $eb8d3a590a2c5962$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $eb8d3a590a2c5962$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $85282375aec33b69$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $78c0cf51d6ae20a5$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $09b4c236f0754fa1$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $85282375aec33b69$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $78c0cf51d6ae20a5$export$2e2bcd8739ae039)(placement) === (0, $8f4b51d0a8061e59$export$dfb5619354ba860) ? (0, $b74ae9d36cb93137$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $78c0cf51d6ae20a5$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $9df536deeb0ba61e$export$2e2bcd8739ae039)(placement) === (0, $8f4b51d0a8061e59$export$b3571188c770cc5a);
        var isVertical = [
            (0, $8f4b51d0a8061e59$export$1e95b668f3b82d),
            (0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $8eb1bedfacaf32cb$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $8f4b51d0a8061e59$export$79ffe56a765070d2) : (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb) : (0, $8f4b51d0a8061e59$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $09b4c236f0754fa1$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $09b4c236f0754fa1$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $85282375aec33b69$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $85282375aec33b69$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $de165c944335cf6f$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $4692e69d4cc53920$export$f28d906d67a997f3(min, value, max) {
    return (0, $b8696baead778479$export$8960430cfd85939f)(min, (0, $b8696baead778479$export$96ec731ed4dcb222)(value, max));
}
function $4692e69d4cc53920$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4692e69d4cc53920$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $105090926ca1a85e$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $8eb1bedfacaf32cb$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $78c0cf51d6ae20a5$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $9df536deeb0ba61e$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ee6baf843ede9c87$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $de165c944335cf6f$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $8f4b51d0a8061e59$export$1e95b668f3b82d) : (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb) : (0, $8f4b51d0a8061e59$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $8f4b51d0a8061e59$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $8f4b51d0a8061e59$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $52948678094e1805$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $a138a34a2273169d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4692e69d4cc53920$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $14e8172e4746edd2$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4692e69d4cc53920$export$f28d906d67a997f3)(tether ? (0, $b8696baead778479$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $b8696baead778479$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $8f4b51d0a8061e59$export$1e95b668f3b82d) : (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb) : (0, $8f4b51d0a8061e59$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $8f4b51d0a8061e59$export$1e95b668f3b82d),
            (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4692e69d4cc53920$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4692e69d4cc53920$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $105090926ca1a85e$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $105090926ca1a85e$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};












var $7ab0bf28b9b5c4a3$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $9cdf1abde75e9a82$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $7086013afd6b1f82$export$2e2bcd8739ae039)(padding, (0, $8f4b51d0a8061e59$export$aec2ce47c367b8c3)));
};
function $7ab0bf28b9b5c4a3$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $78c0cf51d6ae20a5$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ee6baf843ede9c87$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4),
        (0, $8f4b51d0a8061e59$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $7ab0bf28b9b5c4a3$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $52948678094e1805$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $8f4b51d0a8061e59$export$1e95b668f3b82d) : (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb) : (0, $8f4b51d0a8061e59$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $14e8172e4746edd2$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4692e69d4cc53920$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $7ab0bf28b9b5c4a3$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $0512e45ba67db4a6$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $7ab0bf28b9b5c4a3$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $7ab0bf28b9b5c4a3$var$arrow,
    effect: $7ab0bf28b9b5c4a3$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $99a62bd9725975d2$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $99a62bd9725975d2$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $8f4b51d0a8061e59$export$1e95b668f3b82d),
        (0, $8f4b51d0a8061e59$export$79ffe56a765070d2),
        (0, $8f4b51d0a8061e59$export$40e543e69a8b3fbb),
        (0, $8f4b51d0a8061e59$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $99a62bd9725975d2$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $8eb1bedfacaf32cb$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $8eb1bedfacaf32cb$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $99a62bd9725975d2$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $99a62bd9725975d2$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $99a62bd9725975d2$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $99a62bd9725975d2$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $99a62bd9725975d2$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $99a62bd9725975d2$var$hide
};




var $cbbabf321399ac88$export$d34966752335dd47 = [
    (0, $9d54290ef7562ac9$export$2e2bcd8739ae039),
    (0, $17813820adc25f90$export$2e2bcd8739ae039),
    (0, $7ee748f020f72b86$export$2e2bcd8739ae039),
    (0, $3c8254cf92d71344$export$2e2bcd8739ae039),
    (0, $316a97a10f46a4e0$export$2e2bcd8739ae039),
    (0, $85282375aec33b69$export$2e2bcd8739ae039),
    (0, $105090926ca1a85e$export$2e2bcd8739ae039),
    (0, $7ab0bf28b9b5c4a3$export$2e2bcd8739ae039),
    (0, $99a62bd9725975d2$export$2e2bcd8739ae039)
];
var $cbbabf321399ac88$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $11548eec001f316b$export$ed5e13716264f202)({
    defaultModifiers: $cbbabf321399ac88$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $kdLbD = parcelRequire("kdLbD");


var $1HGD7 = parcelRequire("1HGD7");

var $3TIMy = parcelRequire("3TIMy");
function $017a7a8b74ff4120$export$b4312079ad514ba0(slot) {
    return (0, $1HGD7.default)("MuiPopperUnstyled", slot);
}
const $017a7a8b74ff4120$var$popperUnstyledClasses = (0, $3TIMy.default)("MuiPopperUnstyled", [
    "root"
]);
var $017a7a8b74ff4120$export$2e2bcd8739ae039 = $017a7a8b74ff4120$var$popperUnstyledClasses;




var $gWMia = parcelRequire("gWMia");
const $85a67bef82dae34b$var$_excluded = [
    "anchorEl",
    "children",
    "component",
    "components",
    "componentsProps",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "ownerState",
    "placement",
    "popperOptions",
    "popperRef",
    "TransitionProps"
], $85a67bef82dae34b$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition"
];
function $85a67bef82dae34b$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $85a67bef82dae34b$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $85a67bef82dae34b$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $017a7a8b74ff4120$export$b4312079ad514ba0), {});
};
const $85a67bef82dae34b$var$defaultPopperOptions = {};
/* eslint-disable react/prop-types */ const $85a67bef82dae34b$var$PopperTooltip = /*#__PURE__*/ $4lkrv.forwardRef(function PopperTooltip(props, ref) {
    var _ref;
    const { anchorEl: anchorEl , children: children , component: component , components: components = {} , componentsProps: componentsProps = {} , direction: direction , disablePortal: disablePortal , modifiers: modifiers , open: open , ownerState: ownerState , placement: initialPlacement , popperOptions: popperOptions , popperRef: popperRefProp , TransitionProps: TransitionProps  } = props, other = (0, $eLWn9.default)(props, $85a67bef82dae34b$var$_excluded);
    const tooltipRef = $4lkrv.useRef(null);
    const ownRef = (0, $28e34e368be50325$export$2e2bcd8739ae039)(tooltipRef, ref);
    const popperRef = $4lkrv.useRef(null);
    const handlePopperRef = (0, $28e34e368be50325$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $4lkrv.useRef(handlePopperRef);
    (0, $436de094adc3733f$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $4lkrv.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $85a67bef82dae34b$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $4lkrv.useState(rtlPlacement);
    $4lkrv.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    (0, $436de094adc3733f$export$2e2bcd8739ae039)(()=>{
        if (!anchorEl || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        const resolvedAnchorEl = $85a67bef82dae34b$var$resolveAnchorEl(anchorEl);
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state  })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $cbbabf321399ac88$export$8f7491d57c8f97a9)($85a67bef82dae34b$var$resolveAnchorEl(anchorEl), tooltipRef.current, (0, $9YD4s.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        anchorEl,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $85a67bef82dae34b$var$useUtilityClasses();
    const Root = (_ref = component != null ? component : components.Root) != null ? _ref : "div";
    const rootProps = (0, $c8743838c402a3b4$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: componentsProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: (0, $9YD4s.default)({}, props, ownerState),
        className: classes.root
    });
    return /*#__PURE__*/ (0, $gWMia.jsx)(Root, (0, $9YD4s.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/* eslint-enable react/prop-types */ /**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 */ const $85a67bef82dae34b$var$PopperUnstyled = /*#__PURE__*/ $4lkrv.forwardRef(function PopperUnstyled(props, ref) {
    const { anchorEl: anchorEl , children: children , container: containerProp , direction: direction = "ltr" , disablePortal: disablePortal = false , keepMounted: keepMounted = false , modifiers: modifiers , open: open , placement: placement = "bottom" , popperOptions: popperOptions = $85a67bef82dae34b$var$defaultPopperOptions , popperRef: popperRef , style: style , transition: transition = false  } = props, other = (0, $eLWn9.default)(props, $85a67bef82dae34b$var$_excluded2);
    const [exited, setExited] = $4lkrv.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $52fb10e34f656fe7$export$2e2bcd8739ae039)($85a67bef82dae34b$var$resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $a860ed493a65e637$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $gWMia.jsx)($85a67bef82dae34b$var$PopperTooltip, (0, $9YD4s.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: ref,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef
        }, other, {
            style: (0, $9YD4s.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: !open && keepMounted && (!transition || exited) ? "none" : null
            }, style),
            TransitionProps: transition ? {
                in: open,
                onEnter: handleEnter,
                onExited: handleExited
            } : null,
            children: children
        }))
    });
});
var $85a67bef82dae34b$export$2e2bcd8739ae039 = $85a67bef82dae34b$var$PopperUnstyled;



var $idqiR = parcelRequire("idqiR");



var $4lkrv = parcelRequire("4lkrv");

var $bgnZl = parcelRequire("bgnZl");
var $at7OG = parcelRequire("at7OG");

var $gWMia = parcelRequire("gWMia");
const $170d459912f1fdc9$var$PopperRoot = (0, $bgnZl.default)((0, $85a67bef82dae34b$export$2e2bcd8739ae039), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $170d459912f1fdc9$var$Popper = /*#__PURE__*/ $4lkrv.forwardRef(function Popper(inProps, ref) {
    const theme = (0, $idqiR.default)();
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiPopper"
    });
    return /*#__PURE__*/ (0, $gWMia.jsx)($170d459912f1fdc9$var$PopperRoot, (0, $9YD4s.default)({
        direction: theme == null ? void 0 : theme.direction
    }, props, {
        ref: ref
    }));
});
var $170d459912f1fdc9$export$2e2bcd8739ae039 = $170d459912f1fdc9$var$Popper;








var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $85b42f771dca94f9$export$837848f5f6cee923(slot) {
    return (0, $1HGD7.default)("MuiTooltip", slot);
}
const $85b42f771dca94f9$var$tooltipClasses = (0, $3TIMy.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $85b42f771dca94f9$export$2e2bcd8739ae039 = $85b42f771dca94f9$var$tooltipClasses;



var $gWMia = parcelRequire("gWMia");
const $a02a42c2a8820b60$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $a02a42c2a8820b60$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $a02a42c2a8820b60$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableInteractive: disableInteractive , arrow: arrow , touch: touch , placement: placement  } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $lJkvk.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $85b42f771dca94f9$export$837848f5f6cee923), classes);
};
const $a02a42c2a8820b60$var$TooltipPopper = (0, $bgnZl.default)((0, $170d459912f1fdc9$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme , ownerState: ownerState , open: open  })=>(0, $9YD4s.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $85b42f771dca94f9$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $85b42f771dca94f9$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $85b42f771dca94f9$export$2e2bcd8739ae039).arrow}`]: (0, $9YD4s.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $85b42f771dca94f9$export$2e2bcd8739ae039).arrow}`]: (0, $9YD4s.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $a02a42c2a8820b60$var$TooltipTooltip = (0, $bgnZl.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $lJkvk.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kFXNp.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$a02a42c2a8820b60$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $85b42f771dca94f9$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $9YD4s.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $9YD4s.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $9YD4s.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $85b42f771dca94f9$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $9YD4s.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $9YD4s.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $9YD4s.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $85b42f771dca94f9$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $9YD4s.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $85b42f771dca94f9$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $9YD4s.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $a02a42c2a8820b60$var$TooltipArrow = (0, $bgnZl.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme  })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em",
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kFXNp.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $a02a42c2a8820b60$var$hystersisOpen = false;
let $a02a42c2a8820b60$var$hystersisTimer = null;
function $a02a42c2a8820b60$export$b9ee5a7ace0541f8() {
    $a02a42c2a8820b60$var$hystersisOpen = false;
    clearTimeout($a02a42c2a8820b60$var$hystersisTimer);
}
function $a02a42c2a8820b60$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
} // TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $a02a42c2a8820b60$var$Tooltip = /*#__PURE__*/ $4lkrv.forwardRef(function Tooltip(inProps, ref) {
    var _components$Popper, _ref, _components$Transitio, _components$Tooltip, _components$Arrow, _componentsProps$popp;
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false , children: children , components: components = {} , componentsProps: componentsProps = {} , describeChild: describeChild = false , disableFocusListener: disableFocusListener = false , disableHoverListener: disableHoverListener = false , disableInteractive: disableInteractiveProp = false , disableTouchListener: disableTouchListener = false , enterDelay: enterDelay = 100 , enterNextDelay: enterNextDelay = 0 , enterTouchDelay: enterTouchDelay = 700 , followCursor: followCursor = false , id: idProp , leaveDelay: leaveDelay = 0 , leaveTouchDelay: leaveTouchDelay = 1500 , onClose: onClose , onOpen: onOpen , open: openProp , placement: placement = "bottom" , PopperComponent: PopperComponentProp , PopperProps: PopperProps = {} , title: title , TransitionComponent: TransitionComponentProp = (0, $b23fa01d8d65d417$export$2e2bcd8739ae039) , TransitionProps: TransitionProps  } = props, other = (0, $eLWn9.default)(props, $a02a42c2a8820b60$var$_excluded);
    const theme = (0, $0fbff9e4f89c0f97$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $4lkrv.useState();
    const [arrowRef, setArrowRef] = $4lkrv.useState(null);
    const ignoreNonTouchEvents = $4lkrv.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $4lkrv.useRef();
    const enterTimer = $4lkrv.useRef();
    const leaveTimer = $4lkrv.useRef();
    const touchTimer = $4lkrv.useRef();
    const [openState, setOpenState] = (0, $fa80bb9ce38c215b$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $bf5620e76d9e1fde$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $4lkrv.useRef();
    const stopTouchInteraction = $4lkrv.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $4lkrv.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($a02a42c2a8820b60$var$hystersisTimer);
        $a02a42c2a8820b60$var$hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $b9f2c9ca7ac03833$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($a02a42c2a8820b60$var$hystersisTimer);
        $a02a42c2a8820b60$var$hystersisTimer = setTimeout(()=>{
            $a02a42c2a8820b60$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
         // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $a02a42c2a8820b60$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $a02a42c2a8820b60$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef , onBlur: handleBlurVisible , onFocus: handleFocusVisible , ref: focusVisibleRef  } = (0, $774963030b527352$export$2e2bcd8739ae039)(); // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $4lkrv.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect; // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $4lkrv.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleUseRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(setChildNode, ref);
    const handleFocusRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(focusVisibleRef, handleUseRef);
    const handleRef = (0, $55694fd908cff41d$export$2e2bcd8739ae039)(children.ref, handleFocusRef); // There is no point in displaying an empty tooltip.
    if (title === "") open = false;
    const positionRef = $4lkrv.useRef({
        x: 0,
        y: 0
    });
    const popperRef = $4lkrv.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        positionRef.current = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $9YD4s.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $iB56s.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $a02a42c2a8820b60$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $a02a42c2a8820b60$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $a02a42c2a8820b60$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $a02a42c2a8820b60$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $4lkrv.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $9YD4s.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $9YD4s.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $a02a42c2a8820b60$var$useUtilityClasses(ownerState);
    const PopperComponent = (_components$Popper = components.Popper) != null ? _components$Popper : $a02a42c2a8820b60$var$TooltipPopper;
    const TransitionComponent = (_ref = (_components$Transitio = components.Transition) != null ? _components$Transitio : TransitionComponentProp) != null ? _ref : (0, $b23fa01d8d65d417$export$2e2bcd8739ae039);
    const TooltipComponent = (_components$Tooltip = components.Tooltip) != null ? _components$Tooltip : $a02a42c2a8820b60$var$TooltipTooltip;
    const ArrowComponent = (_components$Arrow = components.Arrow) != null ? _components$Arrow : $a02a42c2a8820b60$var$TooltipArrow;
    const popperProps = (0, $11bbf8433f7ee15f$export$2e2bcd8739ae039)(PopperComponent, (0, $9YD4s.default)({}, PopperProps, componentsProps.popper), ownerState);
    const transitionProps = (0, $11bbf8433f7ee15f$export$2e2bcd8739ae039)(TransitionComponent, (0, $9YD4s.default)({}, TransitionProps, componentsProps.transition), ownerState);
    const tooltipProps = (0, $11bbf8433f7ee15f$export$2e2bcd8739ae039)(TooltipComponent, (0, $9YD4s.default)({}, componentsProps.tooltip), ownerState);
    const tooltipArrowProps = (0, $11bbf8433f7ee15f$export$2e2bcd8739ae039)(ArrowComponent, (0, $9YD4s.default)({}, componentsProps.arrow), ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsxs)($4lkrv.Fragment, {
        children: [
            /*#__PURE__*/ $4lkrv.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $gWMia.jsx)(PopperComponent, (0, $9YD4s.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $170d459912f1fdc9$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: positionRef.current.y,
                            left: positionRef.current.x,
                            right: positionRef.current.x,
                            bottom: positionRef.current.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                className: (0, $iB56s.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_componentsProps$popp = componentsProps.popper) == null ? void 0 : _componentsProps$popp.className),
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner  })=>{
                    var _componentsProps$tool, _componentsProps$arro;
                    return /*#__PURE__*/ (0, $gWMia.jsx)(TransitionComponent, (0, $9YD4s.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $gWMia.jsxs)(TooltipComponent, (0, $9YD4s.default)({}, tooltipProps, {
                            className: (0, $iB56s.default)(classes.tooltip, (_componentsProps$tool = componentsProps.tooltip) == null ? void 0 : _componentsProps$tool.className),
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $gWMia.jsx)(ArrowComponent, (0, $9YD4s.default)({}, tooltipArrowProps, {
                                    className: (0, $iB56s.default)(classes.arrow, (_componentsProps$arro = componentsProps.arrow) == null ? void 0 : _componentsProps$arro.className),
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }));
                }
            }))
        ]
    });
});
var $a02a42c2a8820b60$export$2e2bcd8739ae039 = $a02a42c2a8820b60$var$Tooltip;



var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");

var $iB56s = parcelRequire("iB56s");



var $43t7c = parcelRequire("43t7c");

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");

var $9YD4s = parcelRequire("9YD4s");
var $6998b862ae22987b$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $6998b862ae22987b$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $6998b862ae22987b$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $6998b862ae22987b$var$_typeof(document)) === "object" && document.nodeType === 9;
var $6998b862ae22987b$export$2e2bcd8739ae039 = $6998b862ae22987b$export$4e09c449d6c407f7;


var $3d5c317d17d55a8d$var$isProduction = true;
function $3d5c317d17d55a8d$var$warning(condition, message) {
    if (!$3d5c317d17d55a8d$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $3d5c317d17d55a8d$export$2e2bcd8739ae039 = $3d5c317d17d55a8d$var$warning;


function $d019b945c55a7d85$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $d019b945c55a7d85$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d019b945c55a7d85$export$2e2bcd8739ae039(obj);
}



function $fcb26ee9ea042f91$export$2e2bcd8739ae039(input, hint) {
    if ((0, $d019b945c55a7d85$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $d019b945c55a7d85$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $b2f4038c7a8595b4$export$2e2bcd8739ae039(arg) {
    var key = (0, $fcb26ee9ea042f91$export$2e2bcd8739ae039)(arg, "string");
    return (0, $d019b945c55a7d85$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $800d682fe8751e04$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $b2f4038c7a8595b4$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $800d682fe8751e04$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $800d682fe8751e04$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $800d682fe8751e04$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}





var $eLWn9 = parcelRequire("eLWn9");
var $6c93af1bf2532582$var$plainObjectConstrurctor = {}.constructor;
function $6c93af1bf2532582$var$cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map($6c93af1bf2532582$var$cloneStyle);
    if (style.constructor !== $6c93af1bf2532582$var$plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = $6c93af1bf2532582$var$cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function $6c93af1bf2532582$export$56e87122f905fac0(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = $6c93af1bf2532582$var$cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var $6c93af1bf2532582$var$join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var $6c93af1bf2532582$export$5ac341d5e3cf9273 = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += $6c93af1bf2532582$var$join(value[i], " ");
    }
    else cssValue = $6c93af1bf2532582$var$join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function $6c93af1bf2532582$var$getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function $6c93af1bf2532582$var$indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function $6c93af1bf2532582$var$toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = $6c93af1bf2532582$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += $6c93af1bf2532582$var$indentStr(prop + ":" + space + $6c93af1bf2532582$export$5ac341d5e3cf9273(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += $6c93af1bf2532582$var$indentStr(_prop + ":" + space + $6c93af1bf2532582$export$5ac341d5e3cf9273(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += $6c93af1bf2532582$var$indentStr(_prop2 + ":" + space + $6c93af1bf2532582$export$5ac341d5e3cf9273(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return $6c93af1bf2532582$var$indentStr("" + selector + space + "{" + result, indent) + $6c93af1bf2532582$var$indentStr("}", indent);
}
var $6c93af1bf2532582$var$escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var $6c93af1bf2532582$var$nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var $6c93af1bf2532582$var$escape = function(str) {
    return $6c93af1bf2532582$var$nativeEscape ? $6c93af1bf2532582$var$nativeEscape(str) : str.replace($6c93af1bf2532582$var$escapeRegex, "\\$1");
};
var $6c93af1bf2532582$var$BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var $6c93af1bf2532582$var$StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $32997f18e5380783$export$2e2bcd8739ae039)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $8ecf9feca1f5acae$export$2e2bcd8739ae039)((0, $8ecf9feca1f5acae$export$2e2bcd8739ae039)(_this)), sheet);
            _this.selectorText = "." + $6c93af1bf2532582$var$escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = $6c93af1bf2532582$export$5ac341d5e3cf9273(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $9YD4s.default)({}, options, {
            allowEmpty: true
        }) : options;
        return $6c93af1bf2532582$var$toCss(this.selectorText, this.style, opts);
    };
    (0, $800d682fe8751e04$export$2e2bcd8739ae039)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}($6c93af1bf2532582$var$BaseStyleRule);
var $6c93af1bf2532582$var$pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new $6c93af1bf2532582$var$StyleRule(key, style, options);
    }
};
var $6c93af1bf2532582$var$defaultToStringOptions = {
    indent: 1,
    children: true
};
var $6c93af1bf2532582$var$atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var $6c93af1bf2532582$var$ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match($6c93af1bf2532582$var$atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new $6c93af1bf2532582$export$d9da2a13178d3d68((0, $9YD4s.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $6c93af1bf2532582$var$defaultToStringOptions;
        var _getWhitespaceSymbols = $6c93af1bf2532582$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = $6c93af1bf2532582$var$defaultToStringOptions.indent;
        if (options.children == null) options.children = $6c93af1bf2532582$var$defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var $6c93af1bf2532582$var$keyRegExp = /@container|@media|@supports\s+/;
var $6c93af1bf2532582$var$pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return $6c93af1bf2532582$var$keyRegExp.test(key) ? new $6c93af1bf2532582$var$ConditionalRule(key, styles, options) : null;
    }
};
var $6c93af1bf2532582$var$defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var $6c93af1bf2532582$var$nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var $6c93af1bf2532582$var$KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match($6c93af1bf2532582$var$nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : $6c93af1bf2532582$var$escape(generateId(this, sheet));
        this.rules = new $6c93af1bf2532582$export$d9da2a13178d3d68((0, $9YD4s.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $9YD4s.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $6c93af1bf2532582$var$defaultToStringOptions$1;
        var _getWhitespaceSymbols = $6c93af1bf2532582$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = $6c93af1bf2532582$var$defaultToStringOptions$1.indent;
        if (options.children == null) options.children = $6c93af1bf2532582$var$defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var $6c93af1bf2532582$var$keyRegExp$1 = /@keyframes\s+/;
var $6c93af1bf2532582$var$refRegExp = /\$([\w-]+)/g;
var $6c93af1bf2532582$var$findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace($6c93af1bf2532582$var$refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var $6c93af1bf2532582$var$replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = $6c93af1bf2532582$var$findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var $6c93af1bf2532582$var$pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && $6c93af1bf2532582$var$keyRegExp$1.test(key) ? new $6c93af1bf2532582$var$KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) $6c93af1bf2532582$var$replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) $6c93af1bf2532582$var$replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return $6c93af1bf2532582$var$findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return $6c93af1bf2532582$var$findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var $6c93af1bf2532582$var$KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $32997f18e5380783$export$2e2bcd8739ae039)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $9YD4s.default)({}, options, {
            allowEmpty: true
        }) : options;
        return $6c93af1bf2532582$var$toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}($6c93af1bf2532582$var$BaseStyleRule);
var $6c93af1bf2532582$var$pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new $6c93af1bf2532582$var$KeyframeRule(key, style, options);
        return null;
    }
};
var $6c93af1bf2532582$var$FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = $6c93af1bf2532582$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += $6c93af1bf2532582$var$toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return $6c93af1bf2532582$var$toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var $6c93af1bf2532582$var$keyRegExp$2 = /@font-face/;
var $6c93af1bf2532582$var$pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return $6c93af1bf2532582$var$keyRegExp$2.test(key) ? new $6c93af1bf2532582$var$FontFaceRule(key, style, options) : null;
    }
};
var $6c93af1bf2532582$var$ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return $6c93af1bf2532582$var$toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var $6c93af1bf2532582$var$pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new $6c93af1bf2532582$var$ViewportRule(key, style, options) : null;
    }
};
var $6c93af1bf2532582$var$SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var $6c93af1bf2532582$var$keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var $6c93af1bf2532582$var$pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in $6c93af1bf2532582$var$keysMap ? new $6c93af1bf2532582$var$SimpleRule(key, value, options) : null;
    }
};
var $6c93af1bf2532582$var$plugins = [
    $6c93af1bf2532582$var$pluginStyleRule,
    $6c93af1bf2532582$var$pluginConditionalRule,
    $6c93af1bf2532582$var$pluginKeyframesRule,
    $6c93af1bf2532582$var$pluginKeyframeRule,
    $6c93af1bf2532582$var$pluginFontFaceRule,
    $6c93af1bf2532582$var$pluginViewportRule,
    $6c93af1bf2532582$var$pluginSimpleRule
];
var $6c93af1bf2532582$var$defaultUpdateOptions = {
    process: true
};
var $6c93af1bf2532582$var$forceUpdateOptions = {
    force: true,
    process: true
};
var $6c93af1bf2532582$export$d9da2a13178d3d68 = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $9YD4s.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + $6c93af1bf2532582$var$escape(this.classes[key]);
        var rule = $6c93af1bf2532582$export$56e87122f905fac0(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $9YD4s.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof $6c93af1bf2532582$var$StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof $6c93af1bf2532582$var$KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof $6c93af1bf2532582$var$StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof $6c93af1bf2532582$var$KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = $6c93af1bf2532582$var$defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, $6c93af1bf2532582$var$forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, $6c93af1bf2532582$var$forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = $6c93af1bf2532582$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var $6c93af1bf2532582$var$StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $9YD4s.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new $6c93af1bf2532582$export$d9da2a13178d3d68(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var $6c93af1bf2532582$var$PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var $6c93af1bf2532582$export$bcb2f1d96ff51db3 = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $eLWn9.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = $6c93af1bf2532582$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $800d682fe8751e04$export$2e2bcd8739ae039)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var $6c93af1bf2532582$export$d1f2fc3a3d47c5af = new $6c93af1bf2532582$export$bcb2f1d96ff51db3();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var $6c93af1bf2532582$var$globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var $6c93af1bf2532582$var$ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if ($6c93af1bf2532582$var$globalThis$1[$6c93af1bf2532582$var$ns] == null) $6c93af1bf2532582$var$globalThis$1[$6c93af1bf2532582$var$ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var $6c93af1bf2532582$var$moduleId = $6c93af1bf2532582$var$globalThis$1[$6c93af1bf2532582$var$ns]++;
var $6c93af1bf2532582$var$maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var $6c93af1bf2532582$export$ddff9cce7c732c82 = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + $6c93af1bf2532582$var$moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + $6c93af1bf2532582$var$moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var $6c93af1bf2532582$var$memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var $6c93af1bf2532582$var$getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var $6c93af1bf2532582$var$setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = $6c93af1bf2532582$export$5ac341d5e3cf9273(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var $6c93af1bf2532582$var$removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var $6c93af1bf2532582$var$setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var $6c93af1bf2532582$var$getHead = $6c93af1bf2532582$var$memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function $6c93af1bf2532582$var$findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function $6c93af1bf2532582$var$findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function $6c93af1bf2532582$var$findCommentNode(text) {
    var head = $6c93af1bf2532582$var$getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function $6c93af1bf2532582$var$findPrevNode(options) {
    var registry = $6c93af1bf2532582$export$d1f2fc3a3d47c5af.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = $6c93af1bf2532582$var$findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = $6c93af1bf2532582$var$findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = $6c93af1bf2532582$var$findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function $6c93af1bf2532582$var$insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = $6c93af1bf2532582$var$findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    $6c93af1bf2532582$var$getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var $6c93af1bf2532582$var$getNonce = $6c93af1bf2532582$var$memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var $6c93af1bf2532582$var$_insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var $6c93af1bf2532582$var$getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var $6c93af1bf2532582$var$createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var $6c93af1bf2532582$var$DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = $6c93af1bf2532582$var$getPropertyValue;
        this.setProperty = $6c93af1bf2532582$var$setProperty;
        this.removeProperty = $6c93af1bf2532582$var$removeProperty;
        this.setSelector = $6c93af1bf2532582$var$setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) $6c93af1bf2532582$export$d1f2fc3a3d47c5af.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || $6c93af1bf2532582$var$createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = $6c93af1bf2532582$var$getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        $6c93af1bf2532582$var$insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = $6c93af1bf2532582$var$getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = $6c93af1bf2532582$var$_insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = $6c93af1bf2532582$var$getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = $6c93af1bf2532582$var$_insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof $6c93af1bf2532582$var$StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var $6c93af1bf2532582$var$instanceCounter = 0;
var $6c93af1bf2532582$var$Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = $6c93af1bf2532582$var$instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new $6c93af1bf2532582$var$PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: $6c93af1bf2532582$export$ddff9cce7c732c82,
            Renderer: (0, $6998b862ae22987b$export$2e2bcd8739ae039) ? $6c93af1bf2532582$var$DomRenderer : null,
            plugins: []
        };
        this.generateId = $6c93af1bf2532582$export$ddff9cce7c732c82({
            minify: false
        });
        for(var i = 0; i < $6c93af1bf2532582$var$plugins.length; i++)this.plugins.use($6c93af1bf2532582$var$plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $9YD4s.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = $6c93af1bf2532582$export$d1f2fc3a3d47c5af.index === 0 ? 0 : $6c93af1bf2532582$export$d1f2fc3a3d47c5af.index + 1;
        var sheet = new $6c93af1bf2532582$var$StyleSheet(styles, (0, $9YD4s.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        $6c93af1bf2532582$export$d1f2fc3a3d47c5af.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $9YD4s.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = $6c93af1bf2532582$export$56e87122f905fac0(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var $6c93af1bf2532582$export$185802fd694ee1f5 = function createJss(options) {
    return new $6c93af1bf2532582$var$Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var $6c93af1bf2532582$export$c72bb5031d779271 = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $3d5c317d17d55a8d$export$2e2bcd8739ae039)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $3d5c317d17d55a8d$export$2e2bcd8739ae039)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $800d682fe8751e04$export$2e2bcd8739ae039)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var $6c93af1bf2532582$export$2305122a7d881dec = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function $6c93af1bf2532582$export$8558f2aefa046992(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = $6c93af1bf2532582$export$8558f2aefa046992(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var $6c93af1bf2532582$var$index = $6c93af1bf2532582$export$185802fd694ee1f5();
var $6c93af1bf2532582$export$2e2bcd8739ae039 = $6c93af1bf2532582$var$index;



var $9YD4s = parcelRequire("9YD4s");

function $8666895c57d05125$export$2e2bcd8739ae039(options = {}) {
    const { baseClasses: baseClasses , newClasses: newClasses , Component: Component  } = options;
    if (!newClasses) return baseClasses;
    const nextClasses = (0, $9YD4s.default)({}, baseClasses);
    Object.keys(newClasses).forEach((key)=>{
        if (newClasses[key]) nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    });
    return nextClasses;
}


// Used https://github.com/thinkloop/multi-key-cache as inspiration
const $ff846c141e20127e$var$multiKeyStore = {
    set: (cache, key1, key2, value)=>{
        let subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $ff846c141e20127e$export$2e2bcd8739ae039 = $ff846c141e20127e$var$multiKeyStore;



var $4lkrv = parcelRequire("4lkrv");

var $4lkrv = parcelRequire("4lkrv");
const $e23b4c1380107a86$var$ThemeContext = /*#__PURE__*/ $4lkrv.createContext(null);
var $e23b4c1380107a86$export$2e2bcd8739ae039 = $e23b4c1380107a86$var$ThemeContext;


function $22e19f93f7ed6f34$export$2e2bcd8739ae039() {
    const theme = $4lkrv.useContext((0, $e23b4c1380107a86$export$2e2bcd8739ae039));
    return theme;
}



var $9YD4s = parcelRequire("9YD4s");

var $eLWn9 = parcelRequire("eLWn9");

var $4lkrv = parcelRequire("4lkrv");



const $49d61b77f5a8b65e$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $49d61b77f5a8b65e$export$2e2bcd8739ae039 = $49d61b77f5a8b65e$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";


/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */ const $52b48f3a2593a5cc$var$stateClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
]; // Returns a function which generates unique class names based on counters.
function $52b48f3a2593a5cc$export$2e2bcd8739ae039(options = {}) {
    const { disableGlobal: disableGlobal = false , productionPrefix: productionPrefix = "jss" , seed: seed = ""  } = options;
    const seedPrefix = seed === "" ? "" : `${seed}-`;
    let ruleCounter = 0;
    const getNextCounterId = ()=>{
        ruleCounter += 1;
        return ruleCounter;
    };
    return (rule, styleSheet)=>{
        const name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($52b48f3a2593a5cc$var$stateClasses.indexOf(rule.key) !== -1) return `Mui-${rule.key}`;
            const prefix = `${seedPrefix}${name}-${rule.key}`;
            if (!styleSheet.options.theme[0, $49d61b77f5a8b65e$export$2e2bcd8739ae039] || seed !== "") return prefix;
            return `${prefix}-${getNextCounterId()}`;
        }
        return `${seedPrefix}${productionPrefix}${getNextCounterId()}`;
    };
}




var $5784f9625d1ab3ac$var$now = Date.now();
var $5784f9625d1ab3ac$var$fnValuesNs = "fnValues" + $5784f9625d1ab3ac$var$now;
var $5784f9625d1ab3ac$var$fnRuleNs = "fnStyle" + ++$5784f9625d1ab3ac$var$now;
var $5784f9625d1ab3ac$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $6c93af1bf2532582$export$56e87122f905fac0)(name, {}, options);
            rule[$5784f9625d1ab3ac$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($5784f9625d1ab3ac$var$fnValuesNs in rule || $5784f9625d1ab3ac$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$5784f9625d1ab3ac$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$5784f9625d1ab3ac$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$5784f9625d1ab3ac$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $5784f9625d1ab3ac$export$2e2bcd8739ae039 = $5784f9625d1ab3ac$var$functionPlugin;



var $9YD4s = parcelRequire("9YD4s");

var $1960b1286eeba503$var$at = "@global";
var $1960b1286eeba503$var$atPrefix = "@global ";
var $1960b1286eeba503$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $1960b1286eeba503$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $6c93af1bf2532582$export$d9da2a13178d3d68)((0, $9YD4s.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $1960b1286eeba503$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $1960b1286eeba503$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($1960b1286eeba503$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $9YD4s.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $1960b1286eeba503$var$separatorRegExp = /\s*,\s*/g;
function $1960b1286eeba503$var$addScope(selector, scope) {
    var parts = selector.split($1960b1286eeba503$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $1960b1286eeba503$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$1960b1286eeba503$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $9YD4s.default)({}, options, {
        selector: $1960b1286eeba503$var$addScope(name, rule.selector)
    }));
    delete style[$1960b1286eeba503$var$at];
}
function $1960b1286eeba503$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $1960b1286eeba503$var$at.length) !== $1960b1286eeba503$var$at) continue;
        var selector = $1960b1286eeba503$var$addScope(prop.substr($1960b1286eeba503$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $9YD4s.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $1960b1286eeba503$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $1960b1286eeba503$var$at) return new $1960b1286eeba503$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $1960b1286eeba503$var$atPrefix.length) === $1960b1286eeba503$var$atPrefix) return new $1960b1286eeba503$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $1960b1286eeba503$var$handleNestedGlobalContainerRule(rule, sheet);
        $1960b1286eeba503$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $1960b1286eeba503$export$2e2bcd8739ae039 = $1960b1286eeba503$var$jssGlobal;



var $9YD4s = parcelRequire("9YD4s");

var $6a240663d34ed726$var$separatorRegExp = /\s*,\s*/g;
var $6a240663d34ed726$var$parentRegExp = /&/g;
var $6a240663d34ed726$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $6a240663d34ed726$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($6a240663d34ed726$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($6a240663d34ed726$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($6a240663d34ed726$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $9YD4s.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $9YD4s.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($6a240663d34ed726$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $9YD4s.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $9YD4s.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $6a240663d34ed726$export$2e2bcd8739ae039 = $6a240663d34ed726$var$jssNested;


/* eslint-disable no-var, prefer-template */ var $450be850c25a302e$var$uppercasePattern = /[A-Z]/g;
var $450be850c25a302e$var$msPattern = /^ms-/;
var $450be850c25a302e$var$cache = {};
function $450be850c25a302e$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $450be850c25a302e$var$hyphenateStyleName(name) {
    if ($450be850c25a302e$var$cache.hasOwnProperty(name)) return $450be850c25a302e$var$cache[name];
    var hName = name.replace($450be850c25a302e$var$uppercasePattern, $450be850c25a302e$var$toHyphenLower);
    return $450be850c25a302e$var$cache[name] = $450be850c25a302e$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $450be850c25a302e$export$2e2bcd8739ae039 = $450be850c25a302e$var$hyphenateStyleName;


/**
 * Convert camel cased property names to dash separated.
 */ function $8ef645e4bdd86540$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $450be850c25a302e$export$2e2bcd8739ae039)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($8ef645e4bdd86540$var$convertCase);
        else converted.fallbacks = $8ef645e4bdd86540$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $8ef645e4bdd86540$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $8ef645e4bdd86540$var$convertCase(style[index]);
            return style;
        }
        return $8ef645e4bdd86540$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $450be850c25a302e$export$2e2bcd8739ae039)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $8ef645e4bdd86540$export$2e2bcd8739ae039 = $8ef645e4bdd86540$var$camelCase;



var $47d11aab80513aca$var$px = (0, $6c93af1bf2532582$export$2305122a7d881dec) && CSS ? CSS.px : "px";
var $47d11aab80513aca$var$ms = (0, $6c93af1bf2532582$export$2305122a7d881dec) && CSS ? CSS.ms : "ms";
var $47d11aab80513aca$var$percent = (0, $6c93af1bf2532582$export$2305122a7d881dec) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $47d11aab80513aca$var$defaultUnits = {
    // Animation properties
    "animation-delay": $47d11aab80513aca$var$ms,
    "animation-duration": $47d11aab80513aca$var$ms,
    // Background properties
    "background-position": $47d11aab80513aca$var$px,
    "background-position-x": $47d11aab80513aca$var$px,
    "background-position-y": $47d11aab80513aca$var$px,
    "background-size": $47d11aab80513aca$var$px,
    // Border Properties
    border: $47d11aab80513aca$var$px,
    "border-bottom": $47d11aab80513aca$var$px,
    "border-bottom-left-radius": $47d11aab80513aca$var$px,
    "border-bottom-right-radius": $47d11aab80513aca$var$px,
    "border-bottom-width": $47d11aab80513aca$var$px,
    "border-left": $47d11aab80513aca$var$px,
    "border-left-width": $47d11aab80513aca$var$px,
    "border-radius": $47d11aab80513aca$var$px,
    "border-right": $47d11aab80513aca$var$px,
    "border-right-width": $47d11aab80513aca$var$px,
    "border-top": $47d11aab80513aca$var$px,
    "border-top-left-radius": $47d11aab80513aca$var$px,
    "border-top-right-radius": $47d11aab80513aca$var$px,
    "border-top-width": $47d11aab80513aca$var$px,
    "border-width": $47d11aab80513aca$var$px,
    "border-block": $47d11aab80513aca$var$px,
    "border-block-end": $47d11aab80513aca$var$px,
    "border-block-end-width": $47d11aab80513aca$var$px,
    "border-block-start": $47d11aab80513aca$var$px,
    "border-block-start-width": $47d11aab80513aca$var$px,
    "border-block-width": $47d11aab80513aca$var$px,
    "border-inline": $47d11aab80513aca$var$px,
    "border-inline-end": $47d11aab80513aca$var$px,
    "border-inline-end-width": $47d11aab80513aca$var$px,
    "border-inline-start": $47d11aab80513aca$var$px,
    "border-inline-start-width": $47d11aab80513aca$var$px,
    "border-inline-width": $47d11aab80513aca$var$px,
    "border-start-start-radius": $47d11aab80513aca$var$px,
    "border-start-end-radius": $47d11aab80513aca$var$px,
    "border-end-start-radius": $47d11aab80513aca$var$px,
    "border-end-end-radius": $47d11aab80513aca$var$px,
    // Margin properties
    margin: $47d11aab80513aca$var$px,
    "margin-bottom": $47d11aab80513aca$var$px,
    "margin-left": $47d11aab80513aca$var$px,
    "margin-right": $47d11aab80513aca$var$px,
    "margin-top": $47d11aab80513aca$var$px,
    "margin-block": $47d11aab80513aca$var$px,
    "margin-block-end": $47d11aab80513aca$var$px,
    "margin-block-start": $47d11aab80513aca$var$px,
    "margin-inline": $47d11aab80513aca$var$px,
    "margin-inline-end": $47d11aab80513aca$var$px,
    "margin-inline-start": $47d11aab80513aca$var$px,
    // Padding properties
    padding: $47d11aab80513aca$var$px,
    "padding-bottom": $47d11aab80513aca$var$px,
    "padding-left": $47d11aab80513aca$var$px,
    "padding-right": $47d11aab80513aca$var$px,
    "padding-top": $47d11aab80513aca$var$px,
    "padding-block": $47d11aab80513aca$var$px,
    "padding-block-end": $47d11aab80513aca$var$px,
    "padding-block-start": $47d11aab80513aca$var$px,
    "padding-inline": $47d11aab80513aca$var$px,
    "padding-inline-end": $47d11aab80513aca$var$px,
    "padding-inline-start": $47d11aab80513aca$var$px,
    // Mask properties
    "mask-position-x": $47d11aab80513aca$var$px,
    "mask-position-y": $47d11aab80513aca$var$px,
    "mask-size": $47d11aab80513aca$var$px,
    // Width and height properties
    height: $47d11aab80513aca$var$px,
    width: $47d11aab80513aca$var$px,
    "min-height": $47d11aab80513aca$var$px,
    "max-height": $47d11aab80513aca$var$px,
    "min-width": $47d11aab80513aca$var$px,
    "max-width": $47d11aab80513aca$var$px,
    // Position properties
    bottom: $47d11aab80513aca$var$px,
    left: $47d11aab80513aca$var$px,
    top: $47d11aab80513aca$var$px,
    right: $47d11aab80513aca$var$px,
    inset: $47d11aab80513aca$var$px,
    "inset-block": $47d11aab80513aca$var$px,
    "inset-block-end": $47d11aab80513aca$var$px,
    "inset-block-start": $47d11aab80513aca$var$px,
    "inset-inline": $47d11aab80513aca$var$px,
    "inset-inline-end": $47d11aab80513aca$var$px,
    "inset-inline-start": $47d11aab80513aca$var$px,
    // Shadow properties
    "box-shadow": $47d11aab80513aca$var$px,
    "text-shadow": $47d11aab80513aca$var$px,
    // Column properties
    "column-gap": $47d11aab80513aca$var$px,
    "column-rule": $47d11aab80513aca$var$px,
    "column-rule-width": $47d11aab80513aca$var$px,
    "column-width": $47d11aab80513aca$var$px,
    // Font and text properties
    "font-size": $47d11aab80513aca$var$px,
    "font-size-delta": $47d11aab80513aca$var$px,
    "letter-spacing": $47d11aab80513aca$var$px,
    "text-decoration-thickness": $47d11aab80513aca$var$px,
    "text-indent": $47d11aab80513aca$var$px,
    "text-stroke": $47d11aab80513aca$var$px,
    "text-stroke-width": $47d11aab80513aca$var$px,
    "word-spacing": $47d11aab80513aca$var$px,
    // Motion properties
    motion: $47d11aab80513aca$var$px,
    "motion-offset": $47d11aab80513aca$var$px,
    // Outline properties
    outline: $47d11aab80513aca$var$px,
    "outline-offset": $47d11aab80513aca$var$px,
    "outline-width": $47d11aab80513aca$var$px,
    // Perspective properties
    perspective: $47d11aab80513aca$var$px,
    "perspective-origin-x": $47d11aab80513aca$var$percent,
    "perspective-origin-y": $47d11aab80513aca$var$percent,
    // Transform properties
    "transform-origin": $47d11aab80513aca$var$percent,
    "transform-origin-x": $47d11aab80513aca$var$percent,
    "transform-origin-y": $47d11aab80513aca$var$percent,
    "transform-origin-z": $47d11aab80513aca$var$percent,
    // Transition properties
    "transition-delay": $47d11aab80513aca$var$ms,
    "transition-duration": $47d11aab80513aca$var$ms,
    // Alignment properties
    "vertical-align": $47d11aab80513aca$var$px,
    "flex-basis": $47d11aab80513aca$var$px,
    // Some random properties
    "shape-margin": $47d11aab80513aca$var$px,
    size: $47d11aab80513aca$var$px,
    gap: $47d11aab80513aca$var$px,
    // Grid properties
    grid: $47d11aab80513aca$var$px,
    "grid-gap": $47d11aab80513aca$var$px,
    "row-gap": $47d11aab80513aca$var$px,
    "grid-row-gap": $47d11aab80513aca$var$px,
    "grid-column-gap": $47d11aab80513aca$var$px,
    "grid-template-rows": $47d11aab80513aca$var$px,
    "grid-template-columns": $47d11aab80513aca$var$px,
    "grid-auto-rows": $47d11aab80513aca$var$px,
    "grid-auto-columns": $47d11aab80513aca$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $47d11aab80513aca$var$px,
    "box-shadow-y": $47d11aab80513aca$var$px,
    "box-shadow-blur": $47d11aab80513aca$var$px,
    "box-shadow-spread": $47d11aab80513aca$var$px,
    "font-line-height": $47d11aab80513aca$var$px,
    "text-shadow-x": $47d11aab80513aca$var$px,
    "text-shadow-y": $47d11aab80513aca$var$px,
    "text-shadow-blur": $47d11aab80513aca$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $47d11aab80513aca$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $47d11aab80513aca$var$units = $47d11aab80513aca$var$addCamelCasedVersion($47d11aab80513aca$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $47d11aab80513aca$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $47d11aab80513aca$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $47d11aab80513aca$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $47d11aab80513aca$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $47d11aab80513aca$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $47d11aab80513aca$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $47d11aab80513aca$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $47d11aab80513aca$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $47d11aab80513aca$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $47d11aab80513aca$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $47d11aab80513aca$export$2e2bcd8739ae039 = $47d11aab80513aca$var$defaultUnit;



function $47907277261b6b1b$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $674a4a9c2b1f254c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $47907277261b6b1b$export$2e2bcd8739ae039)(arr);
}


function $1cc1988928176b39$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $aaa2497aec565674$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $47907277261b6b1b$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $47907277261b6b1b$export$2e2bcd8739ae039)(o, minLen);
}


function $ef28343595cad0dd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d886357b6a9626ff$export$2e2bcd8739ae039(arr) {
    return (0, $674a4a9c2b1f254c$export$2e2bcd8739ae039)(arr) || (0, $1cc1988928176b39$export$2e2bcd8739ae039)(arr) || (0, $aaa2497aec565674$export$2e2bcd8739ae039)(arr) || (0, $ef28343595cad0dd$export$2e2bcd8739ae039)();
}


// Export javascript style and css style vendor prefixes.
var $92f21f616111cd14$var$js = "";
var $92f21f616111cd14$var$css = "";
var $92f21f616111cd14$var$vendor = "";
var $92f21f616111cd14$var$browser = "";
var $92f21f616111cd14$var$isTouch = (0, $6998b862ae22987b$export$2e2bcd8739ae039) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $6998b862ae22987b$export$2e2bcd8739ae039) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $92f21f616111cd14$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $92f21f616111cd14$var$_document$createEleme = document.createElement("p"), $92f21f616111cd14$var$style = $92f21f616111cd14$var$_document$createEleme.style;
    var $92f21f616111cd14$var$testProp = "Transform";
    for(var $92f21f616111cd14$var$key in $92f21f616111cd14$var$jsCssMap)if ($92f21f616111cd14$var$key + $92f21f616111cd14$var$testProp in $92f21f616111cd14$var$style) {
        $92f21f616111cd14$var$js = $92f21f616111cd14$var$key;
        $92f21f616111cd14$var$css = $92f21f616111cd14$var$jsCssMap[$92f21f616111cd14$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($92f21f616111cd14$var$js === "Webkit" && "msHyphens" in $92f21f616111cd14$var$style) {
        $92f21f616111cd14$var$js = "ms";
        $92f21f616111cd14$var$css = $92f21f616111cd14$var$jsCssMap.ms;
        $92f21f616111cd14$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($92f21f616111cd14$var$js === "Webkit" && "-apple-trailing-word" in $92f21f616111cd14$var$style) $92f21f616111cd14$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $92f21f616111cd14$export$82e9f45cca5ba907 = {
    js: $92f21f616111cd14$var$js,
    css: $92f21f616111cd14$var$css,
    vendor: $92f21f616111cd14$var$vendor,
    browser: $92f21f616111cd14$var$browser,
    isTouch: $92f21f616111cd14$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $92f21f616111cd14$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $92f21f616111cd14$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $92f21f616111cd14$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $92f21f616111cd14$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $92f21f616111cd14$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "Webkit") return $92f21f616111cd14$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $92f21f616111cd14$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $92f21f616111cd14$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $92f21f616111cd14$var$camelize(str) {
    return str.replace($92f21f616111cd14$var$regExp, $92f21f616111cd14$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $92f21f616111cd14$var$pascalize(str) {
    return $92f21f616111cd14$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $92f21f616111cd14$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($92f21f616111cd14$var$camelize(longhand) in style) return prop;
            if ($92f21f616111cd14$export$82e9f45cca5ba907.js + $92f21f616111cd14$var$pascalize(longhand) in style) return $92f21f616111cd14$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $92f21f616111cd14$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.vendor === "apple" && !$92f21f616111cd14$export$82e9f45cca5ba907.isTouch) return $92f21f616111cd14$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $92f21f616111cd14$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $92f21f616111cd14$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $92f21f616111cd14$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $92f21f616111cd14$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $92f21f616111cd14$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "Webkit" || $92f21f616111cd14$export$82e9f45cca5ba907.js === "ms" && $92f21f616111cd14$export$82e9f45cca5ba907.browser !== "edge") return $92f21f616111cd14$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $92f21f616111cd14$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "Moz" || $92f21f616111cd14$export$82e9f45cca5ba907.js === "ms" || $92f21f616111cd14$export$82e9f45cca5ba907.vendor === "apple") return $92f21f616111cd14$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $92f21f616111cd14$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $92f21f616111cd14$var$pascalize(prop);
            return jsProp in style ? $92f21f616111cd14$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $92f21f616111cd14$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $92f21f616111cd14$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $92f21f616111cd14$export$82e9f45cca5ba907.js + $92f21f616111cd14$var$pascalize(newProp) in style ? $92f21f616111cd14$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $92f21f616111cd14$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $92f21f616111cd14$var$camelize(prop) in style ? prop : false;
    }
};
var $92f21f616111cd14$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $92f21f616111cd14$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js + pascalized in style) return $92f21f616111cd14$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $92f21f616111cd14$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "ms") return "" + $92f21f616111cd14$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $92f21f616111cd14$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($92f21f616111cd14$export$82e9f45cca5ba907.js === "ms") return $92f21f616111cd14$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $92f21f616111cd14$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $92f21f616111cd14$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $92f21f616111cd14$var$propMap[prop];
        if (!newProp) return false;
        return $92f21f616111cd14$export$82e9f45cca5ba907.js + $92f21f616111cd14$var$pascalize(newProp) in style ? $92f21f616111cd14$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $92f21f616111cd14$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $92f21f616111cd14$var$propKeys = Object.keys($92f21f616111cd14$var$propMap$1);
var $92f21f616111cd14$var$prefixCss = function prefixCss(p) {
    return $92f21f616111cd14$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $92f21f616111cd14$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($92f21f616111cd14$var$propKeys.indexOf(prop) > -1) {
            var newProp = $92f21f616111cd14$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $92f21f616111cd14$export$82e9f45cca5ba907.js + $92f21f616111cd14$var$pascalize(newProp) in style ? $92f21f616111cd14$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($92f21f616111cd14$export$82e9f45cca5ba907.js + $92f21f616111cd14$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($92f21f616111cd14$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $92f21f616111cd14$var$plugins = [
    $92f21f616111cd14$var$appearence,
    $92f21f616111cd14$var$colorAdjust,
    $92f21f616111cd14$var$mask,
    $92f21f616111cd14$var$textOrientation,
    $92f21f616111cd14$var$transform,
    $92f21f616111cd14$var$transition,
    $92f21f616111cd14$var$writingMode,
    $92f21f616111cd14$var$userSelect,
    $92f21f616111cd14$var$breakPropsOld,
    $92f21f616111cd14$var$inlineLogicalOld,
    $92f21f616111cd14$var$unprefixed,
    $92f21f616111cd14$var$prefixed,
    $92f21f616111cd14$var$scrollSnap,
    $92f21f616111cd14$var$overscrollBehavior,
    $92f21f616111cd14$var$flex2012,
    $92f21f616111cd14$var$flex2009
];
var $92f21f616111cd14$var$propertyDetectors = $92f21f616111cd14$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $92f21f616111cd14$var$noPrefill = $92f21f616111cd14$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $d886357b6a9626ff$export$2e2bcd8739ae039)(p.noPrefill));
    return a;
}, []);
var $92f21f616111cd14$var$el;
var $92f21f616111cd14$var$cache = {};
if (0, $6998b862ae22987b$export$2e2bcd8739ae039) {
    $92f21f616111cd14$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $92f21f616111cd14$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $92f21f616111cd14$var$key$1 in $92f21f616111cd14$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($92f21f616111cd14$var$key$1)) $92f21f616111cd14$var$cache[$92f21f616111cd14$var$computed[$92f21f616111cd14$var$key$1]] = $92f21f616111cd14$var$computed[$92f21f616111cd14$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $92f21f616111cd14$var$noPrefill.forEach(function(x) {
        return delete $92f21f616111cd14$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $92f21f616111cd14$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$92f21f616111cd14$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($92f21f616111cd14$var$cache[prop] != null) return $92f21f616111cd14$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $92f21f616111cd14$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $92f21f616111cd14$var$propertyDetectors.length; i++){
        $92f21f616111cd14$var$cache[prop] = $92f21f616111cd14$var$propertyDetectors[i](prop, $92f21f616111cd14$var$el.style, options); // Break loop, if value found.
        if ($92f21f616111cd14$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $92f21f616111cd14$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $92f21f616111cd14$var$cache[prop];
}
var $92f21f616111cd14$var$cache$1 = {};
var $92f21f616111cd14$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $92f21f616111cd14$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $92f21f616111cd14$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $92f21f616111cd14$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $92f21f616111cd14$export$ce097f82c2e4551a(p1) : ", " + $92f21f616111cd14$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $6998b862ae22987b$export$2e2bcd8739ae039) $92f21f616111cd14$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $92f21f616111cd14$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$92f21f616111cd14$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($92f21f616111cd14$var$cache$1[cacheKey] != null) return $92f21f616111cd14$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $92f21f616111cd14$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $92f21f616111cd14$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($92f21f616111cd14$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($92f21f616111cd14$var$transPropsRegExp, $92f21f616111cd14$var$prefixTransitionCallback);
    else if ($92f21f616111cd14$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $92f21f616111cd14$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $92f21f616111cd14$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $92f21f616111cd14$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($92f21f616111cd14$var$el$1.style[property] === "") {
            $92f21f616111cd14$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $92f21f616111cd14$var$el$1.style[property] = ""; // Write current value to cache.
    $92f21f616111cd14$var$cache$1[cacheKey] = prefixedValue;
    return $92f21f616111cd14$var$cache$1[cacheKey];
}



/**
 * Add vendor prefix to a property name when needed.
 */ function $4f2160313ee7a81a$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $92f21f616111cd14$export$b6aa0648d950180a)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $92f21f616111cd14$export$ce097f82c2e4551a)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $92f21f616111cd14$export$511766124059c277)(supportedProp, (0, $6c93af1bf2532582$export$5ac341d5e3cf9273)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $92f21f616111cd14$export$511766124059c277)(prop, (0, $6c93af1bf2532582$export$5ac341d5e3cf9273)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $4f2160313ee7a81a$export$2e2bcd8739ae039 = $4f2160313ee7a81a$var$jssVendorPrefixer;


/**
 * Sort props by length.
 */ function $34778fc34e6f563b$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $34778fc34e6f563b$export$2e2bcd8739ae039 = $34778fc34e6f563b$var$jssPropsSort;


function $0df0b52720028187$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $5784f9625d1ab3ac$export$2e2bcd8739ae039)(),
            (0, $1960b1286eeba503$export$2e2bcd8739ae039)(),
            (0, $6a240663d34ed726$export$2e2bcd8739ae039)(),
            (0, $8ef645e4bdd86540$export$2e2bcd8739ae039)(),
            (0, $47d11aab80513aca$export$2e2bcd8739ae039)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $4f2160313ee7a81a$export$2e2bcd8739ae039)(),
            (0, $34778fc34e6f563b$export$2e2bcd8739ae039)()
        ]
    };
}



var $gWMia = parcelRequire("gWMia");
const $bbb8f8e1bb968f76$var$_excluded = [
    "children",
    "injectFirst",
    "disableGeneration"
];
const $bbb8f8e1bb968f76$var$jss = (0, $6c93af1bf2532582$export$185802fd694ee1f5)((0, $0df0b52720028187$export$2e2bcd8739ae039)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const $bbb8f8e1bb968f76$var$generateClassName = (0, $52b48f3a2593a5cc$export$2e2bcd8739ae039)(); // Exported for test purposes
const $bbb8f8e1bb968f76$export$70a8aea9ff58d1cd = new Map();
const $bbb8f8e1bb968f76$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $bbb8f8e1bb968f76$var$generateClassName,
    jss: $bbb8f8e1bb968f76$var$jss,
    sheetsCache: null,
    sheetsManager: $bbb8f8e1bb968f76$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
const $bbb8f8e1bb968f76$export$f4de434b269fe487 = /*#__PURE__*/ $4lkrv.createContext($bbb8f8e1bb968f76$var$defaultOptions);
let $bbb8f8e1bb968f76$var$injectFirstNode;
function $bbb8f8e1bb968f76$export$2e2bcd8739ae039(props) {
    const { children: children , injectFirst: injectFirst = false , disableGeneration: disableGeneration = false  } = props, localOptions = (0, $eLWn9.default)(props, $bbb8f8e1bb968f76$var$_excluded);
    const outerOptions = $4lkrv.useContext($bbb8f8e1bb968f76$export$f4de434b269fe487);
    const context = (0, $9YD4s.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
        if (!$bbb8f8e1bb968f76$var$injectFirstNode) {
            const head = document.head;
            $bbb8f8e1bb968f76$var$injectFirstNode = document.createComment("mui-inject-first");
            head.insertBefore($bbb8f8e1bb968f76$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $6c93af1bf2532582$export$185802fd694ee1f5)({
            plugins: (0, $0df0b52720028187$export$2e2bcd8739ae039)().plugins,
            insertionPoint: $bbb8f8e1bb968f76$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, $gWMia.jsx)($bbb8f8e1bb968f76$export$f4de434b269fe487.Provider, {
        value: context,
        children: children
    });
}


/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
let $8f752c8802f5ff11$var$indexCounter = -1000000000;
function $8f752c8802f5ff11$export$a2647aa13413c947() {
    $8f752c8802f5ff11$var$indexCounter += 1;
    return $8f752c8802f5ff11$var$indexCounter;
}



var $9YD4s = parcelRequire("9YD4s");

var $3ocmy = parcelRequire("3ocmy");

var $eLWn9 = parcelRequire("eLWn9");

var $1Z8IT = parcelRequire("1Z8IT");
const $fa67e6b63cf0d591$var$_excluded = [
    "variant"
];
function $fa67e6b63cf0d591$var$isEmpty(string) {
    return string.length === 0;
}
function $fa67e6b63cf0d591$export$2e2bcd8739ae039(props) {
    const { variant: variant  } = props, other = (0, $eLWn9.default)(props, $fa67e6b63cf0d591$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $fa67e6b63cf0d591$var$isEmpty(classKey) ? props[key] : (0, $1Z8IT.default)(props[key]);
        else classKey += `${$fa67e6b63cf0d591$var$isEmpty(classKey) ? key : (0, $1Z8IT.default)(key)}${(0, $1Z8IT.default)(props[key].toString())}`;
    });
    return classKey;
}



function $5b3e738460a26b79$export$2e2bcd8739ae039(stylesOrCreator) {
    const themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: (theme, name)=>{
            let styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) return styles;
            const overrides = theme.components[name].styleOverrides || {};
            const variants = theme.components[name].variants || [];
            const stylesWithOverrides = (0, $9YD4s.default)({}, styles);
            Object.keys(overrides).forEach((key)=>{
                stylesWithOverrides[key] = (0, $3ocmy.default)(stylesWithOverrides[key] || {}, overrides[key]);
            });
            variants.forEach((definition)=>{
                const classKey = (0, $fa67e6b63cf0d591$export$2e2bcd8739ae039)(definition.props);
                stylesWithOverrides[classKey] = (0, $3ocmy.default)(stylesWithOverrides[classKey] || {}, definition.style);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}


// We use the same empty object to ref count the styles that don't need a theme object.
const $2f09abdb32df2460$var$noopTheme = {};
var $2f09abdb32df2460$export$2e2bcd8739ae039 = $2f09abdb32df2460$var$noopTheme;


const $17f928f289ce2a2e$var$_excluded = [
    "name",
    "classNamePrefix",
    "Component",
    "defaultTheme"
];
function $17f928f289ce2a2e$var$getClasses({ state: state , stylesOptions: stylesOptions  }, classes, Component) {
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    let generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $8666895c57d05125$export$2e2bcd8739ae039)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $17f928f289ce2a2e$var$attach({ state: state , theme: theme , stylesOptions: stylesOptions , stylesCreator: stylesCreator , name: name  }, props) {
    if (stylesOptions.disableGeneration) return;
    let sheetManager = (0, $ff846c141e20127e$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $ff846c141e20127e$export$2e2bcd8739ae039).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    const options = (0, $9YD4s.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        let staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $ff846c141e20127e$export$2e2bcd8739ae039).get(stylesOptions.sheetsCache, stylesCreator, theme);
        const styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $9YD4s.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $ff846c141e20127e$export$2e2bcd8739ae039).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $6c93af1bf2532582$export$8558f2aefa046992)(styles);
    }
    if (sheetManager.dynamicStyles) {
        const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $9YD4s.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $8666895c57d05125$export$2e2bcd8739ae039)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $17f928f289ce2a2e$var$update({ state: state  }, props) {
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $17f928f289ce2a2e$var$detach({ state: state , theme: theme , stylesOptions: stylesOptions , stylesCreator: stylesCreator  }) {
    if (stylesOptions.disableGeneration) return;
    const sheetManager = (0, $ff846c141e20127e$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $ff846c141e20127e$export$2e2bcd8739ae039).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $17f928f289ce2a2e$var$useSynchronousEffect(func, values) {
    const key = $4lkrv.useRef([]);
    let output; // Store "generation" key. Just returns a new object every time
    const currentKey = $4lkrv.useMemo(()=>({}), values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    $4lkrv.useEffect(()=>()=>{
            if (output) output();
        }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $17f928f289ce2a2e$export$2e2bcd8739ae039(stylesOrCreator, options = {}) {
    const { name: // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name , // Help with debuggability.
    classNamePrefix: classNamePrefixOption , Component: Component , defaultTheme: defaultTheme = (0, $2f09abdb32df2460$export$2e2bcd8739ae039)  } = options, stylesOptions2 = (0, $eLWn9.default)(options, $17f928f289ce2a2e$var$_excluded);
    const stylesCreator = (0, $5b3e738460a26b79$export$2e2bcd8739ae039)(stylesOrCreator);
    const classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $8f752c8802f5ff11$export$a2647aa13413c947)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    const useStyles = (props = {})=>{
        const theme = (0, $22e19f93f7ed6f34$export$2e2bcd8739ae039)() || defaultTheme;
        const stylesOptions = (0, $9YD4s.default)({}, $4lkrv.useContext((0, $bbb8f8e1bb968f76$export$f4de434b269fe487)), stylesOptions2);
        const instance = $4lkrv.useRef();
        const shouldUpdate = $4lkrv.useRef();
        $17f928f289ce2a2e$var$useSynchronousEffect(()=>{
            const current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $17f928f289ce2a2e$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return ()=>{
                $17f928f289ce2a2e$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        $4lkrv.useEffect(()=>{
            if (shouldUpdate.current) $17f928f289ce2a2e$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        const classes = $17f928f289ce2a2e$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}



var $gWMia = parcelRequire("gWMia");
const $dcf1329d8b12f8bf$var$_excluded = [
    "name"
], $dcf1329d8b12f8bf$var$_excluded2 = [
    "children",
    "className",
    "clone",
    "component"
];
function $dcf1329d8b12f8bf$var$omit(input, fields) {
    const output = {};
    Object.keys(input).forEach((prop)=>{
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
} // styled-components's API removes the mapping between components and styles.
function $dcf1329d8b12f8bf$export$2e2bcd8739ae039(Component) {
    const componentCreator = (style, options = {})=>{
        const { name: name  } = options, stylesOptions = (0, $eLWn9.default)(options, $dcf1329d8b12f8bf$var$_excluded);
        let classNamePrefix = name;
        const stylesOrCreator = typeof style === "function" ? (theme)=>({
                root: (props)=>style((0, $9YD4s.default)({
                        theme: theme
                    }, props))
            }) : {
            root: style
        };
        const useStyles = (0, $17f928f289ce2a2e$export$2e2bcd8739ae039)(stylesOrCreator, (0, $9YD4s.default)({
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        let filterProps;
        let propTypes = {};
        if (style.filterProps) {
            filterProps = style.filterProps;
            delete style.filterProps;
        }
        /* eslint-disable react/forbid-foreign-prop-types */ if (style.propTypes) {
            propTypes = style.propTypes;
            delete style.propTypes;
        }
        /* eslint-enable react/forbid-foreign-prop-types */ const StyledComponent = /*#__PURE__*/ $4lkrv.forwardRef(function StyledComponent(props, ref) {
            const { children: children , className: classNameProp , clone: clone , component: ComponentProp  } = props, other = (0, $eLWn9.default)(props, $dcf1329d8b12f8bf$var$_excluded2);
            const classes = useStyles(props);
            const className = (0, $iB56s.default)(classes.root, classNameProp);
            let spread = other;
            if (filterProps) spread = $dcf1329d8b12f8bf$var$omit(spread, filterProps);
            if (clone) return /*#__PURE__*/ $4lkrv.cloneElement(children, (0, $9YD4s.default)({
                className: (0, $iB56s.default)(children.props.className, className)
            }, spread));
            if (typeof children === "function") return children((0, $9YD4s.default)({
                className: className
            }, spread));
            const FinalComponent = ComponentProp || Component;
            return /*#__PURE__*/ (0, $gWMia.jsx)(FinalComponent, (0, $9YD4s.default)({
                ref: ref,
                className: className
            }, spread, {
                children: children
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($43t7c)))(StyledComponent, Component);
        return StyledComponent;
    };
    return componentCreator;
}


const $f52640c06fecdae6$var$buttonBarHeight = "60px";
const $f52640c06fecdae6$var$TooltipBox = (0, $dcf1329d8b12f8bf$export$2e2bcd8739ae039)(({ className: className , ...props })=>/*#__PURE__*/ (0, $gWMia.jsx)((0, $a02a42c2a8820b60$export$2e2bcd8739ae039), {
        ...props,
        arrow: true,
        classes: {
            popper: className
        }
    }))(()=>({
        [`& .${(0, $85b42f771dca94f9$export$2e2bcd8739ae039).arrow}`]: {
            color: (0, $5b810149f92fce45$export$2e2bcd8739ae039).colors.greenLightest
        },
        [`& .${(0, $85b42f771dca94f9$export$2e2bcd8739ae039).tooltip}`]: {
            backgroundColor: (0, $5b810149f92fce45$export$2e2bcd8739ae039).colors.greenLightest,
            color: (0, $5b810149f92fce45$export$2e2bcd8739ae039).colors.coolBlueDark,
            maxWidth: 225,
            fontSize: (0, $5b810149f92fce45$export$2e2bcd8739ae039).typography.pxToRem(12),
            border: "1px solid #dadde9",
            borderRadius: 10,
            padding: 10
        }
    }));
const $f52640c06fecdae6$export$9c206965c8c1c7b1 = (props)=>{
    const [selectedMaterialSku, setSelectedMaterialSku] = (0, $4lkrv.useState)(props.materialSku);
    const { otherMaterialCosts: otherMaterialCosts  } = (0, $d717c651d716ec6b$export$38e79abb03ea76a8)(props.materials, props.design, props.showPricesIncTax, true);
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $gWMia.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                sx: {
                    overflow: "auto",
                    position: "sticky",
                    bottom: 0,
                    height: `calc(100vh - ${$f52640c06fecdae6$var$buttonBarHeight})`,
                    maxHeight: {
                        md: 600
                    }
                },
                children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $5dc18c1bf26fdbc8$export$2e2bcd8739ae039), {
                            title: props.translations.cancel,
                            sx: {
                                position: "absolute",
                                top: 0,
                                right: 0.5,
                                color: (theme)=>theme.colors.grey,
                                display: {
                                    md: "none"
                                }
                            },
                            onClick: ()=>props.onCancel(),
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($db4f288fda5f92a7$exports))), {})
                        }),
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                            sx: {
                                marginLeft: 4,
                                marginTop: 2
                            },
                            variant: "h5",
                            children: props.translations.chooseYourMaterial
                        }),
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $981795693fc84723$export$2e2bcd8739ae039), {
                                sx: {
                                    margin: 2,
                                    marginTop: 0,
                                    width: "100%"
                                },
                                children: props.materials.map((material, idx)=>{
                                    const extraCost = otherMaterialCosts[material.sku];
                                    const priceDiff = material.sku === props.design.materialSku ? 0 : extraCost?.price - props.price.price;
                                    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $0a5a8a2907404c73$export$2e2bcd8739ae039), {
                                        sx: {
                                            borderWidth: 1,
                                            borderStyle: "solid",
                                            backgroundColor: material.sku === selectedMaterialSku ? (0, $kFXNp.lighten)((0, $5b810149f92fce45$export$8f45430ccf837300).coolBlueLight, 0.25) : "#fff",
                                            borderRadius: "9px",
                                            marginLeft: 0,
                                            marginBottom: 1,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                            minHeight: priceDiff !== 0 ? 125 : undefined,
                                            cursor: "pointer",
                                            borderColor: "#fff",
                                            "&:hover": {
                                                borderColor: (0, $5b810149f92fce45$export$8f45430ccf837300).coolBlueLight
                                            },
                                            position: "relative",
                                            alignItems: "start"
                                        },
                                        onClick: ()=>{
                                            if (props.onChange) props.onChange(material.sku);
                                            setSelectedMaterialSku(material.sku);
                                        },
                                        children: [
                                            props.onClickInfo ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                                sx: {
                                                    position: "absolute",
                                                    top: 4,
                                                    right: 0
                                                },
                                                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $5dc18c1bf26fdbc8$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        color: (0, $5b810149f92fce45$export$8f45430ccf837300).greyLight,
                                                        zIndex: 9999
                                                    },
                                                    onClick: (ev)=>{
                                                        ev.preventDefault();
                                                        ev.stopPropagation();
                                                        if (props.onClickInfo) props.onClickInfo(material.sku);
                                                    },
                                                    children: /*#__PURE__*/ (0, $gWMia.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04133f85715f197f$exports))), {})
                                                })
                                            }) : null,
                                            material.bestseller ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                                sx: {
                                                    position: "absolute",
                                                    right: 8,
                                                    top: 8
                                                },
                                                children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        px: "10px",
                                                        py: "4px",
                                                        bgcolor: "#FFC000",
                                                        borderRadius: "20px",
                                                        color: (0, $5b810149f92fce45$export$2e2bcd8739ae039).colors.black,
                                                        fontSize: "10px",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $gWMia.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64b0978063c5d8f4$exports))), {
                                                            sx: {
                                                                fontSize: "10px",
                                                                colors: (0, $5b810149f92fce45$export$2e2bcd8739ae039).colors.black
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            sx: {
                                                                ml: "2px"
                                                            },
                                                            children: material.bestseller
                                                        })
                                                    ]
                                                })
                                            }) : null,
                                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                                sx: {
                                                    position: "absolute",
                                                    bottom: 5,
                                                    right: 5,
                                                    borderRadius: 9,
                                                    backgroundColor: (0, $5b810149f92fce45$export$8f45430ccf837300).greenSuperLight,
                                                    padding: 1
                                                },
                                                children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                                    variant: "body2",
                                                    component: "span",
                                                    children: [
                                                        priceDiff > 0 ? "+" : null,
                                                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $6aa7d7a2594069b4$export$49333b01794f7d28), {
                                                            price: priceDiff,
                                                            currencyCode: props.price.currencyCode,
                                                            locale: props.locale
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                                sx: {
                                                    display: "flex"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            width: "70px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $gWMia.jsx)("img", {
                                                            title: material.name,
                                                            alt: `${material.name} icon`,
                                                            loading: idx < 3 ? "eager" : "lazy",
                                                            width: "70",
                                                            height: "70",
                                                            src: material.imageSrc
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: 2
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $gWMia.jsxs)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                                                variant: "h6",
                                                                sx: {
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis"
                                                                },
                                                                children: [
                                                                    material.name,
                                                                    /*#__PURE__*/ (0, $gWMia.jsx)($f52640c06fecdae6$var$TooltipBox, {
                                                                        title: /*#__PURE__*/ (0, $gWMia.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                                                                    color: "inherit",
                                                                                    sx: {
                                                                                        fontWeight: 600
                                                                                    },
                                                                                    children: material.name
                                                                                }),
                                                                                /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                                                                    component: "p",
                                                                                    sx: {
                                                                                        fontSize: "12px"
                                                                                    },
                                                                                    children: material.description
                                                                                })
                                                                            ]
                                                                        }),
                                                                        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04133f85715f197f$exports))), {
                                                                            sx: {
                                                                                fontSize: 16,
                                                                                color: (0, $5b810149f92fce45$export$2e2bcd8739ae039).colors.coolBlue,
                                                                                cursor: "pointer",
                                                                                ml: "5px",
                                                                                position: "relative",
                                                                                top: "2.5px"
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                                                variant: "body2",
                                                                sx: {
                                                                    marginTop: 1
                                                                },
                                                                children: material.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, material.sku);
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $04165d3803d5a8b7$export$f5a845d4be3630ee), {
                sx: {
                    height: $f52640c06fecdae6$var$buttonBarHeight,
                    paddingTop: 0.5
                },
                children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 6,
                            sx: {
                                padding: 1
                            },
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $c57a8262ea075bfb$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                fullWidth: true,
                                onClick: ()=>props.onCancel(),
                                children: props.translations.cancel
                            })
                        }),
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 6,
                            sx: {
                                padding: 1
                            },
                            onClick: ()=>props.onChangeConfirmed(selectedMaterialSku),
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $c57a8262ea075bfb$export$2e2bcd8739ae039), {
                                variant: "contained",
                                color: "primary",
                                fullWidth: true,
                                children: props.translations.continue
                            })
                        })
                    ]
                })
            })
        ]
    });
};



var $gWMia = parcelRequire("gWMia");

var $4lkrv = parcelRequire("4lkrv");







var $kFXNp = parcelRequire("kFXNp");




const $1535d0b0f5da64f5$var$buttonBarHeight = "60px";
const $1535d0b0f5da64f5$export$4125d34c01d0d379 = (props)=>{
    const theme = (0, $0fbff9e4f89c0f97$export$2e2bcd8739ae039)();
    const [selectedShape, setSelectedShape] = (0, $4lkrv.useState)(props.shape);
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $gWMia.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                sx: {
                    overflow: "auto",
                    position: "sticky",
                    bottom: 0,
                    height: `calc(100vh - ${$1535d0b0f5da64f5$var$buttonBarHeight})`,
                    [theme.breakpoints.up("md")]: {
                        maxHeight: 600
                    }
                },
                children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $5dc18c1bf26fdbc8$export$2e2bcd8739ae039), {
                            title: props.translations.cancel,
                            sx: {
                                position: "absolute",
                                top: 0,
                                right: 0.5,
                                color: theme.colors.grey,
                                display: {
                                    md: "none"
                                }
                            },
                            onClick: ()=>props.onCancel(),
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($db4f288fda5f92a7$exports))), {})
                        }),
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                            sx: {
                                textAlign: "center",
                                marginTop: 2
                            },
                            variant: "h3",
                            children: props.translations.title
                        }),
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $981795693fc84723$export$2e2bcd8739ae039), {
                                sx: {
                                    margin: 2
                                },
                                children: props.shapes.map(({ name: name , shape: shape , description: description , imageSrc: imageSrc  })=>{
                                    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $0a5a8a2907404c73$export$2e2bcd8739ae039), {
                                        sx: {
                                            borderWidth: 2,
                                            borderStyle: "solid",
                                            backgroundColor: shape === selectedShape ? (0, $kFXNp.lighten)((0, $5b810149f92fce45$export$8f45430ccf837300).coolBlueLight, 0.25) : "#fff",
                                            borderColor: "#fff",
                                            borderRadius: "5px",
                                            marginLeft: 0,
                                            marginBottom: 1,
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            cursor: "pointer",
                                            "&:hover": {
                                                borderColor: (0, $5b810149f92fce45$export$8f45430ccf837300).coolBlueLight
                                            }
                                        },
                                        onClick: ()=>{
                                            setSelectedShape(shape);
                                        },
                                        children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                            container: true,
                                            children: [
                                                /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: 3,
                                                    children: /*#__PURE__*/ (0, $gWMia.jsx)("img", {
                                                        title: name,
                                                        alt: `${name} icon`,
                                                        width: "100%",
                                                        src: imageSrc
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    xs: 9,
                                                    children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            marginLeft: 4
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                                                component: "div",
                                                                variant: "h4",
                                                                sx: {
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis"
                                                                },
                                                                children: props.translations.shapes[shape]
                                                            }),
                                                            description ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                                                variant: "body2",
                                                                sx: {
                                                                    marginTop: 1
                                                                },
                                                                children: description
                                                            }) : null
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }, shape);
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $04165d3803d5a8b7$export$f5a845d4be3630ee), {
                sx: {
                    height: $1535d0b0f5da64f5$var$buttonBarHeight,
                    paddingTop: 0.5
                },
                children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 6,
                            sx: {
                                padding: 1
                            },
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $c57a8262ea075bfb$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                fullWidth: true,
                                onClick: ()=>props.onCancel(),
                                children: props.translations.cancel
                            })
                        }),
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 6,
                            sx: {
                                padding: 1
                            },
                            onClick: ()=>props.onChangeConfirmed(selectedShape),
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $c57a8262ea075bfb$export$2e2bcd8739ae039), {
                                variant: "contained",
                                color: "primary",
                                fullWidth: true,
                                children: props.translations.continue
                            })
                        })
                    ]
                })
            })
        ]
    });
};



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");


var $lJkvk = parcelRequire("lJkvk");




var $at7OG = parcelRequire("at7OG");

var $bgnZl = parcelRequire("bgnZl");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $357e8ae679e036d0$export$2177af0aa15c34c2(slot) {
    return (0, $1HGD7.default)("MuiDialog", slot);
}
const $357e8ae679e036d0$var$dialogClasses = (0, $3TIMy.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $357e8ae679e036d0$export$2e2bcd8739ae039 = $357e8ae679e036d0$var$dialogClasses;



var $4lkrv = parcelRequire("4lkrv");
const $d7d9d303195ccc03$var$DialogContext = /*#__PURE__*/ (0, $4lkrv.createContext)({});
var $d7d9d303195ccc03$export$2e2bcd8739ae039 = $d7d9d303195ccc03$var$DialogContext;





var $gWMia = parcelRequire("gWMia");
const $d0738d14f749e262$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $d0738d14f749e262$var$DialogBackdrop = (0, $bgnZl.default)((0, $9c4b5c2a5380ab28$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $d0738d14f749e262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , scroll: scroll , maxWidth: maxWidth , fullWidth: fullWidth , fullScreen: fullScreen  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $lJkvk.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $lJkvk.default)(scroll)}`,
            `paperWidth${(0, $lJkvk.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $357e8ae679e036d0$export$2177af0aa15c34c2), classes);
};
const $d0738d14f749e262$var$DialogRoot = (0, $bgnZl.default)((0, $381898583d2692cc$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $d0738d14f749e262$var$DialogContainer = (0, $bgnZl.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.container,
            styles[`scroll${(0, $lJkvk.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $d0738d14f749e262$var$DialogPaper = (0, $bgnZl.default)((0, $21e6fd1e4a152e6c$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $lJkvk.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $lJkvk.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `${theme.breakpoints.values.xs}${theme.breakpoints.unit}`,
        [`&.${(0, $357e8ae679e036d0$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $357e8ae679e036d0$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $357e8ae679e036d0$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $d0738d14f749e262$var$Dialog = /*#__PURE__*/ $4lkrv.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $0fbff9e4f89c0f97$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby , "aria-labelledby": ariaLabelledbyProp , BackdropComponent: BackdropComponent , BackdropProps: BackdropProps , children: children , className: className , disableEscapeKeyDown: disableEscapeKeyDown = false , fullScreen: fullScreen = false , fullWidth: fullWidth = false , maxWidth: maxWidth = "sm" , onBackdropClick: onBackdropClick , onClose: onClose , open: open , PaperComponent: PaperComponent = (0, $21e6fd1e4a152e6c$export$2e2bcd8739ae039) , PaperProps: PaperProps = {} , scroll: scroll = "paper" , TransitionComponent: TransitionComponent = (0, $caa37e747bd4f08b$export$2e2bcd8739ae039) , transitionDuration: transitionDuration = defaultTransitionDuration , TransitionProps: TransitionProps  } = props, other = (0, $eLWn9.default)(props, $d0738d14f749e262$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $d0738d14f749e262$var$useUtilityClasses(ownerState);
    const backdropClick = $4lkrv.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $5ab99b711f62def3$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $4lkrv.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $gWMia.jsx)($d0738d14f749e262$var$DialogRoot, (0, $9YD4s.default)({
        className: (0, $iB56s.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $d0738d14f749e262$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $9YD4s.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $gWMia.jsx)(TransitionComponent, (0, $9YD4s.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $gWMia.jsx)($d0738d14f749e262$var$DialogContainer, {
                className: (0, $iB56s.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $gWMia.jsx)($d0738d14f749e262$var$DialogPaper, (0, $9YD4s.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $iB56s.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $d7d9d303195ccc03$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $d0738d14f749e262$export$2e2bcd8739ae039 = $d0738d14f749e262$var$Dialog;


var $4lkrv = parcelRequire("4lkrv");

var $goj8c = parcelRequire("goj8c");
var $idqiR = parcelRequire("idqiR");

/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ function $88611cfcea8437c0$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const [match, setMatch] = $4lkrv.useState(()=>{
        if (noSsr && supportMatchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
         // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $c3a88e87df6459f2$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!supportMatchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch(); // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia,
        supportMatchMedia
    ]);
    return match;
} // eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $88611cfcea8437c0$var$maybeReactUseSyncExternalStore = $4lkrv.useSyncExternalStore;
function $88611cfcea8437c0$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia) {
    const getDefaultSnapshot = $4lkrv.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $4lkrv.useMemo(()=>{
        if (ssrMatchMedia !== null) {
            const { matches: matches  } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia
    ]);
    const [getSnapshot, subscribe] = $4lkrv.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $88611cfcea8437c0$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $88611cfcea8437c0$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $idqiR.default)(); // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false , matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null , ssrMatchMedia: ssrMatchMedia = null , noSsr: noSsr  } = (0, $goj8c.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, ""); // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $88611cfcea8437c0$var$maybeReactUseSyncExternalStore !== undefined ? $88611cfcea8437c0$var$useMediaQueryNew : $88611cfcea8437c0$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}



const $d5fd773e72f9cc9f$var$chooser = (props)=>{
    switch(props?.type){
        case "shape":
            return /*#__PURE__*/ (0, $gWMia.jsx)((0, $1535d0b0f5da64f5$export$4125d34c01d0d379), {
                ...props
            });
        case "material":
            return /*#__PURE__*/ (0, $gWMia.jsx)((0, $f52640c06fecdae6$export$9c206965c8c1c7b1), {
                ...props
            });
    }
    return null;
};
const $d5fd773e72f9cc9f$var$FullScreenDialog = (props)=>{
    const theme = (0, $0fbff9e4f89c0f97$export$2e2bcd8739ae039)();
    const isFullScreen = (0, $88611cfcea8437c0$export$2e2bcd8739ae039)(theme.breakpoints.down("md"));
    return isFullScreen ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $d0738d14f749e262$export$2e2bcd8739ae039), {
        open: true,
        fullScreen: true,
        children: $d5fd773e72f9cc9f$var$chooser(props)
    }) : /*#__PURE__*/ (0, $gWMia.jsx)((0, $gWMia.Fragment), {
        children: $d5fd773e72f9cc9f$var$chooser(props)
    });
};
var $d5fd773e72f9cc9f$export$2e2bcd8739ae039 = $d5fd773e72f9cc9f$var$FullScreenDialog;




var $gWMia = parcelRequire("gWMia");

parcelRequire("4lkrv");

const $8647b94ffb2df117$var$ShapeSection = (props)=>{
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $5f7e2c6633a64ab9$export$6e2c8f0811a474ce), {
        number: 2,
        title: props.translations.selectYourShape,
        "data-section": "Shape",
        sx: {
            px: {
                md: "23px"
            }
        },
        children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $e8d14b4c1acbbd03$export$2e2bcd8739ae039), {
            fullWidth: true,
            children: [
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $c7c5c012b882f66d$export$2e2bcd8739ae039), {
                    id: "select-shape-label",
                    children: props.translations.shapeLabel
                }),
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $6cd68c276cf6dda7$export$2e2bcd8739ae039), {
                    labelId: "select-shape-label",
                    id: "select-shape",
                    value: props.shape,
                    label: props.translations.shapeLabel,
                    sx: {
                        maxWidth: {
                            xs: "100%",
                            md: "276px"
                        }
                    },
                    open: props.open,
                    onOpen: props.onOpenShapes,
                    onChange: (ev)=>{
                        props.onChangeComplete(ev.target.value);
                    },
                    children: props.shapes.map((shape)=>{
                        return /*#__PURE__*/ (0, $gWMia.jsx)((0, $1faef22859109c7a$export$2e2bcd8739ae039), {
                            value: shape.shape,
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                container: true,
                                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 6,
                                    children: props.translations.shapes[shape.shape]
                                })
                            })
                        }, shape.shape);
                    })
                })
            ]
        })
    }, "shape");
};
var $8647b94ffb2df117$export$2e2bcd8739ae039 = $8647b94ffb2df117$var$ShapeSection;



var $gWMia = parcelRequire("gWMia");


var $4lkrv = parcelRequire("4lkrv");

var $bgnZl = parcelRequire("bgnZl");


const $35a4787718bcca00$var$StyledTextField = (0, $bgnZl.default)((props)=>/*#__PURE__*/ (0, $gWMia.jsx)((0, $3e443e1578d52cec$export$2e2bcd8739ae039), {
        ...props
    }))(({ theme: theme  })=>({
        width: "110px",
        "& .MuiFormHelperText-root": {
            margin: 4,
            marginRight: 0,
            fontSize: 10,
            [theme.breakpoints.down("md")]: {
                fontSize: 9
            }
        },
        [theme.breakpoints.down("md")]: {
            width: "100px"
        }
    }));
const $35a4787718bcca00$export$1640d03394074b8a = (props)=>{
    const id = (0, $4lkrv.useId)();
    const labelId = (0, $4lkrv.useId)();
    const { units: units  } = props;
    const [displayAs, setDisplayAs] = (0, $4lkrv.useState)(props.displayAs || "cm");
    const [width, setWidth] = (0, $4lkrv.useState)(props.width.toString());
    const [height, setHeight] = (0, $4lkrv.useState)(props.height.toString());
    const widthNum = parseFloat(width);
    const heightNum = parseFloat(height);
    //   useEffect(() => {
    //     if (errors) {
    //       return;
    //     }
    //     props.onChangeConfirmed(widthNum, heightNum, displayAs);
    //   }, [errors, widthNum, heightNum, displayAs]);
    const t = (0, $18550a1b1cf51454$export$2e2bcd8739ae039)(props.translations);
    const label = "Button/Badge Size";
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
        container: true,
        alignItems: "center",
        sx: {
            position: "relative"
        },
        children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $e8d14b4c1acbbd03$export$2e2bcd8739ae039), {
            fullWidth: true,
            children: [
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $c7c5c012b882f66d$export$2e2bcd8739ae039), {
                    id: labelId,
                    children: label
                }),
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $6cd68c276cf6dda7$export$2e2bcd8739ae039), {
                    labelId: labelId,
                    id: id,
                    value: (0, $7972a9f32c26a5b9$export$9c68d69a4c5bbcf9)(props.units, props.displayAs, props.width),
                    label: label,
                    sx: {
                        maxWidth: {
                            xs: "100%",
                            md: "276px"
                        }
                    },
                    onChange: (ev)=>{
                        props.onChangeConfirmed(+ev.target.value, +ev.target.value, "mm");
                    },
                    children: props.options.map((opt)=>{
                        return /*#__PURE__*/ (0, $gWMia.jsx)((0, $1faef22859109c7a$export$2e2bcd8739ae039), {
                            value: opt.width,
                            children: opt.title
                        }, opt.title);
                    })
                })
            ]
        })
    });
};


const $2be5a94a1fa4afe8$var$buttonsOptions = [
    {
        title: `25mm (1")`,
        width: 25,
        height: 25,
        units: "mm"
    },
    {
        title: `32mm (1.25")`,
        width: 32,
        height: 32,
        units: "mm"
    },
    {
        title: `37mm (1.5")`,
        width: 37,
        height: 37,
        units: "mm"
    },
    {
        title: `58mm (2.25")`,
        width: 58,
        height: 58,
        units: "mm"
    }
];
const $2be5a94a1fa4afe8$export$6d2ecb7fe3aeded9 = (props)=>{
    const { PricingCalculator: translations  } = props.allTranslations;
    const [quantity, setQuantity] = (0, $4lkrv.useState)(props.quantity.toString());
    const [width, setWidth] = (0, $4lkrv.useState)(props.width);
    const [height, setHeight] = (0, $4lkrv.useState)(props.height);
    const quantityNum = parseInt(quantity);
    const [units, setUnits] = (0, $4lkrv.useState)(props.units);
    const [materialSku, setMaterialSku] = (0, $4lkrv.useState)(props.defaultMaterialSku);
    const [shape, setShape] = (0, $4lkrv.useState)(props.shape);
    const [changed, setChanged] = (0, $4lkrv.useState)({
        width: width,
        height: height,
        quantity: quantityNum,
        units: units,
        materialSku: materialSku,
        shape: shape
    });
    const debouncedChanged = (0, $f07e996c3fe7b389$export$2e2bcd8739ae039)(changed, 100);
    const [view, setView] = (0, $4lkrv.useState)("pc");
    (0, $4lkrv.useEffect)(()=>{
        setMaterialSku(props.defaultMaterialSku);
        setShape(props.shape);
    }, [
        props.defaultMaterialSku,
        props.shape
    ]);
    (0, $4lkrv.useEffect)(()=>{
        const { width: width , height: height , quantity: quantity , materialSku: materialSku , units: units  } = debouncedChanged;
        if (isNaN(width) || isNaN(height) || isNaN(quantity)) return;
        props.onChangeComplete(width, height, quantity, materialSku, shape, units);
    }, [
        debouncedChanged
    ]);
    const tr = (0, $18550a1b1cf51454$export$2e2bcd8739ae039)({
        ...translations,
        cm: props.allTranslations.Dimensions.cm,
        in: props.allTranslations.Dimensions.in
    });
    const t = (0, $18550a1b1cf51454$export$2a099a09599f0bc7)(tr, {
        units: units,
        width: width,
        height: height,
        moq: props.moq,
        minDimensions: props.minDimensions,
        maxDimensions: props.maxDimensions
    });
    function handleCustomPricing(price) {
        setQuantity(price.quantity.toString());
        setChanged((prev)=>{
            return {
                ...prev,
                quantity: price.quantity
            };
        });
    }
    function handleSetMaterial(materialSku) {
        setMaterialSku(materialSku);
        setChanged((prev)=>{
            return {
                ...prev,
                materialSku: materialSku
            };
        });
        setView("pc");
    }
    function handleSetShape(shape) {
        setShape(shape);
        setChanged((prev)=>{
            return {
                ...prev,
                shape: shape
            };
        });
        setView("pc");
    }
    function handleCustomQuantity(ev) {
        setQuantity(ev.target.value);
        setChanged((prev)=>{
            return {
                ...prev,
                quantity: +ev.target.value
            };
        });
    }
    const quantityError = props.price === null || quantityNum < props.moq;
    const isButton = props.productSku?.startsWith("BUTTONS-") || props.productSku?.includes("SAMPLE-BUTTONS");
    const usesDimensionsOptions = isButton;
    if (view === "materials") return /*#__PURE__*/ (0, $gWMia.jsx)((0, $d5fd773e72f9cc9f$export$2e2bcd8739ae039), {
        type: "material",
        materials: props.materials,
        locale: props.locale,
        materialSku: materialSku,
        design: {
            productSku: props.productSku,
            quantity: quantityNum,
            width: width,
            height: height,
            unit: units,
            materialSku: materialSku,
            shape: shape
        },
        price: props.price,
        showPricesIncTax: props.pricesIncTax,
        onChangeConfirmed: handleSetMaterial,
        onCancel: ()=>setView("pc"),
        translations: props.allTranslations.MaterialChooser
    });
    else if (view === "shapes") return /*#__PURE__*/ (0, $gWMia.jsx)((0, $d5fd773e72f9cc9f$export$2e2bcd8739ae039), {
        type: "shape",
        shape: shape,
        // locale={props.locale}
        shapes: props.shapes || [],
        onChangeConfirmed: handleSetShape,
        onCancel: ()=>setView("pc"),
        translations: {
            ...props.allTranslations.ShapeChooser,
            shapes: props.allTranslations.Shapes
        }
    });
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $gWMia.Fragment), {
        children: [
            props.dimensionsEnabled ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                sx: {
                    paddingLeft: {
                        xs: "14px",
                        md: "26px"
                    },
                    paddingRight: {
                        xs: "14px",
                        md: "26px"
                    }
                },
                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $5f7e2c6633a64ab9$export$6e2c8f0811a474ce), {
                    number: 1,
                    title: t(isButton ? "chooseSize" : "enterSize"),
                    subtitle: isButton ? undefined : t("enterSizeDesc"),
                    "data-section": "Size",
                    sx: {
                        px: {
                            md: "23px"
                        }
                    },
                    children: usesDimensionsOptions ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $35a4787718bcca00$export$1640d03394074b8a), {
                        width: props.width,
                        height: props.height,
                        units: props.units,
                        displayAs: "mm",
                        options: $2be5a94a1fa4afe8$var$buttonsOptions,
                        onChangeConfirmed: (newWidth, newHeight, newUnits)=>{
                            setWidth(newWidth);
                            setHeight(newHeight);
                            setUnits(newUnits);
                            setChanged((prev)=>{
                                return {
                                    ...prev,
                                    width: newWidth,
                                    height: newHeight,
                                    units: newUnits
                                };
                            });
                        },
                        showInches: props.showInches,
                        translations: props.allTranslations.Dimensions
                    }) : /*#__PURE__*/ (0, $gWMia.jsx)((0, $6e15a2f1d483daf7$export$d5b8c1948b345816), {
                        width: props.width,
                        height: props.height,
                        units: props.units,
                        displayAs: props.units,
                        minDimensions: props.minDimensions,
                        maxDimensions: props.maxDimensions,
                        fixedAspectRatio: props.fixedAspectRatio,
                        onChangeConfirmed: (newWidth, newHeight, newUnits)=>{
                            setWidth(newWidth);
                            setHeight(newHeight);
                            setUnits(newUnits);
                            setChanged((prev)=>{
                                return {
                                    ...prev,
                                    width: newWidth,
                                    height: newHeight,
                                    units: newUnits
                                };
                            });
                        },
                        showInches: props.showInches,
                        translations: props.allTranslations.Dimensions
                    })
                }, "size")
            }) : null,
            /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                sx: {
                    paddingLeft: {
                        xs: "14px",
                        md: "26px"
                    },
                    paddingRight: {
                        xs: "14px",
                        md: "26px"
                    }
                },
                children: [
                    props.materialEnabled && props.materials.length > 1 ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $0d00bee21f2c0aec$export$2e2bcd8739ae039), {
                        materials: props.materials || [],
                        materialSku: materialSku || props.defaultMaterialSku,
                        translations: {
                            materialLabel: translations.materialLabel,
                            selectYourMaterial: translations.selectYourMaterial,
                            bestseller: translations.bestseller
                        },
                        onChangeComplete: (materialSku)=>{
                            setMaterialSku(materialSku);
                            setChanged((prev)=>{
                                return {
                                    ...prev,
                                    materialSku: materialSku
                                };
                            });
                        },
                        onOpenMaterials: ()=>{
                            setView("materials");
                        }
                    }) : null,
                    props.shapeEnabled && props.shapes && props.shapes.length > 1 ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $8647b94ffb2df117$export$2e2bcd8739ae039), {
                        shapes: props.shapes || [],
                        shape: shape,
                        translations: {
                            shapeLabel: translations.shapeLabel,
                            selectYourShape: translations.selectYourShape,
                            shapes: props.allTranslations.Shapes
                        },
                        onChangeComplete: (shape)=>{
                            setShape(shape);
                            setChanged((prev)=>{
                                return {
                                    ...prev,
                                    shape: shape
                                };
                            });
                        },
                        onOpenShapes: ()=>{
                            setView("shapes");
                        }
                    }) : null,
                    props.quantityEnabled ? /*#__PURE__*/ (0, $gWMia.jsx)((0, $759bd2a6351c3477$export$2e2bcd8739ae039), {
                        translations: {
                            enterSize: translations.enterSize,
                            customQuantityLabel: translations.customQuantityLabel,
                            quantitySubtitle: t("quantitySubtitle"),
                            incTax: translations.incTax,
                            exTax: translations.exTax,
                            save: translations.save,
                            quantityTitle: translations.quantityTitle,
                            quantityLabel: translations.quantityLabel,
                            quantityHelperText: translations.quantityHelperText
                        },
                        prices: props.prices,
                        pricesIncTax: props.pricesIncTax,
                        handleCustomPricing: handleCustomPricing,
                        handleCustomQuantity: handleCustomQuantity,
                        moq: props.moq,
                        quantity: props.quantity,
                        locale: props.locale,
                        price: props.price,
                        quantityError: quantityError
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $15f157c1531c2362$export$2e2bcd8739ae039), {
                graphicMode: props.graphicMode,
                loading: false,
                currencyCode: props.currencyCode,
                locale: props.locale,
                quantity: quantityNum,
                handleSubmit: props.onSubmit,
                moq: props.moq,
                price: props.price,
                translations: {
                    continue: translations.continue,
                    customize: translations.customize,
                    addToCart: translations.addToCart,
                    uploadText: translations.uploadText
                }
            })
        ]
    });
};



var $gWMia = parcelRequire("gWMia");
parcelRequire("4lkrv");

const $e6be050d098f57b5$var$borderRadius = {
    xs: 4,
    md: 6
};
const $e6be050d098f57b5$export$4faac3888fb5e689 = (props)=>{
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
        "data-component": "PricingContainer",
        sx: {
            width: "100%",
            maxWidth: 414,
            border: (theme)=>{
                return {
                    xs: `4px solid ${theme.colors.greenLightest}`,
                    md: `8px solid ${theme.colors.greenLightest}`
                };
            },
            borderTop: (theme)=>{
                return {
                    md: `8px solid ${theme.colors.greenLightest}`
                };
            },
            backgroundColor: (theme)=>`${theme.colors.greenLightest}`,
            borderRadius: $e6be050d098f57b5$var$borderRadius,
            boxShadow: {
                xs: "none",
                md: "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
            },
            ...props.sx
        },
        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
            sx: {
                backgroundColor: "#fff",
                borderRadius: $e6be050d098f57b5$var$borderRadius,
                ...props.customWidthHeight
            },
            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                style: {
                    paddingTop: 4
                },
                children: props.children
            })
        })
    });
};




var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $at7OG = parcelRequire("at7OG");


var $gWMia = parcelRequire("gWMia");
const $11b3930c194468cc$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $9YD4s.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && {
        colorScheme: theme.palette.mode
    });
const $11b3930c194468cc$export$32180ef41b15b513 = (theme)=>(0, $9YD4s.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $11b3930c194468cc$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components, _theme$components$Mui;
    let defaultStyles = {
        html: $11b3930c194468cc$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $9YD4s.default)({
            margin: 0
        }, $11b3930c194468cc$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    };
    const themeOverrides = (_theme$components = theme.components) == null ? void 0 : (_theme$components$Mui = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components$Mui.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $11b3930c194468cc$var$CssBaseline(inProps) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children , enableColorScheme: enableColorScheme = false  } = props;
    return /*#__PURE__*/ (0, $gWMia.jsxs)($4lkrv.Fragment, {
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $a7b2bbb01cfa3e26$export$2e2bcd8739ae039), {
                styles: (theme)=>$11b3930c194468cc$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $11b3930c194468cc$export$2e2bcd8739ae039 = $11b3930c194468cc$var$CssBaseline;


var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");






var $gWMia = parcelRequire("gWMia");
function $33261db42cec9e47$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $9YD4s.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $33261db42cec9e47$var$ThemeProvider(props) {
    const { children: children , theme: localTheme  } = props;
    const outerTheme = (0, $22e19f93f7ed6f34$export$2e2bcd8739ae039)();
    const theme = $4lkrv.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $33261db42cec9e47$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $49d61b77f5a8b65e$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $e23b4c1380107a86$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $33261db42cec9e47$export$2e2bcd8739ae039 = $33261db42cec9e47$var$ThemeProvider;



parcelRequire("35uzv");
var $3SpgA = parcelRequire("3SpgA");

var $idqiR = parcelRequire("idqiR");

var $gWMia = parcelRequire("gWMia");
const $5f631035ddfc3cd7$var$EMPTY_THEME = {};
function $5f631035ddfc3cd7$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $4lkrv.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $9YD4s.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $9YD4s.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $9YD4s.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $5f631035ddfc3cd7$var$ThemeProvider(props) {
    const { children: children , theme: localTheme , themeId: themeId  } = props;
    const upperTheme = (0, $idqiR.default)($5f631035ddfc3cd7$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $22e19f93f7ed6f34$export$2e2bcd8739ae039)() || $5f631035ddfc3cd7$var$EMPTY_THEME;
    const engineTheme = $5f631035ddfc3cd7$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $5f631035ddfc3cd7$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $33261db42cec9e47$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $3SpgA.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $5f631035ddfc3cd7$export$2e2bcd8739ae039 = $5f631035ddfc3cd7$var$ThemeProvider;



var $gWMia = parcelRequire("gWMia");

var $4lkrv = parcelRequire("4lkrv");
/* eslint-disable material-ui/mui-name-matches-component-name */ 

var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $1Z8IT = parcelRequire("1Z8IT");
var $kdLbD = parcelRequire("kdLbD");
var $1HGD7 = parcelRequire("1HGD7");

var $bS3WL = parcelRequire("bS3WL");

var $i0DZt = parcelRequire("i0DZt");
const $0c78207bdf367cdd$var$styled = (0, $i0DZt.default)();
var $0c78207bdf367cdd$export$2e2bcd8739ae039 = $0c78207bdf367cdd$var$styled;



var $l77nE = parcelRequire("l77nE");

var $gWMia = parcelRequire("gWMia");
const $118b180aba8d0040$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $118b180aba8d0040$var$defaultTheme = (0, $l77nE.default)();
const $118b180aba8d0040$var$defaultCreateStyledComponent = (0, $0c78207bdf367cdd$export$2e2bcd8739ae039)("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $1Z8IT.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $118b180aba8d0040$var$useThemePropsDefault = (inProps)=>(0, $bS3WL.default)({
        props: inProps,
        name: "MuiContainer",
        defaultTheme: $118b180aba8d0040$var$defaultTheme
    });
const $118b180aba8d0040$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $1HGD7.default)(componentName, slot);
    };
    const { classes: classes , fixed: fixed , disableGutters: disableGutters , maxWidth: maxWidth  } = ownerState;
    const slots = {
        root: [
            "root",
            maxWidth && `maxWidth${(0, $1Z8IT.default)(String(maxWidth))}`,
            fixed && "fixed",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $kdLbD.default)(slots, getContainerUtilityClass, classes);
};
function $118b180aba8d0040$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $118b180aba8d0040$var$defaultCreateStyledComponent , useThemeProps: useThemeProps = $118b180aba8d0040$var$useThemePropsDefault , componentName: componentName = "MuiContainer"  } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            display: "block"
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("sm")]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme , ownerState: ownerState  })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({}, ownerState.maxWidth === "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("xs")]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $4lkrv.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className , component: component = "div" , disableGutters: disableGutters = false , fixed: fixed = false , maxWidth: maxWidth = "lg"  } = props, other = (0, $eLWn9.default)(props, $118b180aba8d0040$var$_excluded);
        const ownerState = (0, $9YD4s.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $118b180aba8d0040$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $gWMia.jsx)(ContainerRoot, (0, $9YD4s.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $iB56s.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $lJkvk = parcelRequire("lJkvk");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");
const $79506d4265a38831$var$Container = (0, $118b180aba8d0040$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $bgnZl.default)("div", {
        name: "MuiContainer",
        slot: "Root",
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState  } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $lJkvk.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $at7OG.default)({
            props: inProps,
            name: "MuiContainer"
        })
});
var $79506d4265a38831$export$2e2bcd8739ae039 = $79506d4265a38831$var$Container;


var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $35uzv = parcelRequire("35uzv");
var $kFXNp = parcelRequire("kFXNp");

var $lJkvk = parcelRequire("lJkvk");


var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");

var $1HGD7 = parcelRequire("1HGD7");
var $3TIMy = parcelRequire("3TIMy");
function $e43918e5ea6112bf$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $1HGD7.default)("MuiLinearProgress", slot);
}
const $e43918e5ea6112bf$var$linearProgressClasses = (0, $3TIMy.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
var $e43918e5ea6112bf$export$2e2bcd8739ae039 = $e43918e5ea6112bf$var$linearProgressClasses;



var $gWMia = parcelRequire("gWMia");
const $c508cdd3f8306af1$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $c508cdd3f8306af1$var$_ = (t)=>t, $c508cdd3f8306af1$var$_t, $c508cdd3f8306af1$var$_t2, $c508cdd3f8306af1$var$_t3, $c508cdd3f8306af1$var$_t4, $c508cdd3f8306af1$var$_t5, $c508cdd3f8306af1$var$_t6;
const $c508cdd3f8306af1$var$TRANSITION_DURATION = 4; // seconds
const $c508cdd3f8306af1$var$indeterminate1Keyframe = (0, $35uzv.keyframes)($c508cdd3f8306af1$var$_t || ($c508cdd3f8306af1$var$_t = $c508cdd3f8306af1$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $c508cdd3f8306af1$var$indeterminate2Keyframe = (0, $35uzv.keyframes)($c508cdd3f8306af1$var$_t2 || ($c508cdd3f8306af1$var$_t2 = $c508cdd3f8306af1$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $c508cdd3f8306af1$var$bufferKeyframe = (0, $35uzv.keyframes)($c508cdd3f8306af1$var$_t3 || ($c508cdd3f8306af1$var$_t3 = $c508cdd3f8306af1$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $c508cdd3f8306af1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , color: color  } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $lJkvk.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, $lJkvk.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, $lJkvk.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, $lJkvk.default)(color)}`,
            variant === "buffer" && `color${(0, $lJkvk.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $e43918e5ea6112bf$export$bc8a6ea1eb17d7c6), classes);
};
const $c508cdd3f8306af1$var$getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, $kFXNp.lighten)(theme.palette[color].main, 0.62) : (0, $kFXNp.darken)(theme.palette[color].main, 0.5);
};
const $c508cdd3f8306af1$var$LinearProgressRoot = (0, $bgnZl.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[`color${(0, $lJkvk.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState , theme: theme  })=>(0, $9YD4s.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: $c508cdd3f8306af1$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const $c508cdd3f8306af1$var$LinearProgressDashed = (0, $bgnZl.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $lJkvk.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState , theme: theme  })=>{
    const backgroundColor = $c508cdd3f8306af1$var$getColorShade(theme, ownerState.color);
    return (0, $9YD4s.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, $35uzv.css)($c508cdd3f8306af1$var$_t4 || ($c508cdd3f8306af1$var$_t4 = $c508cdd3f8306af1$var$_`
    animation: ${0} 3s infinite linear;
  `), $c508cdd3f8306af1$var$bufferKeyframe));
const $c508cdd3f8306af1$var$LinearProgressBar1 = (0, $bgnZl.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $lJkvk.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState , theme: theme  })=>(0, $9YD4s.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${$c508cdd3f8306af1$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${$c508cdd3f8306af1$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState  })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $35uzv.css)($c508cdd3f8306af1$var$_t5 || ($c508cdd3f8306af1$var$_t5 = $c508cdd3f8306af1$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $c508cdd3f8306af1$var$indeterminate1Keyframe));
const $c508cdd3f8306af1$var$LinearProgressBar2 = (0, $bgnZl.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $lJkvk.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState , theme: theme  })=>(0, $9YD4s.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: $c508cdd3f8306af1$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$c508cdd3f8306af1$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState  })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $35uzv.css)($c508cdd3f8306af1$var$_t6 || ($c508cdd3f8306af1$var$_t6 = $c508cdd3f8306af1$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $c508cdd3f8306af1$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $c508cdd3f8306af1$var$LinearProgress = /*#__PURE__*/ $4lkrv.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className: className , color: color = "primary" , value: value , valueBuffer: valueBuffer , variant: variant = "indeterminate"  } = props, other = (0, $eLWn9.default)(props, $c508cdd3f8306af1$var$_excluded);
    const ownerState = (0, $9YD4s.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $c508cdd3f8306af1$var$useUtilityClasses(ownerState);
    const theme = (0, $0fbff9e4f89c0f97$export$2e2bcd8739ae039)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $gWMia.jsxs)($c508cdd3f8306af1$var$LinearProgressRoot, (0, $9YD4s.default)({
        className: (0, $iB56s.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, $gWMia.jsx)($c508cdd3f8306af1$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $gWMia.jsx)($c508cdd3f8306af1$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, $gWMia.jsx)($c508cdd3f8306af1$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $c508cdd3f8306af1$export$2e2bcd8739ae039 = $c508cdd3f8306af1$var$LinearProgress;




var $gWMia = parcelRequire("gWMia");
parcelRequire("4lkrv");


var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");



var $at7OG = parcelRequire("at7OG");

var $bgnZl = parcelRequire("bgnZl");


var $gWMia = parcelRequire("gWMia");
const $519710e16d648003$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $519710e16d648003$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , inset: inset , primary: primary , secondary: secondary , dense: dense  } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $75adc5174b3f215d$export$1061006a0db3aeb5), classes);
};
const $519710e16d648003$var$ListItemTextRoot = (0, $bgnZl.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            {
                [`& .${(0, $75adc5174b3f215d$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $75adc5174b3f215d$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState  })=>(0, $9YD4s.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $519710e16d648003$var$ListItemText = /*#__PURE__*/ $4lkrv.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children , className: className , disableTypography: disableTypography = false , inset: inset = false , primary: primaryProp , primaryTypographyProps: primaryTypographyProps , secondary: secondaryProp , secondaryTypographyProps: secondaryTypographyProps  } = props, other = (0, $eLWn9.default)(props, $519710e16d648003$var$_excluded);
    const { dense: dense  } = $4lkrv.useContext((0, $6458657c0c336f3b$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $9YD4s.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $519710e16d648003$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), (0, $9YD4s.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), (0, $9YD4s.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $gWMia.jsxs)($519710e16d648003$var$ListItemTextRoot, (0, $9YD4s.default)({
        className: (0, $iB56s.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $519710e16d648003$export$2e2bcd8739ae039 = $519710e16d648003$var$ListItemText;



var $eLWn9 = parcelRequire("eLWn9");

var $9YD4s = parcelRequire("9YD4s");

var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");

var $kdLbD = parcelRequire("kdLbD");

var $bgnZl = parcelRequire("bgnZl");

var $at7OG = parcelRequire("at7OG");



var $gWMia = parcelRequire("gWMia");
const $bcd744992a72d0ea$var$_excluded = [
    "className"
];
const $bcd744992a72d0ea$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $kdLbD.default)(slots, (0, $e0234da23279e90c$export$81478e24460c57f2), classes);
};
const $bcd744992a72d0ea$var$ListItemIconRoot = (0, $bgnZl.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $9YD4s.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $bcd744992a72d0ea$var$ListItemIcon = /*#__PURE__*/ $4lkrv.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $at7OG.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className  } = props, other = (0, $eLWn9.default)(props, $bcd744992a72d0ea$var$_excluded);
    const context = $4lkrv.useContext((0, $6458657c0c336f3b$export$2e2bcd8739ae039));
    const ownerState = (0, $9YD4s.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $bcd744992a72d0ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $gWMia.jsx)($bcd744992a72d0ea$var$ListItemIconRoot, (0, $9YD4s.default)({
        className: (0, $iB56s.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $bcd744992a72d0ea$export$2e2bcd8739ae039 = $bcd744992a72d0ea$var$ListItemIcon;


var $7872706ad878de00$exports = {};
"use strict";

Object.defineProperty($7872706ad878de00$exports, "__esModule", {
    value: true
});
$7872706ad878de00$exports.default = void 0;

var $7872706ad878de00$var$_createSvgIcon = $95a1a4123f33e1f5$exports((parcelRequire("irtyR")));

var $gWMia = parcelRequire("gWMia");
var $7872706ad878de00$var$_default = (0, $7872706ad878de00$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $gWMia.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
$7872706ad878de00$exports.default = $7872706ad878de00$var$_default;




const $d51c7a15f04be0e1$export$a85d7ffbae8ac6f1 = (props)=>{
    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $0a5a8a2907404c73$export$2e2bcd8739ae039), {
        ...props,
        sx: {
            padding: 0
        },
        children: [
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $bcd744992a72d0ea$export$2e2bcd8739ae039), {
                sx: {
                    minWidth: 32
                },
                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7872706ad878de00$exports))), {
                    htmlColor: (0, $5b810149f92fce45$export$8f45430ccf837300).greenDark
                })
            }),
            /*#__PURE__*/ (0, $gWMia.jsx)((0, $519710e16d648003$export$2e2bcd8739ae039), {
                disableTypography: true,
                primary: /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                    variant: props.variant,
                    children: props.children
                })
            })
        ]
    });
};


var $13af16d9286ded7b$export$2e2bcd8739ae039 = (0, $d51c7a15f04be0e1$export$a85d7ffbae8ac6f1);



var $4lkrv = parcelRequire("4lkrv");


var $iB56s = parcelRequire("iB56s");
let $7424647819f0470e$var$e = {
    data: ""
}, $7424647819f0470e$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $7424647819f0470e$var$e, $7424647819f0470e$export$54aba348a7896325 = (e)=>{
    let r = $7424647819f0470e$var$t(e), l = r.data;
    return r.data = "", l;
}, $7424647819f0470e$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $7424647819f0470e$var$a = /\/\*[^]*?\*\/|  +/g, $7424647819f0470e$var$n = /\n+/g, $7424647819f0470e$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $7424647819f0470e$var$o(c, n) : n + "{" + $7424647819f0470e$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $7424647819f0470e$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $7424647819f0470e$var$o.p ? $7424647819f0470e$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $7424647819f0470e$var$c = {}, $7424647819f0470e$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $7424647819f0470e$var$s(e[r]);
        return t;
    }
    return e;
}, $7424647819f0470e$var$i = (e, t, r, i, p)=>{
    let u = $7424647819f0470e$var$s(e), d = $7424647819f0470e$var$c[u] || ($7424647819f0470e$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$7424647819f0470e$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $7424647819f0470e$var$l.exec(e.replace($7424647819f0470e$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($7424647819f0470e$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($7424647819f0470e$var$n, " ").trim();
            return o[0];
        })(e);
        $7424647819f0470e$var$c[d] = $7424647819f0470e$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $7424647819f0470e$var$c.g ? $7424647819f0470e$var$c.g : null;
    return r && ($7424647819f0470e$var$c.g = $7424647819f0470e$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($7424647819f0470e$var$c[d], t, i, f), d;
}, $7424647819f0470e$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $7424647819f0470e$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $7424647819f0470e$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $7424647819f0470e$var$i(l.unshift ? l.raw ? $7424647819f0470e$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $7424647819f0470e$var$t(r.target), r.g, r.o, r.k);
}
let $7424647819f0470e$var$d, $7424647819f0470e$var$f, $7424647819f0470e$var$g, $7424647819f0470e$export$442f1a04865e4790 = $7424647819f0470e$export$dbf350e5966cf602.bind({
    g: 1
}), $7424647819f0470e$export$d25ddfdf17c3ad3e = $7424647819f0470e$export$dbf350e5966cf602.bind({
    k: 1
});
function $7424647819f0470e$export$de27182ff8187d6c(e, t, r, l) {
    $7424647819f0470e$var$o.p = t, $7424647819f0470e$var$d = e, $7424647819f0470e$var$f = r, $7424647819f0470e$var$g = l;
}
function $7424647819f0470e$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $7424647819f0470e$var$f && $7424647819f0470e$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $7424647819f0470e$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $7424647819f0470e$var$g && i[0] && $7424647819f0470e$var$g(c), $7424647819f0470e$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}


function $44230f55c9f29a55$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $44230f55c9f29a55$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $44230f55c9f29a55$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $44230f55c9f29a55$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $44230f55c9f29a55$var$_extends() {
    $44230f55c9f29a55$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $44230f55c9f29a55$var$_extends.apply(this, arguments);
}
function $44230f55c9f29a55$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $44230f55c9f29a55$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $44230f55c9f29a55$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $44230f55c9f29a55$var$noOp = function noOp() {
    return "";
};
var $44230f55c9f29a55$var$SnackbarContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createContext({
    enqueueSnackbar: $44230f55c9f29a55$var$noOp,
    closeSnackbar: $44230f55c9f29a55$var$noOp
});
var $44230f55c9f29a55$var$breakpoints = {
    downXs: "@media (max-width:599.95px)",
    upSm: "@media (min-width:600px)"
};
var $44230f55c9f29a55$var$capitalise = function capitalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var $44230f55c9f29a55$var$originKeyExtractor = function originKeyExtractor(anchor) {
    return "" + $44230f55c9f29a55$var$capitalise(anchor.vertical) + $44230f55c9f29a55$var$capitalise(anchor.horizontal);
};
var $44230f55c9f29a55$var$isDefined = function isDefined(value) {
    return !!value || value === 0;
};
var $44230f55c9f29a55$var$UNMOUNTED = "unmounted";
var $44230f55c9f29a55$var$EXITED = "exited";
var $44230f55c9f29a55$var$ENTERING = "entering";
var $44230f55c9f29a55$var$ENTERED = "entered";
var $44230f55c9f29a55$var$EXITING = "exiting";
var $44230f55c9f29a55$export$be58926105124dd4 = /*#__PURE__*/ function(_React$Component) {
    $44230f55c9f29a55$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var appear = props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props["in"]) {
            if (appear) {
                initialStatus = $44230f55c9f29a55$var$EXITED;
                _this.appearStatus = $44230f55c9f29a55$var$ENTERING;
            } else initialStatus = $44230f55c9f29a55$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $44230f55c9f29a55$var$UNMOUNTED;
        else initialStatus = $44230f55c9f29a55$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref["in"];
        if (nextIn && prevState.status === $44230f55c9f29a55$var$UNMOUNTED) return {
            status: $44230f55c9f29a55$var$EXITED
        };
        return null;
    };
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props["in"]) {
                if (status !== $44230f55c9f29a55$var$ENTERING && status !== $44230f55c9f29a55$var$ENTERED) nextStatus = $44230f55c9f29a55$var$ENTERING;
            } else if (status === $44230f55c9f29a55$var$ENTERING || status === $44230f55c9f29a55$var$ENTERED) nextStatus = $44230f55c9f29a55$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var enter = timeout;
        var exit = timeout;
        if (timeout != null && typeof timeout !== "number" && typeof timeout !== "string") {
            exit = timeout.exit;
            enter = timeout.enter;
        }
        return {
            exit: exit,
            enter: enter
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            this.cancelNextCallback();
            if (nextStatus === $44230f55c9f29a55$var$ENTERING) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $44230f55c9f29a55$var$EXITED) this.setState({
            status: $44230f55c9f29a55$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var isAppearing = mounting;
        var timeouts = this.getTimeouts();
        if (!mounting && !enter) {
            this.safeSetState({
                status: $44230f55c9f29a55$var$ENTERED
            }, function() {
                if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
            });
            return;
        }
        if (this.props.onEnter) this.props.onEnter(this.node, isAppearing);
        this.safeSetState({
            status: $44230f55c9f29a55$var$ENTERING
        }, function() {
            if (_this2.props.onEntering) _this2.props.onEntering(_this2.node, isAppearing);
            _this2.onTransitionEnd(timeouts.enter, function() {
                _this2.safeSetState({
                    status: $44230f55c9f29a55$var$ENTERED
                }, function() {
                    if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $44230f55c9f29a55$var$EXITED
            }, function() {
                if (_this3.props.onExited) _this3.props.onExited(_this3.node);
            });
            return;
        }
        if (this.props.onExit) this.props.onExit(this.node);
        this.safeSetState({
            status: $44230f55c9f29a55$var$EXITING
        }, function() {
            if (_this3.props.onExiting) _this3.props.onExiting(_this3.node);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $44230f55c9f29a55$var$EXITED
                }, function() {
                    if (_this3.props.onExited) _this3.props.onExited(_this3.node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null && this.nextCallback.cancel) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function() {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback();
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!this.node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(this.node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $44230f55c9f29a55$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $44230f55c9f29a55$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return children(status, childProps);
    };
    $44230f55c9f29a55$var$_createClass(Transition, [
        {
            key: "node",
            get: function get() {
                var _this$props$nodeRef;
                var node = (_this$props$nodeRef = this.props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current;
                if (!node) throw new Error("notistack - Custom snackbar is not refForwarding");
                return node;
            }
        }
    ]);
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).Component);
function $44230f55c9f29a55$var$noop() {}
$44230f55c9f29a55$export$be58926105124dd4.defaultProps = {
    "in": false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $44230f55c9f29a55$var$noop,
    onEntering: $44230f55c9f29a55$var$noop,
    onEntered: $44230f55c9f29a55$var$noop,
    onExit: $44230f55c9f29a55$var$noop,
    onExiting: $44230f55c9f29a55$var$noop,
    onExited: $44230f55c9f29a55$var$noop
};
/**
 * Credit to MUI team @ https://mui.com
 */ /**
 * passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $44230f55c9f29a55$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $44230f55c9f29a55$var$useForkRef(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return (0, $4lkrv.useMemo)(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            $44230f55c9f29a55$var$setRef(refA, refValue);
            $44230f55c9f29a55$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $44230f55c9f29a55$var$getTransitionProps(props) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, mode = props.mode;
    return {
        duration: typeof timeout === "object" ? timeout[mode] || 0 : timeout,
        easing: style.transitionTimingFunction,
        delay: style.transitionDelay
    };
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $44230f55c9f29a55$var$defaultEasing = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
/**
 * CSS hack to force a repaint
 */ var $44230f55c9f29a55$var$reflow = function reflow(node) {
    // We have to do something with node.scrollTop.
    // Otherwise it's removed from the compiled code by optimisers
    // eslint-disable-next-line no-self-assign
    node.scrollTop = node.scrollTop;
};
var $44230f55c9f29a55$var$formatMs = function formatMs(milliseconds) {
    return Math.round(milliseconds) + "ms";
};
function $44230f55c9f29a55$var$createTransition(props, options) {
    if (props === void 0) props = [
        "all"
    ];
    var _ref = options || {}, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 300 : _ref$duration, _ref$easing = _ref.easing, easing = _ref$easing === void 0 ? $44230f55c9f29a55$var$defaultEasing.easeInOut : _ref$easing, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay;
    var properties = Array.isArray(props) ? props : [
        props
    ];
    return properties.map(function(animatedProp) {
        var formattedDuration = typeof duration === "string" ? duration : $44230f55c9f29a55$var$formatMs(duration);
        var formattedDelay = typeof delay === "string" ? delay : $44230f55c9f29a55$var$formatMs(delay);
        return animatedProp + " " + formattedDuration + " " + easing + " " + formattedDelay;
    }).join(",");
}
function $44230f55c9f29a55$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
function $44230f55c9f29a55$var$ownerWindow(node) {
    var doc = $44230f55c9f29a55$var$ownerDocument(node);
    return doc.defaultView || window;
}
/**
 * Corresponds to 10 frames at 60 Hz.
 * A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
 */ function $44230f55c9f29a55$var$debounce(func, wait) {
    if (wait === void 0) wait = 166;
    var timeout;
    function debounced() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var later = function later() {
            // @ts-ignore
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}
/**
 * Translate the node so it can't be seen on the screen.
 * Later, we're going to translate the node back to its original location with `none`.
 */ function $44230f55c9f29a55$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var containerWindow = $44230f55c9f29a55$var$ownerWindow(node);
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        var transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    switch(direction){
        case "left":
            return "translateX(" + (containerWindow.innerWidth + offsetX - rect.left) + "px)";
        case "right":
            return "translateX(-" + (rect.left + rect.width - offsetX) + "px)";
        case "up":
            return "translateY(" + (containerWindow.innerHeight + offsetY - rect.top) + "px)";
        default:
            // down
            return "translateY(-" + (rect.top + rect.height - offsetY) + "px)";
    }
}
function $44230f55c9f29a55$var$setTranslateValue(direction, node) {
    if (!node) return;
    var transform = $44230f55c9f29a55$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $44230f55c9f29a55$var$Slide = /*#__PURE__*/ (0, $4lkrv.forwardRef)(function(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? "down" : _props$direction, inProp = props["in"], style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 0 : _props$timeout, onEnter = props.onEnter, onEntered = props.onEntered, onExit = props.onExit, onExited = props.onExited, other = $44230f55c9f29a55$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "direction",
        "in",
        "style",
        "timeout",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var nodeRef = (0, $4lkrv.useRef)(null);
    var handleRefIntermediary = $44230f55c9f29a55$var$useForkRef(children.ref, nodeRef);
    var handleRef = $44230f55c9f29a55$var$useForkRef(handleRefIntermediary, ref);
    var handleEnter = function handleEnter(node, isAppearing) {
        $44230f55c9f29a55$var$setTranslateValue(direction, node);
        $44230f55c9f29a55$var$reflow(node);
        if (onEnter) onEnter(node, isAppearing);
    };
    var handleEntering = function handleEntering(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $44230f55c9f29a55$var$defaultEasing.easeOut;
        var transitionProps = $44230f55c9f29a55$var$getTransitionProps({
            timeout: timeout,
            mode: "enter",
            style: $44230f55c9f29a55$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $44230f55c9f29a55$var$createTransition("-webkit-transform", transitionProps);
        node.style.transition = $44230f55c9f29a55$var$createTransition("transform", transitionProps);
        node.style.webkitTransform = "none";
        node.style.transform = "none";
    };
    var handleExit = function handleExit(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $44230f55c9f29a55$var$defaultEasing.sharp;
        var transitionProps = $44230f55c9f29a55$var$getTransitionProps({
            timeout: timeout,
            mode: "exit",
            style: $44230f55c9f29a55$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $44230f55c9f29a55$var$createTransition("-webkit-transform", transitionProps);
        node.style.transition = $44230f55c9f29a55$var$createTransition("transform", transitionProps);
        $44230f55c9f29a55$var$setTranslateValue(direction, node);
        if (onExit) onExit(node);
    };
    var handleExited = function handleExited(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    };
    var updatePosition = (0, $4lkrv.useCallback)(function() {
        if (nodeRef.current) $44230f55c9f29a55$var$setTranslateValue(direction, nodeRef.current);
    }, [
        direction
    ]);
    (0, $4lkrv.useEffect)(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        var handleResize = $44230f55c9f29a55$var$debounce(function() {
            if (nodeRef.current) $44230f55c9f29a55$var$setTranslateValue(direction, nodeRef.current);
        });
        var containerWindow = $44230f55c9f29a55$var$ownerWindow(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    (0, $4lkrv.useEffect)(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return (0, $4lkrv.createElement)($44230f55c9f29a55$export$be58926105124dd4, Object.assign({
        appear: true,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: onEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        "in": inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return (0, $4lkrv.cloneElement)(children, $44230f55c9f29a55$var$_extends({
            ref: handleRef,
            style: $44230f55c9f29a55$var$_extends({
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, style, {}, children.props.style)
        }, childProps));
    });
});
$44230f55c9f29a55$var$Slide.displayName = "Slide";
var $44230f55c9f29a55$var$SvgIcon = function SvgIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement("svg", Object.assign({
        viewBox: "0 0 24 24",
        focusable: "false",
        style: {
            fontSize: 20,
            marginInlineEnd: 8,
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentColor",
            flexShrink: 0
        }
    }, props));
};
var $44230f55c9f29a55$var$CheckIcon = function CheckIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement("path", {
        d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    }));
};
var $44230f55c9f29a55$var$WarningIcon = function WarningIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement("path", {
        d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
    }));
};
var $44230f55c9f29a55$var$ErrorIcon = function ErrorIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement("path", {
        d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    }));
};
var $44230f55c9f29a55$var$InfoIcon = function InfoIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement("path", {
        d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
    }));
};
var $44230f55c9f29a55$var$defaultIconVariants = {
    "default": undefined,
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$CheckIcon, null),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$WarningIcon, null),
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$ErrorIcon, null),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$InfoIcon, null)
};
var $44230f55c9f29a55$var$defaults = {
    maxSnack: 3,
    persist: false,
    hideIconVariant: false,
    disableWindowBlurListener: false,
    variant: "default",
    autoHideDuration: 5000,
    iconVariant: $44230f55c9f29a55$var$defaultIconVariants,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
    },
    TransitionComponent: $44230f55c9f29a55$var$Slide,
    transitionDuration: {
        enter: 225,
        exit: 195
    }
};
/**
 * Derives the right autoHideDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $44230f55c9f29a55$var$getAutoHideDuration = function getAutoHideDuration(optionsDuration, propsDuration) {
    var isNumberOrNull = function isNumberOrNull(numberish) {
        return typeof numberish === "number" || numberish === null;
    };
    if (isNumberOrNull(optionsDuration)) return optionsDuration;
    if (isNumberOrNull(propsDuration)) return propsDuration;
    return $44230f55c9f29a55$var$defaults.autoHideDuration;
};
/**
 * Derives the right transitionDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $44230f55c9f29a55$var$getTransitionDuration = function getTransitionDuration(optionsDuration, propsDuration) {
    var is = function is(item, types) {
        return types.some(function(t) {
            return typeof item === t;
        });
    };
    if (is(optionsDuration, [
        "string",
        "number"
    ])) return optionsDuration;
    if (is(optionsDuration, [
        "object"
    ])) return $44230f55c9f29a55$var$_extends({}, $44230f55c9f29a55$var$defaults.transitionDuration, {}, is(propsDuration, [
        "object"
    ]) && propsDuration, {}, optionsDuration);
    if (is(propsDuration, [
        "string",
        "number"
    ])) return propsDuration;
    if (is(propsDuration, [
        "object"
    ])) return $44230f55c9f29a55$var$_extends({}, $44230f55c9f29a55$var$defaults.transitionDuration, {}, propsDuration);
    return $44230f55c9f29a55$var$defaults.transitionDuration;
};
var $44230f55c9f29a55$var$merge = function merge(options, props) {
    return function(name, shouldObjectMerge) {
        if (shouldObjectMerge === void 0) shouldObjectMerge = false;
        if (shouldObjectMerge) return $44230f55c9f29a55$var$_extends({}, $44230f55c9f29a55$var$defaults[name], {}, props[name], {}, options[name]);
        if (name === "autoHideDuration") return $44230f55c9f29a55$var$getAutoHideDuration(options.autoHideDuration, props.autoHideDuration);
        if (name === "transitionDuration") return $44230f55c9f29a55$var$getTransitionDuration(options.transitionDuration, props.transitionDuration);
        return options[name] || props[name] || $44230f55c9f29a55$var$defaults[name];
    };
};
function $44230f55c9f29a55$var$makeStyles(styles) {
    return Object.entries(styles).reduce(function(acc, _ref) {
        var _extends2;
        var key = _ref[0], value = _ref[1];
        return $44230f55c9f29a55$var$_extends({}, acc, (_extends2 = {}, _extends2[key] = (0, $7424647819f0470e$export$dbf350e5966cf602)(value), _extends2));
    }, {});
}
var $44230f55c9f29a55$var$ComponentClasses = {
    SnackbarContainer: "notistack-SnackbarContainer",
    Snackbar: "notistack-Snackbar",
    CollapseWrapper: "notistack-CollapseWrapper",
    MuiContent: "notistack-MuiContent",
    MuiContentVariant: function MuiContentVariant(variant) {
        return "notistack-MuiContent-" + variant;
    }
};
var $44230f55c9f29a55$var$classes = /*#__PURE__*/ $44230f55c9f29a55$var$makeStyles({
    root: {
        height: 0
    },
    entered: {
        height: "auto"
    }
});
var $44230f55c9f29a55$var$collapsedSize = "0px";
var $44230f55c9f29a55$var$timeout = 175;
var $44230f55c9f29a55$var$Collapse = /*#__PURE__*/ (0, $4lkrv.forwardRef)(function(props, ref) {
    var children = props.children, inProp = props["in"], onExited = props.onExited;
    var wrapperRef = (0, $4lkrv.useRef)(null);
    var nodeRef = (0, $4lkrv.useRef)(null);
    var handleRef = $44230f55c9f29a55$var$useForkRef(ref, nodeRef);
    var getWrapperSize = function getWrapperSize() {
        return wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    };
    var handleEnter = function handleEnter(node) {
        node.style.height = $44230f55c9f29a55$var$collapsedSize;
    };
    var handleEntering = function handleEntering(node) {
        var wrapperSize = getWrapperSize();
        var _getTransitionProps = $44230f55c9f29a55$var$getTransitionProps({
            timeout: $44230f55c9f29a55$var$timeout,
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration, easing = _getTransitionProps.easing;
        node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : transitionDuration + "ms";
        node.style.height = wrapperSize + "px";
        node.style.transitionTimingFunction = easing || "";
    };
    var handleEntered = function handleEntered(node) {
        node.style.height = "auto";
    };
    var handleExit = function handleExit(node) {
        node.style.height = getWrapperSize() + "px";
    };
    var handleExiting = function handleExiting(node) {
        $44230f55c9f29a55$var$reflow(node);
        var _getTransitionProps2 = $44230f55c9f29a55$var$getTransitionProps({
            timeout: $44230f55c9f29a55$var$timeout,
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration, easing = _getTransitionProps2.easing;
        node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : transitionDuration + "ms";
        node.style.height = $44230f55c9f29a55$var$collapsedSize;
        node.style.transitionTimingFunction = easing || "";
    };
    return (0, $4lkrv.createElement)($44230f55c9f29a55$export$be58926105124dd4, {
        "in": inProp,
        unmountOnExit: true,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: onExited,
        onExiting: handleExiting,
        nodeRef: nodeRef,
        timeout: $44230f55c9f29a55$var$timeout
    }, function(state, childProps) {
        return (0, $4lkrv.createElement)("div", Object.assign({
            ref: handleRef,
            className: (0, $iB56s.default)($44230f55c9f29a55$var$classes.root, state === "entered" && $44230f55c9f29a55$var$classes.entered),
            style: $44230f55c9f29a55$var$_extends({
                pointerEvents: "all",
                overflow: "hidden",
                minHeight: $44230f55c9f29a55$var$collapsedSize,
                transition: $44230f55c9f29a55$var$createTransition("height")
            }, state === "entered" && {
                overflow: "visible"
            }, {}, state === "exited" && !inProp && {
                visibility: "hidden"
            })
        }, childProps), (0, $4lkrv.createElement)("div", {
            ref: wrapperRef,
            className: $44230f55c9f29a55$var$ComponentClasses.CollapseWrapper,
            // Hack to get children with a negative margin to not falsify the height computation.
            style: {
                display: "flex",
                width: "100%"
            }
        }, children));
    });
});
$44230f55c9f29a55$var$Collapse.displayName = "Collapse";
var $44230f55c9f29a55$var$direction = {
    right: "left",
    left: "right",
    bottom: "up",
    top: "down"
};
var $44230f55c9f29a55$var$getSlideDirection = function getSlideDirection(anchorOrigin) {
    if (anchorOrigin.horizontal !== "center") return $44230f55c9f29a55$var$direction[anchorOrigin.horizontal];
    return $44230f55c9f29a55$var$direction[anchorOrigin.vertical];
};
/** Tranforms classes name */ var $44230f55c9f29a55$var$toSnackbarAnchorOrigin = function toSnackbarAnchorOrigin(anchorOrigin) {
    return "anchorOrigin" + $44230f55c9f29a55$var$originKeyExtractor(anchorOrigin);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */ var $44230f55c9f29a55$var$keepSnackbarClassKeys = function keepSnackbarClassKeys(classes) {
    if (classes === void 0) classes = {};
    var containerClasses = {
        containerRoot: true,
        containerAnchorOriginTopCenter: true,
        containerAnchorOriginBottomCenter: true,
        containerAnchorOriginTopRight: true,
        containerAnchorOriginBottomRight: true,
        containerAnchorOriginTopLeft: true,
        containerAnchorOriginBottomLeft: true
    };
    return Object.keys(classes).filter(function(key) {
        return !containerClasses[key];
    }).reduce(function(obj, key) {
        var _extends2;
        return $44230f55c9f29a55$var$_extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {});
};
var $44230f55c9f29a55$var$noOp$1 = function noOp() {
/* */ };
/**
 * Credit to MUI team @ https://mui.com
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $44230f55c9f29a55$var$createChainedFunction(funcs, snackbarId) {
    // @ts-ignore
    return funcs.reduce(function(acc, func) {
        if (func === null || func === undefined) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var argums = [].concat(args);
            if (snackbarId && argums.indexOf(snackbarId) === -1) argums.push(snackbarId);
             // @ts-ignore
            acc.apply(this, argums);
            func.apply(this, argums);
        };
    }, $44230f55c9f29a55$var$noOp$1);
}
/**
 * Credit to MUI team @ https://mui.com
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ var $44230f55c9f29a55$var$useEnhancedEffect = typeof window !== "undefined" ? (0, $4lkrv.useLayoutEffect) : (0, $4lkrv.useEffect);
function $44230f55c9f29a55$var$useEventCallback(fn) {
    var ref = (0, $4lkrv.useRef)(fn);
    $44230f55c9f29a55$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return (0, $4lkrv.useCallback)(function() {
        return ref.current.apply(void 0, arguments);
    }, []);
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $44230f55c9f29a55$var$Snackbar = /*#__PURE__*/ (0, $4lkrv.forwardRef)(function(props, ref) {
    var children = props.children, className = props.className, autoHideDuration = props.autoHideDuration, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, onClose = props.onClose, id = props.id, open = props.open, _props$SnackbarProps = props.SnackbarProps, SnackbarProps = _props$SnackbarProps === void 0 ? {} : _props$SnackbarProps;
    var timerAutoHide = (0, $4lkrv.useRef)();
    var handleClose = $44230f55c9f29a55$var$useEventCallback(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = $44230f55c9f29a55$var$useEventCallback(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, "timeout", id);
        }, autoHideDurationParam);
    });
    (0, $4lkrv.useEffect)(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */ var handlePause = function handlePause() {
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
    };
    /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */ var handleResume = (0, $4lkrv.useCallback)(function() {
        if (autoHideDuration != null) setAutoHideTimer(autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (SnackbarProps.onMouseEnter) SnackbarProps.onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (SnackbarProps.onMouseLeave) SnackbarProps.onMouseLeave(event);
        handleResume();
    };
    (0, $4lkrv.useEffect)(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return function() {
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    return (0, $4lkrv.createElement)("div", Object.assign({
        ref: ref
    }, SnackbarProps, {
        className: (0, $iB56s.default)($44230f55c9f29a55$var$ComponentClasses.Snackbar, className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }), children);
});
$44230f55c9f29a55$var$Snackbar.displayName = "Snackbar";
var $44230f55c9f29a55$var$_root;
var $44230f55c9f29a55$var$classes$1 = /*#__PURE__*/ $44230f55c9f29a55$var$makeStyles({
    root: ($44230f55c9f29a55$var$_root = {
        display: "flex",
        flexWrap: "wrap",
        flexGrow: 1
    }, $44230f55c9f29a55$var$_root[$44230f55c9f29a55$var$breakpoints.upSm] = {
        flexGrow: "initial",
        minWidth: "288px"
    }, $44230f55c9f29a55$var$_root)
});
var $44230f55c9f29a55$export$860cef82710cac7 = /*#__PURE__*/ (0, $4lkrv.forwardRef)(function(_ref, ref) {
    var className = _ref.className, props = $44230f55c9f29a55$var$_objectWithoutPropertiesLoose(_ref, [
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement("div", Object.assign({
        ref: ref,
        className: (0, $iB56s.default)($44230f55c9f29a55$var$classes$1.root, className)
    }, props));
});
$44230f55c9f29a55$export$860cef82710cac7.displayName = "SnackbarContent";
var $44230f55c9f29a55$var$classes$2 = /*#__PURE__*/ $44230f55c9f29a55$var$makeStyles({
    root: {
        backgroundColor: "#313131",
        fontSize: "0.875rem",
        lineHeight: 1.43,
        letterSpacing: "0.01071em",
        color: "#fff",
        alignItems: "center",
        padding: "6px 16px",
        borderRadius: "4px",
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
    },
    lessPadding: {
        paddingLeft: "20px"
    },
    "default": {
        backgroundColor: "#313131"
    },
    success: {
        backgroundColor: "#43a047"
    },
    error: {
        backgroundColor: "#d32f2f"
    },
    warning: {
        backgroundColor: "#ff9800"
    },
    info: {
        backgroundColor: "#2196f3"
    },
    message: {
        display: "flex",
        alignItems: "center",
        padding: "8px 0"
    },
    action: {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
        paddingLeft: "16px",
        marginRight: "-8px"
    }
});
var $44230f55c9f29a55$var$ariaDescribedby = "notistack-snackbar";
var $44230f55c9f29a55$var$MaterialDesignContent = /*#__PURE__*/ (0, $4lkrv.forwardRef)(function(props, forwardedRef) {
    var id = props.id, message = props.message, componentOrFunctionAction = props.action, iconVariant = props.iconVariant, variant = props.variant, hideIconVariant = props.hideIconVariant, style = props.style, className = props.className;
    var icon = iconVariant[variant];
    var action = componentOrFunctionAction;
    if (typeof action === "function") action = action(id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$export$860cef82710cac7, {
        ref: forwardedRef,
        role: "alert",
        "aria-describedby": $44230f55c9f29a55$var$ariaDescribedby,
        style: style,
        className: (0, $iB56s.default)($44230f55c9f29a55$var$ComponentClasses.MuiContent, $44230f55c9f29a55$var$ComponentClasses.MuiContentVariant(variant), $44230f55c9f29a55$var$classes$2.root, $44230f55c9f29a55$var$classes$2[variant], className, !hideIconVariant && icon && $44230f55c9f29a55$var$classes$2.lessPadding)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement("div", {
        id: $44230f55c9f29a55$var$ariaDescribedby,
        className: $44230f55c9f29a55$var$classes$2.message
    }, !hideIconVariant ? icon : null, message), action && (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement("div", {
        className: $44230f55c9f29a55$var$classes$2.action
    }, action));
});
$44230f55c9f29a55$var$MaterialDesignContent.displayName = "MaterialDesignContent";
var $44230f55c9f29a55$export$407b0b907b65dfeb = /*#__PURE__*/ (0, $4lkrv.memo)($44230f55c9f29a55$var$MaterialDesignContent);
var $44230f55c9f29a55$var$styles = /*#__PURE__*/ $44230f55c9f29a55$var$makeStyles({
    wrappedRoot: {
        width: "100%",
        position: "relative",
        transform: "translateX(0)",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        minWidth: "288px"
    }
});
var $44230f55c9f29a55$var$SnackbarItem = function SnackbarItem(props) {
    var timeout = (0, $4lkrv.useRef)();
    var _useState = (0, $4lkrv.useState)(true), collapsed = _useState[0], setCollapsed = _useState[1];
    var handleClose = $44230f55c9f29a55$var$createChainedFunction([
        props.snack.onClose,
        props.onClose
    ]);
    var handleEntered = function handleEntered() {
        if (props.snack.requestClose) handleClose(null, "instructed", props.snack.id);
    };
    var handleExitedScreen = (0, $4lkrv.useCallback)(function() {
        timeout.current = setTimeout(function() {
            setCollapsed(function(col) {
                return !col;
            });
        }, 125);
    }, []);
    (0, $4lkrv.useEffect)(function() {
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    var snack = props.snack, allClasses = props.classes, _props$Component = props.Component, Component = _props$Component === void 0 ? $44230f55c9f29a55$export$407b0b907b65dfeb : _props$Component;
    var classes = (0, $4lkrv.useMemo)(function() {
        return $44230f55c9f29a55$var$keepSnackbarClassKeys(allClasses);
    }, [
        allClasses
    ]);
    var open = snack.open, SnackbarProps = snack.SnackbarProps, TransitionComponent = snack.TransitionComponent, TransitionProps = snack.TransitionProps, transitionDuration = snack.transitionDuration, disableWindowBlurListener = snack.disableWindowBlurListener, componentOrFunctionContent = snack.content, otherSnack = $44230f55c9f29a55$var$_objectWithoutPropertiesLoose(snack, [
        "open",
        "SnackbarProps",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "disableWindowBlurListener",
        "content",
        "entered",
        "requestClose",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var transitionProps = $44230f55c9f29a55$var$_extends({
        direction: $44230f55c9f29a55$var$getSlideDirection(otherSnack.anchorOrigin),
        timeout: transitionDuration
    }, TransitionProps);
    var content = componentOrFunctionContent;
    if (typeof content === "function") content = content(otherSnack.id, otherSnack.message);
    var callbacks = [
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ].reduce(function(acc, cbName) {
        var _extends2;
        return $44230f55c9f29a55$var$_extends({}, acc, (_extends2 = {}, _extends2[cbName] = $44230f55c9f29a55$var$createChainedFunction([
            props.snack[cbName],
            props[cbName]
        ], otherSnack.id), _extends2));
    }, {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$Collapse, {
        "in": collapsed,
        onExited: callbacks.onExited
    }, (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$Snackbar, {
        open: open,
        id: otherSnack.id,
        disableWindowBlurListener: disableWindowBlurListener,
        autoHideDuration: otherSnack.autoHideDuration,
        className: (0, $iB56s.default)($44230f55c9f29a55$var$styles.wrappedRoot, classes.root, classes[$44230f55c9f29a55$var$toSnackbarAnchorOrigin(otherSnack.anchorOrigin)]),
        SnackbarProps: SnackbarProps,
        onClose: handleClose
    }, (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement(TransitionComponent, Object.assign({}, transitionProps, {
        appear: true,
        "in": open,
        onExit: callbacks.onExit,
        onExited: handleExitedScreen,
        onEnter: callbacks.onEnter,
        // order matters. first callbacks.onEntered to set entered: true,
        // then handleEntered to check if there's a request for closing
        onEntered: $44230f55c9f29a55$var$createChainedFunction([
            callbacks.onEntered,
            handleEntered
        ], otherSnack.id)
    }), content || (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement(Component, Object.assign({}, otherSnack)))));
};
var $44230f55c9f29a55$var$_root$1, $44230f55c9f29a55$var$_rootDense, $44230f55c9f29a55$var$_left, $44230f55c9f29a55$var$_right, $44230f55c9f29a55$var$_center;
var $44230f55c9f29a55$var$indents = {
    view: {
        "default": 20,
        dense: 4
    },
    snackbar: {
        "default": 6,
        dense: 2
    }
};
var $44230f55c9f29a55$var$collapseWrapper = "." + $44230f55c9f29a55$var$ComponentClasses.CollapseWrapper;
var $44230f55c9f29a55$var$xsWidthMargin = 16;
var $44230f55c9f29a55$var$styles$1 = /*#__PURE__*/ $44230f55c9f29a55$var$makeStyles({
    root: ($44230f55c9f29a55$var$_root$1 = {
        boxSizing: "border-box",
        display: "flex",
        maxHeight: "100%",
        position: "fixed",
        zIndex: 1400,
        height: "auto",
        width: "auto",
        transition: /*#__PURE__*/ $44230f55c9f29a55$var$createTransition([
            "top",
            "right",
            "bottom",
            "left",
            "max-width"
        ], {
            duration: 300,
            easing: "ease"
        }),
        // container itself is invisible and should not block clicks, clicks should be passed to its children
        // a pointerEvents: all is applied in the collapse component
        pointerEvents: "none"
    }, $44230f55c9f29a55$var$_root$1[$44230f55c9f29a55$var$collapseWrapper] = {
        padding: $44230f55c9f29a55$var$indents.snackbar["default"] + "px 0px",
        transition: "padding 300ms ease 0ms"
    }, $44230f55c9f29a55$var$_root$1.maxWidth = "calc(100% - " + $44230f55c9f29a55$var$indents.view["default"] * 2 + "px)", $44230f55c9f29a55$var$_root$1[$44230f55c9f29a55$var$breakpoints.downXs] = {
        width: "100%",
        maxWidth: "calc(100% - " + $44230f55c9f29a55$var$xsWidthMargin * 2 + "px)"
    }, $44230f55c9f29a55$var$_root$1),
    rootDense: ($44230f55c9f29a55$var$_rootDense = {}, $44230f55c9f29a55$var$_rootDense[$44230f55c9f29a55$var$collapseWrapper] = {
        padding: $44230f55c9f29a55$var$indents.snackbar.dense + "px 0px"
    }, $44230f55c9f29a55$var$_rootDense),
    top: {
        top: $44230f55c9f29a55$var$indents.view["default"] - $44230f55c9f29a55$var$indents.snackbar["default"] + "px",
        flexDirection: "column"
    },
    bottom: {
        bottom: $44230f55c9f29a55$var$indents.view["default"] - $44230f55c9f29a55$var$indents.snackbar["default"] + "px",
        flexDirection: "column-reverse"
    },
    left: ($44230f55c9f29a55$var$_left = {
        left: $44230f55c9f29a55$var$indents.view["default"] + "px"
    }, $44230f55c9f29a55$var$_left[$44230f55c9f29a55$var$breakpoints.upSm] = {
        alignItems: "flex-start"
    }, $44230f55c9f29a55$var$_left[$44230f55c9f29a55$var$breakpoints.downXs] = {
        left: $44230f55c9f29a55$var$xsWidthMargin + "px"
    }, $44230f55c9f29a55$var$_left),
    right: ($44230f55c9f29a55$var$_right = {
        right: $44230f55c9f29a55$var$indents.view["default"] + "px"
    }, $44230f55c9f29a55$var$_right[$44230f55c9f29a55$var$breakpoints.upSm] = {
        alignItems: "flex-end"
    }, $44230f55c9f29a55$var$_right[$44230f55c9f29a55$var$breakpoints.downXs] = {
        right: $44230f55c9f29a55$var$xsWidthMargin + "px"
    }, $44230f55c9f29a55$var$_right),
    center: ($44230f55c9f29a55$var$_center = {
        left: "50%",
        transform: "translateX(-50%)"
    }, $44230f55c9f29a55$var$_center[$44230f55c9f29a55$var$breakpoints.upSm] = {
        alignItems: "center"
    }, $44230f55c9f29a55$var$_center)
});
var $44230f55c9f29a55$var$SnackbarContainer = function SnackbarContainer(props) {
    var _props$classes = props.classes, classes = _props$classes === void 0 ? {} : _props$classes, anchorOrigin = props.anchorOrigin, dense = props.dense, children = props.children;
    var combinedClassname = (0, $iB56s.default)($44230f55c9f29a55$var$ComponentClasses.SnackbarContainer, $44230f55c9f29a55$var$styles$1[anchorOrigin.vertical], $44230f55c9f29a55$var$styles$1[anchorOrigin.horizontal], $44230f55c9f29a55$var$styles$1.root, classes.containerRoot, classes["containerAnchorOrigin" + $44230f55c9f29a55$var$originKeyExtractor(anchorOrigin)], dense && $44230f55c9f29a55$var$styles$1.rootDense);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement("div", {
        className: combinedClassname
    }, children);
};
var $44230f55c9f29a55$var$SnackbarContainer$1 = /*#__PURE__*/ (0, $4lkrv.memo)($44230f55c9f29a55$var$SnackbarContainer);
/* eslint-disable */ var $44230f55c9f29a55$var$__DEV__ = false;
var $44230f55c9f29a55$var$messages = {
    NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var $44230f55c9f29a55$var$warning = function(messageKey) {
    if (!$44230f55c9f29a55$var$__DEV__) return;
    var message = $44230f55c9f29a55$var$messages[messageKey];
    if (typeof console !== "undefined") console.error("WARNING - notistack: " + message);
    try {
        throw new Error(message);
    } catch (x) {}
};
var $44230f55c9f29a55$var$isOptions = function isOptions(messageOrOptions) {
    var isMessage = typeof messageOrOptions === "string" || (0, $4lkrv.isValidElement)(messageOrOptions);
    return !isMessage;
};
var $44230f55c9f29a55$export$9d70c354f0150b1b;
var $44230f55c9f29a55$export$823cdc5238933767;
var $44230f55c9f29a55$export$d1e619fddc3508ce = /*#__PURE__*/ function(_Component) {
    $44230f55c9f29a55$var$_inheritsLoose(SnackbarProvider, _Component);
    function SnackbarProvider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */ _this.enqueueSnackbar = function(messageOrOptions, optsOrUndefined) {
            if (optsOrUndefined === void 0) optsOrUndefined = {};
            if (messageOrOptions === undefined || messageOrOptions === null) throw new Error("enqueueSnackbar called with invalid argument");
            var opts = $44230f55c9f29a55$var$isOptions(messageOrOptions) ? messageOrOptions : optsOrUndefined;
            var message = $44230f55c9f29a55$var$isOptions(messageOrOptions) ? messageOrOptions.message : messageOrOptions;
            var key = opts.key, preventDuplicate = opts.preventDuplicate, options = $44230f55c9f29a55$var$_objectWithoutPropertiesLoose(opts, [
                "key",
                "preventDuplicate"
            ]);
            var hasSpecifiedKey = $44230f55c9f29a55$var$isDefined(key);
            var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
            var merger = $44230f55c9f29a55$var$merge(options, _this.props);
            var snack = $44230f55c9f29a55$var$_extends({
                id: id
            }, options, {
                message: message,
                open: true,
                entered: false,
                requestClose: false,
                persist: merger("persist"),
                action: merger("action"),
                content: merger("content"),
                variant: merger("variant"),
                anchorOrigin: merger("anchorOrigin"),
                disableWindowBlurListener: merger("disableWindowBlurListener"),
                autoHideDuration: merger("autoHideDuration"),
                hideIconVariant: merger("hideIconVariant"),
                TransitionComponent: merger("TransitionComponent"),
                transitionDuration: merger("transitionDuration"),
                TransitionProps: merger("TransitionProps", true),
                iconVariant: merger("iconVariant", true),
                style: merger("style", true),
                SnackbarProps: merger("SnackbarProps", true),
                className: (0, $iB56s.default)(_this.props.className, options.className)
            });
            if (snack.persist) snack.autoHideDuration = undefined;
            _this.setState(function(state) {
                if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
                    var compareFunction = function compareFunction(item) {
                        return hasSpecifiedKey ? item.id === id : item.message === message;
                    };
                    var inQueue = state.queue.findIndex(compareFunction) > -1;
                    var inView = state.snacks.findIndex(compareFunction) > -1;
                    if (inQueue || inView) return state;
                }
                return _this.handleDisplaySnack($44230f55c9f29a55$var$_extends({}, state, {
                    queue: [].concat(state.queue, [
                        snack
                    ])
                }));
            });
            return id;
        };
        /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */ _this.handleDisplaySnack = function(state) {
            var snacks = state.snacks;
            if (snacks.length >= _this.maxSnack) return _this.handleDismissOldest(state);
            return _this.processQueue(state);
        };
        /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */ _this.processQueue = function(state) {
            var queue = state.queue, snacks = state.snacks;
            if (queue.length > 0) return $44230f55c9f29a55$var$_extends({}, state, {
                snacks: [].concat(snacks, [
                    queue[0]
                ]),
                queue: queue.slice(1, queue.length)
            });
            return state;
        };
        /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */ _this.handleDismissOldest = function(state) {
            if (state.snacks.some(function(item) {
                return !item.open || item.requestClose;
            })) return state;
            var popped = false;
            var ignore = false;
            var persistentCount = state.snacks.reduce(function(acc, current) {
                return acc + (current.open && current.persist ? 1 : 0);
            }, 0);
            if (persistentCount === _this.maxSnack) ignore = true;
            var snacks = state.snacks.map(function(item) {
                if (!popped && (!item.persist || ignore)) {
                    popped = true;
                    if (!item.entered) return $44230f55c9f29a55$var$_extends({}, item, {
                        requestClose: true
                    });
                    if (item.onClose) item.onClose(null, "maxsnack", item.id);
                    if (_this.props.onClose) _this.props.onClose(null, "maxsnack", item.id);
                    return $44230f55c9f29a55$var$_extends({}, item, {
                        open: false
                    });
                }
                return $44230f55c9f29a55$var$_extends({}, item);
            });
            return $44230f55c9f29a55$var$_extends({}, state, {
                snacks: snacks
            });
        };
        /**
     * Set the entered state of the snackbar with the given key.
     */ _this.handleEnteredSnack = function(node, isAppearing, key) {
            if (!$44230f55c9f29a55$var$isDefined(key)) throw new Error("handleEnteredSnack Cannot be called with undefined key");
            _this.setState(function(_ref) {
                var snacks = _ref.snacks;
                return {
                    snacks: snacks.map(function(item) {
                        return item.id === key ? $44230f55c9f29a55$var$_extends({}, item, {
                            entered: true
                        }) : $44230f55c9f29a55$var$_extends({}, item);
                    })
                };
            });
        };
        /**
     * Hide a snackbar after its timeout.
     */ _this.handleCloseSnack = function(event, reason, key) {
            // should not use createChainedFunction for onClose.
            // because this.closeSnackbar called this function
            if (_this.props.onClose) _this.props.onClose(event, reason, key);
            var shouldCloseAll = key === undefined;
            _this.setState(function(_ref2) {
                var snacks = _ref2.snacks, queue = _ref2.queue;
                return {
                    snacks: snacks.map(function(item) {
                        if (!shouldCloseAll && item.id !== key) return $44230f55c9f29a55$var$_extends({}, item);
                        return item.entered ? $44230f55c9f29a55$var$_extends({}, item, {
                            open: false
                        }) : $44230f55c9f29a55$var$_extends({}, item, {
                            requestClose: true
                        });
                    }),
                    queue: queue.filter(function(item) {
                        return item.id !== key;
                    })
                };
            });
        };
        /**
     * Close snackbar with the given key
     */ _this.closeSnackbar = function(key) {
            // call individual snackbar onClose callback passed through options parameter
            var toBeClosed = _this.state.snacks.find(function(item) {
                return item.id === key;
            });
            if ($44230f55c9f29a55$var$isDefined(key) && toBeClosed && toBeClosed.onClose) toBeClosed.onClose(null, "instructed", key);
            _this.handleCloseSnack(null, "instructed", key);
        };
        /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */ _this.handleExitedSnack = function(node, key) {
            if (!$44230f55c9f29a55$var$isDefined(key)) throw new Error("handleExitedSnack Cannot be called with undefined key");
            _this.setState(function(state) {
                var newState = _this.processQueue($44230f55c9f29a55$var$_extends({}, state, {
                    snacks: state.snacks.filter(function(item) {
                        return item.id !== key;
                    })
                }));
                if (newState.queue.length === 0) return newState;
                return _this.handleDismissOldest(newState);
            });
        };
        $44230f55c9f29a55$export$9d70c354f0150b1b = _this.enqueueSnackbar;
        $44230f55c9f29a55$export$823cdc5238933767 = _this.closeSnackbar;
        _this.state = {
            snacks: [],
            queue: [],
            contextValue: {
                enqueueSnackbar: _this.enqueueSnackbar.bind($44230f55c9f29a55$var$_assertThisInitialized(_this)),
                closeSnackbar: _this.closeSnackbar.bind($44230f55c9f29a55$var$_assertThisInitialized(_this))
            }
        };
        return _this;
    }
    var _proto = SnackbarProvider.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var contextValue = this.state.contextValue;
        var _this$props = this.props, domRoot = _this$props.domRoot, children = _this$props.children, _this$props$dense = _this$props.dense, dense = _this$props$dense === void 0 ? false : _this$props$dense, _this$props$Component = _this$props.Components, Components = _this$props$Component === void 0 ? {} : _this$props$Component, classes = _this$props.classes;
        var categ = this.state.snacks.reduce(function(acc, current) {
            var _extends2;
            var category = $44230f55c9f29a55$var$originKeyExtractor(current.anchorOrigin);
            var existingOfCategory = acc[category] || [];
            return $44230f55c9f29a55$var$_extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [
                current
            ]), _extends2));
        }, {});
        var snackbars = Object.keys(categ).map(function(origin) {
            var snacks = categ[origin];
            var nomineeSnack = snacks[0];
            return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$SnackbarContainer$1, {
                key: origin,
                dense: dense,
                anchorOrigin: nomineeSnack.anchorOrigin,
                classes: classes
            }, snacks.map(function(snack) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$SnackbarItem, {
                    key: snack.id,
                    snack: snack,
                    classes: classes,
                    Component: Components[snack.variant],
                    onClose: _this2.handleCloseSnack,
                    onEnter: _this2.props.onEnter,
                    onExit: _this2.props.onExit,
                    onExited: $44230f55c9f29a55$var$createChainedFunction([
                        _this2.handleExitedSnack,
                        _this2.props.onExited
                    ], snack.id),
                    onEntered: $44230f55c9f29a55$var$createChainedFunction([
                        _this2.handleEnteredSnack,
                        _this2.props.onEntered
                    ], snack.id)
                });
            }));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).createElement($44230f55c9f29a55$var$SnackbarContext.Provider, {
            value: contextValue
        }, children, domRoot ? (0, $b4d8cf9ba0f25243$exports.createPortal)(snackbars, domRoot) : snackbars);
    };
    $44230f55c9f29a55$var$_createClass(SnackbarProvider, [
        {
            key: "maxSnack",
            get: function get() {
                return this.props.maxSnack || $44230f55c9f29a55$var$defaults.maxSnack;
            }
        }
    ]);
    return SnackbarProvider;
}((0, $4lkrv.Component));
var $44230f55c9f29a55$export$1c97ac2c9a6e7c09 = function() {
    return (0, $4lkrv.useContext)($44230f55c9f29a55$var$SnackbarContext);
};



var $4lkrv = parcelRequire("4lkrv");

let $fdfb5b79060d95bb$var$cartFetcher;
const $fdfb5b79060d95bb$var$useShopifyApi = ()=>{
    const { baseUrl: baseUrl , currencyCode: currencyCode , shipToCountryCode: shipToCountryCode , locale: locale , storeHash: storeHash  } = (0, $4lkrv.useContext)((0, $e2f0b13a8b8b1035$export$e9e34775259af03f));
    const fetcher = (path, init)=>{
        return fetch(baseUrl + path, init).then((res)=>res.json());
    };
    const prepareProduct = (design)=>{
        const params = new URLSearchParams();
        params.set("w", design.width.toString());
        params.set("h", design.height.toString());
        params.set("u", design.unit);
        params.set("quantity", design.quantity.toString());
        params.set("productSku", design.productSku);
        params.set("materialSku", design.materialSku);
        params.set("currencyCode", currencyCode);
        params.set("shipToCountryCode", shipToCountryCode);
        params.set("languageCode", locale);
        return fetcher(`/v4/shopify/product?${params.toString()}`, {
            method: "POST"
        });
    };
    return {
        fetcher: fetcher,
        prepareProduct: prepareProduct,
        removeFromCart: (cartItemId)=>{
            return fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    updates: {
                        [cartItemId]: 0
                    }
                })
            });
        },
        addToCart: async (design, files)=>{
            const item = {
                id: 0,
                quantity: 1,
                properties: {
                    _ID: design._id || "CI" + (new Date().getTime() + Math.random() * 100).toString(),
                    Quantity: design.quantity,
                    Width: design.width + design.unit,
                    Height: design.height + design.unit,
                    Material: design.materialSku,
                    Shape: design.shape,
                    Files: files?.map((f)=>f.id),
                    Instructions: design.instructions
                }
            };
            Object.entries(design).forEach(([k, v])=>{
                if (k.startsWith("_")) item.properties[k] = v;
            });
            let variantId = design.variantId;
            if (!variantId) try {
                const product = await prepareProduct(design);
                variantId = parseInt(product.variantId.replace("gid://shopify/ProductVariant/", ""));
            } catch (err) {
                console.error(err);
                throw err;
            }
            const result = await fetch("/cart/add.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify({
                    ...item,
                    id: variantId
                })
            });
            let allPricesAreZero = true;
            while(allPricesAreZero){
                if (!$fdfb5b79060d95bb$var$cartFetcher) $fdfb5b79060d95bb$var$cartFetcher = fetch("/cart.js").then((resp)=>{
                    $fdfb5b79060d95bb$var$cartFetcher = null;
                    return resp.json();
                });
                const cart = await $fdfb5b79060d95bb$var$cartFetcher;
                allPricesAreZero = cart.items.some((item)=>item.price === 0);
                if (allPricesAreZero) await new Promise((resolve)=>setTimeout(()=>resolve(), 1000));
            }
            $fdfb5b79060d95bb$var$cartFetcher = null;
            if (result.status !== 200) throw new Error("error adding to cart");
            return await result.json();
        }
    };
};
var $fdfb5b79060d95bb$export$2e2bcd8739ae039 = $fdfb5b79060d95bb$var$useShopifyApi;



var $1aa075571e67a535$exports = {};
"use strict";

Object.defineProperty($1aa075571e67a535$exports, "__esModule", {
    value: true
});
$1aa075571e67a535$exports.default = void 0;

var $1aa075571e67a535$var$_createSvgIcon = $95a1a4123f33e1f5$exports((parcelRequire("irtyR")));

var $gWMia = parcelRequire("gWMia");
var $1aa075571e67a535$var$_default = (0, $1aa075571e67a535$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $gWMia.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");
$1aa075571e67a535$exports.default = $1aa075571e67a535$var$_default;


var $6b38c9940a8b734d$exports = {};
"use strict";

Object.defineProperty($6b38c9940a8b734d$exports, "__esModule", {
    value: true
});
$6b38c9940a8b734d$exports.default = void 0;

var $6b38c9940a8b734d$var$_createSvgIcon = $95a1a4123f33e1f5$exports((parcelRequire("irtyR")));

var $gWMia = parcelRequire("gWMia");
var $6b38c9940a8b734d$var$_default = (0, $6b38c9940a8b734d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $gWMia.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
$6b38c9940a8b734d$exports.default = $6b38c9940a8b734d$var$_default;


var $9d639098aa5e9dd2$exports = {};

$9d639098aa5e9dd2$exports = (parcelRequire("hEj67"));


const $05c8b2442d20db85$var$StartDesign = (props)=>{
    const inputRef = (0, $4lkrv.useRef)(null);
    const [isAddingToCart, setAddingToCart] = (0, $4lkrv.useState)(false);
    const websiteApi = (0, $9f35c1aee77f93aa$export$2e2bcd8739ae039)();
    const shopifyApi = (0, $fdfb5b79060d95bb$export$2e2bcd8739ae039)();
    const uploadButtonId = (0, $4lkrv.useId)();
    const [files, setFiles] = (0, $4lkrv.useState)([]);
    const isUploading = files.some((fs)=>fs.uploadState == "uploading");
    const [instructions, setInstructions] = (0, $4lkrv.useState)("");
    const handleAddToCart = async (filesUploaded)=>{
        const key = (0, $44230f55c9f29a55$export$9d70c354f0150b1b)("Adding to cart", {
            variant: "info",
            autoHideDuration: 30000
        });
        setAddingToCart(true);
        try {
            await shopifyApi.addToCart({
                ...props.design,
                instructions: instructions
            }, filesUploaded);
            window.location.pathname = props.cartPath;
        } catch (err) {
            (0, $44230f55c9f29a55$export$9d70c354f0150b1b)("Error adding to the cart", {
                variant: "error"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($9d639098aa5e9dd2$exports))).notify(err);
            console.error(err);
        } finally{
            setAddingToCart(false);
            (0, $44230f55c9f29a55$export$823cdc5238933767)(key);
        }
    };
    const progressEventFactory = (fs)=>{
        return (progressEvent)=>{
            setFiles((files)=>{
                return files.map((fs2)=>{
                    if (fs.id === fs2.id) {
                        fs2.uploadProgress = progressEvent.progress || 0;
                        fs2.uploadState = "uploading";
                    }
                    return fs2;
                });
            });
        };
    };
    const handleFileUploaded = (id, newId)=>{
        setFiles((files)=>{
            return files.map((fs2)=>{
                if (fs2.id === id) {
                    fs2.id = newId;
                    fs2.uploadState = "uploaded";
                    fs2.uploadProgress = 100;
                }
                return fs2;
            });
        });
    };
    const handleOnFileUpload = async (ev)=>{
        const fileEv = ev;
        if (fileEv.target.files) {
            (0, $44230f55c9f29a55$export$9d70c354f0150b1b)(`Uploading ${fileEv.target.files.length} files`, {
                variant: "info"
            });
            const filesToUpload = fileEv?.target?.files || [];
            const filesArr = Array.from(filesToUpload).flat().filter((f)=>f).map((f)=>{
                const fs = {
                    id: new Date().getTime() + Math.random() * 10000,
                    f: f,
                    uploadProgress: 0,
                    uploadState: "uploading"
                };
                return fs;
            });
            setFiles((oldFiles)=>oldFiles.concat(filesArr));
            const allUploaded = Promise.all(filesArr.map((fs, idx)=>{
                const progress = progressEventFactory(fs);
                return websiteApi.uploadArtwork(fs.f, progress).then((upload)=>{
                    (0, $44230f55c9f29a55$export$9d70c354f0150b1b)(`Uploaded file ${idx + 1}/${filesArr.length}`, {
                        variant: "success"
                    });
                    handleFileUploaded(fs.id, upload.id);
                    return upload;
                });
            }));
            const filesUploaded = await allUploaded;
            if (filesUploaded.length > 1) (0, $44230f55c9f29a55$export$9d70c354f0150b1b)("Uploaded all files", {
                variant: "success"
            });
        // handleAddToCart(filesUploaded);
        }
    };
    const handleRemoveFile = (id)=>{
        setFiles((files)=>{
            return files.filter((fs2)=>id !== fs2.id);
        });
    };
    const handleFormSubmit = (ev)=>{
        ev.preventDefault();
        handleAddToCart(files.filter((fs)=>typeof fs.id === "string").map((fs)=>{
            return {
                id: fs.id.toString(),
                contentType: fs.f.type,
                src: ""
            };
        }));
    };
    const maxFiles = props.design.productSku.includes("SAMPLE") ? 1 : 5;
    const multipleFileUploadsAllowed = maxFiles > 1;
    const maxFilesReached = files.length >= maxFiles;
    return /*#__PURE__*/ (0, $gWMia.jsx)((0, $gWMia.Fragment), {
        children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $79506d4265a38831$export$2e2bcd8739ae039), {
            component: "form",
            sx: {
                border: {
                    xs: "none",
                    md: `1px solid ${(0, $5b810149f92fce45$export$2e2bcd8739ae039).colors.greyPlaceholder}`
                },
                borderRadius: 2,
                display: "flex",
                justifyContent: "center",
                marginTop: {
                    xs: 0,
                    md: 5
                },
                padding: {
                    xs: 0,
                    md: 2
                }
            },
            onSubmit: handleFormSubmit,
            maxWidth: "sm",
            children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                sx: {
                    width: "100%",
                    padding: 2
                },
                children: [
                    /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                        sx: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                variant: "h2",
                                children: props.translations.uploadArtworkTitle
                            }),
                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "center",
                                paddingTop: 3,
                                paddingBottom: 5,
                                children: /*#__PURE__*/ (0, $gWMia.jsxs)("label", {
                                    htmlFor: uploadButtonId,
                                    children: [
                                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $9ff55d59ff528ce1$export$2e2bcd8739ae039), {
                                            ref: inputRef,
                                            sx: {
                                                display: "none"
                                            },
                                            id: uploadButtonId,
                                            // disabled in MUIv5?
                                            type: "file",
                                            inputProps: {
                                                // accept: ACCEPTABLE_FILE_TYPES.join(","),
                                                multiple: multipleFileUploadsAllowed
                                            },
                                            onChange: handleOnFileUpload
                                        }),
                                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $c57a8262ea075bfb$export$2e2bcd8739ae039), {
                                            disabled: isAddingToCart || maxFilesReached,
                                            variant: "contained",
                                            color: "primary",
                                            fullWidth: true,
                                            startIcon: /*#__PURE__*/ (0, $gWMia.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1aa075571e67a535$exports))), {}),
                                            component: "span",
                                            children: props.translations.uploadArtworkButtonText
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $gWMia.jsxs)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $4d47fcbf28a0e37f$export$2e2bcd8739ae039), {
                                        variant: "h6",
                                        children: "You can:"
                                    }),
                                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $981795693fc84723$export$2e2bcd8739ae039), {
                                        dense: true,
                                        children: props?.translations.uploadArtworkFeatures?.map((feature, idx)=>{
                                            return /*#__PURE__*/ (0, $gWMia.jsx)((0, $13af16d9286ded7b$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                children: feature.replace("{{maxDesigns}}", maxFiles.toString())
                                            }, idx);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                                children: files.map((fs)=>{
                                    return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                        container: true,
                                        sx: {
                                            height: "50px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 5,
                                                sx: {
                                                    lineHeight: "50px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    paddingRight: 1,
                                                    fontSize: "14px",
                                                    fontStyle: "italic"
                                                },
                                                children: /*#__PURE__*/ (0, $gWMia.jsx)("i", {
                                                    title: fs.id.toString(),
                                                    children: fs.f.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 5,
                                                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $c508cdd3f8306af1$export$2e2bcd8739ae039), {
                                                    variant: "determinate",
                                                    value: fs.uploadProgress * 100,
                                                    sx: {
                                                        marginTop: "21px"
                                                    },
                                                    color: fs.uploadState === "uploaded" ? "success" : "primary"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 2,
                                                sx: {
                                                    textAlign: "right"
                                                },
                                                children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $5dc18c1bf26fdbc8$export$2e2bcd8739ae039), {
                                                    onClick: ()=>handleRemoveFile(fs.id),
                                                    children: /*#__PURE__*/ (0, $gWMia.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6b38c9940a8b734d$exports))), {})
                                                })
                                            })
                                        ]
                                    }, fs.id);
                                })
                            }),
                            /*#__PURE__*/ (0, $gWMia.jsx)((0, $3e443e1578d52cec$export$2e2bcd8739ae039), {
                                id: "outlined-multiline-static",
                                variant: "outlined",
                                label: "Notes / Instructions",
                                multiline: true,
                                rows: 4,
                                placeholder: "Add proofing instructions",
                                fullWidth: true,
                                sx: {
                                    fontSize: "12px",
                                    marginTop: 2
                                },
                                value: instructions,
                                onChange: (ev)=>setInstructions(ev.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gWMia.jsx)((0, $9bc6663fb5729a22$export$2e2bcd8739ae039), {
                        sx: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                            width: "100%",
                            container: true,
                            spacing: {
                                xs: 0,
                                md: 2
                            },
                            flexDirection: {
                                xs: "column-reverse",
                                md: "row"
                            },
                            sx: {
                                paddingTop: {
                                    xs: 2,
                                    md: 0
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 5,
                                    children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $c57a8262ea075bfb$export$2e2bcd8739ae039), {
                                        disabled: isUploading || isAddingToCart,
                                        type: "submit",
                                        variant: "text",
                                        color: "primary",
                                        sx: {
                                            marginTop: {
                                                xs: 1,
                                                md: 2
                                            },
                                            marginBottom: {
                                                xs: 0,
                                                md: 2
                                            }
                                        },
                                        fullWidth: true,
                                        onClick: ()=>{
                                            setFiles([]);
                                        },
                                        children: props?.translations.uploadArtworkSkipText
                                    })
                                }),
                                /*#__PURE__*/ (0, $gWMia.jsx)((0, $62d2338da85f4e74$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    md: 7,
                                    children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $c57a8262ea075bfb$export$2e2bcd8739ae039), {
                                        disabled: isUploading || isAddingToCart,
                                        type: "submit",
                                        variant: "contained",
                                        color: "primary",
                                        sx: {
                                            marginTop: {
                                                xs: 1,
                                                md: 2
                                            },
                                            marginBottom: {
                                                xs: 0,
                                                md: 2
                                            }
                                        },
                                        fullWidth: true,
                                        children: "Continue"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $05c8b2442d20db85$export$2e2bcd8739ae039 = $05c8b2442d20db85$var$StartDesign;






var $5YV4M = parcelRequire("5YV4M");

var $gWMia = parcelRequire("gWMia");
var $1f50bd1753fd1f06$export$2e2bcd8739ae039 = (0, $5YV4M.default)(/*#__PURE__*/ (0, $gWMia.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $e01ab73312b0a410$exports = {};
(function(f) {
    var g;
    $e01ab73312b0a410$exports = f();
})(function() {
    var define, module1, exports;
    var _$src_1 = {};
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    _$src_1 = /*#__PURE__*/ function() {
        function BugsnagPluginReact() {
            // Fetch React from the window object, if it exists
            var globalReact = typeof window !== "undefined" && window.React;
            this.name = "react";
            this.lazy = arguments.length === 0 && !globalReact;
            if (!this.lazy) {
                this.React = (arguments.length <= 0 ? undefined : arguments[0]) || globalReact;
                if (!this.React) throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
            }
        }
        var _proto = BugsnagPluginReact.prototype;
        _proto.load = function load(client) {
            if (!this.lazy) {
                var ErrorBoundary = createClass(this.React, client);
                ErrorBoundary.createErrorBoundary = function() {
                    return ErrorBoundary;
                };
                return ErrorBoundary;
            }
            var BugsnagPluginReactLazyInitializer = function() {
                throw new Error("@bugsnag/plugin-react was used incorrectly. Valid usage is as follows:\nPass React to the plugin constructor\n\n  `Bugsnag.start({ plugins: [new BugsnagPluginReact(React)] })`\nand then call `const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary()`\n\nOr if React is not available until after Bugsnag has started,\nconstruct the plugin with no arguments\n  `Bugsnag.start({ plugins: [new BugsnagPluginReact()] })`,\nthen pass in React when available to construct your error boundary\n  `const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)`");
            };
            BugsnagPluginReactLazyInitializer.createErrorBoundary = function(React) {
                if (!React) throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
                return createClass(React, client);
            };
            return BugsnagPluginReactLazyInitializer;
        };
        return BugsnagPluginReact;
    }();
    var formatComponentStack = function(str) {
        var lines = str.split(/\n/g);
        var ret = "";
        for(var line = 0, len = lines.length; line < len; line++)if (lines[line].length) ret += "" + (ret.length ? "\n" : "") + lines[line].trim();
        return ret;
    };
    var createClass = function(React, client) {
        return /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(ErrorBoundary, _React$Component);
            function ErrorBoundary(props) {
                var _this;
                _this = _React$Component.call(this, props) || this;
                _this.state = {
                    error: null,
                    info: null
                };
                _this.handleClearError = _this.handleClearError.bind(_assertThisInitialized(_this));
                return _this;
            }
            var _proto2 = ErrorBoundary.prototype;
            _proto2.handleClearError = function handleClearError() {
                this.setState({
                    error: null,
                    info: null
                });
            };
            _proto2.componentDidCatch = function componentDidCatch(error, info) {
                var onError = this.props.onError;
                var handledState = {
                    severity: "error",
                    unhandled: true,
                    severityReason: {
                        type: "unhandledException"
                    }
                };
                var event = client.Event.create(error, true, handledState, 1);
                if (info && info.componentStack) info.componentStack = formatComponentStack(info.componentStack);
                event.addMetadata("react", info);
                client._notify(event, onError);
                this.setState({
                    error: error,
                    info: info
                });
            };
            _proto2.render = function render() {
                var error = this.state.error;
                if (error) {
                    var FallbackComponent = this.props.FallbackComponent;
                    if (FallbackComponent) return React.createElement(FallbackComponent, _extends({}, this.state, {
                        clearError: this.handleClearError
                    }));
                    return null;
                }
                return this.props.children;
            };
            return ErrorBoundary;
        }(React.Component);
    };
    _$src_1.formatComponentStack = formatComponentStack;
    _$src_1["default"] = _$src_1;
    return _$src_1;
});



var $4lkrv = parcelRequire("4lkrv");
(0, (/*@__PURE__*/$parcel$interopDefault($9d639098aa5e9dd2$exports))).start({
    apiKey: "a714c7e3a2faebc8984d6947d51e2b71",
    plugins: [
        new (0, (/*@__PURE__*/$parcel$interopDefault($e01ab73312b0a410$exports)))()
    ],
    releaseStage: "live",
    autoTrackSessions: false,
    enabledReleaseStages: [
        "live",
        "staging"
    ]
});
const $72413571ece6033e$export$e926676385687eaf = (0, (/*@__PURE__*/$parcel$interopDefault($9d639098aa5e9dd2$exports))).getPlugin("react").createErrorBoundary((0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))));



var $gWMia = parcelRequire("gWMia");
parcelRequire("4lkrv");
const $5869b013801e0525$var$ErrorView = ()=>/*#__PURE__*/ (0, $gWMia.jsx)("div", {
        children: /*#__PURE__*/ (0, $gWMia.jsx)("p", {
            children: "Inform users of an error in the component tree."
        })
    });
var $5869b013801e0525$export$2e2bcd8739ae039 = $5869b013801e0525$var$ErrorView;






var $4lkrv = parcelRequire("4lkrv");
var $a238e831c380b23f$exports = {};
"use strict";

$a238e831c380b23f$exports = (parcelRequire("b6MEP"));



var $4lkrv = parcelRequire("4lkrv");
// Shared state between server components and client components
const $1644dbbfed495f23$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $1644dbbfed495f23$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $1644dbbfed495f23$export$8793edee2d425525();
const $1644dbbfed495f23$export$8b8a958a7f6f130c = Object;
const $1644dbbfed495f23$export$fce6876652108ab = (v)=>v === $1644dbbfed495f23$export$6db089fe7b26f5b6;
const $1644dbbfed495f23$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $1644dbbfed495f23$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $1644dbbfed495f23$export$ae936b9d47e5870e = (x)=>$1644dbbfed495f23$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $1644dbbfed495f23$var$table = new WeakMap();
// counter of the key
let $1644dbbfed495f23$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $1644dbbfed495f23$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($1644dbbfed495f23$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $1644dbbfed495f23$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$1644dbbfed495f23$var$counter + "~";
        $1644dbbfed495f23$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $1644dbbfed495f23$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $1644dbbfed495f23$var$table.set(arg, result);
        }
        if (constructor == $1644dbbfed495f23$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $1644dbbfed495f23$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$1644dbbfed495f23$export$fce6876652108ab(index = keys.pop()))if (!$1644dbbfed495f23$export$fce6876652108ab(arg[index])) result += index + ":" + $1644dbbfed495f23$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $1644dbbfed495f23$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $1644dbbfed495f23$export$b94ca9901c60634 = new WeakMap();
const $1644dbbfed495f23$var$EMPTY_CACHE = {};
const $1644dbbfed495f23$var$INITIAL_CACHE = {};
const $1644dbbfed495f23$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $1644dbbfed495f23$export$6e85fd745dc51282 = typeof window != $1644dbbfed495f23$var$STR_UNDEFINED;
const $1644dbbfed495f23$export$842dfe7a9f24298 = typeof document != $1644dbbfed495f23$var$STR_UNDEFINED;
const $1644dbbfed495f23$export$a9116928c9d15917 = ()=>$1644dbbfed495f23$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $1644dbbfed495f23$var$STR_UNDEFINED;
const $1644dbbfed495f23$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $1644dbbfed495f23$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$1644dbbfed495f23$export$fce6876652108ab(key) && cache.get(key) || $1644dbbfed495f23$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$1644dbbfed495f23$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $1644dbbfed495f23$var$INITIAL_CACHE)) $1644dbbfed495f23$var$INITIAL_CACHE[key] = prev;
                state[5](key, $1644dbbfed495f23$export$2321aea138b44780(prev, info), prev || $1644dbbfed495f23$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$1644dbbfed495f23$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $1644dbbfed495f23$var$INITIAL_CACHE) return $1644dbbfed495f23$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$1644dbbfed495f23$export$fce6876652108ab(key) && cache.get(key) || $1644dbbfed495f23$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $1644dbbfed495f23$var$online = true;
const $1644dbbfed495f23$var$isOnline = ()=>$1644dbbfed495f23$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$1644dbbfed495f23$var$onWindowEvent, $1644dbbfed495f23$var$offWindowEvent] = $1644dbbfed495f23$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $1644dbbfed495f23$export$8793edee2d425525,
    $1644dbbfed495f23$export$8793edee2d425525
];
const $1644dbbfed495f23$var$isVisible = ()=>{
    const visibilityState = $1644dbbfed495f23$export$842dfe7a9f24298 && document.visibilityState;
    return $1644dbbfed495f23$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $1644dbbfed495f23$var$initFocus = (callback)=>{
    // focus revalidate
    if ($1644dbbfed495f23$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $1644dbbfed495f23$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($1644dbbfed495f23$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $1644dbbfed495f23$var$offWindowEvent("focus", callback);
    };
};
const $1644dbbfed495f23$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $1644dbbfed495f23$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $1644dbbfed495f23$var$online = false;
    };
    $1644dbbfed495f23$var$onWindowEvent("online", onOnline);
    $1644dbbfed495f23$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $1644dbbfed495f23$var$offWindowEvent("online", onOnline);
        $1644dbbfed495f23$var$offWindowEvent("offline", onOffline);
    };
};
const $1644dbbfed495f23$export$f5ab8217e0edff04 = {
    isOnline: $1644dbbfed495f23$var$isOnline,
    isVisible: $1644dbbfed495f23$var$isVisible
};
const $1644dbbfed495f23$export$b1857f3440a65373 = {
    initFocus: $1644dbbfed495f23$var$initFocus,
    initReconnect: $1644dbbfed495f23$var$initReconnect
};
const $1644dbbfed495f23$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).useId;
const $1644dbbfed495f23$export$d2f4d8e74279c212 = !$1644dbbfed495f23$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $1644dbbfed495f23$export$eba6076d3d7d0c06 = (f)=>$1644dbbfed495f23$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $1644dbbfed495f23$export$700979bc83e7db82 = $1644dbbfed495f23$export$d2f4d8e74279c212 ? (0, $4lkrv.useEffect) : (0, $4lkrv.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $1644dbbfed495f23$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $1644dbbfed495f23$export$3723beb60427dc52 = !$1644dbbfed495f23$export$d2f4d8e74279c212 && $1644dbbfed495f23$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($1644dbbfed495f23$var$navigatorConnection.effectiveType) || $1644dbbfed495f23$var$navigatorConnection.saveData);
const $1644dbbfed495f23$export$dfdc1655ccc5b9cb = (key)=>{
    if ($1644dbbfed495f23$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $1644dbbfed495f23$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $1644dbbfed495f23$var$__timestamp = 0;
const $1644dbbfed495f23$export$3c95c4c8b671ef0 = ()=>++$1644dbbfed495f23$var$__timestamp;
const $1644dbbfed495f23$var$FOCUS_EVENT = 0;
const $1644dbbfed495f23$var$RECONNECT_EVENT = 1;
const $1644dbbfed495f23$var$MUTATE_EVENT = 2;
const $1644dbbfed495f23$var$ERROR_REVALIDATE_EVENT = 3;
var $1644dbbfed495f23$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $1644dbbfed495f23$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $1644dbbfed495f23$var$FOCUS_EVENT,
    MUTATE_EVENT: $1644dbbfed495f23$var$MUTATE_EVENT,
    RECONNECT_EVENT: $1644dbbfed495f23$var$RECONNECT_EVENT
};
async function $1644dbbfed495f23$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $1644dbbfed495f23$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($1644dbbfed495f23$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $1644dbbfed495f23$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $1644dbbfed495f23$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $1644dbbfed495f23$export$b94ca9901c60634.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $1644dbbfed495f23$export$f6e2535fb5126e54(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($1644dbbfed495f23$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $1644dbbfed495f23$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$1644dbbfed495f23$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $1644dbbfed495f23$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $1644dbbfed495f23$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($1644dbbfed495f23$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $1644dbbfed495f23$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $1644dbbfed495f23$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($1644dbbfed495f23$export$f6e2535fb5126e54(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $1644dbbfed495f23$export$6db089fe7b26f5b6,
                        _c: $1644dbbfed495f23$export$6db089fe7b26f5b6
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $1644dbbfed495f23$export$6db089fe7b26f5b6,
                    _c: $1644dbbfed495f23$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $1644dbbfed495f23$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $1644dbbfed495f23$export$6db089fe7b26f5b6
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $1644dbbfed495f23$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $1644dbbfed495f23$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$1644dbbfed495f23$export$b94ca9901c60634.has(provider)) {
        const opts = $1644dbbfed495f23$export$2321aea138b44780($1644dbbfed495f23$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $1644dbbfed495f23$export$c9d44e5bea4509be.bind($1644dbbfed495f23$export$6db089fe7b26f5b6, provider);
        let unmount = $1644dbbfed495f23$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$1644dbbfed495f23$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $1644dbbfed495f23$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$1644dbbfed495f23$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($1644dbbfed495f23$export$6db089fe7b26f5b6, $1644dbbfed495f23$var$revalidateAllKeys.bind($1644dbbfed495f23$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $1644dbbfed495f23$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($1644dbbfed495f23$export$6db089fe7b26f5b6, $1644dbbfed495f23$var$revalidateAllKeys.bind($1644dbbfed495f23$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $1644dbbfed495f23$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $1644dbbfed495f23$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $1644dbbfed495f23$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $1644dbbfed495f23$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$1644dbbfed495f23$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $1644dbbfed495f23$export$398604a469f7de9a = (currentData, newData)=>$1644dbbfed495f23$export$e9a4e06c7dfb0bd4(currentData) == $1644dbbfed495f23$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$1644dbbfed495f23$export$69a3209f1a06c04d, $1644dbbfed495f23$export$57e795267c26e600] = $1644dbbfed495f23$export$4008f5b66f9e0b3c(new Map());
// Default config
const $1644dbbfed495f23$export$f84bd70098573c5c = $1644dbbfed495f23$export$2321aea138b44780({
    // events
    onLoadingSlow: $1644dbbfed495f23$export$8793edee2d425525,
    onSuccess: $1644dbbfed495f23$export$8793edee2d425525,
    onError: $1644dbbfed495f23$export$8793edee2d425525,
    onErrorRetry: $1644dbbfed495f23$var$onErrorRetry,
    onDiscarded: $1644dbbfed495f23$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $1644dbbfed495f23$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $1644dbbfed495f23$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $1644dbbfed495f23$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $1644dbbfed495f23$export$69a3209f1a06c04d,
    mutate: $1644dbbfed495f23$export$57e795267c26e600,
    fallback: {}
}, $1644dbbfed495f23$export$f5ab8217e0edff04);
const $1644dbbfed495f23$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $1644dbbfed495f23$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1 , fallback: f1  } = a;
        const { use: u2 , fallback: f2  } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $1644dbbfed495f23$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $1644dbbfed495f23$var$SWRConfigContext = (0, $4lkrv.createContext)({});
const $1644dbbfed495f23$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value  } = props;
    const parentConfig = (0, $4lkrv.useContext)($1644dbbfed495f23$var$SWRConfigContext);
    const isFunctionalConfig = $1644dbbfed495f23$export$f6e2535fb5126e54(value);
    const config = (0, $4lkrv.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $4lkrv.useMemo)(()=>isFunctionalConfig ? config : $1644dbbfed495f23$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $4lkrv.useRef)($1644dbbfed495f23$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $1644dbbfed495f23$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $1644dbbfed495f23$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $1644dbbfed495f23$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $4lkrv.createElement)($1644dbbfed495f23$var$SWRConfigContext.Provider, $1644dbbfed495f23$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
const $1644dbbfed495f23$export$8667f065faedc62c = "$inf$";
// @ts-expect-error
const $1644dbbfed495f23$var$enableDevtools = $1644dbbfed495f23$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $1644dbbfed495f23$var$use = $1644dbbfed495f23$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $1644dbbfed495f23$var$setupDevTools = ()=>{
    if ($1644dbbfed495f23$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv)));
};
const $1644dbbfed495f23$export$a3295358bff77e = (args)=>{
    return $1644dbbfed495f23$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $1644dbbfed495f23$export$f1dc0e282d4c1c0 = ()=>{
    return $1644dbbfed495f23$export$2321aea138b44780($1644dbbfed495f23$export$f84bd70098573c5c, (0, $4lkrv.useContext)($1644dbbfed495f23$var$SWRConfigContext));
};
const $1644dbbfed495f23$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $1644dbbfed495f23$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $1644dbbfed495f23$export$b94ca9901c60634.get($1644dbbfed495f23$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $1644dbbfed495f23$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $1644dbbfed495f23$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $1644dbbfed495f23$export$b94ca9901c60634.get($1644dbbfed495f23$export$69a3209f1a06c04d);
            if (key.startsWith($1644dbbfed495f23$export$8667f065faedc62c)) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ($1644dbbfed495f23$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $1644dbbfed495f23$var$BUILT_IN_MIDDLEWARE = $1644dbbfed495f23$var$use.concat($1644dbbfed495f23$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $1644dbbfed495f23$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $1644dbbfed495f23$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $1644dbbfed495f23$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $1644dbbfed495f23$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use  } = config;
        const middleware = (use || []).concat($1644dbbfed495f23$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $1644dbbfed495f23$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $1644dbbfed495f23$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $1644dbbfed495f23$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$1644dbbfed495f23$var$setupDevTools();


const $d99fabdf0310bdf0$export$dbab534a48e651ef = (key)=>(0, $1644dbbfed495f23$export$dfdc1655ccc5b9cb)(key)[0];
/// <reference types="react/experimental" />
const $d99fabdf0310bdf0$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($4lkrv))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $d99fabdf0310bdf0$var$WITH_DEDUPE = {
    dedupe: true
};
const $d99fabdf0310bdf0$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache , compare: compare , suspense: suspense , fallbackData: fallbackData , revalidateOnMount: revalidateOnMount , revalidateIfStale: revalidateIfStale , refreshInterval: refreshInterval , refreshWhenHidden: refreshWhenHidden , refreshWhenOffline: refreshWhenOffline , keepPreviousData: keepPreviousData  } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $1644dbbfed495f23$export$b94ca9901c60634).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $1644dbbfed495f23$export$dfdc1655ccc5b9cb)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $4lkrv.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $4lkrv.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $4lkrv.useRef)(key);
    const fetcherRef = (0, $4lkrv.useRef)(fetcher);
    const configRef = (0, $4lkrv.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $1644dbbfed495f23$export$1251d51d9c571b45)(cache, key);
    const stateDependencies = (0, $4lkrv.useRef)({}).current;
    const fallback = (0, $1644dbbfed495f23$export$fce6876652108ab)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $1644dbbfed495f23$export$fce6876652108ab)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $4lkrv.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $1644dbbfed495f23$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $1644dbbfed495f23$export$fce6876652108ab)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $1644dbbfed495f23$export$2321aea138b44780)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $a238e831c380b23f$exports.useSyncExternalStore)((0, $4lkrv.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $1644dbbfed495f23$export$fce6876652108ab)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $4lkrv.useRef)(data);
    const returnedData = keepPreviousData ? (0, $1644dbbfed495f23$export$fce6876652108ab)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $1644dbbfed495f23$export$fce6876652108ab)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $1644dbbfed495f23$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $1644dbbfed495f23$export$fce6876652108ab)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $1644dbbfed495f23$export$fce6876652108ab)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $1644dbbfed495f23$export$fce6876652108ab)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $1644dbbfed495f23$export$fce6876652108ab)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $4lkrv.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $1644dbbfed495f23$export$ddb64fe6466374f7) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $1644dbbfed495f23$export$fce6876652108ab)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $1644dbbfed495f23$export$fce6876652108ab)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $1644dbbfed495f23$export$3c95c4c8b671ef0)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $1644dbbfed495f23$export$6db089fe7b26f5b6);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $1644dbbfed495f23$export$fce6876652108ab)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError  } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $1644dbbfed495f23$export$f6e2535fb5126e54)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $1644dbbfed495f23$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $4lkrv.useCallback)((...args)=>{
        return (0, $1644dbbfed495f23$export$c9d44e5bea4509be)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $1644dbbfed495f23$export$700979bc83e7db82)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $1644dbbfed495f23$export$fce6876652108ab)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $1644dbbfed495f23$export$700979bc83e7db82)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $1644dbbfed495f23$export$6db089fe7b26f5b6), $d99fabdf0310bdf0$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $1644dbbfed495f23$export$10213d6aa5ce32e6).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $1644dbbfed495f23$export$10213d6aa5ce32e6).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $1644dbbfed495f23$export$10213d6aa5ce32e6).MUTATE_EVENT) return revalidate();
            else if (type == (0, $1644dbbfed495f23$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $1644dbbfed495f23$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $1644dbbfed495f23$export$fce6876652108ab)(data) || (0, $1644dbbfed495f23$export$d2f4d8e74279c212)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $1644dbbfed495f23$export$eba6076d3d7d0c06)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $1644dbbfed495f23$export$700979bc83e7db82)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $1644dbbfed495f23$export$f6e2535fb5126e54)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($d99fabdf0310bdf0$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $4lkrv.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $1644dbbfed495f23$export$fce6876652108ab)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $1644dbbfed495f23$export$ddb64fe6466374f7) && (0, $1644dbbfed495f23$export$d2f4d8e74279c212)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $1644dbbfed495f23$export$fce6876652108ab)(req)) {
            const promise = boundMutate(req);
            $d99fabdf0310bdf0$var$use(promise);
        }
        if ((0, $1644dbbfed495f23$export$fce6876652108ab)(error)) {
            const promise = revalidate($d99fabdf0310bdf0$var$WITH_DEDUPE);
            if (!(0, $1644dbbfed495f23$export$fce6876652108ab)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $d99fabdf0310bdf0$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $d99fabdf0310bdf0$export$4c7bbecdacc3ca2c = (0, $1644dbbfed495f23$export$8b8a958a7f6f130c).defineProperty((0, $1644dbbfed495f23$export$4c7bbecdacc3ca2c), "defaultValue", {
    value: (0, $1644dbbfed495f23$export$f84bd70098573c5c)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $d99fabdf0310bdf0$export$2e2bcd8739ae039 = (0, $1644dbbfed495f23$export$84d44e54e14b0133)($d99fabdf0310bdf0$var$useSWRHandler);


const $38645f8689e3b3ee$export$7d7dab0d475ba5fb = (productSku, unit, templateId)=>{
    const websiteApi = (0, $9f35c1aee77f93aa$export$2e2bcd8739ae039)();
    const { data: product  } = (0, $d99fabdf0310bdf0$export$2e2bcd8739ae039)(`/v1/product/${productSku}?u=${unit}`, websiteApi.fetcher);
    const { data: template  } = (0, $d99fabdf0310bdf0$export$2e2bcd8739ae039)(templateId ? `/api/template?code=${templateId}` : null, (s)=>{
        return fetch(`https://graphic.stickerit.co${s}`).then((resp)=>resp.json());
    });
    if (templateId) {
        if (!template) return null;
        return {
            ...product,
            defaultDimensions: {
                width: template.dimensions.width,
                height: template.dimensions.height,
                unit: template.dimensions.unit_type.unit_type_id
            }
        };
    }
    return product;
};





const $fcf0bf99c0161f2b$var$fallbackDefaultQuantities = [
    50,
    100,
    200,
    500,
    1000,
    2000,
    5000,
    10000
];
const $fcf0bf99c0161f2b$var$graphicModeQuantities = [
    1,
    5,
    10,
    100,
    1000
];
const $fcf0bf99c0161f2b$var$fallbackDefaultQuantity = 50;
const $fcf0bf99c0161f2b$var$graphicModeDefaultQuantity = 1;
const $fcf0bf99c0161f2b$var$forceInchSkus = [
    "STICKER-CUSTOM-CIRCULAR-0.5",
    "STICKER-CUSTOM-CIRCULAR-1",
    "STICKER-CUSTOM-CIRCULAR-2",
    "STICKER-CUSTOM-CIRCULAR-3",
    "STICKER-CUSTOM-CIRCULAR-4",
    "STICKER-CUSTOM-CIRCULAR-5"
];
const $fcf0bf99c0161f2b$var$addTranslations = (translations, materials)=>{
    return materials.map((m)=>{
        return {
            ...m,
            name: translations[m.sku]?.name || m.sku,
            description: translations[m.sku]?.description || "",
            bestseller: translations[m.sku]?.bestseller || ""
        };
    });
};
const $fcf0bf99c0161f2b$export$f22da7240b7add18 = (translations)=>{
    const container = document.getElementById("loader-pc");
    const baseUrl = container?.getAttribute("data-pc-api-url")?.valueOf() || "";
    const locale = container?.getAttribute("data-pc-locale")?.valueOf().replace("_", "-") || "";
    const storeHash = container?.getAttribute("data-pc-store-hash")?.valueOf() || "";
    const initialproductSku = container?.getAttribute("data-pc-product-sku")?.valueOf() || "";
    const cartPath = container?.getAttribute("data-pc-cart-path")?.valueOf() || "";
    const materialEnabled = container?.getAttribute("data-pc-material-enabled")?.valueOf() === "true";
    const dimensionsEnabled = container?.getAttribute("data-pc-dimensions-enabled")?.valueOf() !== "false";
    const shapeEnabled = container?.getAttribute("data-pc-shape-enabled")?.valueOf() === "true";
    const defaultShape = container?.getAttribute("data-pc-default-shape")?.valueOf();
    const quantityEnabled = container?.getAttribute("data-pc-quantity-enabled")?.valueOf() === "true";
    const graphicMode = container?.getAttribute("data-pc-graphic-mode") === "true";
    const graphicTemplateId = container?.getAttribute("data-pc-graphic-template-id");
    const fallbackQuantity = graphicMode ? $fcf0bf99c0161f2b$var$graphicModeDefaultQuantity : $fcf0bf99c0161f2b$var$fallbackDefaultQuantity;
    const fallbackQuantities = graphicMode ? $fcf0bf99c0161f2b$var$graphicModeQuantities : $fcf0bf99c0161f2b$var$fallbackDefaultQuantities;
    const fixedAspectRatio = graphicMode;
    const productSku = graphicMode ? "STICKER-CUSTOM-DIE" : initialproductSku;
    const variantId = productSku.startsWith("SAMPLE-") ? parseInt(container?.getAttribute("data-pc-variant-id")?.valueOf() || "") || undefined : undefined;
    const fixedQuantity = parseInt(container?.getAttribute("data-pc-fixed-quantity")?.valueOf() || "") || fallbackQuantity;
    const root = (0, $e62bf22c69a691b7$export$882461b6382ed46c)(container);
    if (!container) return;
    const defaultUnit = Shopify.country === "US" || $fcf0bf99c0161f2b$var$forceInchSkus.includes(productSku) ? "in" : "cm";
    const Wrapped = ()=>{
        const theme = (0, $0fbff9e4f89c0f97$export$2e2bcd8739ae039)();
        const websiteApi = (0, $9f35c1aee77f93aa$export$2e2bcd8739ae039)();
        const shopifyApi = (0, $fdfb5b79060d95bb$export$2e2bcd8739ae039)();
        const { currencyCode: currencyCode , shipToCountryCode: shipToCountryCode , locale: locale  } = (0, $4lkrv.useContext)((0, $e2f0b13a8b8b1035$export$e9e34775259af03f));
        const [design, setDesign] = (0, $4lkrv.useState)({
            quantity: fixedQuantity,
            width: 2,
            height: 2,
            unit: defaultUnit,
            materialSku: "vinyl-white",
            productSku: productSku,
            shape: "custom",
            variantId: variantId
        });
        const product = (0, $38645f8689e3b3ee$export$7d7dab0d475ba5fb)(design.productSku, design.unit, graphicMode && graphicTemplateId || undefined);
        const [quote, setQuote] = (0, $4lkrv.useState)(null);
        const prices = quote?.quantities ? quote.quantities : fallbackQuantities.map((qty)=>{
            return {
                quantity: qty,
                price: 0,
                currencyCode: "GBP",
                saving: 0,
                isLoading: true
            };
        });
        const showInches = Shopify.country === "US";
        const materials = (0, $4lkrv.useMemo)(()=>{
            return $fcf0bf99c0161f2b$var$addTranslations(translations.Materials, product?.materials || []).sort((a, b)=>{
                if (a.sortOrder && b.sortOrder) return b.sortOrder - a.sortOrder;
                return b.name.localeCompare(a.name);
            });
        }, [
            product?.materials
        ]);
        const [startDesignOpen, setStartDesignOpen] = (0, $4lkrv.useState)(false);
        const [touched, setTouched] = (0, $4lkrv.useState)(false);
        (0, $4lkrv.useEffect)(()=>{
            if (!product || touched) return;
            const toDim = (n, unit)=>{
                switch(unit){
                    case "mm":
                        return n / 10;
                }
                return n;
            };
            setDesign((d)=>{
                const newDesign = {
                    ...d,
                    width: toDim(product.defaultDimensions.width, product.defaultDimensions.unit),
                    height: toDim(product.defaultDimensions.height, product.defaultDimensions.unit),
                    materialSku: materials?.length > 0 ? materials[0].sku : "vinyl-white",
                    shape: defaultShape || product.shapes[0].shape || "custom"
                };
                return newDesign;
            });
            setTouched(true);
        }, [
            product,
            touched,
            materials
        ]);
        // TODO: remove once useState calls have been removed in VerticalPricingCalculator
        if (!touched) return null;
        return /*#__PURE__*/ (0, $gWMia.jsxs)((0, $gWMia.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gWMia.jsxs)((0, $d0738d14f749e262$export$2e2bcd8739ae039), {
                    onClose: ()=>{
                        setStartDesignOpen(false);
                    },
                    open: startDesignOpen,
                    fullScreen: true,
                    children: [
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $5dc18c1bf26fdbc8$export$2e2bcd8739ae039), {
                            sx: {
                                position: "absolute",
                                top: 20,
                                right: 24,
                                width: "24px",
                                height: "24px",
                                fontSize: "18px",
                                backgroundColor: theme.colors.greyLight
                            },
                            size: "small",
                            onClick: ()=>{
                                setStartDesignOpen(false);
                            },
                            children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $1f50bd1753fd1f06$export$2e2bcd8739ae039), {
                                sx: {
                                    color: "white"
                                },
                                fontSize: "inherit"
                            })
                        }),
                        /*#__PURE__*/ (0, $gWMia.jsx)((0, $05c8b2442d20db85$export$2e2bcd8739ae039), {
                            translations: translations.StartDesign,
                            design: design,
                            cartPath: cartPath
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $2be5a94a1fa4afe8$export$6d2ecb7fe3aeded9), {
                    graphicMode: graphicMode,
                    dimensionsEnabled: dimensionsEnabled,
                    materialEnabled: materialEnabled,
                    shapeEnabled: shapeEnabled,
                    quantityEnabled: quantityEnabled,
                    fixedQuantity: fixedQuantity,
                    allTranslations: translations,
                    currencyCode: currencyCode,
                    locale: locale,
                    defaultMaterialSku: materials?.[0]?.sku || "vinyl-white",
                    materials: materials,
                    shape: design?.shape || "custom",
                    shapes: product?.shapes || [],
                    price: {
                        quantity: design.quantity,
                        currencyCode: currencyCode,
                        price: quote?.priceIncTax || null
                    },
                    prices: prices,
                    pricesIncTax: true,
                    moq: quote?.moq || 1,
                    onChangeComplete: (width, height, quantity, materialSku, shape, unit)=>{
                        if (!touched) return;
                        const params = new URLSearchParams();
                        params.set("w", width.toString());
                        params.set("h", height.toString());
                        params.set("u", unit);
                        params.set("quantity", quantity.toString());
                        params.set("productSku", productSku);
                        params.set("materialSku", materialSku);
                        params.set("currencyCode", currencyCode);
                        params.set("shipToCountryCode", shipToCountryCode);
                        params.set("languageCode", locale);
                        if (graphicMode) $fcf0bf99c0161f2b$var$graphicModeQuantities.forEach((qty)=>{
                            params.append("qtys", qty.toString());
                        });
                        websiteApi.quote(params).then((quote)=>{
                            setQuote(quote);
                            setDesign((d)=>{
                                return {
                                    ...d,
                                    productSku: productSku,
                                    quantity: quantity,
                                    width: width,
                                    height: height,
                                    unit: unit,
                                    materialSku: materialSku,
                                    shape: shape
                                };
                            });
                        });
                    },
                    onSubmit: async (stype)=>{
                        switch(stype){
                            case (0, $15f157c1531c2362$export$560e3d5bfb204b57).Customize:
                                const params = new URLSearchParams();
                                params.set("u", "cm");
                                params.set("w", (design.width * 10).toString());
                                params.set("h", (design.height * 10).toString());
                                params.set("qty", design.quantity.toString());
                                if (graphicTemplateId) params.set("templateId", graphicTemplateId);
                                window.location.href = `https://graphic.stickerit.co/design/new?${params.toString()}`;
                                return;
                            case (0, $15f157c1531c2362$export$560e3d5bfb204b57).Continue:
                                setStartDesignOpen(true);
                                break;
                            case (0, $15f157c1531c2362$export$560e3d5bfb204b57).AddToCart:
                                const key = (0, $44230f55c9f29a55$export$9d70c354f0150b1b)("Adding to cart", {
                                    variant: "info",
                                    autoHideDuration: 30000
                                });
                                // setAddingToCart(true);
                                try {
                                    const { data: { project_id: project_id  }  } = await websiteApi.createProject(graphicTemplateId || "");
                                    await shopifyApi.addToCart(design, [
                                        {
                                            id: `graphic://${project_id}`,
                                            contentType: "",
                                            src: ""
                                        }
                                    ]);
                                    window.location.pathname = cartPath;
                                } catch (err) {
                                    (0, $44230f55c9f29a55$export$9d70c354f0150b1b)("Error adding to the cart", {
                                        variant: "error"
                                    });
                                    (0, (/*@__PURE__*/$parcel$interopDefault($9d639098aa5e9dd2$exports))).notify(err);
                                    console.error(err);
                                } finally{
                                    // setAddingToCart(false);
                                    (0, $44230f55c9f29a55$export$823cdc5238933767)(key);
                                }
                                break;
                        }
                    },
                    units: design?.unit || "cm",
                    minDimensions: product?.minDimensions || {
                        unit: "cm",
                        width: 1,
                        height: 1
                    },
                    maxDimensions: product?.maxDimensions || {
                        unit: "cm",
                        width: 33,
                        height: 70
                    },
                    quantity: design?.quantity || fallbackQuantity,
                    width: design?.width || product?.minDimensions?.width || 2,
                    height: design?.height || product?.minDimensions?.height || 2,
                    showInches: showInches,
                    productSku: design.productSku,
                    fixedAspectRatio: fixedAspectRatio
                })
            ]
        });
    };
    root.render(/*#__PURE__*/ (0, $gWMia.jsx)((0, $72413571ece6033e$export$e926676385687eaf), {
        FallbackComponent: (0, $5869b013801e0525$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $gWMia.jsxs)((0, $5f631035ddfc3cd7$export$2e2bcd8739ae039), {
            theme: (0, $5b810149f92fce45$export$2e2bcd8739ae039),
            children: [
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $11b3930c194468cc$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $44230f55c9f29a55$export$d1e619fddc3508ce), {
                    domRoot: document.querySelector("body"),
                    anchorOrigin: {
                        horizontal: "center",
                        vertical: "top"
                    }
                }),
                /*#__PURE__*/ (0, $gWMia.jsx)((0, $e2f0b13a8b8b1035$export$e9e34775259af03f).Provider, {
                    value: {
                        baseUrl: baseUrl,
                        currencyCode: Shopify.currency.active,
                        shipToCountryCode: Shopify.country,
                        locale: locale,
                        storeHash: storeHash
                    },
                    children: /*#__PURE__*/ (0, $gWMia.jsx)((0, $e6be050d098f57b5$export$4faac3888fb5e689), {
                        customWidthHeight: {},
                        children: /*#__PURE__*/ (0, $gWMia.jsx)(Wrapped, {})
                    })
                })
            ]
        })
    }));
};


(0, $fcf0bf99c0161f2b$export$f22da7240b7add18)((0, (/*@__PURE__*/$parcel$interopDefault($00126b774925bb38$exports))));

})();
//# sourceMappingURL=lng_en_US.js.map
